import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _defineProperty from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _slicedToArray from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _wrapNativeSuper from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e7) { throw _e7; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e8) { didErr = true; err = _e8; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __defProp = Object.defineProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as dateFns from "date-fns";
import { startOfMinute, addMinutes, roundToNearestMinutes, addSeconds } from "date-fns";
var dist = {
  exports: {}
};
/*! For license information please see index.js.LICENSE.txt */
(function (module, exports) {
  !function (e, t) {
    module.exports = t();
  }(window, function () {
    return function (e) {
      function t(t2) {
        for (var r2, o2, i2 = t2[0], s2 = t2[1], a3 = 0, u = []; a3 < i2.length; a3++) o2 = i2[a3], Object.prototype.hasOwnProperty.call(n, o2) && n[o2] && u.push(n[o2][0]), n[o2] = 0;
        for (r2 in s2) Object.prototype.hasOwnProperty.call(s2, r2) && (e[r2] = s2[r2]);
        for (l && l(t2); u.length;) u.shift()();
      }
      var r = {},
        n = {
          0: 0
        };
      function o(t2) {
        if (r[t2]) return r[t2].exports;
        var n2 = r[t2] = {
          i: t2,
          l: false,
          exports: {}
        };
        return e[t2].call(n2.exports, n2, n2.exports, o), n2.l = true, n2.exports;
      }
      o.e = function () {
        return Promise.resolve();
      }, o.m = e, o.c = r, o.d = function (e2, t2, r2) {
        o.o(e2, t2) || Object.defineProperty(e2, t2, {
          enumerable: true,
          get: r2
        });
      }, o.r = function (e2) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e2, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e2, "__esModule", {
          value: true
        });
      }, o.t = function (e2, t2) {
        if (1 & t2 && (e2 = o(e2)), 8 & t2) return e2;
        if (4 & t2 && "object" == typeof e2 && e2 && e2.__esModule) return e2;
        var r2 = /* @__PURE__ */Object.create(null);
        if (o.r(r2), Object.defineProperty(r2, "default", {
          enumerable: true,
          value: e2
        }), 2 & t2 && "string" != typeof e2) for (var n2 in e2) o.d(r2, n2, function (t3) {
          return e2[t3];
        }.bind(null, n2));
        return r2;
      }, o.n = function (e2) {
        var t2 = e2 && e2.__esModule ? function () {
          return e2.default;
        } : function () {
          return e2;
        };
        return o.d(t2, "a", t2), t2;
      }, o.o = function (e2, t2) {
        return Object.prototype.hasOwnProperty.call(e2, t2);
      }, o.p = "", o.oe = function (e2) {
        throw console.error(e2), e2;
      };
      var i = window.webpackJsonpFormantRealtimeSDK = window.webpackJsonpFormantRealtimeSDK || [],
        s = i.push.bind(i);
      i.push = t, i = i.slice();
      for (var a2 = 0; a2 < i.length; a2++) t(i[a2]);
      var l = s;
      return o(o.s = 228);
    }([function (e, t, r) {
      r.d(t, "a", function () {
        return H;
      });
      var n = r(14),
        o = r.n(n),
        i = r(18),
        s = r(56),
        a2 = r(19);
      var l = Math.pow(2, 20),
        u = l;
      function g(e2, t2) {
        if (t2.length < e2) throw new TypeError(e2 + " argument" + (e2 > 1 ? "s" : "") + " required, but only " + t2.length + " present");
      }
      function c(e2) {
        if (null === e2 || true === e2 || false === e2) return NaN;
        var t2 = Number(e2);
        return isNaN(t2) ? t2 : t2 < 0 ? Math.ceil(t2) : Math.floor(t2);
      }
      var f = {
          dateTimeDelimiter: /[T ]/,
          timeZoneDelimiter: /[Z ]/i,
          timezone: /([Z+-].*)$/
        },
        p = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/,
        h = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/,
        d = /^([+-])(\d{2})(?::?(\d{2}))?$/;
      function y(e2) {
        var t2,
          r2 = {},
          n2 = e2.split(f.dateTimeDelimiter);
        if (n2.length > 2) return r2;
        if (/:/.test(n2[0]) ? t2 = n2[0] : (r2.date = n2[0], t2 = n2[1], f.timeZoneDelimiter.test(r2.date) && (r2.date = e2.split(f.timeZoneDelimiter)[0], t2 = e2.substr(r2.date.length, e2.length))), t2) {
          var o2 = f.timezone.exec(t2);
          o2 ? (r2.time = t2.replace(o2[1], ""), r2.timezone = o2[1]) : r2.time = t2;
        }
        return r2;
      }
      function m(e2, t2) {
        var r2 = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t2) + "})|(\\d{2}|[+-]\\d{" + (2 + t2) + "})$)"),
          n2 = e2.match(r2);
        if (!n2) return {
          year: NaN,
          restDateString: ""
        };
        var o2 = n2[1] ? parseInt(n2[1]) : null,
          i2 = n2[2] ? parseInt(n2[2]) : null;
        return {
          year: null === i2 ? o2 : 100 * i2,
          restDateString: e2.slice((n2[1] || n2[2]).length)
        };
      }
      function b(e2, t2) {
        if (null === t2) return new Date(NaN);
        var r2 = e2.match(p);
        if (!r2) return new Date(NaN);
        var n2 = !!r2[4],
          o2 = v(r2[1]),
          i2 = v(r2[2]) - 1,
          s2 = v(r2[3]),
          a3 = v(r2[4]),
          l2 = v(r2[5]) - 1;
        if (n2) return function (e3, t3, r3) {
          return t3 >= 1 && t3 <= 53 && r3 >= 0 && r3 <= 6;
        }(0, a3, l2) ? function (e3, t3, r3) {
          var n3 = new Date(0);
          n3.setUTCFullYear(e3, 0, 4);
          var o3 = n3.getUTCDay() || 7,
            i3 = 7 * (t3 - 1) + r3 + 1 - o3;
          return n3.setUTCDate(n3.getUTCDate() + i3), n3;
        }(t2, a3, l2) : new Date(NaN);
        var u2 = new Date(0);
        return function (e3, t3, r3) {
          return t3 >= 0 && t3 <= 11 && r3 >= 1 && r3 <= (E[t3] || (T(e3) ? 29 : 28));
        }(t2, i2, s2) && function (e3, t3) {
          return t3 >= 1 && t3 <= (T(e3) ? 366 : 365);
        }(t2, o2) ? (u2.setUTCFullYear(t2, i2, Math.max(o2, s2)), u2) : new Date(NaN);
      }
      function v(e2) {
        return e2 ? parseInt(e2) : 1;
      }
      function _(e2) {
        var t2 = e2.match(h);
        if (!t2) return NaN;
        var r2 = S(t2[1]),
          n2 = S(t2[2]),
          o2 = S(t2[3]);
        return function (e3, t3, r3) {
          if (24 === e3) return 0 === t3 && 0 === r3;
          return r3 >= 0 && r3 < 60 && t3 >= 0 && t3 < 60 && e3 >= 0 && e3 < 25;
        }(r2, n2, o2) ? 36e5 * r2 + 6e4 * n2 + 1e3 * o2 : NaN;
      }
      function S(e2) {
        return e2 && parseFloat(e2.replace(",", ".")) || 0;
      }
      function w(e2) {
        if ("Z" === e2) return 0;
        var t2 = e2.match(d);
        if (!t2) return 0;
        var r2 = "+" === t2[1] ? -1 : 1,
          n2 = parseInt(t2[2]),
          o2 = t2[3] && parseInt(t2[3]) || 0;
        return function (e3, t3) {
          return t3 >= 0 && t3 <= 59;
        }(0, o2) ? r2 * (36e5 * n2 + 6e4 * o2) : NaN;
      }
      var E = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      function T(e2) {
        return e2 % 400 == 0 || e2 % 4 == 0 && e2 % 100 != 0;
      }
      function R(e2) {
        return g(1, arguments), e2 instanceof Date || "object" == typeof e2 && "[object Date]" === Object.prototype.toString.call(e2);
      }
      function A(e2) {
        g(1, arguments);
        var t2 = Object.prototype.toString.call(e2);
        return e2 instanceof Date || "object" == typeof e2 && "[object Date]" === t2 ? new Date(e2.getTime()) : "number" == typeof e2 || "[object Number]" === t2 ? new Date(e2) : ("string" != typeof e2 && "[object String]" !== t2 || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
      }
      function O(e2) {
        var t2 = function (e3, t3) {
          var r2;
          g(1, arguments);
          var n2 = c(null !== (r2 = null == t3 ? void 0 : t3.additionalDigits) && void 0 !== r2 ? r2 : 2);
          if (2 !== n2 && 1 !== n2 && 0 !== n2) throw new RangeError("additionalDigits must be 0, 1 or 2");
          if ("string" != typeof e3 && "[object String]" !== Object.prototype.toString.call(e3)) return new Date(NaN);
          var o2,
            i2 = y(e3);
          if (i2.date) {
            var s2 = m(i2.date, n2);
            o2 = b(s2.restDateString, s2.year);
          }
          if (!o2 || isNaN(o2.getTime())) return new Date(NaN);
          var a3,
            l2 = o2.getTime(),
            u2 = 0;
          if (i2.time && (u2 = _(i2.time), isNaN(u2))) return new Date(NaN);
          if (!i2.timezone) {
            var f2 = new Date(l2 + u2),
              p2 = new Date(0);
            return p2.setFullYear(f2.getUTCFullYear(), f2.getUTCMonth(), f2.getUTCDate()), p2.setHours(f2.getUTCHours(), f2.getUTCMinutes(), f2.getUTCSeconds(), f2.getUTCMilliseconds()), p2;
          }
          return a3 = w(i2.timezone), isNaN(a3) ? new Date(NaN) : new Date(l2 + u2 + a3);
        }(e2);
        if (!function (e3) {
          if (g(1, arguments), !R(e3) && "number" != typeof e3) return false;
          var t3 = A(e3);
          return !isNaN(Number(t3));
        }(t2)) throw new Error("Invalid ISO 8601 date string (".concat(e2, ")"));
        return t2;
      }
      var C = r(4),
        I = r(34);
      function j(e2) {
        return o()(e2, {
          cycles: true
        });
      }
      var M = function M(e2, t2) {
        var r2 = {};
        for (var n2 in e2) Object.prototype.hasOwnProperty.call(e2, n2) && t2.indexOf(n2) < 0 && (r2[n2] = e2[n2]);
        if (null != e2 && "function" == typeof Object.getOwnPropertySymbols) {
          var o2 = 0;
          for (n2 = Object.getOwnPropertySymbols(e2); o2 < n2.length; o2++) t2.indexOf(n2[o2]) < 0 && Object.prototype.propertyIsEnumerable.call(e2, n2[o2]) && (r2[n2[o2]] = e2[n2[o2]]);
        }
        return r2;
      };
      function P(e2) {
        var t2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r2 = function r2(e3) {
          return false !== t2.redacted ? Object(I.a)(e3) : e3;
        };
        if (!e2.stack) return {
          message: j(r2(e2))
        };
        var n2 = e2.name,
          o2 = e2.message,
          i2 = e2.stack,
          s2 = M(e2, ["name", "message", "stack"]);
        return {
          name: n2,
          message: void 0 !== o2 ? o2 : j(r2(e2)),
          stack: i2,
          meta: s2 && 0 === Object.keys(s2).length ? void 0 : r2(s2)
        };
      }
      function N(e2) {
        var t2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _P = P(e2, t2),
          r2 = _P.message,
          n2 = _P.stack,
          o2 = _P.meta;
        return "".concat(n2 || r2 || "").concat(o2 && Object.keys(o2).length > 0 ? " -- ".concat(j(o2)) : "");
      }
      var L = r(39),
        D = r(103),
        x = r.n(D),
        U = function U(e2, t2, r2, n2) {
          return new (r2 || (r2 = Promise))(function (o2, i2) {
            function s2(e3) {
              try {
                l2(n2.next(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function a3(e3) {
              try {
                l2(n2.throw(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function l2(e3) {
              var t3;
              e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
                e4(t3);
              })).then(s2, a3);
            }
            l2((n2 = n2.apply(e2, t2 || [])).next());
          });
        },
        B = function B(e2, t2) {
          var r2 = {};
          for (var n2 in e2) Object.prototype.hasOwnProperty.call(e2, n2) && t2.indexOf(n2) < 0 && (r2[n2] = e2[n2]);
          if (null != e2 && "function" == typeof Object.getOwnPropertySymbols) {
            var o2 = 0;
            for (n2 = Object.getOwnPropertySymbols(e2); o2 < n2.length; o2++) t2.indexOf(n2[o2]) < 0 && Object.prototype.propertyIsEnumerable.call(e2, n2[o2]) && (r2[n2[o2]] = e2[n2[o2]]);
          }
          return r2;
        };
      var k = /*#__PURE__*/function (_x$a) {
        _inherits(k, _x$a);
        function k(e2, t2) {
          var _this;
          _classCallCheck(this, k);
          _this = _possibleConstructorReturn(this, _getPrototypeOf(k).call(this)), _this.endpoint = e2, _this.metadata = t2, _this.logClient = _this.getLogClient();
          return _this;
        }
        _createClass(k, [{
          key: "getLogClient",
          value: function getLogClient() {
            return U(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var _yield$Promise$resolv, e2;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return Promise.resolve().then(r.bind(null, 231));
                  case 2:
                    _yield$Promise$resolv = _context.sent;
                    e2 = _yield$Promise$resolv.LogClient;
                    return _context.abrupt("return", new e2(this.endpoint));
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }, _callee, this);
            }));
          }
        }, {
          key: "log",
          value: function log(e2, t2) {
            return U(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
              var r2, n2, o2, i2;
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    r2 = e2.level, n2 = e2.message, o2 = e2.error, i2 = B(e2, ["level", "message", "error"]);
                    this.emit("logged");
                    _context2.prev = 2;
                    _context2.next = 5;
                    return this.logClient;
                  case 5:
                    _context2.next = 7;
                    return _context2.sent.log([{
                      timestamp: new Date().toISOString(),
                      level: r2,
                      message: "".concat(n2).substring(0, 1e3),
                      error: void 0 !== o2 ? P(o2) : void 0,
                      meta: Object.assign(Object.assign({}, i2), this.metadata)
                    }]);
                  case 7:
                    _context2.next = 12;
                    break;
                  case 9:
                    _context2.prev = 9;
                    _context2.t0 = _context2["catch"](2);
                    console.error("Failed to log to log-api: ".concat(N(_context2.t0)));
                  case 12:
                    t2();
                  case 13:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, this, [[2, 9]]);
            }));
          }
        }]);
        return k;
      }(x.a);
      var F = function F(e2, t2) {
        var r2 = {};
        for (var n2 in e2) Object.prototype.hasOwnProperty.call(e2, n2) && t2.indexOf(n2) < 0 && (r2[n2] = e2[n2]);
        if (null != e2 && "function" == typeof Object.getOwnPropertySymbols) {
          var o2 = 0;
          for (n2 = Object.getOwnPropertySymbols(e2); o2 < n2.length; o2++) t2.indexOf(n2[o2]) < 0 && Object.prototype.propertyIsEnumerable.call(e2, n2[o2]) && (r2[n2[o2]] = e2[n2[o2]]);
        }
        return r2;
      };
      var W = {
          app: C.a,
          namespace: C.i,
          buildTag: C.b,
          instanceId: L.a
        },
        V = C.e ? a2.format.printf(function (e2) {
          var t2 = e2.timestamp,
            r2 = e2.level,
            n2 = e2.message,
            i2 = e2.error,
            s2 = F(e2, ["timestamp", "level", "message", "error"]);
          var a3 = Object.assign(Object.assign({
            timestamp: t2 ? O(t2).getTime() : new Date().getTime(),
            level: r2.toUpperCase(),
            message: n2
          }, i2 ? {
            error: P(i2)
          } : {}), {
            meta: Object.assign(Object.assign({}, W), s2)
          });
          return o()(a3, {
            cycles: true
          });
        }) : a2.format.printf(function (e2) {
          var t2 = e2.timestamp,
            r2 = e2.level,
            n2 = e2.message,
            i2 = e2.error,
            s2 = F(e2, ["timestamp", "level", "message", "error"]);
          var a3 = "".concat(t2 || new Date().toISOString(), " ").concat(r2.toUpperCase(), ": ").concat(n2, " ");
          return Object.keys(s2).length > 0 && (a3 += o()(s2, {
            cycles: true
          })), i2 && (a3 += "\n".concat(N(i2))), a3;
        });
      var H = Object(a2.createLogger)({
        level: C.f
      });
      C.g && H.add(new a2.transports.Console({
        format: V,
        level: "debug"
      })), C.d && H.add(new k(C.d, W));
      if (C.h) {
        var e2 = s.resolve(i.tmpdir(), "silly-".concat(C.a, ".log"));
        H.debug("Logging silly logs to file", {
          filename: e2
        }), H.add(new a2.transports.File({
          filename: e2,
          maxsize: 1 * u,
          maxFiles: 10,
          format: a2.format.combine((z = "silly", Object(a2.format)(function (e3) {
            return e3.level === z && e3;
          })()), V),
          level: "silly"
        }));
      }
      var z;
    }, function (e, t, r) {
      r.d(t, "a", function () {
        return n;
      });
      var n = {
        millisecond: 1,
        second: 1e3,
        minute: 6e4,
        hour: 36e5,
        day: 864e5,
        week: 6048e5,
        month: 2592e6,
        year: 31536e6
      };
    }, function (e, t) {
      var r,
        n,
        o = e.exports = {};
      function i() {
        throw new Error("setTimeout has not been defined");
      }
      function s() {
        throw new Error("clearTimeout has not been defined");
      }
      function a2(e2) {
        if (r === setTimeout) return setTimeout(e2, 0);
        if ((r === i || !r) && setTimeout) return r = setTimeout, setTimeout(e2, 0);
        try {
          return r(e2, 0);
        } catch (t2) {
          try {
            return r.call(null, e2, 0);
          } catch (t3) {
            return r.call(this, e2, 0);
          }
        }
      }
      !function () {
        try {
          r = "function" == typeof setTimeout ? setTimeout : i;
        } catch (e2) {
          r = i;
        }
        try {
          n = "function" == typeof clearTimeout ? clearTimeout : s;
        } catch (e2) {
          n = s;
        }
      }();
      var l,
        u = [],
        g = false,
        c = -1;
      function f() {
        g && l && (g = false, l.length ? u = l.concat(u) : c = -1, u.length && p());
      }
      function p() {
        if (!g) {
          var e2 = a2(f);
          g = true;
          for (var t2 = u.length; t2;) {
            for (l = u, u = []; ++c < t2;) l && l[c].run();
            c = -1, t2 = u.length;
          }
          l = null, g = false, function (e3) {
            if (n === clearTimeout) return clearTimeout(e3);
            if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e3);
            try {
              n(e3);
            } catch (t3) {
              try {
                return n.call(null, e3);
              } catch (t4) {
                return n.call(this, e3);
              }
            }
          }(e2);
        }
      }
      function h(e2, t2) {
        this.fun = e2, this.array = t2;
      }
      function d() {}
      o.nextTick = function (e2) {
        var t2 = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var r2 = 1; r2 < arguments.length; r2++) t2[r2 - 1] = arguments[r2];
        u.push(new h(e2, t2)), 1 !== u.length || g || a2(p);
      }, h.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, o.title = "browser", o.browser = true, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = d, o.addListener = d, o.once = d, o.off = d, o.removeListener = d, o.removeAllListeners = d, o.emit = d, o.prependListener = d, o.prependOnceListener = d, o.listeners = function (e2) {
        return [];
      }, o.binding = function (e2) {
        throw new Error("process.binding is not supported");
      }, o.cwd = function () {
        return "/";
      }, o.chdir = function (e2) {
        throw new Error("process.chdir is not supported");
      }, o.umask = function () {
        return 0;
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "LEVEL", {
        value: Symbol.for("level")
      }), Object.defineProperty(t, "MESSAGE", {
        value: Symbol.for("message")
      }), Object.defineProperty(t, "SPLAT", {
        value: Symbol.for("splat")
      }), Object.defineProperty(t, "configs", {
        value: r(118)
      });
    }, function (e, t, r) {
      (function (e2) {
        r.d(t, "a", function () {
          return i;
        }), r.d(t, "i", function () {
          return s;
        }), r.d(t, "j", function () {
          return a2;
        }), r.d(t, "b", function () {
          return l;
        }), r.d(t, "f", function () {
          return u;
        }), r.d(t, "e", function () {
          return g;
        }), r.d(t, "g", function () {
          return c;
        }), r.d(t, "d", function () {
          return f;
        }), r.d(t, "c", function () {
          return p;
        }), r.d(t, "h", function () {
          return h;
        });
        var n = r(102);
        var o = n.from({
            ENVIRONMENT: e2.env.ENV,
            API_ENDPOINT: e2.env.API_ENDPOINT,
            APP: "realtime-sdk",
            APP_PATH: e2.env.APP_PATH,
            BUILD_TAG: e2.env.BUILD_TAG,
            ENABLE_SELF_SERVE: e2.env.ENABLE_SELF_SERVE,
            ENABLE_SENTRY: e2.env.ENABLE_SENTRY,
            ENABLE_SENTRY_PROFILING: e2.env.ENABLE_SENTRY_PROFILING,
            GIT_COMMIT: e2.env.GIT_COMMIT,
            JEST_WORKER_ID: e2.env.JEST_WORKER_ID,
            LOG_API_ENDPOINT: e2.env.LOG_API_ENDPOINT,
            LOG_JSON: "false",
            LOG_LEVEL: e2.env.LOG_LEVEL,
            LOG_TO_CONSOLE: e2.env.LOG_TO_CONSOLE,
            LOG_TO_FILE: e2.env.LOG_TO_FILE,
            NAMESPACE: "production",
            SENTRY_DSN: e2.env.SENTRY_DSN,
            SHEET_EXPORT_MAX_ROW_COUNT: e2.env.SHEET_EXPORT_MAX_ROW_COUNT,
            STABLE_AGENT_VERSION: e2.env.STABLE_AGENT_VERSION,
            VERSION: e2.env.VERSION
          }),
          i = (o.get("ENVIRONMENT").default("").asString(), o.get("APP").default("").asString()),
          s = (o.get("APP_PATH").default("").asString(), o.get("API_ENDPOINT").default("").asString(), o.get("NAMESPACE").default("").asString()),
          a2 = o.get("VERSION").default("").asString(),
          l = o.get("BUILD_TAG").default("").asString(),
          u = (o.get("GIT_COMMIT").default("").asString(), o.get("ENABLE_SENTRY").default("false").asBool(), o.get("ENABLE_SENTRY_PROFILING").default("false").asBool(), o.get("SENTRY_DSN").default("").asString(), o.get("LOG_LEVEL").default("debug").asString()),
          g = o.get("LOG_JSON").default("true").asBool(),
          c = o.get("LOG_TO_CONSOLE").default("true").asBool(),
          f = (o.get("STABLE_AGENT_VERSION").default("").asString(), o.get("LOG_API_ENDPOINT").asString()),
          p = o.get("JEST_WORKER_ID").asString(),
          h = (o.get("SHEET_EXPORT_MAX_ROW_COUNT").default("10000").asIntPositive(), o.get("LOG_TO_FILE").default("false").asBoolStrict());
        o.get("ENABLE_SELF_SERVE").default("true").asBoolStrict();
      }).call(this, r(2));
    }, function (e, t, r) {
      (function (e2) {
        var n = r(126),
          o = r(127),
          i = r(42);
        function s() {
          return l.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }
        function a2(e3, t2) {
          if (s() < t2) throw new RangeError("Invalid typed array length");
          return l.TYPED_ARRAY_SUPPORT ? (e3 = new Uint8Array(t2)).__proto__ = l.prototype : (null === e3 && (e3 = new l(t2)), e3.length = t2), e3;
        }
        function l(e3, t2, r2) {
          if (!(l.TYPED_ARRAY_SUPPORT || this instanceof l)) return new l(e3, t2, r2);
          if ("number" == typeof e3) {
            if ("string" == typeof t2) throw new Error("If encoding is specified then the first argument must be a string");
            return c(this, e3);
          }
          return u(this, e3, t2, r2);
        }
        function u(e3, t2, r2, n2) {
          if ("number" == typeof t2) throw new TypeError('"value" argument must not be a number');
          return "undefined" != typeof ArrayBuffer && t2 instanceof ArrayBuffer ? function (e4, t3, r3, n3) {
            if (t3.byteLength, r3 < 0 || t3.byteLength < r3) throw new RangeError("'offset' is out of bounds");
            if (t3.byteLength < r3 + (n3 || 0)) throw new RangeError("'length' is out of bounds");
            t3 = void 0 === r3 && void 0 === n3 ? new Uint8Array(t3) : void 0 === n3 ? new Uint8Array(t3, r3) : new Uint8Array(t3, r3, n3);
            l.TYPED_ARRAY_SUPPORT ? (e4 = t3).__proto__ = l.prototype : e4 = f(e4, t3);
            return e4;
          }(e3, t2, r2, n2) : "string" == typeof t2 ? function (e4, t3, r3) {
            "string" == typeof r3 && "" !== r3 || (r3 = "utf8");
            if (!l.isEncoding(r3)) throw new TypeError('"encoding" must be a valid string encoding');
            var n3 = 0 | h(t3, r3),
              o2 = (e4 = a2(e4, n3)).write(t3, r3);
            o2 !== n3 && (e4 = e4.slice(0, o2));
            return e4;
          }(e3, t2, r2) : function (e4, t3) {
            if (l.isBuffer(t3)) {
              var r3 = 0 | p(t3.length);
              return 0 === (e4 = a2(e4, r3)).length || t3.copy(e4, 0, 0, r3), e4;
            }
            if (t3) {
              if ("undefined" != typeof ArrayBuffer && t3.buffer instanceof ArrayBuffer || "length" in t3) return "number" != typeof t3.length || (n3 = t3.length) != n3 ? a2(e4, 0) : f(e4, t3);
              if ("Buffer" === t3.type && i(t3.data)) return f(e4, t3.data);
            }
            var n3;
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
          }(e3, t2);
        }
        function g(e3) {
          if ("number" != typeof e3) throw new TypeError('"size" argument must be a number');
          if (e3 < 0) throw new RangeError('"size" argument must not be negative');
        }
        function c(e3, t2) {
          if (g(t2), e3 = a2(e3, t2 < 0 ? 0 : 0 | p(t2)), !l.TYPED_ARRAY_SUPPORT) for (var r2 = 0; r2 < t2; ++r2) e3[r2] = 0;
          return e3;
        }
        function f(e3, t2) {
          var r2 = t2.length < 0 ? 0 : 0 | p(t2.length);
          e3 = a2(e3, r2);
          for (var n2 = 0; n2 < r2; n2 += 1) e3[n2] = 255 & t2[n2];
          return e3;
        }
        function p(e3) {
          if (e3 >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
          return 0 | e3;
        }
        function h(e3, t2) {
          if (l.isBuffer(e3)) return e3.length;
          if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e3) || e3 instanceof ArrayBuffer)) return e3.byteLength;
          "string" != typeof e3 && (e3 = "" + e3);
          var r2 = e3.length;
          if (0 === r2) return 0;
          for (var n2 = false;;) switch (t2) {
            case "ascii":
            case "latin1":
            case "binary":
              return r2;
            case "utf8":
            case "utf-8":
            case void 0:
              return F(e3).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r2;
            case "hex":
              return r2 >>> 1;
            case "base64":
              return W(e3).length;
            default:
              if (n2) return F(e3).length;
              t2 = ("" + t2).toLowerCase(), n2 = true;
          }
        }
        function d(e3, t2, r2) {
          var n2 = false;
          if ((void 0 === t2 || t2 < 0) && (t2 = 0), t2 > this.length) return "";
          if ((void 0 === r2 || r2 > this.length) && (r2 = this.length), r2 <= 0) return "";
          if ((r2 >>>= 0) <= (t2 >>>= 0)) return "";
          for (e3 || (e3 = "utf8");;) switch (e3) {
            case "hex":
              return I(this, t2, r2);
            case "utf8":
            case "utf-8":
              return A(this, t2, r2);
            case "ascii":
              return O(this, t2, r2);
            case "latin1":
            case "binary":
              return C(this, t2, r2);
            case "base64":
              return R(this, t2, r2);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return j(this, t2, r2);
            default:
              if (n2) throw new TypeError("Unknown encoding: " + e3);
              e3 = (e3 + "").toLowerCase(), n2 = true;
          }
        }
        function y(e3, t2, r2) {
          var n2 = e3[t2];
          e3[t2] = e3[r2], e3[r2] = n2;
        }
        function m(e3, t2, r2, n2, o2) {
          if (0 === e3.length) return -1;
          if ("string" == typeof r2 ? (n2 = r2, r2 = 0) : r2 > 2147483647 ? r2 = 2147483647 : r2 < -2147483648 && (r2 = -2147483648), r2 = +r2, isNaN(r2) && (r2 = o2 ? 0 : e3.length - 1), r2 < 0 && (r2 = e3.length + r2), r2 >= e3.length) {
            if (o2) return -1;
            r2 = e3.length - 1;
          } else if (r2 < 0) {
            if (!o2) return -1;
            r2 = 0;
          }
          if ("string" == typeof t2 && (t2 = l.from(t2, n2)), l.isBuffer(t2)) return 0 === t2.length ? -1 : b(e3, t2, r2, n2, o2);
          if ("number" == typeof t2) return t2 &= 255, l.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o2 ? Uint8Array.prototype.indexOf.call(e3, t2, r2) : Uint8Array.prototype.lastIndexOf.call(e3, t2, r2) : b(e3, [t2], r2, n2, o2);
          throw new TypeError("val must be string, number or Buffer");
        }
        function b(e3, t2, r2, n2, o2) {
          var i2,
            s2 = 1,
            a3 = e3.length,
            l2 = t2.length;
          if (void 0 !== n2 && ("ucs2" === (n2 = String(n2).toLowerCase()) || "ucs-2" === n2 || "utf16le" === n2 || "utf-16le" === n2)) {
            if (e3.length < 2 || t2.length < 2) return -1;
            s2 = 2, a3 /= 2, l2 /= 2, r2 /= 2;
          }
          function u2(e4, t3) {
            return 1 === s2 ? e4[t3] : e4.readUInt16BE(t3 * s2);
          }
          if (o2) {
            var g2 = -1;
            for (i2 = r2; i2 < a3; i2++) if (u2(e3, i2) === u2(t2, -1 === g2 ? 0 : i2 - g2)) {
              if (-1 === g2 && (g2 = i2), i2 - g2 + 1 === l2) return g2 * s2;
            } else -1 !== g2 && (i2 -= i2 - g2), g2 = -1;
          } else for (r2 + l2 > a3 && (r2 = a3 - l2), i2 = r2; i2 >= 0; i2--) {
            for (var c2 = true, f2 = 0; f2 < l2; f2++) if (u2(e3, i2 + f2) !== u2(t2, f2)) {
              c2 = false;
              break;
            }
            if (c2) return i2;
          }
          return -1;
        }
        function v(e3, t2, r2, n2) {
          r2 = Number(r2) || 0;
          var o2 = e3.length - r2;
          n2 ? (n2 = Number(n2)) > o2 && (n2 = o2) : n2 = o2;
          var i2 = t2.length;
          if (i2 % 2 != 0) throw new TypeError("Invalid hex string");
          n2 > i2 / 2 && (n2 = i2 / 2);
          for (var s2 = 0; s2 < n2; ++s2) {
            var a3 = parseInt(t2.substr(2 * s2, 2), 16);
            if (isNaN(a3)) return s2;
            e3[r2 + s2] = a3;
          }
          return s2;
        }
        function _(e3, t2, r2, n2) {
          return V(F(t2, e3.length - r2), e3, r2, n2);
        }
        function S(e3, t2, r2, n2) {
          return V(function (e4) {
            for (var t3 = [], r3 = 0; r3 < e4.length; ++r3) t3.push(255 & e4.charCodeAt(r3));
            return t3;
          }(t2), e3, r2, n2);
        }
        function w(e3, t2, r2, n2) {
          return S(e3, t2, r2, n2);
        }
        function E(e3, t2, r2, n2) {
          return V(W(t2), e3, r2, n2);
        }
        function T(e3, t2, r2, n2) {
          return V(function (e4, t3) {
            for (var r3, n3, o2, i2 = [], s2 = 0; s2 < e4.length && !((t3 -= 2) < 0); ++s2) r3 = e4.charCodeAt(s2), n3 = r3 >> 8, o2 = r3 % 256, i2.push(o2), i2.push(n3);
            return i2;
          }(t2, e3.length - r2), e3, r2, n2);
        }
        function R(e3, t2, r2) {
          return 0 === t2 && r2 === e3.length ? n.fromByteArray(e3) : n.fromByteArray(e3.slice(t2, r2));
        }
        function A(e3, t2, r2) {
          r2 = Math.min(e3.length, r2);
          for (var n2 = [], o2 = t2; o2 < r2;) {
            var i2,
              s2,
              a3,
              l2,
              u2 = e3[o2],
              g2 = null,
              c2 = u2 > 239 ? 4 : u2 > 223 ? 3 : u2 > 191 ? 2 : 1;
            if (o2 + c2 <= r2) switch (c2) {
              case 1:
                u2 < 128 && (g2 = u2);
                break;
              case 2:
                128 == (192 & (i2 = e3[o2 + 1])) && (l2 = (31 & u2) << 6 | 63 & i2) > 127 && (g2 = l2);
                break;
              case 3:
                i2 = e3[o2 + 1], s2 = e3[o2 + 2], 128 == (192 & i2) && 128 == (192 & s2) && (l2 = (15 & u2) << 12 | (63 & i2) << 6 | 63 & s2) > 2047 && (l2 < 55296 || l2 > 57343) && (g2 = l2);
                break;
              case 4:
                i2 = e3[o2 + 1], s2 = e3[o2 + 2], a3 = e3[o2 + 3], 128 == (192 & i2) && 128 == (192 & s2) && 128 == (192 & a3) && (l2 = (15 & u2) << 18 | (63 & i2) << 12 | (63 & s2) << 6 | 63 & a3) > 65535 && l2 < 1114112 && (g2 = l2);
            }
            null === g2 ? (g2 = 65533, c2 = 1) : g2 > 65535 && (g2 -= 65536, n2.push(g2 >>> 10 & 1023 | 55296), g2 = 56320 | 1023 & g2), n2.push(g2), o2 += c2;
          }
          return function (e4) {
            var t3 = e4.length;
            if (t3 <= 4096) return String.fromCharCode.apply(String, e4);
            var r3 = "",
              n3 = 0;
            for (; n3 < t3;) r3 += String.fromCharCode.apply(String, e4.slice(n3, n3 += 4096));
            return r3;
          }(n2);
        }
        t.Buffer = l, t.SlowBuffer = function (e3) {
          +e3 != e3 && (e3 = 0);
          return l.alloc(+e3);
        }, t.INSPECT_MAX_BYTES = 50, l.TYPED_ARRAY_SUPPORT = void 0 !== e2.TYPED_ARRAY_SUPPORT ? e2.TYPED_ARRAY_SUPPORT : function () {
          try {
            var e3 = new Uint8Array(1);
            return e3.__proto__ = {
              __proto__: Uint8Array.prototype,
              foo: function foo() {
                return 42;
              }
            }, 42 === e3.foo() && "function" == typeof e3.subarray && 0 === e3.subarray(1, 1).byteLength;
          } catch (e4) {
            return false;
          }
        }(), t.kMaxLength = s(), l.poolSize = 8192, l._augment = function (e3) {
          return e3.__proto__ = l.prototype, e3;
        }, l.from = function (e3, t2, r2) {
          return u(null, e3, t2, r2);
        }, l.TYPED_ARRAY_SUPPORT && (l.prototype.__proto__ = Uint8Array.prototype, l.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && l[Symbol.species] === l && Object.defineProperty(l, Symbol.species, {
          value: null,
          configurable: true
        })), l.alloc = function (e3, t2, r2) {
          return function (e4, t3, r3, n2) {
            return g(t3), t3 <= 0 ? a2(e4, t3) : void 0 !== r3 ? "string" == typeof n2 ? a2(e4, t3).fill(r3, n2) : a2(e4, t3).fill(r3) : a2(e4, t3);
          }(null, e3, t2, r2);
        }, l.allocUnsafe = function (e3) {
          return c(null, e3);
        }, l.allocUnsafeSlow = function (e3) {
          return c(null, e3);
        }, l.isBuffer = function (e3) {
          return !(null == e3 || !e3._isBuffer);
        }, l.compare = function (e3, t2) {
          if (!l.isBuffer(e3) || !l.isBuffer(t2)) throw new TypeError("Arguments must be Buffers");
          if (e3 === t2) return 0;
          for (var r2 = e3.length, n2 = t2.length, o2 = 0, i2 = Math.min(r2, n2); o2 < i2; ++o2) if (e3[o2] !== t2[o2]) {
            r2 = e3[o2], n2 = t2[o2];
            break;
          }
          return r2 < n2 ? -1 : n2 < r2 ? 1 : 0;
        }, l.isEncoding = function (e3) {
          switch (String(e3).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return true;
            default:
              return false;
          }
        }, l.concat = function (e3, t2) {
          if (!i(e3)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === e3.length) return l.alloc(0);
          var r2;
          if (void 0 === t2) for (t2 = 0, r2 = 0; r2 < e3.length; ++r2) t2 += e3[r2].length;
          var n2 = l.allocUnsafe(t2),
            o2 = 0;
          for (r2 = 0; r2 < e3.length; ++r2) {
            var s2 = e3[r2];
            if (!l.isBuffer(s2)) throw new TypeError('"list" argument must be an Array of Buffers');
            s2.copy(n2, o2), o2 += s2.length;
          }
          return n2;
        }, l.byteLength = h, l.prototype._isBuffer = true, l.prototype.swap16 = function () {
          var e3 = this.length;
          if (e3 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
          for (var t2 = 0; t2 < e3; t2 += 2) y(this, t2, t2 + 1);
          return this;
        }, l.prototype.swap32 = function () {
          var e3 = this.length;
          if (e3 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
          for (var t2 = 0; t2 < e3; t2 += 4) y(this, t2, t2 + 3), y(this, t2 + 1, t2 + 2);
          return this;
        }, l.prototype.swap64 = function () {
          var e3 = this.length;
          if (e3 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
          for (var t2 = 0; t2 < e3; t2 += 8) y(this, t2, t2 + 7), y(this, t2 + 1, t2 + 6), y(this, t2 + 2, t2 + 5), y(this, t2 + 3, t2 + 4);
          return this;
        }, l.prototype.toString = function () {
          var e3 = 0 | this.length;
          return 0 === e3 ? "" : 0 === arguments.length ? A(this, 0, e3) : d.apply(this, arguments);
        }, l.prototype.equals = function (e3) {
          if (!l.isBuffer(e3)) throw new TypeError("Argument must be a Buffer");
          return this === e3 || 0 === l.compare(this, e3);
        }, l.prototype.inspect = function () {
          var e3 = "",
            r2 = t.INSPECT_MAX_BYTES;
          return this.length > 0 && (e3 = this.toString("hex", 0, r2).match(/.{2}/g).join(" "), this.length > r2 && (e3 += " ... ")), "<Buffer " + e3 + ">";
        }, l.prototype.compare = function (e3, t2, r2, n2, o2) {
          if (!l.isBuffer(e3)) throw new TypeError("Argument must be a Buffer");
          if (void 0 === t2 && (t2 = 0), void 0 === r2 && (r2 = e3 ? e3.length : 0), void 0 === n2 && (n2 = 0), void 0 === o2 && (o2 = this.length), t2 < 0 || r2 > e3.length || n2 < 0 || o2 > this.length) throw new RangeError("out of range index");
          if (n2 >= o2 && t2 >= r2) return 0;
          if (n2 >= o2) return -1;
          if (t2 >= r2) return 1;
          if (this === e3) return 0;
          for (var i2 = (o2 >>>= 0) - (n2 >>>= 0), s2 = (r2 >>>= 0) - (t2 >>>= 0), a3 = Math.min(i2, s2), u2 = this.slice(n2, o2), g2 = e3.slice(t2, r2), c2 = 0; c2 < a3; ++c2) if (u2[c2] !== g2[c2]) {
            i2 = u2[c2], s2 = g2[c2];
            break;
          }
          return i2 < s2 ? -1 : s2 < i2 ? 1 : 0;
        }, l.prototype.includes = function (e3, t2, r2) {
          return -1 !== this.indexOf(e3, t2, r2);
        }, l.prototype.indexOf = function (e3, t2, r2) {
          return m(this, e3, t2, r2, true);
        }, l.prototype.lastIndexOf = function (e3, t2, r2) {
          return m(this, e3, t2, r2, false);
        }, l.prototype.write = function (e3, t2, r2, n2) {
          if (void 0 === t2) n2 = "utf8", r2 = this.length, t2 = 0;else if (void 0 === r2 && "string" == typeof t2) n2 = t2, r2 = this.length, t2 = 0;else {
            if (!isFinite(t2)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            t2 |= 0, isFinite(r2) ? (r2 |= 0, void 0 === n2 && (n2 = "utf8")) : (n2 = r2, r2 = void 0);
          }
          var o2 = this.length - t2;
          if ((void 0 === r2 || r2 > o2) && (r2 = o2), e3.length > 0 && (r2 < 0 || t2 < 0) || t2 > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          n2 || (n2 = "utf8");
          for (var i2 = false;;) switch (n2) {
            case "hex":
              return v(this, e3, t2, r2);
            case "utf8":
            case "utf-8":
              return _(this, e3, t2, r2);
            case "ascii":
              return S(this, e3, t2, r2);
            case "latin1":
            case "binary":
              return w(this, e3, t2, r2);
            case "base64":
              return E(this, e3, t2, r2);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return T(this, e3, t2, r2);
            default:
              if (i2) throw new TypeError("Unknown encoding: " + n2);
              n2 = ("" + n2).toLowerCase(), i2 = true;
          }
        }, l.prototype.toJSON = function () {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
          };
        };
        function O(e3, t2, r2) {
          var n2 = "";
          r2 = Math.min(e3.length, r2);
          for (var o2 = t2; o2 < r2; ++o2) n2 += String.fromCharCode(127 & e3[o2]);
          return n2;
        }
        function C(e3, t2, r2) {
          var n2 = "";
          r2 = Math.min(e3.length, r2);
          for (var o2 = t2; o2 < r2; ++o2) n2 += String.fromCharCode(e3[o2]);
          return n2;
        }
        function I(e3, t2, r2) {
          var n2 = e3.length;
          (!t2 || t2 < 0) && (t2 = 0), (!r2 || r2 < 0 || r2 > n2) && (r2 = n2);
          for (var o2 = "", i2 = t2; i2 < r2; ++i2) o2 += k(e3[i2]);
          return o2;
        }
        function j(e3, t2, r2) {
          for (var n2 = e3.slice(t2, r2), o2 = "", i2 = 0; i2 < n2.length; i2 += 2) o2 += String.fromCharCode(n2[i2] + 256 * n2[i2 + 1]);
          return o2;
        }
        function M(e3, t2, r2) {
          if (e3 % 1 != 0 || e3 < 0) throw new RangeError("offset is not uint");
          if (e3 + t2 > r2) throw new RangeError("Trying to access beyond buffer length");
        }
        function P(e3, t2, r2, n2, o2, i2) {
          if (!l.isBuffer(e3)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (t2 > o2 || t2 < i2) throw new RangeError('"value" argument is out of bounds');
          if (r2 + n2 > e3.length) throw new RangeError("Index out of range");
        }
        function N(e3, t2, r2, n2) {
          t2 < 0 && (t2 = 65535 + t2 + 1);
          for (var o2 = 0, i2 = Math.min(e3.length - r2, 2); o2 < i2; ++o2) e3[r2 + o2] = (t2 & 255 << 8 * (n2 ? o2 : 1 - o2)) >>> 8 * (n2 ? o2 : 1 - o2);
        }
        function L(e3, t2, r2, n2) {
          t2 < 0 && (t2 = 4294967295 + t2 + 1);
          for (var o2 = 0, i2 = Math.min(e3.length - r2, 4); o2 < i2; ++o2) e3[r2 + o2] = t2 >>> 8 * (n2 ? o2 : 3 - o2) & 255;
        }
        function D(e3, t2, r2, n2, o2, i2) {
          if (r2 + n2 > e3.length) throw new RangeError("Index out of range");
          if (r2 < 0) throw new RangeError("Index out of range");
        }
        function x(e3, t2, r2, n2, i2) {
          return i2 || D(e3, 0, r2, 4), o.write(e3, t2, r2, n2, 23, 4), r2 + 4;
        }
        function U(e3, t2, r2, n2, i2) {
          return i2 || D(e3, 0, r2, 8), o.write(e3, t2, r2, n2, 52, 8), r2 + 8;
        }
        l.prototype.slice = function (e3, t2) {
          var r2,
            n2 = this.length;
          if ((e3 = ~~e3) < 0 ? (e3 += n2) < 0 && (e3 = 0) : e3 > n2 && (e3 = n2), (t2 = void 0 === t2 ? n2 : ~~t2) < 0 ? (t2 += n2) < 0 && (t2 = 0) : t2 > n2 && (t2 = n2), t2 < e3 && (t2 = e3), l.TYPED_ARRAY_SUPPORT) (r2 = this.subarray(e3, t2)).__proto__ = l.prototype;else {
            var o2 = t2 - e3;
            r2 = new l(o2, void 0);
            for (var i2 = 0; i2 < o2; ++i2) r2[i2] = this[i2 + e3];
          }
          return r2;
        }, l.prototype.readUIntLE = function (e3, t2, r2) {
          e3 |= 0, t2 |= 0, r2 || M(e3, t2, this.length);
          for (var n2 = this[e3], o2 = 1, i2 = 0; ++i2 < t2 && (o2 *= 256);) n2 += this[e3 + i2] * o2;
          return n2;
        }, l.prototype.readUIntBE = function (e3, t2, r2) {
          e3 |= 0, t2 |= 0, r2 || M(e3, t2, this.length);
          for (var n2 = this[e3 + --t2], o2 = 1; t2 > 0 && (o2 *= 256);) n2 += this[e3 + --t2] * o2;
          return n2;
        }, l.prototype.readUInt8 = function (e3, t2) {
          return t2 || M(e3, 1, this.length), this[e3];
        }, l.prototype.readUInt16LE = function (e3, t2) {
          return t2 || M(e3, 2, this.length), this[e3] | this[e3 + 1] << 8;
        }, l.prototype.readUInt16BE = function (e3, t2) {
          return t2 || M(e3, 2, this.length), this[e3] << 8 | this[e3 + 1];
        }, l.prototype.readUInt32LE = function (e3, t2) {
          return t2 || M(e3, 4, this.length), (this[e3] | this[e3 + 1] << 8 | this[e3 + 2] << 16) + 16777216 * this[e3 + 3];
        }, l.prototype.readUInt32BE = function (e3, t2) {
          return t2 || M(e3, 4, this.length), 16777216 * this[e3] + (this[e3 + 1] << 16 | this[e3 + 2] << 8 | this[e3 + 3]);
        }, l.prototype.readIntLE = function (e3, t2, r2) {
          e3 |= 0, t2 |= 0, r2 || M(e3, t2, this.length);
          for (var n2 = this[e3], o2 = 1, i2 = 0; ++i2 < t2 && (o2 *= 256);) n2 += this[e3 + i2] * o2;
          return n2 >= (o2 *= 128) && (n2 -= Math.pow(2, 8 * t2)), n2;
        }, l.prototype.readIntBE = function (e3, t2, r2) {
          e3 |= 0, t2 |= 0, r2 || M(e3, t2, this.length);
          for (var n2 = t2, o2 = 1, i2 = this[e3 + --n2]; n2 > 0 && (o2 *= 256);) i2 += this[e3 + --n2] * o2;
          return i2 >= (o2 *= 128) && (i2 -= Math.pow(2, 8 * t2)), i2;
        }, l.prototype.readInt8 = function (e3, t2) {
          return t2 || M(e3, 1, this.length), 128 & this[e3] ? -1 * (255 - this[e3] + 1) : this[e3];
        }, l.prototype.readInt16LE = function (e3, t2) {
          t2 || M(e3, 2, this.length);
          var r2 = this[e3] | this[e3 + 1] << 8;
          return 32768 & r2 ? 4294901760 | r2 : r2;
        }, l.prototype.readInt16BE = function (e3, t2) {
          t2 || M(e3, 2, this.length);
          var r2 = this[e3 + 1] | this[e3] << 8;
          return 32768 & r2 ? 4294901760 | r2 : r2;
        }, l.prototype.readInt32LE = function (e3, t2) {
          return t2 || M(e3, 4, this.length), this[e3] | this[e3 + 1] << 8 | this[e3 + 2] << 16 | this[e3 + 3] << 24;
        }, l.prototype.readInt32BE = function (e3, t2) {
          return t2 || M(e3, 4, this.length), this[e3] << 24 | this[e3 + 1] << 16 | this[e3 + 2] << 8 | this[e3 + 3];
        }, l.prototype.readFloatLE = function (e3, t2) {
          return t2 || M(e3, 4, this.length), o.read(this, e3, true, 23, 4);
        }, l.prototype.readFloatBE = function (e3, t2) {
          return t2 || M(e3, 4, this.length), o.read(this, e3, false, 23, 4);
        }, l.prototype.readDoubleLE = function (e3, t2) {
          return t2 || M(e3, 8, this.length), o.read(this, e3, true, 52, 8);
        }, l.prototype.readDoubleBE = function (e3, t2) {
          return t2 || M(e3, 8, this.length), o.read(this, e3, false, 52, 8);
        }, l.prototype.writeUIntLE = function (e3, t2, r2, n2) {
          (e3 = +e3, t2 |= 0, r2 |= 0, n2) || P(this, e3, t2, r2, Math.pow(2, 8 * r2) - 1, 0);
          var o2 = 1,
            i2 = 0;
          for (this[t2] = 255 & e3; ++i2 < r2 && (o2 *= 256);) this[t2 + i2] = e3 / o2 & 255;
          return t2 + r2;
        }, l.prototype.writeUIntBE = function (e3, t2, r2, n2) {
          (e3 = +e3, t2 |= 0, r2 |= 0, n2) || P(this, e3, t2, r2, Math.pow(2, 8 * r2) - 1, 0);
          var o2 = r2 - 1,
            i2 = 1;
          for (this[t2 + o2] = 255 & e3; --o2 >= 0 && (i2 *= 256);) this[t2 + o2] = e3 / i2 & 255;
          return t2 + r2;
        }, l.prototype.writeUInt8 = function (e3, t2, r2) {
          return e3 = +e3, t2 |= 0, r2 || P(this, e3, t2, 1, 255, 0), l.TYPED_ARRAY_SUPPORT || (e3 = Math.floor(e3)), this[t2] = 255 & e3, t2 + 1;
        }, l.prototype.writeUInt16LE = function (e3, t2, r2) {
          return e3 = +e3, t2 |= 0, r2 || P(this, e3, t2, 2, 65535, 0), l.TYPED_ARRAY_SUPPORT ? (this[t2] = 255 & e3, this[t2 + 1] = e3 >>> 8) : N(this, e3, t2, true), t2 + 2;
        }, l.prototype.writeUInt16BE = function (e3, t2, r2) {
          return e3 = +e3, t2 |= 0, r2 || P(this, e3, t2, 2, 65535, 0), l.TYPED_ARRAY_SUPPORT ? (this[t2] = e3 >>> 8, this[t2 + 1] = 255 & e3) : N(this, e3, t2, false), t2 + 2;
        }, l.prototype.writeUInt32LE = function (e3, t2, r2) {
          return e3 = +e3, t2 |= 0, r2 || P(this, e3, t2, 4, 4294967295, 0), l.TYPED_ARRAY_SUPPORT ? (this[t2 + 3] = e3 >>> 24, this[t2 + 2] = e3 >>> 16, this[t2 + 1] = e3 >>> 8, this[t2] = 255 & e3) : L(this, e3, t2, true), t2 + 4;
        }, l.prototype.writeUInt32BE = function (e3, t2, r2) {
          return e3 = +e3, t2 |= 0, r2 || P(this, e3, t2, 4, 4294967295, 0), l.TYPED_ARRAY_SUPPORT ? (this[t2] = e3 >>> 24, this[t2 + 1] = e3 >>> 16, this[t2 + 2] = e3 >>> 8, this[t2 + 3] = 255 & e3) : L(this, e3, t2, false), t2 + 4;
        }, l.prototype.writeIntLE = function (e3, t2, r2, n2) {
          if (e3 = +e3, t2 |= 0, !n2) {
            var o2 = Math.pow(2, 8 * r2 - 1);
            P(this, e3, t2, r2, o2 - 1, -o2);
          }
          var i2 = 0,
            s2 = 1,
            a3 = 0;
          for (this[t2] = 255 & e3; ++i2 < r2 && (s2 *= 256);) e3 < 0 && 0 === a3 && 0 !== this[t2 + i2 - 1] && (a3 = 1), this[t2 + i2] = (e3 / s2 >> 0) - a3 & 255;
          return t2 + r2;
        }, l.prototype.writeIntBE = function (e3, t2, r2, n2) {
          if (e3 = +e3, t2 |= 0, !n2) {
            var o2 = Math.pow(2, 8 * r2 - 1);
            P(this, e3, t2, r2, o2 - 1, -o2);
          }
          var i2 = r2 - 1,
            s2 = 1,
            a3 = 0;
          for (this[t2 + i2] = 255 & e3; --i2 >= 0 && (s2 *= 256);) e3 < 0 && 0 === a3 && 0 !== this[t2 + i2 + 1] && (a3 = 1), this[t2 + i2] = (e3 / s2 >> 0) - a3 & 255;
          return t2 + r2;
        }, l.prototype.writeInt8 = function (e3, t2, r2) {
          return e3 = +e3, t2 |= 0, r2 || P(this, e3, t2, 1, 127, -128), l.TYPED_ARRAY_SUPPORT || (e3 = Math.floor(e3)), e3 < 0 && (e3 = 255 + e3 + 1), this[t2] = 255 & e3, t2 + 1;
        }, l.prototype.writeInt16LE = function (e3, t2, r2) {
          return e3 = +e3, t2 |= 0, r2 || P(this, e3, t2, 2, 32767, -32768), l.TYPED_ARRAY_SUPPORT ? (this[t2] = 255 & e3, this[t2 + 1] = e3 >>> 8) : N(this, e3, t2, true), t2 + 2;
        }, l.prototype.writeInt16BE = function (e3, t2, r2) {
          return e3 = +e3, t2 |= 0, r2 || P(this, e3, t2, 2, 32767, -32768), l.TYPED_ARRAY_SUPPORT ? (this[t2] = e3 >>> 8, this[t2 + 1] = 255 & e3) : N(this, e3, t2, false), t2 + 2;
        }, l.prototype.writeInt32LE = function (e3, t2, r2) {
          return e3 = +e3, t2 |= 0, r2 || P(this, e3, t2, 4, 2147483647, -2147483648), l.TYPED_ARRAY_SUPPORT ? (this[t2] = 255 & e3, this[t2 + 1] = e3 >>> 8, this[t2 + 2] = e3 >>> 16, this[t2 + 3] = e3 >>> 24) : L(this, e3, t2, true), t2 + 4;
        }, l.prototype.writeInt32BE = function (e3, t2, r2) {
          return e3 = +e3, t2 |= 0, r2 || P(this, e3, t2, 4, 2147483647, -2147483648), e3 < 0 && (e3 = 4294967295 + e3 + 1), l.TYPED_ARRAY_SUPPORT ? (this[t2] = e3 >>> 24, this[t2 + 1] = e3 >>> 16, this[t2 + 2] = e3 >>> 8, this[t2 + 3] = 255 & e3) : L(this, e3, t2, false), t2 + 4;
        }, l.prototype.writeFloatLE = function (e3, t2, r2) {
          return x(this, e3, t2, true, r2);
        }, l.prototype.writeFloatBE = function (e3, t2, r2) {
          return x(this, e3, t2, false, r2);
        }, l.prototype.writeDoubleLE = function (e3, t2, r2) {
          return U(this, e3, t2, true, r2);
        }, l.prototype.writeDoubleBE = function (e3, t2, r2) {
          return U(this, e3, t2, false, r2);
        }, l.prototype.copy = function (e3, t2, r2, n2) {
          if (r2 || (r2 = 0), n2 || 0 === n2 || (n2 = this.length), t2 >= e3.length && (t2 = e3.length), t2 || (t2 = 0), n2 > 0 && n2 < r2 && (n2 = r2), n2 === r2) return 0;
          if (0 === e3.length || 0 === this.length) return 0;
          if (t2 < 0) throw new RangeError("targetStart out of bounds");
          if (r2 < 0 || r2 >= this.length) throw new RangeError("sourceStart out of bounds");
          if (n2 < 0) throw new RangeError("sourceEnd out of bounds");
          n2 > this.length && (n2 = this.length), e3.length - t2 < n2 - r2 && (n2 = e3.length - t2 + r2);
          var o2,
            i2 = n2 - r2;
          if (this === e3 && r2 < t2 && t2 < n2) for (o2 = i2 - 1; o2 >= 0; --o2) e3[o2 + t2] = this[o2 + r2];else if (i2 < 1e3 || !l.TYPED_ARRAY_SUPPORT) for (o2 = 0; o2 < i2; ++o2) e3[o2 + t2] = this[o2 + r2];else Uint8Array.prototype.set.call(e3, this.subarray(r2, r2 + i2), t2);
          return i2;
        }, l.prototype.fill = function (e3, t2, r2, n2) {
          if ("string" == typeof e3) {
            if ("string" == typeof t2 ? (n2 = t2, t2 = 0, r2 = this.length) : "string" == typeof r2 && (n2 = r2, r2 = this.length), 1 === e3.length) {
              var o2 = e3.charCodeAt(0);
              o2 < 256 && (e3 = o2);
            }
            if (void 0 !== n2 && "string" != typeof n2) throw new TypeError("encoding must be a string");
            if ("string" == typeof n2 && !l.isEncoding(n2)) throw new TypeError("Unknown encoding: " + n2);
          } else "number" == typeof e3 && (e3 &= 255);
          if (t2 < 0 || this.length < t2 || this.length < r2) throw new RangeError("Out of range index");
          if (r2 <= t2) return this;
          var i2;
          if (t2 >>>= 0, r2 = void 0 === r2 ? this.length : r2 >>> 0, e3 || (e3 = 0), "number" == typeof e3) for (i2 = t2; i2 < r2; ++i2) this[i2] = e3;else {
            var s2 = l.isBuffer(e3) ? e3 : F(new l(e3, n2).toString()),
              a3 = s2.length;
            for (i2 = 0; i2 < r2 - t2; ++i2) this[i2 + t2] = s2[i2 % a3];
          }
          return this;
        };
        var B = /[^+\/0-9A-Za-z-_]/g;
        function k(e3) {
          return e3 < 16 ? "0" + e3.toString(16) : e3.toString(16);
        }
        function F(e3, t2) {
          var r2;
          t2 = t2 || 1 / 0;
          for (var n2 = e3.length, o2 = null, i2 = [], s2 = 0; s2 < n2; ++s2) {
            if ((r2 = e3.charCodeAt(s2)) > 55295 && r2 < 57344) {
              if (!o2) {
                if (r2 > 56319) {
                  (t2 -= 3) > -1 && i2.push(239, 191, 189);
                  continue;
                }
                if (s2 + 1 === n2) {
                  (t2 -= 3) > -1 && i2.push(239, 191, 189);
                  continue;
                }
                o2 = r2;
                continue;
              }
              if (r2 < 56320) {
                (t2 -= 3) > -1 && i2.push(239, 191, 189), o2 = r2;
                continue;
              }
              r2 = 65536 + (o2 - 55296 << 10 | r2 - 56320);
            } else o2 && (t2 -= 3) > -1 && i2.push(239, 191, 189);
            if (o2 = null, r2 < 128) {
              if ((t2 -= 1) < 0) break;
              i2.push(r2);
            } else if (r2 < 2048) {
              if ((t2 -= 2) < 0) break;
              i2.push(r2 >> 6 | 192, 63 & r2 | 128);
            } else if (r2 < 65536) {
              if ((t2 -= 3) < 0) break;
              i2.push(r2 >> 12 | 224, r2 >> 6 & 63 | 128, 63 & r2 | 128);
            } else {
              if (!(r2 < 1114112)) throw new Error("Invalid code point");
              if ((t2 -= 4) < 0) break;
              i2.push(r2 >> 18 | 240, r2 >> 12 & 63 | 128, r2 >> 6 & 63 | 128, 63 & r2 | 128);
            }
          }
          return i2;
        }
        function W(e3) {
          return n.toByteArray(function (e4) {
            if ((e4 = function (e5) {
              return e5.trim ? e5.trim() : e5.replace(/^\s+|\s+$/g, "");
            }(e4).replace(B, "")).length < 2) return "";
            for (; e4.length % 4 != 0;) e4 += "=";
            return e4;
          }(e3));
        }
        function V(e3, t2, r2, n2) {
          for (var o2 = 0; o2 < n2 && !(o2 + r2 >= t2.length || o2 >= e3.length); ++o2) t2[o2 + r2] = e3[o2];
          return o2;
        }
      }).call(this, r(6));
    }, function (e, t) {
      var r;
      r = function () {
        return this;
      }();
      try {
        r = r || new Function("return this")();
      } catch (e2) {
        "object" == typeof window && (r = window);
      }
      e.exports = r;
    }, function (e, t) {
      "function" == typeof Object.create ? e.exports = function (e2, t2) {
        t2 && (e2.super_ = t2, e2.prototype = Object.create(t2.prototype, {
          constructor: {
            value: e2,
            enumerable: false,
            writable: true,
            configurable: true
          }
        }));
      } : e.exports = function (e2, t2) {
        if (t2) {
          e2.super_ = t2;
          var r = function r() {};
          r.prototype = t2.prototype, e2.prototype = new r(), e2.prototype.constructor = e2;
        }
      };
    }, function (e, t, r) {
      r.d(t, "a", function () {
        return n;
      });
      var n = function n(e2) {
        return new Promise(function (t2) {
          return setTimeout(t2, e2 || 0);
        });
      };
    }, function (e, t, r) {
      var n = r(99),
        o = n,
        i = Function("return this")(),
        s = r(98);
      o.object.extend(proto, s), o.exportSymbol("proto.v1.signaling.api.CreatePeerRequest", null, i), o.exportSymbol("proto.v1.signaling.api.CreatePeerResponse", null, i), o.exportSymbol("proto.v1.signaling.api.DeletePeerRequest", null, i), o.exportSymbol("proto.v1.signaling.api.DeletePeerResponse", null, i), o.exportSymbol("proto.v1.signaling.api.GetHealthRequest", null, i), o.exportSymbol("proto.v1.signaling.api.GetHealthResponse", null, i), o.exportSymbol("proto.v1.signaling.api.GetIceServersRequest", null, i), o.exportSymbol("proto.v1.signaling.api.GetIceServersResponse", null, i), o.exportSymbol("proto.v1.signaling.api.GetPeersRequest", null, i), o.exportSymbol("proto.v1.signaling.api.GetPeersResponse", null, i), o.exportSymbol("proto.v1.signaling.api.Peer", null, i), o.exportSymbol("proto.v1.signaling.api.ReceiveSignalStreamRequest", null, i), o.exportSymbol("proto.v1.signaling.api.ReceiveSignalStreamResponse", null, i), o.exportSymbol("proto.v1.signaling.api.RefreshPeerRequest", null, i), o.exportSymbol("proto.v1.signaling.api.RefreshPeerResponse", null, i), o.exportSymbol("proto.v1.signaling.api.SendSignalRequest", null, i), o.exportSymbol("proto.v1.signaling.api.SendSignalResponse", null, i), o.exportSymbol("proto.v1.signaling.api.SessionType", null, i), o.exportSymbol("proto.v1.signaling.api.Signal", null, i), proto.v1.signaling.api.Peer = function (e2) {
        n.Message.initialize(this, e2, 0, -1, proto.v1.signaling.api.Peer.repeatedFields_, null);
      }, o.inherits(proto.v1.signaling.api.Peer, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.Peer.displayName = "proto.v1.signaling.api.Peer"), proto.v1.signaling.api.Signal = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.Signal, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.Signal.displayName = "proto.v1.signaling.api.Signal"), proto.v1.signaling.api.GetHealthRequest = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.GetHealthRequest, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.GetHealthRequest.displayName = "proto.v1.signaling.api.GetHealthRequest"), proto.v1.signaling.api.GetHealthResponse = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.GetHealthResponse, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.GetHealthResponse.displayName = "proto.v1.signaling.api.GetHealthResponse"), proto.v1.signaling.api.CreatePeerRequest = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.CreatePeerRequest, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.CreatePeerRequest.displayName = "proto.v1.signaling.api.CreatePeerRequest"), proto.v1.signaling.api.CreatePeerResponse = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.CreatePeerResponse, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.CreatePeerResponse.displayName = "proto.v1.signaling.api.CreatePeerResponse"), proto.v1.signaling.api.DeletePeerRequest = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.DeletePeerRequest, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.DeletePeerRequest.displayName = "proto.v1.signaling.api.DeletePeerRequest"), proto.v1.signaling.api.DeletePeerResponse = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.DeletePeerResponse, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.DeletePeerResponse.displayName = "proto.v1.signaling.api.DeletePeerResponse"), proto.v1.signaling.api.RefreshPeerRequest = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.RefreshPeerRequest, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.RefreshPeerRequest.displayName = "proto.v1.signaling.api.RefreshPeerRequest"), proto.v1.signaling.api.RefreshPeerResponse = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.RefreshPeerResponse, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.RefreshPeerResponse.displayName = "proto.v1.signaling.api.RefreshPeerResponse"), proto.v1.signaling.api.GetPeersRequest = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.GetPeersRequest, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.GetPeersRequest.displayName = "proto.v1.signaling.api.GetPeersRequest"), proto.v1.signaling.api.GetPeersResponse = function (e2) {
        n.Message.initialize(this, e2, 0, -1, proto.v1.signaling.api.GetPeersResponse.repeatedFields_, null);
      }, o.inherits(proto.v1.signaling.api.GetPeersResponse, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.GetPeersResponse.displayName = "proto.v1.signaling.api.GetPeersResponse"), proto.v1.signaling.api.GetIceServersRequest = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.GetIceServersRequest, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.GetIceServersRequest.displayName = "proto.v1.signaling.api.GetIceServersRequest"), proto.v1.signaling.api.GetIceServersResponse = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.GetIceServersResponse, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.GetIceServersResponse.displayName = "proto.v1.signaling.api.GetIceServersResponse"), proto.v1.signaling.api.SendSignalRequest = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.SendSignalRequest, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.SendSignalRequest.displayName = "proto.v1.signaling.api.SendSignalRequest"), proto.v1.signaling.api.SendSignalResponse = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.SendSignalResponse, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.SendSignalResponse.displayName = "proto.v1.signaling.api.SendSignalResponse"), proto.v1.signaling.api.ReceiveSignalStreamRequest = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.ReceiveSignalStreamRequest, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.ReceiveSignalStreamRequest.displayName = "proto.v1.signaling.api.ReceiveSignalStreamRequest"), proto.v1.signaling.api.ReceiveSignalStreamResponse = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.v1.signaling.api.ReceiveSignalStreamResponse, n.Message), o.DEBUG && !COMPILED && (proto.v1.signaling.api.ReceiveSignalStreamResponse.displayName = "proto.v1.signaling.api.ReceiveSignalStreamResponse"), proto.v1.signaling.api.Peer.repeatedFields_ = [5], n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.Peer.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.Peer.toObject(e2, this);
      }, proto.v1.signaling.api.Peer.toObject = function (e2, t2) {
        var r2,
          o2 = {
            peerId: n.Message.getFieldWithDefault(t2, 1, ""),
            organizationId: n.Message.getFieldWithDefault(t2, 2, ""),
            userId: (r2 = t2.getUserId()) && s.StringValue.toObject(e2, r2),
            deviceId: (r2 = t2.getDeviceId()) && s.StringValue.toObject(e2, r2),
            sessionIdsList: null == (r2 = n.Message.getRepeatedField(t2, 5)) ? void 0 : r2,
            peerCreatedTimestamp: (r2 = t2.getPeerCreatedTimestamp()) && s.Int64Value.toObject(e2, r2)
          };
        return e2 && (o2.$jspbMessageInstance = t2), o2;
      }), proto.v1.signaling.api.Peer.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.Peer();
        return proto.v1.signaling.api.Peer.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.Peer.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readString();
              e2.setPeerId(r2);
              break;
            case 2:
              r2 = t2.readString();
              e2.setOrganizationId(r2);
              break;
            case 3:
              r2 = new s.StringValue();
              t2.readMessage(r2, s.StringValue.deserializeBinaryFromReader), e2.setUserId(r2);
              break;
            case 4:
              r2 = new s.StringValue();
              t2.readMessage(r2, s.StringValue.deserializeBinaryFromReader), e2.setDeviceId(r2);
              break;
            case 5:
              r2 = t2.readString();
              e2.addSessionIds(r2);
              break;
            case 6:
              r2 = new s.Int64Value();
              t2.readMessage(r2, s.Int64Value.deserializeBinaryFromReader), e2.setPeerCreatedTimestamp(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.Peer.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.Peer.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.Peer.serializeBinaryToWriter = function (e2, t2) {
        var r2 = void 0;
        (r2 = e2.getPeerId()).length > 0 && t2.writeString(1, r2), (r2 = e2.getOrganizationId()).length > 0 && t2.writeString(2, r2), null != (r2 = e2.getUserId()) && t2.writeMessage(3, r2, s.StringValue.serializeBinaryToWriter), null != (r2 = e2.getDeviceId()) && t2.writeMessage(4, r2, s.StringValue.serializeBinaryToWriter), (r2 = e2.getSessionIdsList()).length > 0 && t2.writeRepeatedString(5, r2), null != (r2 = e2.getPeerCreatedTimestamp()) && t2.writeMessage(6, r2, s.Int64Value.serializeBinaryToWriter);
      }, proto.v1.signaling.api.Peer.prototype.getPeerId = function () {
        return n.Message.getFieldWithDefault(this, 1, "");
      }, proto.v1.signaling.api.Peer.prototype.setPeerId = function (e2) {
        return n.Message.setProto3StringField(this, 1, e2);
      }, proto.v1.signaling.api.Peer.prototype.getOrganizationId = function () {
        return n.Message.getFieldWithDefault(this, 2, "");
      }, proto.v1.signaling.api.Peer.prototype.setOrganizationId = function (e2) {
        return n.Message.setProto3StringField(this, 2, e2);
      }, proto.v1.signaling.api.Peer.prototype.getUserId = function () {
        return n.Message.getWrapperField(this, s.StringValue, 3);
      }, proto.v1.signaling.api.Peer.prototype.setUserId = function (e2) {
        return n.Message.setWrapperField(this, 3, e2);
      }, proto.v1.signaling.api.Peer.prototype.clearUserId = function () {
        return this.setUserId(void 0);
      }, proto.v1.signaling.api.Peer.prototype.hasUserId = function () {
        return null != n.Message.getField(this, 3);
      }, proto.v1.signaling.api.Peer.prototype.getDeviceId = function () {
        return n.Message.getWrapperField(this, s.StringValue, 4);
      }, proto.v1.signaling.api.Peer.prototype.setDeviceId = function (e2) {
        return n.Message.setWrapperField(this, 4, e2);
      }, proto.v1.signaling.api.Peer.prototype.clearDeviceId = function () {
        return this.setDeviceId(void 0);
      }, proto.v1.signaling.api.Peer.prototype.hasDeviceId = function () {
        return null != n.Message.getField(this, 4);
      }, proto.v1.signaling.api.Peer.prototype.getSessionIdsList = function () {
        return n.Message.getRepeatedField(this, 5);
      }, proto.v1.signaling.api.Peer.prototype.setSessionIdsList = function (e2) {
        return n.Message.setField(this, 5, e2 || []);
      }, proto.v1.signaling.api.Peer.prototype.addSessionIds = function (e2, t2) {
        return n.Message.addToRepeatedField(this, 5, e2, t2);
      }, proto.v1.signaling.api.Peer.prototype.clearSessionIdsList = function () {
        return this.setSessionIdsList([]);
      }, proto.v1.signaling.api.Peer.prototype.getPeerCreatedTimestamp = function () {
        return n.Message.getWrapperField(this, s.Int64Value, 6);
      }, proto.v1.signaling.api.Peer.prototype.setPeerCreatedTimestamp = function (e2) {
        return n.Message.setWrapperField(this, 6, e2);
      }, proto.v1.signaling.api.Peer.prototype.clearPeerCreatedTimestamp = function () {
        return this.setPeerCreatedTimestamp(void 0);
      }, proto.v1.signaling.api.Peer.prototype.hasPeerCreatedTimestamp = function () {
        return null != n.Message.getField(this, 6);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.Signal.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.Signal.toObject(e2, this);
      }, proto.v1.signaling.api.Signal.toObject = function (e2, t2) {
        var r2,
          o2 = {
            sessionId: (r2 = t2.getSessionId()) && s.StringValue.toObject(e2, r2),
            sessionCreatedTimestamp: (r2 = t2.getSessionCreatedTimestamp()) && s.Int64Value.toObject(e2, r2),
            senderId: n.Message.getFieldWithDefault(t2, 3, ""),
            receiverId: n.Message.getFieldWithDefault(t2, 4, ""),
            payload: n.Message.getFieldWithDefault(t2, 5, ""),
            iceServers: n.Message.getFieldWithDefault(t2, 6, ""),
            iceTransportPolicy: n.Message.getFieldWithDefault(t2, 7, ""),
            sessionType: n.Message.getFieldWithDefault(t2, 8, 0)
          };
        return e2 && (o2.$jspbMessageInstance = t2), o2;
      }), proto.v1.signaling.api.Signal.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.Signal();
        return proto.v1.signaling.api.Signal.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.Signal.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = new s.StringValue();
              t2.readMessage(r2, s.StringValue.deserializeBinaryFromReader), e2.setSessionId(r2);
              break;
            case 2:
              r2 = new s.Int64Value();
              t2.readMessage(r2, s.Int64Value.deserializeBinaryFromReader), e2.setSessionCreatedTimestamp(r2);
              break;
            case 3:
              r2 = t2.readString();
              e2.setSenderId(r2);
              break;
            case 4:
              r2 = t2.readString();
              e2.setReceiverId(r2);
              break;
            case 5:
              r2 = t2.readString();
              e2.setPayload(r2);
              break;
            case 6:
              r2 = t2.readString();
              e2.setIceServers(r2);
              break;
            case 7:
              r2 = t2.readString();
              e2.setIceTransportPolicy(r2);
              break;
            case 8:
              r2 = t2.readEnum();
              e2.setSessionType(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.Signal.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.Signal.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.Signal.serializeBinaryToWriter = function (e2, t2) {
        var r2 = void 0;
        null != (r2 = e2.getSessionId()) && t2.writeMessage(1, r2, s.StringValue.serializeBinaryToWriter), null != (r2 = e2.getSessionCreatedTimestamp()) && t2.writeMessage(2, r2, s.Int64Value.serializeBinaryToWriter), (r2 = e2.getSenderId()).length > 0 && t2.writeString(3, r2), (r2 = e2.getReceiverId()).length > 0 && t2.writeString(4, r2), (r2 = e2.getPayload()).length > 0 && t2.writeString(5, r2), (r2 = e2.getIceServers()).length > 0 && t2.writeString(6, r2), (r2 = e2.getIceTransportPolicy()).length > 0 && t2.writeString(7, r2), 0 !== (r2 = e2.getSessionType()) && t2.writeEnum(8, r2);
      }, proto.v1.signaling.api.Signal.prototype.getSessionId = function () {
        return n.Message.getWrapperField(this, s.StringValue, 1);
      }, proto.v1.signaling.api.Signal.prototype.setSessionId = function (e2) {
        return n.Message.setWrapperField(this, 1, e2);
      }, proto.v1.signaling.api.Signal.prototype.clearSessionId = function () {
        return this.setSessionId(void 0);
      }, proto.v1.signaling.api.Signal.prototype.hasSessionId = function () {
        return null != n.Message.getField(this, 1);
      }, proto.v1.signaling.api.Signal.prototype.getSessionCreatedTimestamp = function () {
        return n.Message.getWrapperField(this, s.Int64Value, 2);
      }, proto.v1.signaling.api.Signal.prototype.setSessionCreatedTimestamp = function (e2) {
        return n.Message.setWrapperField(this, 2, e2);
      }, proto.v1.signaling.api.Signal.prototype.clearSessionCreatedTimestamp = function () {
        return this.setSessionCreatedTimestamp(void 0);
      }, proto.v1.signaling.api.Signal.prototype.hasSessionCreatedTimestamp = function () {
        return null != n.Message.getField(this, 2);
      }, proto.v1.signaling.api.Signal.prototype.getSenderId = function () {
        return n.Message.getFieldWithDefault(this, 3, "");
      }, proto.v1.signaling.api.Signal.prototype.setSenderId = function (e2) {
        return n.Message.setProto3StringField(this, 3, e2);
      }, proto.v1.signaling.api.Signal.prototype.getReceiverId = function () {
        return n.Message.getFieldWithDefault(this, 4, "");
      }, proto.v1.signaling.api.Signal.prototype.setReceiverId = function (e2) {
        return n.Message.setProto3StringField(this, 4, e2);
      }, proto.v1.signaling.api.Signal.prototype.getPayload = function () {
        return n.Message.getFieldWithDefault(this, 5, "");
      }, proto.v1.signaling.api.Signal.prototype.setPayload = function (e2) {
        return n.Message.setProto3StringField(this, 5, e2);
      }, proto.v1.signaling.api.Signal.prototype.getIceServers = function () {
        return n.Message.getFieldWithDefault(this, 6, "");
      }, proto.v1.signaling.api.Signal.prototype.setIceServers = function (e2) {
        return n.Message.setProto3StringField(this, 6, e2);
      }, proto.v1.signaling.api.Signal.prototype.getIceTransportPolicy = function () {
        return n.Message.getFieldWithDefault(this, 7, "");
      }, proto.v1.signaling.api.Signal.prototype.setIceTransportPolicy = function (e2) {
        return n.Message.setProto3StringField(this, 7, e2);
      }, proto.v1.signaling.api.Signal.prototype.getSessionType = function () {
        return n.Message.getFieldWithDefault(this, 8, 0);
      }, proto.v1.signaling.api.Signal.prototype.setSessionType = function (e2) {
        return n.Message.setProto3EnumField(this, 8, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.GetHealthRequest.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.GetHealthRequest.toObject(e2, this);
      }, proto.v1.signaling.api.GetHealthRequest.toObject = function (e2, t2) {
        var r2 = {};
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.GetHealthRequest.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.GetHealthRequest();
        return proto.v1.signaling.api.GetHealthRequest.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.GetHealthRequest.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          t2.getFieldNumber();
          t2.skipField();
        }
        return e2;
      }, proto.v1.signaling.api.GetHealthRequest.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.GetHealthRequest.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.GetHealthRequest.serializeBinaryToWriter = function (e2, t2) {}, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.GetHealthResponse.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.GetHealthResponse.toObject(e2, this);
      }, proto.v1.signaling.api.GetHealthResponse.toObject = function (e2, t2) {
        var r2 = {
          version: n.Message.getFieldWithDefault(t2, 1, "")
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.GetHealthResponse.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.GetHealthResponse();
        return proto.v1.signaling.api.GetHealthResponse.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.GetHealthResponse.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readString();
              e2.setVersion(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.GetHealthResponse.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.GetHealthResponse.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.GetHealthResponse.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        (r2 = e2.getVersion()).length > 0 && t2.writeString(1, r2);
      }, proto.v1.signaling.api.GetHealthResponse.prototype.getVersion = function () {
        return n.Message.getFieldWithDefault(this, 1, "");
      }, proto.v1.signaling.api.GetHealthResponse.prototype.setVersion = function (e2) {
        return n.Message.setProto3StringField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.CreatePeerRequest.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.CreatePeerRequest.toObject(e2, this);
      }, proto.v1.signaling.api.CreatePeerRequest.toObject = function (e2, t2) {
        var r2 = {};
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.CreatePeerRequest.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.CreatePeerRequest();
        return proto.v1.signaling.api.CreatePeerRequest.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.CreatePeerRequest.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          t2.getFieldNumber();
          t2.skipField();
        }
        return e2;
      }, proto.v1.signaling.api.CreatePeerRequest.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.CreatePeerRequest.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.CreatePeerRequest.serializeBinaryToWriter = function (e2, t2) {}, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.CreatePeerResponse.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.CreatePeerResponse.toObject(e2, this);
      }, proto.v1.signaling.api.CreatePeerResponse.toObject = function (e2, t2) {
        var r2,
          n2 = {
            peer: (r2 = t2.getPeer()) && proto.v1.signaling.api.Peer.toObject(e2, r2)
          };
        return e2 && (n2.$jspbMessageInstance = t2), n2;
      }), proto.v1.signaling.api.CreatePeerResponse.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.CreatePeerResponse();
        return proto.v1.signaling.api.CreatePeerResponse.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.CreatePeerResponse.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = new proto.v1.signaling.api.Peer();
              t2.readMessage(r2, proto.v1.signaling.api.Peer.deserializeBinaryFromReader), e2.setPeer(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.CreatePeerResponse.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.CreatePeerResponse.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.CreatePeerResponse.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        null != (r2 = e2.getPeer()) && t2.writeMessage(1, r2, proto.v1.signaling.api.Peer.serializeBinaryToWriter);
      }, proto.v1.signaling.api.CreatePeerResponse.prototype.getPeer = function () {
        return n.Message.getWrapperField(this, proto.v1.signaling.api.Peer, 1);
      }, proto.v1.signaling.api.CreatePeerResponse.prototype.setPeer = function (e2) {
        return n.Message.setWrapperField(this, 1, e2);
      }, proto.v1.signaling.api.CreatePeerResponse.prototype.clearPeer = function () {
        return this.setPeer(void 0);
      }, proto.v1.signaling.api.CreatePeerResponse.prototype.hasPeer = function () {
        return null != n.Message.getField(this, 1);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.DeletePeerRequest.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.DeletePeerRequest.toObject(e2, this);
      }, proto.v1.signaling.api.DeletePeerRequest.toObject = function (e2, t2) {
        var r2 = {
          peerId: n.Message.getFieldWithDefault(t2, 1, "")
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.DeletePeerRequest.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.DeletePeerRequest();
        return proto.v1.signaling.api.DeletePeerRequest.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.DeletePeerRequest.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readString();
              e2.setPeerId(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.DeletePeerRequest.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.DeletePeerRequest.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.DeletePeerRequest.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        (r2 = e2.getPeerId()).length > 0 && t2.writeString(1, r2);
      }, proto.v1.signaling.api.DeletePeerRequest.prototype.getPeerId = function () {
        return n.Message.getFieldWithDefault(this, 1, "");
      }, proto.v1.signaling.api.DeletePeerRequest.prototype.setPeerId = function (e2) {
        return n.Message.setProto3StringField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.DeletePeerResponse.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.DeletePeerResponse.toObject(e2, this);
      }, proto.v1.signaling.api.DeletePeerResponse.toObject = function (e2, t2) {
        var r2 = {};
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.DeletePeerResponse.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.DeletePeerResponse();
        return proto.v1.signaling.api.DeletePeerResponse.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.DeletePeerResponse.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          t2.getFieldNumber();
          t2.skipField();
        }
        return e2;
      }, proto.v1.signaling.api.DeletePeerResponse.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.DeletePeerResponse.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.DeletePeerResponse.serializeBinaryToWriter = function (e2, t2) {}, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.RefreshPeerRequest.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.RefreshPeerRequest.toObject(e2, this);
      }, proto.v1.signaling.api.RefreshPeerRequest.toObject = function (e2, t2) {
        var r2,
          n2 = {
            peer: (r2 = t2.getPeer()) && proto.v1.signaling.api.Peer.toObject(e2, r2)
          };
        return e2 && (n2.$jspbMessageInstance = t2), n2;
      }), proto.v1.signaling.api.RefreshPeerRequest.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.RefreshPeerRequest();
        return proto.v1.signaling.api.RefreshPeerRequest.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.RefreshPeerRequest.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = new proto.v1.signaling.api.Peer();
              t2.readMessage(r2, proto.v1.signaling.api.Peer.deserializeBinaryFromReader), e2.setPeer(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.RefreshPeerRequest.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.RefreshPeerRequest.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.RefreshPeerRequest.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        null != (r2 = e2.getPeer()) && t2.writeMessage(1, r2, proto.v1.signaling.api.Peer.serializeBinaryToWriter);
      }, proto.v1.signaling.api.RefreshPeerRequest.prototype.getPeer = function () {
        return n.Message.getWrapperField(this, proto.v1.signaling.api.Peer, 1);
      }, proto.v1.signaling.api.RefreshPeerRequest.prototype.setPeer = function (e2) {
        return n.Message.setWrapperField(this, 1, e2);
      }, proto.v1.signaling.api.RefreshPeerRequest.prototype.clearPeer = function () {
        return this.setPeer(void 0);
      }, proto.v1.signaling.api.RefreshPeerRequest.prototype.hasPeer = function () {
        return null != n.Message.getField(this, 1);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.RefreshPeerResponse.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.RefreshPeerResponse.toObject(e2, this);
      }, proto.v1.signaling.api.RefreshPeerResponse.toObject = function (e2, t2) {
        var r2 = {};
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.RefreshPeerResponse.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.RefreshPeerResponse();
        return proto.v1.signaling.api.RefreshPeerResponse.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.RefreshPeerResponse.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          t2.getFieldNumber();
          t2.skipField();
        }
        return e2;
      }, proto.v1.signaling.api.RefreshPeerResponse.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.RefreshPeerResponse.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.RefreshPeerResponse.serializeBinaryToWriter = function (e2, t2) {}, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.GetPeersRequest.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.GetPeersRequest.toObject(e2, this);
      }, proto.v1.signaling.api.GetPeersRequest.toObject = function (e2, t2) {
        var r2 = {};
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.GetPeersRequest.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.GetPeersRequest();
        return proto.v1.signaling.api.GetPeersRequest.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.GetPeersRequest.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          t2.getFieldNumber();
          t2.skipField();
        }
        return e2;
      }, proto.v1.signaling.api.GetPeersRequest.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.GetPeersRequest.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.GetPeersRequest.serializeBinaryToWriter = function (e2, t2) {}, proto.v1.signaling.api.GetPeersResponse.repeatedFields_ = [1], n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.GetPeersResponse.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.GetPeersResponse.toObject(e2, this);
      }, proto.v1.signaling.api.GetPeersResponse.toObject = function (e2, t2) {
        var r2 = {
          peersList: n.Message.toObjectList(t2.getPeersList(), proto.v1.signaling.api.Peer.toObject, e2)
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.GetPeersResponse.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.GetPeersResponse();
        return proto.v1.signaling.api.GetPeersResponse.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.GetPeersResponse.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = new proto.v1.signaling.api.Peer();
              t2.readMessage(r2, proto.v1.signaling.api.Peer.deserializeBinaryFromReader), e2.addPeers(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.GetPeersResponse.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.GetPeersResponse.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.GetPeersResponse.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        (r2 = e2.getPeersList()).length > 0 && t2.writeRepeatedMessage(1, r2, proto.v1.signaling.api.Peer.serializeBinaryToWriter);
      }, proto.v1.signaling.api.GetPeersResponse.prototype.getPeersList = function () {
        return n.Message.getRepeatedWrapperField(this, proto.v1.signaling.api.Peer, 1);
      }, proto.v1.signaling.api.GetPeersResponse.prototype.setPeersList = function (e2) {
        return n.Message.setRepeatedWrapperField(this, 1, e2);
      }, proto.v1.signaling.api.GetPeersResponse.prototype.addPeers = function (e2, t2) {
        return n.Message.addToRepeatedWrapperField(this, 1, e2, proto.v1.signaling.api.Peer, t2);
      }, proto.v1.signaling.api.GetPeersResponse.prototype.clearPeersList = function () {
        return this.setPeersList([]);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.GetIceServersRequest.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.GetIceServersRequest.toObject(e2, this);
      }, proto.v1.signaling.api.GetIceServersRequest.toObject = function (e2, t2) {
        var r2 = {};
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.GetIceServersRequest.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.GetIceServersRequest();
        return proto.v1.signaling.api.GetIceServersRequest.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.GetIceServersRequest.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          t2.getFieldNumber();
          t2.skipField();
        }
        return e2;
      }, proto.v1.signaling.api.GetIceServersRequest.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.GetIceServersRequest.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.GetIceServersRequest.serializeBinaryToWriter = function (e2, t2) {}, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.GetIceServersResponse.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.GetIceServersResponse.toObject(e2, this);
      }, proto.v1.signaling.api.GetIceServersResponse.toObject = function (e2, t2) {
        var r2 = {
          iceServers: n.Message.getFieldWithDefault(t2, 1, "")
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.GetIceServersResponse.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.GetIceServersResponse();
        return proto.v1.signaling.api.GetIceServersResponse.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.GetIceServersResponse.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readString();
              e2.setIceServers(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.GetIceServersResponse.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.GetIceServersResponse.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.GetIceServersResponse.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        (r2 = e2.getIceServers()).length > 0 && t2.writeString(1, r2);
      }, proto.v1.signaling.api.GetIceServersResponse.prototype.getIceServers = function () {
        return n.Message.getFieldWithDefault(this, 1, "");
      }, proto.v1.signaling.api.GetIceServersResponse.prototype.setIceServers = function (e2) {
        return n.Message.setProto3StringField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.SendSignalRequest.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.SendSignalRequest.toObject(e2, this);
      }, proto.v1.signaling.api.SendSignalRequest.toObject = function (e2, t2) {
        var r2,
          n2 = {
            signal: (r2 = t2.getSignal()) && proto.v1.signaling.api.Signal.toObject(e2, r2)
          };
        return e2 && (n2.$jspbMessageInstance = t2), n2;
      }), proto.v1.signaling.api.SendSignalRequest.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.SendSignalRequest();
        return proto.v1.signaling.api.SendSignalRequest.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.SendSignalRequest.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = new proto.v1.signaling.api.Signal();
              t2.readMessage(r2, proto.v1.signaling.api.Signal.deserializeBinaryFromReader), e2.setSignal(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.SendSignalRequest.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.SendSignalRequest.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.SendSignalRequest.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        null != (r2 = e2.getSignal()) && t2.writeMessage(1, r2, proto.v1.signaling.api.Signal.serializeBinaryToWriter);
      }, proto.v1.signaling.api.SendSignalRequest.prototype.getSignal = function () {
        return n.Message.getWrapperField(this, proto.v1.signaling.api.Signal, 1);
      }, proto.v1.signaling.api.SendSignalRequest.prototype.setSignal = function (e2) {
        return n.Message.setWrapperField(this, 1, e2);
      }, proto.v1.signaling.api.SendSignalRequest.prototype.clearSignal = function () {
        return this.setSignal(void 0);
      }, proto.v1.signaling.api.SendSignalRequest.prototype.hasSignal = function () {
        return null != n.Message.getField(this, 1);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.SendSignalResponse.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.SendSignalResponse.toObject(e2, this);
      }, proto.v1.signaling.api.SendSignalResponse.toObject = function (e2, t2) {
        var r2,
          n2 = {
            sessionId: (r2 = t2.getSessionId()) && s.StringValue.toObject(e2, r2),
            sessionCreatedTimestamp: (r2 = t2.getSessionCreatedTimestamp()) && s.Int64Value.toObject(e2, r2)
          };
        return e2 && (n2.$jspbMessageInstance = t2), n2;
      }), proto.v1.signaling.api.SendSignalResponse.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.SendSignalResponse();
        return proto.v1.signaling.api.SendSignalResponse.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.SendSignalResponse.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = new s.StringValue();
              t2.readMessage(r2, s.StringValue.deserializeBinaryFromReader), e2.setSessionId(r2);
              break;
            case 2:
              r2 = new s.Int64Value();
              t2.readMessage(r2, s.Int64Value.deserializeBinaryFromReader), e2.setSessionCreatedTimestamp(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.SendSignalResponse.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.SendSignalResponse.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.SendSignalResponse.serializeBinaryToWriter = function (e2, t2) {
        var r2 = void 0;
        null != (r2 = e2.getSessionId()) && t2.writeMessage(1, r2, s.StringValue.serializeBinaryToWriter), null != (r2 = e2.getSessionCreatedTimestamp()) && t2.writeMessage(2, r2, s.Int64Value.serializeBinaryToWriter);
      }, proto.v1.signaling.api.SendSignalResponse.prototype.getSessionId = function () {
        return n.Message.getWrapperField(this, s.StringValue, 1);
      }, proto.v1.signaling.api.SendSignalResponse.prototype.setSessionId = function (e2) {
        return n.Message.setWrapperField(this, 1, e2);
      }, proto.v1.signaling.api.SendSignalResponse.prototype.clearSessionId = function () {
        return this.setSessionId(void 0);
      }, proto.v1.signaling.api.SendSignalResponse.prototype.hasSessionId = function () {
        return null != n.Message.getField(this, 1);
      }, proto.v1.signaling.api.SendSignalResponse.prototype.getSessionCreatedTimestamp = function () {
        return n.Message.getWrapperField(this, s.Int64Value, 2);
      }, proto.v1.signaling.api.SendSignalResponse.prototype.setSessionCreatedTimestamp = function (e2) {
        return n.Message.setWrapperField(this, 2, e2);
      }, proto.v1.signaling.api.SendSignalResponse.prototype.clearSessionCreatedTimestamp = function () {
        return this.setSessionCreatedTimestamp(void 0);
      }, proto.v1.signaling.api.SendSignalResponse.prototype.hasSessionCreatedTimestamp = function () {
        return null != n.Message.getField(this, 2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.ReceiveSignalStreamRequest.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.ReceiveSignalStreamRequest.toObject(e2, this);
      }, proto.v1.signaling.api.ReceiveSignalStreamRequest.toObject = function (e2, t2) {
        var r2 = {
          peerId: n.Message.getFieldWithDefault(t2, 1, "")
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.v1.signaling.api.ReceiveSignalStreamRequest.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.ReceiveSignalStreamRequest();
        return proto.v1.signaling.api.ReceiveSignalStreamRequest.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.ReceiveSignalStreamRequest.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readString();
              e2.setPeerId(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.ReceiveSignalStreamRequest.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.ReceiveSignalStreamRequest.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.ReceiveSignalStreamRequest.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        (r2 = e2.getPeerId()).length > 0 && t2.writeString(1, r2);
      }, proto.v1.signaling.api.ReceiveSignalStreamRequest.prototype.getPeerId = function () {
        return n.Message.getFieldWithDefault(this, 1, "");
      }, proto.v1.signaling.api.ReceiveSignalStreamRequest.prototype.setPeerId = function (e2) {
        return n.Message.setProto3StringField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.v1.signaling.api.ReceiveSignalStreamResponse.prototype.toObject = function (e2) {
        return proto.v1.signaling.api.ReceiveSignalStreamResponse.toObject(e2, this);
      }, proto.v1.signaling.api.ReceiveSignalStreamResponse.toObject = function (e2, t2) {
        var r2,
          n2 = {
            signal: (r2 = t2.getSignal()) && proto.v1.signaling.api.Signal.toObject(e2, r2)
          };
        return e2 && (n2.$jspbMessageInstance = t2), n2;
      }), proto.v1.signaling.api.ReceiveSignalStreamResponse.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.v1.signaling.api.ReceiveSignalStreamResponse();
        return proto.v1.signaling.api.ReceiveSignalStreamResponse.deserializeBinaryFromReader(r2, t2);
      }, proto.v1.signaling.api.ReceiveSignalStreamResponse.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = new proto.v1.signaling.api.Signal();
              t2.readMessage(r2, proto.v1.signaling.api.Signal.deserializeBinaryFromReader), e2.setSignal(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.v1.signaling.api.ReceiveSignalStreamResponse.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.v1.signaling.api.ReceiveSignalStreamResponse.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.v1.signaling.api.ReceiveSignalStreamResponse.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        null != (r2 = e2.getSignal()) && t2.writeMessage(1, r2, proto.v1.signaling.api.Signal.serializeBinaryToWriter);
      }, proto.v1.signaling.api.ReceiveSignalStreamResponse.prototype.getSignal = function () {
        return n.Message.getWrapperField(this, proto.v1.signaling.api.Signal, 1);
      }, proto.v1.signaling.api.ReceiveSignalStreamResponse.prototype.setSignal = function (e2) {
        return n.Message.setWrapperField(this, 1, e2);
      }, proto.v1.signaling.api.ReceiveSignalStreamResponse.prototype.clearSignal = function () {
        return this.setSignal(void 0);
      }, proto.v1.signaling.api.ReceiveSignalStreamResponse.prototype.hasSignal = function () {
        return null != n.Message.getField(this, 1);
      }, proto.v1.signaling.api.SessionType = {
        UNKNOWN: 0,
        TELEOP: 1,
        PORT_FORWARD: 2,
        OBSERVE: 3
      }, o.object.extend(t, proto.v1.signaling.api);
    }, function (e, t, r) {
      function n(e2, t2) {
        var r2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
          return true;
        };
        if (e2 instanceof t2 && r2(e2)) return e2;
        throw e2;
      }
      r.d(t, "a", function () {
        return n;
      });
    }, function (e, t, r) {
      r.d(t, "a", function () {
        return o;
      });
      var n = r(34);
      var o = /*#__PURE__*/function (_Error) {
        _inherits(o, _Error);
        function o(e2, t2, r2, o2) {
          var _this2;
          var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
          var s = arguments.length > 5 ? arguments[5] : undefined;
          _classCallCheck(this, o);
          _this2 = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, "Unexpected response (".concat(r2, ") for ").concat(e2, " ").concat(t2, ": ").concat(JSON.stringify(s ? Object(n.a)(_toConsumableArray(s.entries()).reduce(function (e3, _ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              t3 = _ref2[0],
              r3 = _ref2[1];
            return e3[t3] = r3, e3;
          }, {})) : {}), " -- ").concat(JSON.stringify(Object(n.a)(o2))))), _this2.method = e2, _this2.url = t2, _this2.statusCode = r2, _this2.body = o2, _this2.validationErrors = i, _this2.headers = s;
          return _this2;
        }
        return o;
      }(_wrapNativeSuper(Error));
    }, function (e, t, r) {
      function n(e2) {
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e3) {
          return typeof e3;
        } : function (e3) {
          return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
        })(e2);
      }
      function o(e2, t2) {
        return !t2 || "object" !== n(t2) && "function" != typeof t2 ? i(e2) : t2;
      }
      function i(e2) {
        if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e2;
      }
      function s(e2) {
        var t2 = "function" == typeof Map ? /* @__PURE__ */new Map() : void 0;
        return (s = function s(e3) {
          if (null === e3 || (r2 = e3, -1 === Function.toString.call(r2).indexOf("[native code]"))) return e3;
          var r2;
          if ("function" != typeof e3) throw new TypeError("Super expression must either be null or a function");
          if (void 0 !== t2) {
            if (t2.has(e3)) return t2.get(e3);
            t2.set(e3, n2);
          }
          function n2() {
            return a2(e3, arguments, g(this).constructor);
          }
          return n2.prototype = Object.create(e3.prototype, {
            constructor: {
              value: n2,
              enumerable: false,
              writable: true,
              configurable: true
            }
          }), u(n2, e3);
        })(e2);
      }
      function a2(e2, t2, r2) {
        return (a2 = l() ? Reflect.construct : function (e3, t3, r3) {
          var n2 = [null];
          n2.push.apply(n2, t3);
          var o2 = new (Function.bind.apply(e3, n2))();
          return r3 && u(o2, r3.prototype), o2;
        }).apply(null, arguments);
      }
      function l() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if ("function" == typeof Proxy) return true;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), true;
        } catch (e2) {
          return false;
        }
      }
      function u(e2, t2) {
        return (u = Object.setPrototypeOf || function (e3, t3) {
          return e3.__proto__ = t3, e3;
        })(e2, t2);
      }
      function g(e2) {
        return (g = Object.setPrototypeOf ? Object.getPrototypeOf : function (e3) {
          return e3.__proto__ || Object.getPrototypeOf(e3);
        })(e2);
      }
      var c = function (e2) {
        !function (e3, t3) {
          if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
          e3.prototype = Object.create(t3 && t3.prototype, {
            constructor: {
              value: e3,
              writable: true,
              configurable: true
            }
          }), t3 && u(e3, t3);
        }(s2, e2);
        var t2,
          r2,
          n2 = (t2 = s2, r2 = l(), function () {
            var e3,
              n3 = g(t2);
            if (r2) {
              var i2 = g(this).constructor;
              e3 = Reflect.construct(n3, arguments, i2);
            } else e3 = n3.apply(this, arguments);
            return o(this, e3);
          });
        function s2(e3) {
          var t3;
          return function (e4, t4) {
            if (!(e4 instanceof t4)) throw new TypeError("Cannot call a class as a function");
          }(this, s2), t3 = n2.call(this, "Format functions must be synchronous taking a two arguments: (info, opts)\nFound: ".concat(e3.toString().split("\n")[0], "\n")), Error.captureStackTrace(i(t3), s2), t3;
        }
        return s2;
      }(s(Error));
      e.exports = function (e2) {
        if (e2.length > 2) throw new c(e2);
        function t2() {
          var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.options = e3;
        }
        function r2(e3) {
          return new t2(e3);
        }
        return t2.prototype.transform = e2, r2.Format = t2, r2;
      };
    }, function (e, t, r) {
      (function (e2) {
        var n = Object.getOwnPropertyDescriptors || function (e3) {
            for (var t2 = Object.keys(e3), r2 = {}, n2 = 0; n2 < t2.length; n2++) r2[t2[n2]] = Object.getOwnPropertyDescriptor(e3, t2[n2]);
            return r2;
          },
          o = /%[sdj%]/g;
        t.format = function (e3) {
          if (!m(e3)) {
            for (var t2 = [], r2 = 0; r2 < arguments.length; r2++) t2.push(a2(arguments[r2]));
            return t2.join(" ");
          }
          r2 = 1;
          for (var n2 = arguments, i2 = n2.length, s2 = String(e3).replace(o, function (e4) {
              if ("%%" === e4) return "%";
              if (r2 >= i2) return e4;
              switch (e4) {
                case "%s":
                  return String(n2[r2++]);
                case "%d":
                  return Number(n2[r2++]);
                case "%j":
                  try {
                    return JSON.stringify(n2[r2++]);
                  } catch (e5) {
                    return "[Circular]";
                  }
                default:
                  return e4;
              }
            }), l2 = n2[r2]; r2 < i2; l2 = n2[++r2]) d(l2) || !_(l2) ? s2 += " " + l2 : s2 += " " + a2(l2);
          return s2;
        }, t.deprecate = function (r2, n2) {
          if (void 0 !== e2 && true === e2.noDeprecation) return r2;
          if (void 0 === e2) return function () {
            return t.deprecate(r2, n2).apply(this, arguments);
          };
          var o2 = false;
          return function () {
            if (!o2) {
              if (e2.throwDeprecation) throw new Error(n2);
              e2.traceDeprecation ? console.trace(n2) : console.error(n2), o2 = true;
            }
            return r2.apply(this, arguments);
          };
        };
        var i,
          s = {};
        function a2(e3, r2) {
          var n2 = {
            seen: [],
            stylize: u
          };
          return arguments.length >= 3 && (n2.depth = arguments[2]), arguments.length >= 4 && (n2.colors = arguments[3]), h(r2) ? n2.showHidden = r2 : r2 && t._extend(n2, r2), b(n2.showHidden) && (n2.showHidden = false), b(n2.depth) && (n2.depth = 2), b(n2.colors) && (n2.colors = false), b(n2.customInspect) && (n2.customInspect = true), n2.colors && (n2.stylize = l), g(n2, e3, n2.depth);
        }
        function l(e3, t2) {
          var r2 = a2.styles[t2];
          return r2 ? "\x1B[" + a2.colors[r2][0] + "m" + e3 + "\x1B[" + a2.colors[r2][1] + "m" : e3;
        }
        function u(e3, t2) {
          return e3;
        }
        function g(e3, r2, n2) {
          if (e3.customInspect && r2 && E(r2.inspect) && r2.inspect !== t.inspect && (!r2.constructor || r2.constructor.prototype !== r2)) {
            var o2 = r2.inspect(n2, e3);
            return m(o2) || (o2 = g(e3, o2, n2)), o2;
          }
          var i2 = function (e4, t2) {
            if (b(t2)) return e4.stylize("undefined", "undefined");
            if (m(t2)) {
              var r3 = "'" + JSON.stringify(t2).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
              return e4.stylize(r3, "string");
            }
            if (y(t2)) return e4.stylize("" + t2, "number");
            if (h(t2)) return e4.stylize("" + t2, "boolean");
            if (d(t2)) return e4.stylize("null", "null");
          }(e3, r2);
          if (i2) return i2;
          var s2 = Object.keys(r2),
            a3 = function (e4) {
              var t2 = {};
              return e4.forEach(function (e5, r3) {
                t2[e5] = true;
              }), t2;
            }(s2);
          if (e3.showHidden && (s2 = Object.getOwnPropertyNames(r2)), w(r2) && (s2.indexOf("message") >= 0 || s2.indexOf("description") >= 0)) return c(r2);
          if (0 === s2.length) {
            if (E(r2)) {
              var l2 = r2.name ? ": " + r2.name : "";
              return e3.stylize("[Function" + l2 + "]", "special");
            }
            if (v(r2)) return e3.stylize(RegExp.prototype.toString.call(r2), "regexp");
            if (S(r2)) return e3.stylize(Date.prototype.toString.call(r2), "date");
            if (w(r2)) return c(r2);
          }
          var u2,
            _2 = "",
            T2 = false,
            R2 = ["{", "}"];
          (p(r2) && (T2 = true, R2 = ["[", "]"]), E(r2)) && (_2 = " [Function" + (r2.name ? ": " + r2.name : "") + "]");
          return v(r2) && (_2 = " " + RegExp.prototype.toString.call(r2)), S(r2) && (_2 = " " + Date.prototype.toUTCString.call(r2)), w(r2) && (_2 = " " + c(r2)), 0 !== s2.length || T2 && 0 != r2.length ? n2 < 0 ? v(r2) ? e3.stylize(RegExp.prototype.toString.call(r2), "regexp") : e3.stylize("[Object]", "special") : (e3.seen.push(r2), u2 = T2 ? function (e4, t2, r3, n3, o3) {
            for (var i3 = [], s3 = 0, a4 = t2.length; s3 < a4; ++s3) C(t2, String(s3)) ? i3.push(f(e4, t2, r3, n3, String(s3), true)) : i3.push("");
            return o3.forEach(function (o4) {
              o4.match(/^\d+$/) || i3.push(f(e4, t2, r3, n3, o4, true));
            }), i3;
          }(e3, r2, n2, a3, s2) : s2.map(function (t2) {
            return f(e3, r2, n2, a3, t2, T2);
          }), e3.seen.pop(), function (e4, t2, r3) {
            if (e4.reduce(function (e5, t3) {
              return t3.indexOf("\n") >= 0 && 0, e5 + t3.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0) > 60) return r3[0] + ("" === t2 ? "" : t2 + "\n ") + " " + e4.join(",\n  ") + " " + r3[1];
            return r3[0] + t2 + " " + e4.join(", ") + " " + r3[1];
          }(u2, _2, R2)) : R2[0] + _2 + R2[1];
        }
        function c(e3) {
          return "[" + Error.prototype.toString.call(e3) + "]";
        }
        function f(e3, t2, r2, n2, o2, i2) {
          var s2, a3, l2;
          if ((l2 = Object.getOwnPropertyDescriptor(t2, o2) || {
            value: t2[o2]
          }).get ? a3 = l2.set ? e3.stylize("[Getter/Setter]", "special") : e3.stylize("[Getter]", "special") : l2.set && (a3 = e3.stylize("[Setter]", "special")), C(n2, o2) || (s2 = "[" + o2 + "]"), a3 || (e3.seen.indexOf(l2.value) < 0 ? (a3 = d(r2) ? g(e3, l2.value, null) : g(e3, l2.value, r2 - 1)).indexOf("\n") > -1 && (a3 = i2 ? a3.split("\n").map(function (e4) {
            return "  " + e4;
          }).join("\n").substr(2) : "\n" + a3.split("\n").map(function (e4) {
            return "   " + e4;
          }).join("\n")) : a3 = e3.stylize("[Circular]", "special")), b(s2)) {
            if (i2 && o2.match(/^\d+$/)) return a3;
            (s2 = JSON.stringify("" + o2)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s2 = s2.substr(1, s2.length - 2), s2 = e3.stylize(s2, "name")) : (s2 = s2.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s2 = e3.stylize(s2, "string"));
          }
          return s2 + ": " + a3;
        }
        function p(e3) {
          return Array.isArray(e3);
        }
        function h(e3) {
          return "boolean" == typeof e3;
        }
        function d(e3) {
          return null === e3;
        }
        function y(e3) {
          return "number" == typeof e3;
        }
        function m(e3) {
          return "string" == typeof e3;
        }
        function b(e3) {
          return void 0 === e3;
        }
        function v(e3) {
          return _(e3) && "[object RegExp]" === T(e3);
        }
        function _(e3) {
          return "object" == typeof e3 && null !== e3;
        }
        function S(e3) {
          return _(e3) && "[object Date]" === T(e3);
        }
        function w(e3) {
          return _(e3) && ("[object Error]" === T(e3) || e3 instanceof Error);
        }
        function E(e3) {
          return "function" == typeof e3;
        }
        function T(e3) {
          return Object.prototype.toString.call(e3);
        }
        function R(e3) {
          return e3 < 10 ? "0" + e3.toString(10) : e3.toString(10);
        }
        t.debuglog = function (r2) {
          if (b(i) && (i = e2.env.NODE_DEBUG || ""), r2 = r2.toUpperCase(), !s[r2]) if (new RegExp("\\b" + r2 + "\\b", "i").test(i)) {
            var n2 = e2.pid;
            s[r2] = function () {
              var e3 = t.format.apply(t, arguments);
              console.error("%s %d: %s", r2, n2, e3);
            };
          } else s[r2] = function () {};
          return s[r2];
        }, t.inspect = a2, a2.colors = {
          bold: [1, 22],
          italic: [3, 23],
          underline: [4, 24],
          inverse: [7, 27],
          white: [37, 39],
          grey: [90, 39],
          black: [30, 39],
          blue: [34, 39],
          cyan: [36, 39],
          green: [32, 39],
          magenta: [35, 39],
          red: [31, 39],
          yellow: [33, 39]
        }, a2.styles = {
          special: "cyan",
          number: "yellow",
          boolean: "yellow",
          undefined: "grey",
          null: "bold",
          string: "green",
          date: "magenta",
          regexp: "red"
        }, t.isArray = p, t.isBoolean = h, t.isNull = d, t.isNullOrUndefined = function (e3) {
          return null == e3;
        }, t.isNumber = y, t.isString = m, t.isSymbol = function (e3) {
          return "symbol" == typeof e3;
        }, t.isUndefined = b, t.isRegExp = v, t.isObject = _, t.isDate = S, t.isError = w, t.isFunction = E, t.isPrimitive = function (e3) {
          return null === e3 || "boolean" == typeof e3 || "number" == typeof e3 || "string" == typeof e3 || "symbol" == typeof e3 || void 0 === e3;
        }, t.isBuffer = r(107);
        var A = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        function O() {
          var e3 = new Date(),
            t2 = [R(e3.getHours()), R(e3.getMinutes()), R(e3.getSeconds())].join(":");
          return [e3.getDate(), A[e3.getMonth()], t2].join(" ");
        }
        function C(e3, t2) {
          return Object.prototype.hasOwnProperty.call(e3, t2);
        }
        t.log = function () {
          console.log("%s - %s", O(), t.format.apply(t, arguments));
        }, t.inherits = r(108), t._extend = function (e3, t2) {
          if (!t2 || !_(t2)) return e3;
          for (var r2 = Object.keys(t2), n2 = r2.length; n2--;) e3[r2[n2]] = t2[r2[n2]];
          return e3;
        };
        var I = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
        function j(e3, t2) {
          if (!e3) {
            var r2 = new Error("Promise was rejected with a falsy value");
            r2.reason = e3, e3 = r2;
          }
          return t2(e3);
        }
        t.promisify = function (e3) {
          if ("function" != typeof e3) throw new TypeError('The "original" argument must be of type Function');
          if (I && e3[I]) {
            var t2;
            if ("function" != typeof (t2 = e3[I])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            return Object.defineProperty(t2, I, {
              value: t2,
              enumerable: false,
              writable: false,
              configurable: true
            }), t2;
          }
          function t2() {
            for (var t3, r2, n2 = new Promise(function (e4, n3) {
                t3 = e4, r2 = n3;
              }), o2 = [], i2 = 0; i2 < arguments.length; i2++) o2.push(arguments[i2]);
            o2.push(function (e4, n3) {
              e4 ? r2(e4) : t3(n3);
            });
            try {
              e3.apply(this, o2);
            } catch (e4) {
              r2(e4);
            }
            return n2;
          }
          return Object.setPrototypeOf(t2, Object.getPrototypeOf(e3)), I && Object.defineProperty(t2, I, {
            value: t2,
            enumerable: false,
            writable: false,
            configurable: true
          }), Object.defineProperties(t2, n(e3));
        }, t.promisify.custom = I, t.callbackify = function (t2) {
          if ("function" != typeof t2) throw new TypeError('The "original" argument must be of type Function');
          function r2() {
            for (var r3 = [], n2 = 0; n2 < arguments.length; n2++) r3.push(arguments[n2]);
            var o2 = r3.pop();
            if ("function" != typeof o2) throw new TypeError("The last argument must be of type Function");
            var i2 = this,
              s2 = function s2() {
                return o2.apply(i2, arguments);
              };
            t2.apply(this, r3).then(function (t3) {
              e2.nextTick(s2, null, t3);
            }, function (t3) {
              e2.nextTick(j, t3, s2);
            });
          }
          return Object.setPrototypeOf(r2, Object.getPrototypeOf(t2)), Object.defineProperties(r2, n(t2)), r2;
        };
      }).call(this, r(2));
    }, function (e, t, r) {
      e.exports = function (e2, t2) {
        t2 || (t2 = {}), "function" == typeof t2 && (t2 = {
          cmp: t2
        });
        var r2,
          n = "boolean" == typeof t2.cycles && t2.cycles,
          o = t2.cmp && (r2 = t2.cmp, function (e3) {
            return function (t3, n2) {
              var o2 = {
                  key: t3,
                  value: e3[t3]
                },
                i2 = {
                  key: n2,
                  value: e3[n2]
                };
              return r2(o2, i2);
            };
          }),
          i = [];
        return function e3(t3) {
          if (t3 && t3.toJSON && "function" == typeof t3.toJSON && (t3 = t3.toJSON()), void 0 !== t3) {
            if ("number" == typeof t3) return isFinite(t3) ? "" + t3 : "null";
            if ("object" != typeof t3) return JSON.stringify(t3);
            var r3, s;
            if (Array.isArray(t3)) {
              for (s = "[", r3 = 0; r3 < t3.length; r3++) r3 && (s += ","), s += e3(t3[r3]) || "null";
              return s + "]";
            }
            if (null === t3) return "null";
            if (-1 !== i.indexOf(t3)) {
              if (n) return JSON.stringify("__cycle__");
              throw new TypeError("Converting circular structure to JSON");
            }
            var a2 = i.push(t3) - 1,
              l = Object.keys(t3).sort(o && o(t3));
            for (s = "", r3 = 0; r3 < l.length; r3++) {
              var u = l[r3],
                g = e3(t3[u]);
              g && (s && (s += ","), s += JSON.stringify(u) + ":" + g);
            }
            return i.splice(a2, 1), "{" + s + "}";
          }
        }(e2);
      };
    }, function (e, t, r) {
      (function (e2) {
        var n = void 0 !== e2 && e2 || "undefined" != typeof self && self || window,
          o = Function.prototype.apply;
        function i(e3, t2) {
          this._id = e3, this._clearFn = t2;
        }
        t.setTimeout = function () {
          return new i(o.call(setTimeout, n, arguments), clearTimeout);
        }, t.setInterval = function () {
          return new i(o.call(setInterval, n, arguments), clearInterval);
        }, t.clearTimeout = t.clearInterval = function (e3) {
          e3 && e3.close();
        }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
          this._clearFn.call(n, this._id);
        }, t.enroll = function (e3, t2) {
          clearTimeout(e3._idleTimeoutId), e3._idleTimeout = t2;
        }, t.unenroll = function (e3) {
          clearTimeout(e3._idleTimeoutId), e3._idleTimeout = -1;
        }, t._unrefActive = t.active = function (e3) {
          clearTimeout(e3._idleTimeoutId);
          var t2 = e3._idleTimeout;
          t2 >= 0 && (e3._idleTimeoutId = setTimeout(function () {
            e3._onTimeout && e3._onTimeout();
          }, t2));
        }, r(141), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e2 && e2.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e2 && e2.clearImmediate || this && this.clearImmediate;
      }).call(this, r(6));
    }, function (e, t, r) {
      (function (t2) {
        void 0 === t2 || !t2.version || 0 === t2.version.indexOf("v0.") || 0 === t2.version.indexOf("v1.") && 0 !== t2.version.indexOf("v1.8.") ? e.exports = {
          nextTick: function nextTick(e2, r2, n, o) {
            if ("function" != typeof e2) throw new TypeError('"callback" argument must be a function');
            var i,
              s,
              a2 = arguments.length;
            switch (a2) {
              case 0:
              case 1:
                return t2.nextTick(e2);
              case 2:
                return t2.nextTick(function () {
                  e2.call(null, r2);
                });
              case 3:
                return t2.nextTick(function () {
                  e2.call(null, r2, n);
                });
              case 4:
                return t2.nextTick(function () {
                  e2.call(null, r2, n, o);
                });
              default:
                for (i = new Array(a2 - 1), s = 0; s < i.length;) i[s++] = arguments[s];
                return t2.nextTick(function () {
                  e2.apply(null, i);
                });
            }
          }
        } : e.exports = t2;
      }).call(this, r(2));
    }, function (e, t, r) {
      (function (e2) {
        function r2(e3) {
          return Object.prototype.toString.call(e3);
        }
        t.isArray = function (e3) {
          return Array.isArray ? Array.isArray(e3) : "[object Array]" === r2(e3);
        }, t.isBoolean = function (e3) {
          return "boolean" == typeof e3;
        }, t.isNull = function (e3) {
          return null === e3;
        }, t.isNullOrUndefined = function (e3) {
          return null == e3;
        }, t.isNumber = function (e3) {
          return "number" == typeof e3;
        }, t.isString = function (e3) {
          return "string" == typeof e3;
        }, t.isSymbol = function (e3) {
          return "symbol" == typeof e3;
        }, t.isUndefined = function (e3) {
          return void 0 === e3;
        }, t.isRegExp = function (e3) {
          return "[object RegExp]" === r2(e3);
        }, t.isObject = function (e3) {
          return "object" == typeof e3 && null !== e3;
        }, t.isDate = function (e3) {
          return "[object Date]" === r2(e3);
        }, t.isError = function (e3) {
          return "[object Error]" === r2(e3) || e3 instanceof Error;
        }, t.isFunction = function (e3) {
          return "function" == typeof e3;
        }, t.isPrimitive = function (e3) {
          return null === e3 || "boolean" == typeof e3 || "number" == typeof e3 || "string" == typeof e3 || "symbol" == typeof e3 || void 0 === e3;
        }, t.isBuffer = e2.isBuffer;
      }).call(this, r(5).Buffer);
    }, function (e, t) {
      t.endianness = function () {
        return "LE";
      }, t.hostname = function () {
        return "undefined" != typeof location ? location.hostname : "";
      }, t.loadavg = function () {
        return [];
      }, t.uptime = function () {
        return 0;
      }, t.freemem = function () {
        return Number.MAX_VALUE;
      }, t.totalmem = function () {
        return Number.MAX_VALUE;
      }, t.cpus = function () {
        return [];
      }, t.type = function () {
        return "Browser";
      }, t.release = function () {
        return "undefined" != typeof navigator ? navigator.appVersion : "";
      }, t.networkInterfaces = t.getNetworkInterfaces = function () {
        return {};
      }, t.arch = function () {
        return "javascript";
      }, t.platform = function () {
        return "browser";
      }, t.tmpdir = t.tmpDir = function () {
        return "/tmp";
      }, t.EOL = "\n", t.homedir = function () {
        return "/";
      };
    }, function (e, t, r) {
      var n = r(58),
        o = r(61).warn,
        i = t;
      i.version = r(138).version, i.transports = r(139), i.config = r(50), i.addColors = n.levels, i.format = n.format, i.createLogger = r(88), i.ExceptionHandler = r(89), i.RejectionHandler = r(93), i.Container = r(210), i.Transport = r(20), i.loggers = new i.Container();
      var s = i.createLogger();
      Object.keys(i.config.npm.levels).concat(["log", "query", "stream", "add", "remove", "clear", "profile", "startTimer", "handleExceptions", "unhandleExceptions", "handleRejections", "unhandleRejections", "configure", "child"]).forEach(function (e2) {
        return i[e2] = function () {
          return s[e2].apply(s, arguments);
        };
      }), Object.defineProperty(i, "level", {
        get: function get() {
          return s.level;
        },
        set: function set(e2) {
          s.level = e2;
        }
      }), Object.defineProperty(i, "exceptions", {
        get: function get() {
          return s.exceptions;
        }
      }), ["exitOnError"].forEach(function (e2) {
        Object.defineProperty(i, e2, {
          get: function get() {
            return s[e2];
          },
          set: function set(t2) {
            s[e2] = t2;
          }
        });
      }), Object.defineProperty(i, "default", {
        get: function get() {
          return {
            exceptionHandlers: s.exceptionHandlers,
            rejectionHandlers: s.rejectionHandlers,
            transports: s.transports
          };
        }
      }), o.deprecated(i, "setLevels"), o.forFunctions(i, "useFormat", ["cli"]), o.forProperties(i, "useFormat", ["padLevels", "stripColors"]), o.forFunctions(i, "deprecated", ["addRewriter", "addFilter", "clone", "extend"]), o.forProperties(i, "deprecated", ["emitErrs", "levelLength"]), o.moved(i, "createLogger", "Logger");
    }, function (e, t, r) {
      var n = r(13),
        o = r(142),
        i = r(3).LEVEL,
        s = e.exports = function () {
          var e2 = this,
            t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          o.call(this, {
            objectMode: true,
            highWaterMark: t2.highWaterMark
          }), this.format = t2.format, this.level = t2.level, this.handleExceptions = t2.handleExceptions, this.handleRejections = t2.handleRejections, this.silent = t2.silent, t2.log && (this.log = t2.log), t2.logv && (this.logv = t2.logv), t2.close && (this.close = t2.close), this.once("pipe", function (t3) {
            e2.levels = t3.levels, e2.parent = t3;
          }), this.once("unpipe", function (t3) {
            t3 === e2.parent && (e2.parent = null, e2.close && e2.close());
          });
        };
      n.inherits(s, o), s.prototype._write = function (e2, t2, r2) {
        if (this.silent || true === e2.exception && !this.handleExceptions) return r2(null);
        var n2 = this.level || this.parent && this.parent.level;
        if (!n2 || this.levels[n2] >= this.levels[e2[i]]) {
          if (e2 && !this.format) return this.log(e2, r2);
          var o2 = void 0,
            s2 = void 0;
          try {
            s2 = this.format.transform(Object.assign({}, e2), this.format.options);
          } catch (e3) {
            o2 = e3;
          }
          if (o2 || !s2) {
            if (r2(), o2) throw o2;
            return;
          }
          return this.log(s2, r2);
        }
        return r2(null);
      }, s.prototype._writev = function (e2, t2) {
        if (this.logv) {
          var r2 = e2.filter(this._accept, this);
          return r2.length ? this.logv(r2, t2) : t2(null);
        }
        for (var n2 = 0; n2 < e2.length; n2++) if (this._accept(e2[n2])) if (!e2[n2].chunk || this.format) {
          var o2 = void 0,
            i2 = void 0;
          try {
            i2 = this.format.transform(Object.assign({}, e2[n2].chunk), this.format.options);
          } catch (e3) {
            o2 = e3;
          }
          if (o2 || !i2) {
            if (e2[n2].callback(), o2) throw t2(null), o2;
          } else this.log(i2, e2[n2].callback);
        } else this.log(e2[n2].chunk, e2[n2].callback);
        return t2(null);
      }, s.prototype._accept = function (e2) {
        var t2 = e2.chunk;
        if (this.silent) return false;
        var r2 = this.level || this.parent && this.parent.level;
        return !(true !== t2.exception && r2 && !(this.levels[r2] >= this.levels[t2[i]]) || !this.handleExceptions && true === t2.exception);
      }, s.prototype._nop = function () {}, e.exports.LegacyTransportStream = r(148);
    }, function (e, t, r) {
      var n,
        o = "object" == typeof Reflect ? Reflect : null,
        i = o && "function" == typeof o.apply ? o.apply : function (e2, t2, r2) {
          return Function.prototype.apply.call(e2, t2, r2);
        };
      n = o && "function" == typeof o.ownKeys ? o.ownKeys : Object.getOwnPropertySymbols ? function (e2) {
        return Object.getOwnPropertyNames(e2).concat(Object.getOwnPropertySymbols(e2));
      } : function (e2) {
        return Object.getOwnPropertyNames(e2);
      };
      var s = Number.isNaN || function (e2) {
        return e2 != e2;
      };
      function a2() {
        a2.init.call(this);
      }
      e.exports = a2, a2.EventEmitter = a2, a2.prototype._events = void 0, a2.prototype._eventsCount = 0, a2.prototype._maxListeners = void 0;
      var l = 10;
      function u(e2) {
        return void 0 === e2._maxListeners ? a2.defaultMaxListeners : e2._maxListeners;
      }
      function g(e2, t2, r2, n2) {
        var o2, i2, s2, a3;
        if ("function" != typeof r2) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r2);
        if (void 0 === (i2 = e2._events) ? (i2 = e2._events = /* @__PURE__ */Object.create(null), e2._eventsCount = 0) : (void 0 !== i2.newListener && (e2.emit("newListener", t2, r2.listener ? r2.listener : r2), i2 = e2._events), s2 = i2[t2]), void 0 === s2) s2 = i2[t2] = r2, ++e2._eventsCount;else if ("function" == typeof s2 ? s2 = i2[t2] = n2 ? [r2, s2] : [s2, r2] : n2 ? s2.unshift(r2) : s2.push(r2), (o2 = u(e2)) > 0 && s2.length > o2 && !s2.warned) {
          s2.warned = true;
          var l2 = new Error("Possible EventEmitter memory leak detected. " + s2.length + " " + String(t2) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          l2.name = "MaxListenersExceededWarning", l2.emitter = e2, l2.type = t2, l2.count = s2.length, a3 = l2, console && console.warn && console.warn(a3);
        }
        return e2;
      }
      function c() {
        for (var e2 = [], t2 = 0; t2 < arguments.length; t2++) e2.push(arguments[t2]);
        this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = true, i(this.listener, this.target, e2));
      }
      function f(e2, t2, r2) {
        var n2 = {
            fired: false,
            wrapFn: void 0,
            target: e2,
            type: t2,
            listener: r2
          },
          o2 = c.bind(n2);
        return o2.listener = r2, n2.wrapFn = o2, o2;
      }
      function p(e2, t2, r2) {
        var n2 = e2._events;
        if (void 0 === n2) return [];
        var o2 = n2[t2];
        return void 0 === o2 ? [] : "function" == typeof o2 ? r2 ? [o2.listener || o2] : [o2] : r2 ? function (e3) {
          for (var t3 = new Array(e3.length), r3 = 0; r3 < t3.length; ++r3) t3[r3] = e3[r3].listener || e3[r3];
          return t3;
        }(o2) : d(o2, o2.length);
      }
      function h(e2) {
        var t2 = this._events;
        if (void 0 !== t2) {
          var r2 = t2[e2];
          if ("function" == typeof r2) return 1;
          if (void 0 !== r2) return r2.length;
        }
        return 0;
      }
      function d(e2, t2) {
        for (var r2 = new Array(t2), n2 = 0; n2 < t2; ++n2) r2[n2] = e2[n2];
        return r2;
      }
      Object.defineProperty(a2, "defaultMaxListeners", {
        enumerable: true,
        get: function get() {
          return l;
        },
        set: function set(e2) {
          if ("number" != typeof e2 || e2 < 0 || s(e2)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e2 + ".");
          l = e2;
        }
      }), a2.init = function () {
        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      }, a2.prototype.setMaxListeners = function (e2) {
        if ("number" != typeof e2 || e2 < 0 || s(e2)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e2 + ".");
        return this._maxListeners = e2, this;
      }, a2.prototype.getMaxListeners = function () {
        return u(this);
      }, a2.prototype.emit = function (e2) {
        for (var t2 = [], r2 = 1; r2 < arguments.length; r2++) t2.push(arguments[r2]);
        var n2 = "error" === e2,
          o2 = this._events;
        if (void 0 !== o2) n2 = n2 && void 0 === o2.error;else if (!n2) return false;
        if (n2) {
          var s2;
          if (t2.length > 0 && (s2 = t2[0]), s2 instanceof Error) throw s2;
          var a3 = new Error("Unhandled error." + (s2 ? " (" + s2.message + ")" : ""));
          throw a3.context = s2, a3;
        }
        var l2 = o2[e2];
        if (void 0 === l2) return false;
        if ("function" == typeof l2) i(l2, this, t2);else {
          var u2 = l2.length,
            g2 = d(l2, u2);
          for (r2 = 0; r2 < u2; ++r2) i(g2[r2], this, t2);
        }
        return true;
      }, a2.prototype.addListener = function (e2, t2) {
        return g(this, e2, t2, false);
      }, a2.prototype.on = a2.prototype.addListener, a2.prototype.prependListener = function (e2, t2) {
        return g(this, e2, t2, true);
      }, a2.prototype.once = function (e2, t2) {
        if ("function" != typeof t2) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t2);
        return this.on(e2, f(this, e2, t2)), this;
      }, a2.prototype.prependOnceListener = function (e2, t2) {
        if ("function" != typeof t2) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t2);
        return this.prependListener(e2, f(this, e2, t2)), this;
      }, a2.prototype.removeListener = function (e2, t2) {
        var r2, n2, o2, i2, s2;
        if ("function" != typeof t2) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t2);
        if (void 0 === (n2 = this._events)) return this;
        if (void 0 === (r2 = n2[e2])) return this;
        if (r2 === t2 || r2.listener === t2) 0 == --this._eventsCount ? this._events = /* @__PURE__ */Object.create(null) : (delete n2[e2], n2.removeListener && this.emit("removeListener", e2, r2.listener || t2));else if ("function" != typeof r2) {
          for (o2 = -1, i2 = r2.length - 1; i2 >= 0; i2--) if (r2[i2] === t2 || r2[i2].listener === t2) {
            s2 = r2[i2].listener, o2 = i2;
            break;
          }
          if (o2 < 0) return this;
          0 === o2 ? r2.shift() : function (e3, t3) {
            for (; t3 + 1 < e3.length; t3++) e3[t3] = e3[t3 + 1];
            e3.pop();
          }(r2, o2), 1 === r2.length && (n2[e2] = r2[0]), void 0 !== n2.removeListener && this.emit("removeListener", e2, s2 || t2);
        }
        return this;
      }, a2.prototype.off = a2.prototype.removeListener, a2.prototype.removeAllListeners = function (e2) {
        var t2, r2, n2;
        if (void 0 === (r2 = this._events)) return this;
        if (void 0 === r2.removeListener) return 0 === arguments.length ? (this._events = /* @__PURE__ */Object.create(null), this._eventsCount = 0) : void 0 !== r2[e2] && (0 == --this._eventsCount ? this._events = /* @__PURE__ */Object.create(null) : delete r2[e2]), this;
        if (0 === arguments.length) {
          var o2,
            i2 = Object.keys(r2);
          for (n2 = 0; n2 < i2.length; ++n2) "removeListener" !== (o2 = i2[n2]) && this.removeAllListeners(o2);
          return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */Object.create(null), this._eventsCount = 0, this;
        }
        if ("function" == typeof (t2 = r2[e2])) this.removeListener(e2, t2);else if (void 0 !== t2) for (n2 = t2.length - 1; n2 >= 0; n2--) this.removeListener(e2, t2[n2]);
        return this;
      }, a2.prototype.listeners = function (e2) {
        return p(this, e2, true);
      }, a2.prototype.rawListeners = function (e2) {
        return p(this, e2, false);
      }, a2.listenerCount = function (e2, t2) {
        return "function" == typeof e2.listenerCount ? e2.listenerCount(t2) : h.call(e2, t2);
      }, a2.prototype.listenerCount = h, a2.prototype.eventNames = function () {
        return this._eventsCount > 0 ? n(this._events) : [];
      };
    }, function (e, t, r) {
      var n = r(147).Buffer,
        o = n.isEncoding || function (e2) {
          switch ((e2 = "" + e2) && e2.toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
              return true;
            default:
              return false;
          }
        };
      function i(e2) {
        var t2;
        switch (this.encoding = function (e3) {
          var t3 = function (e4) {
            if (!e4) return "utf8";
            for (var t4;;) switch (e4) {
              case "utf8":
              case "utf-8":
                return "utf8";
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";
              case "latin1":
              case "binary":
                return "latin1";
              case "base64":
              case "ascii":
              case "hex":
                return e4;
              default:
                if (t4) return;
                e4 = ("" + e4).toLowerCase(), t4 = true;
            }
          }(e3);
          if ("string" != typeof t3 && (n.isEncoding === o || !o(e3))) throw new Error("Unknown encoding: " + e3);
          return t3 || e3;
        }(e2), this.encoding) {
          case "utf16le":
            this.text = l, this.end = u, t2 = 4;
            break;
          case "utf8":
            this.fillLast = a2, t2 = 4;
            break;
          case "base64":
            this.text = g, this.end = c, t2 = 3;
            break;
          default:
            return this.write = f, void (this.end = p);
        }
        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t2);
      }
      function s(e2) {
        return e2 <= 127 ? 0 : e2 >> 5 == 6 ? 2 : e2 >> 4 == 14 ? 3 : e2 >> 3 == 30 ? 4 : e2 >> 6 == 2 ? -1 : -2;
      }
      function a2(e2) {
        var t2 = this.lastTotal - this.lastNeed,
          r2 = function (e3, t3, r3) {
            if (128 != (192 & t3[0])) return e3.lastNeed = 0, "\uFFFD";
            if (e3.lastNeed > 1 && t3.length > 1) {
              if (128 != (192 & t3[1])) return e3.lastNeed = 1, "\uFFFD";
              if (e3.lastNeed > 2 && t3.length > 2 && 128 != (192 & t3[2])) return e3.lastNeed = 2, "\uFFFD";
            }
          }(this, e2);
        return void 0 !== r2 ? r2 : this.lastNeed <= e2.length ? (e2.copy(this.lastChar, t2, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e2.copy(this.lastChar, t2, 0, e2.length), void (this.lastNeed -= e2.length));
      }
      function l(e2, t2) {
        if ((e2.length - t2) % 2 == 0) {
          var r2 = e2.toString("utf16le", t2);
          if (r2) {
            var n2 = r2.charCodeAt(r2.length - 1);
            if (n2 >= 55296 && n2 <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e2[e2.length - 2], this.lastChar[1] = e2[e2.length - 1], r2.slice(0, -1);
          }
          return r2;
        }
        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e2[e2.length - 1], e2.toString("utf16le", t2, e2.length - 1);
      }
      function u(e2) {
        var t2 = e2 && e2.length ? this.write(e2) : "";
        if (this.lastNeed) {
          var r2 = this.lastTotal - this.lastNeed;
          return t2 + this.lastChar.toString("utf16le", 0, r2);
        }
        return t2;
      }
      function g(e2, t2) {
        var r2 = (e2.length - t2) % 3;
        return 0 === r2 ? e2.toString("base64", t2) : (this.lastNeed = 3 - r2, this.lastTotal = 3, 1 === r2 ? this.lastChar[0] = e2[e2.length - 1] : (this.lastChar[0] = e2[e2.length - 2], this.lastChar[1] = e2[e2.length - 1]), e2.toString("base64", t2, e2.length - r2));
      }
      function c(e2) {
        var t2 = e2 && e2.length ? this.write(e2) : "";
        return this.lastNeed ? t2 + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t2;
      }
      function f(e2) {
        return e2.toString(this.encoding);
      }
      function p(e2) {
        return e2 && e2.length ? this.write(e2) : "";
      }
      t.StringDecoder = i, i.prototype.write = function (e2) {
        if (0 === e2.length) return "";
        var t2, r2;
        if (this.lastNeed) {
          if (void 0 === (t2 = this.fillLast(e2))) return "";
          r2 = this.lastNeed, this.lastNeed = 0;
        } else r2 = 0;
        return r2 < e2.length ? t2 ? t2 + this.text(e2, r2) : this.text(e2, r2) : t2 || "";
      }, i.prototype.end = function (e2) {
        var t2 = e2 && e2.length ? this.write(e2) : "";
        return this.lastNeed ? t2 + "\uFFFD" : t2;
      }, i.prototype.text = function (e2, t2) {
        var r2 = function (e3, t3, r3) {
          var n3 = t3.length - 1;
          if (n3 < r3) return 0;
          var o2 = s(t3[n3]);
          if (o2 >= 0) return o2 > 0 && (e3.lastNeed = o2 - 1), o2;
          if (--n3 < r3 || -2 === o2) return 0;
          if ((o2 = s(t3[n3])) >= 0) return o2 > 0 && (e3.lastNeed = o2 - 2), o2;
          if (--n3 < r3 || -2 === o2) return 0;
          if ((o2 = s(t3[n3])) >= 0) return o2 > 0 && (2 === o2 ? o2 = 0 : e3.lastNeed = o2 - 3), o2;
          return 0;
        }(this, e2, t2);
        if (!this.lastNeed) return e2.toString("utf8", t2);
        this.lastTotal = r2;
        var n2 = e2.length - (r2 - this.lastNeed);
        return e2.copy(this.lastChar, 0, n2), e2.toString("utf8", t2, n2);
      }, i.prototype.fillLast = function (e2) {
        if (this.lastNeed <= e2.length) return e2.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        e2.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e2.length), this.lastNeed -= e2.length;
      };
    }, function (e, t, r) {
      var n = r(16),
        o = Object.keys || function (e2) {
          var t2 = [];
          for (var r2 in e2) t2.push(r2);
          return t2;
        };
      e.exports = c;
      var i = r(17);
      i.inherits = r(7);
      var s = r(69),
        a2 = r(48);
      i.inherits(c, s);
      for (var l = o(a2.prototype), u = 0; u < l.length; u++) {
        var g = l[u];
        c.prototype[g] || (c.prototype[g] = a2.prototype[g]);
      }
      function c(e2) {
        if (!(this instanceof c)) return new c(e2);
        s.call(this, e2), a2.call(this, e2), e2 && false === e2.readable && (this.readable = false), e2 && false === e2.writable && (this.writable = false), this.allowHalfOpen = true, e2 && false === e2.allowHalfOpen && (this.allowHalfOpen = false), this.once("end", f);
      }
      function f() {
        this.allowHalfOpen || this._writableState.ended || n.nextTick(p, this);
      }
      function p(e2) {
        e2.end();
      }
      Object.defineProperty(c.prototype, "writableHighWaterMark", {
        enumerable: false,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), Object.defineProperty(c.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(e2) {
          void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e2, this._writableState.destroyed = e2);
        }
      }), c.prototype._destroy = function (e2, t2) {
        this.push(null), this.end(), n.nextTick(t2, e2);
      };
    }, function (e, t, r) {
      (function (t2) {
        function r2(e2) {
          var t3 = 0;
          return function () {
            return t3 < e2.length ? {
              done: false,
              value: e2[t3++]
            } : {
              done: true
            };
          };
        }
        var n = "function" == typeof Object.defineProperties ? Object.defineProperty : function (e2, t3, r3) {
          e2 != Array.prototype && e2 != Object.prototype && (e2[t3] = r3.value);
        };
        var o = function (e2) {
          e2 = ["object" == typeof window && window, "object" == typeof self && self, "object" == typeof t2 && t2, e2];
          for (var r3 = 0; r3 < e2.length; ++r3) {
            var n2 = e2[r3];
            if (n2 && n2.Math == Math) return n2;
          }
          throw Error("Cannot find global object");
        }(this);
        function i(e2, t3) {
          if (t3) {
            var r3 = o;
            e2 = e2.split(".");
            for (var i2 = 0; i2 < e2.length - 1; i2++) {
              var s2 = e2[i2];
              s2 in r3 || (r3[s2] = {}), r3 = r3[s2];
            }
            (t3 = t3(i2 = r3[e2 = e2[e2.length - 1]])) != i2 && null != t3 && n(r3, e2, {
              configurable: true,
              writable: true,
              value: t3
            });
          }
        }
        function s(e2) {
          var t3 = "undefined" != typeof Symbol && Symbol.iterator && e2[Symbol.iterator];
          return t3 ? t3.call(e2) : {
            next: r2(e2)
          };
        }
        i("Object.is", function (e2) {
          return e2 || function (e3, t3) {
            return e3 === t3 ? 0 !== e3 || 1 / e3 == 1 / t3 : e3 != e3 && t3 != t3;
          };
        }), i("Array.prototype.includes", function (e2) {
          return e2 || function (e3, t3) {
            var r3 = this;
            r3 instanceof String && (r3 = String(r3));
            var n2 = r3.length;
            for (0 > (t3 = t3 || 0) && (t3 = Math.max(t3 + n2, 0)); t3 < n2; t3++) {
              var o2 = r3[t3];
              if (o2 === e3 || Object.is(o2, e3)) return true;
            }
            return false;
          };
        }), i("Promise", function (e2) {
          function t3(e3) {
            this.b = 0, this.c = void 0, this.a = [];
            var t4 = this.f();
            try {
              e3(t4.resolve, t4.reject);
            } catch (e4) {
              t4.reject(e4);
            }
          }
          function r3() {
            this.a = null;
          }
          function n2(e3) {
            return e3 instanceof t3 ? e3 : new t3(function (t4) {
              t4(e3);
            });
          }
          if (e2) return e2;
          r3.prototype.b = function (e3) {
            if (null == this.a) {
              this.a = [];
              var t4 = this;
              this.c(function () {
                t4.g();
              });
            }
            this.a.push(e3);
          };
          var i2 = o.setTimeout;
          r3.prototype.c = function (e3) {
            i2(e3, 0);
          }, r3.prototype.g = function () {
            for (; this.a && this.a.length;) {
              var e3 = this.a;
              this.a = [];
              for (var t4 = 0; t4 < e3.length; ++t4) {
                var r4 = e3[t4];
                e3[t4] = null;
                try {
                  r4();
                } catch (e4) {
                  this.f(e4);
                }
              }
            }
            this.a = null;
          }, r3.prototype.f = function (e3) {
            this.c(function () {
              throw e3;
            });
          }, t3.prototype.f = function () {
            function e3(e4) {
              return function (n3) {
                r4 || (r4 = true, e4.call(t4, n3));
              };
            }
            var t4 = this,
              r4 = false;
            return {
              resolve: e3(this.m),
              reject: e3(this.g)
            };
          }, t3.prototype.m = function (e3) {
            if (e3 === this) this.g(new TypeError("A Promise cannot resolve to itself"));else if (e3 instanceof t3) this.o(e3);else {
              e: switch (typeof e3) {
                case "object":
                  var r4 = null != e3;
                  break e;
                case "function":
                  r4 = true;
                  break e;
                default:
                  r4 = false;
              }
              r4 ? this.l(e3) : this.h(e3);
            }
          }, t3.prototype.l = function (e3) {
            var t4 = void 0;
            try {
              t4 = e3.then;
            } catch (e4) {
              return void this.g(e4);
            }
            "function" == typeof t4 ? this.u(t4, e3) : this.h(e3);
          }, t3.prototype.g = function (e3) {
            this.i(2, e3);
          }, t3.prototype.h = function (e3) {
            this.i(1, e3);
          }, t3.prototype.i = function (e3, t4) {
            if (0 != this.b) throw Error("Cannot settle(" + e3 + ", " + t4 + "): Promise already settled in state" + this.b);
            this.b = e3, this.c = t4, this.j();
          }, t3.prototype.j = function () {
            if (null != this.a) {
              for (var e3 = 0; e3 < this.a.length; ++e3) a3.b(this.a[e3]);
              this.a = null;
            }
          };
          var a3 = new r3();
          return t3.prototype.o = function (e3) {
            var t4 = this.f();
            e3.w(t4.resolve, t4.reject);
          }, t3.prototype.u = function (e3, t4) {
            var r4 = this.f();
            try {
              e3.call(t4, r4.resolve, r4.reject);
            } catch (e4) {
              r4.reject(e4);
            }
          }, t3.prototype.then = function (e3, r4) {
            function n3(e4, t4) {
              return "function" == typeof e4 ? function (t5) {
                try {
                  o2(e4(t5));
                } catch (e5) {
                  i3(e5);
                }
              } : t4;
            }
            var o2,
              i3,
              s2 = new t3(function (e4, t4) {
                o2 = e4, i3 = t4;
              });
            return this.w(n3(e3, o2), n3(r4, i3)), s2;
          }, t3.prototype.catch = function (e3) {
            return this.then(void 0, e3);
          }, t3.prototype.w = function (e3, t4) {
            function r4() {
              switch (n3.b) {
                case 1:
                  e3(n3.c);
                  break;
                case 2:
                  t4(n3.c);
                  break;
                default:
                  throw Error("Unexpected state: " + n3.b);
              }
            }
            var n3 = this;
            null == this.a ? a3.b(r4) : this.a.push(r4);
          }, t3.resolve = n2, t3.reject = function (e3) {
            return new t3(function (t4, r4) {
              r4(e3);
            });
          }, t3.race = function (e3) {
            return new t3(function (t4, r4) {
              for (var o2 = s(e3), i3 = o2.next(); !i3.done; i3 = o2.next()) n2(i3.value).w(t4, r4);
            });
          }, t3.all = function (e3) {
            var r4 = s(e3),
              o2 = r4.next();
            return o2.done ? n2([]) : new t3(function (e4, t4) {
              function i3(t5) {
                return function (r5) {
                  s2[t5] = r5, 0 == --a4 && e4(s2);
                };
              }
              var s2 = [],
                a4 = 0;
              do {
                s2.push(void 0), a4++, n2(o2.value).w(i3(s2.length - 1), t4), o2 = r4.next();
              } while (!o2.done);
            });
          }, t3;
        });
        var a2 = a2 || {},
          l = this || self;
        function u(e2, t3) {
          e2 = e2.split("."), t3 = t3 || l;
          for (var r3 = 0; r3 < e2.length; r3++) if (null == (t3 = t3[e2[r3]])) return null;
          return t3;
        }
        function g() {}
        function c(e2) {
          var t3 = typeof e2;
          if ("object" == t3) {
            if (!e2) return "null";
            if (e2 instanceof Array) return "array";
            if (e2 instanceof Object) return t3;
            var r3 = Object.prototype.toString.call(e2);
            if ("[object Window]" == r3) return "object";
            if ("[object Array]" == r3 || "number" == typeof e2.length && void 0 !== e2.splice && void 0 !== e2.propertyIsEnumerable && !e2.propertyIsEnumerable("splice")) return "array";
            if ("[object Function]" == r3 || void 0 !== e2.call && void 0 !== e2.propertyIsEnumerable && !e2.propertyIsEnumerable("call")) return "function";
          } else if ("function" == t3 && void 0 === e2.call) return "object";
          return t3;
        }
        function f(e2) {
          var t3 = typeof e2;
          return "object" == t3 && null != e2 || "function" == t3;
        }
        function d(e2, t3, r3) {
          return e2.call.apply(e2.bind, arguments);
        }
        function y(e2, t3, r3) {
          if (!e2) throw Error();
          if (2 < arguments.length) {
            var n2 = Array.prototype.slice.call(arguments, 2);
            return function () {
              var r4 = Array.prototype.slice.call(arguments);
              return Array.prototype.unshift.apply(r4, n2), e2.apply(t3, r4);
            };
          }
          return function () {
            return e2.apply(t3, arguments);
          };
        }
        function m(e2, t3, r3) {
          return (m = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? d : y).apply(null, arguments);
        }
        function v(e2, t3) {
          function r3() {}
          r3.prototype = t3.prototype, e2.S = t3.prototype, e2.prototype = new r3(), e2.prototype.constructor = e2;
        }
        function _() {
          this.a = {};
        }
        function S(e2, t3, r3, n2) {
          this.f = e2, this.c = t3, this.b = r3, this.a = n2;
        }
        function w(e2, t3, r3, n2) {
          r3 = void 0 === r3 ? {} : r3, this.c = e2, this.a = r3, this.b = t3, this.f = void 0 === n2 ? null : n2;
        }
        function E(e2, t3, r3, n2, o2, i2) {
          this.name = e2, this.a = o2, this.b = i2;
        }
        function T(e2, t3, r3) {
          r3 = void 0 === r3 ? {} : r3;
          var n2 = void 0 === n2 ? new _() : n2;
          return new S(t3, e2, r3, n2);
        }
        function R(e2, t3, r3, n2) {
          return n2 instanceof E ? n2 : new E(e2, r3, n2.b || t3.constructor, n2.f, n2.a, n2.c);
        }
        function A(e2) {
          this.a = e2;
        }
        function O(e2) {
          switch (e2) {
            case 0:
              return "No Error";
            case 1:
              return "Access denied to content document";
            case 2:
              return "File not found";
            case 3:
              return "Firefox silently errored";
            case 4:
              return "Application custom error";
            case 5:
              return "An exception occurred";
            case 6:
              return "Http response at 400 or 500 level";
            case 7:
              return "Request was aborted";
            case 8:
              return "Request timed out";
            case 9:
              return "The resource is not available offline";
            default:
              return "Unrecognized error code";
          }
        }
        function C(e2) {
          if (Error.captureStackTrace) Error.captureStackTrace(this, C);else {
            var t3 = Error().stack;
            t3 && (this.stack = t3);
          }
          e2 && (this.message = String(e2));
        }
        function I(e2, t3) {
          for (var r3 = "", n2 = (e2 = e2.split("%s")).length - 1, o2 = 0; o2 < n2; o2++) r3 += e2[o2] + (o2 < t3.length ? t3[o2] : "%s");
          C.call(this, r3 + e2[n2]);
        }
        function j() {
          this.j = null, this.i = [], this.l = 0, this.b = M, this.f = this.a = this.h = 0, this.c = null, this.g = 0;
        }
        _.prototype.get = function (e2) {
          return this.a[e2];
        }, _.prototype.f = function () {
          return Object.keys(this.a);
        }, S.prototype.getRequestMessage = function () {
          return this.f;
        }, S.prototype.getMethodDescriptor = function () {
          return this.c;
        }, S.prototype.getMetadata = function () {
          return this.b;
        }, S.prototype.getCallOptions = function () {
          return this.a;
        }, w.prototype.getResponseMessage = function () {
          return this.c;
        }, w.prototype.getMetadata = function () {
          return this.a;
        }, w.prototype.getMethodDescriptor = function () {
          return this.b;
        }, w.prototype.getStatus = function () {
          return this.f;
        }, A.prototype.on = function (e2, t3) {
          return "data" == e2 || "error" == e2 ? this : this.a.on(e2, t3);
        }, A.prototype.removeListener = function (e2, t3) {
          return this.a.removeListener(e2, t3);
        }, A.prototype.cancel = function () {
          this.a.cancel();
        }, v(C, Error), C.prototype.name = "CustomError", v(I, C), I.prototype.name = "AssertionError";
        var M = 0,
          P = 1,
          N = 2,
          L = 3,
          D = 0,
          x = 128;
        function U(e2, t3, r3, n2) {
          throw e2.b = L, e2.j = "The stream is broken @" + e2.l + "/" + r3 + ". Error: " + n2 + ". With input:\n" + t3, Error(e2.j);
        }
        var B = Array.prototype.indexOf ? function (e2, t3) {
          return Array.prototype.indexOf.call(e2, t3, void 0);
        } : function (e2, t3) {
          if ("string" == typeof e2) return "string" != typeof t3 || 1 != t3.length ? -1 : e2.indexOf(t3, 0);
          for (var r3 = 0; r3 < e2.length; r3++) if (r3 in e2 && e2[r3] === t3) return r3;
          return -1;
        };
        var k,
          F = String.prototype.trim ? function (e2) {
            return e2.trim();
          } : function (e2) {
            return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e2)[1];
          };
        function W(e2, t3) {
          return -1 != e2.indexOf(t3);
        }
        function V(e2, t3) {
          return e2 < t3 ? -1 : e2 > t3 ? 1 : 0;
        }
        e: {
          var H = l.navigator;
          if (H) {
            var z = H.userAgent;
            if (z) {
              k = z;
              break e;
            }
          }
          k = "";
        }
        var G = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
        function q(e2) {
          var t3 = 1;
          e2 = e2.split(":");
          for (var r3 = []; 0 < t3 && e2.length;) r3.push(e2.shift()), t3--;
          return e2.length && r3.push(e2.join(":")), r3;
        }
        function Y(e2) {
          return Y[" "](e2), e2;
        }
        Y[" "] = g;
        var Z,
          $,
          K = W(k, "Opera"),
          X = W(k, "Trident") || W(k, "MSIE"),
          J = W(k, "Edge"),
          Q = W(k, "Gecko") && !(W(k.toLowerCase(), "webkit") && !W(k, "Edge")) && !(W(k, "Trident") || W(k, "MSIE")) && !W(k, "Edge"),
          ee = W(k.toLowerCase(), "webkit") && !W(k, "Edge");
        function te() {
          var e2 = l.document;
          return e2 ? e2.documentMode : void 0;
        }
        e: {
          var re = "",
            ne = ($ = k, Q ? /rv:([^\);]+)(\)|;)/.exec($) : J ? /Edge\/([\d\.]+)/.exec($) : X ? /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec($) : ee ? /WebKit\/(\S+)/.exec($) : K ? /(?:Version)[ \/]?(\S+)/.exec($) : void 0);
          if (ne && (re = ne ? ne[1] : ""), X) {
            var oe = te();
            if (null != oe && oe > parseFloat(re)) {
              Z = String(oe);
              break e;
            }
          }
          Z = re;
        }
        var ie,
          se = {};
        function ae(e2) {
          return function (e3, t3) {
            var r3 = se;
            return Object.prototype.hasOwnProperty.call(r3, e3) ? r3[e3] : r3[e3] = t3(e3);
          }(e2, function () {
            for (var t3 = 0, r3 = F(String(Z)).split("."), n2 = F(String(e2)).split("."), o2 = Math.max(r3.length, n2.length), i2 = 0; 0 == t3 && i2 < o2; i2++) {
              var s2 = r3[i2] || "",
                a3 = n2[i2] || "";
              do {
                if (s2 = /(\d*)(\D*)(.*)/.exec(s2) || ["", "", "", ""], a3 = /(\d*)(\D*)(.*)/.exec(a3) || ["", "", "", ""], 0 == s2[0].length && 0 == a3[0].length) break;
                t3 = V(0 == s2[1].length ? 0 : parseInt(s2[1], 10), 0 == a3[1].length ? 0 : parseInt(a3[1], 10)) || V(0 == s2[2].length, 0 == a3[2].length) || V(s2[2], a3[2]), s2 = s2[3], a3 = a3[3];
              } while (0 == t3);
            }
            return 0 <= t3;
          });
        }
        if (l.document && X) {
          var le = te();
          ie = le || parseInt(Z, 10) || void 0;
        } else ie = void 0;
        var ue = ie;
        function ge() {
          this.F = this.F;
        }
        ge.prototype.F = false;
        var fe,
          pe = Object.freeze || function (e2) {
            return e2;
          };
        (fe = !X) || (fe = 9 <= Number(ue));
        var he = fe,
          de = X && !ae("9"),
          ye = function () {
            if (!l.addEventListener || !Object.defineProperty) return false;
            var e2 = false,
              t3 = Object.defineProperty({}, "passive", {
                get: function get() {
                  e2 = true;
                }
              });
            try {
              l.addEventListener("test", g, t3), l.removeEventListener("test", g, t3);
            } catch (e3) {}
            return e2;
          }();
        function me(e2, t3) {
          this.type = e2, this.a = this.target = t3, this.defaultPrevented = false;
        }
        function be(e2, t3) {
          if (me.call(this, e2 ? e2.type : ""), this.relatedTarget = this.a = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = false, this.pointerId = 0, this.pointerType = "", this.c = null, e2) {
            var r3 = this.type = e2.type,
              n2 = e2.changedTouches && e2.changedTouches.length ? e2.changedTouches[0] : null;
            if (this.target = e2.target || e2.srcElement, this.a = t3, t3 = e2.relatedTarget) {
              if (Q) {
                e: {
                  try {
                    Y(t3.nodeName);
                    var o2 = true;
                    break e;
                  } catch (e3) {}
                  o2 = false;
                }
                o2 || (t3 = null);
              }
            } else "mouseover" == r3 ? t3 = e2.fromElement : "mouseout" == r3 && (t3 = e2.toElement);
            this.relatedTarget = t3, n2 ? (this.clientX = void 0 !== n2.clientX ? n2.clientX : n2.pageX, this.clientY = void 0 !== n2.clientY ? n2.clientY : n2.pageY, this.screenX = n2.screenX || 0, this.screenY = n2.screenY || 0) : (this.clientX = void 0 !== e2.clientX ? e2.clientX : e2.pageX, this.clientY = void 0 !== e2.clientY ? e2.clientY : e2.pageY, this.screenX = e2.screenX || 0, this.screenY = e2.screenY || 0), this.button = e2.button, this.key = e2.key || "", this.ctrlKey = e2.ctrlKey, this.altKey = e2.altKey, this.shiftKey = e2.shiftKey, this.metaKey = e2.metaKey, this.pointerId = e2.pointerId || 0, this.pointerType = "string" == typeof e2.pointerType ? e2.pointerType : ve[e2.pointerType] || "", this.c = e2, e2.defaultPrevented && this.b();
          }
        }
        me.prototype.b = function () {
          this.defaultPrevented = true;
        }, v(be, me);
        var ve = pe({
          2: "touch",
          3: "pen",
          4: "mouse"
        });
        be.prototype.b = function () {
          be.S.b.call(this);
          var e2 = this.c;
          if (e2.preventDefault) e2.preventDefault();else if (e2.returnValue = false, de) try {
            (e2.ctrlKey || 112 <= e2.keyCode && 123 >= e2.keyCode) && (e2.keyCode = -1);
          } catch (e3) {}
        };
        var _e = "closure_listenable_" + (1e6 * Math.random() | 0),
          Se = 0;
        function we(e2, t3, r3, n2, o2) {
          this.listener = e2, this.proxy = null, this.src = t3, this.type = r3, this.capture = !!n2, this.A = o2, this.key = ++Se, this.s = this.v = false;
        }
        function Ee(e2) {
          e2.s = true, e2.listener = null, e2.proxy = null, e2.src = null, e2.A = null;
        }
        function Te(e2) {
          this.src = e2, this.a = {}, this.b = 0;
        }
        function Re(e2, t3) {
          var r3 = t3.type;
          if (r3 in e2.a) {
            var n2,
              o2 = e2.a[r3],
              i2 = B(o2, t3);
            (n2 = 0 <= i2) && Array.prototype.splice.call(o2, i2, 1), n2 && (Ee(t3), 0 == e2.a[r3].length && (delete e2.a[r3], e2.b--));
          }
        }
        function Ae(e2, t3, r3, n2) {
          for (var o2 = 0; o2 < e2.length; ++o2) {
            var i2 = e2[o2];
            if (!i2.s && i2.listener == t3 && i2.capture == !!r3 && i2.A == n2) return o2;
          }
          return -1;
        }
        Te.prototype.add = function (e2, t3, r3, n2, o2) {
          var i2 = e2.toString();
          (e2 = this.a[i2]) || (e2 = this.a[i2] = [], this.b++);
          var s2 = Ae(e2, t3, n2, o2);
          return -1 < s2 ? (t3 = e2[s2], r3 || (t3.v = false)) : ((t3 = new we(t3, this.src, i2, !!n2, o2)).v = r3, e2.push(t3)), t3;
        };
        var Oe = "closure_lm_" + (1e6 * Math.random() | 0),
          Ce = {};
        function Ie(e2, t3, r3, n2, o2) {
          if (n2 && n2.once) !function e3(t4, r4, n3, o3, i3) {
            if (Array.isArray(r4)) for (var s2 = 0; s2 < r4.length; s2++) e3(t4, r4[s2], n3, o3, i3);else n3 = Be(n3), t4 && t4[_e] ? t4.f.add(String(r4), n3, true, f(o3) ? !!o3.capture : !!o3, i3) : je(t4, r4, n3, true, o3, i3);
          }(e2, t3, r3, n2, o2);else if (Array.isArray(t3)) for (var i2 = 0; i2 < t3.length; i2++) Ie(e2, t3[i2], r3, n2, o2);else r3 = Be(r3), e2 && e2[_e] ? e2.f.add(String(t3), r3, false, f(n2) ? !!n2.capture : !!n2, o2) : je(e2, t3, r3, false, n2, o2);
        }
        function je(e2, t3, r3, n2, o2, i2) {
          if (!t3) throw Error("Invalid event type");
          var s2 = f(o2) ? !!o2.capture : !!o2,
            a3 = xe(e2);
          if (a3 || (e2[Oe] = a3 = new Te(e2)), !(r3 = a3.add(t3, r3, n2, s2, i2)).proxy) {
            if (n2 = function () {
              var e3 = De,
                t4 = he ? function (r4) {
                  return e3.call(t4.src, t4.listener, r4);
                } : function (r4) {
                  if (!(r4 = e3.call(t4.src, t4.listener, r4))) return r4;
                };
              return t4;
            }(), r3.proxy = n2, n2.src = e2, n2.listener = r3, e2.addEventListener) ye || (o2 = s2), void 0 === o2 && (o2 = false), e2.addEventListener(t3.toString(), n2, o2);else if (e2.attachEvent) e2.attachEvent(Pe(t3.toString()), n2);else {
              if (!e2.addListener || !e2.removeListener) throw Error("addEventListener and attachEvent are unavailable.");
              e2.addListener(n2);
            }
          }
        }
        function Me(e2) {
          if ("number" != typeof e2 && e2 && !e2.s) {
            var t3 = e2.src;
            if (t3 && t3[_e]) Re(t3.f, e2);else {
              var r3 = e2.type,
                n2 = e2.proxy;
              t3.removeEventListener ? t3.removeEventListener(r3, n2, e2.capture) : t3.detachEvent ? t3.detachEvent(Pe(r3), n2) : t3.addListener && t3.removeListener && t3.removeListener(n2), (r3 = xe(t3)) ? (Re(r3, e2), 0 == r3.b && (r3.src = null, t3[Oe] = null)) : Ee(e2);
            }
          }
        }
        function Pe(e2) {
          return e2 in Ce ? Ce[e2] : Ce[e2] = "on" + e2;
        }
        function Ne(e2, t3, r3, n2) {
          var o2 = true;
          if ((e2 = xe(e2)) && (t3 = e2.a[t3.toString()])) for (t3 = t3.concat(), e2 = 0; e2 < t3.length; e2++) {
            var i2 = t3[e2];
            i2 && i2.capture == r3 && !i2.s && (i2 = Le(i2, n2), o2 = o2 && false !== i2);
          }
          return o2;
        }
        function Le(e2, t3) {
          var r3 = e2.listener,
            n2 = e2.A || e2.src;
          return e2.v && Me(e2), r3.call(n2, t3);
        }
        function De(e2, t3) {
          if (e2.s) return true;
          if (!he) {
            var r3 = t3 || u("window.event");
            t3 = new be(r3, this);
            var n2 = true;
            if (!(0 > r3.keyCode || null != r3.returnValue)) {
              e: {
                var o2 = false;
                if (0 == r3.keyCode) try {
                  r3.keyCode = -1;
                  break e;
                } catch (e3) {
                  o2 = true;
                }
                (o2 || null == r3.returnValue) && (r3.returnValue = true);
              }
              for (r3 = [], o2 = t3.a; o2; o2 = o2.parentNode) r3.push(o2);
              for (e2 = e2.type, o2 = r3.length - 1; 0 <= o2; o2--) {
                t3.a = r3[o2];
                var i2 = Ne(r3[o2], e2, true, t3);
                n2 = n2 && i2;
              }
              for (o2 = 0; o2 < r3.length; o2++) t3.a = r3[o2], i2 = Ne(r3[o2], e2, false, t3), n2 = n2 && i2;
            }
            return n2;
          }
          return Le(e2, new be(t3, this));
        }
        function xe(e2) {
          return (e2 = e2[Oe]) instanceof Te ? e2 : null;
        }
        var Ue = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
        function Be(e2) {
          return "function" == c(e2) ? e2 : (e2[Ue] || (e2[Ue] = function (t3) {
            return e2.handleEvent(t3);
          }), e2[Ue]);
        }
        function ke() {
          ge.call(this), this.f = new Te(this), this.N = this;
        }
        function Fe(e2, t3) {
          e2 = e2.N;
          var r3 = t3.type || t3;
          if ("string" == typeof t3) t3 = new me(t3, e2);else if (t3 instanceof me) t3.target = t3.target || e2;else {
            var n2 = t3;
            (function (e3, t4) {
              for (var r4, n3, o2 = 1; o2 < arguments.length; o2++) {
                for (r4 in n3 = arguments[o2]) e3[r4] = n3[r4];
                for (var i2 = 0; i2 < G.length; i2++) r4 = G[i2], Object.prototype.hasOwnProperty.call(n3, r4) && (e3[r4] = n3[r4]);
              }
            })(t3 = new me(r3, e2), n2);
          }
          We(e2 = t3.a = e2, r3, true, t3), We(e2, r3, false, t3);
        }
        function We(e2, t3, r3, n2) {
          if (t3 = e2.f.a[String(t3)]) {
            t3 = t3.concat();
            for (var o2 = true, i2 = 0; i2 < t3.length; ++i2) {
              var s2 = t3[i2];
              if (s2 && !s2.s && s2.capture == r3) {
                var a3 = s2.listener,
                  l2 = s2.A || s2.src;
                s2.v && Re(e2.f, s2), o2 = false !== a3.call(l2, n2) && o2;
              }
            }
          }
        }
        function Ve(e2, t3, r3) {
          if ("function" == c(e2)) r3 && (e2 = m(e2, r3));else {
            if (!e2 || "function" != typeof e2.handleEvent) throw Error("Invalid listener argument");
            e2 = m(e2.handleEvent, e2);
          }
          return 2147483647 < Number(t3) ? -1 : l.setTimeout(e2, t3 || 0);
        }
        function He(e2, t3, r3) {
          this.reset(e2, t3, r3, void 0, void 0);
        }
        v(ke, ge), ke.prototype[_e] = true, ke.prototype.addEventListener = function (e2, t3, r3, n2) {
          Ie(this, e2, t3, r3, n2);
        }, ke.prototype.removeEventListener = function (e2, t3, r3, n2) {
          !function e3(t4, r4, n3, o2, i2) {
            if (Array.isArray(r4)) for (var s2 = 0; s2 < r4.length; s2++) e3(t4, r4[s2], n3, o2, i2);else o2 = f(o2) ? !!o2.capture : !!o2, n3 = Be(n3), t4 && t4[_e] ? (t4 = t4.f, (r4 = String(r4).toString()) in t4.a && -1 < (n3 = Ae(s2 = t4.a[r4], n3, o2, i2)) && (Ee(s2[n3]), Array.prototype.splice.call(s2, n3, 1), 0 == s2.length && (delete t4.a[r4], t4.b--))) : t4 && (t4 = xe(t4)) && (r4 = t4.a[r4.toString()], t4 = -1, r4 && (t4 = Ae(r4, n3, o2, i2)), (n3 = -1 < t4 ? r4[t4] : null) && Me(n3));
          }(this, e2, t3, r3, n2);
        }, He.prototype.a = null;
        function ze(e2) {
          this.f = e2, this.b = this.c = this.a = null;
        }
        function Ge(e2, t3) {
          this.name = e2, this.value = t3;
        }
        He.prototype.reset = function (e2, t3, r3, n2, o2) {
          delete this.a;
        }, Ge.prototype.toString = function () {
          return this.name;
        };
        var qe = new Ge("SEVERE", 1e3),
          Ye = new Ge("CONFIG", 700),
          Ze = new Ge("FINE", 500);
        function $e(e2) {
          return e2.c ? e2.c : e2.a ? $e(e2.a) : (function (e3, t3) {
            throw new I("Failure" + (e3 ? ": " + e3 : ""), Array.prototype.slice.call(arguments, 1));
          }("Root logger has no level set."), null);
        }
        ze.prototype.log = function (e2, t3, r3) {
          if (e2.value >= $e(this).value) for ("function" == c(t3) && (t3 = t3()), e2 = new He(e2, String(t3), this.f), r3 && (e2.a = r3), r3 = this; r3;) r3 = r3.a;
        };
        var Ke,
          Xe = {},
          Je = null;
        function Qe(e2, t3) {
          e2 && e2.log(Ze, t3, void 0);
        }
        function et() {}
        function tt(e2) {
          var t3;
          return (t3 = e2.a) || (t3 = {}, ot(e2) && (t3[0] = true, t3[1] = true), t3 = e2.a = t3), t3;
        }
        function rt() {}
        function nt(e2) {
          return (e2 = ot(e2)) ? new ActiveXObject(e2) : new XMLHttpRequest();
        }
        function ot(e2) {
          if (!e2.b && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
            for (var t3 = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], r3 = 0; r3 < t3.length; r3++) {
              var n2 = t3[r3];
              try {
                return new ActiveXObject(n2), e2.b = n2;
              } catch (e3) {}
            }
            throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
          }
          return e2.b;
        }
        function it(e2, t3) {
          this.b = {}, this.a = [], this.c = 0;
          var r3 = arguments.length;
          if (1 < r3) {
            if (r3 % 2) throw Error("Uneven number of arguments");
            for (var n2 = 0; n2 < r3; n2 += 2) this.set(arguments[n2], arguments[n2 + 1]);
          } else e2 && at(this, e2);
        }
        function st(e2) {
          if (e2.c != e2.a.length) {
            for (var t3 = 0, r3 = 0; t3 < e2.a.length;) {
              var n2 = e2.a[t3];
              lt(e2.b, n2) && (e2.a[r3++] = n2), t3++;
            }
            e2.a.length = r3;
          }
          if (e2.c != e2.a.length) {
            var o2 = {};
            for (r3 = t3 = 0; t3 < e2.a.length;) lt(o2, n2 = e2.a[t3]) || (e2.a[r3++] = n2, o2[n2] = 1), t3++;
            e2.a.length = r3;
          }
        }
        function at(e2, t3) {
          if (t3 instanceof it) for (var r3 = t3.f(), n2 = 0; n2 < r3.length; n2++) e2.set(r3[n2], t3.get(r3[n2]));else for (r3 in t3) e2.set(r3, t3[r3]);
        }
        function lt(e2, t3) {
          return Object.prototype.hasOwnProperty.call(e2, t3);
        }
        et.prototype.a = null, v(rt, et), Ke = new rt(), it.prototype.f = function () {
          return st(this), this.a.concat();
        }, it.prototype.get = function (e2, t3) {
          return lt(this.b, e2) ? this.b[e2] : t3;
        }, it.prototype.set = function (e2, t3) {
          lt(this.b, e2) || (this.c++, this.a.push(e2)), this.b[e2] = t3;
        }, it.prototype.forEach = function (e2, t3) {
          for (var r3 = this.f(), n2 = 0; n2 < r3.length; n2++) {
            var o2 = r3[n2],
              i2 = this.get(o2);
            e2.call(t3, i2, o2, this);
          }
        };
        var ut = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
        function gt(e2) {
          ke.call(this), this.headers = new it(), this.D = e2 || null, this.c = false, this.C = this.a = null, this.J = this.o = "", this.g = 0, this.i = "", this.h = this.I = this.m = this.G = false, this.l = 0, this.u = null, this.j = ct, this.B = this.H = false;
        }
        v(gt, ke);
        var ct = "",
          ft = gt.prototype,
          pt = function e2(t3) {
            var r3;
            if (Je || (Je = new ze(""), Xe[""] = Je, Je.c = Ye), !(r3 = Xe[t3])) {
              r3 = new ze(t3);
              var n2 = t3.lastIndexOf("."),
                o2 = t3.substr(n2 + 1);
              (n2 = e2(t3.substr(0, n2))).b || (n2.b = {}), n2.b[o2] = r3, r3.a = n2, Xe[t3] = r3;
            }
            return r3;
          }("goog.net.XhrIo");
        ft.b = pt;
        var ht = /^https?$/i,
          dt = ["POST", "PUT"];
        function yt(e2, t3, r3) {
          if (e2.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + e2.o + "; newUri=" + t3);
          e2.o = t3, e2.i = "", e2.g = 0, e2.J = "POST", e2.G = false, e2.c = true, e2.a = e2.D ? nt(e2.D) : nt(Ke), e2.C = e2.D ? tt(e2.D) : tt(Ke), e2.a.onreadystatechange = m(e2.K, e2);
          try {
            Qe(e2.b, Rt(e2, "Opening Xhr")), e2.I = true, e2.a.open("POST", String(t3), true), e2.I = false;
          } catch (t4) {
            return Qe(e2.b, Rt(e2, "Error opening Xhr: " + t4.message)), void bt(e2, t4);
          }
          t3 = r3 || "";
          var n2 = function (e3) {
              e: {
                for (var t4 = mt, r4 = e3.length, n3 = "string" == typeof e3 ? e3.split("") : e3, o3 = 0; o3 < r4; o3++) if (o3 in n3 && t4.call(void 0, n3[o3], o3, e3)) {
                  t4 = o3;
                  break e;
                }
                t4 = -1;
              }
              return 0 > t4 ? null : "string" == typeof e3 ? e3.charAt(t4) : e3[t4];
            }((r3 = new it(e2.headers)).f()),
            o2 = l.FormData && t3 instanceof l.FormData;
          !(0 <= B(dt, "POST")) || n2 || o2 || r3.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"), r3.forEach(function (e3, t4) {
            this.a.setRequestHeader(t4, e3);
          }, e2), e2.j && (e2.a.responseType = e2.j), "withCredentials" in e2.a && e2.a.withCredentials !== e2.H && (e2.a.withCredentials = e2.H);
          try {
            wt(e2), 0 < e2.l && (e2.B = function (e3) {
              return X && ae(9) && "number" == typeof e3.timeout && void 0 !== e3.ontimeout;
            }(e2.a), Qe(e2.b, Rt(e2, "Will abort after " + e2.l + "ms if incomplete, xhr2 " + e2.B)), e2.B ? (e2.a.timeout = e2.l, e2.a.ontimeout = m(e2.L, e2)) : e2.u = Ve(e2.L, e2.l, e2)), Qe(e2.b, Rt(e2, "Sending request")), e2.m = true, e2.a.send(t3), e2.m = false;
          } catch (t4) {
            Qe(e2.b, Rt(e2, "Send error: " + t4.message)), bt(e2, t4);
          }
        }
        function mt(e2) {
          return "content-type" == e2.toLowerCase();
        }
        function bt(e2, t3) {
          e2.c = false, e2.a && (e2.h = true, e2.a.abort(), e2.h = false), e2.i = t3, e2.g = 5, vt(e2), St(e2);
        }
        function vt(e2) {
          e2.G || (e2.G = true, Fe(e2, "complete"), Fe(e2, "error"));
        }
        function _t(e2) {
          if (e2.c && void 0 !== a2) {
            if (e2.C[1] && 4 == Et(e2) && 2 == e2.getStatus()) Qe(e2.b, Rt(e2, "Local request error detected and ignored"));else if (e2.m && 4 == Et(e2)) Ve(e2.K, 0, e2);else if (Fe(e2, "readystatechange"), 4 == Et(e2)) {
              Qe(e2.b, Rt(e2, "Request complete")), e2.c = false;
              try {
                var t3,
                  r3 = e2.getStatus();
                e: switch (r3) {
                  case 200:
                  case 201:
                  case 202:
                  case 204:
                  case 206:
                  case 304:
                  case 1223:
                    var n2 = true;
                    break e;
                  default:
                    n2 = false;
                }
                if (!(t3 = n2)) {
                  var o2;
                  if (o2 = 0 === r3) {
                    var i2 = String(e2.o).match(ut)[1] || null;
                    if (!i2 && l.self && l.self.location) {
                      var s2 = l.self.location.protocol;
                      i2 = s2.substr(0, s2.length - 1);
                    }
                    o2 = !ht.test(i2 ? i2.toLowerCase() : "");
                  }
                  t3 = o2;
                }
                if (t3) Fe(e2, "complete"), Fe(e2, "success");else {
                  e2.g = 6;
                  try {
                    var u2 = 2 < Et(e2) ? e2.a.statusText : "";
                  } catch (t4) {
                    Qe(e2.b, "Can not get status: " + t4.message), u2 = "";
                  }
                  e2.i = u2 + " [" + e2.getStatus() + "]", vt(e2);
                }
              } finally {
                St(e2);
              }
            }
          }
        }
        function St(e2) {
          if (e2.a) {
            wt(e2);
            var t3 = e2.a,
              r3 = e2.C[0] ? g : null;
            e2.a = null, e2.C = null, Fe(e2, "ready");
            try {
              t3.onreadystatechange = r3;
            } catch (t4) {
              (e2 = e2.b) && e2.log(qe, "Problem encountered resetting onreadystatechange: " + t4.message, void 0);
            }
          }
        }
        function wt(e2) {
          e2.a && e2.B && (e2.a.ontimeout = null), e2.u && (l.clearTimeout(e2.u), e2.u = null);
        }
        function Et(e2) {
          return e2.a ? e2.a.readyState : 0;
        }
        function Tt(e2, t3) {
          if (e2.a && 4 == Et(e2)) return null === (e2 = e2.a.getResponseHeader(t3)) ? void 0 : e2;
        }
        function Rt(e2, t3) {
          return t3 + " [" + e2.J + " " + e2.o + " " + e2.getStatus() + "]";
        }
        gt.prototype.L = function () {
          void 0 !== a2 && this.a && (this.i = "Timed out after " + this.l + "ms, aborting", this.g = 8, Qe(this.b, Rt(this, this.i)), Fe(this, "timeout"), this.abort(8));
        }, gt.prototype.abort = function (e2) {
          this.a && this.c && (Qe(this.b, Rt(this, "Aborting")), this.c = false, this.h = true, this.a.abort(), this.h = false, this.g = e2 || 7, Fe(this, "complete"), Fe(this, "abort"), St(this));
        }, gt.prototype.K = function () {
          this.F || (this.I || this.m || this.h ? _t(this) : this.O());
        }, gt.prototype.O = function () {
          _t(this);
        }, gt.prototype.getStatus = function () {
          try {
            return 2 < Et(this) ? this.a.status : -1;
          } catch (e2) {
            return -1;
          }
        };
        var At = {},
          Ot = null;
        function Ct(e2) {
          var t3 = e2.length,
            r3 = 3 * t3 / 4;
          r3 % 3 ? r3 = Math.floor(r3) : W("=.", e2[t3 - 1]) && (r3 = W("=.", e2[t3 - 2]) ? r3 - 2 : r3 - 1);
          var n2 = new Uint8Array(r3),
            o2 = 0;
          return function (e3, t4) {
            function r4(t5) {
              for (; n3 < e3.length;) {
                var r5 = e3.charAt(n3++),
                  o4 = Ot[r5];
                if (null != o4) return o4;
                if (!/^[\s\xa0]*$/.test(r5)) throw Error("Unknown base64 encoding at char: " + r5);
              }
              return t5;
            }
            It();
            for (var n3 = 0;;) {
              var o3 = r4(-1),
                i2 = r4(0),
                s2 = r4(64),
                a3 = r4(64);
              if (64 === a3 && -1 === o3) break;
              t4(o3 << 2 | i2 >> 4), 64 != s2 && (t4(i2 << 4 & 240 | s2 >> 2), 64 != a3 && t4(s2 << 6 & 192 | a3));
            }
          }(e2, function (e3) {
            n2[o2++] = e3;
          }), n2.subarray(0, o2);
        }
        function It() {
          if (!Ot) {
            Ot = {};
            for (var e2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), t3 = ["+/=", "+/", "-_=", "-_.", "-_"], r3 = 0; 5 > r3; r3++) {
              var n2 = e2.concat(t3[r3].split(""));
              At[r3] = n2;
              for (var o2 = 0; o2 < n2.length; o2++) {
                var i2 = n2[o2];
                void 0 === Ot[i2] && (Ot[i2] = o2);
              }
            }
          }
        }
        var jt = ["content-type", "grpc-status", "grpc-message"];
        function Mt(e2) {
          this.a = e2.T, this.l = null, this.b = [], this.h = [], this.g = [], this.f = [], this.c = [], this.j = false, this.i = 0, this.m = new j();
          var t3 = this;
          Ie(this.a, "readystatechange", function () {
            var e3 = t3.a;
            if (e3 = e3.a ? e3.a.getResponseHeader("Content-Type") : null) {
              if (0 == (e3 = e3.toLowerCase()).lastIndexOf("application/grpc-web-text", 0)) {
                e3 = t3.a;
                try {
                  var r3 = e3.a ? e3.a.responseText : "";
                } catch (t4) {
                  Qe(e3.b, "Can not get responseText: " + t4.message), r3 = "";
                }
                if (r3 = (e3 = r3 || "").length - e3.length % 4, 0 == (e3 = e3.substr(t3.i, r3 - t3.i)).length) return;
                t3.i = r3, e3 = Ct(e3);
              } else {
                if (0 != e3.lastIndexOf("application/grpc", 0)) return void Nt(t3, {
                  code: 2,
                  message: "Unknown Content-type received.",
                  metadata: {}
                });
                e3 = new Uint8Array(function (e4) {
                  try {
                    if (!e4.a) return null;
                    if ("response" in e4.a) return e4.a.response;
                    switch (e4.j) {
                      case ct:
                      case "text":
                        return e4.a.responseText;
                      case "arraybuffer":
                        if ("mozResponseArrayBuffer" in e4.a) return e4.a.mozResponseArrayBuffer;
                    }
                    var t4 = e4.b;
                    return t4 && t4.log(qe, "Response type " + e4.j + " is not supported on this browser", void 0), null;
                  } catch (t5) {
                    return Qe(e4.b, "Can not get response: " + t5.message), null;
                  }
                }(t3.a));
              }
              r3 = null;
              try {
                r3 = function (e4, t4) {
                  function r4(e5) {
                    a4.f++, a4.a = (a4.a << 8) + e5, 4 == a4.f && (a4.b = N, a4.g = 0, "undefined" != typeof Uint8Array ? a4.c = new Uint8Array(a4.a) : a4.c = Array(a4.a), 0 == a4.a && o3());
                  }
                  function n3(e5) {
                    a4.c[a4.g++] = e5, a4.g == a4.a && o3();
                  }
                  function o3() {
                    var e5 = {};
                    e5[a4.h] = a4.c, a4.i.push(e5), a4.b = M;
                  }
                  var i3,
                    s3,
                    a4 = e4,
                    l2 = 0;
                  for (i3 = t4 instanceof Uint8Array || t4 instanceof Array ? t4 : new Uint8Array(t4); l2 < i3.length;) {
                    switch (a4.b) {
                      case L:
                        U(a4, i3, l2, "stream already broken");
                        break;
                      case M:
                        (s3 = i3[l2]) == D || s3 == x ? a4.h = s3 : U(a4, i3, l2, "invalid frame byte"), a4.b = P, a4.a = 0, a4.f = 0;
                        break;
                      case P:
                        r4(i3[l2]);
                        break;
                      case N:
                        n3(i3[l2]);
                        break;
                      default:
                        throw Error("unexpected parser state: " + a4.b);
                    }
                    a4.l++, l2++;
                  }
                  return e4 = a4.i, a4.i = [], 0 < e4.length ? e4 : null;
                }(t3.m, e3);
              } catch (e4) {
                Nt(t3, {
                  code: 2,
                  message: "Error in parsing response body",
                  metadata: {}
                });
              }
              if (r3) for (e3 = 0; e3 < r3.length; e3++) {
                if (D in r3[e3]) {
                  var n2 = r3[e3][D];
                  if (n2) try {
                    var o2 = t3.l(n2);
                    if (o2) {
                      n2 = t3;
                      for (var i2 = o2, s2 = 0; s2 < n2.b.length; s2++) n2.b[s2](i2);
                    }
                  } catch (e4) {
                    Nt(t3, {
                      code: 2,
                      message: "Error in response deserializer function.",
                      metadata: {}
                    });
                  }
                }
                if (x in r3[e3] && 0 < r3[e3][x].length) {
                  for (n2 = "", i2 = 0; i2 < r3[e3][x].length; i2++) n2 += String.fromCharCode(r3[e3][x][i2]);
                  for (n2 = n2.trim().split("\r\n"), i2 = {}, s2 = 0; s2 < n2.length; s2++) {
                    var a3 = n2[s2].indexOf(":");
                    i2[n2[s2].substring(0, a3).trim()] = n2[s2].substring(a3 + 1).trim();
                  }
                  n2 = i2, i2 = 0, s2 = "", "grpc-status" in n2 && (i2 = n2["grpc-status"], delete n2["grpc-status"]), "grpc-message" in n2 && (s2 = n2["grpc-message"], delete n2["grpc-message"]), Nt(t3, {
                    code: Number(i2),
                    message: s2,
                    metadata: n2
                  });
                }
              }
            }
          }), Ie(this.a, "complete", function () {
            var e3 = t3.a.g,
              r3 = "",
              n2 = {},
              o2 = function (e4) {
                var t4 = {};
                e4 = (e4.a && 4 == Et(e4) && e4.a.getAllResponseHeaders() || "").split("\r\n");
                for (var r4 = 0; r4 < e4.length; r4++) if (!/^[\s\xa0]*$/.test(e4[r4])) {
                  var n3 = q(e4[r4]),
                    o3 = n3[0];
                  if ("string" == typeof (n3 = n3[1])) {
                    n3 = n3.trim();
                    var i3 = t4[o3] || [];
                    t4[o3] = i3, i3.push(n3);
                  }
                }
                return function (e5, t5) {
                  var r5,
                    n4 = {};
                  for (r5 in e5) n4[r5] = t5.call(void 0, e5[r5], r5, e5);
                  return n4;
                }(t4, function (e5) {
                  return e5.join(", ");
                });
              }(t3.a);
            if (Object.keys(o2).forEach(function (e4) {
              jt.includes(e4) || (n2[e4] = o2[e4]);
            }), function (e4, t4) {
              for (var r4 = 0; r4 < e4.g.length; r4++) e4.g[r4](t4);
            }(t3, n2), 0 != e3) {
              switch (e3) {
                case 7:
                  var i2 = 10;
                  break;
                case 8:
                  i2 = 4;
                  break;
                case 6:
                  i2 = function (e4) {
                    switch (e4) {
                      case 200:
                        return 0;
                      case 400:
                        return 3;
                      case 401:
                        return 16;
                      case 403:
                        return 7;
                      case 404:
                        return 5;
                      case 409:
                        return 10;
                      case 412:
                        return 9;
                      case 429:
                        return 8;
                      case 499:
                        return 1;
                      case 500:
                        return 2;
                      case 501:
                        return 12;
                      case 503:
                        return 14;
                      case 504:
                        return 4;
                      default:
                        return 2;
                    }
                  }(t3.a.getStatus());
                  break;
                default:
                  i2 = 14;
              }
              10 == i2 && t3.j || Nt(t3, {
                code: i2,
                message: O(e3),
                metadata: {}
              });
            } else e3 = false, "grpc-status" in o2 && (i2 = Tt(t3.a, "grpc-status"), "grpc-message" in o2 && (r3 = Tt(t3.a, "grpc-message")), 0 != Number(i2) && (Nt(t3, {
              code: Number(i2),
              message: r3,
              metadata: o2
            }), e3 = true)), e3 || function (e4) {
              for (var t4 = 0; t4 < e4.c.length; t4++) e4.c[t4]();
            }(t3);
          });
        }
        function Pt(e2, t3) {
          -1 < (t3 = e2.indexOf(t3)) && e2.splice(t3, 1);
        }
        function Nt(e2, t3) {
          if (0 != t3.code) for (var r3 = {
              code: t3.code,
              message: decodeURIComponent(t3.message || ""),
              metadata: t3.metadata
            }, n2 = 0; n2 < e2.f.length; n2++) e2.f[n2](r3);
          for (t3 = {
            code: t3.code,
            details: decodeURIComponent(t3.message || ""),
            metadata: t3.metadata
          }, r3 = 0; r3 < e2.h.length; r3++) e2.h[r3](t3);
        }
        function Lt(e2) {
          this.a = u("format", e2) || "text", this.f = u("suppressCorsPreflight", e2) || false, this.c = u("withCredentials", e2) || false, this.b = u("streamInterceptors", e2) || [], this.g = u("unaryInterceptors", e2) || [];
        }
        function Dt(e2, t3, r3) {
          var n2 = t3.getMethodDescriptor(),
            o2 = r3 + n2.name;
          (r3 = new gt()).H = e2.c;
          var i2 = new Mt({
            T: r3
          });
          if (i2.l = n2.b, at(r3.headers, t3.getMetadata()), "text" == e2.a ? (r3.headers.set("Content-Type", "application/grpc-web-text"), r3.headers.set("Accept", "application/grpc-web-text")) : r3.headers.set("Content-Type", "application/grpc-web+proto"), r3.headers.set("X-User-Agent", "grpc-web-javascript/0.1"), r3.headers.set("X-Grpc-Web", "1"), lt(r3.headers.b, "deadline")) {
            var s2 = r3.headers.get("deadline");
            s2 = Math.round(s2 - new Date().getTime());
            var a3 = r3.headers;
            lt(a3.b, "deadline") && (delete a3.b.deadline, a3.c--, a3.a.length > 2 * a3.c && st(a3)), 1 / 0 === s2 && (s2 = 0), 0 < s2 && r3.headers.set("grpc-timeout", s2 + "m");
          }
          if (e2.f) {
            st(a3 = r3.headers), s2 = {};
            for (var l2 = 0; l2 < a3.a.length; l2++) {
              var u2 = a3.a[l2];
              s2[u2] = a3.b[u2];
            }
            (a3 = r3.headers).b = {}, a3.a.length = 0, a3.c = 0;
            e: {
              for (g2 in s2) {
                var g2 = false;
                break e;
              }
              g2 = true;
            }
            g2 || (s2 = function (e3) {
              var t4 = "";
              return function (e4, t5) {
                for (var r4 in e4) t5.call(void 0, e4[r4], r4, e4);
              }(e3, function (e4, r4) {
                t4 += r4, t4 += ":", t4 += e4, t4 += "\r\n";
              }), t4;
            }(s2), "string" == typeof o2 ? (g2 = encodeURIComponent("$httpHeaders"), (g2 += s2 = null != s2 ? "=" + encodeURIComponent(String(s2)) : "") && (0 > (s2 = o2.indexOf("#")) && (s2 = o2.length), 0 > (a3 = o2.indexOf("?")) || a3 > s2 ? (a3 = s2, l2 = "") : l2 = o2.substring(a3 + 1, s2), s2 = (o2 = [o2.substr(0, a3), l2, o2.substr(s2)])[1], o2[1] = g2 ? s2 ? s2 + "&" + g2 : g2 : s2, o2 = o2[0] + (o2[1] ? "?" + o2[1] : "") + o2[2])) : o2.a("$httpHeaders", s2));
          }
          for (n2 = (t3 = (0, n2.a)(t3.getRequestMessage())).length, g2 = [0, 0, 0, 0], s2 = new Uint8Array(5 + n2), a3 = 3; 0 <= a3; a3--) g2[a3] = n2 % 256, n2 >>>= 8;
          if (s2.set(new Uint8Array(g2), 1), s2.set(t3, 5), t3 = s2, "text" == e2.a) {
            var c2;
            for (e2 = t3, void 0 === c2 && (c2 = 0), It(), c2 = At[c2], t3 = [], n2 = 0; n2 < e2.length; n2 += 3) {
              u2 = e2[n2];
              var f2 = (g2 = n2 + 1 < e2.length) ? e2[n2 + 1] : 0;
              a3 = u2 >> 2, u2 = (3 & u2) << 4 | f2 >> 4, f2 = (15 & f2) << 2 | (l2 = (s2 = n2 + 2 < e2.length) ? e2[n2 + 2] : 0) >> 6, l2 &= 63, s2 || (l2 = 64, g2 || (f2 = 64)), t3.push(c2[a3], c2[u2], c2[f2] || "", c2[l2] || "");
            }
            t3 = t3.join("");
          } else "binary" == e2.a && (r3.j = "arraybuffer");
          return yt(r3, o2, t3), i2;
        }
        function xt(e2, t3, r3) {
          var n2 = null,
            o2 = false;
          e2.on("data", function (e3) {
            n2 = e3;
          }), e2.on("error", function (e3) {
            0 == e3.code || o2 || (o2 = true, t3(e3, null));
          }), e2.on("status", function (e3) {
            0 == e3.code || o2 ? r3 && t3(null, null, e3) : (o2 = true, t3({
              code: e3.code,
              message: e3.details,
              metadata: e3.metadata
            }, null));
          }), r3 && e2.on("metadata", function (e3) {
            t3(null, null, null, e3);
          }), e2.on("end", function () {
            o2 || (null == n2 ? t3({
              code: 2,
              message: "Incomplete response"
            }) : t3(null, n2)), r3 && t3(null, null);
          });
        }
        function Ut(e2, t3) {
          var r3 = e2;
          return t3.forEach(function (e3) {
            var t4 = r3;
            r3 = function r3(r4) {
              return e3.intercept(r4, t4);
            };
          }), r3;
        }
        Mt.prototype.on = function (e2, t3) {
          return "data" == e2 ? this.b.push(t3) : "status" == e2 ? this.h.push(t3) : "metadata" == e2 ? this.g.push(t3) : "end" == e2 ? this.c.push(t3) : "error" == e2 && this.f.push(t3), this;
        }, Mt.prototype.removeListener = function (e2, t3) {
          return "data" == e2 ? Pt(this.b, t3) : "status" == e2 ? Pt(this.h, t3) : "metadata" == e2 ? Pt(this.g, t3) : "end" == e2 ? Pt(this.c, t3) : "error" == e2 && Pt(this.f, t3), this;
        }, Mt.prototype.cancel = function () {
          this.j = true, this.a.abort();
        }, Mt.prototype.cancel = Mt.prototype.cancel, Mt.prototype.removeListener = Mt.prototype.removeListener, Mt.prototype.on = Mt.prototype.on, Lt.prototype.P = function (e2, t3, r3, n2, o2) {
          var i2 = this;
          n2 = R(e2, t3, "unary", n2);
          var s2 = e2.substr(0, e2.length - n2.name.length);
          return xt(e2 = Ut(function (e3) {
            return Dt(i2, e3, s2);
          }, this.b).call(this, T(n2, t3, r3)), o2, false), new A(e2);
        }, Lt.prototype.M = function (e2, t3, r3, n2) {
          var o2 = this;
          n2 = R(e2, t3, "unary", n2);
          var i2 = e2.substr(0, e2.length - n2.name.length);
          return Ut(function (e3) {
            return new Promise(function (t4, r4) {
              var n3, s2, a3;
              xt(Dt(o2, e3, i2), function (o3, i3, l2, u2) {
                o3 ? r4(o3) : i3 ? a3 = i3 : l2 ? s2 = l2 : u2 ? n3 = u2 : (o3 = e3.getMethodDescriptor(), t4(new w(a3, o3, i3 = void 0 === (i3 = n3) ? {} : i3, void 0 === s2 ? null : s2)));
              }, true);
            });
          }, this.g).call(this, T(n2, t3, r3)).then(function (e3) {
            return e3.getResponseMessage();
          });
        }, Lt.prototype.unaryCall = function (e2, t3, r3, n2) {
          return this.M(e2, t3, r3, n2);
        }, Lt.prototype.R = function (e2, t3, r3, n2) {
          var o2 = this;
          n2 = R(e2, t3, "server_streaming", n2);
          var i2 = e2.substr(0, e2.length - n2.name.length);
          return Ut(function (e3) {
            return Dt(o2, e3, i2);
          }, this.b).call(this, T(n2, t3, r3));
        }, Lt.prototype.serverStreaming = Lt.prototype.R, Lt.prototype.unaryCall = Lt.prototype.unaryCall, Lt.prototype.thenableCall = Lt.prototype.M, Lt.prototype.rpcCall = Lt.prototype.P, e.exports.AbstractClientBase = {
          MethodInfo: function MethodInfo(e2, t3, r3, n2, o2) {
            this.name = n2, this.b = o2, this.f = e2, this.a = t3, this.c = r3;
          }
        }, e.exports.GrpcWebClientBase = Lt, e.exports.StatusCode = {
          OK: 0,
          CANCELLED: 1,
          UNKNOWN: 2,
          INVALID_ARGUMENT: 3,
          DEADLINE_EXCEEDED: 4,
          NOT_FOUND: 5,
          ALREADY_EXISTS: 6,
          PERMISSION_DENIED: 7,
          UNAUTHENTICATED: 16,
          RESOURCE_EXHAUSTED: 8,
          FAILED_PRECONDITION: 9,
          ABORTED: 10,
          OUT_OF_RANGE: 11,
          UNIMPLEMENTED: 12,
          INTERNAL: 13,
          UNAVAILABLE: 14,
          DATA_LOSS: 15
        }, e.exports.MethodDescriptor = E, e.exports.MethodType = {
          UNARY: "unary",
          SERVER_STREAMING: "server_streaming"
        };
      }).call(this, r(6));
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.isAsyncIterable = t.isAsyncGenerator = t.isAsync = void 0;
      var n,
        o = r(152),
        i = (n = o) && n.__esModule ? n : {
          default: n
        };
      function s(e2) {
        return "AsyncFunction" === e2[Symbol.toStringTag];
      }
      t.default = function (e2) {
        if ("function" != typeof e2) throw new Error("expected a function");
        return s(e2) ? (0, i.default)(e2) : e2;
      }, t.isAsync = s, t.isAsyncGenerator = function (e2) {
        return "AsyncGenerator" === e2[Symbol.toStringTag];
      }, t.isAsyncIterable = function (e2) {
        return "function" == typeof e2[Symbol.asyncIterator];
      };
    }, function (e, t, r) {
      var n = {};
      function o(e2, t2, r2) {
        r2 || (r2 = Error);
        var o2 = function (e3) {
          var r3, n2;
          function o3(r4, n3, o4) {
            return e3.call(this, function (e4, r5, n4) {
              return "string" == typeof t2 ? t2 : t2(e4, r5, n4);
            }(r4, n3, o4)) || this;
          }
          return n2 = e3, (r3 = o3).prototype = Object.create(n2.prototype), r3.prototype.constructor = r3, r3.__proto__ = n2, o3;
        }(r2);
        o2.prototype.name = r2.name, o2.prototype.code = e2, n[e2] = o2;
      }
      function i(e2, t2) {
        if (Array.isArray(e2)) {
          var r2 = e2.length;
          return e2 = e2.map(function (e3) {
            return String(e3);
          }), r2 > 2 ? "one of ".concat(t2, " ").concat(e2.slice(0, r2 - 1).join(", "), ", or ") + e2[r2 - 1] : 2 === r2 ? "one of ".concat(t2, " ").concat(e2[0], " or ").concat(e2[1]) : "of ".concat(t2, " ").concat(e2[0]);
        }
        return "of ".concat(t2, " ").concat(String(e2));
      }
      o("ERR_INVALID_OPT_VALUE", function (e2, t2) {
        return 'The value "' + t2 + '" is invalid for option "' + e2 + '"';
      }, TypeError), o("ERR_INVALID_ARG_TYPE", function (e2, t2, r2) {
        var n2, o2, a2;
        if ("string" == typeof t2 && (o2 = "not ", t2.substr(0, o2.length) === o2) ? (n2 = "must not be", t2 = t2.replace(/^not /, "")) : n2 = "must be", function (e3, t3, r3) {
          return (void 0 === r3 || r3 > e3.length) && (r3 = e3.length), e3.substring(r3 - t3.length, r3) === t3;
        }(e2, " argument")) a2 = "The ".concat(e2, " ").concat(n2, " ").concat(i(t2, "type"));else {
          var l = function (e3, t3, r3) {
            return "number" != typeof r3 && (r3 = 0), !(r3 + t3.length > e3.length) && -1 !== e3.indexOf(t3, r3);
          }(e2, ".") ? "property" : "argument";
          a2 = 'The "'.concat(e2, '" ').concat(l, " ").concat(n2, " ").concat(i(t2, "type"));
        }
        return a2 += ". Received type ".concat(typeof r2);
      }, TypeError), o("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), o("ERR_METHOD_NOT_IMPLEMENTED", function (e2) {
        return "The " + e2 + " method is not implemented";
      }), o("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), o("ERR_STREAM_DESTROYED", function (e2) {
        return "Cannot call " + e2 + " after a stream was destroyed";
      }), o("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), o("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), o("ERR_STREAM_WRITE_AFTER_END", "write after end"), o("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), o("ERR_UNKNOWN_ENCODING", function (e2) {
        return "Unknown encoding: " + e2;
      }, TypeError), o("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), e.exports.codes = n;
    }, function (e, t, r) {
      (function (t2) {
        var n = Object.keys || function (e2) {
          var t3 = [];
          for (var r2 in e2) t3.push(r2);
          return t3;
        };
        e.exports = u;
        var o = r(77),
          i = r(81);
        r(7)(u, o);
        for (var s = n(i.prototype), a2 = 0; a2 < s.length; a2++) {
          var l = s[a2];
          u.prototype[l] || (u.prototype[l] = i.prototype[l]);
        }
        function u(e2) {
          if (!(this instanceof u)) return new u(e2);
          o.call(this, e2), i.call(this, e2), this.allowHalfOpen = true, e2 && (false === e2.readable && (this.readable = false), false === e2.writable && (this.writable = false), false === e2.allowHalfOpen && (this.allowHalfOpen = false, this.once("end", g)));
        }
        function g() {
          this._writableState.ended || t2.nextTick(c, this);
        }
        function c(e2) {
          e2.end();
        }
        Object.defineProperty(u.prototype, "writableHighWaterMark", {
          enumerable: false,
          get: function get() {
            return this._writableState.highWaterMark;
          }
        }), Object.defineProperty(u.prototype, "writableBuffer", {
          enumerable: false,
          get: function get() {
            return this._writableState && this._writableState.getBuffer();
          }
        }), Object.defineProperty(u.prototype, "writableLength", {
          enumerable: false,
          get: function get() {
            return this._writableState.length;
          }
        }), Object.defineProperty(u.prototype, "destroyed", {
          enumerable: false,
          get: function get() {
            return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
          },
          set: function set(e2) {
            void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e2, this._writableState.destroyed = e2);
          }
        });
      }).call(this, r(2));
    }, function (e, t, r) {
      r.d(t, "a", function () {
        return s;
      });
      var n = r(40),
        o = r(4);
      var i = {
        "app-id": ["app-id must match formant/*"]
      };
      var s = /*#__PURE__*/function (_n$a) {
        _inherits(s, _n$a);
        function s(e2) {
          var _this3;
          var t2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          _classCallCheck(this, s);
          _this3 = _possibleConstructorReturn(this, _getPrototypeOf(s).call(this, e2, Object.assign({
            validateHeaders: function validateHeaders(e3) {
              return "".concat(e3.get("app-id")).startsWith("formant/") ? {} : i;
            }
          }, t2))), _this3.endpoint = e2;
          return _this3;
        }
        _createClass(s, [{
          key: "getHeaders",
          value: function getHeaders() {
            return Object.assign(Object.assign({}, s.headers), {
              "App-ID": "formant/".concat(o.a),
              "App-Version": o.j
            });
          }
        }]);
        return s;
      }(n.a);
      s.headers = {};
    }, function (e, t, r) {
      r(227), e.exports = {
        encode: function encode(e2) {
          return new TextEncoder().encode(e2);
        },
        decode: function decode(e2) {
          return new TextDecoder().decode(e2);
        }
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2) {
        var t2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e2.length;
        if (!t2) throw new Error("arity is undefined");
        return function () {
          var _this4 = this;
          for (var _len = arguments.length, r2 = new Array(_len), _key = 0; _key < _len; _key++) {
            r2[_key] = arguments[_key];
          }
          return "function" == typeof r2[t2 - 1] ? e2.apply(this, r2) : new Promise(function (n, o) {
            r2[t2 - 1] = function (e3) {
              if (e3) return o(e3);
              for (var _len2 = arguments.length, t3 = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                t3[_key2 - 1] = arguments[_key2];
              }
              n(t3.length > 1 ? t3 : t3[0]);
            }, e2.apply(_this4, r2);
          });
        };
      }, e.exports = t.default;
    }, function (e, t, r) {
      (t = e.exports = r(69)).Stream = t, t.Readable = t, t.Writable = r(48), t.Duplex = r(23), t.Transform = r(72), t.PassThrough = r(165);
    }, function (e, t, r) {
      (t = e.exports = r(77)).Stream = t, t.Readable = t, t.Writable = r(81), t.Duplex = r(27), t.Transform = r(82), t.PassThrough = r(184), t.finished = r(49), t.pipeline = r(185);
    }, function (e, t, r) {
      e.exports = function (e2) {
        return e2;
      };
    }, function (e, t, r) {
      r.d(t, "a", function () {
        return o;
      });
      var n = ["password", "secret", "token", "key", "buffer"];
      function o(e2) {
        var t2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /* @__PURE__ */new Set();
        return t2.has(e2) ? "[ RECURSIVE ]" : !(r2 = e2) || "object" != typeof r2 && "function" != typeof r2 ? e2 : (t2.add(e2), Object.keys(e2).reduce(function (r3, i) {
          return r3[i] = n.some(function (e3) {
            return i.toLowerCase().includes(e3.toLowerCase());
          }) ? "[ REDACTED ]" : o(e2[i], t2), r3;
        }, {}));
        var r2;
      }
    }, function (e, t) {
      e.exports = n, n.default = n, n.stable = i, n.stableStringify = i;
      var r = [];
      function n(e2, t2, n2) {
        !function e3(t3, n3, o3, i3) {
          var s;
          if ("object" == typeof t3 && null !== t3) {
            for (s = 0; s < o3.length; s++) if (o3[s] === t3) return i3[n3] = "[Circular]", void r.push([i3, n3, t3]);
            if (o3.push(t3), Array.isArray(t3)) for (s = 0; s < t3.length; s++) e3(t3[s], s, o3, t3);else {
              var a2 = Object.keys(t3);
              for (s = 0; s < a2.length; s++) {
                var l = a2[s];
                e3(t3[l], l, o3, t3);
              }
            }
            o3.pop();
          }
        }(e2, "", [], void 0);
        for (var o2 = JSON.stringify(e2, t2, n2); 0 !== r.length;) {
          var i2 = r.pop();
          i2[0][i2[1]] = i2[2];
        }
        return o2;
      }
      function o(e2, t2) {
        return e2 < t2 ? -1 : e2 > t2 ? 1 : 0;
      }
      function i(e2, t2, n2) {
        for (var i2 = function e3(t3, n3, i3, s2) {
            var a3;
            if ("object" == typeof t3 && null !== t3) {
              for (a3 = 0; a3 < i3.length; a3++) if (i3[a3] === t3) return s2[n3] = "[Circular]", void r.push([s2, n3, t3]);
              if ("function" == typeof t3.toJSON) return;
              if (i3.push(t3), Array.isArray(t3)) for (a3 = 0; a3 < t3.length; a3++) e3(t3[a3], a3, i3, t3);else {
                var l = {},
                  u = Object.keys(t3).sort(o);
                for (a3 = 0; a3 < u.length; a3++) {
                  var g = u[a3];
                  e3(t3[g], g, i3, t3), l[g] = t3[g];
                }
                if (void 0 === s2) return l;
                r.push([s2, n3, t3]), s2[n3] = l;
              }
              i3.pop();
            }
          }(e2, "", [], void 0) || e2, s = JSON.stringify(i2, t2, n2); 0 !== r.length;) {
          var a2 = r.pop();
          a2[0][a2[1]] = a2[2];
        }
        return s;
      }
    }, function (e, t, r) {
      var n = r(16),
        o = Object.keys || function (e2) {
          var t2 = [];
          for (var r2 in e2) t2.push(r2);
          return t2;
        };
      e.exports = c;
      var i = Object.create(r(17));
      i.inherits = r(7);
      var s = r(143),
        a2 = r(62);
      i.inherits(c, s);
      for (var l = o(a2.prototype), u = 0; u < l.length; u++) {
        var g = l[u];
        c.prototype[g] || (c.prototype[g] = a2.prototype[g]);
      }
      function c(e2) {
        if (!(this instanceof c)) return new c(e2);
        s.call(this, e2), a2.call(this, e2), e2 && false === e2.readable && (this.readable = false), e2 && false === e2.writable && (this.writable = false), this.allowHalfOpen = true, e2 && false === e2.allowHalfOpen && (this.allowHalfOpen = false), this.once("end", f);
      }
      function f() {
        this.allowHalfOpen || this._writableState.ended || n.nextTick(p, this);
      }
      function p(e2) {
        e2.end();
      }
      Object.defineProperty(c.prototype, "writableHighWaterMark", {
        enumerable: false,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), Object.defineProperty(c.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(e2) {
          void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e2, this._writableState.destroyed = e2);
        }
      }), c.prototype._destroy = function (e2, t2) {
        this.push(null), this.end(), n.nextTick(t2, e2);
      };
    }, function (e, t, r) {
      var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
      function o(e2, t2) {
        return Object.prototype.hasOwnProperty.call(e2, t2);
      }
      t.assign = function (e2) {
        for (var t2 = Array.prototype.slice.call(arguments, 1); t2.length;) {
          var r2 = t2.shift();
          if (r2) {
            if ("object" != typeof r2) throw new TypeError(r2 + "must be non-object");
            for (var n2 in r2) o(r2, n2) && (e2[n2] = r2[n2]);
          }
        }
        return e2;
      }, t.shrinkBuf = function (e2, t2) {
        return e2.length === t2 ? e2 : e2.subarray ? e2.subarray(0, t2) : (e2.length = t2, e2);
      };
      var i = {
          arraySet: function arraySet(e2, t2, r2, n2, o2) {
            if (t2.subarray && e2.subarray) e2.set(t2.subarray(r2, r2 + n2), o2);else for (var i2 = 0; i2 < n2; i2++) e2[o2 + i2] = t2[r2 + i2];
          },
          flattenChunks: function flattenChunks(e2) {
            var t2, r2, n2, o2, i2, s2;
            for (n2 = 0, t2 = 0, r2 = e2.length; t2 < r2; t2++) n2 += e2[t2].length;
            for (s2 = new Uint8Array(n2), o2 = 0, t2 = 0, r2 = e2.length; t2 < r2; t2++) i2 = e2[t2], s2.set(i2, o2), o2 += i2.length;
            return s2;
          }
        },
        s = {
          arraySet: function arraySet(e2, t2, r2, n2, o2) {
            for (var i2 = 0; i2 < n2; i2++) e2[o2 + i2] = t2[r2 + i2];
          },
          flattenChunks: function flattenChunks(e2) {
            return [].concat.apply([], e2);
          }
        };
      t.setTyped = function (e2) {
        e2 ? (t.Buf8 = Uint8Array, t.Buf16 = Uint16Array, t.Buf32 = Int32Array, t.assign(t, i)) : (t.Buf8 = Array, t.Buf16 = Array, t.Buf32 = Array, t.assign(t, s));
      }, t.setTyped(n);
    }, function (e, t, r) {
      e.exports = r(186);
    }, function (e, t, r) {
      r.d(t, "a", function () {
        return o;
      });
      var n = r(229);
      var o = Object(n.a)();
    }, function (e, t, r) {
      r.d(t, "a", function () {
        return m;
      });
      var n = r(1),
        o = r(100),
        i = r.n(o),
        s = r(101),
        a2 = r.n(s);
      var l = /*#__PURE__*/function (_Error2) {
        _inherits(l, _Error2);
        function l(e2, t2, r2) {
          var _this5;
          _classCallCheck(this, l);
          _this5 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, "Connection failure: ".concat(e2.message))), _this5.cause = e2, _this5.url = t2, _this5.retryable = r2;
          return _this5;
        }
        return l;
      }(_wrapNativeSuper(Error));
      var u = r(8),
        g = r(0),
        c = r(10),
        f = r(11);
      var p = /*#__PURE__*/function (_Error3) {
        _inherits(p, _Error3);
        function p(e2, t2) {
          var _this6;
          _classCallCheck(this, p);
          _this6 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "Invalid headers (".concat(JSON.stringify(e2), ") for response: ").concat(t2.message))), _this6.validationErrors = e2, _this6.responseError = t2;
          return _this6;
        }
        return p;
      }(_wrapNativeSuper(Error));
      var h = function h(e2, t2, r2, n2) {
          return new (r2 || (r2 = Promise))(function (o2, i2) {
            function s2(e3) {
              try {
                l2(n2.next(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function a3(e3) {
              try {
                l2(n2.throw(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function l2(e3) {
              var t3;
              e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
                e4(t3);
              })).then(s2, a3);
            }
            l2((n2 = n2.apply(e2, t2 || [])).next());
          });
        },
        d = function d(e2, t2) {
          var r2 = {};
          for (var n2 in e2) Object.prototype.hasOwnProperty.call(e2, n2) && t2.indexOf(n2) < 0 && (r2[n2] = e2[n2]);
          if (null != e2 && "function" == typeof Object.getOwnPropertySymbols) {
            var o2 = 0;
            for (n2 = Object.getOwnPropertySymbols(e2); o2 < n2.length; o2++) t2.indexOf(n2[o2]) < 0 && Object.prototype.propertyIsEnumerable.call(e2, n2[o2]) && (r2[n2[o2]] = e2[n2[o2]]);
          }
          return r2;
        };
      var y = /* @__PURE__ */new Set(["GET", "HEAD", "PUT", "QUERY", "DELETE", "OPTIONS", "TRACE"]);
      var m = /*#__PURE__*/function () {
        function m(e2) {
          var t2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          _classCallCheck(this, m);
          if (this.endpoint = e2, this.validateHeaders = function (e3) {
            return t2.validateHeaders ? t2.validateHeaders(e3) : {};
          }, this.verbose = false !== t2.verbose, void 0 !== t2.retries && !(t2.retries >= 0)) throw new Error("retries must be positive or zero");
          if (this.configuredRetries = t2.retries, void 0 !== t2.timeoutMs && !(t2.timeoutMs > 0)) throw new Error("timeoutMs must be positive");
          if (this.timeoutMs = t2.timeoutMs, void 0 !== t2.maxBackoffDelayMs && !(t2.maxBackoffDelayMs > 0)) throw new Error("maxBackoffDelayMs must be positive");
          this.maxBackoffDelayMs = t2.maxBackoffDelayMs || 30 * n.a.second;
        }
        _createClass(m, [{
          key: "getRetries",
          value: function getRetries() {
            return void 0 !== this.configuredRetries ? this.configuredRetries : this.getConstructor().retries;
          }
        }, {
          key: "getHeaders",
          value: function getHeaders() {
            return {};
          }
        }, {
          key: "fetch",
          value: function fetch(e2) {
            var t2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return h(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return this.fetchVerbose(e2, t2);
                  case 2:
                    return _context3.abrupt("return", _context3.sent.body);
                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3, this);
            }));
          }
        }, {
          key: "fetchVerbose",
          value: function fetchVerbose(e2) {
            var t2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return h(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
              var r2, o2, i2, s2, t3;
              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    r2 = 100 * n.a.millisecond, o2 = 0;
                    i2 = void 0 !== this.timeoutMs ? new Date().getTime() + this.timeoutMs : void 0, s2 = i2 ? function () {
                      return Math.max(i2 - new Date().getTime(), 0);
                    } : void 0;
                  case 2:
                    _context4.prev = 2;
                    _context4.next = 5;
                    return this.doFetch(e2, t2, s2);
                  case 5:
                    return _context4.abrupt("return", _context4.sent);
                  case 8:
                    _context4.prev = 8;
                    _context4.t0 = _context4["catch"](2);
                    t3 = Object(c.a)(_context4.t0, l);
                    if (!(0 === (null == s2 ? void 0 : s2()) || o2 === this.getRetries() || !t3.retryable)) {
                      _context4.next = 13;
                      break;
                    }
                    throw t3;
                  case 13:
                    o2++;
                    r2 = Math.min.apply(Math, _toConsumableArray(s2 ? [s2()] : []).concat([r2 * (2 + 0.1 * (Math.random() - 0.5)), this.maxBackoffDelayMs]));
                    _context4.next = 17;
                    return Object(u.a)(r2);
                  case 17:
                    this.verbose && g.a.warn("Connection failure, retrying. Error: ".concat(_context4.t0.cause.message), {
                      url: _context4.t0.url,
                      error: _context4.t0.cause,
                      attempt: o2
                    });
                  case 18:
                    _context4.next = 2;
                    break;
                  case 20:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4, this, [[2, 8]]);
            }));
          }
        }, {
          key: "doFetch",
          value: function doFetch(e2, t2, r2) {
            return h(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
              var o2, s2, u2, h2, m2, b, v, _, e3, _e2, t3, i2, l2, u3, c2, d2, _t2, r3, n2, o3;
              return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    o2 = t2.token, s2 = t2.json, u2 = t2.allowUnsafeRetries, h2 = d(t2, ["token", "json", "allowUnsafeRetries"]), m2 = (h2.method || "GET").toUpperCase(), b = void 0 !== this.endpoint ? "".concat(this.endpoint).concat(e2 ? "/".concat(e2) : "") : e2, v = new i.a();
                    if (r2) {
                      e3 = r2();
                      e3 > 0 ? _ = setTimeout(function () {
                        v.abort();
                      }, e3) : v.abort();
                    }
                    _context5.prev = 2;
                    _context5.next = 5;
                    return Promise.race([this.getConstructor().waitForConnectivity(), new Promise(function (t4) {
                      _e2 = setTimeout(t4, r2 ? Math.min(n.a.minute, r2()) : n.a.minute);
                    })]);
                  case 5:
                    _e2 && clearTimeout(_e2);
                    _context5.next = 8;
                    return a2()(b, Object.assign(Object.assign({}, h2), {
                      headers: Object.assign(Object.assign(Object.assign(Object.assign({}, false !== s2 ? {
                        "Content-Type": "application/json"
                      } : {}), this.getHeaders()), h2.headers || {}), void 0 !== o2 ? {
                        Authorization: "Bearer ".concat(o2)
                      } : {}),
                      signal: v.signal
                    }));
                  case 8:
                    t3 = _context5.sent;
                    i2 = t3.headers.get("content-type") || "";
                    l2 = i2 && i2.startsWith("application/json");
                    if (!l2) {
                      _context5.next = 17;
                      break;
                    }
                    _context5.next = 14;
                    return t3.json();
                  case 14:
                    _context5.t0 = _context5.sent;
                    _context5.next = 20;
                    break;
                  case 17:
                    _context5.next = 19;
                    return t3.text();
                  case 19:
                    _context5.t0 = _context5.sent;
                  case 20:
                    u3 = _context5.t0;
                    c2 = function c2() {
                      return new f.a(m2, b, t3.status, u3, u3 && u3.validationErrors || {}, t3.headers);
                    };
                    if (t3.ok) {
                      _context5.next = 24;
                      break;
                    }
                    throw this.verbose && g.a[t3.status >= 500 ? "warn" : "info"]("Response error", {
                      method: m2,
                      url: b,
                      statusCode: t3.status
                    }), c2();
                  case 24:
                    d2 = this.validateHeaders(t3.headers);
                    if (!(0 !== Object.keys(d2).length)) {
                      _context5.next = 27;
                      break;
                    }
                    throw new p(d2, c2());
                  case 27:
                    if (!(204 === t3.status)) {
                      _context5.next = 29;
                      break;
                    }
                    return _context5.abrupt("return", {
                      body: void 0,
                      headers: t3.headers
                    });
                  case 29:
                    if (!(s2 && !l2)) {
                      _context5.next = 31;
                      break;
                    }
                    throw new Error("Response is not JSON: ".concat(JSON.stringify(u3)));
                  case 31:
                    return _context5.abrupt("return", {
                      body: u3,
                      headers: t3.headers
                    });
                  case 34:
                    _context5.prev = 34;
                    _context5.t1 = _context5["catch"](2);
                    _t2 = u2 || y.has(m2);
                    if (!("Network request failed" === _context5.t1.message)) {
                      _context5.next = 39;
                      break;
                    }
                    throw new l(_context5.t1, b, _t2);
                  case 39:
                    if (!("system" === _context5.t1.type && ["EAI_AGAIN", "ECONNREFUSED", "EHOSTUNREACH", "ENOTFOUND"].find(function (t4) {
                      return t4 === _context5.t1.code;
                    }))) {
                      _context5.next = 41;
                      break;
                    }
                    throw new l(_context5.t1, b, true);
                  case 41:
                    if (!("system" === _context5.t1.type && ["ETIMEDOUT", "ECONNRESET", "ESOCKETTIMEDOUT", "EPIPE"].find(function (t4) {
                      return t4 === _context5.t1.code;
                    }))) {
                      _context5.next = 43;
                      break;
                    }
                    throw new l(_context5.t1, b, _t2);
                  case 43:
                    if (!("AbortError" === _context5.t1.name)) {
                      _context5.next = 45;
                      break;
                    }
                    throw new l(_context5.t1, b, _t2);
                  case 45:
                    r3 = Object(c.a)(_context5.t1, f.a), n2 = r3.statusCode;
                    if (!(408 === n2 || 429 === n2 || 502 === n2 || 503 === n2 || 504 === n2)) {
                      _context5.next = 48;
                      break;
                    }
                    throw this.verbose && !_t2 && g.a.warn("Potentially unsafe retry"), new l(_context5.t1, b, true);
                  case 48:
                    o3 = this.validateHeaders(r3.headers);
                    if (!(0 !== Object.keys(o3).length)) {
                      _context5.next = 51;
                      break;
                    }
                    throw new p(o3, r3);
                  case 51:
                    _context5.next = 53;
                    return this.getConstructor().onResponseError(r3);
                  case 53:
                    throw _context5.t1;
                  case 54:
                    _context5.prev = 54;
                    _ && clearTimeout(_);
                    return _context5.finish(54);
                  case 57:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5, this, [[2, 34, 54, 57]]);
            }));
          }
        }, {
          key: "getConstructor",
          value: function getConstructor() {
            return Object.getPrototypeOf(this).constructor;
          }
        }]);
        return m;
      }();
      m.retries = 8, m.waitForConnectivity = function () {
        return h(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
      }, m.onResponseError = function () {
        return h(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
      };
    }, function (e, t, r) {
      function n(e2, t2) {
        if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
      }
      function o(e2, t2) {
        for (var r2 = 0; r2 < t2.length; r2++) {
          var n2 = t2[r2];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
        }
      }
      var i = r(59),
        s = r(3),
        a2 = s.LEVEL,
        l = s.MESSAGE;
      i.enabled = true;
      var u = /\s+/,
        g = function () {
          function e2() {
            var t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            n(this, e2), t3.colors && this.addColors(t3.colors), this.options = t3;
          }
          var t2, r2, s2;
          return t2 = e2, s2 = [{
            key: "addColors",
            value: function value(t3) {
              var r3 = Object.keys(t3).reduce(function (e3, r4) {
                return e3[r4] = u.test(t3[r4]) ? t3[r4].split(u) : t3[r4], e3;
              }, {});
              return e2.allColors = Object.assign({}, e2.allColors || {}, r3), e2.allColors;
            }
          }], (r2 = [{
            key: "addColors",
            value: function value(t3) {
              return e2.addColors(t3);
            }
          }, {
            key: "colorize",
            value: function value(t3, r3, n2) {
              if (void 0 === n2 && (n2 = r3), !Array.isArray(e2.allColors[t3])) return i[e2.allColors[t3]](n2);
              for (var o2 = 0, s3 = e2.allColors[t3].length; o2 < s3; o2++) n2 = i[e2.allColors[t3][o2]](n2);
              return n2;
            }
          }, {
            key: "transform",
            value: function value(e3, t3) {
              return t3.all && "string" == typeof e3[l] && (e3[l] = this.colorize(e3[a2], e3.level, e3[l])), (t3.level || t3.all || !t3.message) && (e3.level = this.colorize(e3[a2], e3.level)), (t3.all || t3.message) && (e3.message = this.colorize(e3[a2], e3.level, e3.message)), e3;
            }
          }]) && o(t2.prototype, r2), s2 && o(t2, s2), e2;
        }();
      e.exports = function (e2) {
        return new g(e2);
      }, e.exports.Colorizer = e.exports.Format = g;
    }, function (e, t) {
      var r = {}.toString;
      e.exports = Array.isArray || function (e2) {
        return "[object Array]" == r.call(e2);
      };
    }, function (e, t, r) {
      (function (t2) {
        function r2(e2) {
          try {
            if (!t2.localStorage) return false;
          } catch (e3) {
            return false;
          }
          var r3 = t2.localStorage[e2];
          return null != r3 && "true" === String(r3).toLowerCase();
        }
        e.exports = function (e2, t3) {
          if (r2("noDeprecation")) return e2;
          var n = false;
          return function () {
            if (!n) {
              if (r2("throwDeprecation")) throw new Error(t3);
              r2("traceDeprecation") ? console.trace(t3) : console.warn(t3), n = true;
            }
            return e2.apply(this, arguments);
          };
        };
      }).call(this, r(6));
    }, function (e, t, r) {
      var n = r(5),
        o = n.Buffer;
      function i(e2, t2) {
        for (var r2 in e2) t2[r2] = e2[r2];
      }
      function s(e2, t2, r2) {
        return o(e2, t2, r2);
      }
      o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? e.exports = n : (i(n, t), t.Buffer = s), i(o, s), s.from = function (e2, t2, r2) {
        if ("number" == typeof e2) throw new TypeError("Argument must not be a number");
        return o(e2, t2, r2);
      }, s.alloc = function (e2, t2, r2) {
        if ("number" != typeof e2) throw new TypeError("Argument must be a number");
        var n2 = o(e2);
        return void 0 !== t2 ? "string" == typeof r2 ? n2.fill(t2, r2) : n2.fill(t2) : n2.fill(0), n2;
      }, s.allocUnsafe = function (e2) {
        if ("number" != typeof e2) throw new TypeError("Argument must be a number");
        return o(e2);
      }, s.allocUnsafeSlow = function (e2) {
        if ("number" != typeof e2) throw new TypeError("Argument must be a number");
        return n.SlowBuffer(e2);
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2) {
        return e2 && "number" == typeof e2.length && e2.length >= 0 && e2.length % 1 == 0;
      }, e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      });
      t.default = {}, e.exports = t.default;
    }, function (e, t, r) {
      var n = r(5),
        o = n.Buffer;
      function i(e2, t2) {
        for (var r2 in e2) t2[r2] = e2[r2];
      }
      function s(e2, t2, r2) {
        return o(e2, t2, r2);
      }
      o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? e.exports = n : (i(n, t), t.Buffer = s), i(o, s), s.from = function (e2, t2, r2) {
        if ("number" == typeof e2) throw new TypeError("Argument must not be a number");
        return o(e2, t2, r2);
      }, s.alloc = function (e2, t2, r2) {
        if ("number" != typeof e2) throw new TypeError("Argument must be a number");
        var n2 = o(e2);
        return void 0 !== t2 ? "string" == typeof r2 ? n2.fill(t2, r2) : n2.fill(t2) : n2.fill(0), n2;
      }, s.allocUnsafe = function (e2) {
        if ("number" != typeof e2) throw new TypeError("Argument must be a number");
        return o(e2);
      }, s.allocUnsafeSlow = function (e2) {
        if ("number" != typeof e2) throw new TypeError("Argument must be a number");
        return n.SlowBuffer(e2);
      };
    }, function (e, t, r) {
      (function (t2, n, o) {
        var i = r(16);
        function s(e2) {
          var t3 = this;
          this.next = null, this.entry = null, this.finish = function () {
            !function (e3, t4, r2) {
              var n2 = e3.entry;
              e3.entry = null;
              for (; n2;) {
                var o2 = n2.callback;
                t4.pendingcb--, o2(r2), n2 = n2.next;
              }
              t4.corkedRequestsFree ? t4.corkedRequestsFree.next = e3 : t4.corkedRequestsFree = e3;
            }(t3, e2);
          };
        }
        e.exports = b;
        var a2,
          l = !t2.browser && ["v0.10", "v0.9."].indexOf(t2.version.slice(0, 5)) > -1 ? n : i.nextTick;
        b.WritableState = m;
        var u = r(17);
        u.inherits = r(7);
        var g = {
            deprecate: r(43)
          },
          c = r(70),
          f = r(47).Buffer,
          p = o.Uint8Array || function () {};
        var h,
          d = r(71);
        function y() {}
        function m(e2, t3) {
          a2 = a2 || r(23), e2 = e2 || {};
          var n2 = t3 instanceof a2;
          this.objectMode = !!e2.objectMode, n2 && (this.objectMode = this.objectMode || !!e2.writableObjectMode);
          var o2 = e2.highWaterMark,
            u2 = e2.writableHighWaterMark,
            g2 = this.objectMode ? 16 : 16384;
          this.highWaterMark = o2 || 0 === o2 ? o2 : n2 && (u2 || 0 === u2) ? u2 : g2, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = false, this.needDrain = false, this.ending = false, this.ended = false, this.finished = false, this.destroyed = false;
          var c2 = false === e2.decodeStrings;
          this.decodeStrings = !c2, this.defaultEncoding = e2.defaultEncoding || "utf8", this.length = 0, this.writing = false, this.corked = 0, this.sync = true, this.bufferProcessing = false, this.onwrite = function (e3) {
            !function (e4, t4) {
              var r2 = e4._writableState,
                n3 = r2.sync,
                o3 = r2.writecb;
              if (function (e5) {
                e5.writing = false, e5.writecb = null, e5.length -= e5.writelen, e5.writelen = 0;
              }(r2), t4) !function (e5, t5, r3, n4, o4) {
                --t5.pendingcb, r3 ? (i.nextTick(o4, n4), i.nextTick(T, e5, t5), e5._writableState.errorEmitted = true, e5.emit("error", n4)) : (o4(n4), e5._writableState.errorEmitted = true, e5.emit("error", n4), T(e5, t5));
              }(e4, r2, n3, t4, o3);else {
                var s2 = w(r2);
                s2 || r2.corked || r2.bufferProcessing || !r2.bufferedRequest || S(e4, r2), n3 ? l(_, e4, r2, s2, o3) : _(e4, r2, s2, o3);
              }
            }(t3, e3);
          }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = false, this.errorEmitted = false, this.bufferedRequestCount = 0, this.corkedRequestsFree = new s(this);
        }
        function b(e2) {
          if (a2 = a2 || r(23), !(h.call(b, this) || this instanceof a2)) return new b(e2);
          this._writableState = new m(e2, this), this.writable = true, e2 && ("function" == typeof e2.write && (this._write = e2.write), "function" == typeof e2.writev && (this._writev = e2.writev), "function" == typeof e2.destroy && (this._destroy = e2.destroy), "function" == typeof e2.final && (this._final = e2.final)), c.call(this);
        }
        function v(e2, t3, r2, n2, o2, i2, s2) {
          t3.writelen = n2, t3.writecb = s2, t3.writing = true, t3.sync = true, r2 ? e2._writev(o2, t3.onwrite) : e2._write(o2, i2, t3.onwrite), t3.sync = false;
        }
        function _(e2, t3, r2, n2) {
          r2 || function (e3, t4) {
            0 === t4.length && t4.needDrain && (t4.needDrain = false, e3.emit("drain"));
          }(e2, t3), t3.pendingcb--, n2(), T(e2, t3);
        }
        function S(e2, t3) {
          t3.bufferProcessing = true;
          var r2 = t3.bufferedRequest;
          if (e2._writev && r2 && r2.next) {
            var n2 = t3.bufferedRequestCount,
              o2 = new Array(n2),
              i2 = t3.corkedRequestsFree;
            i2.entry = r2;
            for (var a3 = 0, l2 = true; r2;) o2[a3] = r2, r2.isBuf || (l2 = false), r2 = r2.next, a3 += 1;
            o2.allBuffers = l2, v(e2, t3, true, t3.length, o2, "", i2.finish), t3.pendingcb++, t3.lastBufferedRequest = null, i2.next ? (t3.corkedRequestsFree = i2.next, i2.next = null) : t3.corkedRequestsFree = new s(t3), t3.bufferedRequestCount = 0;
          } else {
            for (; r2;) {
              var u2 = r2.chunk,
                g2 = r2.encoding,
                c2 = r2.callback;
              if (v(e2, t3, false, t3.objectMode ? 1 : u2.length, u2, g2, c2), r2 = r2.next, t3.bufferedRequestCount--, t3.writing) break;
            }
            null === r2 && (t3.lastBufferedRequest = null);
          }
          t3.bufferedRequest = r2, t3.bufferProcessing = false;
        }
        function w(e2) {
          return e2.ending && 0 === e2.length && null === e2.bufferedRequest && !e2.finished && !e2.writing;
        }
        function E(e2, t3) {
          e2._final(function (r2) {
            t3.pendingcb--, r2 && e2.emit("error", r2), t3.prefinished = true, e2.emit("prefinish"), T(e2, t3);
          });
        }
        function T(e2, t3) {
          var r2 = w(t3);
          return r2 && (!function (e3, t4) {
            t4.prefinished || t4.finalCalled || ("function" == typeof e3._final ? (t4.pendingcb++, t4.finalCalled = true, i.nextTick(E, e3, t4)) : (t4.prefinished = true, e3.emit("prefinish")));
          }(e2, t3), 0 === t3.pendingcb && (t3.finished = true, e2.emit("finish"))), r2;
        }
        u.inherits(b, c), m.prototype.getBuffer = function () {
          for (var e2 = this.bufferedRequest, t3 = []; e2;) t3.push(e2), e2 = e2.next;
          return t3;
        }, function () {
          try {
            Object.defineProperty(m.prototype, "buffer", {
              get: g.deprecate(function () {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
            });
          } catch (e2) {}
        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (h = Function.prototype[Symbol.hasInstance], Object.defineProperty(b, Symbol.hasInstance, {
          value: function value(e2) {
            return !!h.call(this, e2) || this === b && e2 && e2._writableState instanceof m;
          }
        })) : h = function h(e2) {
          return e2 instanceof this;
        }, b.prototype.pipe = function () {
          this.emit("error", new Error("Cannot pipe, not readable"));
        }, b.prototype.write = function (e2, t3, r2) {
          var n2,
            o2 = this._writableState,
            s2 = false,
            a3 = !o2.objectMode && (n2 = e2, f.isBuffer(n2) || n2 instanceof p);
          return a3 && !f.isBuffer(e2) && (e2 = function (e3) {
            return f.from(e3);
          }(e2)), "function" == typeof t3 && (r2 = t3, t3 = null), a3 ? t3 = "buffer" : t3 || (t3 = o2.defaultEncoding), "function" != typeof r2 && (r2 = y), o2.ended ? function (e3, t4) {
            var r3 = new Error("write after end");
            e3.emit("error", r3), i.nextTick(t4, r3);
          }(this, r2) : (a3 || function (e3, t4, r3, n3) {
            var o3 = true,
              s3 = false;
            return null === r3 ? s3 = new TypeError("May not write null values to stream") : "string" == typeof r3 || void 0 === r3 || t4.objectMode || (s3 = new TypeError("Invalid non-string/buffer chunk")), s3 && (e3.emit("error", s3), i.nextTick(n3, s3), o3 = false), o3;
          }(this, o2, e2, r2)) && (o2.pendingcb++, s2 = function (e3, t4, r3, n3, o3, i2) {
            if (!r3) {
              var s3 = function (e4, t5, r4) {
                e4.objectMode || false === e4.decodeStrings || "string" != typeof t5 || (t5 = f.from(t5, r4));
                return t5;
              }(t4, n3, o3);
              n3 !== s3 && (r3 = true, o3 = "buffer", n3 = s3);
            }
            var a4 = t4.objectMode ? 1 : n3.length;
            t4.length += a4;
            var l2 = t4.length < t4.highWaterMark;
            l2 || (t4.needDrain = true);
            if (t4.writing || t4.corked) {
              var u2 = t4.lastBufferedRequest;
              t4.lastBufferedRequest = {
                chunk: n3,
                encoding: o3,
                isBuf: r3,
                callback: i2,
                next: null
              }, u2 ? u2.next = t4.lastBufferedRequest : t4.bufferedRequest = t4.lastBufferedRequest, t4.bufferedRequestCount += 1;
            } else v(e3, t4, false, a4, n3, o3, i2);
            return l2;
          }(this, o2, a3, e2, t3, r2)), s2;
        }, b.prototype.cork = function () {
          this._writableState.corked++;
        }, b.prototype.uncork = function () {
          var e2 = this._writableState;
          e2.corked && (e2.corked--, e2.writing || e2.corked || e2.finished || e2.bufferProcessing || !e2.bufferedRequest || S(this, e2));
        }, b.prototype.setDefaultEncoding = function (e2) {
          if ("string" == typeof e2 && (e2 = e2.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e2 + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e2);
          return this._writableState.defaultEncoding = e2, this;
        }, Object.defineProperty(b.prototype, "writableHighWaterMark", {
          enumerable: false,
          get: function get() {
            return this._writableState.highWaterMark;
          }
        }), b.prototype._write = function (e2, t3, r2) {
          r2(new Error("_write() is not implemented"));
        }, b.prototype._writev = null, b.prototype.end = function (e2, t3, r2) {
          var n2 = this._writableState;
          "function" == typeof e2 ? (r2 = e2, e2 = null, t3 = null) : "function" == typeof t3 && (r2 = t3, t3 = null), null != e2 && this.write(e2, t3), n2.corked && (n2.corked = 1, this.uncork()), n2.ending || n2.finished || function (e3, t4, r3) {
            t4.ending = true, T(e3, t4), r3 && (t4.finished ? i.nextTick(r3) : e3.once("finish", r3));
            t4.ended = true, e3.writable = false;
          }(this, n2, r2);
        }, Object.defineProperty(b.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._writableState && this._writableState.destroyed;
          },
          set: function set(e2) {
            this._writableState && (this._writableState.destroyed = e2);
          }
        }), b.prototype.destroy = d.destroy, b.prototype._undestroy = d.undestroy, b.prototype._destroy = function (e2, t3) {
          this.end(), t3(e2);
        };
      }).call(this, r(2), r(15).setImmediate, r(6));
    }, function (e, t, r) {
      var n = r(26).codes.ERR_STREAM_PREMATURE_CLOSE;
      function o() {}
      e.exports = function e2(t2, r2, i) {
        if ("function" == typeof r2) return e2(t2, null, r2);
        r2 || (r2 = {}), i = function (e3) {
          var t3 = false;
          return function () {
            if (!t3) {
              t3 = true;
              for (var r3 = arguments.length, n2 = new Array(r3), o2 = 0; o2 < r3; o2++) n2[o2] = arguments[o2];
              e3.apply(this, n2);
            }
          };
        }(i || o);
        var s = r2.readable || false !== r2.readable && t2.readable,
          a2 = r2.writable || false !== r2.writable && t2.writable,
          l = function l() {
            t2.writable || g();
          },
          u = t2._writableState && t2._writableState.finished,
          g = function g() {
            a2 = false, u = true, s || i.call(t2);
          },
          c = t2._readableState && t2._readableState.endEmitted,
          f = function f() {
            s = false, c = true, a2 || i.call(t2);
          },
          p = function p(e3) {
            i.call(t2, e3);
          },
          h = function h() {
            var e3;
            return s && !c ? (t2._readableState && t2._readableState.ended || (e3 = new n()), i.call(t2, e3)) : a2 && !u ? (t2._writableState && t2._writableState.ended || (e3 = new n()), i.call(t2, e3)) : void 0;
          },
          d = function d() {
            t2.req.on("finish", g);
          };
        return !function (e3) {
          return e3.setHeader && "function" == typeof e3.abort;
        }(t2) ? a2 && !t2._writableState && (t2.on("end", l), t2.on("close", l)) : (t2.on("complete", g), t2.on("abort", h), t2.req ? d() : t2.on("request", d)), t2.on("end", f), t2.on("finish", g), false !== r2.error && t2.on("error", p), t2.on("close", h), function () {
          t2.removeListener("complete", g), t2.removeListener("abort", h), t2.removeListener("request", d), t2.req && t2.req.removeListener("finish", g), t2.removeListener("end", l), t2.removeListener("close", l), t2.removeListener("finish", g), t2.removeListener("end", f), t2.removeListener("error", p), t2.removeListener("close", h);
        };
      };
    }, function (e, t, r) {
      var n = r(58),
        o = r(3).configs;
      t.cli = n.levels(o.cli), t.npm = n.levels(o.npm), t.syslog = n.levels(o.syslog), t.addColors = n.levels;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      });
      var n = a2(r(203)),
        o = a2(r(204)),
        i = a2(r(25)),
        s = a2(r(30));
      function a2(e2) {
        return e2 && e2.__esModule ? e2 : {
          default: e2
        };
      }
      t.default = (0, s.default)(function (e2, t2, r2) {
        return (0, n.default)(e2, (0, o.default)((0, i.default)(t2)), r2);
      }, 3), e.exports = t.default;
    }, function (e, t, r) {
      var n = /*#__PURE__*/function (_Error4) {
        _inherits(n, _Error4);
        function n(e2) {
          var _getPrototypeOf2;
          var _this7;
          _classCallCheck(this, n);
          for (var _len3 = arguments.length, t2 = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            t2[_key3 - 1] = arguments[_key3];
          }
          _this7 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(n)).call.apply(_getPrototypeOf2, [this, "env-var: ".concat(e2)].concat(t2))), Error.captureStackTrace && Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this7)), n), _this7.name = "EnvVarError";
          return _this7;
        }
        return n;
      }(_wrapNativeSuper(Error));
      e.exports = n;
    }, function (e, t, r) {
      e.exports = function (e2) {
        var t2 = parseInt(e2, 10);
        if (isNaN(t2) || t2.toString(10) !== e2) throw new Error("should be a valid integer");
        return t2;
      };
    }, function (e, t, r) {
      e.exports = function (e2) {
        var t2 = parseFloat(e2);
        if (isNaN(t2) || t2.toString() !== e2) throw new Error("should be a valid float");
        return t2;
      };
    }, function (e, t, r) {
      e.exports = function (e2) {
        try {
          return JSON.parse(e2);
        } catch (e3) {
          throw new Error("should be valid (parseable) JSON");
        }
      };
    }, function (e, t, r) {
      (function (e2) {
        function r2(e3, t2) {
          for (var r3 = 0, n2 = e3.length - 1; n2 >= 0; n2--) {
            var o2 = e3[n2];
            "." === o2 ? e3.splice(n2, 1) : ".." === o2 ? (e3.splice(n2, 1), r3++) : r3 && (e3.splice(n2, 1), r3--);
          }
          if (t2) for (; r3--; r3) e3.unshift("..");
          return e3;
        }
        function n(e3, t2) {
          if (e3.filter) return e3.filter(t2);
          for (var r3 = [], n2 = 0; n2 < e3.length; n2++) t2(e3[n2], n2, e3) && r3.push(e3[n2]);
          return r3;
        }
        t.resolve = function () {
          for (var t2 = "", o2 = false, i = arguments.length - 1; i >= -1 && !o2; i--) {
            var s = i >= 0 ? arguments[i] : e2.cwd();
            if ("string" != typeof s) throw new TypeError("Arguments to path.resolve must be strings");
            s && (t2 = s + "/" + t2, o2 = "/" === s.charAt(0));
          }
          return (o2 ? "/" : "") + (t2 = r2(n(t2.split("/"), function (e3) {
            return !!e3;
          }), !o2).join("/")) || ".";
        }, t.normalize = function (e3) {
          var i = t.isAbsolute(e3),
            s = "/" === o(e3, -1);
          return (e3 = r2(n(e3.split("/"), function (e4) {
            return !!e4;
          }), !i).join("/")) || i || (e3 = "."), e3 && s && (e3 += "/"), (i ? "/" : "") + e3;
        }, t.isAbsolute = function (e3) {
          return "/" === e3.charAt(0);
        }, t.join = function () {
          var e3 = Array.prototype.slice.call(arguments, 0);
          return t.normalize(n(e3, function (e4, t2) {
            if ("string" != typeof e4) throw new TypeError("Arguments to path.join must be strings");
            return e4;
          }).join("/"));
        }, t.relative = function (e3, r3) {
          function n2(e4) {
            for (var t2 = 0; t2 < e4.length && "" === e4[t2]; t2++);
            for (var r4 = e4.length - 1; r4 >= 0 && "" === e4[r4]; r4--);
            return t2 > r4 ? [] : e4.slice(t2, r4 - t2 + 1);
          }
          e3 = t.resolve(e3).substr(1), r3 = t.resolve(r3).substr(1);
          for (var o2 = n2(e3.split("/")), i = n2(r3.split("/")), s = Math.min(o2.length, i.length), a2 = s, l = 0; l < s; l++) if (o2[l] !== i[l]) {
            a2 = l;
            break;
          }
          var u = [];
          for (l = a2; l < o2.length; l++) u.push("..");
          return (u = u.concat(i.slice(a2))).join("/");
        }, t.sep = "/", t.delimiter = ":", t.dirname = function (e3) {
          if ("string" != typeof e3 && (e3 += ""), 0 === e3.length) return ".";
          for (var t2 = e3.charCodeAt(0), r3 = 47 === t2, n2 = -1, o2 = true, i = e3.length - 1; i >= 1; --i) if (47 === (t2 = e3.charCodeAt(i))) {
            if (!o2) {
              n2 = i;
              break;
            }
          } else o2 = false;
          return -1 === n2 ? r3 ? "/" : "." : r3 && 1 === n2 ? "/" : e3.slice(0, n2);
        }, t.basename = function (e3, t2) {
          var r3 = function (e4) {
            "string" != typeof e4 && (e4 += "");
            var t3,
              r4 = 0,
              n2 = -1,
              o2 = true;
            for (t3 = e4.length - 1; t3 >= 0; --t3) if (47 === e4.charCodeAt(t3)) {
              if (!o2) {
                r4 = t3 + 1;
                break;
              }
            } else -1 === n2 && (o2 = false, n2 = t3 + 1);
            return -1 === n2 ? "" : e4.slice(r4, n2);
          }(e3);
          return t2 && r3.substr(-1 * t2.length) === t2 && (r3 = r3.substr(0, r3.length - t2.length)), r3;
        }, t.extname = function (e3) {
          "string" != typeof e3 && (e3 += "");
          for (var t2 = -1, r3 = 0, n2 = -1, o2 = true, i = 0, s = e3.length - 1; s >= 0; --s) {
            var a2 = e3.charCodeAt(s);
            if (47 !== a2) -1 === n2 && (o2 = false, n2 = s + 1), 46 === a2 ? -1 === t2 ? t2 = s : 1 !== i && (i = 1) : -1 !== t2 && (i = -1);else if (!o2) {
              r3 = s + 1;
              break;
            }
          }
          return -1 === t2 || -1 === n2 || 0 === i || 1 === i && t2 === n2 - 1 && t2 === r3 + 1 ? "" : e3.slice(t2, n2);
        };
        var o = "b" === "ab".substr(-1) ? function (e3, t2, r3) {
          return e3.substr(t2, r3);
        } : function (e3, t2, r3) {
          return t2 < 0 && (t2 = e3.length + t2), e3.substr(t2, r3);
        };
      }).call(this, r(2));
    },, function (e, t, r) {
      var n = t.format = r(12);
      t.levels = r(105), Object.defineProperty(n, "align", {
        value: r(122)
      }), Object.defineProperty(n, "cli", {
        value: r(123)
      }), Object.defineProperty(n, "combine", {
        value: r(124)
      }), Object.defineProperty(n, "colorize", {
        value: r(41)
      }), Object.defineProperty(n, "json", {
        value: r(125)
      }), Object.defineProperty(n, "label", {
        value: r(128)
      }), Object.defineProperty(n, "logstash", {
        value: r(129)
      }), Object.defineProperty(n, "metadata", {
        value: r(130)
      }), Object.defineProperty(n, "padLevels", {
        value: r(60)
      }), Object.defineProperty(n, "prettyPrint", {
        value: r(131)
      }), Object.defineProperty(n, "printf", {
        value: r(132)
      }), Object.defineProperty(n, "simple", {
        value: r(133)
      }), Object.defineProperty(n, "splat", {
        value: r(134)
      }), Object.defineProperty(n, "timestamp", {
        value: r(135)
      }), Object.defineProperty(n, "uncolorize", {
        value: r(137)
      });
    }, function (e, t, r) {
      var n = r(106);
      e.exports = n;
    }, function (e, t, r) {
      function n(e2) {
        return function (e3) {
          if (Array.isArray(e3)) return o(e3);
        }(e2) || function (e3) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(e3)) return Array.from(e3);
        }(e2) || function (e3, t2) {
          if (!e3) return;
          if ("string" == typeof e3) return o(e3, t2);
          var r2 = Object.prototype.toString.call(e3).slice(8, -1);
          "Object" === r2 && e3.constructor && (r2 = e3.constructor.name);
          if ("Map" === r2 || "Set" === r2) return Array.from(e3);
          if ("Arguments" === r2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r2)) return o(e3, t2);
        }(e2) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function o(e2, t2) {
        (null == t2 || t2 > e2.length) && (t2 = e2.length);
        for (var r2 = 0, n2 = new Array(t2); r2 < t2; r2++) n2[r2] = e2[r2];
        return n2;
      }
      function i(e2, t2) {
        if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
      }
      function s(e2, t2) {
        for (var r2 = 0; r2 < t2.length; r2++) {
          var n2 = t2[r2];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
        }
      }
      var a2 = r(3),
        l = a2.configs,
        u = a2.LEVEL,
        g = a2.MESSAGE,
        c = function () {
          function e2() {
            var t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              levels: l.npm.levels
            };
            i(this, e2), this.paddings = e2.paddingForLevels(t3.levels, t3.filler), this.options = t3;
          }
          var t2, r2, o2;
          return t2 = e2, o2 = [{
            key: "getLongestLevel",
            value: function value(e3) {
              var t3 = Object.keys(e3).map(function (e4) {
                return e4.length;
              });
              return Math.max.apply(Math, n(t3));
            }
          }, {
            key: "paddingForLevel",
            value: function value(e3, t3, r3) {
              var n2 = r3 + 1 - e3.length,
                o3 = Math.floor(n2 / t3.length);
              return "".concat(t3).concat(t3.repeat(o3)).slice(0, n2);
            }
          }, {
            key: "paddingForLevels",
            value: function value(t3) {
              var r3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ",
                n2 = e2.getLongestLevel(t3);
              return Object.keys(t3).reduce(function (t4, o3) {
                return t4[o3] = e2.paddingForLevel(o3, r3, n2), t4;
              }, {});
            }
          }], (r2 = [{
            key: "transform",
            value: function value(e3, t3) {
              return e3.message = "".concat(this.paddings[e3[u]]).concat(e3.message), e3[g] && (e3[g] = "".concat(this.paddings[e3[u]]).concat(e3[g])), e3;
            }
          }]) && s(t2.prototype, r2), o2 && s(t2, o2), e2;
        }();
      e.exports = function (e2) {
        return new c(e2);
      }, e.exports.Padder = e.exports.Format = c;
    }, function (e, t, r) {
      var n = r(13).format;
      t.warn = {
        deprecated: function deprecated(e2) {
          return function () {
            throw new Error(n("{ %s } was removed in winston@3.0.0.", e2));
          };
        },
        useFormat: function useFormat(e2) {
          return function () {
            throw new Error([n("{ %s } was removed in winston@3.0.0.", e2), "Use a custom winston.format = winston.format(function) instead."].join("\n"));
          };
        },
        forFunctions: function forFunctions(e2, r2, n2) {
          n2.forEach(function (n3) {
            e2[n3] = t.warn[r2](n3);
          });
        },
        moved: function moved(e2, t2, r2) {
          function o() {
            return function () {
              throw new Error([n("winston.%s was moved in winston@3.0.0.", r2), n("Use a winston.%s instead.", t2)].join("\n"));
            };
          }
          Object.defineProperty(e2, r2, {
            get: o,
            set: o
          });
        },
        forProperties: function forProperties(e2, r2, n2) {
          n2.forEach(function (n3) {
            var o = t.warn[r2](n3);
            Object.defineProperty(e2, n3, {
              get: o,
              set: o
            });
          });
        }
      };
    }, function (e, t, r) {
      (function (t2, n, o) {
        var i = r(16);
        function s(e2) {
          var t3 = this;
          this.next = null, this.entry = null, this.finish = function () {
            !function (e3, t4, r2) {
              var n2 = e3.entry;
              e3.entry = null;
              for (; n2;) {
                var o2 = n2.callback;
                t4.pendingcb--, o2(r2), n2 = n2.next;
              }
              t4.corkedRequestsFree ? t4.corkedRequestsFree.next = e3 : t4.corkedRequestsFree = e3;
            }(t3, e2);
          };
        }
        e.exports = b;
        var a2,
          l = !t2.browser && ["v0.10", "v0.9."].indexOf(t2.version.slice(0, 5)) > -1 ? n : i.nextTick;
        b.WritableState = m;
        var u = Object.create(r(17));
        u.inherits = r(7);
        var g = {
            deprecate: r(43)
          },
          c = r(63),
          f = r(44).Buffer,
          p = o.Uint8Array || function () {};
        var h,
          d = r(64);
        function y() {}
        function m(e2, t3) {
          a2 = a2 || r(36), e2 = e2 || {};
          var n2 = t3 instanceof a2;
          this.objectMode = !!e2.objectMode, n2 && (this.objectMode = this.objectMode || !!e2.writableObjectMode);
          var o2 = e2.highWaterMark,
            u2 = e2.writableHighWaterMark,
            g2 = this.objectMode ? 16 : 16384;
          this.highWaterMark = o2 || 0 === o2 ? o2 : n2 && (u2 || 0 === u2) ? u2 : g2, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = false, this.needDrain = false, this.ending = false, this.ended = false, this.finished = false, this.destroyed = false;
          var c2 = false === e2.decodeStrings;
          this.decodeStrings = !c2, this.defaultEncoding = e2.defaultEncoding || "utf8", this.length = 0, this.writing = false, this.corked = 0, this.sync = true, this.bufferProcessing = false, this.onwrite = function (e3) {
            !function (e4, t4) {
              var r2 = e4._writableState,
                n3 = r2.sync,
                o3 = r2.writecb;
              if (function (e5) {
                e5.writing = false, e5.writecb = null, e5.length -= e5.writelen, e5.writelen = 0;
              }(r2), t4) !function (e5, t5, r3, n4, o4) {
                --t5.pendingcb, r3 ? (i.nextTick(o4, n4), i.nextTick(T, e5, t5), e5._writableState.errorEmitted = true, e5.emit("error", n4)) : (o4(n4), e5._writableState.errorEmitted = true, e5.emit("error", n4), T(e5, t5));
              }(e4, r2, n3, t4, o3);else {
                var s2 = w(r2);
                s2 || r2.corked || r2.bufferProcessing || !r2.bufferedRequest || S(e4, r2), n3 ? l(_, e4, r2, s2, o3) : _(e4, r2, s2, o3);
              }
            }(t3, e3);
          }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = false, this.errorEmitted = false, this.bufferedRequestCount = 0, this.corkedRequestsFree = new s(this);
        }
        function b(e2) {
          if (a2 = a2 || r(36), !(h.call(b, this) || this instanceof a2)) return new b(e2);
          this._writableState = new m(e2, this), this.writable = true, e2 && ("function" == typeof e2.write && (this._write = e2.write), "function" == typeof e2.writev && (this._writev = e2.writev), "function" == typeof e2.destroy && (this._destroy = e2.destroy), "function" == typeof e2.final && (this._final = e2.final)), c.call(this);
        }
        function v(e2, t3, r2, n2, o2, i2, s2) {
          t3.writelen = n2, t3.writecb = s2, t3.writing = true, t3.sync = true, r2 ? e2._writev(o2, t3.onwrite) : e2._write(o2, i2, t3.onwrite), t3.sync = false;
        }
        function _(e2, t3, r2, n2) {
          r2 || function (e3, t4) {
            0 === t4.length && t4.needDrain && (t4.needDrain = false, e3.emit("drain"));
          }(e2, t3), t3.pendingcb--, n2(), T(e2, t3);
        }
        function S(e2, t3) {
          t3.bufferProcessing = true;
          var r2 = t3.bufferedRequest;
          if (e2._writev && r2 && r2.next) {
            var n2 = t3.bufferedRequestCount,
              o2 = new Array(n2),
              i2 = t3.corkedRequestsFree;
            i2.entry = r2;
            for (var a3 = 0, l2 = true; r2;) o2[a3] = r2, r2.isBuf || (l2 = false), r2 = r2.next, a3 += 1;
            o2.allBuffers = l2, v(e2, t3, true, t3.length, o2, "", i2.finish), t3.pendingcb++, t3.lastBufferedRequest = null, i2.next ? (t3.corkedRequestsFree = i2.next, i2.next = null) : t3.corkedRequestsFree = new s(t3), t3.bufferedRequestCount = 0;
          } else {
            for (; r2;) {
              var u2 = r2.chunk,
                g2 = r2.encoding,
                c2 = r2.callback;
              if (v(e2, t3, false, t3.objectMode ? 1 : u2.length, u2, g2, c2), r2 = r2.next, t3.bufferedRequestCount--, t3.writing) break;
            }
            null === r2 && (t3.lastBufferedRequest = null);
          }
          t3.bufferedRequest = r2, t3.bufferProcessing = false;
        }
        function w(e2) {
          return e2.ending && 0 === e2.length && null === e2.bufferedRequest && !e2.finished && !e2.writing;
        }
        function E(e2, t3) {
          e2._final(function (r2) {
            t3.pendingcb--, r2 && e2.emit("error", r2), t3.prefinished = true, e2.emit("prefinish"), T(e2, t3);
          });
        }
        function T(e2, t3) {
          var r2 = w(t3);
          return r2 && (!function (e3, t4) {
            t4.prefinished || t4.finalCalled || ("function" == typeof e3._final ? (t4.pendingcb++, t4.finalCalled = true, i.nextTick(E, e3, t4)) : (t4.prefinished = true, e3.emit("prefinish")));
          }(e2, t3), 0 === t3.pendingcb && (t3.finished = true, e2.emit("finish"))), r2;
        }
        u.inherits(b, c), m.prototype.getBuffer = function () {
          for (var e2 = this.bufferedRequest, t3 = []; e2;) t3.push(e2), e2 = e2.next;
          return t3;
        }, function () {
          try {
            Object.defineProperty(m.prototype, "buffer", {
              get: g.deprecate(function () {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
            });
          } catch (e2) {}
        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (h = Function.prototype[Symbol.hasInstance], Object.defineProperty(b, Symbol.hasInstance, {
          value: function value(e2) {
            return !!h.call(this, e2) || this === b && e2 && e2._writableState instanceof m;
          }
        })) : h = function h(e2) {
          return e2 instanceof this;
        }, b.prototype.pipe = function () {
          this.emit("error", new Error("Cannot pipe, not readable"));
        }, b.prototype.write = function (e2, t3, r2) {
          var n2,
            o2 = this._writableState,
            s2 = false,
            a3 = !o2.objectMode && (n2 = e2, f.isBuffer(n2) || n2 instanceof p);
          return a3 && !f.isBuffer(e2) && (e2 = function (e3) {
            return f.from(e3);
          }(e2)), "function" == typeof t3 && (r2 = t3, t3 = null), a3 ? t3 = "buffer" : t3 || (t3 = o2.defaultEncoding), "function" != typeof r2 && (r2 = y), o2.ended ? function (e3, t4) {
            var r3 = new Error("write after end");
            e3.emit("error", r3), i.nextTick(t4, r3);
          }(this, r2) : (a3 || function (e3, t4, r3, n3) {
            var o3 = true,
              s3 = false;
            return null === r3 ? s3 = new TypeError("May not write null values to stream") : "string" == typeof r3 || void 0 === r3 || t4.objectMode || (s3 = new TypeError("Invalid non-string/buffer chunk")), s3 && (e3.emit("error", s3), i.nextTick(n3, s3), o3 = false), o3;
          }(this, o2, e2, r2)) && (o2.pendingcb++, s2 = function (e3, t4, r3, n3, o3, i2) {
            if (!r3) {
              var s3 = function (e4, t5, r4) {
                e4.objectMode || false === e4.decodeStrings || "string" != typeof t5 || (t5 = f.from(t5, r4));
                return t5;
              }(t4, n3, o3);
              n3 !== s3 && (r3 = true, o3 = "buffer", n3 = s3);
            }
            var a4 = t4.objectMode ? 1 : n3.length;
            t4.length += a4;
            var l2 = t4.length < t4.highWaterMark;
            l2 || (t4.needDrain = true);
            if (t4.writing || t4.corked) {
              var u2 = t4.lastBufferedRequest;
              t4.lastBufferedRequest = {
                chunk: n3,
                encoding: o3,
                isBuf: r3,
                callback: i2,
                next: null
              }, u2 ? u2.next = t4.lastBufferedRequest : t4.bufferedRequest = t4.lastBufferedRequest, t4.bufferedRequestCount += 1;
            } else v(e3, t4, false, a4, n3, o3, i2);
            return l2;
          }(this, o2, a3, e2, t3, r2)), s2;
        }, b.prototype.cork = function () {
          this._writableState.corked++;
        }, b.prototype.uncork = function () {
          var e2 = this._writableState;
          e2.corked && (e2.corked--, e2.writing || e2.corked || e2.finished || e2.bufferProcessing || !e2.bufferedRequest || S(this, e2));
        }, b.prototype.setDefaultEncoding = function (e2) {
          if ("string" == typeof e2 && (e2 = e2.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e2 + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e2);
          return this._writableState.defaultEncoding = e2, this;
        }, Object.defineProperty(b.prototype, "writableHighWaterMark", {
          enumerable: false,
          get: function get() {
            return this._writableState.highWaterMark;
          }
        }), b.prototype._write = function (e2, t3, r2) {
          r2(new Error("_write() is not implemented"));
        }, b.prototype._writev = null, b.prototype.end = function (e2, t3, r2) {
          var n2 = this._writableState;
          "function" == typeof e2 ? (r2 = e2, e2 = null, t3 = null) : "function" == typeof t3 && (r2 = t3, t3 = null), null != e2 && this.write(e2, t3), n2.corked && (n2.corked = 1, this.uncork()), n2.ending || n2.finished || function (e3, t4, r3) {
            t4.ending = true, T(e3, t4), r3 && (t4.finished ? i.nextTick(r3) : e3.once("finish", r3));
            t4.ended = true, e3.writable = false;
          }(this, n2, r2);
        }, Object.defineProperty(b.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._writableState && this._writableState.destroyed;
          },
          set: function set(e2) {
            this._writableState && (this._writableState.destroyed = e2);
          }
        }), b.prototype.destroy = d.destroy, b.prototype._undestroy = d.undestroy, b.prototype._destroy = function (e2, t3) {
          this.end(), t3(e2);
        };
      }).call(this, r(2), r(15).setImmediate, r(6));
    }, function (e, t, r) {
      e.exports = r(21).EventEmitter;
    }, function (e, t, r) {
      var n = r(16);
      function o(e2, t2) {
        e2.emit("error", t2);
      }
      e.exports = {
        destroy: function destroy(e2, t2) {
          var r2 = this,
            i = this._readableState && this._readableState.destroyed,
            s = this._writableState && this._writableState.destroyed;
          return i || s ? (t2 ? t2(e2) : !e2 || this._writableState && this._writableState.errorEmitted || n.nextTick(o, this, e2), this) : (this._readableState && (this._readableState.destroyed = true), this._writableState && (this._writableState.destroyed = true), this._destroy(e2 || null, function (e3) {
            !t2 && e3 ? (n.nextTick(o, r2, e3), r2._writableState && (r2._writableState.errorEmitted = true)) : t2 && t2(e3);
          }), this);
        },
        undestroy: function undestroy() {
          this._readableState && (this._readableState.destroyed = false, this._readableState.reading = false, this._readableState.ended = false, this._readableState.endEmitted = false), this._writableState && (this._writableState.destroyed = false, this._writableState.ended = false, this._writableState.ending = false, this._writableState.finished = false, this._writableState.errorEmitted = false);
        }
      };
    }, function (e, t) {}, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      });
      var n = s(r(156)),
        o = s(r(25)),
        i = s(r(30));
      function s(e2) {
        return e2 && e2.__esModule ? e2 : {
          default: e2
        };
      }
      t.default = (0, i.default)(function (e2, t2, r2, i2) {
        return (0, n.default)(t2)(e2, (0, o.default)(r2), i2);
      }, 4), e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2) {
        function t2() {
          if (null !== e2) {
            var r2 = e2;
            for (var _len4 = arguments.length, t3 = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              t3[_key4] = arguments[_key4];
            }
            e2 = null, r2.apply(this, t3);
          }
        }
        return Object.assign(t2, e2), t2;
      }, e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2) {
        return function () {
          if (null === e2) throw new Error("Callback was already called.");
          var r2 = e2;
          for (var _len5 = arguments.length, t2 = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            t2[_key5] = arguments[_key5];
          }
          e2 = null, r2.apply(this, t2);
        };
      }, e.exports = t.default;
    }, function (e, t, r) {
      (function (t2, n) {
        var o = r(16);
        e.exports = v;
        var i,
          s = r(42);
        v.ReadableState = b;
        r(21).EventEmitter;
        var a2 = function a2(e2, t3) {
            return e2.listeners(t3).length;
          },
          l = r(70),
          u = r(47).Buffer,
          g = t2.Uint8Array || function () {};
        var c = r(17);
        c.inherits = r(7);
        var f = r(162),
          p = void 0;
        p = f && f.debuglog ? f.debuglog("stream") : function () {};
        var h,
          d = r(163),
          y = r(71);
        c.inherits(v, l);
        var m = ["error", "close", "destroy", "pause", "resume"];
        function b(e2, t3) {
          e2 = e2 || {};
          var n2 = t3 instanceof (i = i || r(23));
          this.objectMode = !!e2.objectMode, n2 && (this.objectMode = this.objectMode || !!e2.readableObjectMode);
          var o2 = e2.highWaterMark,
            s2 = e2.readableHighWaterMark,
            a3 = this.objectMode ? 16 : 16384;
          this.highWaterMark = o2 || 0 === o2 ? o2 : n2 && (s2 || 0 === s2) ? s2 : a3, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new d(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = false, this.endEmitted = false, this.reading = false, this.sync = true, this.needReadable = false, this.emittedReadable = false, this.readableListening = false, this.resumeScheduled = false, this.destroyed = false, this.defaultEncoding = e2.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = false, this.decoder = null, this.encoding = null, e2.encoding && (h || (h = r(22).StringDecoder), this.decoder = new h(e2.encoding), this.encoding = e2.encoding);
        }
        function v(e2) {
          if (i = i || r(23), !(this instanceof v)) return new v(e2);
          this._readableState = new b(e2, this), this.readable = true, e2 && ("function" == typeof e2.read && (this._read = e2.read), "function" == typeof e2.destroy && (this._destroy = e2.destroy)), l.call(this);
        }
        function _(e2, t3, r2, n2, o2) {
          var i2,
            s2 = e2._readableState;
          null === t3 ? (s2.reading = false, function (e3, t4) {
            if (t4.ended) return;
            if (t4.decoder) {
              var r3 = t4.decoder.end();
              r3 && r3.length && (t4.buffer.push(r3), t4.length += t4.objectMode ? 1 : r3.length);
            }
            t4.ended = true, E(e3);
          }(e2, s2)) : (o2 || (i2 = function (e3, t4) {
            var r3;
            n3 = t4, u.isBuffer(n3) || n3 instanceof g || "string" == typeof t4 || void 0 === t4 || e3.objectMode || (r3 = new TypeError("Invalid non-string/buffer chunk"));
            var n3;
            return r3;
          }(s2, t3)), i2 ? e2.emit("error", i2) : s2.objectMode || t3 && t3.length > 0 ? ("string" == typeof t3 || s2.objectMode || Object.getPrototypeOf(t3) === u.prototype || (t3 = function (e3) {
            return u.from(e3);
          }(t3)), n2 ? s2.endEmitted ? e2.emit("error", new Error("stream.unshift() after end event")) : S(e2, s2, t3, true) : s2.ended ? e2.emit("error", new Error("stream.push() after EOF")) : (s2.reading = false, s2.decoder && !r2 ? (t3 = s2.decoder.write(t3), s2.objectMode || 0 !== t3.length ? S(e2, s2, t3, false) : R(e2, s2)) : S(e2, s2, t3, false))) : n2 || (s2.reading = false));
          return function (e3) {
            return !e3.ended && (e3.needReadable || e3.length < e3.highWaterMark || 0 === e3.length);
          }(s2);
        }
        function S(e2, t3, r2, n2) {
          t3.flowing && 0 === t3.length && !t3.sync ? (e2.emit("data", r2), e2.read(0)) : (t3.length += t3.objectMode ? 1 : r2.length, n2 ? t3.buffer.unshift(r2) : t3.buffer.push(r2), t3.needReadable && E(e2)), R(e2, t3);
        }
        Object.defineProperty(v.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._readableState && this._readableState.destroyed;
          },
          set: function set(e2) {
            this._readableState && (this._readableState.destroyed = e2);
          }
        }), v.prototype.destroy = y.destroy, v.prototype._undestroy = y.undestroy, v.prototype._destroy = function (e2, t3) {
          this.push(null), t3(e2);
        }, v.prototype.push = function (e2, t3) {
          var r2,
            n2 = this._readableState;
          return n2.objectMode ? r2 = true : "string" == typeof e2 && ((t3 = t3 || n2.defaultEncoding) !== n2.encoding && (e2 = u.from(e2, t3), t3 = ""), r2 = true), _(this, e2, t3, false, r2);
        }, v.prototype.unshift = function (e2) {
          return _(this, e2, null, true, false);
        }, v.prototype.isPaused = function () {
          return false === this._readableState.flowing;
        }, v.prototype.setEncoding = function (e2) {
          return h || (h = r(22).StringDecoder), this._readableState.decoder = new h(e2), this._readableState.encoding = e2, this;
        };
        function w(e2, t3) {
          return e2 <= 0 || 0 === t3.length && t3.ended ? 0 : t3.objectMode ? 1 : e2 != e2 ? t3.flowing && t3.length ? t3.buffer.head.data.length : t3.length : (e2 > t3.highWaterMark && (t3.highWaterMark = function (e3) {
            return e3 >= 8388608 ? e3 = 8388608 : (e3--, e3 |= e3 >>> 1, e3 |= e3 >>> 2, e3 |= e3 >>> 4, e3 |= e3 >>> 8, e3 |= e3 >>> 16, e3++), e3;
          }(e2)), e2 <= t3.length ? e2 : t3.ended ? t3.length : (t3.needReadable = true, 0));
        }
        function E(e2) {
          var t3 = e2._readableState;
          t3.needReadable = false, t3.emittedReadable || (p("emitReadable", t3.flowing), t3.emittedReadable = true, t3.sync ? o.nextTick(T, e2) : T(e2));
        }
        function T(e2) {
          p("emit readable"), e2.emit("readable"), I(e2);
        }
        function R(e2, t3) {
          t3.readingMore || (t3.readingMore = true, o.nextTick(A, e2, t3));
        }
        function A(e2, t3) {
          for (var r2 = t3.length; !t3.reading && !t3.flowing && !t3.ended && t3.length < t3.highWaterMark && (p("maybeReadMore read 0"), e2.read(0), r2 !== t3.length);) r2 = t3.length;
          t3.readingMore = false;
        }
        function O(e2) {
          p("readable nexttick read 0"), e2.read(0);
        }
        function C(e2, t3) {
          t3.reading || (p("resume read 0"), e2.read(0)), t3.resumeScheduled = false, t3.awaitDrain = 0, e2.emit("resume"), I(e2), t3.flowing && !t3.reading && e2.read(0);
        }
        function I(e2) {
          var t3 = e2._readableState;
          for (p("flow", t3.flowing); t3.flowing && null !== e2.read(););
        }
        function j(e2, t3) {
          return 0 === t3.length ? null : (t3.objectMode ? r2 = t3.buffer.shift() : !e2 || e2 >= t3.length ? (r2 = t3.decoder ? t3.buffer.join("") : 1 === t3.buffer.length ? t3.buffer.head.data : t3.buffer.concat(t3.length), t3.buffer.clear()) : r2 = function (e3, t4, r3) {
            var n2;
            e3 < t4.head.data.length ? (n2 = t4.head.data.slice(0, e3), t4.head.data = t4.head.data.slice(e3)) : n2 = e3 === t4.head.data.length ? t4.shift() : r3 ? function (e4, t5) {
              var r4 = t5.head,
                n3 = 1,
                o2 = r4.data;
              e4 -= o2.length;
              for (; r4 = r4.next;) {
                var i2 = r4.data,
                  s2 = e4 > i2.length ? i2.length : e4;
                if (s2 === i2.length ? o2 += i2 : o2 += i2.slice(0, e4), 0 === (e4 -= s2)) {
                  s2 === i2.length ? (++n3, r4.next ? t5.head = r4.next : t5.head = t5.tail = null) : (t5.head = r4, r4.data = i2.slice(s2));
                  break;
                }
                ++n3;
              }
              return t5.length -= n3, o2;
            }(e3, t4) : function (e4, t5) {
              var r4 = u.allocUnsafe(e4),
                n3 = t5.head,
                o2 = 1;
              n3.data.copy(r4), e4 -= n3.data.length;
              for (; n3 = n3.next;) {
                var i2 = n3.data,
                  s2 = e4 > i2.length ? i2.length : e4;
                if (i2.copy(r4, r4.length - e4, 0, s2), 0 === (e4 -= s2)) {
                  s2 === i2.length ? (++o2, n3.next ? t5.head = n3.next : t5.head = t5.tail = null) : (t5.head = n3, n3.data = i2.slice(s2));
                  break;
                }
                ++o2;
              }
              return t5.length -= o2, r4;
            }(e3, t4);
            return n2;
          }(e2, t3.buffer, t3.decoder), r2);
          var r2;
        }
        function M(e2) {
          var t3 = e2._readableState;
          if (t3.length > 0) throw new Error('"endReadable()" called on non-empty stream');
          t3.endEmitted || (t3.ended = true, o.nextTick(P, t3, e2));
        }
        function P(e2, t3) {
          e2.endEmitted || 0 !== e2.length || (e2.endEmitted = true, t3.readable = false, t3.emit("end"));
        }
        function N(e2, t3) {
          for (var r2 = 0, n2 = e2.length; r2 < n2; r2++) if (e2[r2] === t3) return r2;
          return -1;
        }
        v.prototype.read = function (e2) {
          p("read", e2), e2 = parseInt(e2, 10);
          var t3 = this._readableState,
            r2 = e2;
          if (0 !== e2 && (t3.emittedReadable = false), 0 === e2 && t3.needReadable && (t3.length >= t3.highWaterMark || t3.ended)) return p("read: emitReadable", t3.length, t3.ended), 0 === t3.length && t3.ended ? M(this) : E(this), null;
          if (0 === (e2 = w(e2, t3)) && t3.ended) return 0 === t3.length && M(this), null;
          var n2,
            o2 = t3.needReadable;
          return p("need readable", o2), (0 === t3.length || t3.length - e2 < t3.highWaterMark) && p("length less than watermark", o2 = true), t3.ended || t3.reading ? p("reading or ended", o2 = false) : o2 && (p("do read"), t3.reading = true, t3.sync = true, 0 === t3.length && (t3.needReadable = true), this._read(t3.highWaterMark), t3.sync = false, t3.reading || (e2 = w(r2, t3))), null === (n2 = e2 > 0 ? j(e2, t3) : null) ? (t3.needReadable = true, e2 = 0) : t3.length -= e2, 0 === t3.length && (t3.ended || (t3.needReadable = true), r2 !== e2 && t3.ended && M(this)), null !== n2 && this.emit("data", n2), n2;
        }, v.prototype._read = function (e2) {
          this.emit("error", new Error("_read() is not implemented"));
        }, v.prototype.pipe = function (e2, t3) {
          var r2 = this,
            i2 = this._readableState;
          switch (i2.pipesCount) {
            case 0:
              i2.pipes = e2;
              break;
            case 1:
              i2.pipes = [i2.pipes, e2];
              break;
            default:
              i2.pipes.push(e2);
          }
          i2.pipesCount += 1, p("pipe count=%d opts=%j", i2.pipesCount, t3);
          var l2 = (!t3 || false !== t3.end) && e2 !== n.stdout && e2 !== n.stderr ? g2 : v2;
          function u2(t4, n2) {
            p("onunpipe"), t4 === r2 && n2 && false === n2.hasUnpiped && (n2.hasUnpiped = true, p("cleanup"), e2.removeListener("close", m2), e2.removeListener("finish", b2), e2.removeListener("drain", c2), e2.removeListener("error", y2), e2.removeListener("unpipe", u2), r2.removeListener("end", g2), r2.removeListener("end", v2), r2.removeListener("data", d2), f2 = true, !i2.awaitDrain || e2._writableState && !e2._writableState.needDrain || c2());
          }
          function g2() {
            p("onend"), e2.end();
          }
          i2.endEmitted ? o.nextTick(l2) : r2.once("end", l2), e2.on("unpipe", u2);
          var c2 = function (e3) {
            return function () {
              var t4 = e3._readableState;
              p("pipeOnDrain", t4.awaitDrain), t4.awaitDrain && t4.awaitDrain--, 0 === t4.awaitDrain && a2(e3, "data") && (t4.flowing = true, I(e3));
            };
          }(r2);
          e2.on("drain", c2);
          var f2 = false;
          var h2 = false;
          function d2(t4) {
            p("ondata"), h2 = false, false !== e2.write(t4) || h2 || ((1 === i2.pipesCount && i2.pipes === e2 || i2.pipesCount > 1 && -1 !== N(i2.pipes, e2)) && !f2 && (p("false write response, pause", r2._readableState.awaitDrain), r2._readableState.awaitDrain++, h2 = true), r2.pause());
          }
          function y2(t4) {
            p("onerror", t4), v2(), e2.removeListener("error", y2), 0 === a2(e2, "error") && e2.emit("error", t4);
          }
          function m2() {
            e2.removeListener("finish", b2), v2();
          }
          function b2() {
            p("onfinish"), e2.removeListener("close", m2), v2();
          }
          function v2() {
            p("unpipe"), r2.unpipe(e2);
          }
          return r2.on("data", d2), function (e3, t4, r3) {
            if ("function" == typeof e3.prependListener) return e3.prependListener(t4, r3);
            e3._events && e3._events[t4] ? s(e3._events[t4]) ? e3._events[t4].unshift(r3) : e3._events[t4] = [r3, e3._events[t4]] : e3.on(t4, r3);
          }(e2, "error", y2), e2.once("close", m2), e2.once("finish", b2), e2.emit("pipe", r2), i2.flowing || (p("pipe resume"), r2.resume()), e2;
        }, v.prototype.unpipe = function (e2) {
          var t3 = this._readableState,
            r2 = {
              hasUnpiped: false
            };
          if (0 === t3.pipesCount) return this;
          if (1 === t3.pipesCount) return e2 && e2 !== t3.pipes || (e2 || (e2 = t3.pipes), t3.pipes = null, t3.pipesCount = 0, t3.flowing = false, e2 && e2.emit("unpipe", this, r2)), this;
          if (!e2) {
            var n2 = t3.pipes,
              o2 = t3.pipesCount;
            t3.pipes = null, t3.pipesCount = 0, t3.flowing = false;
            for (var i2 = 0; i2 < o2; i2++) n2[i2].emit("unpipe", this, r2);
            return this;
          }
          var s2 = N(t3.pipes, e2);
          return -1 === s2 || (t3.pipes.splice(s2, 1), t3.pipesCount -= 1, 1 === t3.pipesCount && (t3.pipes = t3.pipes[0]), e2.emit("unpipe", this, r2)), this;
        }, v.prototype.on = function (e2, t3) {
          var r2 = l.prototype.on.call(this, e2, t3);
          if ("data" === e2) false !== this._readableState.flowing && this.resume();else if ("readable" === e2) {
            var n2 = this._readableState;
            n2.endEmitted || n2.readableListening || (n2.readableListening = n2.needReadable = true, n2.emittedReadable = false, n2.reading ? n2.length && E(this) : o.nextTick(O, this));
          }
          return r2;
        }, v.prototype.addListener = v.prototype.on, v.prototype.resume = function () {
          var e2 = this._readableState;
          return e2.flowing || (p("resume"), e2.flowing = true, function (e3, t3) {
            t3.resumeScheduled || (t3.resumeScheduled = true, o.nextTick(C, e3, t3));
          }(this, e2)), this;
        }, v.prototype.pause = function () {
          return p("call pause flowing=%j", this._readableState.flowing), false !== this._readableState.flowing && (p("pause"), this._readableState.flowing = false, this.emit("pause")), this;
        }, v.prototype.wrap = function (e2) {
          var t3 = this,
            r2 = this._readableState,
            n2 = false;
          for (var o2 in e2.on("end", function () {
            if (p("wrapped end"), r2.decoder && !r2.ended) {
              var e3 = r2.decoder.end();
              e3 && e3.length && t3.push(e3);
            }
            t3.push(null);
          }), e2.on("data", function (o3) {
            (p("wrapped data"), r2.decoder && (o3 = r2.decoder.write(o3)), r2.objectMode && null == o3) || (r2.objectMode || o3 && o3.length) && (t3.push(o3) || (n2 = true, e2.pause()));
          }), e2) void 0 === this[o2] && "function" == typeof e2[o2] && (this[o2] = function (t4) {
            return function () {
              return e2[t4].apply(e2, arguments);
            };
          }(o2));
          for (var i2 = 0; i2 < m.length; i2++) e2.on(m[i2], this.emit.bind(this, m[i2]));
          return this._read = function (t4) {
            p("wrapped _read", t4), n2 && (n2 = false, e2.resume());
          }, this;
        }, Object.defineProperty(v.prototype, "readableHighWaterMark", {
          enumerable: false,
          get: function get() {
            return this._readableState.highWaterMark;
          }
        }), v._fromList = j;
      }).call(this, r(6), r(2));
    }, function (e, t, r) {
      e.exports = r(21).EventEmitter;
    }, function (e, t, r) {
      var n = r(16);
      function o(e2, t2) {
        e2.emit("error", t2);
      }
      e.exports = {
        destroy: function destroy(e2, t2) {
          var r2 = this,
            i = this._readableState && this._readableState.destroyed,
            s = this._writableState && this._writableState.destroyed;
          return i || s ? (t2 ? t2(e2) : !e2 || this._writableState && this._writableState.errorEmitted || n.nextTick(o, this, e2), this) : (this._readableState && (this._readableState.destroyed = true), this._writableState && (this._writableState.destroyed = true), this._destroy(e2 || null, function (e3) {
            !t2 && e3 ? (n.nextTick(o, r2, e3), r2._writableState && (r2._writableState.errorEmitted = true)) : t2 && t2(e3);
          }), this);
        },
        undestroy: function undestroy() {
          this._readableState && (this._readableState.destroyed = false, this._readableState.reading = false, this._readableState.ended = false, this._readableState.endEmitted = false), this._writableState && (this._writableState.destroyed = false, this._writableState.ended = false, this._writableState.ending = false, this._writableState.finished = false, this._writableState.errorEmitted = false);
        }
      };
    }, function (e, t, r) {
      e.exports = s;
      var n = r(23),
        o = r(17);
      function i(e2, t2) {
        var r2 = this._transformState;
        r2.transforming = false;
        var n2 = r2.writecb;
        if (!n2) return this.emit("error", new Error("write callback called multiple times"));
        r2.writechunk = null, r2.writecb = null, null != t2 && this.push(t2), n2(e2);
        var o2 = this._readableState;
        o2.reading = false, (o2.needReadable || o2.length < o2.highWaterMark) && this._read(o2.highWaterMark);
      }
      function s(e2) {
        if (!(this instanceof s)) return new s(e2);
        n.call(this, e2), this._transformState = {
          afterTransform: i.bind(this),
          needTransform: false,
          transforming: false,
          writecb: null,
          writechunk: null,
          writeencoding: null
        }, this._readableState.needReadable = true, this._readableState.sync = false, e2 && ("function" == typeof e2.transform && (this._transform = e2.transform), "function" == typeof e2.flush && (this._flush = e2.flush)), this.on("prefinish", a2);
      }
      function a2() {
        var e2 = this;
        "function" == typeof this._flush ? this._flush(function (t2, r2) {
          l(e2, t2, r2);
        }) : l(this, null, null);
      }
      function l(e2, t2, r2) {
        if (t2) return e2.emit("error", t2);
        if (null != r2 && e2.push(r2), e2._writableState.length) throw new Error("Calling transform done when ws.length != 0");
        if (e2._transformState.transforming) throw new Error("Calling transform done when still transforming");
        return e2.push(null);
      }
      o.inherits = r(7), o.inherits(s, n), s.prototype.push = function (e2, t2) {
        return this._transformState.needTransform = false, n.prototype.push.call(this, e2, t2);
      }, s.prototype._transform = function (e2, t2, r2) {
        throw new Error("_transform() is not implemented");
      }, s.prototype._write = function (e2, t2, r2) {
        var n2 = this._transformState;
        if (n2.writecb = r2, n2.writechunk = e2, n2.writeencoding = t2, !n2.transforming) {
          var o2 = this._readableState;
          (n2.needTransform || o2.needReadable || o2.length < o2.highWaterMark) && this._read(o2.highWaterMark);
        }
      }, s.prototype._read = function (e2) {
        var t2 = this._transformState;
        null !== t2.writechunk && t2.writecb && !t2.transforming ? (t2.transforming = true, this._transform(t2.writechunk, t2.writeencoding, t2.afterTransform)) : t2.needTransform = true;
      }, s.prototype._destroy = function (e2, t2) {
        var r2 = this;
        n.prototype._destroy.call(this, e2, function (e3) {
          t2(e3), r2.emit("close");
        });
      };
    }, function (e, t, r) {
      e.exports = r(48);
    }, function (e, t, r) {
      (function (t2) {
        var n = r(170);
        function o(e2, t3) {
          if (e2 === t3) return 0;
          for (var r2 = e2.length, n2 = t3.length, o2 = 0, i2 = Math.min(r2, n2); o2 < i2; ++o2) if (e2[o2] !== t3[o2]) {
            r2 = e2[o2], n2 = t3[o2];
            break;
          }
          return r2 < n2 ? -1 : n2 < r2 ? 1 : 0;
        }
        function i(e2) {
          return t2.Buffer && "function" == typeof t2.Buffer.isBuffer ? t2.Buffer.isBuffer(e2) : !(null == e2 || !e2._isBuffer);
        }
        var s = r(13),
          a2 = Object.prototype.hasOwnProperty,
          l = Array.prototype.slice,
          u = "foo" === function () {}.name;
        function g(e2) {
          return Object.prototype.toString.call(e2);
        }
        function c(e2) {
          return !i(e2) && "function" == typeof t2.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e2) : !!e2 && (e2 instanceof DataView || !!(e2.buffer && e2.buffer instanceof ArrayBuffer)));
        }
        var f = e.exports = b,
          p = /\s*function\s+([^\(\s]*)\s*/;
        function h(e2) {
          if (s.isFunction(e2)) {
            if (u) return e2.name;
            var t3 = e2.toString().match(p);
            return t3 && t3[1];
          }
        }
        function d(e2, t3) {
          return "string" == typeof e2 ? e2.length < t3 ? e2 : e2.slice(0, t3) : e2;
        }
        function y(e2) {
          if (u || !s.isFunction(e2)) return s.inspect(e2);
          var t3 = h(e2);
          return "[Function" + (t3 ? ": " + t3 : "") + "]";
        }
        function m(e2, t3, r2, n2, o2) {
          throw new f.AssertionError({
            message: r2,
            actual: e2,
            expected: t3,
            operator: n2,
            stackStartFunction: o2
          });
        }
        function b(e2, t3) {
          e2 || m(e2, true, t3, "==", f.ok);
        }
        function v(e2, t3, r2, n2) {
          if (e2 === t3) return true;
          if (i(e2) && i(t3)) return 0 === o(e2, t3);
          if (s.isDate(e2) && s.isDate(t3)) return e2.getTime() === t3.getTime();
          if (s.isRegExp(e2) && s.isRegExp(t3)) return e2.source === t3.source && e2.global === t3.global && e2.multiline === t3.multiline && e2.lastIndex === t3.lastIndex && e2.ignoreCase === t3.ignoreCase;
          if (null !== e2 && "object" == typeof e2 || null !== t3 && "object" == typeof t3) {
            if (c(e2) && c(t3) && g(e2) === g(t3) && !(e2 instanceof Float32Array || e2 instanceof Float64Array)) return 0 === o(new Uint8Array(e2.buffer), new Uint8Array(t3.buffer));
            if (i(e2) !== i(t3)) return false;
            var a3 = (n2 = n2 || {
              actual: [],
              expected: []
            }).actual.indexOf(e2);
            return -1 !== a3 && a3 === n2.expected.indexOf(t3) || (n2.actual.push(e2), n2.expected.push(t3), function (e3, t4, r3, n3) {
              if (null == e3 || null == t4) return false;
              if (s.isPrimitive(e3) || s.isPrimitive(t4)) return e3 === t4;
              if (r3 && Object.getPrototypeOf(e3) !== Object.getPrototypeOf(t4)) return false;
              var o2 = _(e3),
                i2 = _(t4);
              if (o2 && !i2 || !o2 && i2) return false;
              if (o2) return e3 = l.call(e3), t4 = l.call(t4), v(e3, t4, r3);
              var a4,
                u2,
                g2 = E(e3),
                c2 = E(t4);
              if (g2.length !== c2.length) return false;
              for (g2.sort(), c2.sort(), u2 = g2.length - 1; u2 >= 0; u2--) if (g2[u2] !== c2[u2]) return false;
              for (u2 = g2.length - 1; u2 >= 0; u2--) if (a4 = g2[u2], !v(e3[a4], t4[a4], r3, n3)) return false;
              return true;
            }(e2, t3, r2, n2));
          }
          return r2 ? e2 === t3 : e2 == t3;
        }
        function _(e2) {
          return "[object Arguments]" == Object.prototype.toString.call(e2);
        }
        function S(e2, t3) {
          if (!e2 || !t3) return false;
          if ("[object RegExp]" == Object.prototype.toString.call(t3)) return t3.test(e2);
          try {
            if (e2 instanceof t3) return true;
          } catch (e3) {}
          return !Error.isPrototypeOf(t3) && true === t3.call({}, e2);
        }
        function w(e2, t3, r2, n2) {
          var o2;
          if ("function" != typeof t3) throw new TypeError('"block" argument must be a function');
          "string" == typeof r2 && (n2 = r2, r2 = null), o2 = function (e3) {
            var t4;
            try {
              e3();
            } catch (e4) {
              t4 = e4;
            }
            return t4;
          }(t3), n2 = (r2 && r2.name ? " (" + r2.name + ")." : ".") + (n2 ? " " + n2 : "."), e2 && !o2 && m(o2, r2, "Missing expected exception" + n2);
          var i2 = "string" == typeof n2,
            a3 = !e2 && o2 && !r2;
          if ((!e2 && s.isError(o2) && i2 && S(o2, r2) || a3) && m(o2, r2, "Got unwanted exception" + n2), e2 && o2 && r2 && !S(o2, r2) || !e2 && o2) throw o2;
        }
        f.AssertionError = function (e2) {
          this.name = "AssertionError", this.actual = e2.actual, this.expected = e2.expected, this.operator = e2.operator, e2.message ? (this.message = e2.message, this.generatedMessage = false) : (this.message = function (e3) {
            return d(y(e3.actual), 128) + " " + e3.operator + " " + d(y(e3.expected), 128);
          }(this), this.generatedMessage = true);
          var t3 = e2.stackStartFunction || m;
          if (Error.captureStackTrace) Error.captureStackTrace(this, t3);else {
            var r2 = new Error();
            if (r2.stack) {
              var n2 = r2.stack,
                o2 = h(t3),
                i2 = n2.indexOf("\n" + o2);
              if (i2 >= 0) {
                var s2 = n2.indexOf("\n", i2 + 1);
                n2 = n2.substring(s2 + 1);
              }
              this.stack = n2;
            }
          }
        }, s.inherits(f.AssertionError, Error), f.fail = m, f.ok = b, f.equal = function (e2, t3, r2) {
          e2 != t3 && m(e2, t3, r2, "==", f.equal);
        }, f.notEqual = function (e2, t3, r2) {
          e2 == t3 && m(e2, t3, r2, "!=", f.notEqual);
        }, f.deepEqual = function (e2, t3, r2) {
          v(e2, t3, false) || m(e2, t3, r2, "deepEqual", f.deepEqual);
        }, f.deepStrictEqual = function (e2, t3, r2) {
          v(e2, t3, true) || m(e2, t3, r2, "deepStrictEqual", f.deepStrictEqual);
        }, f.notDeepEqual = function (e2, t3, r2) {
          v(e2, t3, false) && m(e2, t3, r2, "notDeepEqual", f.notDeepEqual);
        }, f.notDeepStrictEqual = function e2(t3, r2, n2) {
          v(t3, r2, true) && m(t3, r2, n2, "notDeepStrictEqual", e2);
        }, f.strictEqual = function (e2, t3, r2) {
          e2 !== t3 && m(e2, t3, r2, "===", f.strictEqual);
        }, f.notStrictEqual = function (e2, t3, r2) {
          e2 === t3 && m(e2, t3, r2, "!==", f.notStrictEqual);
        }, f.throws = function (e2, t3, r2) {
          w(true, e2, t3, r2);
        }, f.doesNotThrow = function (e2, t3, r2) {
          w(false, e2, t3, r2);
        }, f.ifError = function (e2) {
          if (e2) throw e2;
        }, f.strict = n(function e2(t3, r2) {
          t3 || m(t3, true, r2, "==", e2);
        }, f, {
          equal: f.strictEqual,
          deepEqual: f.deepStrictEqual,
          notEqual: f.notStrictEqual,
          notDeepEqual: f.notDeepStrictEqual
        }), f.strict.strict = f.strict;
        var E = Object.keys || function (e2) {
          var t3 = [];
          for (var r2 in e2) a2.call(e2, r2) && t3.push(r2);
          return t3;
        };
      }).call(this, r(6));
    }, function (e, t, r) {
      e.exports = function (e2, t2, r2, n) {
        for (var o = 65535 & e2 | 0, i = e2 >>> 16 & 65535 | 0, s = 0; 0 !== r2;) {
          r2 -= s = r2 > 2e3 ? 2e3 : r2;
          do {
            i = i + (o = o + t2[n++] | 0) | 0;
          } while (--s);
          o %= 65521, i %= 65521;
        }
        return o | i << 16 | 0;
      };
    }, function (e, t, r) {
      var n = function () {
        for (var e2, t2 = [], r2 = 0; r2 < 256; r2++) {
          e2 = r2;
          for (var n2 = 0; n2 < 8; n2++) e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
          t2[r2] = e2;
        }
        return t2;
      }();
      e.exports = function (e2, t2, r2, o) {
        var i = n,
          s = o + r2;
        e2 ^= -1;
        for (var a2 = o; a2 < s; a2++) e2 = e2 >>> 8 ^ i[255 & (e2 ^ t2[a2])];
        return -1 ^ e2;
      };
    }, function (e, t, r) {
      (function (t2, n) {
        var o;
        e.exports = R, R.ReadableState = T;
        r(21).EventEmitter;
        var i = function i(e2, t3) {
            return e2.listeners(t3).length;
          },
          s = r(78),
          a2 = r(5).Buffer,
          l = t2.Uint8Array || function () {};
        var u,
          g = r(179);
        u = g && g.debuglog ? g.debuglog("stream") : function () {};
        var c,
          f,
          p,
          h = r(180),
          d = r(79),
          y = r(80).getHighWaterMark,
          m = r(26).codes,
          b = m.ERR_INVALID_ARG_TYPE,
          v = m.ERR_STREAM_PUSH_AFTER_EOF,
          _ = m.ERR_METHOD_NOT_IMPLEMENTED,
          S = m.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
        r(7)(R, s);
        var w = d.errorOrDestroy,
          E = ["error", "close", "destroy", "pause", "resume"];
        function T(e2, t3, n2) {
          o = o || r(27), e2 = e2 || {}, "boolean" != typeof n2 && (n2 = t3 instanceof o), this.objectMode = !!e2.objectMode, n2 && (this.objectMode = this.objectMode || !!e2.readableObjectMode), this.highWaterMark = y(this, e2, "readableHighWaterMark", n2), this.buffer = new h(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = false, this.endEmitted = false, this.reading = false, this.sync = true, this.needReadable = false, this.emittedReadable = false, this.readableListening = false, this.resumeScheduled = false, this.paused = true, this.emitClose = false !== e2.emitClose, this.autoDestroy = !!e2.autoDestroy, this.destroyed = false, this.defaultEncoding = e2.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = false, this.decoder = null, this.encoding = null, e2.encoding && (c || (c = r(22).StringDecoder), this.decoder = new c(e2.encoding), this.encoding = e2.encoding);
        }
        function R(e2) {
          if (o = o || r(27), !(this instanceof R)) return new R(e2);
          var t3 = this instanceof o;
          this._readableState = new T(e2, this, t3), this.readable = true, e2 && ("function" == typeof e2.read && (this._read = e2.read), "function" == typeof e2.destroy && (this._destroy = e2.destroy)), s.call(this);
        }
        function A(e2, t3, r2, n2, o2) {
          u("readableAddChunk", t3);
          var i2,
            s2 = e2._readableState;
          if (null === t3) s2.reading = false, function (e3, t4) {
            if (u("onEofChunk"), t4.ended) return;
            if (t4.decoder) {
              var r3 = t4.decoder.end();
              r3 && r3.length && (t4.buffer.push(r3), t4.length += t4.objectMode ? 1 : r3.length);
            }
            t4.ended = true, t4.sync ? I(e3) : (t4.needReadable = false, t4.emittedReadable || (t4.emittedReadable = true, j(e3)));
          }(e2, s2);else if (o2 || (i2 = function (e3, t4) {
            var r3;
            n3 = t4, a2.isBuffer(n3) || n3 instanceof l || "string" == typeof t4 || void 0 === t4 || e3.objectMode || (r3 = new b("chunk", ["string", "Buffer", "Uint8Array"], t4));
            var n3;
            return r3;
          }(s2, t3)), i2) w(e2, i2);else if (s2.objectMode || t3 && t3.length > 0) {
            if ("string" == typeof t3 || s2.objectMode || Object.getPrototypeOf(t3) === a2.prototype || (t3 = function (e3) {
              return a2.from(e3);
            }(t3)), n2) s2.endEmitted ? w(e2, new S()) : O(e2, s2, t3, true);else if (s2.ended) w(e2, new v());else {
              if (s2.destroyed) return false;
              s2.reading = false, s2.decoder && !r2 ? (t3 = s2.decoder.write(t3), s2.objectMode || 0 !== t3.length ? O(e2, s2, t3, false) : M(e2, s2)) : O(e2, s2, t3, false);
            }
          } else n2 || (s2.reading = false, M(e2, s2));
          return !s2.ended && (s2.length < s2.highWaterMark || 0 === s2.length);
        }
        function O(e2, t3, r2, n2) {
          t3.flowing && 0 === t3.length && !t3.sync ? (t3.awaitDrain = 0, e2.emit("data", r2)) : (t3.length += t3.objectMode ? 1 : r2.length, n2 ? t3.buffer.unshift(r2) : t3.buffer.push(r2), t3.needReadable && I(e2)), M(e2, t3);
        }
        Object.defineProperty(R.prototype, "destroyed", {
          enumerable: false,
          get: function get() {
            return void 0 !== this._readableState && this._readableState.destroyed;
          },
          set: function set(e2) {
            this._readableState && (this._readableState.destroyed = e2);
          }
        }), R.prototype.destroy = d.destroy, R.prototype._undestroy = d.undestroy, R.prototype._destroy = function (e2, t3) {
          t3(e2);
        }, R.prototype.push = function (e2, t3) {
          var r2,
            n2 = this._readableState;
          return n2.objectMode ? r2 = true : "string" == typeof e2 && ((t3 = t3 || n2.defaultEncoding) !== n2.encoding && (e2 = a2.from(e2, t3), t3 = ""), r2 = true), A(this, e2, t3, false, r2);
        }, R.prototype.unshift = function (e2) {
          return A(this, e2, null, true, false);
        }, R.prototype.isPaused = function () {
          return false === this._readableState.flowing;
        }, R.prototype.setEncoding = function (e2) {
          c || (c = r(22).StringDecoder);
          var t3 = new c(e2);
          this._readableState.decoder = t3, this._readableState.encoding = this._readableState.decoder.encoding;
          for (var n2 = this._readableState.buffer.head, o2 = ""; null !== n2;) o2 += t3.write(n2.data), n2 = n2.next;
          return this._readableState.buffer.clear(), "" !== o2 && this._readableState.buffer.push(o2), this._readableState.length = o2.length, this;
        };
        function C(e2, t3) {
          return e2 <= 0 || 0 === t3.length && t3.ended ? 0 : t3.objectMode ? 1 : e2 != e2 ? t3.flowing && t3.length ? t3.buffer.head.data.length : t3.length : (e2 > t3.highWaterMark && (t3.highWaterMark = function (e3) {
            return e3 >= 1073741824 ? e3 = 1073741824 : (e3--, e3 |= e3 >>> 1, e3 |= e3 >>> 2, e3 |= e3 >>> 4, e3 |= e3 >>> 8, e3 |= e3 >>> 16, e3++), e3;
          }(e2)), e2 <= t3.length ? e2 : t3.ended ? t3.length : (t3.needReadable = true, 0));
        }
        function I(e2) {
          var t3 = e2._readableState;
          u("emitReadable", t3.needReadable, t3.emittedReadable), t3.needReadable = false, t3.emittedReadable || (u("emitReadable", t3.flowing), t3.emittedReadable = true, n.nextTick(j, e2));
        }
        function j(e2) {
          var t3 = e2._readableState;
          u("emitReadable_", t3.destroyed, t3.length, t3.ended), t3.destroyed || !t3.length && !t3.ended || (e2.emit("readable"), t3.emittedReadable = false), t3.needReadable = !t3.flowing && !t3.ended && t3.length <= t3.highWaterMark, x(e2);
        }
        function M(e2, t3) {
          t3.readingMore || (t3.readingMore = true, n.nextTick(P, e2, t3));
        }
        function P(e2, t3) {
          for (; !t3.reading && !t3.ended && (t3.length < t3.highWaterMark || t3.flowing && 0 === t3.length);) {
            var r2 = t3.length;
            if (u("maybeReadMore read 0"), e2.read(0), r2 === t3.length) break;
          }
          t3.readingMore = false;
        }
        function N(e2) {
          var t3 = e2._readableState;
          t3.readableListening = e2.listenerCount("readable") > 0, t3.resumeScheduled && !t3.paused ? t3.flowing = true : e2.listenerCount("data") > 0 && e2.resume();
        }
        function L(e2) {
          u("readable nexttick read 0"), e2.read(0);
        }
        function D(e2, t3) {
          u("resume", t3.reading), t3.reading || e2.read(0), t3.resumeScheduled = false, e2.emit("resume"), x(e2), t3.flowing && !t3.reading && e2.read(0);
        }
        function x(e2) {
          var t3 = e2._readableState;
          for (u("flow", t3.flowing); t3.flowing && null !== e2.read(););
        }
        function U(e2, t3) {
          return 0 === t3.length ? null : (t3.objectMode ? r2 = t3.buffer.shift() : !e2 || e2 >= t3.length ? (r2 = t3.decoder ? t3.buffer.join("") : 1 === t3.buffer.length ? t3.buffer.first() : t3.buffer.concat(t3.length), t3.buffer.clear()) : r2 = t3.buffer.consume(e2, t3.decoder), r2);
          var r2;
        }
        function B(e2) {
          var t3 = e2._readableState;
          u("endReadable", t3.endEmitted), t3.endEmitted || (t3.ended = true, n.nextTick(k, t3, e2));
        }
        function k(e2, t3) {
          if (u("endReadableNT", e2.endEmitted, e2.length), !e2.endEmitted && 0 === e2.length && (e2.endEmitted = true, t3.readable = false, t3.emit("end"), e2.autoDestroy)) {
            var r2 = t3._writableState;
            (!r2 || r2.autoDestroy && r2.finished) && t3.destroy();
          }
        }
        function F(e2, t3) {
          for (var r2 = 0, n2 = e2.length; r2 < n2; r2++) if (e2[r2] === t3) return r2;
          return -1;
        }
        R.prototype.read = function (e2) {
          u("read", e2), e2 = parseInt(e2, 10);
          var t3 = this._readableState,
            r2 = e2;
          if (0 !== e2 && (t3.emittedReadable = false), 0 === e2 && t3.needReadable && ((0 !== t3.highWaterMark ? t3.length >= t3.highWaterMark : t3.length > 0) || t3.ended)) return u("read: emitReadable", t3.length, t3.ended), 0 === t3.length && t3.ended ? B(this) : I(this), null;
          if (0 === (e2 = C(e2, t3)) && t3.ended) return 0 === t3.length && B(this), null;
          var n2,
            o2 = t3.needReadable;
          return u("need readable", o2), (0 === t3.length || t3.length - e2 < t3.highWaterMark) && u("length less than watermark", o2 = true), t3.ended || t3.reading ? u("reading or ended", o2 = false) : o2 && (u("do read"), t3.reading = true, t3.sync = true, 0 === t3.length && (t3.needReadable = true), this._read(t3.highWaterMark), t3.sync = false, t3.reading || (e2 = C(r2, t3))), null === (n2 = e2 > 0 ? U(e2, t3) : null) ? (t3.needReadable = t3.length <= t3.highWaterMark, e2 = 0) : (t3.length -= e2, t3.awaitDrain = 0), 0 === t3.length && (t3.ended || (t3.needReadable = true), r2 !== e2 && t3.ended && B(this)), null !== n2 && this.emit("data", n2), n2;
        }, R.prototype._read = function (e2) {
          w(this, new _("_read()"));
        }, R.prototype.pipe = function (e2, t3) {
          var r2 = this,
            o2 = this._readableState;
          switch (o2.pipesCount) {
            case 0:
              o2.pipes = e2;
              break;
            case 1:
              o2.pipes = [o2.pipes, e2];
              break;
            default:
              o2.pipes.push(e2);
          }
          o2.pipesCount += 1, u("pipe count=%d opts=%j", o2.pipesCount, t3);
          var s2 = (!t3 || false !== t3.end) && e2 !== n.stdout && e2 !== n.stderr ? l2 : y2;
          function a3(t4, n2) {
            u("onunpipe"), t4 === r2 && n2 && false === n2.hasUnpiped && (n2.hasUnpiped = true, u("cleanup"), e2.removeListener("close", h2), e2.removeListener("finish", d2), e2.removeListener("drain", g2), e2.removeListener("error", p2), e2.removeListener("unpipe", a3), r2.removeListener("end", l2), r2.removeListener("end", y2), r2.removeListener("data", f2), c2 = true, !o2.awaitDrain || e2._writableState && !e2._writableState.needDrain || g2());
          }
          function l2() {
            u("onend"), e2.end();
          }
          o2.endEmitted ? n.nextTick(s2) : r2.once("end", s2), e2.on("unpipe", a3);
          var g2 = function (e3) {
            return function () {
              var t4 = e3._readableState;
              u("pipeOnDrain", t4.awaitDrain), t4.awaitDrain && t4.awaitDrain--, 0 === t4.awaitDrain && i(e3, "data") && (t4.flowing = true, x(e3));
            };
          }(r2);
          e2.on("drain", g2);
          var c2 = false;
          function f2(t4) {
            u("ondata");
            var n2 = e2.write(t4);
            u("dest.write", n2), false === n2 && ((1 === o2.pipesCount && o2.pipes === e2 || o2.pipesCount > 1 && -1 !== F(o2.pipes, e2)) && !c2 && (u("false write response, pause", o2.awaitDrain), o2.awaitDrain++), r2.pause());
          }
          function p2(t4) {
            u("onerror", t4), y2(), e2.removeListener("error", p2), 0 === i(e2, "error") && w(e2, t4);
          }
          function h2() {
            e2.removeListener("finish", d2), y2();
          }
          function d2() {
            u("onfinish"), e2.removeListener("close", h2), y2();
          }
          function y2() {
            u("unpipe"), r2.unpipe(e2);
          }
          return r2.on("data", f2), function (e3, t4, r3) {
            if ("function" == typeof e3.prependListener) return e3.prependListener(t4, r3);
            e3._events && e3._events[t4] ? Array.isArray(e3._events[t4]) ? e3._events[t4].unshift(r3) : e3._events[t4] = [r3, e3._events[t4]] : e3.on(t4, r3);
          }(e2, "error", p2), e2.once("close", h2), e2.once("finish", d2), e2.emit("pipe", r2), o2.flowing || (u("pipe resume"), r2.resume()), e2;
        }, R.prototype.unpipe = function (e2) {
          var t3 = this._readableState,
            r2 = {
              hasUnpiped: false
            };
          if (0 === t3.pipesCount) return this;
          if (1 === t3.pipesCount) return e2 && e2 !== t3.pipes || (e2 || (e2 = t3.pipes), t3.pipes = null, t3.pipesCount = 0, t3.flowing = false, e2 && e2.emit("unpipe", this, r2)), this;
          if (!e2) {
            var n2 = t3.pipes,
              o2 = t3.pipesCount;
            t3.pipes = null, t3.pipesCount = 0, t3.flowing = false;
            for (var i2 = 0; i2 < o2; i2++) n2[i2].emit("unpipe", this, {
              hasUnpiped: false
            });
            return this;
          }
          var s2 = F(t3.pipes, e2);
          return -1 === s2 || (t3.pipes.splice(s2, 1), t3.pipesCount -= 1, 1 === t3.pipesCount && (t3.pipes = t3.pipes[0]), e2.emit("unpipe", this, r2)), this;
        }, R.prototype.on = function (e2, t3) {
          var r2 = s.prototype.on.call(this, e2, t3),
            o2 = this._readableState;
          return "data" === e2 ? (o2.readableListening = this.listenerCount("readable") > 0, false !== o2.flowing && this.resume()) : "readable" === e2 && (o2.endEmitted || o2.readableListening || (o2.readableListening = o2.needReadable = true, o2.flowing = false, o2.emittedReadable = false, u("on readable", o2.length, o2.reading), o2.length ? I(this) : o2.reading || n.nextTick(L, this))), r2;
        }, R.prototype.addListener = R.prototype.on, R.prototype.removeListener = function (e2, t3) {
          var r2 = s.prototype.removeListener.call(this, e2, t3);
          return "readable" === e2 && n.nextTick(N, this), r2;
        }, R.prototype.removeAllListeners = function (e2) {
          var t3 = s.prototype.removeAllListeners.apply(this, arguments);
          return "readable" !== e2 && void 0 !== e2 || n.nextTick(N, this), t3;
        }, R.prototype.resume = function () {
          var e2 = this._readableState;
          return e2.flowing || (u("resume"), e2.flowing = !e2.readableListening, function (e3, t3) {
            t3.resumeScheduled || (t3.resumeScheduled = true, n.nextTick(D, e3, t3));
          }(this, e2)), e2.paused = false, this;
        }, R.prototype.pause = function () {
          return u("call pause flowing=%j", this._readableState.flowing), false !== this._readableState.flowing && (u("pause"), this._readableState.flowing = false, this.emit("pause")), this._readableState.paused = true, this;
        }, R.prototype.wrap = function (e2) {
          var t3 = this,
            r2 = this._readableState,
            n2 = false;
          for (var o2 in e2.on("end", function () {
            if (u("wrapped end"), r2.decoder && !r2.ended) {
              var e3 = r2.decoder.end();
              e3 && e3.length && t3.push(e3);
            }
            t3.push(null);
          }), e2.on("data", function (o3) {
            (u("wrapped data"), r2.decoder && (o3 = r2.decoder.write(o3)), r2.objectMode && null == o3) || (r2.objectMode || o3 && o3.length) && (t3.push(o3) || (n2 = true, e2.pause()));
          }), e2) void 0 === this[o2] && "function" == typeof e2[o2] && (this[o2] = function (t4) {
            return function () {
              return e2[t4].apply(e2, arguments);
            };
          }(o2));
          for (var i2 = 0; i2 < E.length; i2++) e2.on(E[i2], this.emit.bind(this, E[i2]));
          return this._read = function (t4) {
            u("wrapped _read", t4), n2 && (n2 = false, e2.resume());
          }, this;
        }, "function" == typeof Symbol && (R.prototype[Symbol.asyncIterator] = function () {
          return void 0 === f && (f = r(182)), f(this);
        }), Object.defineProperty(R.prototype, "readableHighWaterMark", {
          enumerable: false,
          get: function get() {
            return this._readableState.highWaterMark;
          }
        }), Object.defineProperty(R.prototype, "readableBuffer", {
          enumerable: false,
          get: function get() {
            return this._readableState && this._readableState.buffer;
          }
        }), Object.defineProperty(R.prototype, "readableFlowing", {
          enumerable: false,
          get: function get() {
            return this._readableState.flowing;
          },
          set: function set(e2) {
            this._readableState && (this._readableState.flowing = e2);
          }
        }), R._fromList = U, Object.defineProperty(R.prototype, "readableLength", {
          enumerable: false,
          get: function get() {
            return this._readableState.length;
          }
        }), "function" == typeof Symbol && (R.from = function (e2, t3) {
          return void 0 === p && (p = r(183)), p(R, e2, t3);
        });
      }).call(this, r(6), r(2));
    }, function (e, t, r) {
      e.exports = r(21).EventEmitter;
    }, function (e, t, r) {
      (function (t2) {
        function r2(e2, t3) {
          o(e2, t3), n(e2);
        }
        function n(e2) {
          e2._writableState && !e2._writableState.emitClose || e2._readableState && !e2._readableState.emitClose || e2.emit("close");
        }
        function o(e2, t3) {
          e2.emit("error", t3);
        }
        e.exports = {
          destroy: function destroy(e2, i) {
            var s = this,
              a2 = this._readableState && this._readableState.destroyed,
              l = this._writableState && this._writableState.destroyed;
            return a2 || l ? (i ? i(e2) : e2 && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = true, t2.nextTick(o, this, e2)) : t2.nextTick(o, this, e2)), this) : (this._readableState && (this._readableState.destroyed = true), this._writableState && (this._writableState.destroyed = true), this._destroy(e2 || null, function (e3) {
              !i && e3 ? s._writableState ? s._writableState.errorEmitted ? t2.nextTick(n, s) : (s._writableState.errorEmitted = true, t2.nextTick(r2, s, e3)) : t2.nextTick(r2, s, e3) : i ? (t2.nextTick(n, s), i(e3)) : t2.nextTick(n, s);
            }), this);
          },
          undestroy: function undestroy() {
            this._readableState && (this._readableState.destroyed = false, this._readableState.reading = false, this._readableState.ended = false, this._readableState.endEmitted = false), this._writableState && (this._writableState.destroyed = false, this._writableState.ended = false, this._writableState.ending = false, this._writableState.finalCalled = false, this._writableState.prefinished = false, this._writableState.finished = false, this._writableState.errorEmitted = false);
          },
          errorOrDestroy: function errorOrDestroy(e2, t3) {
            var r3 = e2._readableState,
              n2 = e2._writableState;
            r3 && r3.autoDestroy || n2 && n2.autoDestroy ? e2.destroy(t3) : e2.emit("error", t3);
          }
        };
      }).call(this, r(2));
    }, function (e, t, r) {
      var n = r(26).codes.ERR_INVALID_OPT_VALUE;
      e.exports = {
        getHighWaterMark: function getHighWaterMark(e2, t2, r2, o) {
          var i = function (e3, t3, r3) {
            return null != e3.highWaterMark ? e3.highWaterMark : t3 ? e3[r3] : null;
          }(t2, o, r2);
          if (null != i) {
            if (!isFinite(i) || Math.floor(i) !== i || i < 0) throw new n(o ? r2 : "highWaterMark", i);
            return Math.floor(i);
          }
          return e2.objectMode ? 16 : 16384;
        }
      };
    }, function (e, t, r) {
      (function (t2, n) {
        function o(e2) {
          var t3 = this;
          this.next = null, this.entry = null, this.finish = function () {
            !function (e3, t4, r2) {
              var n2 = e3.entry;
              e3.entry = null;
              for (; n2;) {
                var o2 = n2.callback;
                t4.pendingcb--, o2(r2), n2 = n2.next;
              }
              t4.corkedRequestsFree.next = e3;
            }(t3, e2);
          };
        }
        var i;
        e.exports = R, R.WritableState = T;
        var s = {
            deprecate: r(43)
          },
          a2 = r(78),
          l = r(5).Buffer,
          u = t2.Uint8Array || function () {};
        var g,
          c = r(79),
          f = r(80).getHighWaterMark,
          p = r(26).codes,
          h = p.ERR_INVALID_ARG_TYPE,
          d = p.ERR_METHOD_NOT_IMPLEMENTED,
          y = p.ERR_MULTIPLE_CALLBACK,
          m = p.ERR_STREAM_CANNOT_PIPE,
          b = p.ERR_STREAM_DESTROYED,
          v = p.ERR_STREAM_NULL_VALUES,
          _ = p.ERR_STREAM_WRITE_AFTER_END,
          S = p.ERR_UNKNOWN_ENCODING,
          w = c.errorOrDestroy;
        function E() {}
        function T(e2, t3, s2) {
          i = i || r(27), e2 = e2 || {}, "boolean" != typeof s2 && (s2 = t3 instanceof i), this.objectMode = !!e2.objectMode, s2 && (this.objectMode = this.objectMode || !!e2.writableObjectMode), this.highWaterMark = f(this, e2, "writableHighWaterMark", s2), this.finalCalled = false, this.needDrain = false, this.ending = false, this.ended = false, this.finished = false, this.destroyed = false;
          var a3 = false === e2.decodeStrings;
          this.decodeStrings = !a3, this.defaultEncoding = e2.defaultEncoding || "utf8", this.length = 0, this.writing = false, this.corked = 0, this.sync = true, this.bufferProcessing = false, this.onwrite = function (e3) {
            !function (e4, t4) {
              var r2 = e4._writableState,
                o2 = r2.sync,
                i2 = r2.writecb;
              if ("function" != typeof i2) throw new y();
              if (function (e5) {
                e5.writing = false, e5.writecb = null, e5.length -= e5.writelen, e5.writelen = 0;
              }(r2), t4) !function (e5, t5, r3, o3, i3) {
                --t5.pendingcb, r3 ? (n.nextTick(i3, o3), n.nextTick(M, e5, t5), e5._writableState.errorEmitted = true, w(e5, o3)) : (i3(o3), e5._writableState.errorEmitted = true, w(e5, o3), M(e5, t5));
              }(e4, r2, o2, t4, i2);else {
                var s3 = I(r2) || e4.destroyed;
                s3 || r2.corked || r2.bufferProcessing || !r2.bufferedRequest || C(e4, r2), o2 ? n.nextTick(O, e4, r2, s3, i2) : O(e4, r2, s3, i2);
              }
            }(t3, e3);
          }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = false, this.errorEmitted = false, this.emitClose = false !== e2.emitClose, this.autoDestroy = !!e2.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
        }
        function R(e2) {
          var t3 = this instanceof (i = i || r(27));
          if (!t3 && !g.call(R, this)) return new R(e2);
          this._writableState = new T(e2, this, t3), this.writable = true, e2 && ("function" == typeof e2.write && (this._write = e2.write), "function" == typeof e2.writev && (this._writev = e2.writev), "function" == typeof e2.destroy && (this._destroy = e2.destroy), "function" == typeof e2.final && (this._final = e2.final)), a2.call(this);
        }
        function A(e2, t3, r2, n2, o2, i2, s2) {
          t3.writelen = n2, t3.writecb = s2, t3.writing = true, t3.sync = true, t3.destroyed ? t3.onwrite(new b("write")) : r2 ? e2._writev(o2, t3.onwrite) : e2._write(o2, i2, t3.onwrite), t3.sync = false;
        }
        function O(e2, t3, r2, n2) {
          r2 || function (e3, t4) {
            0 === t4.length && t4.needDrain && (t4.needDrain = false, e3.emit("drain"));
          }(e2, t3), t3.pendingcb--, n2(), M(e2, t3);
        }
        function C(e2, t3) {
          t3.bufferProcessing = true;
          var r2 = t3.bufferedRequest;
          if (e2._writev && r2 && r2.next) {
            var n2 = t3.bufferedRequestCount,
              i2 = new Array(n2),
              s2 = t3.corkedRequestsFree;
            s2.entry = r2;
            for (var a3 = 0, l2 = true; r2;) i2[a3] = r2, r2.isBuf || (l2 = false), r2 = r2.next, a3 += 1;
            i2.allBuffers = l2, A(e2, t3, true, t3.length, i2, "", s2.finish), t3.pendingcb++, t3.lastBufferedRequest = null, s2.next ? (t3.corkedRequestsFree = s2.next, s2.next = null) : t3.corkedRequestsFree = new o(t3), t3.bufferedRequestCount = 0;
          } else {
            for (; r2;) {
              var u2 = r2.chunk,
                g2 = r2.encoding,
                c2 = r2.callback;
              if (A(e2, t3, false, t3.objectMode ? 1 : u2.length, u2, g2, c2), r2 = r2.next, t3.bufferedRequestCount--, t3.writing) break;
            }
            null === r2 && (t3.lastBufferedRequest = null);
          }
          t3.bufferedRequest = r2, t3.bufferProcessing = false;
        }
        function I(e2) {
          return e2.ending && 0 === e2.length && null === e2.bufferedRequest && !e2.finished && !e2.writing;
        }
        function j(e2, t3) {
          e2._final(function (r2) {
            t3.pendingcb--, r2 && w(e2, r2), t3.prefinished = true, e2.emit("prefinish"), M(e2, t3);
          });
        }
        function M(e2, t3) {
          var r2 = I(t3);
          if (r2 && (function (e3, t4) {
            t4.prefinished || t4.finalCalled || ("function" != typeof e3._final || t4.destroyed ? (t4.prefinished = true, e3.emit("prefinish")) : (t4.pendingcb++, t4.finalCalled = true, n.nextTick(j, e3, t4)));
          }(e2, t3), 0 === t3.pendingcb && (t3.finished = true, e2.emit("finish"), t3.autoDestroy))) {
            var o2 = e2._readableState;
            (!o2 || o2.autoDestroy && o2.endEmitted) && e2.destroy();
          }
          return r2;
        }
        r(7)(R, a2), T.prototype.getBuffer = function () {
          for (var e2 = this.bufferedRequest, t3 = []; e2;) t3.push(e2), e2 = e2.next;
          return t3;
        }, function () {
          try {
            Object.defineProperty(T.prototype, "buffer", {
              get: s.deprecate(function () {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
            });
          } catch (e2) {}
        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (g = Function.prototype[Symbol.hasInstance], Object.defineProperty(R, Symbol.hasInstance, {
          value: function value(e2) {
            return !!g.call(this, e2) || this === R && e2 && e2._writableState instanceof T;
          }
        })) : g = function g(e2) {
          return e2 instanceof this;
        }, R.prototype.pipe = function () {
          w(this, new m());
        }, R.prototype.write = function (e2, t3, r2) {
          var o2,
            i2 = this._writableState,
            s2 = false,
            a3 = !i2.objectMode && (o2 = e2, l.isBuffer(o2) || o2 instanceof u);
          return a3 && !l.isBuffer(e2) && (e2 = function (e3) {
            return l.from(e3);
          }(e2)), "function" == typeof t3 && (r2 = t3, t3 = null), a3 ? t3 = "buffer" : t3 || (t3 = i2.defaultEncoding), "function" != typeof r2 && (r2 = E), i2.ending ? function (e3, t4) {
            var r3 = new _();
            w(e3, r3), n.nextTick(t4, r3);
          }(this, r2) : (a3 || function (e3, t4, r3, o3) {
            var i3;
            return null === r3 ? i3 = new v() : "string" == typeof r3 || t4.objectMode || (i3 = new h("chunk", ["string", "Buffer"], r3)), !i3 || (w(e3, i3), n.nextTick(o3, i3), false);
          }(this, i2, e2, r2)) && (i2.pendingcb++, s2 = function (e3, t4, r3, n2, o3, i3) {
            if (!r3) {
              var s3 = function (e4, t5, r4) {
                e4.objectMode || false === e4.decodeStrings || "string" != typeof t5 || (t5 = l.from(t5, r4));
                return t5;
              }(t4, n2, o3);
              n2 !== s3 && (r3 = true, o3 = "buffer", n2 = s3);
            }
            var a4 = t4.objectMode ? 1 : n2.length;
            t4.length += a4;
            var u2 = t4.length < t4.highWaterMark;
            u2 || (t4.needDrain = true);
            if (t4.writing || t4.corked) {
              var g2 = t4.lastBufferedRequest;
              t4.lastBufferedRequest = {
                chunk: n2,
                encoding: o3,
                isBuf: r3,
                callback: i3,
                next: null
              }, g2 ? g2.next = t4.lastBufferedRequest : t4.bufferedRequest = t4.lastBufferedRequest, t4.bufferedRequestCount += 1;
            } else A(e3, t4, false, a4, n2, o3, i3);
            return u2;
          }(this, i2, a3, e2, t3, r2)), s2;
        }, R.prototype.cork = function () {
          this._writableState.corked++;
        }, R.prototype.uncork = function () {
          var e2 = this._writableState;
          e2.corked && (e2.corked--, e2.writing || e2.corked || e2.bufferProcessing || !e2.bufferedRequest || C(this, e2));
        }, R.prototype.setDefaultEncoding = function (e2) {
          if ("string" == typeof e2 && (e2 = e2.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e2 + "").toLowerCase()) > -1)) throw new S(e2);
          return this._writableState.defaultEncoding = e2, this;
        }, Object.defineProperty(R.prototype, "writableBuffer", {
          enumerable: false,
          get: function get() {
            return this._writableState && this._writableState.getBuffer();
          }
        }), Object.defineProperty(R.prototype, "writableHighWaterMark", {
          enumerable: false,
          get: function get() {
            return this._writableState.highWaterMark;
          }
        }), R.prototype._write = function (e2, t3, r2) {
          r2(new d("_write()"));
        }, R.prototype._writev = null, R.prototype.end = function (e2, t3, r2) {
          var o2 = this._writableState;
          return "function" == typeof e2 ? (r2 = e2, e2 = null, t3 = null) : "function" == typeof t3 && (r2 = t3, t3 = null), null != e2 && this.write(e2, t3), o2.corked && (o2.corked = 1, this.uncork()), o2.ending || function (e3, t4, r3) {
            t4.ending = true, M(e3, t4), r3 && (t4.finished ? n.nextTick(r3) : e3.once("finish", r3));
            t4.ended = true, e3.writable = false;
          }(this, o2, r2), this;
        }, Object.defineProperty(R.prototype, "writableLength", {
          enumerable: false,
          get: function get() {
            return this._writableState.length;
          }
        }), Object.defineProperty(R.prototype, "destroyed", {
          enumerable: false,
          get: function get() {
            return void 0 !== this._writableState && this._writableState.destroyed;
          },
          set: function set(e2) {
            this._writableState && (this._writableState.destroyed = e2);
          }
        }), R.prototype.destroy = c.destroy, R.prototype._undestroy = c.undestroy, R.prototype._destroy = function (e2, t3) {
          t3(e2);
        };
      }).call(this, r(6), r(2));
    }, function (e, t, r) {
      e.exports = g;
      var n = r(26).codes,
        o = n.ERR_METHOD_NOT_IMPLEMENTED,
        i = n.ERR_MULTIPLE_CALLBACK,
        s = n.ERR_TRANSFORM_ALREADY_TRANSFORMING,
        a2 = n.ERR_TRANSFORM_WITH_LENGTH_0,
        l = r(27);
      function u(e2, t2) {
        var r2 = this._transformState;
        r2.transforming = false;
        var n2 = r2.writecb;
        if (null === n2) return this.emit("error", new i());
        r2.writechunk = null, r2.writecb = null, null != t2 && this.push(t2), n2(e2);
        var o2 = this._readableState;
        o2.reading = false, (o2.needReadable || o2.length < o2.highWaterMark) && this._read(o2.highWaterMark);
      }
      function g(e2) {
        if (!(this instanceof g)) return new g(e2);
        l.call(this, e2), this._transformState = {
          afterTransform: u.bind(this),
          needTransform: false,
          transforming: false,
          writecb: null,
          writechunk: null,
          writeencoding: null
        }, this._readableState.needReadable = true, this._readableState.sync = false, e2 && ("function" == typeof e2.transform && (this._transform = e2.transform), "function" == typeof e2.flush && (this._flush = e2.flush)), this.on("prefinish", c);
      }
      function c() {
        var e2 = this;
        "function" != typeof this._flush || this._readableState.destroyed ? f(this, null, null) : this._flush(function (t2, r2) {
          f(e2, t2, r2);
        });
      }
      function f(e2, t2, r2) {
        if (t2) return e2.emit("error", t2);
        if (null != r2 && e2.push(r2), e2._writableState.length) throw new a2();
        if (e2._transformState.transforming) throw new s();
        return e2.push(null);
      }
      r(7)(g, l), g.prototype.push = function (e2, t2) {
        return this._transformState.needTransform = false, l.prototype.push.call(this, e2, t2);
      }, g.prototype._transform = function (e2, t2, r2) {
        r2(new o("_transform()"));
      }, g.prototype._write = function (e2, t2, r2) {
        var n2 = this._transformState;
        if (n2.writecb = r2, n2.writechunk = e2, n2.writeencoding = t2, !n2.transforming) {
          var o2 = this._readableState;
          (n2.needTransform || o2.needReadable || o2.length < o2.highWaterMark) && this._read(o2.highWaterMark);
        }
      }, g.prototype._read = function (e2) {
        var t2 = this._transformState;
        null === t2.writechunk || t2.transforming ? t2.needTransform = true : (t2.transforming = true, this._transform(t2.writechunk, t2.writeencoding, t2.afterTransform));
      }, g.prototype._destroy = function (e2, t2) {
        l.prototype._destroy.call(this, e2, function (e3) {
          t2(e3);
        });
      };
    }, function (e, t, r) {
      (function (e2) {
        var n = r(190),
          o = r(85),
          i = r(192),
          s = r(193),
          a2 = r(86),
          l = t;
        l.request = function (t2, r2) {
          t2 = "string" == typeof t2 ? a2.parse(t2) : i(t2);
          var o2 = -1 === e2.location.protocol.search(/^https?:$/) ? "http:" : "",
            s2 = t2.protocol || o2,
            l2 = t2.hostname || t2.host,
            u = t2.port,
            g = t2.path || "/";
          l2 && -1 !== l2.indexOf(":") && (l2 = "[" + l2 + "]"), t2.url = (l2 ? s2 + "//" + l2 : "") + (u ? ":" + u : "") + g, t2.method = (t2.method || "GET").toUpperCase(), t2.headers = t2.headers || {};
          var c = new n(t2);
          return r2 && c.on("response", r2), c;
        }, l.get = function (e3, t2) {
          var r2 = l.request(e3, t2);
          return r2.end(), r2;
        }, l.ClientRequest = n, l.IncomingMessage = o.IncomingMessage, l.Agent = function () {}, l.Agent.defaultMaxSockets = 4, l.globalAgent = new l.Agent(), l.STATUS_CODES = s, l.METHODS = ["CHECKOUT", "CONNECT", "COPY", "DELETE", "GET", "HEAD", "LOCK", "M-SEARCH", "MERGE", "MKACTIVITY", "MKCOL", "MOVE", "NOTIFY", "OPTIONS", "PATCH", "POST", "PROPFIND", "PROPPATCH", "PURGE", "PUT", "REPORT", "SEARCH", "SUBSCRIBE", "TRACE", "UNLOCK", "UNSUBSCRIBE"];
      }).call(this, r(6));
    }, function (e, t, r) {
      (function (e2) {
        t.fetch = a2(e2.fetch) && a2(e2.ReadableStream), t.writableStream = a2(e2.WritableStream), t.abortController = a2(e2.AbortController), t.blobConstructor = false;
        try {
          new Blob([new ArrayBuffer(1)]), t.blobConstructor = true;
        } catch (e3) {}
        var r2;
        function n() {
          if (void 0 !== r2) return r2;
          if (e2.XMLHttpRequest) {
            r2 = new e2.XMLHttpRequest();
            try {
              r2.open("GET", e2.XDomainRequest ? "/" : "https://example.com");
            } catch (e3) {
              r2 = null;
            }
          } else r2 = null;
          return r2;
        }
        function o(e3) {
          var t2 = n();
          if (!t2) return false;
          try {
            return t2.responseType = e3, t2.responseType === e3;
          } catch (e4) {}
          return false;
        }
        var i = void 0 !== e2.ArrayBuffer,
          s = i && a2(e2.ArrayBuffer.prototype.slice);
        function a2(e3) {
          return "function" == typeof e3;
        }
        t.arraybuffer = t.fetch || i && o("arraybuffer"), t.msstream = !t.fetch && s && o("ms-stream"), t.mozchunkedarraybuffer = !t.fetch && i && o("moz-chunked-arraybuffer"), t.overrideMimeType = t.fetch || !!n() && a2(n().overrideMimeType), t.vbArray = a2(e2.VBArray), r2 = null;
      }).call(this, r(6));
    }, function (e, t, r) {
      (function (e2, n, o) {
        var i = r(84),
          s = r(7),
          a2 = r(31),
          l = t.readyStates = {
            UNSENT: 0,
            OPENED: 1,
            HEADERS_RECEIVED: 2,
            LOADING: 3,
            DONE: 4
          },
          u = t.IncomingMessage = function (t2, r2, s2, l2) {
            var u2 = this;
            if (a2.Readable.call(u2), u2._mode = s2, u2.headers = {}, u2.rawHeaders = [], u2.trailers = {}, u2.rawTrailers = [], u2.on("end", function () {
              e2.nextTick(function () {
                u2.emit("close");
              });
            }), "fetch" === s2) {
              if (u2._fetchResponse = r2, u2.url = r2.url, u2.statusCode = r2.status, u2.statusMessage = r2.statusText, r2.headers.forEach(function (e3, t3) {
                u2.headers[t3.toLowerCase()] = e3, u2.rawHeaders.push(t3, e3);
              }), i.writableStream) {
                var g = new WritableStream({
                  write: function write(e3) {
                    return new Promise(function (t3, r3) {
                      u2._destroyed ? r3() : u2.push(new n(e3)) ? t3() : u2._resumeFetch = t3;
                    });
                  },
                  close: function close() {
                    o.clearTimeout(l2), u2._destroyed || u2.push(null);
                  },
                  abort: function abort(e3) {
                    u2._destroyed || u2.emit("error", e3);
                  }
                });
                try {
                  return void r2.body.pipeTo(g).catch(function (e3) {
                    o.clearTimeout(l2), u2._destroyed || u2.emit("error", e3);
                  });
                } catch (e3) {}
              }
              var c = r2.body.getReader();
              !function e3() {
                c.read().then(function (t3) {
                  if (!u2._destroyed) {
                    if (t3.done) return o.clearTimeout(l2), void u2.push(null);
                    u2.push(new n(t3.value)), e3();
                  }
                }).catch(function (e4) {
                  o.clearTimeout(l2), u2._destroyed || u2.emit("error", e4);
                });
              }();
            } else {
              if (u2._xhr = t2, u2._pos = 0, u2.url = t2.responseURL, u2.statusCode = t2.status, u2.statusMessage = t2.statusText, t2.getAllResponseHeaders().split(/\r?\n/).forEach(function (e3) {
                var t3 = e3.match(/^([^:]+):\s*(.*)/);
                if (t3) {
                  var r3 = t3[1].toLowerCase();
                  "set-cookie" === r3 ? (void 0 === u2.headers[r3] && (u2.headers[r3] = []), u2.headers[r3].push(t3[2])) : void 0 !== u2.headers[r3] ? u2.headers[r3] += ", " + t3[2] : u2.headers[r3] = t3[2], u2.rawHeaders.push(t3[1], t3[2]);
                }
              }), u2._charset = "x-user-defined", !i.overrideMimeType) {
                var f = u2.rawHeaders["mime-type"];
                if (f) {
                  var p = f.match(/;\s*charset=([^;])(;|$)/);
                  p && (u2._charset = p[1].toLowerCase());
                }
                u2._charset || (u2._charset = "utf-8");
              }
            }
          };
        s(u, a2.Readable), u.prototype._read = function () {
          var e3 = this._resumeFetch;
          e3 && (this._resumeFetch = null, e3());
        }, u.prototype._onXHRProgress = function () {
          var e3 = this,
            t2 = e3._xhr,
            r2 = null;
          switch (e3._mode) {
            case "text:vbarray":
              if (t2.readyState !== l.DONE) break;
              try {
                r2 = new o.VBArray(t2.responseBody).toArray();
              } catch (e4) {}
              if (null !== r2) {
                e3.push(new n(r2));
                break;
              }
            case "text":
              try {
                r2 = t2.responseText;
              } catch (t3) {
                e3._mode = "text:vbarray";
                break;
              }
              if (r2.length > e3._pos) {
                var i2 = r2.substr(e3._pos);
                if ("x-user-defined" === e3._charset) {
                  for (var s2 = new n(i2.length), a3 = 0; a3 < i2.length; a3++) s2[a3] = 255 & i2.charCodeAt(a3);
                  e3.push(s2);
                } else e3.push(i2, e3._charset);
                e3._pos = r2.length;
              }
              break;
            case "arraybuffer":
              if (t2.readyState !== l.DONE || !t2.response) break;
              r2 = t2.response, e3.push(new n(new Uint8Array(r2)));
              break;
            case "moz-chunked-arraybuffer":
              if (r2 = t2.response, t2.readyState !== l.LOADING || !r2) break;
              e3.push(new n(new Uint8Array(r2)));
              break;
            case "ms-stream":
              if (r2 = t2.response, t2.readyState !== l.LOADING) break;
              var u2 = new o.MSStreamReader();
              u2.onprogress = function () {
                u2.result.byteLength > e3._pos && (e3.push(new n(new Uint8Array(u2.result.slice(e3._pos)))), e3._pos = u2.result.byteLength);
              }, u2.onload = function () {
                e3.push(null);
              }, u2.readAsArrayBuffer(r2);
          }
          e3._xhr.readyState === l.DONE && "ms-stream" !== e3._mode && e3.push(null);
        };
      }).call(this, r(2), r(5).Buffer, r(6));
    }, function (e, t, r) {
      var n = r(194),
        o = r(196);
      function i() {
        this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
      }
      t.parse = v, t.resolve = function (e2, t2) {
        return v(e2, false, true).resolve(t2);
      }, t.resolveObject = function (e2, t2) {
        return e2 ? v(e2, false, true).resolveObject(t2) : t2;
      }, t.format = function (e2) {
        o.isString(e2) && (e2 = v(e2));
        return e2 instanceof i ? e2.format() : i.prototype.format.call(e2);
      }, t.Url = i;
      var s = /^([a-z0-9.+-]+:)/i,
        a2 = /:[0-9]*$/,
        l = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
        u = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "	"]),
        g = ["'"].concat(u),
        c = ["%", "/", "?", ";", "#"].concat(g),
        f = ["/", "?", "#"],
        p = /^[+a-z0-9A-Z_-]{0,63}$/,
        h = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
        d = {
          javascript: true,
          "javascript:": true
        },
        y = {
          javascript: true,
          "javascript:": true
        },
        m = {
          http: true,
          https: true,
          ftp: true,
          gopher: true,
          file: true,
          "http:": true,
          "https:": true,
          "ftp:": true,
          "gopher:": true,
          "file:": true
        },
        b = r(197);
      function v(e2, t2, r2) {
        if (e2 && o.isObject(e2) && e2 instanceof i) return e2;
        var n2 = new i();
        return n2.parse(e2, t2, r2), n2;
      }
      i.prototype.parse = function (e2, t2, r2) {
        if (!o.isString(e2)) throw new TypeError("Parameter 'url' must be a string, not " + typeof e2);
        var i2 = e2.indexOf("?"),
          a3 = -1 !== i2 && i2 < e2.indexOf("#") ? "?" : "#",
          u2 = e2.split(a3);
        u2[0] = u2[0].replace(/\\/g, "/");
        var v2 = e2 = u2.join(a3);
        if (v2 = v2.trim(), !r2 && 1 === e2.split("#").length) {
          var _ = l.exec(v2);
          if (_) return this.path = v2, this.href = v2, this.pathname = _[1], _[2] ? (this.search = _[2], this.query = t2 ? b.parse(this.search.substr(1)) : this.search.substr(1)) : t2 && (this.search = "", this.query = {}), this;
        }
        var S = s.exec(v2);
        if (S) {
          var w = (S = S[0]).toLowerCase();
          this.protocol = w, v2 = v2.substr(S.length);
        }
        if (r2 || S || v2.match(/^\/\/[^@\/]+@[^@\/]+/)) {
          var E = "//" === v2.substr(0, 2);
          !E || S && y[S] || (v2 = v2.substr(2), this.slashes = true);
        }
        if (!y[S] && (E || S && !m[S])) {
          for (var T, R, A = -1, O = 0; O < f.length; O++) {
            -1 !== (C = v2.indexOf(f[O])) && (-1 === A || C < A) && (A = C);
          }
          -1 !== (R = -1 === A ? v2.lastIndexOf("@") : v2.lastIndexOf("@", A)) && (T = v2.slice(0, R), v2 = v2.slice(R + 1), this.auth = decodeURIComponent(T)), A = -1;
          for (O = 0; O < c.length; O++) {
            var C;
            -1 !== (C = v2.indexOf(c[O])) && (-1 === A || C < A) && (A = C);
          }
          -1 === A && (A = v2.length), this.host = v2.slice(0, A), v2 = v2.slice(A), this.parseHost(), this.hostname = this.hostname || "";
          var I = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
          if (!I) for (var j = this.hostname.split(/\./), M = (O = 0, j.length); O < M; O++) {
            var P = j[O];
            if (P && !P.match(p)) {
              for (var N = "", L = 0, D = P.length; L < D; L++) P.charCodeAt(L) > 127 ? N += "x" : N += P[L];
              if (!N.match(p)) {
                var x = j.slice(0, O),
                  U = j.slice(O + 1),
                  B = P.match(h);
                B && (x.push(B[1]), U.unshift(B[2])), U.length && (v2 = "/" + U.join(".") + v2), this.hostname = x.join(".");
                break;
              }
            }
          }
          this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), I || (this.hostname = n.toASCII(this.hostname));
          var k = this.port ? ":" + this.port : "",
            F = this.hostname || "";
          this.host = F + k, this.href += this.host, I && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== v2[0] && (v2 = "/" + v2));
        }
        if (!d[w]) for (O = 0, M = g.length; O < M; O++) {
          var W = g[O];
          if (-1 !== v2.indexOf(W)) {
            var V = encodeURIComponent(W);
            V === W && (V = escape(W)), v2 = v2.split(W).join(V);
          }
        }
        var H = v2.indexOf("#");
        -1 !== H && (this.hash = v2.substr(H), v2 = v2.slice(0, H));
        var z = v2.indexOf("?");
        if (-1 !== z ? (this.search = v2.substr(z), this.query = v2.substr(z + 1), t2 && (this.query = b.parse(this.query)), v2 = v2.slice(0, z)) : t2 && (this.search = "", this.query = {}), v2 && (this.pathname = v2), m[w] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
          k = this.pathname || "";
          var G = this.search || "";
          this.path = k + G;
        }
        return this.href = this.format(), this;
      }, i.prototype.format = function () {
        var e2 = this.auth || "";
        e2 && (e2 = (e2 = encodeURIComponent(e2)).replace(/%3A/i, ":"), e2 += "@");
        var t2 = this.protocol || "",
          r2 = this.pathname || "",
          n2 = this.hash || "",
          i2 = false,
          s2 = "";
        this.host ? i2 = e2 + this.host : this.hostname && (i2 = e2 + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (i2 += ":" + this.port)), this.query && o.isObject(this.query) && Object.keys(this.query).length && (s2 = b.stringify(this.query));
        var a3 = this.search || s2 && "?" + s2 || "";
        return t2 && ":" !== t2.substr(-1) && (t2 += ":"), this.slashes || (!t2 || m[t2]) && false !== i2 ? (i2 = "//" + (i2 || ""), r2 && "/" !== r2.charAt(0) && (r2 = "/" + r2)) : i2 || (i2 = ""), n2 && "#" !== n2.charAt(0) && (n2 = "#" + n2), a3 && "?" !== a3.charAt(0) && (a3 = "?" + a3), t2 + i2 + (r2 = r2.replace(/[?#]/g, function (e3) {
          return encodeURIComponent(e3);
        })) + (a3 = a3.replace("#", "%23")) + n2;
      }, i.prototype.resolve = function (e2) {
        return this.resolveObject(v(e2, false, true)).format();
      }, i.prototype.resolveObject = function (e2) {
        if (o.isString(e2)) {
          var t2 = new i();
          t2.parse(e2, false, true), e2 = t2;
        }
        for (var r2 = new i(), n2 = Object.keys(this), s2 = 0; s2 < n2.length; s2++) {
          var a3 = n2[s2];
          r2[a3] = this[a3];
        }
        if (r2.hash = e2.hash, "" === e2.href) return r2.href = r2.format(), r2;
        if (e2.slashes && !e2.protocol) {
          for (var l2 = Object.keys(e2), u2 = 0; u2 < l2.length; u2++) {
            var g2 = l2[u2];
            "protocol" !== g2 && (r2[g2] = e2[g2]);
          }
          return m[r2.protocol] && r2.hostname && !r2.pathname && (r2.path = r2.pathname = "/"), r2.href = r2.format(), r2;
        }
        if (e2.protocol && e2.protocol !== r2.protocol) {
          if (!m[e2.protocol]) {
            for (var c2 = Object.keys(e2), f2 = 0; f2 < c2.length; f2++) {
              var p2 = c2[f2];
              r2[p2] = e2[p2];
            }
            return r2.href = r2.format(), r2;
          }
          if (r2.protocol = e2.protocol, e2.host || y[e2.protocol]) r2.pathname = e2.pathname;else {
            for (var h2 = (e2.pathname || "").split("/"); h2.length && !(e2.host = h2.shift()););
            e2.host || (e2.host = ""), e2.hostname || (e2.hostname = ""), "" !== h2[0] && h2.unshift(""), h2.length < 2 && h2.unshift(""), r2.pathname = h2.join("/");
          }
          if (r2.search = e2.search, r2.query = e2.query, r2.host = e2.host || "", r2.auth = e2.auth, r2.hostname = e2.hostname || e2.host, r2.port = e2.port, r2.pathname || r2.search) {
            var d2 = r2.pathname || "",
              b2 = r2.search || "";
            r2.path = d2 + b2;
          }
          return r2.slashes = r2.slashes || e2.slashes, r2.href = r2.format(), r2;
        }
        var v2 = r2.pathname && "/" === r2.pathname.charAt(0),
          _ = e2.host || e2.pathname && "/" === e2.pathname.charAt(0),
          S = _ || v2 || r2.host && e2.pathname,
          w = S,
          E = r2.pathname && r2.pathname.split("/") || [],
          T = (h2 = e2.pathname && e2.pathname.split("/") || [], r2.protocol && !m[r2.protocol]);
        if (T && (r2.hostname = "", r2.port = null, r2.host && ("" === E[0] ? E[0] = r2.host : E.unshift(r2.host)), r2.host = "", e2.protocol && (e2.hostname = null, e2.port = null, e2.host && ("" === h2[0] ? h2[0] = e2.host : h2.unshift(e2.host)), e2.host = null), S = S && ("" === h2[0] || "" === E[0])), _) r2.host = e2.host || "" === e2.host ? e2.host : r2.host, r2.hostname = e2.hostname || "" === e2.hostname ? e2.hostname : r2.hostname, r2.search = e2.search, r2.query = e2.query, E = h2;else if (h2.length) E || (E = []), E.pop(), E = E.concat(h2), r2.search = e2.search, r2.query = e2.query;else if (!o.isNullOrUndefined(e2.search)) {
          if (T) r2.hostname = r2.host = E.shift(), (I = !!(r2.host && r2.host.indexOf("@") > 0) && r2.host.split("@")) && (r2.auth = I.shift(), r2.host = r2.hostname = I.shift());
          return r2.search = e2.search, r2.query = e2.query, o.isNull(r2.pathname) && o.isNull(r2.search) || (r2.path = (r2.pathname ? r2.pathname : "") + (r2.search ? r2.search : "")), r2.href = r2.format(), r2;
        }
        if (!E.length) return r2.pathname = null, r2.search ? r2.path = "/" + r2.search : r2.path = null, r2.href = r2.format(), r2;
        for (var R = E.slice(-1)[0], A = (r2.host || e2.host || E.length > 1) && ("." === R || ".." === R) || "" === R, O = 0, C = E.length; C >= 0; C--) "." === (R = E[C]) ? E.splice(C, 1) : ".." === R ? (E.splice(C, 1), O++) : O && (E.splice(C, 1), O--);
        if (!S && !w) for (; O--; O) E.unshift("..");
        !S || "" === E[0] || E[0] && "/" === E[0].charAt(0) || E.unshift(""), A && "/" !== E.join("/").substr(-1) && E.push("");
        var I,
          j = "" === E[0] || E[0] && "/" === E[0].charAt(0);
        T && (r2.hostname = r2.host = j ? "" : E.length ? E.shift() : "", (I = !!(r2.host && r2.host.indexOf("@") > 0) && r2.host.split("@")) && (r2.auth = I.shift(), r2.host = r2.hostname = I.shift()));
        return (S = S || r2.host && E.length) && !j && E.unshift(""), E.length ? r2.pathname = E.join("/") : (r2.pathname = null, r2.path = null), o.isNull(r2.pathname) && o.isNull(r2.search) || (r2.path = (r2.pathname ? r2.pathname : "") + (r2.search ? r2.search : "")), r2.auth = e2.auth || r2.auth, r2.slashes = r2.slashes || e2.slashes, r2.href = r2.format(), r2;
      }, i.prototype.parseHost = function () {
        var e2 = this.host,
          t2 = a2.exec(e2);
        t2 && (":" !== (t2 = t2[0]) && (this.port = t2.substr(1)), e2 = e2.substr(0, e2.length - t2.length)), e2 && (this.hostname = e2);
      };
    }, function (e, t, r) {
      var n = function n(e2) {
        return null !== e2 && "object" == typeof e2 && "function" == typeof e2.pipe;
      };
      n.writable = function (e2) {
        return n(e2) && false !== e2.writable && "function" == typeof e2._write && "object" == typeof e2._writableState;
      }, n.readable = function (e2) {
        return n(e2) && false !== e2.readable && "function" == typeof e2._read && "object" == typeof e2._readableState;
      }, n.duplex = function (e2) {
        return n.writable(e2) && n.readable(e2);
      }, n.transform = function (e2) {
        return n.duplex(e2) && "function" == typeof e2._transform && "object" == typeof e2._transformState;
      }, e.exports = n;
    }, function (e, t, r) {
      function n(e2) {
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e3) {
          return typeof e3;
        } : function (e3) {
          return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
        })(e2);
      }
      function o(e2, t2) {
        if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
      }
      function i(e2, t2) {
        if ("function" != typeof t2 && null !== t2) throw new TypeError("Super expression must either be null or a function");
        e2.prototype = Object.create(t2 && t2.prototype, {
          constructor: {
            value: e2,
            writable: true,
            configurable: true
          }
        }), t2 && s(e2, t2);
      }
      function s(e2, t2) {
        return (s = Object.setPrototypeOf || function (e3, t3) {
          return e3.__proto__ = t3, e3;
        })(e2, t2);
      }
      function a2(e2) {
        var t2 = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return false;
          if (Reflect.construct.sham) return false;
          if ("function" == typeof Proxy) return true;
          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), true;
          } catch (e3) {
            return false;
          }
        }();
        return function () {
          var r2,
            n2 = u(e2);
          if (t2) {
            var o2 = u(this).constructor;
            r2 = Reflect.construct(n2, arguments, o2);
          } else r2 = n2.apply(this, arguments);
          return l(this, r2);
        };
      }
      function l(e2, t2) {
        return !t2 || "object" !== n(t2) && "function" != typeof t2 ? function (e3) {
          if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e3;
        }(e2) : t2;
      }
      function u(e2) {
        return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e3) {
          return e3.__proto__ || Object.getPrototypeOf(e3);
        })(e2);
      }
      var g = r(3).LEVEL,
        c = r(50),
        f = r(202),
        p = r(38)("winston:create-logger");
      function h(e2) {
        return "is" + e2.charAt(0).toUpperCase() + e2.slice(1) + "Enabled";
      }
      e.exports = function () {
        var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        e2.levels = e2.levels || c.npm.levels;
        var t2 = function (e3) {
            i(r3, e3);
            var t3 = a2(r3);
            function r3(e4) {
              return o(this, r3), t3.call(this, e4);
            }
            return r3;
          }(f),
          r2 = new t2(e2);
        return Object.keys(e2.levels).forEach(function (e3) {
          p('Define prototype method for "%s"', e3), "log" !== e3 ? (t2.prototype[e3] = function () {
            for (var t3 = this || r2, n2 = arguments.length, o2 = new Array(n2), i2 = 0; i2 < n2; i2++) o2[i2] = arguments[i2];
            if (1 === o2.length) {
              var s2 = o2[0],
                a3 = s2 && s2.message && s2 || {
                  message: s2
                };
              return a3.level = a3[g] = e3, t3._addDefaultMeta(a3), t3.write(a3), this || r2;
            }
            return 0 === o2.length ? (t3.log(e3, ""), t3) : t3.log.apply(t3, [e3].concat(o2));
          }, t2.prototype[h(e3)] = function () {
            return (this || r2).isLevelEnabled(e3);
          }) : console.warn('Level "log" not defined: conflicts with the method "log". Use a different level name.');
        }), r2;
      };
    }, function (e, t, r) {
      (function (t2) {
        function n(e2, t3) {
          for (var r2 = 0; r2 < t3.length; r2++) {
            var n2 = t3[r2];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
          }
        }
        var o = r(18),
          i = r(51),
          s = r(38)("winston:exception"),
          a2 = r(90),
          l = r(91),
          u = r(92);
        e.exports = function () {
          function e2(t3) {
            if (function (e3, t4) {
              if (!(e3 instanceof t4)) throw new TypeError("Cannot call a class as a function");
            }(this, e2), !t3) throw new Error("Logger is required to handle exceptions");
            this.logger = t3, this.handlers = /* @__PURE__ */new Map();
          }
          var r2, g;
          return r2 = e2, (g = [{
            key: "handle",
            value: function value() {
              for (var e3 = this, r3 = arguments.length, n2 = new Array(r3), o2 = 0; o2 < r3; o2++) n2[o2] = arguments[o2];
              n2.forEach(function (t3) {
                if (Array.isArray(t3)) return t3.forEach(function (t4) {
                  return e3._addHandler(t4);
                });
                e3._addHandler(t3);
              }), this.catcher || (this.catcher = this._uncaughtException.bind(this), t2.on("uncaughtException", this.catcher));
            }
          }, {
            key: "unhandle",
            value: function value() {
              var e3 = this;
              this.catcher && (t2.removeListener("uncaughtException", this.catcher), this.catcher = false, Array.from(this.handlers.values()).forEach(function (t3) {
                return e3.logger.unpipe(t3);
              }));
            }
          }, {
            key: "getAllInfo",
            value: function value(e3) {
              var t3 = e3.message;
              return t3 || "string" != typeof e3 || (t3 = e3), {
                error: e3,
                level: "error",
                message: ["uncaughtException: ".concat(t3 || "(no error message)"), e3.stack || "  No stack trace"].join("\n"),
                stack: e3.stack,
                exception: true,
                date: new Date().toString(),
                process: this.getProcessInfo(),
                os: this.getOsInfo(),
                trace: this.getTrace(e3)
              };
            }
          }, {
            key: "getProcessInfo",
            value: function value() {
              return {
                pid: t2.pid,
                uid: t2.getuid ? t2.getuid() : null,
                gid: t2.getgid ? t2.getgid() : null,
                cwd: t2.cwd(),
                execPath: t2.execPath,
                version: t2.version,
                argv: t2.argv,
                memoryUsage: t2.memoryUsage()
              };
            }
          }, {
            key: "getOsInfo",
            value: function value() {
              return {
                loadavg: o.loadavg(),
                uptime: o.uptime()
              };
            }
          }, {
            key: "getTrace",
            value: function value(e3) {
              return (e3 ? l.parse(e3) : l.get()).map(function (e4) {
                return {
                  column: e4.getColumnNumber(),
                  file: e4.getFileName(),
                  function: e4.getFunctionName(),
                  line: e4.getLineNumber(),
                  method: e4.getMethodName(),
                  native: e4.isNative()
                };
              });
            }
          }, {
            key: "_addHandler",
            value: function value(e3) {
              if (!this.handlers.has(e3)) {
                e3.handleExceptions = true;
                var t3 = new u(e3);
                this.handlers.set(e3, t3), this.logger.pipe(t3);
              }
            }
          }, {
            key: "_uncaughtException",
            value: function value(e3) {
              var r3,
                n2 = this.getAllInfo(e3),
                o2 = this._getExceptionHandlers(),
                l2 = "function" == typeof this.logger.exitOnError ? this.logger.exitOnError(e3) : this.logger.exitOnError;
              function u2() {
                s("doExit", l2), s("process._exiting", t2._exiting), l2 && !t2._exiting && (r3 && clearTimeout(r3), t2.exit(1));
              }
              if (!o2.length && l2 && (console.warn("winston: exitOnError cannot be true with no exception handlers."), console.warn("winston: not exiting process."), l2 = false), !o2 || 0 === o2.length) return t2.nextTick(u2);
              i(o2, function (e4, t3) {
                var r4 = a2(t3),
                  n3 = e4.transport || e4;
                function o3(e5) {
                  return function () {
                    s(e5), r4();
                  };
                }
                n3._ending = true, n3.once("finish", o3("finished")), n3.once("error", o3("error"));
              }, function () {
                return l2 && u2();
              }), this.logger.log(n2), l2 && (r3 = setTimeout(u2, 3e3));
            }
          }, {
            key: "_getExceptionHandlers",
            value: function value() {
              return this.logger.transports.filter(function (e3) {
                return (e3.transport || e3).handleExceptions;
              });
            }
          }]) && n(r2.prototype, g), e2;
        }();
      }).call(this, r(2));
    }, function (e, t, r) {
      var n = r(205);
      e.exports = function (e2) {
        var t2,
          r2 = 0;
        function o() {
          return r2 || (r2 = 1, t2 = e2.apply(this, arguments), e2 = null), t2;
        }
        return o.displayName = n(e2), o;
      };
    }, function (e, t) {
      function r(e2) {
        for (var t2 in e2) this[t2] = e2[t2];
      }
      t.get = function (e2) {
        var r2 = Error.stackTraceLimit;
        Error.stackTraceLimit = 1 / 0;
        var n = {},
          o = Error.prepareStackTrace;
        Error.prepareStackTrace = function (e3, t2) {
          return t2;
        }, Error.captureStackTrace(n, e2 || t.get);
        var i = n.stack;
        return Error.prepareStackTrace = o, Error.stackTraceLimit = r2, i;
      }, t.parse = function (e2) {
        if (!e2.stack) return [];
        var t2 = this;
        return e2.stack.split("\n").slice(1).map(function (e3) {
          if (e3.match(/^\s*[-]{4,}$/)) return t2._createParsedCallSite({
            fileName: e3,
            lineNumber: null,
            functionName: null,
            typeName: null,
            methodName: null,
            columnNumber: null,
            native: null
          });
          var r2 = e3.match(/at (?:(.+)\s+\()?(?:(.+?):(\d+)(?::(\d+))?|([^)]+))\)?/);
          if (r2) {
            var n = null,
              o = null,
              i = null,
              s = null,
              a2 = null,
              l = "native" === r2[5];
            if (r2[1]) {
              var u = (i = r2[1]).lastIndexOf(".");
              if ("." == i[u - 1] && u--, u > 0) {
                n = i.substr(0, u), o = i.substr(u + 1);
                var g = n.indexOf(".Module");
                g > 0 && (i = i.substr(g + 1), n = n.substr(0, g));
              }
              s = null;
            }
            o && (s = n, a2 = o), "<anonymous>" === o && (a2 = null, i = null);
            var c = {
              fileName: r2[2] || null,
              lineNumber: parseInt(r2[3], 10) || null,
              functionName: i,
              typeName: s,
              methodName: a2,
              columnNumber: parseInt(r2[4], 10) || null,
              native: l
            };
            return t2._createParsedCallSite(c);
          }
        }).filter(function (e3) {
          return !!e3;
        });
      };
      ["this", "typeName", "functionName", "methodName", "fileName", "lineNumber", "columnNumber", "function", "evalOrigin"].forEach(function (e2) {
        r.prototype[e2] = null, r.prototype["get" + e2[0].toUpperCase() + e2.substr(1)] = function () {
          return this[e2];
        };
      }), ["topLevel", "eval", "native", "constructor"].forEach(function (e2) {
        r.prototype[e2] = false, r.prototype["is" + e2[0].toUpperCase() + e2.substr(1)] = function () {
          return this[e2];
        };
      }), t._createParsedCallSite = function (e2) {
        return new r(e2);
      };
    }, function (e, t, r) {
      function n(e2) {
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e3) {
          return typeof e3;
        } : function (e3) {
          return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
        })(e2);
      }
      function o(e2, t2) {
        for (var r2 = 0; r2 < t2.length; r2++) {
          var n2 = t2[r2];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
        }
      }
      function i(e2, t2) {
        return (i = Object.setPrototypeOf || function (e3, t3) {
          return e3.__proto__ = t3, e3;
        })(e2, t2);
      }
      function s(e2) {
        var t2 = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return false;
          if (Reflect.construct.sham) return false;
          if ("function" == typeof Proxy) return true;
          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), true;
          } catch (e3) {
            return false;
          }
        }();
        return function () {
          var r2,
            n2 = l(e2);
          if (t2) {
            var o2 = l(this).constructor;
            r2 = Reflect.construct(n2, arguments, o2);
          } else r2 = n2.apply(this, arguments);
          return a2(this, r2);
        };
      }
      function a2(e2, t2) {
        return !t2 || "object" !== n(t2) && "function" != typeof t2 ? function (e3) {
          if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e3;
        }(e2) : t2;
      }
      function l(e2) {
        return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e3) {
          return e3.__proto__ || Object.getPrototypeOf(e3);
        })(e2);
      }
      var u = r(32).Writable;
      e.exports = function (e2) {
        !function (e3, t3) {
          if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
          e3.prototype = Object.create(t3 && t3.prototype, {
            constructor: {
              value: e3,
              writable: true,
              configurable: true
            }
          }), t3 && i(e3, t3);
        }(l2, e2);
        var t2,
          r2,
          a3 = s(l2);
        function l2(e3) {
          var t3;
          if (function (e4, t4) {
            if (!(e4 instanceof t4)) throw new TypeError("Cannot call a class as a function");
          }(this, l2), t3 = a3.call(this, {
            objectMode: true
          }), !e3) throw new Error("ExceptionStream requires a TransportStream instance.");
          return t3.handleExceptions = true, t3.transport = e3, t3;
        }
        return t2 = l2, (r2 = [{
          key: "_write",
          value: function value(e3, t3, r3) {
            return e3.exception ? this.transport.log(e3, r3) : (r3(), true);
          }
        }]) && o(t2.prototype, r2), l2;
      }(u);
    }, function (e, t, r) {
      (function (t2) {
        function n(e2, t3) {
          for (var r2 = 0; r2 < t3.length; r2++) {
            var n2 = t3[r2];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
          }
        }
        var o = r(18),
          i = r(51),
          s = r(38)("winston:rejection"),
          a2 = r(90),
          l = r(91),
          u = r(92);
        e.exports = function () {
          function e2(t3) {
            if (function (e3, t4) {
              if (!(e3 instanceof t4)) throw new TypeError("Cannot call a class as a function");
            }(this, e2), !t3) throw new Error("Logger is required to handle rejections");
            this.logger = t3, this.handlers = /* @__PURE__ */new Map();
          }
          var r2, g;
          return r2 = e2, (g = [{
            key: "handle",
            value: function value() {
              for (var e3 = this, r3 = arguments.length, n2 = new Array(r3), o2 = 0; o2 < r3; o2++) n2[o2] = arguments[o2];
              n2.forEach(function (t3) {
                if (Array.isArray(t3)) return t3.forEach(function (t4) {
                  return e3._addHandler(t4);
                });
                e3._addHandler(t3);
              }), this.catcher || (this.catcher = this._unhandledRejection.bind(this), t2.on("unhandledRejection", this.catcher));
            }
          }, {
            key: "unhandle",
            value: function value() {
              var e3 = this;
              this.catcher && (t2.removeListener("unhandledRejection", this.catcher), this.catcher = false, Array.from(this.handlers.values()).forEach(function (t3) {
                return e3.logger.unpipe(t3);
              }));
            }
          }, {
            key: "getAllInfo",
            value: function value(e3) {
              var t3 = e3.message;
              return t3 || "string" != typeof e3 || (t3 = e3), {
                error: e3,
                level: "error",
                message: ["unhandledRejection: ".concat(t3 || "(no error message)"), e3.stack || "  No stack trace"].join("\n"),
                stack: e3.stack,
                exception: true,
                date: new Date().toString(),
                process: this.getProcessInfo(),
                os: this.getOsInfo(),
                trace: this.getTrace(e3)
              };
            }
          }, {
            key: "getProcessInfo",
            value: function value() {
              return {
                pid: t2.pid,
                uid: t2.getuid ? t2.getuid() : null,
                gid: t2.getgid ? t2.getgid() : null,
                cwd: t2.cwd(),
                execPath: t2.execPath,
                version: t2.version,
                argv: t2.argv,
                memoryUsage: t2.memoryUsage()
              };
            }
          }, {
            key: "getOsInfo",
            value: function value() {
              return {
                loadavg: o.loadavg(),
                uptime: o.uptime()
              };
            }
          }, {
            key: "getTrace",
            value: function value(e3) {
              return (e3 ? l.parse(e3) : l.get()).map(function (e4) {
                return {
                  column: e4.getColumnNumber(),
                  file: e4.getFileName(),
                  function: e4.getFunctionName(),
                  line: e4.getLineNumber(),
                  method: e4.getMethodName(),
                  native: e4.isNative()
                };
              });
            }
          }, {
            key: "_addHandler",
            value: function value(e3) {
              if (!this.handlers.has(e3)) {
                e3.handleRejections = true;
                var t3 = new u(e3);
                this.handlers.set(e3, t3), this.logger.pipe(t3);
              }
            }
          }, {
            key: "_unhandledRejection",
            value: function value(e3) {
              var r3,
                n2 = this.getAllInfo(e3),
                o2 = this._getRejectionHandlers(),
                l2 = "function" == typeof this.logger.exitOnError ? this.logger.exitOnError(e3) : this.logger.exitOnError;
              function u2() {
                s("doExit", l2), s("process._exiting", t2._exiting), l2 && !t2._exiting && (r3 && clearTimeout(r3), t2.exit(1));
              }
              if (!o2.length && l2 && (console.warn("winston: exitOnError cannot be true with no rejection handlers."), console.warn("winston: not exiting process."), l2 = false), !o2 || 0 === o2.length) return t2.nextTick(u2);
              i(o2, function (e4, t3) {
                var r4 = a2(t3),
                  n3 = e4.transport || e4;
                function o3(e5) {
                  return function () {
                    s(e5), r4();
                  };
                }
                n3._ending = true, n3.once("finish", o3("finished")), n3.once("error", o3("error"));
              }, function () {
                return l2 && u2();
              }), this.logger.log(n2), l2 && (r3 = setTimeout(u2, 3e3));
            }
          }, {
            key: "_getRejectionHandlers",
            value: function value() {
              return this.logger.transports.filter(function (e3) {
                return (e3.transport || e3).handleRejections;
              });
            }
          }]) && n(r2.prototype, g), e2;
        }();
      }).call(this, r(2));
    }, function (e, t, r) {
      e.exports = {
        asArray: r(212),
        asBoolStrict: r(213),
        asBool: r(214),
        asPortNumber: r(215),
        asEnum: r(216),
        asFloatNegative: r(217),
        asFloatPositive: r(218),
        asFloat: r(54),
        asIntNegative: r(219),
        asIntPositive: r(95),
        asInt: r(53),
        asJsonArray: r(220),
        asJsonObject: r(221),
        asJson: r(55),
        asRegExp: r(222),
        asString: r(33),
        asUrlObject: r(96),
        asUrlString: r(223),
        asEmailString: r(224)
      };
    }, function (e, t, r) {
      var n = r(53);
      e.exports = function (e2) {
        var t2 = n(e2);
        if (t2 < 0) throw new Error("should be a positive integer");
        return t2;
      };
    }, function (e, t, r) {
      var n = r(33);
      e.exports = function (e2) {
        var t2 = n(e2);
        try {
          return new URL(t2);
        } catch (e3) {
          throw new Error("should be a valid URL");
        }
      };
    }, function (e, t, r) {
      var n = {};
      n.web = r(24);
      r(98);
      var o = {
        v1: {}
      };
      o.v1.signaling = {}, o.v1.signaling.api = r(9), o.v1.signaling.api.SignalingClient = function (e2, t2, r2) {
        r2 || (r2 = {}), r2.format = "text", this.client_ = new n.web.GrpcWebClientBase(r2), this.hostname_ = e2;
      }, o.v1.signaling.api.SignalingPromiseClient = function (e2, t2, r2) {
        r2 || (r2 = {}), r2.format = "text", this.client_ = new n.web.GrpcWebClientBase(r2), this.hostname_ = e2;
      };
      var i = new n.web.MethodDescriptor("/v1.signaling.api.Signaling/GetHealth", n.web.MethodType.UNARY, o.v1.signaling.api.GetHealthRequest, o.v1.signaling.api.GetHealthResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.GetHealthResponse.deserializeBinary);
      new n.web.AbstractClientBase.MethodInfo(o.v1.signaling.api.GetHealthResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.GetHealthResponse.deserializeBinary);
      o.v1.signaling.api.SignalingClient.prototype.getHealth = function (e2, t2, r2) {
        return this.client_.rpcCall(this.hostname_ + "/v1.signaling.api.Signaling/GetHealth", e2, t2 || {}, i, r2);
      }, o.v1.signaling.api.SignalingPromiseClient.prototype.getHealth = function (e2, t2) {
        return this.client_.unaryCall(this.hostname_ + "/v1.signaling.api.Signaling/GetHealth", e2, t2 || {}, i);
      };
      var s = new n.web.MethodDescriptor("/v1.signaling.api.Signaling/CreatePeer", n.web.MethodType.UNARY, o.v1.signaling.api.CreatePeerRequest, o.v1.signaling.api.CreatePeerResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.CreatePeerResponse.deserializeBinary);
      new n.web.AbstractClientBase.MethodInfo(o.v1.signaling.api.CreatePeerResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.CreatePeerResponse.deserializeBinary);
      o.v1.signaling.api.SignalingClient.prototype.createPeer = function (e2, t2, r2) {
        return this.client_.rpcCall(this.hostname_ + "/v1.signaling.api.Signaling/CreatePeer", e2, t2 || {}, s, r2);
      }, o.v1.signaling.api.SignalingPromiseClient.prototype.createPeer = function (e2, t2) {
        return this.client_.unaryCall(this.hostname_ + "/v1.signaling.api.Signaling/CreatePeer", e2, t2 || {}, s);
      };
      var a2 = new n.web.MethodDescriptor("/v1.signaling.api.Signaling/DeletePeer", n.web.MethodType.UNARY, o.v1.signaling.api.DeletePeerRequest, o.v1.signaling.api.DeletePeerResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.DeletePeerResponse.deserializeBinary);
      new n.web.AbstractClientBase.MethodInfo(o.v1.signaling.api.DeletePeerResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.DeletePeerResponse.deserializeBinary);
      o.v1.signaling.api.SignalingClient.prototype.deletePeer = function (e2, t2, r2) {
        return this.client_.rpcCall(this.hostname_ + "/v1.signaling.api.Signaling/DeletePeer", e2, t2 || {}, a2, r2);
      }, o.v1.signaling.api.SignalingPromiseClient.prototype.deletePeer = function (e2, t2) {
        return this.client_.unaryCall(this.hostname_ + "/v1.signaling.api.Signaling/DeletePeer", e2, t2 || {}, a2);
      };
      var l = new n.web.MethodDescriptor("/v1.signaling.api.Signaling/RefreshPeer", n.web.MethodType.UNARY, o.v1.signaling.api.RefreshPeerRequest, o.v1.signaling.api.RefreshPeerResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.RefreshPeerResponse.deserializeBinary);
      new n.web.AbstractClientBase.MethodInfo(o.v1.signaling.api.RefreshPeerResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.RefreshPeerResponse.deserializeBinary);
      o.v1.signaling.api.SignalingClient.prototype.refreshPeer = function (e2, t2, r2) {
        return this.client_.rpcCall(this.hostname_ + "/v1.signaling.api.Signaling/RefreshPeer", e2, t2 || {}, l, r2);
      }, o.v1.signaling.api.SignalingPromiseClient.prototype.refreshPeer = function (e2, t2) {
        return this.client_.unaryCall(this.hostname_ + "/v1.signaling.api.Signaling/RefreshPeer", e2, t2 || {}, l);
      };
      var u = new n.web.MethodDescriptor("/v1.signaling.api.Signaling/GetPeers", n.web.MethodType.UNARY, o.v1.signaling.api.GetPeersRequest, o.v1.signaling.api.GetPeersResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.GetPeersResponse.deserializeBinary);
      new n.web.AbstractClientBase.MethodInfo(o.v1.signaling.api.GetPeersResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.GetPeersResponse.deserializeBinary);
      o.v1.signaling.api.SignalingClient.prototype.getPeers = function (e2, t2, r2) {
        return this.client_.rpcCall(this.hostname_ + "/v1.signaling.api.Signaling/GetPeers", e2, t2 || {}, u, r2);
      }, o.v1.signaling.api.SignalingPromiseClient.prototype.getPeers = function (e2, t2) {
        return this.client_.unaryCall(this.hostname_ + "/v1.signaling.api.Signaling/GetPeers", e2, t2 || {}, u);
      };
      var g = new n.web.MethodDescriptor("/v1.signaling.api.Signaling/GetIceServers", n.web.MethodType.UNARY, o.v1.signaling.api.GetIceServersRequest, o.v1.signaling.api.GetIceServersResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.GetIceServersResponse.deserializeBinary);
      new n.web.AbstractClientBase.MethodInfo(o.v1.signaling.api.GetIceServersResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.GetIceServersResponse.deserializeBinary);
      o.v1.signaling.api.SignalingClient.prototype.getIceServers = function (e2, t2, r2) {
        return this.client_.rpcCall(this.hostname_ + "/v1.signaling.api.Signaling/GetIceServers", e2, t2 || {}, g, r2);
      }, o.v1.signaling.api.SignalingPromiseClient.prototype.getIceServers = function (e2, t2) {
        return this.client_.unaryCall(this.hostname_ + "/v1.signaling.api.Signaling/GetIceServers", e2, t2 || {}, g);
      };
      var c = new n.web.MethodDescriptor("/v1.signaling.api.Signaling/SendSignal", n.web.MethodType.UNARY, o.v1.signaling.api.SendSignalRequest, o.v1.signaling.api.SendSignalResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.SendSignalResponse.deserializeBinary);
      new n.web.AbstractClientBase.MethodInfo(o.v1.signaling.api.SendSignalResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.SendSignalResponse.deserializeBinary);
      o.v1.signaling.api.SignalingClient.prototype.sendSignal = function (e2, t2, r2) {
        return this.client_.rpcCall(this.hostname_ + "/v1.signaling.api.Signaling/SendSignal", e2, t2 || {}, c, r2);
      }, o.v1.signaling.api.SignalingPromiseClient.prototype.sendSignal = function (e2, t2) {
        return this.client_.unaryCall(this.hostname_ + "/v1.signaling.api.Signaling/SendSignal", e2, t2 || {}, c);
      };
      var f = new n.web.MethodDescriptor("/v1.signaling.api.Signaling/ReceiveSignalStream", n.web.MethodType.SERVER_STREAMING, o.v1.signaling.api.ReceiveSignalStreamRequest, o.v1.signaling.api.ReceiveSignalStreamResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.ReceiveSignalStreamResponse.deserializeBinary);
      new n.web.AbstractClientBase.MethodInfo(o.v1.signaling.api.ReceiveSignalStreamResponse, function (e2) {
        return e2.serializeBinary();
      }, o.v1.signaling.api.ReceiveSignalStreamResponse.deserializeBinary);
      o.v1.signaling.api.SignalingClient.prototype.receiveSignalStream = function (e2, t2) {
        return this.client_.serverStreaming(this.hostname_ + "/v1.signaling.api.Signaling/ReceiveSignalStream", e2, t2 || {}, f);
      }, o.v1.signaling.api.SignalingPromiseClient.prototype.receiveSignalStream = function (e2, t2) {
        return this.client_.serverStreaming(this.hostname_ + "/v1.signaling.api.Signaling/ReceiveSignalStream", e2, t2 || {}, f);
      }, e.exports = o.v1.signaling.api;
    }, function (e, t, r) {
      var n = r(99),
        o = n,
        i = Function("return this")();
      o.exportSymbol("proto.google.protobuf.BoolValue", null, i), o.exportSymbol("proto.google.protobuf.BytesValue", null, i), o.exportSymbol("proto.google.protobuf.DoubleValue", null, i), o.exportSymbol("proto.google.protobuf.FloatValue", null, i), o.exportSymbol("proto.google.protobuf.Int32Value", null, i), o.exportSymbol("proto.google.protobuf.Int64Value", null, i), o.exportSymbol("proto.google.protobuf.StringValue", null, i), o.exportSymbol("proto.google.protobuf.UInt32Value", null, i), o.exportSymbol("proto.google.protobuf.UInt64Value", null, i), proto.google.protobuf.DoubleValue = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.google.protobuf.DoubleValue, n.Message), o.DEBUG && !COMPILED && (proto.google.protobuf.DoubleValue.displayName = "proto.google.protobuf.DoubleValue"), proto.google.protobuf.FloatValue = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.google.protobuf.FloatValue, n.Message), o.DEBUG && !COMPILED && (proto.google.protobuf.FloatValue.displayName = "proto.google.protobuf.FloatValue"), proto.google.protobuf.Int64Value = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.google.protobuf.Int64Value, n.Message), o.DEBUG && !COMPILED && (proto.google.protobuf.Int64Value.displayName = "proto.google.protobuf.Int64Value"), proto.google.protobuf.UInt64Value = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.google.protobuf.UInt64Value, n.Message), o.DEBUG && !COMPILED && (proto.google.protobuf.UInt64Value.displayName = "proto.google.protobuf.UInt64Value"), proto.google.protobuf.Int32Value = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.google.protobuf.Int32Value, n.Message), o.DEBUG && !COMPILED && (proto.google.protobuf.Int32Value.displayName = "proto.google.protobuf.Int32Value"), proto.google.protobuf.UInt32Value = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.google.protobuf.UInt32Value, n.Message), o.DEBUG && !COMPILED && (proto.google.protobuf.UInt32Value.displayName = "proto.google.protobuf.UInt32Value"), proto.google.protobuf.BoolValue = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.google.protobuf.BoolValue, n.Message), o.DEBUG && !COMPILED && (proto.google.protobuf.BoolValue.displayName = "proto.google.protobuf.BoolValue"), proto.google.protobuf.StringValue = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.google.protobuf.StringValue, n.Message), o.DEBUG && !COMPILED && (proto.google.protobuf.StringValue.displayName = "proto.google.protobuf.StringValue"), proto.google.protobuf.BytesValue = function (e2) {
        n.Message.initialize(this, e2, 0, -1, null, null);
      }, o.inherits(proto.google.protobuf.BytesValue, n.Message), o.DEBUG && !COMPILED && (proto.google.protobuf.BytesValue.displayName = "proto.google.protobuf.BytesValue"), n.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.DoubleValue.prototype.toObject = function (e2) {
        return proto.google.protobuf.DoubleValue.toObject(e2, this);
      }, proto.google.protobuf.DoubleValue.toObject = function (e2, t2) {
        var r2 = {
          value: n.Message.getFloatingPointFieldWithDefault(t2, 1, 0)
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.google.protobuf.DoubleValue.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.google.protobuf.DoubleValue();
        return proto.google.protobuf.DoubleValue.deserializeBinaryFromReader(r2, t2);
      }, proto.google.protobuf.DoubleValue.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readDouble();
              e2.setValue(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.google.protobuf.DoubleValue.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.google.protobuf.DoubleValue.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.google.protobuf.DoubleValue.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        0 !== (r2 = e2.getValue()) && t2.writeDouble(1, r2);
      }, proto.google.protobuf.DoubleValue.prototype.getValue = function () {
        return n.Message.getFloatingPointFieldWithDefault(this, 1, 0);
      }, proto.google.protobuf.DoubleValue.prototype.setValue = function (e2) {
        return n.Message.setProto3FloatField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FloatValue.prototype.toObject = function (e2) {
        return proto.google.protobuf.FloatValue.toObject(e2, this);
      }, proto.google.protobuf.FloatValue.toObject = function (e2, t2) {
        var r2 = {
          value: n.Message.getFloatingPointFieldWithDefault(t2, 1, 0)
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.google.protobuf.FloatValue.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.google.protobuf.FloatValue();
        return proto.google.protobuf.FloatValue.deserializeBinaryFromReader(r2, t2);
      }, proto.google.protobuf.FloatValue.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readFloat();
              e2.setValue(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.google.protobuf.FloatValue.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.google.protobuf.FloatValue.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.google.protobuf.FloatValue.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        0 !== (r2 = e2.getValue()) && t2.writeFloat(1, r2);
      }, proto.google.protobuf.FloatValue.prototype.getValue = function () {
        return n.Message.getFloatingPointFieldWithDefault(this, 1, 0);
      }, proto.google.protobuf.FloatValue.prototype.setValue = function (e2) {
        return n.Message.setProto3FloatField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.Int64Value.prototype.toObject = function (e2) {
        return proto.google.protobuf.Int64Value.toObject(e2, this);
      }, proto.google.protobuf.Int64Value.toObject = function (e2, t2) {
        var r2 = {
          value: n.Message.getFieldWithDefault(t2, 1, 0)
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.google.protobuf.Int64Value.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.google.protobuf.Int64Value();
        return proto.google.protobuf.Int64Value.deserializeBinaryFromReader(r2, t2);
      }, proto.google.protobuf.Int64Value.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readInt64();
              e2.setValue(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.google.protobuf.Int64Value.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.google.protobuf.Int64Value.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.google.protobuf.Int64Value.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        0 !== (r2 = e2.getValue()) && t2.writeInt64(1, r2);
      }, proto.google.protobuf.Int64Value.prototype.getValue = function () {
        return n.Message.getFieldWithDefault(this, 1, 0);
      }, proto.google.protobuf.Int64Value.prototype.setValue = function (e2) {
        return n.Message.setProto3IntField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.UInt64Value.prototype.toObject = function (e2) {
        return proto.google.protobuf.UInt64Value.toObject(e2, this);
      }, proto.google.protobuf.UInt64Value.toObject = function (e2, t2) {
        var r2 = {
          value: n.Message.getFieldWithDefault(t2, 1, 0)
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.google.protobuf.UInt64Value.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.google.protobuf.UInt64Value();
        return proto.google.protobuf.UInt64Value.deserializeBinaryFromReader(r2, t2);
      }, proto.google.protobuf.UInt64Value.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readUint64();
              e2.setValue(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.google.protobuf.UInt64Value.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.google.protobuf.UInt64Value.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.google.protobuf.UInt64Value.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        0 !== (r2 = e2.getValue()) && t2.writeUint64(1, r2);
      }, proto.google.protobuf.UInt64Value.prototype.getValue = function () {
        return n.Message.getFieldWithDefault(this, 1, 0);
      }, proto.google.protobuf.UInt64Value.prototype.setValue = function (e2) {
        return n.Message.setProto3IntField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.Int32Value.prototype.toObject = function (e2) {
        return proto.google.protobuf.Int32Value.toObject(e2, this);
      }, proto.google.protobuf.Int32Value.toObject = function (e2, t2) {
        var r2 = {
          value: n.Message.getFieldWithDefault(t2, 1, 0)
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.google.protobuf.Int32Value.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.google.protobuf.Int32Value();
        return proto.google.protobuf.Int32Value.deserializeBinaryFromReader(r2, t2);
      }, proto.google.protobuf.Int32Value.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readInt32();
              e2.setValue(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.google.protobuf.Int32Value.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.google.protobuf.Int32Value.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.google.protobuf.Int32Value.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        0 !== (r2 = e2.getValue()) && t2.writeInt32(1, r2);
      }, proto.google.protobuf.Int32Value.prototype.getValue = function () {
        return n.Message.getFieldWithDefault(this, 1, 0);
      }, proto.google.protobuf.Int32Value.prototype.setValue = function (e2) {
        return n.Message.setProto3IntField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.UInt32Value.prototype.toObject = function (e2) {
        return proto.google.protobuf.UInt32Value.toObject(e2, this);
      }, proto.google.protobuf.UInt32Value.toObject = function (e2, t2) {
        var r2 = {
          value: n.Message.getFieldWithDefault(t2, 1, 0)
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.google.protobuf.UInt32Value.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.google.protobuf.UInt32Value();
        return proto.google.protobuf.UInt32Value.deserializeBinaryFromReader(r2, t2);
      }, proto.google.protobuf.UInt32Value.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readUint32();
              e2.setValue(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.google.protobuf.UInt32Value.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.google.protobuf.UInt32Value.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.google.protobuf.UInt32Value.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        0 !== (r2 = e2.getValue()) && t2.writeUint32(1, r2);
      }, proto.google.protobuf.UInt32Value.prototype.getValue = function () {
        return n.Message.getFieldWithDefault(this, 1, 0);
      }, proto.google.protobuf.UInt32Value.prototype.setValue = function (e2) {
        return n.Message.setProto3IntField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.BoolValue.prototype.toObject = function (e2) {
        return proto.google.protobuf.BoolValue.toObject(e2, this);
      }, proto.google.protobuf.BoolValue.toObject = function (e2, t2) {
        var r2 = {
          value: n.Message.getBooleanFieldWithDefault(t2, 1, false)
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.google.protobuf.BoolValue.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.google.protobuf.BoolValue();
        return proto.google.protobuf.BoolValue.deserializeBinaryFromReader(r2, t2);
      }, proto.google.protobuf.BoolValue.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readBool();
              e2.setValue(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.google.protobuf.BoolValue.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.google.protobuf.BoolValue.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.google.protobuf.BoolValue.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        (r2 = e2.getValue()) && t2.writeBool(1, r2);
      }, proto.google.protobuf.BoolValue.prototype.getValue = function () {
        return n.Message.getBooleanFieldWithDefault(this, 1, false);
      }, proto.google.protobuf.BoolValue.prototype.setValue = function (e2) {
        return n.Message.setProto3BooleanField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.StringValue.prototype.toObject = function (e2) {
        return proto.google.protobuf.StringValue.toObject(e2, this);
      }, proto.google.protobuf.StringValue.toObject = function (e2, t2) {
        var r2 = {
          value: n.Message.getFieldWithDefault(t2, 1, "")
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.google.protobuf.StringValue.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.google.protobuf.StringValue();
        return proto.google.protobuf.StringValue.deserializeBinaryFromReader(r2, t2);
      }, proto.google.protobuf.StringValue.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readString();
              e2.setValue(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.google.protobuf.StringValue.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.google.protobuf.StringValue.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.google.protobuf.StringValue.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        (r2 = e2.getValue()).length > 0 && t2.writeString(1, r2);
      }, proto.google.protobuf.StringValue.prototype.getValue = function () {
        return n.Message.getFieldWithDefault(this, 1, "");
      }, proto.google.protobuf.StringValue.prototype.setValue = function (e2) {
        return n.Message.setProto3StringField(this, 1, e2);
      }, n.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.BytesValue.prototype.toObject = function (e2) {
        return proto.google.protobuf.BytesValue.toObject(e2, this);
      }, proto.google.protobuf.BytesValue.toObject = function (e2, t2) {
        var r2 = {
          value: t2.getValue_asB64()
        };
        return e2 && (r2.$jspbMessageInstance = t2), r2;
      }), proto.google.protobuf.BytesValue.deserializeBinary = function (e2) {
        var t2 = new n.BinaryReader(e2),
          r2 = new proto.google.protobuf.BytesValue();
        return proto.google.protobuf.BytesValue.deserializeBinaryFromReader(r2, t2);
      }, proto.google.protobuf.BytesValue.deserializeBinaryFromReader = function (e2, t2) {
        for (; t2.nextField() && !t2.isEndGroup();) {
          switch (t2.getFieldNumber()) {
            case 1:
              var r2 = t2.readBytes();
              e2.setValue(r2);
              break;
            default:
              t2.skipField();
          }
        }
        return e2;
      }, proto.google.protobuf.BytesValue.prototype.serializeBinary = function () {
        var e2 = new n.BinaryWriter();
        return proto.google.protobuf.BytesValue.serializeBinaryToWriter(this, e2), e2.getResultBuffer();
      }, proto.google.protobuf.BytesValue.serializeBinaryToWriter = function (e2, t2) {
        var r2;
        (r2 = e2.getValue_asU8()).length > 0 && t2.writeBytes(1, r2);
      }, proto.google.protobuf.BytesValue.prototype.getValue = function () {
        return n.Message.getFieldWithDefault(this, 1, "");
      }, proto.google.protobuf.BytesValue.prototype.getValue_asB64 = function () {
        return n.Message.bytesAsB64(this.getValue());
      }, proto.google.protobuf.BytesValue.prototype.getValue_asU8 = function () {
        return n.Message.bytesAsU8(this.getValue());
      }, proto.google.protobuf.BytesValue.prototype.setValue = function (e2) {
        return n.Message.setProto3BytesField(this, 1, e2);
      }, o.object.extend(t, proto.google.protobuf);
    }, function (module, exports, __webpack_require__) {
      (function (global, Buffer) {
        var $jscomp = $jscomp || {};
        $jscomp.scope = {}, $jscomp.findInternal = function (e, t, r) {
          e instanceof String && (e = String(e));
          for (var n = e.length, o = 0; o < n; o++) {
            var i = e[o];
            if (t.call(r, i, o, e)) return {
              i: o,
              v: i
            };
          }
          return {
            i: -1,
            v: void 0
          };
        }, $jscomp.ASSUME_ES5 = false, $jscomp.ASSUME_NO_NATIVE_MAP = false, $jscomp.ASSUME_NO_NATIVE_SET = false, $jscomp.SIMPLE_FROUND_POLYFILL = false, $jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, t, r) {
          e != Array.prototype && e != Object.prototype && (e[t] = r.value);
        }, $jscomp.getGlobal = function (e) {
          return "undefined" != typeof window && window === e ? e : void 0 !== global && null != global ? global : e;
        }, $jscomp.global = $jscomp.getGlobal(this), $jscomp.polyfill = function (e, t, r, n) {
          if (t) {
            for (r = $jscomp.global, e = e.split("."), n = 0; n < e.length - 1; n++) {
              var o = e[n];
              o in r || (r[o] = {}), r = r[o];
            }
            (t = t(n = r[e = e[e.length - 1]])) != n && null != t && $jscomp.defineProperty(r, e, {
              configurable: true,
              writable: true,
              value: t
            });
          }
        }, $jscomp.polyfill("Array.prototype.findIndex", function (e) {
          return e || function (e2, t) {
            return $jscomp.findInternal(this, e2, t).i;
          };
        }, "es6", "es3"), $jscomp.checkStringArgs = function (e, t, r) {
          if (null == e) throw new TypeError("The 'this' value for String.prototype." + r + " must not be null or undefined");
          if (t instanceof RegExp) throw new TypeError("First argument to String.prototype." + r + " must not be a regular expression");
          return e + "";
        }, $jscomp.polyfill("String.prototype.endsWith", function (e) {
          return e || function (e2, t) {
            var r = $jscomp.checkStringArgs(this, e2, "endsWith");
            e2 += "", void 0 === t && (t = r.length), t = Math.max(0, Math.min(0 | t, r.length));
            for (var n = e2.length; 0 < n && 0 < t;) if (r[--t] != e2[--n]) return false;
            return 0 >= n;
          };
        }, "es6", "es3"), $jscomp.polyfill("Array.prototype.find", function (e) {
          return e || function (e2, t) {
            return $jscomp.findInternal(this, e2, t).v;
          };
        }, "es6", "es3"), $jscomp.polyfill("String.prototype.startsWith", function (e) {
          return e || function (e2, t) {
            var r = $jscomp.checkStringArgs(this, e2, "startsWith");
            e2 += "";
            var n = r.length,
              o = e2.length;
            t = Math.max(0, Math.min(0 | t, r.length));
            for (var i = 0; i < o && t < n;) if (r[t++] != e2[i++]) return false;
            return i >= o;
          };
        }, "es6", "es3"), $jscomp.polyfill("String.prototype.repeat", function (e) {
          return e || function (e2) {
            var t = $jscomp.checkStringArgs(this, null, "repeat");
            if (0 > e2 || 1342177279 < e2) throw new RangeError("Invalid count value");
            e2 |= 0;
            for (var r = ""; e2;) 1 & e2 && (r += t), (e2 >>>= 1) && (t += t);
            return r;
          };
        }, "es6", "es3");
        var COMPILED = true,
          goog = goog || {};
        goog.global = this || self, goog.isDef = function (e) {
          return void 0 !== e;
        }, goog.isString = function (e) {
          return "string" == typeof e;
        }, goog.isBoolean = function (e) {
          return "boolean" == typeof e;
        }, goog.isNumber = function (e) {
          return "number" == typeof e;
        }, goog.exportPath_ = function (e, t, r) {
          e = e.split("."), r = r || goog.global, e[0] in r || void 0 === r.execScript || r.execScript("var " + e[0]);
          for (var n; e.length && (n = e.shift());) !e.length && goog.isDef(t) ? r[n] = t : r = r[n] && r[n] !== Object.prototype[n] ? r[n] : r[n] = {};
        }, goog.define = function (e, t) {
          return t;
        }, goog.FEATURESET_YEAR = 2012, goog.DEBUG = true, goog.LOCALE = "en", goog.TRUSTED_SITE = true, goog.STRICT_MODE_COMPATIBLE = false, goog.DISALLOW_TEST_ONLY_CODE = !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = false, goog.provide = function (e) {
          if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
          goog.constructNamespace_(e);
        }, goog.constructNamespace_ = function (e, t) {
          goog.exportPath_(e, t);
        }, goog.getScriptNonce = function (e) {
          return e && e != goog.global ? goog.getScriptNonce_(e.document) : (null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document)), goog.cspNonce_);
        }, goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/, goog.cspNonce_ = null, goog.getScriptNonce_ = function (e) {
          return (e = e.querySelector && e.querySelector("script[nonce]")) && (e = e.nonce || e.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(e) ? e : "";
        }, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function (e) {
          if (!goog.isString(e) || !e || -1 == e.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
          if (!goog.isInGoogModuleLoader_()) throw Error("Module " + e + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
          if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
          if (goog.moduleLoaderState_.moduleName = e, !COMPILED) ;
        }, goog.module.get = function (e) {
          return goog.module.getInternal_(e);
        }, goog.module.getInternal_ = function (e) {
          return null;
        }, goog.ModuleType = {
          ES6: "es6",
          GOOG: "goog"
        }, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function () {
          return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
        }, goog.isInGoogModuleLoader_ = function () {
          return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
        }, goog.isInEs6ModuleLoader_ = function () {
          if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return true;
          var e = goog.global.$jscomp;
          return !!e && "function" == typeof e.getCurrentModulePath && !!e.getCurrentModulePath();
        }, goog.module.declareLegacyNamespace = function () {
          goog.moduleLoaderState_.declareLegacyNamespace = true;
        }, goog.declareModuleId = function (e) {
          if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = e;else {
            var t = goog.global.$jscomp;
            if (!t || "function" != typeof t.getCurrentModulePath) throw Error('Module with namespace "' + e + '" has been loaded incorrectly.');
            t = t.require(t.getCurrentModulePath()), goog.loadedModules_[e] = {
              exports: t,
              type: goog.ModuleType.ES6,
              moduleId: e
            };
          }
        }, goog.setTestOnly = function (e) {
          if (goog.DISALLOW_TEST_ONLY_CODE) throw e = e || "", Error("Importing test-only code into non-debug environment" + (e ? ": " + e : "."));
        }, goog.forwardDeclare = function (e) {}, goog.getObjectByName = function (e, t) {
          e = e.split("."), t = t || goog.global;
          for (var r = 0; r < e.length; r++) if (t = t[e[r]], !goog.isDefAndNotNull(t)) return null;
          return t;
        }, goog.globalize = function (e, t) {
          for (var r in t = t || goog.global, e) t[r] = e[r];
        }, goog.addDependency = function (e, t, r, n) {}, goog.ENABLE_DEBUG_LOADER = true, goog.logToConsole_ = function (e) {
          goog.global.console && goog.global.console.error(e);
        }, goog.require = function (e) {}, goog.requireType = function (e) {
          return {};
        }, goog.basePath = "", goog.nullFunction = function () {}, goog.abstractMethod = function () {
          throw Error("unimplemented abstract method");
        }, goog.addSingletonGetter = function (e) {
          e.instance_ = void 0, e.getInstance = function () {
            return e.instance_ ? e.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = e), e.instance_ = new e());
          };
        }, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = true, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !COMPILED, goog.TRANSPILE = "detect", goog.ASSUME_ES_MODULES_TRANSPILED = false, goog.TRANSPILE_TO_LANGUAGE = "", goog.TRANSPILER = "transpile.js", goog.hasBadLetScoping = null, goog.useSafari10Workaround = function () {
          if (null == goog.hasBadLetScoping) {
            try {
              var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
            } catch (e) {
              a = false;
            }
            goog.hasBadLetScoping = a;
          }
          return goog.hasBadLetScoping;
        }, goog.workaroundSafari10EvalBug = function (e) {
          return "(function(){" + e + "\n;})();\n";
        }, goog.loadModule = function (e) {
          var t = goog.moduleLoaderState_;
          try {
            if (goog.moduleLoaderState_ = {
              moduleName: "",
              declareLegacyNamespace: false,
              type: goog.ModuleType.GOOG
            }, goog.isFunction(e)) var r = e.call(void 0, {});else {
              if (!goog.isString(e)) throw Error("Invalid module definition");
              goog.useSafari10Workaround() && (e = goog.workaroundSafari10EvalBug(e)), r = goog.loadModuleFromSource_.call(void 0, e);
            }
            var n = goog.moduleLoaderState_.moduleName;
            if (!goog.isString(n) || !n) throw Error('Invalid module name "' + n + '"');
            goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(n, r) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof r && null != r && Object.seal(r), goog.loadedModules_[n] = {
              exports: r,
              type: goog.ModuleType.GOOG,
              moduleId: goog.moduleLoaderState_.moduleName
            };
          } finally {
            goog.moduleLoaderState_ = t;
          }
        }, goog.loadModuleFromSource_ = function (a) {
          return eval(a), {};
        }, goog.normalizePath_ = function (e) {
          e = e.split("/");
          for (var t = 0; t < e.length;) "." == e[t] ? e.splice(t, 1) : t && ".." == e[t] && e[t - 1] && ".." != e[t - 1] ? e.splice(--t, 2) : t++;
          return e.join("/");
        }, goog.loadFileSync_ = function (e) {
          if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(e);
          try {
            var t = new goog.global.XMLHttpRequest();
            return t.open("get", e, false), t.send(), 0 == t.status || 200 == t.status ? t.responseText : null;
          } catch (e2) {
            return null;
          }
        }, goog.transpile_ = function (e, t, r) {
          var n = goog.global.$jscomp;
          n || (goog.global.$jscomp = n = {});
          var o = n.transpile;
          if (!o) {
            var i = goog.basePath + goog.TRANSPILER,
              s = goog.loadFileSync_(i);
            if (s) {
              if (function () {
                (0, eval)(s + "\n//# sourceURL=" + i);
              }.call(goog.global), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
              goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, o = (n = goog.global.$jscomp).transpile;
            }
          }
          return o || (o = n.transpile = function (e2, t2) {
            return goog.logToConsole_(t2 + " requires transpilation but no transpiler was found."), e2;
          }), o(e, t, r);
        }, goog.typeOf = function (e) {
          var t = typeof e;
          if ("object" == t) {
            if (!e) return "null";
            if (e instanceof Array) return "array";
            if (e instanceof Object) return t;
            var r = Object.prototype.toString.call(e);
            if ("[object Window]" == r) return "object";
            if ("[object Array]" == r || "number" == typeof e.length && void 0 !== e.splice && void 0 !== e.propertyIsEnumerable && !e.propertyIsEnumerable("splice")) return "array";
            if ("[object Function]" == r || void 0 !== e.call && void 0 !== e.propertyIsEnumerable && !e.propertyIsEnumerable("call")) return "function";
          } else if ("function" == t && void 0 === e.call) return "object";
          return t;
        }, goog.isNull = function (e) {
          return null === e;
        }, goog.isDefAndNotNull = function (e) {
          return null != e;
        }, goog.isArray = function (e) {
          return "array" == goog.typeOf(e);
        }, goog.isArrayLike = function (e) {
          var t = goog.typeOf(e);
          return "array" == t || "object" == t && "number" == typeof e.length;
        }, goog.isDateLike = function (e) {
          return goog.isObject(e) && "function" == typeof e.getFullYear;
        }, goog.isFunction = function (e) {
          return "function" == goog.typeOf(e);
        }, goog.isObject = function (e) {
          var t = typeof e;
          return "object" == t && null != e || "function" == t;
        }, goog.getUid = function (e) {
          return e[goog.UID_PROPERTY_] || (e[goog.UID_PROPERTY_] = ++goog.uidCounter_);
        }, goog.hasUid = function (e) {
          return !!e[goog.UID_PROPERTY_];
        }, goog.removeUid = function (e) {
          null !== e && "removeAttribute" in e && e.removeAttribute(goog.UID_PROPERTY_);
          try {
            delete e[goog.UID_PROPERTY_];
          } catch (e2) {}
        }, goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.getHashCode = goog.getUid, goog.removeHashCode = goog.removeUid, goog.cloneObject = function (e) {
          var t = goog.typeOf(e);
          if ("object" == t || "array" == t) {
            if ("function" == typeof e.clone) return e.clone();
            for (var r in t = "array" == t ? [] : {}, e) t[r] = goog.cloneObject(e[r]);
            return t;
          }
          return e;
        }, goog.bindNative_ = function (e, t, r) {
          return e.call.apply(e.bind, arguments);
        }, goog.bindJs_ = function (e, t, r) {
          if (!e) throw Error();
          if (2 < arguments.length) {
            var n = Array.prototype.slice.call(arguments, 2);
            return function () {
              var r2 = Array.prototype.slice.call(arguments);
              return Array.prototype.unshift.apply(r2, n), e.apply(t, r2);
            };
          }
          return function () {
            return e.apply(t, arguments);
          };
        }, goog.bind = function (e, t, r) {
          return Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
        }, goog.partial = function (e, t) {
          var r = Array.prototype.slice.call(arguments, 1);
          return function () {
            var t2 = r.slice();
            return t2.push.apply(t2, arguments), e.apply(this, t2);
          };
        }, goog.mixin = function (e, t) {
          for (var r in t) e[r] = t[r];
        }, goog.now = goog.TRUSTED_SITE && Date.now || function () {
          return +new Date();
        }, goog.globalEval = function (e) {
          if (goog.global.execScript) goog.global.execScript(e, "JavaScript");else {
            if (!goog.global.eval) throw Error("goog.globalEval not available");
            if (null == goog.evalWorksForGlobals_) {
              try {
                goog.global.eval("var _evalTest_ = 1;");
              } catch (e2) {}
              if (void 0 !== goog.global._evalTest_) {
                try {
                  delete goog.global._evalTest_;
                } catch (e2) {}
                goog.evalWorksForGlobals_ = true;
              } else goog.evalWorksForGlobals_ = false;
            }
            if (goog.evalWorksForGlobals_) goog.global.eval(e);else {
              var t = goog.global.document,
                r = t.createElement("SCRIPT");
              r.type = "text/javascript", r.defer = false, r.appendChild(t.createTextNode(e)), t.head.appendChild(r), t.head.removeChild(r);
            }
          }
        }, goog.evalWorksForGlobals_ = null, goog.getCssName = function (e, t) {
          if ("." == String(e).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + e);
          var r = function r(e2) {
              return goog.cssNameMapping_[e2] || e2;
            },
            n = function n(e2) {
              e2 = e2.split("-");
              for (var t2 = [], n2 = 0; n2 < e2.length; n2++) t2.push(r(e2[n2]));
              return t2.join("-");
            };
          return n = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? r : n : function (e2) {
            return e2;
          }, e = t ? e + "-" + n(t) : n(e), goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(e) : e;
        }, goog.setCssNameMapping = function (e, t) {
          goog.cssNameMapping_ = e, goog.cssNameMappingStyle_ = t;
        }, goog.getMsg = function (e, t, r) {
          return r && r.html && (e = e.replace(/</g, "&lt;")), t && (e = e.replace(/\{\$([^}]+)}/g, function (e2, r2) {
            return null != t && r2 in t ? t[r2] : e2;
          })), e;
        }, goog.getMsgWithFallback = function (e, t) {
          return e;
        }, goog.exportSymbol = function (e, t, r) {
          goog.exportPath_(e, t, r);
        }, goog.exportProperty = function (e, t, r) {
          e[t] = r;
        }, goog.inherits = function (e, t) {
          function r() {}
          r.prototype = t.prototype, e.superClass_ = t.prototype, e.prototype = new r(), e.prototype.constructor = e, e.base = function (e2, r2, n) {
            for (var o = Array(arguments.length - 2), i = 2; i < arguments.length; i++) o[i - 2] = arguments[i];
            return t.prototype[r2].apply(e2, o);
          };
        }, goog.base = function (e, t, r) {
          var n = arguments.callee.caller;
          if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !n) throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");
          if (void 0 !== n.superClass_) {
            for (var o = Array(arguments.length - 1), i = 1; i < arguments.length; i++) o[i - 1] = arguments[i];
            return n.superClass_.constructor.apply(e, o);
          }
          if ("string" != typeof t && "symbol" != typeof t) throw Error("method names provided to goog.base must be a string or a symbol");
          for (o = Array(arguments.length - 2), i = 2; i < arguments.length; i++) o[i - 2] = arguments[i];
          i = false;
          for (var s = e.constructor.prototype; s; s = Object.getPrototypeOf(s)) if (s[t] === n) i = true;else if (i) return s[t].apply(e, o);
          if (e[t] === n) return e.constructor.prototype[t].apply(e, o);
          throw Error("goog.base called from a method of one name to a method of a different name");
        }, goog.scope = function (e) {
          if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
          e.call(goog.global);
        }, goog.defineClass = function (e, t) {
          var r = t.constructor,
            n = t.statics;
          return r && r != Object.prototype.constructor || (r = function r() {
            throw Error("cannot instantiate an interface (no constructor defined).");
          }), r = goog.defineClass.createSealingConstructor_(r, e), e && goog.inherits(r, e), delete t.constructor, delete t.statics, goog.defineClass.applyProperties_(r.prototype, t), null != n && (n instanceof Function ? n(r) : goog.defineClass.applyProperties_(r, n)), r;
        }, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function (e, t) {
          if (!goog.defineClass.SEAL_CLASS_INSTANCES) return e;
          var r = !goog.defineClass.isUnsealable_(t),
            n = function n() {
              var t2 = e.apply(this, arguments) || this;
              return t2[goog.UID_PROPERTY_] = t2[goog.UID_PROPERTY_], this.constructor === n && r && Object.seal instanceof Function && Object.seal(t2), t2;
            };
          return n;
        }, goog.defineClass.isUnsealable_ = function (e) {
          return e && e.prototype && e.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
        }, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.defineClass.applyProperties_ = function (e, t) {
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          for (var n = 0; n < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; n++) r = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[n], Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }, goog.tagUnsealableClass = function (e) {}, goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable", goog.TRUSTED_TYPES_POLICY_NAME = "", goog.identity_ = function (e) {
          return e;
        }, goog.createTrustedTypesPolicy = function (e) {
          var t = null;
          if ("undefined" == typeof TrustedTypes || !TrustedTypes.createPolicy) return t;
          try {
            t = TrustedTypes.createPolicy(e, {
              createHTML: goog.identity_,
              createScript: goog.identity_,
              createScriptURL: goog.identity_,
              createURL: goog.identity_
            });
          } catch (e2) {
            goog.logToConsole_(e2.message);
          }
          return t;
        }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null;
        var jspb = {
          BinaryConstants: {},
          ConstBinaryMessage: function ConstBinaryMessage() {},
          BinaryMessage: function BinaryMessage() {}
        };
        jspb.BinaryConstants.FieldType = {
          INVALID: -1,
          DOUBLE: 1,
          FLOAT: 2,
          INT64: 3,
          UINT64: 4,
          INT32: 5,
          FIXED64: 6,
          FIXED32: 7,
          BOOL: 8,
          STRING: 9,
          GROUP: 10,
          MESSAGE: 11,
          BYTES: 12,
          UINT32: 13,
          ENUM: 14,
          SFIXED32: 15,
          SFIXED64: 16,
          SINT32: 17,
          SINT64: 18,
          FHASH64: 30,
          VHASH64: 31
        }, jspb.BinaryConstants.WireType = {
          INVALID: -1,
          VARINT: 0,
          FIXED64: 1,
          DELIMITED: 2,
          START_GROUP: 3,
          END_GROUP: 4,
          FIXED32: 5
        }, jspb.BinaryConstants.FieldTypeToWireType = function (e) {
          var t = jspb.BinaryConstants.FieldType,
            r = jspb.BinaryConstants.WireType;
          switch (e) {
            case t.INT32:
            case t.INT64:
            case t.UINT32:
            case t.UINT64:
            case t.SINT32:
            case t.SINT64:
            case t.BOOL:
            case t.ENUM:
            case t.VHASH64:
              return r.VARINT;
            case t.DOUBLE:
            case t.FIXED64:
            case t.SFIXED64:
            case t.FHASH64:
              return r.FIXED64;
            case t.STRING:
            case t.MESSAGE:
            case t.BYTES:
              return r.DELIMITED;
            case t.FLOAT:
            case t.FIXED32:
            case t.SFIXED32:
              return r.FIXED32;
            default:
              return r.INVALID;
          }
        }, jspb.BinaryConstants.INVALID_FIELD_NUMBER = -1, jspb.BinaryConstants.FLOAT32_EPS = 1401298464324817e-60, jspb.BinaryConstants.FLOAT32_MIN = 11754943508222875e-54, jspb.BinaryConstants.FLOAT32_MAX = 34028234663852886e22, jspb.BinaryConstants.FLOAT64_EPS = 5e-324, jspb.BinaryConstants.FLOAT64_MIN = 22250738585072014e-324, jspb.BinaryConstants.FLOAT64_MAX = 17976931348623157e292, jspb.BinaryConstants.TWO_TO_20 = 1048576, jspb.BinaryConstants.TWO_TO_23 = 8388608, jspb.BinaryConstants.TWO_TO_31 = 2147483648, jspb.BinaryConstants.TWO_TO_32 = 4294967296, jspb.BinaryConstants.TWO_TO_52 = 4503599627370496, jspb.BinaryConstants.TWO_TO_63 = 9223372036854776e3, jspb.BinaryConstants.TWO_TO_64 = 18446744073709552e3, jspb.BinaryConstants.ZERO_HASH = "\0\0\0\0\0\0\0\0", goog.dom = {}, goog.dom.NodeType = {
          ELEMENT: 1,
          ATTRIBUTE: 2,
          TEXT: 3,
          CDATA_SECTION: 4,
          ENTITY_REFERENCE: 5,
          ENTITY: 6,
          PROCESSING_INSTRUCTION: 7,
          COMMENT: 8,
          DOCUMENT: 9,
          DOCUMENT_TYPE: 10,
          DOCUMENT_FRAGMENT: 11,
          NOTATION: 12
        }, goog.debug = {}, goog.debug.Error = function (e) {
          if (Error.captureStackTrace) Error.captureStackTrace(this, goog.debug.Error);else {
            var t = Error().stack;
            t && (this.stack = t);
          }
          e && (this.message = String(e)), this.reportErrorToServer = true;
        }, goog.inherits(goog.debug.Error, Error), goog.debug.Error.prototype.name = "CustomError", goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function (e, t) {
          goog.debug.Error.call(this, goog.asserts.subs_(e, t)), this.messagePattern = e;
        }, goog.inherits(goog.asserts.AssertionError, goog.debug.Error), goog.asserts.AssertionError.prototype.name = "AssertionError", goog.asserts.DEFAULT_ERROR_HANDLER = function (e) {
          throw e;
        }, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER, goog.asserts.subs_ = function (e, t) {
          for (var r = "", n = (e = e.split("%s")).length - 1, o = 0; o < n; o++) r += e[o] + (o < t.length ? t[o] : "%s");
          return r + e[n];
        }, goog.asserts.doAssertFailure_ = function (e, t, r, n) {
          var o = "Assertion failed";
          if (r) {
            o += ": " + r;
            var i = n;
          } else e && (o += ": " + e, i = t);
          e = new goog.asserts.AssertionError("" + o, i || []), goog.asserts.errorHandler_(e);
        }, goog.asserts.setErrorHandler = function (e) {
          goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = e);
        }, goog.asserts.assert = function (e, t, r) {
          return goog.asserts.ENABLE_ASSERTS && !e && goog.asserts.doAssertFailure_("", null, t, Array.prototype.slice.call(arguments, 2)), e;
        }, goog.asserts.assertExists = function (e, t, r) {
          return goog.asserts.ENABLE_ASSERTS && null == e && goog.asserts.doAssertFailure_("Expected to exist: %s.", [e], t, Array.prototype.slice.call(arguments, 2)), e;
        }, goog.asserts.fail = function (e, t) {
          goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (e ? ": " + e : ""), Array.prototype.slice.call(arguments, 1)));
        }, goog.asserts.assertNumber = function (e, t, r) {
          return goog.asserts.ENABLE_ASSERTS && !goog.isNumber(e) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
        }, goog.asserts.assertString = function (e, t, r) {
          return goog.asserts.ENABLE_ASSERTS && !goog.isString(e) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
        }, goog.asserts.assertFunction = function (e, t, r) {
          return goog.asserts.ENABLE_ASSERTS && !goog.isFunction(e) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
        }, goog.asserts.assertObject = function (e, t, r) {
          return goog.asserts.ENABLE_ASSERTS && !goog.isObject(e) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
        }, goog.asserts.assertArray = function (e, t, r) {
          return goog.asserts.ENABLE_ASSERTS && !goog.isArray(e) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
        }, goog.asserts.assertBoolean = function (e, t, r) {
          return goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(e) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
        }, goog.asserts.assertElement = function (e, t, r) {
          return !goog.asserts.ENABLE_ASSERTS || goog.isObject(e) && e.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
        }, goog.asserts.assertInstanceof = function (e, t, r, n) {
          return !goog.asserts.ENABLE_ASSERTS || e instanceof t || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(t), goog.asserts.getType_(e)], r, Array.prototype.slice.call(arguments, 3)), e;
        }, goog.asserts.assertFinite = function (e, t, r) {
          return !goog.asserts.ENABLE_ASSERTS || "number" == typeof e && isFinite(e) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [e], t, Array.prototype.slice.call(arguments, 2)), e;
        }, goog.asserts.assertObjectPrototypeIsIntact = function () {
          for (var e in Object.prototype) goog.asserts.fail(e + " should not be enumerable in Object.prototype.");
        }, goog.asserts.getType_ = function (e) {
          return e instanceof Function ? e.displayName || e.name || "unknown type name" : e instanceof Object ? e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e) : null === e ? "null" : typeof e;
        }, goog.array = {}, goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE, goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR, goog.array.peek = function (e) {
          return e[e.length - 1];
        }, goog.array.last = goog.array.peek, goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function (e, t, r) {
          return goog.asserts.assert(null != e.length), Array.prototype.indexOf.call(e, t, r);
        } : function (e, t, r) {
          if (r = null == r ? 0 : 0 > r ? Math.max(0, e.length + r) : r, goog.isString(e)) return goog.isString(t) && 1 == t.length ? e.indexOf(t, r) : -1;
          for (; r < e.length; r++) if (r in e && e[r] === t) return r;
          return -1;
        }, goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function (e, t, r) {
          return goog.asserts.assert(null != e.length), Array.prototype.lastIndexOf.call(e, t, null == r ? e.length - 1 : r);
        } : function (e, t, r) {
          if (0 > (r = null == r ? e.length - 1 : r) && (r = Math.max(0, e.length + r)), goog.isString(e)) return goog.isString(t) && 1 == t.length ? e.lastIndexOf(t, r) : -1;
          for (; 0 <= r; r--) if (r in e && e[r] === t) return r;
          return -1;
        }, goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function (e, t, r) {
          goog.asserts.assert(null != e.length), Array.prototype.forEach.call(e, t, r);
        } : function (e, t, r) {
          for (var n = e.length, o = goog.isString(e) ? e.split("") : e, i = 0; i < n; i++) i in o && t.call(r, o[i], i, e);
        }, goog.array.forEachRight = function (e, t, r) {
          var n = e.length,
            o = goog.isString(e) ? e.split("") : e;
          for (--n; 0 <= n; --n) n in o && t.call(r, o[n], n, e);
        }, goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function (e, t, r) {
          return goog.asserts.assert(null != e.length), Array.prototype.filter.call(e, t, r);
        } : function (e, t, r) {
          for (var n = e.length, o = [], i = 0, s = goog.isString(e) ? e.split("") : e, a2 = 0; a2 < n; a2++) if (a2 in s) {
            var l = s[a2];
            t.call(r, l, a2, e) && (o[i++] = l);
          }
          return o;
        }, goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function (e, t, r) {
          return goog.asserts.assert(null != e.length), Array.prototype.map.call(e, t, r);
        } : function (e, t, r) {
          for (var n = e.length, o = Array(n), i = goog.isString(e) ? e.split("") : e, s = 0; s < n; s++) s in i && (o[s] = t.call(r, i[s], s, e));
          return o;
        }, goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function (e, t, r, n) {
          return goog.asserts.assert(null != e.length), n && (t = goog.bind(t, n)), Array.prototype.reduce.call(e, t, r);
        } : function (e, t, r, n) {
          var o = r;
          return goog.array.forEach(e, function (r2, i) {
            o = t.call(n, o, r2, i, e);
          }), o;
        }, goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function (e, t, r, n) {
          return goog.asserts.assert(null != e.length), goog.asserts.assert(null != t), n && (t = goog.bind(t, n)), Array.prototype.reduceRight.call(e, t, r);
        } : function (e, t, r, n) {
          var o = r;
          return goog.array.forEachRight(e, function (r2, i) {
            o = t.call(n, o, r2, i, e);
          }), o;
        }, goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function (e, t, r) {
          return goog.asserts.assert(null != e.length), Array.prototype.some.call(e, t, r);
        } : function (e, t, r) {
          for (var n = e.length, o = goog.isString(e) ? e.split("") : e, i = 0; i < n; i++) if (i in o && t.call(r, o[i], i, e)) return true;
          return false;
        }, goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function (e, t, r) {
          return goog.asserts.assert(null != e.length), Array.prototype.every.call(e, t, r);
        } : function (e, t, r) {
          for (var n = e.length, o = goog.isString(e) ? e.split("") : e, i = 0; i < n; i++) if (i in o && !t.call(r, o[i], i, e)) return false;
          return true;
        }, goog.array.count = function (e, t, r) {
          var n = 0;
          return goog.array.forEach(e, function (e2, o, i) {
            t.call(r, e2, o, i) && ++n;
          }, r), n;
        }, goog.array.find = function (e, t, r) {
          return 0 > (t = goog.array.findIndex(e, t, r)) ? null : goog.isString(e) ? e.charAt(t) : e[t];
        }, goog.array.findIndex = function (e, t, r) {
          for (var n = e.length, o = goog.isString(e) ? e.split("") : e, i = 0; i < n; i++) if (i in o && t.call(r, o[i], i, e)) return i;
          return -1;
        }, goog.array.findRight = function (e, t, r) {
          return 0 > (t = goog.array.findIndexRight(e, t, r)) ? null : goog.isString(e) ? e.charAt(t) : e[t];
        }, goog.array.findIndexRight = function (e, t, r) {
          var n = e.length,
            o = goog.isString(e) ? e.split("") : e;
          for (--n; 0 <= n; n--) if (n in o && t.call(r, o[n], n, e)) return n;
          return -1;
        }, goog.array.contains = function (e, t) {
          return 0 <= goog.array.indexOf(e, t);
        }, goog.array.isEmpty = function (e) {
          return 0 == e.length;
        }, goog.array.clear = function (e) {
          if (!goog.isArray(e)) for (var t = e.length - 1; 0 <= t; t--) delete e[t];
          e.length = 0;
        }, goog.array.insert = function (e, t) {
          goog.array.contains(e, t) || e.push(t);
        }, goog.array.insertAt = function (e, t, r) {
          goog.array.splice(e, r, 0, t);
        }, goog.array.insertArrayAt = function (e, t, r) {
          goog.partial(goog.array.splice, e, r, 0).apply(null, t);
        }, goog.array.insertBefore = function (e, t, r) {
          var n;
          2 == arguments.length || 0 > (n = goog.array.indexOf(e, r)) ? e.push(t) : goog.array.insertAt(e, t, n);
        }, goog.array.remove = function (e, t) {
          var r;
          return (r = 0 <= (t = goog.array.indexOf(e, t))) && goog.array.removeAt(e, t), r;
        }, goog.array.removeLast = function (e, t) {
          return 0 <= (t = goog.array.lastIndexOf(e, t)) && (goog.array.removeAt(e, t), true);
        }, goog.array.removeAt = function (e, t) {
          return goog.asserts.assert(null != e.length), 1 == Array.prototype.splice.call(e, t, 1).length;
        }, goog.array.removeIf = function (e, t, r) {
          return 0 <= (t = goog.array.findIndex(e, t, r)) && (goog.array.removeAt(e, t), true);
        }, goog.array.removeAllIf = function (e, t, r) {
          var n = 0;
          return goog.array.forEachRight(e, function (o, i) {
            t.call(r, o, i, e) && goog.array.removeAt(e, i) && n++;
          }), n;
        }, goog.array.concat = function (e) {
          return Array.prototype.concat.apply([], arguments);
        }, goog.array.join = function (e) {
          return Array.prototype.concat.apply([], arguments);
        }, goog.array.toArray = function (e) {
          var t = e.length;
          if (0 < t) {
            for (var r = Array(t), n = 0; n < t; n++) r[n] = e[n];
            return r;
          }
          return [];
        }, goog.array.clone = goog.array.toArray, goog.array.extend = function (e, t) {
          for (var r = 1; r < arguments.length; r++) {
            var n = arguments[r];
            if (goog.isArrayLike(n)) {
              var o = e.length || 0,
                i = n.length || 0;
              e.length = o + i;
              for (var s = 0; s < i; s++) e[o + s] = n[s];
            } else e.push(n);
          }
        }, goog.array.splice = function (e, t, r, n) {
          return goog.asserts.assert(null != e.length), Array.prototype.splice.apply(e, goog.array.slice(arguments, 1));
        }, goog.array.slice = function (e, t, r) {
          return goog.asserts.assert(null != e.length), 2 >= arguments.length ? Array.prototype.slice.call(e, t) : Array.prototype.slice.call(e, t, r);
        }, goog.array.removeDuplicates = function (e, t, r) {
          t = t || e;
          var n = function n(e2) {
            return goog.isObject(e2) ? "o" + goog.getUid(e2) : (typeof e2).charAt(0) + e2;
          };
          r = r || n, n = {};
          for (var o = 0, i = 0; i < e.length;) {
            var s = e[i++],
              a2 = r(s);
            Object.prototype.hasOwnProperty.call(n, a2) || (n[a2] = true, t[o++] = s);
          }
          t.length = o;
        }, goog.array.binarySearch = function (e, t, r) {
          return goog.array.binarySearch_(e, r || goog.array.defaultCompare, false, t);
        }, goog.array.binarySelect = function (e, t, r) {
          return goog.array.binarySearch_(e, t, true, void 0, r);
        }, goog.array.binarySearch_ = function (e, t, r, n, o) {
          for (var i, s = 0, a2 = e.length; s < a2;) {
            var l = s + a2 >> 1,
              u = r ? t.call(o, e[l], l, e) : t(n, e[l]);
            0 < u ? s = l + 1 : (a2 = l, i = !u);
          }
          return i ? s : ~s;
        }, goog.array.sort = function (e, t) {
          e.sort(t || goog.array.defaultCompare);
        }, goog.array.stableSort = function (e, t) {
          for (var r = Array(e.length), n = 0; n < e.length; n++) r[n] = {
            index: n,
            value: e[n]
          };
          var o = t || goog.array.defaultCompare;
          for (goog.array.sort(r, function (e2, t2) {
            return o(e2.value, t2.value) || e2.index - t2.index;
          }), n = 0; n < e.length; n++) e[n] = r[n].value;
        }, goog.array.sortByKey = function (e, t, r) {
          var n = r || goog.array.defaultCompare;
          goog.array.sort(e, function (e2, r2) {
            return n(t(e2), t(r2));
          });
        }, goog.array.sortObjectsByKey = function (e, t, r) {
          goog.array.sortByKey(e, function (e2) {
            return e2[t];
          }, r);
        }, goog.array.isSorted = function (e, t, r) {
          t = t || goog.array.defaultCompare;
          for (var n = 1; n < e.length; n++) {
            var o = t(e[n - 1], e[n]);
            if (0 < o || 0 == o && r) return false;
          }
          return true;
        }, goog.array.equals = function (e, t, r) {
          if (!goog.isArrayLike(e) || !goog.isArrayLike(t) || e.length != t.length) return false;
          var n = e.length;
          r = r || goog.array.defaultCompareEquality;
          for (var o = 0; o < n; o++) if (!r(e[o], t[o])) return false;
          return true;
        }, goog.array.compare3 = function (e, t, r) {
          r = r || goog.array.defaultCompare;
          for (var n = Math.min(e.length, t.length), o = 0; o < n; o++) {
            var i = r(e[o], t[o]);
            if (0 != i) return i;
          }
          return goog.array.defaultCompare(e.length, t.length);
        }, goog.array.defaultCompare = function (e, t) {
          return e > t ? 1 : e < t ? -1 : 0;
        }, goog.array.inverseDefaultCompare = function (e, t) {
          return -goog.array.defaultCompare(e, t);
        }, goog.array.defaultCompareEquality = function (e, t) {
          return e === t;
        }, goog.array.binaryInsert = function (e, t, r) {
          return 0 > (r = goog.array.binarySearch(e, t, r)) && (goog.array.insertAt(e, t, -(r + 1)), true);
        }, goog.array.binaryRemove = function (e, t, r) {
          return 0 <= (t = goog.array.binarySearch(e, t, r)) && goog.array.removeAt(e, t);
        }, goog.array.bucket = function (e, t, r) {
          for (var n = {}, o = 0; o < e.length; o++) {
            var i = e[o],
              s = t.call(r, i, o, e);
            goog.isDef(s) && (n[s] || (n[s] = [])).push(i);
          }
          return n;
        }, goog.array.toObject = function (e, t, r) {
          var n = {};
          return goog.array.forEach(e, function (o, i) {
            n[t.call(r, o, i, e)] = o;
          }), n;
        }, goog.array.range = function (e, t, r) {
          var n = [],
            o = 0,
            i = e;
          if (void 0 !== t && (o = e, i = t), 0 > (r = r || 1) * (i - o)) return [];
          if (0 < r) for (e = o; e < i; e += r) n.push(e);else for (e = o; e > i; e += r) n.push(e);
          return n;
        }, goog.array.repeat = function (e, t) {
          for (var r = [], n = 0; n < t; n++) r[n] = e;
          return r;
        }, goog.array.flatten = function (e) {
          for (var t = [], r = 0; r < arguments.length; r++) {
            var n = arguments[r];
            if (goog.isArray(n)) for (var o = 0; o < n.length; o += 8192) {
              var i = goog.array.slice(n, o, o + 8192);
              i = goog.array.flatten.apply(null, i);
              for (var s = 0; s < i.length; s++) t.push(i[s]);
            } else t.push(n);
          }
          return t;
        }, goog.array.rotate = function (e, t) {
          return goog.asserts.assert(null != e.length), e.length && (0 < (t %= e.length) ? Array.prototype.unshift.apply(e, e.splice(-t, t)) : 0 > t && Array.prototype.push.apply(e, e.splice(0, -t))), e;
        }, goog.array.moveItem = function (e, t, r) {
          goog.asserts.assert(0 <= t && t < e.length), goog.asserts.assert(0 <= r && r < e.length), t = Array.prototype.splice.call(e, t, 1), Array.prototype.splice.call(e, r, 0, t[0]);
        }, goog.array.zip = function (e) {
          if (!arguments.length) return [];
          for (var t = [], r = arguments[0].length, n = 1; n < arguments.length; n++) arguments[n].length < r && (r = arguments[n].length);
          for (n = 0; n < r; n++) {
            for (var o = [], i = 0; i < arguments.length; i++) o.push(arguments[i][n]);
            t.push(o);
          }
          return t;
        }, goog.array.shuffle = function (e, t) {
          t = t || Math.random;
          for (var r = e.length - 1; 0 < r; r--) {
            var n = Math.floor(t() * (r + 1)),
              o = e[r];
            e[r] = e[n], e[n] = o;
          }
        }, goog.array.copyByIndex = function (e, t) {
          var r = [];
          return goog.array.forEach(t, function (t2) {
            r.push(e[t2]);
          }), r;
        }, goog.array.concatMap = function (e, t, r) {
          return goog.array.concat.apply([], goog.array.map(e, t, r));
        }, goog.crypt = {}, goog.crypt.stringToByteArray = function (e) {
          for (var t = [], r = 0, n = 0; n < e.length; n++) {
            var o = e.charCodeAt(n);
            255 < o && (t[r++] = 255 & o, o >>= 8), t[r++] = o;
          }
          return t;
        }, goog.crypt.byteArrayToString = function (e) {
          if (8192 >= e.length) return String.fromCharCode.apply(null, e);
          for (var t = "", r = 0; r < e.length; r += 8192) {
            var n = goog.array.slice(e, r, r + 8192);
            t += String.fromCharCode.apply(null, n);
          }
          return t;
        }, goog.crypt.byteArrayToHex = function (e, t) {
          return goog.array.map(e, function (e2) {
            return 1 < (e2 = e2.toString(16)).length ? e2 : "0" + e2;
          }).join(t || "");
        }, goog.crypt.hexToByteArray = function (e) {
          goog.asserts.assert(0 == e.length % 2, "Key string length must be multiple of 2");
          for (var t = [], r = 0; r < e.length; r += 2) t.push(parseInt(e.substring(r, r + 2), 16));
          return t;
        }, goog.crypt.stringToUtf8ByteArray = function (e) {
          for (var t = [], r = 0, n = 0; n < e.length; n++) {
            var o = e.charCodeAt(n);
            128 > o ? t[r++] = o : (2048 > o ? t[r++] = o >> 6 | 192 : (55296 == (64512 & o) && n + 1 < e.length && 56320 == (64512 & e.charCodeAt(n + 1)) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++n)), t[r++] = o >> 18 | 240, t[r++] = o >> 12 & 63 | 128) : t[r++] = o >> 12 | 224, t[r++] = o >> 6 & 63 | 128), t[r++] = 63 & o | 128);
          }
          return t;
        }, goog.crypt.utf8ByteArrayToString = function (e) {
          for (var t = [], r = 0, n = 0; r < e.length;) {
            var o = e[r++];
            if (128 > o) t[n++] = String.fromCharCode(o);else if (191 < o && 224 > o) {
              var i = e[r++];
              t[n++] = String.fromCharCode((31 & o) << 6 | 63 & i);
            } else if (239 < o && 365 > o) {
              i = e[r++];
              var s = e[r++];
              o = ((7 & o) << 18 | (63 & i) << 12 | (63 & s) << 6 | 63 & e[r++]) - 65536, t[n++] = String.fromCharCode(55296 + (o >> 10)), t[n++] = String.fromCharCode(56320 + (1023 & o));
            } else i = e[r++], s = e[r++], t[n++] = String.fromCharCode((15 & o) << 12 | (63 & i) << 6 | 63 & s);
          }
          return t.join("");
        }, goog.crypt.xorByteArray = function (e, t) {
          goog.asserts.assert(e.length == t.length, "XOR array lengths must match");
          for (var r = [], n = 0; n < e.length; n++) r.push(e[n] ^ t[n]);
          return r;
        }, goog.string = {}, goog.string.internal = {}, goog.string.internal.startsWith = function (e, t) {
          return 0 == e.lastIndexOf(t, 0);
        }, goog.string.internal.endsWith = function (e, t) {
          var r = e.length - t.length;
          return 0 <= r && e.indexOf(t, r) == r;
        }, goog.string.internal.caseInsensitiveStartsWith = function (e, t) {
          return 0 == goog.string.internal.caseInsensitiveCompare(t, e.substr(0, t.length));
        }, goog.string.internal.caseInsensitiveEndsWith = function (e, t) {
          return 0 == goog.string.internal.caseInsensitiveCompare(t, e.substr(e.length - t.length, t.length));
        }, goog.string.internal.caseInsensitiveEquals = function (e, t) {
          return e.toLowerCase() == t.toLowerCase();
        }, goog.string.internal.isEmptyOrWhitespace = function (e) {
          return /^[\s\xa0]*$/.test(e);
        }, goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function (e) {
          return e.trim();
        } : function (e) {
          return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e)[1];
        }, goog.string.internal.caseInsensitiveCompare = function (e, t) {
          return (e = String(e).toLowerCase()) < (t = String(t).toLowerCase()) ? -1 : e == t ? 0 : 1;
        }, goog.string.internal.newLineToBr = function (e, t) {
          return e.replace(/(\r\n|\r|\n)/g, t ? "<br />" : "<br>");
        }, goog.string.internal.htmlEscape = function (e, t) {
          if (t) e = e.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");else {
            if (!goog.string.internal.ALL_RE_.test(e)) return e;
            -1 != e.indexOf("&") && (e = e.replace(goog.string.internal.AMP_RE_, "&amp;")), -1 != e.indexOf("<") && (e = e.replace(goog.string.internal.LT_RE_, "&lt;")), -1 != e.indexOf(">") && (e = e.replace(goog.string.internal.GT_RE_, "&gt;")), -1 != e.indexOf('"') && (e = e.replace(goog.string.internal.QUOT_RE_, "&quot;")), -1 != e.indexOf("'") && (e = e.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;")), -1 != e.indexOf("\0") && (e = e.replace(goog.string.internal.NULL_RE_, "&#0;"));
          }
          return e;
        }, goog.string.internal.AMP_RE_ = /&/g, goog.string.internal.LT_RE_ = /</g, goog.string.internal.GT_RE_ = />/g, goog.string.internal.QUOT_RE_ = /"/g, goog.string.internal.SINGLE_QUOTE_RE_ = /'/g, goog.string.internal.NULL_RE_ = /\x00/g, goog.string.internal.ALL_RE_ = /[\x00&<>"']/, goog.string.internal.whitespaceEscape = function (e, t) {
          return goog.string.internal.newLineToBr(e.replace(/  /g, " &#160;"), t);
        }, goog.string.internal.contains = function (e, t) {
          return -1 != e.indexOf(t);
        }, goog.string.internal.caseInsensitiveContains = function (e, t) {
          return goog.string.internal.contains(e.toLowerCase(), t.toLowerCase());
        }, goog.string.internal.compareVersions = function (e, t) {
          var r = 0;
          e = goog.string.internal.trim(String(e)).split("."), t = goog.string.internal.trim(String(t)).split(".");
          for (var n = Math.max(e.length, t.length), o = 0; 0 == r && o < n; o++) {
            var i = e[o] || "",
              s = t[o] || "";
            do {
              if (i = /(\d*)(\D*)(.*)/.exec(i) || ["", "", "", ""], s = /(\d*)(\D*)(.*)/.exec(s) || ["", "", "", ""], 0 == i[0].length && 0 == s[0].length) break;
              r = 0 == i[1].length ? 0 : parseInt(i[1], 10);
              var a2 = 0 == s[1].length ? 0 : parseInt(s[1], 10);
              r = goog.string.internal.compareElements_(r, a2) || goog.string.internal.compareElements_(0 == i[2].length, 0 == s[2].length) || goog.string.internal.compareElements_(i[2], s[2]), i = i[3], s = s[3];
            } while (0 == r);
          }
          return r;
        }, goog.string.internal.compareElements_ = function (e, t) {
          return e < t ? -1 : e > t ? 1 : 0;
        }, goog.string.TypedString = function () {}, goog.string.Const = function (e, t) {
          this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = e === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && t || "", this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
        }, goog.string.Const.prototype.implementsGoogStringTypedString = true, goog.string.Const.prototype.getTypedStringValue = function () {
          return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
        }, goog.string.Const.prototype.toString = function () {
          return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
        }, goog.string.Const.unwrap = function (e) {
          return e instanceof goog.string.Const && e.constructor === goog.string.Const && e.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_ ? e.stringConstValueWithSecurityContract__googStringSecurityPrivate_ : (goog.asserts.fail("expected object of type Const, got '" + e + "'"), "type_error:Const");
        }, goog.string.Const.from = function (e) {
          return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, e);
        }, goog.string.Const.TYPE_MARKER_ = {}, goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.Const.EMPTY = goog.string.Const.from(""), goog.fs = {}, goog.fs.url = {}, goog.fs.url.createObjectUrl = function (e) {
          return goog.fs.url.getUrlObject_().createObjectURL(e);
        }, goog.fs.url.revokeObjectUrl = function (e) {
          goog.fs.url.getUrlObject_().revokeObjectURL(e);
        }, goog.fs.url.getUrlObject_ = function () {
          var e = goog.fs.url.findUrlObject_();
          if (null != e) return e;
          throw Error("This browser doesn't seem to support blob URLs");
        }, goog.fs.url.findUrlObject_ = function () {
          return goog.isDef(goog.global.URL) && goog.isDef(goog.global.URL.createObjectURL) ? goog.global.URL : goog.isDef(goog.global.webkitURL) && goog.isDef(goog.global.webkitURL.createObjectURL) ? goog.global.webkitURL : goog.isDef(goog.global.createObjectURL) ? goog.global : null;
        }, goog.fs.url.browserSupportsObjectUrls = function () {
          return null != goog.fs.url.findUrlObject_();
        }, goog.html = {}, goog.html.trustedtypes = {}, goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null, goog.i18n = {}, goog.i18n.bidi = {}, goog.i18n.bidi.FORCE_RTL = false, goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ("ar" == goog.LOCALE.substring(0, 2).toLowerCase() || "fa" == goog.LOCALE.substring(0, 2).toLowerCase() || "he" == goog.LOCALE.substring(0, 2).toLowerCase() || "iw" == goog.LOCALE.substring(0, 2).toLowerCase() || "ps" == goog.LOCALE.substring(0, 2).toLowerCase() || "sd" == goog.LOCALE.substring(0, 2).toLowerCase() || "ug" == goog.LOCALE.substring(0, 2).toLowerCase() || "ur" == goog.LOCALE.substring(0, 2).toLowerCase() || "yi" == goog.LOCALE.substring(0, 2).toLowerCase()) && (2 == goog.LOCALE.length || "-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && "ckb" == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || "-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) && ("adlm" == goog.LOCALE.substring(3, 7).toLowerCase() || "arab" == goog.LOCALE.substring(3, 7).toLowerCase() || "hebr" == goog.LOCALE.substring(3, 7).toLowerCase() || "nkoo" == goog.LOCALE.substring(3, 7).toLowerCase() || "rohg" == goog.LOCALE.substring(3, 7).toLowerCase() || "thaa" == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) && ("adlm" == goog.LOCALE.substring(4, 8).toLowerCase() || "arab" == goog.LOCALE.substring(4, 8).toLowerCase() || "hebr" == goog.LOCALE.substring(4, 8).toLowerCase() || "nkoo" == goog.LOCALE.substring(4, 8).toLowerCase() || "rohg" == goog.LOCALE.substring(4, 8).toLowerCase() || "thaa" == goog.LOCALE.substring(4, 8).toLowerCase()), goog.i18n.bidi.Format = {
          LRE: "\u202A",
          RLE: "\u202B",
          PDF: "\u202C",
          LRM: "\u200E",
          RLM: "\u200F"
        }, goog.i18n.bidi.Dir = {
          LTR: 1,
          RTL: -1,
          NEUTRAL: 0
        }, goog.i18n.bidi.RIGHT = "right", goog.i18n.bidi.LEFT = "left", goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT, goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, goog.i18n.bidi.toDir = function (e, t) {
          return "number" == typeof e ? 0 < e ? goog.i18n.bidi.Dir.LTR : 0 > e ? goog.i18n.bidi.Dir.RTL : t ? null : goog.i18n.bidi.Dir.NEUTRAL : null == e ? null : e ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
        }, goog.i18n.bidi.ltrChars_ = "A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0900-\u1FFF\u200E\u2C00-\uD801\uD804-\uD839\uD83C-\uDBFF\uF900-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF", goog.i18n.bidi.rtlChars_ = "\u0591-\u06EF\u06FA-\u08FF\u200F\uD802-\uD803\uD83A-\uD83B\uFB1D-\uFDFF\uFE70-\uFEFC", goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g, goog.i18n.bidi.stripHtmlIfNeeded_ = function (e, t) {
          return t ? e.replace(goog.i18n.bidi.htmlSkipReg_, "") : e;
        }, goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.hasAnyRtl = function (e, t) {
          return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
        }, goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl, goog.i18n.bidi.hasAnyLtr = function (e, t) {
          return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
        }, goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.isRtlChar = function (e) {
          return goog.i18n.bidi.rtlRe_.test(e);
        }, goog.i18n.bidi.isLtrChar = function (e) {
          return goog.i18n.bidi.ltrRe_.test(e);
        }, goog.i18n.bidi.isNeutralChar = function (e) {
          return !goog.i18n.bidi.isLtrChar(e) && !goog.i18n.bidi.isRtlChar(e);
        }, goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.startsWithRtl = function (e, t) {
          return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
        }, goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl, goog.i18n.bidi.startsWithLtr = function (e, t) {
          return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
        }, goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr, goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/, goog.i18n.bidi.isNeutralText = function (e, t) {
          return e = goog.i18n.bidi.stripHtmlIfNeeded_(e, t), goog.i18n.bidi.isRequiredLtrRe_.test(e) || !goog.i18n.bidi.hasAnyLtr(e) && !goog.i18n.bidi.hasAnyRtl(e);
        }, goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$"), goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$"), goog.i18n.bidi.endsWithLtr = function (e, t) {
          return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
        }, goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr, goog.i18n.bidi.endsWithRtl = function (e, t) {
          return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
        }, goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl, goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i, goog.i18n.bidi.isRtlLanguage = function (e) {
          return goog.i18n.bidi.rtlLocalesRe_.test(e);
        }, goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g, goog.i18n.bidi.guardBracketInText = function (e, t) {
          return t = (void 0 === t ? goog.i18n.bidi.hasAnyRtl(e) : t) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM, e.replace(goog.i18n.bidi.bracketGuardTextRe_, t + "$&" + t);
        }, goog.i18n.bidi.enforceRtlInHtml = function (e) {
          return "<" == e.charAt(0) ? e.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + e + "</span>";
        }, goog.i18n.bidi.enforceRtlInText = function (e) {
          return goog.i18n.bidi.Format.RLE + e + goog.i18n.bidi.Format.PDF;
        }, goog.i18n.bidi.enforceLtrInHtml = function (e) {
          return "<" == e.charAt(0) ? e.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + e + "</span>";
        }, goog.i18n.bidi.enforceLtrInText = function (e) {
          return goog.i18n.bidi.Format.LRE + e + goog.i18n.bidi.Format.PDF;
        }, goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g, goog.i18n.bidi.leftRe_ = /left/gi, goog.i18n.bidi.rightRe_ = /right/gi, goog.i18n.bidi.tempRe_ = /%%%%/g, goog.i18n.bidi.mirrorCSS = function (e) {
          return e.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
        }, goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g, goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g, goog.i18n.bidi.normalizeHebrewQuote = function (e) {
          return e.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1\u05F4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1\u05F3");
        }, goog.i18n.bidi.wordSeparatorRe_ = /\s+/, goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/, goog.i18n.bidi.rtlDetectionThreshold_ = 0.4, goog.i18n.bidi.estimateDirection = function (e, t) {
          var r = 0,
            n = 0,
            o = false;
          for (e = goog.i18n.bidi.stripHtmlIfNeeded_(e, t).split(goog.i18n.bidi.wordSeparatorRe_), t = 0; t < e.length; t++) {
            var i = e[t];
            goog.i18n.bidi.startsWithRtl(i) ? (r++, n++) : goog.i18n.bidi.isRequiredLtrRe_.test(i) ? o = true : goog.i18n.bidi.hasAnyLtr(i) ? n++ : goog.i18n.bidi.hasNumeralsRe_.test(i) && (o = true);
          }
          return 0 == n ? o ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : r / n > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
        }, goog.i18n.bidi.detectRtlDirectionality = function (e, t) {
          return goog.i18n.bidi.estimateDirection(e, t) == goog.i18n.bidi.Dir.RTL;
        }, goog.i18n.bidi.setElementDirAndAlign = function (e, t) {
          e && (t = goog.i18n.bidi.toDir(t)) && (e.style.textAlign = t == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, e.dir = t == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
        }, goog.i18n.bidi.setElementDirByTextDirectionality = function (e, t) {
          switch (goog.i18n.bidi.estimateDirection(t)) {
            case goog.i18n.bidi.Dir.LTR:
              e.dir = "ltr";
              break;
            case goog.i18n.bidi.Dir.RTL:
              e.dir = "rtl";
              break;
            default:
              e.removeAttribute("dir");
          }
        }, goog.i18n.bidi.DirectionalString = function () {}, goog.html.TrustedResourceUrl = function () {
          this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = "", this.trustedURL_ = null, this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
        }, goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = true, goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function () {
          return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
        }, goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = true, goog.html.TrustedResourceUrl.prototype.getDirection = function () {
          return goog.i18n.bidi.Dir.LTR;
        }, goog.html.TrustedResourceUrl.prototype.cloneWithParams = function (e, t) {
          var r = goog.html.TrustedResourceUrl.unwrap(this),
            n = (r = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(r))[3] || "";
          return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(r[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", r[2] || "", e) + goog.html.TrustedResourceUrl.stringifyParams_("#", n, t));
        }, goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function () {
          return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
        }), goog.html.TrustedResourceUrl.unwrap = function (e) {
          return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(e).toString();
        }, goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function (e) {
          return e instanceof goog.html.TrustedResourceUrl && e.constructor === goog.html.TrustedResourceUrl && e.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ : (goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:TrustedResourceUrl");
        }, goog.html.TrustedResourceUrl.unwrapTrustedURL = function (e) {
          return e.trustedURL_ ? e.trustedURL_ : goog.html.TrustedResourceUrl.unwrap(e);
        }, goog.html.TrustedResourceUrl.format = function (e, t) {
          var r = goog.string.Const.unwrap(e);
          if (!goog.html.TrustedResourceUrl.BASE_URL_.test(r)) throw Error("Invalid TrustedResourceUrl format: " + r);
          return e = r.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function (e2, n) {
            if (!Object.prototype.hasOwnProperty.call(t, n)) throw Error('Found marker, "' + n + '", in format string, "' + r + '", but no valid label mapping found in args: ' + JSON.stringify(t));
            return (e2 = t[n]) instanceof goog.string.Const ? goog.string.Const.unwrap(e2) : encodeURIComponent(String(e2));
          }), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e);
        }, goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g, goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/, goog.html.TrustedResourceUrl.formatWithParams = function (e, t, r, n) {
          return goog.html.TrustedResourceUrl.format(e, t).cloneWithParams(r, n);
        }, goog.html.TrustedResourceUrl.fromConstant = function (e) {
          return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
        }, goog.html.TrustedResourceUrl.fromConstants = function (e) {
          for (var t = "", r = 0; r < e.length; r++) t += goog.string.Const.unwrap(e[r]);
          return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t);
        }, goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function (e) {
          var t = new goog.html.TrustedResourceUrl();
          return t.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(e) : e, goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY && (t.trustedURL_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(e)), t;
        }, goog.html.TrustedResourceUrl.stringifyParams_ = function (e, t, r) {
          if (null == r) return t;
          if (goog.isString(r)) return r ? e + encodeURIComponent(r) : "";
          for (var n in r) {
            var o = r[n];
            o = goog.isArray(o) ? o : [o];
            for (var i = 0; i < o.length; i++) {
              var s = o[i];
              null != s && (t || (t = e), t += (t.length > e.length ? "&" : "") + encodeURIComponent(n) + "=" + encodeURIComponent(String(s)));
            }
          }
          return t;
        }, goog.html.SafeUrl = function () {
          this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = "", this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
        }, goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez", goog.html.SafeUrl.prototype.implementsGoogStringTypedString = true, goog.html.SafeUrl.prototype.getTypedStringValue = function () {
          return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
        }, goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = true, goog.html.SafeUrl.prototype.getDirection = function () {
          return goog.i18n.bidi.Dir.LTR;
        }, goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function () {
          return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
        }), goog.html.SafeUrl.unwrap = function (e) {
          return goog.html.SafeUrl.unwrapTrustedURL(e).toString();
        }, goog.html.SafeUrl.unwrapTrustedURL = function (e) {
          return e instanceof goog.html.SafeUrl && e.constructor === goog.html.SafeUrl && e.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeUrlWrappedValue_ : (goog.asserts.fail("expected object of type SafeUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeUrl");
        }, goog.html.SafeUrl.fromConstant = function (e) {
          return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
        }, goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime))(?:;\w+=(?:\w+|"[\w;=]+"))*$/i, goog.html.SafeUrl.isSafeMimeType = function (e) {
          return goog.html.SAFE_MIME_TYPE_PATTERN_.test(e);
        }, goog.html.SafeUrl.fromBlob = function (e) {
          return e = goog.html.SAFE_MIME_TYPE_PATTERN_.test(e.type) ? goog.fs.url.createObjectUrl(e) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
        }, goog.html.DATA_URL_PATTERN_ = /^data:([^,]*);base64,[a-z0-9+\/]+=*$/i, goog.html.SafeUrl.fromDataUrl = function (e) {
          var t = (e = e.replace(/(%0A|%0D)/g, "")).match(goog.html.DATA_URL_PATTERN_);
          return t = t && goog.html.SAFE_MIME_TYPE_PATTERN_.test(t[1]), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t ? e : goog.html.SafeUrl.INNOCUOUS_STRING);
        }, goog.html.SafeUrl.fromTelUrl = function (e) {
          return goog.string.internal.caseInsensitiveStartsWith(e, "tel:") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
        }, goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i, goog.html.SafeUrl.fromSipUrl = function (e) {
          return goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(e)) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
        }, goog.html.SafeUrl.fromFacebookMessengerUrl = function (e) {
          return goog.string.internal.caseInsensitiveStartsWith(e, "fb-messenger://share") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
        }, goog.html.SafeUrl.fromWhatsAppUrl = function (e) {
          return goog.string.internal.caseInsensitiveStartsWith(e, "whatsapp://send") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
        }, goog.html.SafeUrl.fromSmsUrl = function (e) {
          return goog.string.internal.caseInsensitiveStartsWith(e, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
        }, goog.html.SafeUrl.isSmsUrlBodyValid_ = function (e) {
          var t = e.indexOf("#");
          if (0 < t && (e = e.substring(0, t)), !(t = e.match(/[?&]body=/gi))) return true;
          if (1 < t.length) return false;
          if (!(e = e.match(/[?&]body=([^&]*)/)[1])) return true;
          try {
            decodeURIComponent(e);
          } catch (e2) {
            return false;
          }
          return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(e);
        }, goog.html.SafeUrl.fromSshUrl = function (e) {
          return goog.string.internal.caseInsensitiveStartsWith(e, "ssh://") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
        }, goog.html.SafeUrl.sanitizeChromeExtensionUrl = function (e, t) {
          return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, e, t);
        }, goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function (e, t) {
          return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, e, t);
        }, goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function (e, t) {
          return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, e, t);
        }, goog.html.SafeUrl.sanitizeExtensionUrl_ = function (e, t, r) {
          return (e = e.exec(t)) ? (e = e[1], -1 == (r instanceof goog.string.Const ? [goog.string.Const.unwrap(r)] : r.map(function (e2) {
            return goog.string.Const.unwrap(e2);
          })).indexOf(e) && (t = goog.html.SafeUrl.INNOCUOUS_STRING)) : t = goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t);
        }, goog.html.SafeUrl.fromTrustedResourceUrl = function (e) {
          return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(e));
        }, goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i, goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_, goog.html.SafeUrl.sanitize = function (e) {
          return e instanceof goog.html.SafeUrl ? e : (e = "object" == typeof e && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SAFE_URL_PATTERN_.test(e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e));
        }, goog.html.SafeUrl.sanitizeAssertUnchanged = function (e, t) {
          return e instanceof goog.html.SafeUrl ? e : (e = "object" == typeof e && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), t && /^data:/i.test(e) && (t = goog.html.SafeUrl.fromDataUrl(e)).getTypedStringValue() == e ? t : (goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(e), "%s does not match the safe URL pattern", e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e)));
        }, goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function (e) {
          var t = new goog.html.SafeUrl();
          return t.privateDoNotAccessOrElseSafeUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(e) : e, t;
        }, goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank"), goog.html.SafeStyle = function () {
          this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "", this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
        }, goog.html.SafeStyle.prototype.implementsGoogStringTypedString = true, goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyle.fromConstant = function (e) {
          return 0 === (e = goog.string.Const.unwrap(e)).length ? goog.html.SafeStyle.EMPTY : (goog.asserts.assert(goog.string.internal.endsWith(e, ";"), "Last character of style string is not ';': " + e), goog.asserts.assert(goog.string.internal.contains(e, ":"), "Style string must contain at least one ':', to specify a \"name: value\" pair: " + e), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(e));
        }, goog.html.SafeStyle.prototype.getTypedStringValue = function () {
          return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
        }, goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function () {
          return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
        }), goog.html.SafeStyle.unwrap = function (e) {
          return e instanceof goog.html.SafeStyle && e.constructor === goog.html.SafeStyle && e.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeStyleWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyle, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyle");
        }, goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function (e) {
          return new goog.html.SafeStyle().initSecurityPrivateDoNotAccessOrElse_(e);
        }, goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e) {
          return this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = e, this;
        }, goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez", goog.html.SafeStyle.create = function (e) {
          var t,
            r = "";
          for (t in e) {
            if (!/^[-_a-zA-Z0-9]+$/.test(t)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + t);
            var n = e[t];
            null != n && (r += t + ":" + (n = goog.isArray(n) ? goog.array.map(n, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(n)) + ";");
          }
          return r ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(r) : goog.html.SafeStyle.EMPTY;
        }, goog.html.SafeStyle.sanitizePropertyValue_ = function (e) {
          if (e instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(e).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
          if (e = e instanceof goog.string.Const ? goog.string.Const.unwrap(e) : goog.html.SafeStyle.sanitizePropertyValueString_(String(e)), /[{;}]/.test(e)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [e]);
          return e;
        }, goog.html.SafeStyle.sanitizePropertyValueString_ = function (e) {
          var t = e.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
          return goog.html.SafeStyle.VALUE_RE_.test(t) ? goog.html.SafeStyle.COMMENT_RE_.test(e) ? (goog.asserts.fail("String value disallows comments, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING) : goog.html.SafeStyle.hasBalancedQuotes_(e) ? goog.html.SafeStyle.hasBalancedSquareBrackets_(e) ? goog.html.SafeStyle.sanitizeUrl_(e) : (goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING) : (goog.asserts.fail("String value requires balanced quotes, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING) : (goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING);
        }, goog.html.SafeStyle.hasBalancedQuotes_ = function (e) {
          for (var t = true, r = true, n = 0; n < e.length; n++) {
            var o = e.charAt(n);
            "'" == o && r ? t = !t : '"' == o && t && (r = !r);
          }
          return t && r;
        }, goog.html.SafeStyle.hasBalancedSquareBrackets_ = function (e) {
          for (var t = true, r = /^[-_a-zA-Z0-9]$/, n = 0; n < e.length; n++) {
            var o = e.charAt(n);
            if ("]" == o) {
              if (t) return false;
              t = true;
            } else if ("[" == o) {
              if (!t) return false;
              t = false;
            } else if (!t && !r.test(o)) return false;
          }
          return t;
        }, goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = "[-,.\"'%_!# a-zA-Z0-9\\[\\]]", goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$"), goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g, goog.html.SafeStyle.FUNCTIONS_RE_ = /\b(hsl|hsla|rgb|rgba|matrix|calc|minmax|fit-content|repeat|(rotate|scale|translate)(X|Y|Z|3d)?)\([-+*/0-9a-z.%\[\], ]+\)/g, goog.html.SafeStyle.COMMENT_RE_ = /\/\*/, goog.html.SafeStyle.sanitizeUrl_ = function (e) {
          return e.replace(goog.html.SafeStyle.URL_RE_, function (e2, t, r, n) {
            var o = "";
            return r = r.replace(/^(['"])(.*)\1$/, function (e3, t2, r2) {
              return o = t2, r2;
            }), e2 = goog.html.SafeUrl.sanitize(r).getTypedStringValue(), t + o + e2 + o + n;
          });
        }, goog.html.SafeStyle.concat = function (e) {
          var t = "",
            r = function r(e2) {
              goog.isArray(e2) ? goog.array.forEach(e2, r) : t += goog.html.SafeStyle.unwrap(e2);
            };
          return goog.array.forEach(arguments, r), t ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t) : goog.html.SafeStyle.EMPTY;
        }, goog.html.SafeScript = function () {
          this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "", this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
        }, goog.html.SafeScript.prototype.implementsGoogStringTypedString = true, goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeScript.fromConstant = function (e) {
          return 0 === (e = goog.string.Const.unwrap(e)).length ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(e);
        }, goog.html.SafeScript.fromConstantAndArgs = function (e, t) {
          for (var r = [], n = 1; n < arguments.length; n++) r.push(goog.html.SafeScript.stringify_(arguments[n]));
          return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(e) + ")(" + r.join(", ") + ");");
        }, goog.html.SafeScript.fromJson = function (e) {
          return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(e));
        }, goog.html.SafeScript.prototype.getTypedStringValue = function () {
          return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
        }, goog.DEBUG && (goog.html.SafeScript.prototype.toString = function () {
          return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
        }), goog.html.SafeScript.unwrap = function (e) {
          return goog.html.SafeScript.unwrapTrustedScript(e).toString();
        }, goog.html.SafeScript.unwrapTrustedScript = function (e) {
          return e instanceof goog.html.SafeScript && e.constructor === goog.html.SafeScript && e.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeScriptWrappedValue_ : (goog.asserts.fail("expected object of type SafeScript, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeScript");
        }, goog.html.SafeScript.stringify_ = function (e) {
          return JSON.stringify(e).replace(/</g, "\\x3c");
        }, goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function (e) {
          return new goog.html.SafeScript().initSecurityPrivateDoNotAccessOrElse_(e);
        }, goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e) {
          return this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(e) : e, this;
        }, goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(""), goog.object = {}, goog.object.is = function (e, t) {
          return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
        }, goog.object.forEach = function (e, t, r) {
          for (var n in e) t.call(r, e[n], n, e);
        }, goog.object.filter = function (e, t, r) {
          var n,
            o = {};
          for (n in e) t.call(r, e[n], n, e) && (o[n] = e[n]);
          return o;
        }, goog.object.map = function (e, t, r) {
          var n,
            o = {};
          for (n in e) o[n] = t.call(r, e[n], n, e);
          return o;
        }, goog.object.some = function (e, t, r) {
          for (var n in e) if (t.call(r, e[n], n, e)) return true;
          return false;
        }, goog.object.every = function (e, t, r) {
          for (var n in e) if (!t.call(r, e[n], n, e)) return false;
          return true;
        }, goog.object.getCount = function (e) {
          var t,
            r = 0;
          for (t in e) r++;
          return r;
        }, goog.object.getAnyKey = function (e) {
          for (var t in e) return t;
        }, goog.object.getAnyValue = function (e) {
          for (var t in e) return e[t];
        }, goog.object.contains = function (e, t) {
          return goog.object.containsValue(e, t);
        }, goog.object.getValues = function (e) {
          var t,
            r = [],
            n = 0;
          for (t in e) r[n++] = e[t];
          return r;
        }, goog.object.getKeys = function (e) {
          var t,
            r = [],
            n = 0;
          for (t in e) r[n++] = t;
          return r;
        }, goog.object.getValueByKeys = function (e, t) {
          var r = goog.isArrayLike(t),
            n = r ? t : arguments;
          for (r = r ? 0 : 1; r < n.length; r++) {
            if (null == e) return;
            e = e[n[r]];
          }
          return e;
        }, goog.object.containsKey = function (e, t) {
          return null !== e && t in e;
        }, goog.object.containsValue = function (e, t) {
          for (var r in e) if (e[r] == t) return true;
          return false;
        }, goog.object.findKey = function (e, t, r) {
          for (var n in e) if (t.call(r, e[n], n, e)) return n;
        }, goog.object.findValue = function (e, t, r) {
          return (t = goog.object.findKey(e, t, r)) && e[t];
        }, goog.object.isEmpty = function (e) {
          for (var t in e) return false;
          return true;
        }, goog.object.clear = function (e) {
          for (var t in e) delete e[t];
        }, goog.object.remove = function (e, t) {
          var r;
          return (r = t in e) && delete e[t], r;
        }, goog.object.add = function (e, t, r) {
          if (null !== e && t in e) throw Error('The object already contains the key "' + t + '"');
          goog.object.set(e, t, r);
        }, goog.object.get = function (e, t, r) {
          return null !== e && t in e ? e[t] : r;
        }, goog.object.set = function (e, t, r) {
          e[t] = r;
        }, goog.object.setIfUndefined = function (e, t, r) {
          return t in e ? e[t] : e[t] = r;
        }, goog.object.setWithReturnValueIfNotSet = function (e, t, r) {
          return t in e ? e[t] : (r = r(), e[t] = r);
        }, goog.object.equals = function (e, t) {
          for (var r in e) if (!(r in t) || e[r] !== t[r]) return false;
          for (var n in t) if (!(n in e)) return false;
          return true;
        }, goog.object.clone = function (e) {
          var t,
            r = {};
          for (t in e) r[t] = e[t];
          return r;
        }, goog.object.unsafeClone = function (e) {
          var t = goog.typeOf(e);
          if ("object" == t || "array" == t) {
            if (goog.isFunction(e.clone)) return e.clone();
            for (var r in t = "array" == t ? [] : {}, e) t[r] = goog.object.unsafeClone(e[r]);
            return t;
          }
          return e;
        }, goog.object.transpose = function (e) {
          var t,
            r = {};
          for (t in e) r[e[t]] = t;
          return r;
        }, goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.object.extend = function (e, t) {
          for (var r, n, o = 1; o < arguments.length; o++) {
            for (r in n = arguments[o]) e[r] = n[r];
            for (var i = 0; i < goog.object.PROTOTYPE_FIELDS_.length; i++) r = goog.object.PROTOTYPE_FIELDS_[i], Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }, goog.object.create = function (e) {
          var t = arguments.length;
          if (1 == t && goog.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
          if (t % 2) throw Error("Uneven number of arguments");
          for (var r = {}, n = 0; n < t; n += 2) r[arguments[n]] = arguments[n + 1];
          return r;
        }, goog.object.createSet = function (e) {
          var t = arguments.length;
          if (1 == t && goog.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
          for (var r = {}, n = 0; n < t; n++) r[arguments[n]] = true;
          return r;
        }, goog.object.createImmutableView = function (e) {
          var t = e;
          return Object.isFrozen && !Object.isFrozen(e) && (t = Object.create(e), Object.freeze(t)), t;
        }, goog.object.isImmutableView = function (e) {
          return !!Object.isFrozen && Object.isFrozen(e);
        }, goog.object.getAllPropertyNames = function (e, t, r) {
          if (!e) return [];
          if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(e);
          for (var n = {}; e && (e !== Object.prototype || t) && (e !== Function.prototype || r);) {
            for (var o = Object.getOwnPropertyNames(e), i = 0; i < o.length; i++) n[o[i]] = true;
            e = Object.getPrototypeOf(e);
          }
          return goog.object.getKeys(n);
        }, goog.object.getSuperClass = function (e) {
          return (e = Object.getPrototypeOf(e.prototype)) && e.constructor;
        }, goog.html.SafeStyleSheet = function () {
          this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "", this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
        }, goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = true, goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyleSheet.createRule = function (e, t) {
          if (goog.string.internal.contains(e, "<")) throw Error("Selector does not allow '<', got: " + e);
          var r = e.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
          if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(r)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + e);
          if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(r)) throw Error("() and [] in selector must be balanced, got: " + e);
          return t instanceof goog.html.SafeStyle || (t = goog.html.SafeStyle.create(t)), e = e + "{" + goog.html.SafeStyle.unwrap(t).replace(/</g, "\\3C ") + "}", goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e);
        }, goog.html.SafeStyleSheet.hasBalancedBrackets_ = function (e) {
          for (var t = {
              "(": ")",
              "[": "]"
            }, r = [], n = 0; n < e.length; n++) {
            var o = e[n];
            if (t[o]) r.push(t[o]);else if (goog.object.contains(t, o) && r.pop() != o) return false;
          }
          return 0 == r.length;
        }, goog.html.SafeStyleSheet.concat = function (e) {
          var t = "",
            r = function r(e2) {
              goog.isArray(e2) ? goog.array.forEach(e2, r) : t += goog.html.SafeStyleSheet.unwrap(e2);
            };
          return goog.array.forEach(arguments, r), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t);
        }, goog.html.SafeStyleSheet.fromConstant = function (e) {
          return 0 === (e = goog.string.Const.unwrap(e)).length ? goog.html.SafeStyleSheet.EMPTY : (goog.asserts.assert(!goog.string.internal.contains(e, "<"), "Forbidden '<' character in style sheet string: " + e), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e));
        }, goog.html.SafeStyleSheet.prototype.getTypedStringValue = function () {
          return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
        }, goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function () {
          return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
        }), goog.html.SafeStyleSheet.unwrap = function (e) {
          return e instanceof goog.html.SafeStyleSheet && e.constructor === goog.html.SafeStyleSheet && e.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyleSheet, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyleSheet");
        }, goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function (e) {
          return new goog.html.SafeStyleSheet().initSecurityPrivateDoNotAccessOrElse_(e);
        }, goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e) {
          return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = e, this;
        }, goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(""), goog.dom.tags = {}, goog.dom.tags.VOID_TAGS_ = {
          area: true,
          base: true,
          br: true,
          col: true,
          command: true,
          embed: true,
          hr: true,
          img: true,
          input: true,
          keygen: true,
          link: true,
          meta: true,
          param: true,
          source: true,
          track: true,
          wbr: true
        }, goog.dom.tags.isVoidTag = function (e) {
          return true === goog.dom.tags.VOID_TAGS_[e];
        }, goog.dom.HtmlElement = function () {}, goog.dom.TagName = function (e) {
          this.tagName_ = e;
        }, goog.dom.TagName.prototype.toString = function () {
          return this.tagName_;
        }, goog.dom.TagName.A = new goog.dom.TagName("A"), goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR"), goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM"), goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS"), goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET"), goog.dom.TagName.AREA = new goog.dom.TagName("AREA"), goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE"), goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE"), goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO"), goog.dom.TagName.B = new goog.dom.TagName("B"), goog.dom.TagName.BASE = new goog.dom.TagName("BASE"), goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT"), goog.dom.TagName.BDI = new goog.dom.TagName("BDI"), goog.dom.TagName.BDO = new goog.dom.TagName("BDO"), goog.dom.TagName.BIG = new goog.dom.TagName("BIG"), goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE"), goog.dom.TagName.BODY = new goog.dom.TagName("BODY"), goog.dom.TagName.BR = new goog.dom.TagName("BR"), goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON"), goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS"), goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION"), goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER"), goog.dom.TagName.CITE = new goog.dom.TagName("CITE"), goog.dom.TagName.CODE = new goog.dom.TagName("CODE"), goog.dom.TagName.COL = new goog.dom.TagName("COL"), goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP"), goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND"), goog.dom.TagName.DATA = new goog.dom.TagName("DATA"), goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST"), goog.dom.TagName.DD = new goog.dom.TagName("DD"), goog.dom.TagName.DEL = new goog.dom.TagName("DEL"), goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS"), goog.dom.TagName.DFN = new goog.dom.TagName("DFN"), goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG"), goog.dom.TagName.DIR = new goog.dom.TagName("DIR"), goog.dom.TagName.DIV = new goog.dom.TagName("DIV"), goog.dom.TagName.DL = new goog.dom.TagName("DL"), goog.dom.TagName.DT = new goog.dom.TagName("DT"), goog.dom.TagName.EM = new goog.dom.TagName("EM"), goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED"), goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET"), goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION"), goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE"), goog.dom.TagName.FONT = new goog.dom.TagName("FONT"), goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER"), goog.dom.TagName.FORM = new goog.dom.TagName("FORM"), goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME"), goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET"), goog.dom.TagName.H1 = new goog.dom.TagName("H1"), goog.dom.TagName.H2 = new goog.dom.TagName("H2"), goog.dom.TagName.H3 = new goog.dom.TagName("H3"), goog.dom.TagName.H4 = new goog.dom.TagName("H4"), goog.dom.TagName.H5 = new goog.dom.TagName("H5"), goog.dom.TagName.H6 = new goog.dom.TagName("H6"), goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD"), goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER"), goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP"), goog.dom.TagName.HR = new goog.dom.TagName("HR"), goog.dom.TagName.HTML = new goog.dom.TagName("HTML"), goog.dom.TagName.I = new goog.dom.TagName("I"), goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME"), goog.dom.TagName.IMG = new goog.dom.TagName("IMG"), goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT"), goog.dom.TagName.INS = new goog.dom.TagName("INS"), goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX"), goog.dom.TagName.KBD = new goog.dom.TagName("KBD"), goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN"), goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL"), goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND"), goog.dom.TagName.LI = new goog.dom.TagName("LI"), goog.dom.TagName.LINK = new goog.dom.TagName("LINK"), goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN"), goog.dom.TagName.MAP = new goog.dom.TagName("MAP"), goog.dom.TagName.MARK = new goog.dom.TagName("MARK"), goog.dom.TagName.MATH = new goog.dom.TagName("MATH"), goog.dom.TagName.MENU = new goog.dom.TagName("MENU"), goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM"), goog.dom.TagName.META = new goog.dom.TagName("META"), goog.dom.TagName.METER = new goog.dom.TagName("METER"), goog.dom.TagName.NAV = new goog.dom.TagName("NAV"), goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES"), goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT"), goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT"), goog.dom.TagName.OL = new goog.dom.TagName("OL"), goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP"), goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION"), goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT"), goog.dom.TagName.P = new goog.dom.TagName("P"), goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM"), goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE"), goog.dom.TagName.PRE = new goog.dom.TagName("PRE"), goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS"), goog.dom.TagName.Q = new goog.dom.TagName("Q"), goog.dom.TagName.RP = new goog.dom.TagName("RP"), goog.dom.TagName.RT = new goog.dom.TagName("RT"), goog.dom.TagName.RTC = new goog.dom.TagName("RTC"), goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY"), goog.dom.TagName.S = new goog.dom.TagName("S"), goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP"), goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT"), goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION"), goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT"), goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL"), goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE"), goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN"), goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE"), goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG"), goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE"), goog.dom.TagName.SUB = new goog.dom.TagName("SUB"), goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY"), goog.dom.TagName.SUP = new goog.dom.TagName("SUP"), goog.dom.TagName.SVG = new goog.dom.TagName("SVG"), goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE"), goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY"), goog.dom.TagName.TD = new goog.dom.TagName("TD"), goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE"), goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA"), goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT"), goog.dom.TagName.TH = new goog.dom.TagName("TH"), goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD"), goog.dom.TagName.TIME = new goog.dom.TagName("TIME"), goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE"), goog.dom.TagName.TR = new goog.dom.TagName("TR"), goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK"), goog.dom.TagName.TT = new goog.dom.TagName("TT"), goog.dom.TagName.U = new goog.dom.TagName("U"), goog.dom.TagName.UL = new goog.dom.TagName("UL"), goog.dom.TagName.VAR = new goog.dom.TagName("VAR"), goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO"), goog.dom.TagName.WBR = new goog.dom.TagName("WBR"), goog.labs = {}, goog.labs.userAgent = {}, goog.labs.userAgent.util = {}, goog.labs.userAgent.util.getNativeUserAgentString_ = function () {
          var e = goog.labs.userAgent.util.getNavigator_();
          return e && (e = e.userAgent) ? e : "";
        }, goog.labs.userAgent.util.getNavigator_ = function () {
          return goog.global.navigator;
        }, goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_(), goog.labs.userAgent.util.setUserAgent = function (e) {
          goog.labs.userAgent.util.userAgent_ = e || goog.labs.userAgent.util.getNativeUserAgentString_();
        }, goog.labs.userAgent.util.getUserAgent = function () {
          return goog.labs.userAgent.util.userAgent_;
        }, goog.labs.userAgent.util.matchUserAgent = function (e) {
          var t = goog.labs.userAgent.util.getUserAgent();
          return goog.string.internal.contains(t, e);
        }, goog.labs.userAgent.util.matchUserAgentIgnoreCase = function (e) {
          var t = goog.labs.userAgent.util.getUserAgent();
          return goog.string.internal.caseInsensitiveContains(t, e);
        }, goog.labs.userAgent.util.extractVersionTuples = function (e) {
          for (var t, r = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, n = []; t = r.exec(e);) n.push([t[1], t[2], t[3] || void 0]);
          return n;
        }, goog.labs.userAgent.browser = {}, goog.labs.userAgent.browser.matchOpera_ = function () {
          return goog.labs.userAgent.util.matchUserAgent("Opera");
        }, goog.labs.userAgent.browser.matchIE_ = function () {
          return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
        }, goog.labs.userAgent.browser.matchEdgeHtml_ = function () {
          return goog.labs.userAgent.util.matchUserAgent("Edge");
        }, goog.labs.userAgent.browser.matchEdgeChromium_ = function () {
          return goog.labs.userAgent.util.matchUserAgent("Edg/");
        }, goog.labs.userAgent.browser.matchOperaChromium_ = function () {
          return goog.labs.userAgent.util.matchUserAgent("OPR");
        }, goog.labs.userAgent.browser.matchFirefox_ = function () {
          return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
        }, goog.labs.userAgent.browser.matchSafari_ = function () {
          return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
        }, goog.labs.userAgent.browser.matchCoast_ = function () {
          return goog.labs.userAgent.util.matchUserAgent("Coast");
        }, goog.labs.userAgent.browser.matchIosWebview_ = function () {
          return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
        }, goog.labs.userAgent.browser.matchChrome_ = function () {
          return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
        }, goog.labs.userAgent.browser.matchAndroidBrowser_ = function () {
          return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
        }, goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_, goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_, goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_, goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_, goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_, goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_, goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_, goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_, goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_, goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_, goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_, goog.labs.userAgent.browser.isSilk = function () {
          return goog.labs.userAgent.util.matchUserAgent("Silk");
        }, goog.labs.userAgent.browser.getVersion = function () {
          function e(e2) {
            return e2 = goog.array.find(e2, n), r[e2] || "";
          }
          var t = goog.labs.userAgent.util.getUserAgent();
          if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(t);
          t = goog.labs.userAgent.util.extractVersionTuples(t);
          var r = {};
          goog.array.forEach(t, function (e2) {
            r[e2[0]] = e2[1];
          });
          var n = goog.partial(goog.object.containsKey, r);
          return goog.labs.userAgent.browser.isOpera() ? e(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? e(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? e(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? e(["Chrome", "CriOS"]) : (t = t[2]) && t[1] || "";
        }, goog.labs.userAgent.browser.isVersionOrHigher = function (e) {
          return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), e);
        }, goog.labs.userAgent.browser.getIEVersion_ = function (e) {
          var t = /rv: *([\d\.]*)/.exec(e);
          if (t && t[1]) return t[1];
          t = "";
          var r = /MSIE +([\d\.]+)/.exec(e);
          if (r && r[1]) if (e = /Trident\/(\d.\d)/.exec(e), "7.0" == r[1]) {
            if (e && e[1]) switch (e[1]) {
              case "4.0":
                t = "8.0";
                break;
              case "5.0":
                t = "9.0";
                break;
              case "6.0":
                t = "10.0";
                break;
              case "7.0":
                t = "11.0";
            } else t = "7.0";
          } else t = r[1];
          return t;
        }, goog.html.SafeHtml = function () {
          this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "", this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_, this.dir_ = null;
        }, goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = true, goog.html.SafeHtml.prototype.getDirection = function () {
          return this.dir_;
        }, goog.html.SafeHtml.prototype.implementsGoogStringTypedString = true, goog.html.SafeHtml.prototype.getTypedStringValue = function () {
          return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
        }, goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function () {
          return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
        }), goog.html.SafeHtml.unwrap = function (e) {
          return goog.html.SafeHtml.unwrapTrustedHTML(e).toString();
        }, goog.html.SafeHtml.unwrapTrustedHTML = function (e) {
          return e instanceof goog.html.SafeHtml && e.constructor === goog.html.SafeHtml && e.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeHtmlWrappedValue_ : (goog.asserts.fail("expected object of type SafeHtml, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeHtml");
        }, goog.html.SafeHtml.htmlEscape = function (e) {
          if (e instanceof goog.html.SafeHtml) return e;
          var t = "object" == typeof e,
            r = null;
          return t && e.implementsGoogI18nBidiDirectionalString && (r = e.getDirection()), e = t && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(e), r);
        }, goog.html.SafeHtml.htmlEscapePreservingNewlines = function (e) {
          return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
        }, goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function (e) {
          return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
        }, goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape, goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/, goog.html.SafeHtml.URL_ATTRIBUTES_ = {
          action: true,
          cite: true,
          data: true,
          formaction: true,
          href: true,
          manifest: true,
          poster: true,
          src: true
        }, goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = {
          APPLET: true,
          BASE: true,
          EMBED: true,
          IFRAME: true,
          LINK: true,
          MATH: true,
          META: true,
          OBJECT: true,
          SCRIPT: true,
          STYLE: true,
          SVG: true,
          TEMPLATE: true
        }, goog.html.SafeHtml.create = function (e, t, r) {
          return goog.html.SafeHtml.verifyTagName(String(e)), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(e), t, r);
        }, goog.html.SafeHtml.verifyTagName = function (e) {
          if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(e)) throw Error("Invalid tag name <" + e + ">.");
          if (e.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error("Tag name <" + e + "> is not allowed for SafeHtml.");
        }, goog.html.SafeHtml.createIframe = function (e, t, r, n) {
          e && goog.html.TrustedResourceUrl.unwrap(e);
          var o = {};
          return o.src = e || null, o.srcdoc = t && goog.html.SafeHtml.unwrap(t), e = goog.html.SafeHtml.combineAttributes(o, {
            sandbox: ""
          }, r), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, n);
        }, goog.html.SafeHtml.createSandboxIframe = function (e, t, r, n) {
          if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error("The browser does not support sandboxed iframes.");
          var o = {};
          return o.src = e ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)) : null, o.srcdoc = t || null, o.sandbox = "", e = goog.html.SafeHtml.combineAttributes(o, {}, r), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, n);
        }, goog.html.SafeHtml.canUseSandboxIframe = function () {
          return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
        }, goog.html.SafeHtml.createScriptSrc = function (e, t) {
          return goog.html.TrustedResourceUrl.unwrap(e), e = goog.html.SafeHtml.combineAttributes({
            src: e
          }, {}, t), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", e);
        }, goog.html.SafeHtml.createScript = function (e, t) {
          for (var r in t) {
            var n = r.toLowerCase();
            if ("language" == n || "src" == n || "text" == n || "type" == n) throw Error('Cannot set "' + n + '" attribute');
          }
          for (r = "", e = goog.array.concat(e), n = 0; n < e.length; n++) r += goog.html.SafeScript.unwrap(e[n]);
          return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(r, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", t, e);
        }, goog.html.SafeHtml.createStyle = function (e, t) {
          t = goog.html.SafeHtml.combineAttributes({
            type: "text/css"
          }, {}, t);
          var r = "";
          e = goog.array.concat(e);
          for (var n = 0; n < e.length; n++) r += goog.html.SafeStyleSheet.unwrap(e[n]);
          return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(r, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", t, e);
        }, goog.html.SafeHtml.createMetaRefresh = function (e, t) {
          return e = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)), (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(e, ";") && (e = "'" + e.replace(/'/g, "%27") + "'"), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {
            "http-equiv": "refresh",
            content: (t || 0) + "; url=" + e
          });
        }, goog.html.SafeHtml.getAttrNameAndValue_ = function (e, t, r) {
          if (r instanceof goog.string.Const) r = goog.string.Const.unwrap(r);else if ("style" == t.toLowerCase()) r = goog.html.SafeHtml.getStyleValue_(r);else {
            if (/^on/i.test(t)) throw Error('Attribute "' + t + '" requires goog.string.Const value, "' + r + '" given.');
            if (t.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) if (r instanceof goog.html.TrustedResourceUrl) r = goog.html.TrustedResourceUrl.unwrap(r);else if (r instanceof goog.html.SafeUrl) r = goog.html.SafeUrl.unwrap(r);else {
              if (!goog.isString(r)) throw Error('Attribute "' + t + '" on tag "' + e + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + r + '" given.');
              r = goog.html.SafeUrl.sanitize(r).getTypedStringValue();
            }
          }
          return r.implementsGoogStringTypedString && (r = r.getTypedStringValue()), goog.asserts.assert(goog.isString(r) || goog.isNumber(r), "String or number value expected, got " + typeof r + " with value: " + r), t + '="' + goog.string.internal.htmlEscape(String(r)) + '"';
        }, goog.html.SafeHtml.getStyleValue_ = function (e) {
          if (!goog.isObject(e)) throw Error('The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof e + " given: " + e);
          return e instanceof goog.html.SafeStyle || (e = goog.html.SafeStyle.create(e)), goog.html.SafeStyle.unwrap(e);
        }, goog.html.SafeHtml.createWithDir = function (e, t, r, n) {
          return (t = goog.html.SafeHtml.create(t, r, n)).dir_ = e, t;
        }, goog.html.SafeHtml.join = function (e, t) {
          var r = (e = goog.html.SafeHtml.htmlEscape(e)).getDirection(),
            n = [],
            o = function o(e2) {
              goog.isArray(e2) ? goog.array.forEach(e2, o) : (e2 = goog.html.SafeHtml.htmlEscape(e2), n.push(goog.html.SafeHtml.unwrap(e2)), e2 = e2.getDirection(), r == goog.i18n.bidi.Dir.NEUTRAL ? r = e2 : e2 != goog.i18n.bidi.Dir.NEUTRAL && r != e2 && (r = null));
            };
          return goog.array.forEach(t, o), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(n.join(goog.html.SafeHtml.unwrap(e)), r);
        }, goog.html.SafeHtml.concat = function (e) {
          return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
        }, goog.html.SafeHtml.concatWithDir = function (e, t) {
          var r = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
          return r.dir_ = e, r;
        }, goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function (e, t) {
          return new goog.html.SafeHtml().initSecurityPrivateDoNotAccessOrElse_(e, t);
        }, goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e, t) {
          return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(e) : e, this.dir_ = t, this;
        }, goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function (e, t, r) {
          var n = null,
            o = "<" + e + goog.html.SafeHtml.stringifyAttributes(e, t);
          return goog.isDefAndNotNull(r) ? goog.isArray(r) || (r = [r]) : r = [], goog.dom.tags.isVoidTag(e.toLowerCase()) ? (goog.asserts.assert(!r.length, "Void tag <" + e + "> does not allow content."), o += ">") : (n = goog.html.SafeHtml.concat(r), o += ">" + goog.html.SafeHtml.unwrap(n) + "</" + e + ">", n = n.getDirection()), (e = t && t.dir) && (n = /^(ltr|rtl|auto)$/i.test(e) ? goog.i18n.bidi.Dir.NEUTRAL : null), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o, n);
        }, goog.html.SafeHtml.stringifyAttributes = function (e, t) {
          var r = "";
          if (t) for (var n in t) {
            if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(n)) throw Error('Invalid attribute name "' + n + '".');
            var o = t[n];
            goog.isDefAndNotNull(o) && (r += " " + goog.html.SafeHtml.getAttrNameAndValue_(e, n, o));
          }
          return r;
        }, goog.html.SafeHtml.combineAttributes = function (e, t, r) {
          var n,
            o = {};
          for (n in e) goog.asserts.assert(n.toLowerCase() == n, "Must be lower case"), o[n] = e[n];
          for (n in t) goog.asserts.assert(n.toLowerCase() == n, "Must be lower case"), o[n] = t[n];
          for (n in r) {
            var i = n.toLowerCase();
            if (i in e) throw Error('Cannot override "' + i + '" attribute, got "' + n + '" with value "' + r[n] + '"');
            i in t && delete o[i], o[n] = r[n];
          }
          return o;
        }, goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.uncheckedconversions = {}, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function (e, t, r) {
          return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(t, r || null);
        }, goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function (e, t) {
          return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(t);
        }, goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function (e, t) {
          return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t);
        }, goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function (e, t) {
          return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t);
        }, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function (e, t) {
          return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t);
        }, goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function (e, t) {
          return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t);
        }, goog.dom.asserts = {}, goog.dom.asserts.assertIsLocation = function (e) {
          if (goog.asserts.ENABLE_ASSERTS) {
            var t = goog.dom.asserts.getWindow_(e);
            t && (!e || !(e instanceof t.Location) && e instanceof t.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(e));
          }
          return e;
        }, goog.dom.asserts.assertIsElementType_ = function (e, t) {
          if (goog.asserts.ENABLE_ASSERTS) {
            var r = goog.dom.asserts.getWindow_(e);
            r && void 0 !== r[t] && (e && (e instanceof r[t] || !(e instanceof r.Location || e instanceof r.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", t, goog.dom.asserts.debugStringForType_(e)));
          }
          return e;
        }, goog.dom.asserts.assertIsHTMLAnchorElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLAnchorElement");
        }, goog.dom.asserts.assertIsHTMLButtonElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLButtonElement");
        }, goog.dom.asserts.assertIsHTMLLinkElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLLinkElement");
        }, goog.dom.asserts.assertIsHTMLImageElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLImageElement");
        }, goog.dom.asserts.assertIsHTMLAudioElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLAudioElement");
        }, goog.dom.asserts.assertIsHTMLVideoElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLVideoElement");
        }, goog.dom.asserts.assertIsHTMLInputElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLInputElement");
        }, goog.dom.asserts.assertIsHTMLTextAreaElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLTextAreaElement");
        }, goog.dom.asserts.assertIsHTMLCanvasElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLCanvasElement");
        }, goog.dom.asserts.assertIsHTMLEmbedElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLEmbedElement");
        }, goog.dom.asserts.assertIsHTMLFormElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLFormElement");
        }, goog.dom.asserts.assertIsHTMLFrameElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLFrameElement");
        }, goog.dom.asserts.assertIsHTMLIFrameElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLIFrameElement");
        }, goog.dom.asserts.assertIsHTMLObjectElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLObjectElement");
        }, goog.dom.asserts.assertIsHTMLScriptElement = function (e) {
          return goog.dom.asserts.assertIsElementType_(e, "HTMLScriptElement");
        }, goog.dom.asserts.debugStringForType_ = function (e) {
          if (!goog.isObject(e)) return void 0 === e ? "undefined" : null === e ? "null" : typeof e;
          try {
            return e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e);
          } catch (e2) {
            return "<object could not be stringified>";
          }
        }, goog.dom.asserts.getWindow_ = function (e) {
          try {
            var t = e && e.ownerDocument,
              r = t && (t.defaultView || t.parentWindow);
            if ((r = r || goog.global).Element && r.Location) return r;
          } catch (e2) {}
          return null;
        }, goog.functions = {}, goog.functions.constant = function (e) {
          return function () {
            return e;
          };
        }, goog.functions.FALSE = function () {
          return false;
        }, goog.functions.TRUE = function () {
          return true;
        }, goog.functions.NULL = function () {
          return null;
        }, goog.functions.identity = function (e, t) {
          return e;
        }, goog.functions.error = function (e) {
          return function () {
            throw Error(e);
          };
        }, goog.functions.fail = function (e) {
          return function () {
            throw e;
          };
        }, goog.functions.lock = function (e, t) {
          return t = t || 0, function () {
            return e.apply(this, Array.prototype.slice.call(arguments, 0, t));
          };
        }, goog.functions.nth = function (e) {
          return function () {
            return arguments[e];
          };
        }, goog.functions.partialRight = function (e, t) {
          var r = Array.prototype.slice.call(arguments, 1);
          return function () {
            var t2 = Array.prototype.slice.call(arguments);
            return t2.push.apply(t2, r), e.apply(this, t2);
          };
        }, goog.functions.withReturnValue = function (e, t) {
          return goog.functions.sequence(e, goog.functions.constant(t));
        }, goog.functions.equalTo = function (e, t) {
          return function (r) {
            return t ? e == r : e === r;
          };
        }, goog.functions.compose = function (e, t) {
          var r = arguments,
            n = r.length;
          return function () {
            var e2;
            n && (e2 = r[n - 1].apply(this, arguments));
            for (var t2 = n - 2; 0 <= t2; t2--) e2 = r[t2].call(this, e2);
            return e2;
          };
        }, goog.functions.sequence = function (e) {
          var t = arguments,
            r = t.length;
          return function () {
            for (var e2, n = 0; n < r; n++) e2 = t[n].apply(this, arguments);
            return e2;
          };
        }, goog.functions.and = function (e) {
          var t = arguments,
            r = t.length;
          return function () {
            for (var e2 = 0; e2 < r; e2++) if (!t[e2].apply(this, arguments)) return false;
            return true;
          };
        }, goog.functions.or = function (e) {
          var t = arguments,
            r = t.length;
          return function () {
            for (var e2 = 0; e2 < r; e2++) if (t[e2].apply(this, arguments)) return true;
            return false;
          };
        }, goog.functions.not = function (e) {
          return function () {
            return !e.apply(this, arguments);
          };
        }, goog.functions.create = function (e, t) {
          var r = function r() {};
          return r.prototype = e.prototype, r = new r(), e.apply(r, Array.prototype.slice.call(arguments, 1)), r;
        }, goog.functions.CACHE_RETURN_VALUE = true, goog.functions.cacheReturnValue = function (e) {
          var t,
            r = false;
          return function () {
            return goog.functions.CACHE_RETURN_VALUE ? (r || (t = e(), r = true), t) : e();
          };
        }, goog.functions.once = function (e) {
          var t = e;
          return function () {
            if (t) {
              var e2 = t;
              t = null, e2();
            }
          };
        }, goog.functions.debounce = function (e, t, r) {
          var n = 0;
          return function (o) {
            goog.global.clearTimeout(n);
            var i = arguments;
            n = goog.global.setTimeout(function () {
              e.apply(r, i);
            }, t);
          };
        }, goog.functions.throttle = function (e, t, r) {
          var n = 0,
            o = false,
            i = [],
            s = function s() {
              n = 0, o && (o = false, a2());
            },
            a2 = function a2() {
              n = goog.global.setTimeout(s, t), e.apply(r, i);
            };
          return function (e2) {
            i = arguments, n ? o = true : a2();
          };
        }, goog.functions.rateLimit = function (e, t, r) {
          var n = 0,
            o = function o() {
              n = 0;
            };
          return function (i) {
            n || (n = goog.global.setTimeout(o, t), e.apply(r, arguments));
          };
        }, goog.dom.safe = {}, goog.dom.safe.InsertAdjacentHtmlPosition = {
          AFTERBEGIN: "afterbegin",
          AFTEREND: "afterend",
          BEFOREBEGIN: "beforebegin",
          BEFOREEND: "beforeend"
        }, goog.dom.safe.insertAdjacentHtml = function (e, t, r) {
          e.insertAdjacentHTML(t, goog.html.SafeHtml.unwrapTrustedHTML(r));
        }, goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
          MATH: true,
          SCRIPT: true,
          STYLE: true,
          SVG: true,
          TEMPLATE: true
        }, goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function () {
          if (goog.DEBUG && "undefined" == typeof document) return false;
          var e = document.createElement("div"),
            t = document.createElement("div");
          return t.appendChild(document.createElement("div")), e.appendChild(t), !(goog.DEBUG && !e.firstChild) && (t = e.firstChild.firstChild, e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY), !t.parentElement);
        }), goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function (e, t) {
          if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for (; e.lastChild;) e.removeChild(e.lastChild);
          e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t);
        }, goog.dom.safe.setInnerHtml = function (e, t) {
          if (goog.asserts.ENABLE_ASSERTS) {
            var r = e.tagName.toUpperCase();
            if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[r]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + e.tagName + ".");
          }
          goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(e, t);
        }, goog.dom.safe.setOuterHtml = function (e, t) {
          e.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t);
        }, goog.dom.safe.setFormElementAction = function (e, t) {
          t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLFormElement(e).action = goog.html.SafeUrl.unwrapTrustedURL(t);
        }, goog.dom.safe.setButtonFormAction = function (e, t) {
          t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLButtonElement(e).formAction = goog.html.SafeUrl.unwrapTrustedURL(t);
        }, goog.dom.safe.setInputFormAction = function (e, t) {
          t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLInputElement(e).formAction = goog.html.SafeUrl.unwrapTrustedURL(t);
        }, goog.dom.safe.setStyle = function (e, t) {
          e.style.cssText = goog.html.SafeStyle.unwrap(t);
        }, goog.dom.safe.documentWrite = function (e, t) {
          e.write(goog.html.SafeHtml.unwrapTrustedHTML(t));
        }, goog.dom.safe.setAnchorHref = function (e, t) {
          goog.dom.asserts.assertIsHTMLAnchorElement(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.href = goog.html.SafeUrl.unwrapTrustedURL(t);
        }, goog.dom.safe.setImageSrc = function (e, t) {
          if (goog.dom.asserts.assertIsHTMLImageElement(e), !(t instanceof goog.html.SafeUrl)) {
            var r = /^data:image\//i.test(t);
            t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, r);
          }
          e.src = goog.html.SafeUrl.unwrapTrustedURL(t);
        }, goog.dom.safe.setAudioSrc = function (e, t) {
          if (goog.dom.asserts.assertIsHTMLAudioElement(e), !(t instanceof goog.html.SafeUrl)) {
            var r = /^data:audio\//i.test(t);
            t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, r);
          }
          e.src = goog.html.SafeUrl.unwrapTrustedURL(t);
        }, goog.dom.safe.setVideoSrc = function (e, t) {
          if (goog.dom.asserts.assertIsHTMLVideoElement(e), !(t instanceof goog.html.SafeUrl)) {
            var r = /^data:video\//i.test(t);
            t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, r);
          }
          e.src = goog.html.SafeUrl.unwrapTrustedURL(t);
        }, goog.dom.safe.setEmbedSrc = function (e, t) {
          goog.dom.asserts.assertIsHTMLEmbedElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t);
        }, goog.dom.safe.setFrameSrc = function (e, t) {
          goog.dom.asserts.assertIsHTMLFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(t);
        }, goog.dom.safe.setIframeSrc = function (e, t) {
          goog.dom.asserts.assertIsHTMLIFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(t);
        }, goog.dom.safe.setIframeSrcdoc = function (e, t) {
          goog.dom.asserts.assertIsHTMLIFrameElement(e), e.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(t);
        }, goog.dom.safe.setLinkHrefAndRel = function (e, t, r) {
          goog.dom.asserts.assertIsHTMLLinkElement(e), e.rel = r, goog.string.internal.caseInsensitiveContains(r, "stylesheet") ? (goog.asserts.assert(t instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), e.href = goog.html.TrustedResourceUrl.unwrapTrustedURL(t)) : e.href = t instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrapTrustedURL(t) : t instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrapTrustedURL(t) : goog.html.SafeUrl.unwrapTrustedURL(goog.html.SafeUrl.sanitizeAssertUnchanged(t));
        }, goog.dom.safe.setObjectData = function (e, t) {
          goog.dom.asserts.assertIsHTMLObjectElement(e), e.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t);
        }, goog.dom.safe.setScriptSrc = function (e, t) {
          goog.dom.asserts.assertIsHTMLScriptElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t), (t = goog.getScriptNonce()) && e.setAttribute("nonce", t);
        }, goog.dom.safe.setScriptContent = function (e, t) {
          goog.dom.asserts.assertIsHTMLScriptElement(e), e.text = goog.html.SafeScript.unwrapTrustedScript(t), (t = goog.getScriptNonce()) && e.setAttribute("nonce", t);
        }, goog.dom.safe.setLocationHref = function (e, t) {
          goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.href = goog.html.SafeUrl.unwrapTrustedURL(t);
        }, goog.dom.safe.assignLocation = function (e, t) {
          goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.assign(goog.html.SafeUrl.unwrapTrustedURL(t));
        }, goog.dom.safe.replaceLocation = function (e, t) {
          goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.replace(goog.html.SafeUrl.unwrapTrustedURL(t));
        }, goog.dom.safe.openInWindow = function (e, t, r, n, o) {
          return e = e instanceof goog.html.SafeUrl ? e : goog.html.SafeUrl.sanitizeAssertUnchanged(e), (t || goog.global).open(goog.html.SafeUrl.unwrapTrustedURL(e), r ? goog.string.Const.unwrap(r) : "", n, o);
        }, goog.dom.safe.parseFromStringHtml = function (e, t) {
          return goog.dom.safe.parseFromString(e, t, "text/html");
        }, goog.dom.safe.parseFromString = function (e, t, r) {
          return e.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(t), r);
        }, goog.dom.safe.createImageFromBlob = function (e) {
          if (!/^image\/.*/g.test(e.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
          var t = goog.global.URL.createObjectURL(e);
          return (e = new goog.global.Image()).onload = function () {
            goog.global.URL.revokeObjectURL(t);
          }, goog.dom.safe.setImageSrc(e, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), t)), e;
        }, goog.string.DETECT_DOUBLE_ESCAPING = false, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = false, goog.string.Unicode = {
          NBSP: "\xA0"
        }, goog.string.startsWith = goog.string.internal.startsWith, goog.string.endsWith = goog.string.internal.endsWith, goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith, goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith, goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals, goog.string.subs = function (e, t) {
          for (var r = e.split("%s"), n = "", o = Array.prototype.slice.call(arguments, 1); o.length && 1 < r.length;) n += r.shift() + o.shift();
          return n + r.join("%s");
        }, goog.string.collapseWhitespace = function (e) {
          return e.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
        }, goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace, goog.string.isEmptyString = function (e) {
          return 0 == e.length;
        }, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function (e) {
          return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(e));
        }, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function (e) {
          return !/[^\t\n\r ]/.test(e);
        }, goog.string.isAlpha = function (e) {
          return !/[^a-zA-Z]/.test(e);
        }, goog.string.isNumeric = function (e) {
          return !/[^0-9]/.test(e);
        }, goog.string.isAlphaNumeric = function (e) {
          return !/[^a-zA-Z0-9]/.test(e);
        }, goog.string.isSpace = function (e) {
          return " " == e;
        }, goog.string.isUnicodeChar = function (e) {
          return 1 == e.length && " " <= e && "~" >= e || "\x80" <= e && "\uFFFD" >= e;
        }, goog.string.stripNewlines = function (e) {
          return e.replace(/(\r\n|\r|\n)+/g, " ");
        }, goog.string.canonicalizeNewlines = function (e) {
          return e.replace(/(\r\n|\r|\n)/g, "\n");
        }, goog.string.normalizeWhitespace = function (e) {
          return e.replace(/\xa0|\s/g, " ");
        }, goog.string.normalizeSpaces = function (e) {
          return e.replace(/\xa0|[ \t]+/g, " ");
        }, goog.string.collapseBreakingSpaces = function (e) {
          return e.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
        }, goog.string.trim = goog.string.internal.trim, goog.string.trimLeft = function (e) {
          return e.replace(/^[\s\xa0]+/, "");
        }, goog.string.trimRight = function (e) {
          return e.replace(/[\s\xa0]+$/, "");
        }, goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare, goog.string.numberAwareCompare_ = function (e, t, r) {
          if (e == t) return 0;
          if (!e) return -1;
          if (!t) return 1;
          for (var n = e.toLowerCase().match(r), o = t.toLowerCase().match(r), i = Math.min(n.length, o.length), s = 0; s < i; s++) {
            r = n[s];
            var a2 = o[s];
            if (r != a2) return e = parseInt(r, 10), !isNaN(e) && (t = parseInt(a2, 10), !isNaN(t) && e - t) ? e - t : r < a2 ? -1 : 1;
          }
          return n.length != o.length ? n.length - o.length : e < t ? -1 : 1;
        }, goog.string.intAwareCompare = function (e, t) {
          return goog.string.numberAwareCompare_(e, t, /\d+|\D+/g);
        }, goog.string.floatAwareCompare = function (e, t) {
          return goog.string.numberAwareCompare_(e, t, /\d+|\.\d+|\D+/g);
        }, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function (e) {
          return encodeURIComponent(String(e));
        }, goog.string.urlDecode = function (e) {
          return decodeURIComponent(e.replace(/\+/g, " "));
        }, goog.string.newLineToBr = goog.string.internal.newLineToBr, goog.string.htmlEscape = function (e, t) {
          return e = goog.string.internal.htmlEscape(e, t), goog.string.DETECT_DOUBLE_ESCAPING && (e = e.replace(goog.string.E_RE_, "&#101;")), e;
        }, goog.string.E_RE_ = /e/g, goog.string.unescapeEntities = function (e) {
          return goog.string.contains(e, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(e) : goog.string.unescapePureXmlEntities_(e) : e;
        }, goog.string.unescapeEntitiesWithDocument = function (e, t) {
          return goog.string.contains(e, "&") ? goog.string.unescapeEntitiesUsingDom_(e, t) : e;
        }, goog.string.unescapeEntitiesUsingDom_ = function (e, t) {
          var r = {
              "&amp;": "&",
              "&lt;": "<",
              "&gt;": ">",
              "&quot;": '"'
            },
            n = t ? t.createElement("div") : goog.global.document.createElement("div");
          return e.replace(goog.string.HTML_ENTITY_PATTERN_, function (e2, t2) {
            var o = r[e2];
            return o || ("#" == t2.charAt(0) && (t2 = Number("0" + t2.substr(1)), isNaN(t2) || (o = String.fromCharCode(t2))), o || (goog.dom.safe.setInnerHtml(n, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), e2 + " ")), o = n.firstChild.nodeValue.slice(0, -1)), r[e2] = o);
          });
        }, goog.string.unescapePureXmlEntities_ = function (e) {
          return e.replace(/&([^;]+);/g, function (e2, t) {
            switch (t) {
              case "amp":
                return "&";
              case "lt":
                return "<";
              case "gt":
                return ">";
              case "quot":
                return '"';
              default:
                return "#" != t.charAt(0) || (t = Number("0" + t.substr(1)), isNaN(t)) ? e2 : String.fromCharCode(t);
            }
          });
        }, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function (e, t) {
          return goog.string.newLineToBr(e.replace(/  /g, " &#160;"), t);
        }, goog.string.preserveSpaces = function (e) {
          return e.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
        }, goog.string.stripQuotes = function (e, t) {
          for (var r = t.length, n = 0; n < r; n++) {
            var o = 1 == r ? t : t.charAt(n);
            if (e.charAt(0) == o && e.charAt(e.length - 1) == o) return e.substring(1, e.length - 1);
          }
          return e;
        }, goog.string.truncate = function (e, t, r) {
          return r && (e = goog.string.unescapeEntities(e)), e.length > t && (e = e.substring(0, t - 3) + "..."), r && (e = goog.string.htmlEscape(e)), e;
        }, goog.string.truncateMiddle = function (e, t, r, n) {
          if (r && (e = goog.string.unescapeEntities(e)), n && e.length > t) {
            n > t && (n = t);
            var o = e.length - n;
            e = e.substring(0, t - n) + "..." + e.substring(o);
          } else e.length > t && (n = Math.floor(t / 2), o = e.length - n, e = e.substring(0, n + t % 2) + "..." + e.substring(o));
          return r && (e = goog.string.htmlEscape(e)), e;
        }, goog.string.specialEscapeChars_ = {
          "\0": "\\0",
          "\b": "\\b",
          "\f": "\\f",
          "\n": "\\n",
          "\r": "\\r",
          "	": "\\t",
          "\v": "\\x0B",
          '"': '\\"',
          "\\": "\\\\",
          "<": "\\u003C"
        }, goog.string.jsEscapeCache_ = {
          "'": "\\'"
        }, goog.string.quote = function (e) {
          e = String(e);
          for (var t = ['"'], r = 0; r < e.length; r++) {
            var n = e.charAt(r),
              o = n.charCodeAt(0);
            t[r + 1] = goog.string.specialEscapeChars_[n] || (31 < o && 127 > o ? n : goog.string.escapeChar(n));
          }
          return t.push('"'), t.join("");
        }, goog.string.escapeString = function (e) {
          for (var t = [], r = 0; r < e.length; r++) t[r] = goog.string.escapeChar(e.charAt(r));
          return t.join("");
        }, goog.string.escapeChar = function (e) {
          if (e in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[e];
          if (e in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[e] = goog.string.specialEscapeChars_[e];
          var t = e.charCodeAt(0);
          if (31 < t && 127 > t) var r = e;else 256 > t ? (r = "\\x", (16 > t || 256 < t) && (r += "0")) : (r = "\\u", 4096 > t && (r += "0")), r += t.toString(16).toUpperCase();
          return goog.string.jsEscapeCache_[e] = r;
        }, goog.string.contains = goog.string.internal.contains, goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains, goog.string.countOf = function (e, t) {
          return e && t ? e.split(t).length - 1 : 0;
        }, goog.string.removeAt = function (e, t, r) {
          var n = e;
          return 0 <= t && t < e.length && 0 < r && (n = e.substr(0, t) + e.substr(t + r, e.length - t - r)), n;
        }, goog.string.remove = function (e, t) {
          return e.replace(t, "");
        }, goog.string.removeAll = function (e, t) {
          return t = new RegExp(goog.string.regExpEscape(t), "g"), e.replace(t, "");
        }, goog.string.replaceAll = function (e, t, r) {
          return t = new RegExp(goog.string.regExpEscape(t), "g"), e.replace(t, r.replace(/\$/g, "$$$$"));
        }, goog.string.regExpEscape = function (e) {
          return String(e).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
        }, goog.string.repeat = String.prototype.repeat ? function (e, t) {
          return e.repeat(t);
        } : function (e, t) {
          return Array(t + 1).join(e);
        }, goog.string.padNumber = function (e, t, r) {
          return -1 == (r = (e = goog.isDef(r) ? e.toFixed(r) : String(e)).indexOf(".")) && (r = e.length), goog.string.repeat("0", Math.max(0, t - r)) + e;
        }, goog.string.makeSafe = function (e) {
          return null == e ? "" : String(e);
        }, goog.string.buildString = function (e) {
          return Array.prototype.join.call(arguments, "");
        }, goog.string.getRandomString = function () {
          return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
        }, goog.string.compareVersions = goog.string.internal.compareVersions, goog.string.hashCode = function (e) {
          for (var t = 0, r = 0; r < e.length; ++r) t = 31 * t + e.charCodeAt(r) >>> 0;
          return t;
        }, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function () {
          return "goog_" + goog.string.uniqueStringCounter_++;
        }, goog.string.toNumber = function (e) {
          var t = Number(e);
          return 0 == t && goog.string.isEmptyOrWhitespace(e) ? NaN : t;
        }, goog.string.isLowerCamelCase = function (e) {
          return /^[a-z]+([A-Z][a-z]*)*$/.test(e);
        }, goog.string.isUpperCamelCase = function (e) {
          return /^([A-Z][a-z]*)+$/.test(e);
        }, goog.string.toCamelCase = function (e) {
          return String(e).replace(/\-([a-z])/g, function (e2, t) {
            return t.toUpperCase();
          });
        }, goog.string.toSelectorCase = function (e) {
          return String(e).replace(/([A-Z])/g, "-$1").toLowerCase();
        }, goog.string.toTitleCase = function (e, t) {
          return t = goog.isString(t) ? goog.string.regExpEscape(t) : "\\s", e.replace(new RegExp("(^" + (t ? "|[" + t + "]+" : "") + ")([a-z])", "g"), function (e2, t2, r) {
            return t2 + r.toUpperCase();
          });
        }, goog.string.capitalize = function (e) {
          return String(e.charAt(0)).toUpperCase() + String(e.substr(1)).toLowerCase();
        }, goog.string.parseInt = function (e) {
          return isFinite(e) && (e = String(e)), goog.isString(e) ? /^\s*-?0x/i.test(e) ? parseInt(e, 16) : parseInt(e, 10) : NaN;
        }, goog.string.splitLimit = function (e, t, r) {
          e = e.split(t);
          for (var n = []; 0 < r && e.length;) n.push(e.shift()), r--;
          return e.length && n.push(e.join(t)), n;
        }, goog.string.lastComponent = function (e, t) {
          if (!t) return e;
          "string" == typeof t && (t = [t]);
          for (var r = -1, n = 0; n < t.length; n++) if ("" != t[n]) {
            var o = e.lastIndexOf(t[n]);
            o > r && (r = o);
          }
          return -1 == r ? e : e.slice(r + 1);
        }, goog.string.editDistance = function (e, t) {
          var r = [],
            n = [];
          if (e == t) return 0;
          if (!e.length || !t.length) return Math.max(e.length, t.length);
          for (var o = 0; o < t.length + 1; o++) r[o] = o;
          for (o = 0; o < e.length; o++) {
            n[0] = o + 1;
            for (var i = 0; i < t.length; i++) n[i + 1] = Math.min(n[i] + 1, r[i + 1] + 1, r[i] + Number(e[o] != t[i]));
            for (i = 0; i < r.length; i++) r[i] = n[i];
          }
          return n[t.length];
        }, goog.labs.userAgent.platform = {}, goog.labs.userAgent.platform.isAndroid = function () {
          return goog.labs.userAgent.util.matchUserAgent("Android");
        }, goog.labs.userAgent.platform.isIpod = function () {
          return goog.labs.userAgent.util.matchUserAgent("iPod");
        }, goog.labs.userAgent.platform.isIphone = function () {
          return goog.labs.userAgent.util.matchUserAgent("iPhone") && !goog.labs.userAgent.util.matchUserAgent("iPod") && !goog.labs.userAgent.util.matchUserAgent("iPad");
        }, goog.labs.userAgent.platform.isIpad = function () {
          return goog.labs.userAgent.util.matchUserAgent("iPad");
        }, goog.labs.userAgent.platform.isIos = function () {
          return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpad() || goog.labs.userAgent.platform.isIpod();
        }, goog.labs.userAgent.platform.isMacintosh = function () {
          return goog.labs.userAgent.util.matchUserAgent("Macintosh");
        }, goog.labs.userAgent.platform.isLinux = function () {
          return goog.labs.userAgent.util.matchUserAgent("Linux");
        }, goog.labs.userAgent.platform.isWindows = function () {
          return goog.labs.userAgent.util.matchUserAgent("Windows");
        }, goog.labs.userAgent.platform.isChromeOS = function () {
          return goog.labs.userAgent.util.matchUserAgent("CrOS");
        }, goog.labs.userAgent.platform.isChromecast = function () {
          return goog.labs.userAgent.util.matchUserAgent("CrKey");
        }, goog.labs.userAgent.platform.isKaiOS = function () {
          return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS");
        }, goog.labs.userAgent.platform.isGo2Phone = function () {
          return goog.labs.userAgent.util.matchUserAgentIgnoreCase("GAFP");
        }, goog.labs.userAgent.platform.getVersion = function () {
          var e = goog.labs.userAgent.util.getUserAgent(),
            t = "";
          return goog.labs.userAgent.platform.isWindows() ? t = (e = (t = /Windows (?:NT|Phone) ([0-9.]+)/).exec(e)) ? e[1] : "0.0" : goog.labs.userAgent.platform.isIos() ? t = (e = (t = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/).exec(e)) && e[1].replace(/_/g, ".") : goog.labs.userAgent.platform.isMacintosh() ? t = (e = (t = /Mac OS X ([0-9_.]+)/).exec(e)) ? e[1].replace(/_/g, ".") : "10" : goog.labs.userAgent.platform.isKaiOS() ? t = (e = (t = /(?:KaiOS)\/(\S+)/i).exec(e)) && e[1] : goog.labs.userAgent.platform.isAndroid() ? t = (e = (t = /Android\s+([^\);]+)(\)|;)/).exec(e)) && e[1] : goog.labs.userAgent.platform.isChromeOS() && (t = (e = (t = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/).exec(e)) && e[1]), t || "";
        }, goog.labs.userAgent.platform.isVersionOrHigher = function (e) {
          return 0 <= goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(), e);
        }, goog.reflect = {}, goog.reflect.object = function (e, t) {
          return t;
        }, goog.reflect.objectProperty = function (e, t) {
          return e;
        }, goog.reflect.sinkValue = function (e) {
          return goog.reflect.sinkValue[" "](e), e;
        }, goog.reflect.sinkValue[" "] = goog.nullFunction, goog.reflect.canAccessProperty = function (e, t) {
          try {
            return goog.reflect.sinkValue(e[t]), true;
          } catch (e2) {}
          return false;
        }, goog.reflect.cache = function (e, t, r, n) {
          return n = n ? n(t) : t, Object.prototype.hasOwnProperty.call(e, n) ? e[n] : e[n] = r(t);
        }, goog.labs.userAgent.engine = {}, goog.labs.userAgent.engine.isPresto = function () {
          return goog.labs.userAgent.util.matchUserAgent("Presto");
        }, goog.labs.userAgent.engine.isTrident = function () {
          return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
        }, goog.labs.userAgent.engine.isEdge = function () {
          return goog.labs.userAgent.util.matchUserAgent("Edge");
        }, goog.labs.userAgent.engine.isWebKit = function () {
          return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit") && !goog.labs.userAgent.engine.isEdge();
        }, goog.labs.userAgent.engine.isGecko = function () {
          return goog.labs.userAgent.util.matchUserAgent("Gecko") && !goog.labs.userAgent.engine.isWebKit() && !goog.labs.userAgent.engine.isTrident() && !goog.labs.userAgent.engine.isEdge();
        }, goog.labs.userAgent.engine.getVersion = function () {
          var e = goog.labs.userAgent.util.getUserAgent();
          if (e) {
            e = goog.labs.userAgent.util.extractVersionTuples(e);
            var t,
              r = goog.labs.userAgent.engine.getEngineTuple_(e);
            if (r) return "Gecko" == r[0] ? goog.labs.userAgent.engine.getVersionForKey_(e, "Firefox") : r[1];
            if ((e = e[0]) && (t = e[2]) && (t = /Trident\/([^\s;]+)/.exec(t))) return t[1];
          }
          return "";
        }, goog.labs.userAgent.engine.getEngineTuple_ = function (e) {
          if (!goog.labs.userAgent.engine.isEdge()) return e[1];
          for (var t = 0; t < e.length; t++) {
            var r = e[t];
            if ("Edge" == r[0]) return r;
          }
        }, goog.labs.userAgent.engine.isVersionOrHigher = function (e) {
          return 0 <= goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(), e);
        }, goog.labs.userAgent.engine.getVersionForKey_ = function (e, t) {
          return (e = goog.array.find(e, function (e2) {
            return t == e2[0];
          })) && e[1] || "";
        }, goog.userAgent = {}, goog.userAgent.ASSUME_IE = false, goog.userAgent.ASSUME_EDGE = false, goog.userAgent.ASSUME_GECKO = false, goog.userAgent.ASSUME_WEBKIT = false, goog.userAgent.ASSUME_MOBILE_WEBKIT = false, goog.userAgent.ASSUME_OPERA = false, goog.userAgent.ASSUME_ANY_VERSION = false, goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA, goog.userAgent.getUserAgentString = function () {
          return goog.labs.userAgent.util.getUserAgent();
        }, goog.userAgent.getNavigatorTyped = function () {
          return goog.global.navigator || null;
        }, goog.userAgent.getNavigator = function () {
          return goog.userAgent.getNavigatorTyped();
        }, goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : goog.labs.userAgent.browser.isOpera(), goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : goog.labs.userAgent.browser.isIE(), goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : goog.labs.userAgent.engine.isEdge(), goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE, goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : goog.labs.userAgent.engine.isGecko();
        goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : goog.labs.userAgent.engine.isWebKit(), goog.userAgent.isMobile_ = function () {
          return goog.userAgent.WEBKIT && goog.labs.userAgent.util.matchUserAgent("Mobile");
        }, goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_(), goog.userAgent.SAFARI = goog.userAgent.WEBKIT, goog.userAgent.determinePlatform_ = function () {
          var e = goog.userAgent.getNavigatorTyped();
          return e && e.platform || "";
        }, goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_(), goog.userAgent.ASSUME_MAC = false, goog.userAgent.ASSUME_WINDOWS = false, goog.userAgent.ASSUME_LINUX = false, goog.userAgent.ASSUME_X11 = false, goog.userAgent.ASSUME_ANDROID = false, goog.userAgent.ASSUME_IPHONE = false, goog.userAgent.ASSUME_IPAD = false, goog.userAgent.ASSUME_IPOD = false, goog.userAgent.ASSUME_KAIOS = false, goog.userAgent.ASSUME_GO2PHONE = false, goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD, goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : goog.labs.userAgent.platform.isMacintosh(), goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : goog.labs.userAgent.platform.isWindows(), goog.userAgent.isLegacyLinux_ = function () {
          return goog.labs.userAgent.platform.isLinux() || goog.labs.userAgent.platform.isChromeOS();
        }, goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_(), goog.userAgent.isX11_ = function () {
          var e = goog.userAgent.getNavigatorTyped();
          return !!e && goog.string.contains(e.appVersion || "", "X11");
        }, goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_(), goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : goog.labs.userAgent.platform.isAndroid(), goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : goog.labs.userAgent.platform.isIphone(), goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIpod(), goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIos(), goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : goog.labs.userAgent.platform.isKaiOS(), goog.userAgent.GO2PHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_GO2PHONE : goog.labs.userAgent.platform.isGo2Phone(), goog.userAgent.determineVersion_ = function () {
          var e = "",
            t = goog.userAgent.getVersionRegexResult_();
          return t && (e = t ? t[1] : ""), goog.userAgent.IE && null != (t = goog.userAgent.getDocumentMode_()) && t > parseFloat(e) ? String(t) : e;
        }, goog.userAgent.getVersionRegexResult_ = function () {
          var e = goog.userAgent.getUserAgentString();
          return goog.userAgent.GECKO ? /rv:([^\);]+)(\)|;)/.exec(e) : goog.userAgent.EDGE ? /Edge\/([\d\.]+)/.exec(e) : goog.userAgent.IE ? /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(e) : goog.userAgent.WEBKIT ? /WebKit\/(\S+)/.exec(e) : goog.userAgent.OPERA ? /(?:Version)[ \/]?(\S+)/.exec(e) : void 0;
        }, goog.userAgent.getDocumentMode_ = function () {
          var e = goog.global.document;
          return e ? e.documentMode : void 0;
        }, goog.userAgent.VERSION = goog.userAgent.determineVersion_(), goog.userAgent.compare = function (e, t) {
          return goog.string.compareVersions(e, t);
        }, goog.userAgent.isVersionOrHigherCache_ = {}, goog.userAgent.isVersionOrHigher = function (e) {
          return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, e, function () {
            return 0 <= goog.string.compareVersions(goog.userAgent.VERSION, e);
          });
        }, goog.userAgent.isVersion = goog.userAgent.isVersionOrHigher, goog.userAgent.isDocumentModeOrHigher = function (e) {
          return Number(goog.userAgent.DOCUMENT_MODE) >= e;
        }, goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher, goog.userAgent.DOCUMENT_MODE = function () {
          if (goog.global.document && goog.userAgent.IE) return goog.userAgent.getDocumentMode_();
        }(), goog.userAgent.product = {}, goog.userAgent.product.ASSUME_FIREFOX = false, goog.userAgent.product.ASSUME_IPHONE = false, goog.userAgent.product.ASSUME_IPAD = false, goog.userAgent.product.ASSUME_ANDROID = false, goog.userAgent.product.ASSUME_CHROME = false, goog.userAgent.product.ASSUME_SAFARI = false, goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI, goog.userAgent.product.OPERA = goog.userAgent.OPERA, goog.userAgent.product.IE = goog.userAgent.IE, goog.userAgent.product.EDGE = goog.userAgent.EDGE, goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : goog.labs.userAgent.browser.isFirefox(), goog.userAgent.product.isIphoneOrIpod_ = function () {
          return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpod();
        }, goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_(), goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : goog.labs.userAgent.browser.isAndroidBrowser(), goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : goog.labs.userAgent.browser.isChrome(), goog.userAgent.product.isSafariDesktop_ = function () {
          return goog.labs.userAgent.browser.isSafari() && !goog.labs.userAgent.platform.isIos();
        }, goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_(), goog.crypt.base64 = {}, goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=", goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.", goog.crypt.base64.Alphabet = {
          DEFAULT: 0,
          NO_PADDING: 1,
          WEBSAFE: 2,
          WEBSAFE_DOT_PADDING: 3,
          WEBSAFE_NO_PADDING: 4
        }, goog.crypt.base64.paddingChars_ = "=.", goog.crypt.base64.isPadding_ = function (e) {
          return goog.string.contains(goog.crypt.base64.paddingChars_, e);
        }, goog.crypt.base64.byteToCharMaps_ = {}, goog.crypt.base64.charToByteMap_ = null, goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT && !goog.userAgent.product.SAFARI || goog.userAgent.OPERA, goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || "function" == typeof goog.global.btoa, goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && "function" == typeof goog.global.atob, goog.crypt.base64.encodeByteArray = function (e, t) {
          goog.asserts.assert(goog.isArrayLike(e), "encodeByteArray takes an array as a parameter"), void 0 === t && (t = goog.crypt.base64.Alphabet.DEFAULT), goog.crypt.base64.init_(), t = goog.crypt.base64.byteToCharMaps_[t];
          for (var r = [], n = 0; n < e.length; n += 3) {
            var o = e[n],
              i = n + 1 < e.length,
              s = i ? e[n + 1] : 0,
              a2 = n + 2 < e.length,
              l = a2 ? e[n + 2] : 0,
              u = o >> 2;
            o = (3 & o) << 4 | s >> 4, s = (15 & s) << 2 | l >> 6, l &= 63, a2 || (l = 64, i || (s = 64)), r.push(t[u], t[o], t[s] || "", t[l] || "");
          }
          return r.join("");
        }, goog.crypt.base64.encodeString = function (e, t) {
          return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !t ? goog.global.btoa(e) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(e), t);
        }, goog.crypt.base64.decodeString = function (e, t) {
          if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !t) return goog.global.atob(e);
          var r = "";
          return goog.crypt.base64.decodeStringInternal_(e, function (e2) {
            r += String.fromCharCode(e2);
          }), r;
        }, goog.crypt.base64.decodeStringToByteArray = function (e, t) {
          var r = [];
          return goog.crypt.base64.decodeStringInternal_(e, function (e2) {
            r.push(e2);
          }), r;
        }, goog.crypt.base64.decodeStringToUint8Array = function (e) {
          goog.asserts.assert(!goog.userAgent.IE || goog.userAgent.isVersionOrHigher("10"), "Browser does not support typed arrays");
          var t = e.length,
            r = 3 * t / 4;
          r % 3 ? r = Math.floor(r) : goog.crypt.base64.isPadding_(e[t - 1]) && (r = goog.crypt.base64.isPadding_(e[t - 2]) ? r - 2 : r - 1);
          var n = new Uint8Array(r),
            o = 0;
          return goog.crypt.base64.decodeStringInternal_(e, function (e2) {
            n[o++] = e2;
          }), n.subarray(0, o);
        }, goog.crypt.base64.decodeStringInternal_ = function (e, t) {
          function r(t2) {
            for (; n < e.length;) {
              var r2 = e.charAt(n++),
                o2 = goog.crypt.base64.charToByteMap_[r2];
              if (null != o2) return o2;
              if (!goog.string.isEmptyOrWhitespace(r2)) throw Error("Unknown base64 encoding at char: " + r2);
            }
            return t2;
          }
          goog.crypt.base64.init_();
          for (var n = 0;;) {
            var o = r(-1),
              i = r(0),
              s = r(64),
              a2 = r(64);
            if (64 === a2 && -1 === o) break;
            t(o << 2 | i >> 4), 64 != s && (t(i << 4 & 240 | s >> 2), 64 != a2 && t(s << 6 & 192 | a2));
          }
        }, goog.crypt.base64.init_ = function () {
          if (!goog.crypt.base64.charToByteMap_) {
            goog.crypt.base64.charToByteMap_ = {};
            for (var e = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), t = ["+/=", "+/", "-_=", "-_.", "-_"], r = 0; 5 > r; r++) {
              var n = e.concat(t[r].split(""));
              goog.crypt.base64.byteToCharMaps_[r] = n;
              for (var o = 0; o < n.length; o++) {
                var i = n[o],
                  s = goog.crypt.base64.charToByteMap_[i];
                void 0 === s ? goog.crypt.base64.charToByteMap_[i] = o : goog.asserts.assert(s === o);
              }
            }
          }
        }, jspb.utils = {}, jspb.utils.split64Low = 0, jspb.utils.split64High = 0, jspb.utils.splitUint64 = function (e) {
          var t = e >>> 0;
          e = Math.floor((e - t) / jspb.BinaryConstants.TWO_TO_32) >>> 0, jspb.utils.split64Low = t, jspb.utils.split64High = e;
        }, jspb.utils.splitInt64 = function (e) {
          var t = 0 > e,
            r = (e = Math.abs(e)) >>> 0;
          e = Math.floor((e - r) / jspb.BinaryConstants.TWO_TO_32), e >>>= 0, t && (e = ~e >>> 0, 4294967295 < (r = 1 + (~r >>> 0)) && (r = 0, 4294967295 < ++e && (e = 0))), jspb.utils.split64Low = r, jspb.utils.split64High = e;
        }, jspb.utils.splitZigzag64 = function (e) {
          var t = 0 > e;
          e = 2 * Math.abs(e), jspb.utils.splitUint64(e), e = jspb.utils.split64Low;
          var r = jspb.utils.split64High;
          t && (0 == e ? 0 == r ? r = e = 4294967295 : (r--, e = 4294967295) : e--), jspb.utils.split64Low = e, jspb.utils.split64High = r;
        }, jspb.utils.splitFloat32 = function (e) {
          var t = 0 > e ? 1 : 0;
          if (0 === (e = t ? -e : e)) 0 < 1 / e ? (jspb.utils.split64High = 0, jspb.utils.split64Low = 0) : (jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483648);else if (isNaN(e)) jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483647;else if (e > jspb.BinaryConstants.FLOAT32_MAX) jspb.utils.split64High = 0, jspb.utils.split64Low = (t << 31 | 2139095040) >>> 0;else if (e < jspb.BinaryConstants.FLOAT32_MIN) e = Math.round(e / Math.pow(2, -149)), jspb.utils.split64High = 0, jspb.utils.split64Low = (t << 31 | e) >>> 0;else {
            var r = Math.floor(Math.log(e) / Math.LN2);
            e *= Math.pow(2, -r), e = 8388607 & Math.round(e * jspb.BinaryConstants.TWO_TO_23), jspb.utils.split64High = 0, jspb.utils.split64Low = (t << 31 | r + 127 << 23 | e) >>> 0;
          }
        }, jspb.utils.splitFloat64 = function (e) {
          var t = 0 > e ? 1 : 0;
          if (0 === (e = t ? -e : e)) jspb.utils.split64High = 0 < 1 / e ? 0 : 2147483648, jspb.utils.split64Low = 0;else if (isNaN(e)) jspb.utils.split64High = 2147483647, jspb.utils.split64Low = 4294967295;else if (e > jspb.BinaryConstants.FLOAT64_MAX) jspb.utils.split64High = (t << 31 | 2146435072) >>> 0, jspb.utils.split64Low = 0;else if (e < jspb.BinaryConstants.FLOAT64_MIN) {
            var r = e / Math.pow(2, -1074);
            e = r / jspb.BinaryConstants.TWO_TO_32, jspb.utils.split64High = (t << 31 | e) >>> 0, jspb.utils.split64Low = r >>> 0;
          } else {
            var n = 0;
            if (2 <= (r = e)) for (; 2 <= r && 1023 > n;) n++, r /= 2;else for (; 1 > r && -1022 < n;) r *= 2, n--;
            e = (r = e * Math.pow(2, -n)) * jspb.BinaryConstants.TWO_TO_20 & 1048575, r = r * jspb.BinaryConstants.TWO_TO_52 >>> 0, jspb.utils.split64High = (t << 31 | n + 1023 << 20 | e) >>> 0, jspb.utils.split64Low = r;
          }
        }, jspb.utils.splitHash64 = function (e) {
          var t = e.charCodeAt(0),
            r = e.charCodeAt(1),
            n = e.charCodeAt(2),
            o = e.charCodeAt(3),
            i = e.charCodeAt(4),
            s = e.charCodeAt(5),
            a2 = e.charCodeAt(6);
          e = e.charCodeAt(7), jspb.utils.split64Low = t + (r << 8) + (n << 16) + (o << 24) >>> 0, jspb.utils.split64High = i + (s << 8) + (a2 << 16) + (e << 24) >>> 0;
        }, jspb.utils.joinUint64 = function (e, t) {
          return t * jspb.BinaryConstants.TWO_TO_32 + (e >>> 0);
        }, jspb.utils.joinInt64 = function (e, t) {
          var r = 2147483648 & t;
          return r && (t = ~t >>> 0, 0 == (e = 1 + ~e >>> 0) && (t = t + 1 >>> 0)), e = jspb.utils.joinUint64(e, t), r ? -e : e;
        }, jspb.utils.toZigzag64 = function (e, t, r) {
          var n = t >> 31;
          return r(e << 1 ^ n, (t << 1 | e >>> 31) ^ n);
        }, jspb.utils.joinZigzag64 = function (e, t) {
          return jspb.utils.fromZigzag64(e, t, jspb.utils.joinInt64);
        }, jspb.utils.fromZigzag64 = function (e, t, r) {
          var n = -(1 & e);
          return r((e >>> 1 | t << 31) ^ n, t >>> 1 ^ n);
        }, jspb.utils.joinFloat32 = function (e, t) {
          t = 2 * (e >> 31) + 1;
          var r = e >>> 23 & 255;
          return e &= 8388607, 255 == r ? e ? NaN : 1 / 0 * t : 0 == r ? t * Math.pow(2, -149) * e : t * Math.pow(2, r - 150) * (e + Math.pow(2, 23));
        }, jspb.utils.joinFloat64 = function (e, t) {
          var r = 2 * (t >> 31) + 1,
            n = t >>> 20 & 2047;
          return e = jspb.BinaryConstants.TWO_TO_32 * (1048575 & t) + e, 2047 == n ? e ? NaN : 1 / 0 * r : 0 == n ? r * Math.pow(2, -1074) * e : r * Math.pow(2, n - 1075) * (e + jspb.BinaryConstants.TWO_TO_52);
        }, jspb.utils.joinHash64 = function (e, t) {
          return String.fromCharCode(e >>> 0 & 255, e >>> 8 & 255, e >>> 16 & 255, e >>> 24 & 255, t >>> 0 & 255, t >>> 8 & 255, t >>> 16 & 255, t >>> 24 & 255);
        }, jspb.utils.DIGITS = "0123456789abcdef".split(""), jspb.utils.ZERO_CHAR_CODE_ = 48, jspb.utils.A_CHAR_CODE_ = 97, jspb.utils.joinUnsignedDecimalString = function (e, t) {
          function r(e2, t2) {
            return e2 = e2 ? String(e2) : "", t2 ? "0000000".slice(e2.length) + e2 : e2;
          }
          if (2097151 >= t) return "" + (jspb.BinaryConstants.TWO_TO_32 * t + e);
          var n = (e >>> 24 | t << 8) >>> 0 & 16777215;
          return e = (16777215 & e) + 6777216 * n + 6710656 * (t = t >> 16 & 65535), n += 8147497 * t, t *= 2, 1e7 <= e && (n += Math.floor(e / 1e7), e %= 1e7), 1e7 <= n && (t += Math.floor(n / 1e7), n %= 1e7), r(t, 0) + r(n, t) + r(e, 1);
        }, jspb.utils.joinSignedDecimalString = function (e, t) {
          var r = 2147483648 & t;
          return r && (t = ~t + (0 == (e = 1 + ~e >>> 0) ? 1 : 0) >>> 0), e = jspb.utils.joinUnsignedDecimalString(e, t), r ? "-" + e : e;
        }, jspb.utils.hash64ToDecimalString = function (e, t) {
          jspb.utils.splitHash64(e), e = jspb.utils.split64Low;
          var r = jspb.utils.split64High;
          return t ? jspb.utils.joinSignedDecimalString(e, r) : jspb.utils.joinUnsignedDecimalString(e, r);
        }, jspb.utils.hash64ArrayToDecimalStrings = function (e, t) {
          for (var r = Array(e.length), n = 0; n < e.length; n++) r[n] = jspb.utils.hash64ToDecimalString(e[n], t);
          return r;
        }, jspb.utils.decimalStringToHash64 = function (e) {
          function t(e2, t2) {
            for (var r2 = 0; 8 > r2 && (1 !== e2 || 0 < t2); r2++) t2 = e2 * n[r2] + t2, n[r2] = 255 & t2, t2 >>>= 8;
          }
          goog.asserts.assert(0 < e.length);
          var r = false;
          "-" === e[0] && (r = true, e = e.slice(1));
          for (var n = [0, 0, 0, 0, 0, 0, 0, 0], o = 0; o < e.length; o++) t(10, e.charCodeAt(o) - jspb.utils.ZERO_CHAR_CODE_);
          return r && (function () {
            for (var e2 = 0; 8 > e2; e2++) n[e2] = 255 & ~n[e2];
          }(), t(1, 1)), goog.crypt.byteArrayToString(n);
        }, jspb.utils.splitDecimalString = function (e) {
          jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(e));
        }, jspb.utils.toHexDigit_ = function (e) {
          return String.fromCharCode(10 > e ? jspb.utils.ZERO_CHAR_CODE_ + e : jspb.utils.A_CHAR_CODE_ - 10 + e);
        }, jspb.utils.fromHexCharCode_ = function (e) {
          return e >= jspb.utils.A_CHAR_CODE_ ? e - jspb.utils.A_CHAR_CODE_ + 10 : e - jspb.utils.ZERO_CHAR_CODE_;
        }, jspb.utils.hash64ToHexString = function (e) {
          var t = Array(18);
          t[0] = "0", t[1] = "x";
          for (var r = 0; 8 > r; r++) {
            var n = e.charCodeAt(7 - r);
            t[2 * r + 2] = jspb.utils.toHexDigit_(n >> 4), t[2 * r + 3] = jspb.utils.toHexDigit_(15 & n);
          }
          return t.join("");
        }, jspb.utils.hexStringToHash64 = function (e) {
          e = e.toLowerCase(), goog.asserts.assert(18 == e.length), goog.asserts.assert("0" == e[0]), goog.asserts.assert("x" == e[1]);
          for (var t = "", r = 0; 8 > r; r++) {
            var n = jspb.utils.fromHexCharCode_(e.charCodeAt(2 * r + 2)),
              o = jspb.utils.fromHexCharCode_(e.charCodeAt(2 * r + 3));
            t = String.fromCharCode(16 * n + o) + t;
          }
          return t;
        }, jspb.utils.hash64ToNumber = function (e, t) {
          jspb.utils.splitHash64(e), e = jspb.utils.split64Low;
          var r = jspb.utils.split64High;
          return t ? jspb.utils.joinInt64(e, r) : jspb.utils.joinUint64(e, r);
        }, jspb.utils.numberToHash64 = function (e) {
          return jspb.utils.splitInt64(e), jspb.utils.joinHash64(jspb.utils.split64Low, jspb.utils.split64High);
        }, jspb.utils.countVarints = function (e, t, r) {
          for (var n = 0, o = t; o < r; o++) n += e[o] >> 7;
          return r - t - n;
        }, jspb.utils.countVarintFields = function (e, t, r, n) {
          var o = 0;
          if (128 > (n = 8 * n + jspb.BinaryConstants.WireType.VARINT)) for (; t < r && e[t++] == n;) for (o++;;) {
            var i = e[t++];
            if (0 == (128 & i)) break;
          } else for (; t < r;) {
            for (i = n; 128 < i;) {
              if (e[t] != (127 & i | 128)) return o;
              t++, i >>= 7;
            }
            if (e[t++] != i) break;
            for (o++; 0 != (128 & (i = e[t++])););
          }
          return o;
        }, jspb.utils.countFixedFields_ = function (e, t, r, n, o) {
          var i = 0;
          if (128 > n) for (; t < r && e[t++] == n;) i++, t += o;else for (; t < r;) {
            for (var s = n; 128 < s;) {
              if (e[t++] != (127 & s | 128)) return i;
              s >>= 7;
            }
            if (e[t++] != s) break;
            i++, t += o;
          }
          return i;
        }, jspb.utils.countFixed32Fields = function (e, t, r, n) {
          return jspb.utils.countFixedFields_(e, t, r, 8 * n + jspb.BinaryConstants.WireType.FIXED32, 4);
        }, jspb.utils.countFixed64Fields = function (e, t, r, n) {
          return jspb.utils.countFixedFields_(e, t, r, 8 * n + jspb.BinaryConstants.WireType.FIXED64, 8);
        }, jspb.utils.countDelimitedFields = function (e, t, r, n) {
          var o = 0;
          for (n = 8 * n + jspb.BinaryConstants.WireType.DELIMITED; t < r;) {
            for (var i = n; 128 < i;) {
              if (e[t++] != (127 & i | 128)) return o;
              i >>= 7;
            }
            if (e[t++] != i) break;
            o++;
            for (var s = 0, a2 = 1; s += (127 & (i = e[t++])) * a2, a2 *= 128, 0 != (128 & i););
            t += s;
          }
          return o;
        }, jspb.utils.debugBytesToTextFormat = function (e) {
          var t = '"';
          if (e) {
            e = jspb.utils.byteSourceToUint8Array(e);
            for (var r = 0; r < e.length; r++) t += "\\x", 16 > e[r] && (t += "0"), t += e[r].toString(16);
          }
          return t + '"';
        }, jspb.utils.debugScalarToTextFormat = function (e) {
          return "string" == typeof e ? goog.string.quote(e) : e.toString();
        }, jspb.utils.stringToByteArray = function (e) {
          for (var t = new Uint8Array(e.length), r = 0; r < e.length; r++) {
            var n = e.charCodeAt(r);
            if (255 < n) throw Error("Conversion error: string contains codepoint outside of byte range");
            t[r] = n;
          }
          return t;
        }, jspb.utils.byteSourceToUint8Array = function (e) {
          return e.constructor === Uint8Array ? e : e.constructor === ArrayBuffer || void 0 !== Buffer && e.constructor === Buffer || e.constructor === Array ? new Uint8Array(e) : e.constructor === String ? goog.crypt.base64.decodeStringToUint8Array(e) : (goog.asserts.fail("Type not convertible to Uint8Array."), new Uint8Array(0));
        }, jspb.BinaryDecoder = function (e, t, r) {
          this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = false, e && this.setBlock(e, t, r);
        }, jspb.BinaryDecoder.instanceCache_ = [], jspb.BinaryDecoder.alloc = function (e, t, r) {
          if (jspb.BinaryDecoder.instanceCache_.length) {
            var n = jspb.BinaryDecoder.instanceCache_.pop();
            return e && n.setBlock(e, t, r), n;
          }
          return new jspb.BinaryDecoder(e, t, r);
        }, jspb.BinaryDecoder.prototype.free = function () {
          this.clear(), 100 > jspb.BinaryDecoder.instanceCache_.length && jspb.BinaryDecoder.instanceCache_.push(this);
        }, jspb.BinaryDecoder.prototype.clone = function () {
          return jspb.BinaryDecoder.alloc(this.bytes_, this.start_, this.end_ - this.start_);
        }, jspb.BinaryDecoder.prototype.clear = function () {
          this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = false;
        }, jspb.BinaryDecoder.prototype.getBuffer = function () {
          return this.bytes_;
        }, jspb.BinaryDecoder.prototype.setBlock = function (e, t, r) {
          this.bytes_ = jspb.utils.byteSourceToUint8Array(e), this.start_ = void 0 !== t ? t : 0, this.end_ = void 0 !== r ? this.start_ + r : this.bytes_.length, this.cursor_ = this.start_;
        }, jspb.BinaryDecoder.prototype.getEnd = function () {
          return this.end_;
        }, jspb.BinaryDecoder.prototype.setEnd = function (e) {
          this.end_ = e;
        }, jspb.BinaryDecoder.prototype.reset = function () {
          this.cursor_ = this.start_;
        }, jspb.BinaryDecoder.prototype.getCursor = function () {
          return this.cursor_;
        }, jspb.BinaryDecoder.prototype.setCursor = function (e) {
          this.cursor_ = e;
        }, jspb.BinaryDecoder.prototype.advance = function (e) {
          this.cursor_ += e, goog.asserts.assert(this.cursor_ <= this.end_);
        }, jspb.BinaryDecoder.prototype.atEnd = function () {
          return this.cursor_ == this.end_;
        }, jspb.BinaryDecoder.prototype.pastEnd = function () {
          return this.cursor_ > this.end_;
        }, jspb.BinaryDecoder.prototype.getError = function () {
          return this.error_ || 0 > this.cursor_ || this.cursor_ > this.end_;
        }, jspb.BinaryDecoder.prototype.readSplitVarint64 = function (e) {
          for (var t = 128, r = 0, n = 0, o = 0; 4 > o && 128 <= t; o++) r |= (127 & (t = this.bytes_[this.cursor_++])) << 7 * o;
          if (128 <= t && (r |= (127 & (t = this.bytes_[this.cursor_++])) << 28, n |= (127 & t) >> 4), 128 <= t) for (o = 0; 5 > o && 128 <= t; o++) n |= (127 & (t = this.bytes_[this.cursor_++])) << 7 * o + 3;
          if (128 > t) return e(r >>> 0, n >>> 0);
          goog.asserts.fail("Failed to read varint, encoding is invalid."), this.error_ = true;
        }, jspb.BinaryDecoder.prototype.readSplitZigzagVarint64 = function (e) {
          return this.readSplitVarint64(function (t, r) {
            return jspb.utils.fromZigzag64(t, r, e);
          });
        }, jspb.BinaryDecoder.prototype.readSplitFixed64 = function (e) {
          var t = this.bytes_,
            r = this.cursor_;
          this.cursor_ += 8;
          for (var n = 0, o = 0, i = r + 7; i >= r; i--) n = n << 8 | t[i], o = o << 8 | t[i + 4];
          return e(n, o);
        }, jspb.BinaryDecoder.prototype.skipVarint = function () {
          for (; 128 & this.bytes_[this.cursor_];) this.cursor_++;
          this.cursor_++;
        }, jspb.BinaryDecoder.prototype.unskipVarint = function (e) {
          for (; 128 < e;) this.cursor_--, e >>>= 7;
          this.cursor_--;
        }, jspb.BinaryDecoder.prototype.readUnsignedVarint32 = function () {
          var e = this.bytes_,
            t = e[this.cursor_ + 0],
            r = 127 & t;
          return 128 > t ? (this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), r) : (r |= (127 & (t = e[this.cursor_ + 1])) << 7, 128 > t ? (this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), r) : (r |= (127 & (t = e[this.cursor_ + 2])) << 14, 128 > t ? (this.cursor_ += 3, goog.asserts.assert(this.cursor_ <= this.end_), r) : (r |= (127 & (t = e[this.cursor_ + 3])) << 21, 128 > t ? (this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), r) : (r |= (15 & (t = e[this.cursor_ + 4])) << 28, 128 > t ? (this.cursor_ += 5, goog.asserts.assert(this.cursor_ <= this.end_), r >>> 0) : (this.cursor_ += 5, 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && goog.asserts.assert(false), goog.asserts.assert(this.cursor_ <= this.end_), r)))));
        }, jspb.BinaryDecoder.prototype.readSignedVarint32 = jspb.BinaryDecoder.prototype.readUnsignedVarint32, jspb.BinaryDecoder.prototype.readUnsignedVarint32String = function () {
          return this.readUnsignedVarint32().toString();
        }, jspb.BinaryDecoder.prototype.readSignedVarint32String = function () {
          return this.readSignedVarint32().toString();
        }, jspb.BinaryDecoder.prototype.readZigzagVarint32 = function () {
          var e = this.readUnsignedVarint32();
          return e >>> 1 ^ -(1 & e);
        }, jspb.BinaryDecoder.prototype.readUnsignedVarint64 = function () {
          return this.readSplitVarint64(jspb.utils.joinUint64);
        }, jspb.BinaryDecoder.prototype.readUnsignedVarint64String = function () {
          return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString);
        }, jspb.BinaryDecoder.prototype.readSignedVarint64 = function () {
          return this.readSplitVarint64(jspb.utils.joinInt64);
        }, jspb.BinaryDecoder.prototype.readSignedVarint64String = function () {
          return this.readSplitVarint64(jspb.utils.joinSignedDecimalString);
        }, jspb.BinaryDecoder.prototype.readZigzagVarint64 = function () {
          return this.readSplitVarint64(jspb.utils.joinZigzag64);
        }, jspb.BinaryDecoder.prototype.readZigzagVarintHash64 = function () {
          return this.readSplitZigzagVarint64(jspb.utils.joinHash64);
        }, jspb.BinaryDecoder.prototype.readZigzagVarint64String = function () {
          return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString);
        }, jspb.BinaryDecoder.prototype.readUint8 = function () {
          var e = this.bytes_[this.cursor_ + 0];
          return this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), e;
        }, jspb.BinaryDecoder.prototype.readUint16 = function () {
          var e = this.bytes_[this.cursor_ + 0],
            t = this.bytes_[this.cursor_ + 1];
          return this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), e << 0 | t << 8;
        }, jspb.BinaryDecoder.prototype.readUint32 = function () {
          var e = this.bytes_[this.cursor_ + 0],
            t = this.bytes_[this.cursor_ + 1],
            r = this.bytes_[this.cursor_ + 2],
            n = this.bytes_[this.cursor_ + 3];
          return this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), (e << 0 | t << 8 | r << 16 | n << 24) >>> 0;
        }, jspb.BinaryDecoder.prototype.readUint64 = function () {
          var e = this.readUint32(),
            t = this.readUint32();
          return jspb.utils.joinUint64(e, t);
        }, jspb.BinaryDecoder.prototype.readUint64String = function () {
          var e = this.readUint32(),
            t = this.readUint32();
          return jspb.utils.joinUnsignedDecimalString(e, t);
        }, jspb.BinaryDecoder.prototype.readInt8 = function () {
          var e = this.bytes_[this.cursor_ + 0];
          return this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), e << 24 >> 24;
        }, jspb.BinaryDecoder.prototype.readInt16 = function () {
          var e = this.bytes_[this.cursor_ + 0],
            t = this.bytes_[this.cursor_ + 1];
          return this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), (e << 0 | t << 8) << 16 >> 16;
        }, jspb.BinaryDecoder.prototype.readInt32 = function () {
          var e = this.bytes_[this.cursor_ + 0],
            t = this.bytes_[this.cursor_ + 1],
            r = this.bytes_[this.cursor_ + 2],
            n = this.bytes_[this.cursor_ + 3];
          return this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), e << 0 | t << 8 | r << 16 | n << 24;
        }, jspb.BinaryDecoder.prototype.readInt64 = function () {
          var e = this.readUint32(),
            t = this.readUint32();
          return jspb.utils.joinInt64(e, t);
        }, jspb.BinaryDecoder.prototype.readInt64String = function () {
          var e = this.readUint32(),
            t = this.readUint32();
          return jspb.utils.joinSignedDecimalString(e, t);
        }, jspb.BinaryDecoder.prototype.readFloat = function () {
          var e = this.readUint32();
          return jspb.utils.joinFloat32(e, 0);
        }, jspb.BinaryDecoder.prototype.readDouble = function () {
          var e = this.readUint32(),
            t = this.readUint32();
          return jspb.utils.joinFloat64(e, t);
        }, jspb.BinaryDecoder.prototype.readBool = function () {
          return !!this.bytes_[this.cursor_++];
        }, jspb.BinaryDecoder.prototype.readEnum = function () {
          return this.readSignedVarint32();
        }, jspb.BinaryDecoder.prototype.readString = function (e) {
          var t = this.bytes_,
            r = this.cursor_;
          e = r + e;
          for (var n = [], o = ""; r < e;) {
            var i = t[r++];
            if (128 > i) n.push(i);else {
              if (192 > i) continue;
              if (224 > i) {
                var s = t[r++];
                n.push((31 & i) << 6 | 63 & s);
              } else if (240 > i) {
                s = t[r++];
                var a2 = t[r++];
                n.push((15 & i) << 12 | (63 & s) << 6 | 63 & a2);
              } else if (248 > i) {
                i = (7 & i) << 18 | (63 & (s = t[r++])) << 12 | (63 & (a2 = t[r++])) << 6 | 63 & t[r++], i -= 65536, n.push(55296 + (i >> 10 & 1023), 56320 + (1023 & i));
              }
            }
            8192 <= n.length && (o += String.fromCharCode.apply(null, n), n.length = 0);
          }
          return o += goog.crypt.byteArrayToString(n), this.cursor_ = r, o;
        }, jspb.BinaryDecoder.prototype.readStringWithLength = function () {
          var e = this.readUnsignedVarint32();
          return this.readString(e);
        }, jspb.BinaryDecoder.prototype.readBytes = function (e) {
          if (0 > e || this.cursor_ + e > this.bytes_.length) return this.error_ = true, goog.asserts.fail("Invalid byte length!"), new Uint8Array(0);
          var t = this.bytes_.subarray(this.cursor_, this.cursor_ + e);
          return this.cursor_ += e, goog.asserts.assert(this.cursor_ <= this.end_), t;
        }, jspb.BinaryDecoder.prototype.readVarintHash64 = function () {
          return this.readSplitVarint64(jspb.utils.joinHash64);
        }, jspb.BinaryDecoder.prototype.readFixedHash64 = function () {
          var e = this.bytes_,
            t = this.cursor_,
            r = e[t + 0],
            n = e[t + 1],
            o = e[t + 2],
            i = e[t + 3],
            s = e[t + 4],
            a2 = e[t + 5],
            l = e[t + 6];
          return e = e[t + 7], this.cursor_ += 8, String.fromCharCode(r, n, o, i, s, a2, l, e);
        }, jspb.BinaryReader = function (e, t, r) {
          this.decoder_ = jspb.BinaryDecoder.alloc(e, t, r), this.fieldCursor_ = this.decoder_.getCursor(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = false, this.readCallbacks_ = null;
        }, jspb.BinaryReader.instanceCache_ = [], jspb.BinaryReader.alloc = function (e, t, r) {
          if (jspb.BinaryReader.instanceCache_.length) {
            var n = jspb.BinaryReader.instanceCache_.pop();
            return e && n.decoder_.setBlock(e, t, r), n;
          }
          return new jspb.BinaryReader(e, t, r);
        }, jspb.BinaryReader.prototype.alloc = jspb.BinaryReader.alloc, jspb.BinaryReader.prototype.free = function () {
          this.decoder_.clear(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = false, this.readCallbacks_ = null, 100 > jspb.BinaryReader.instanceCache_.length && jspb.BinaryReader.instanceCache_.push(this);
        }, jspb.BinaryReader.prototype.getFieldCursor = function () {
          return this.fieldCursor_;
        }, jspb.BinaryReader.prototype.getCursor = function () {
          return this.decoder_.getCursor();
        }, jspb.BinaryReader.prototype.getBuffer = function () {
          return this.decoder_.getBuffer();
        }, jspb.BinaryReader.prototype.getFieldNumber = function () {
          return this.nextField_;
        }, jspb.BinaryReader.prototype.getWireType = function () {
          return this.nextWireType_;
        }, jspb.BinaryReader.prototype.isDelimited = function () {
          return this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED;
        }, jspb.BinaryReader.prototype.isEndGroup = function () {
          return this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP;
        }, jspb.BinaryReader.prototype.getError = function () {
          return this.error_ || this.decoder_.getError();
        }, jspb.BinaryReader.prototype.setBlock = function (e, t, r) {
          this.decoder_.setBlock(e, t, r), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
        }, jspb.BinaryReader.prototype.reset = function () {
          this.decoder_.reset(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
        }, jspb.BinaryReader.prototype.advance = function (e) {
          this.decoder_.advance(e);
        }, jspb.BinaryReader.prototype.nextField = function () {
          if (this.decoder_.atEnd()) return false;
          if (this.getError()) return goog.asserts.fail("Decoder hit an error"), false;
          this.fieldCursor_ = this.decoder_.getCursor();
          var e = this.decoder_.readUnsignedVarint32(),
            t = e >>> 3;
          return (e &= 7) != jspb.BinaryConstants.WireType.VARINT && e != jspb.BinaryConstants.WireType.FIXED32 && e != jspb.BinaryConstants.WireType.FIXED64 && e != jspb.BinaryConstants.WireType.DELIMITED && e != jspb.BinaryConstants.WireType.START_GROUP && e != jspb.BinaryConstants.WireType.END_GROUP ? (goog.asserts.fail("Invalid wire type: %s (at position %s)", e, this.fieldCursor_), this.error_ = true, false) : (this.nextField_ = t, this.nextWireType_ = e, true);
        }, jspb.BinaryReader.prototype.unskipHeader = function () {
          this.decoder_.unskipVarint(this.nextField_ << 3 | this.nextWireType_);
        }, jspb.BinaryReader.prototype.skipMatchingFields = function () {
          var e = this.nextField_;
          for (this.unskipHeader(); this.nextField() && this.getFieldNumber() == e;) this.skipField();
          this.decoder_.atEnd() || this.unskipHeader();
        }, jspb.BinaryReader.prototype.skipVarintField = function () {
          this.nextWireType_ != jspb.BinaryConstants.WireType.VARINT ? (goog.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
        }, jspb.BinaryReader.prototype.skipDelimitedField = function () {
          if (this.nextWireType_ != jspb.BinaryConstants.WireType.DELIMITED) goog.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField();else {
            var e = this.decoder_.readUnsignedVarint32();
            this.decoder_.advance(e);
          }
        }, jspb.BinaryReader.prototype.skipFixed32Field = function () {
          this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED32 ? (goog.asserts.fail("Invalid wire type for skipFixed32Field"), this.skipField()) : this.decoder_.advance(4);
        }, jspb.BinaryReader.prototype.skipFixed64Field = function () {
          this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED64 ? (goog.asserts.fail("Invalid wire type for skipFixed64Field"), this.skipField()) : this.decoder_.advance(8);
        }, jspb.BinaryReader.prototype.skipGroup = function () {
          for (var e = this.nextField_;;) {
            if (!this.nextField()) {
              goog.asserts.fail("Unmatched start-group tag: stream EOF"), this.error_ = true;
              break;
            }
            if (this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP) {
              this.nextField_ != e && (goog.asserts.fail("Unmatched end-group tag"), this.error_ = true);
              break;
            }
            this.skipField();
          }
        }, jspb.BinaryReader.prototype.skipField = function () {
          switch (this.nextWireType_) {
            case jspb.BinaryConstants.WireType.VARINT:
              this.skipVarintField();
              break;
            case jspb.BinaryConstants.WireType.FIXED64:
              this.skipFixed64Field();
              break;
            case jspb.BinaryConstants.WireType.DELIMITED:
              this.skipDelimitedField();
              break;
            case jspb.BinaryConstants.WireType.FIXED32:
              this.skipFixed32Field();
              break;
            case jspb.BinaryConstants.WireType.START_GROUP:
              this.skipGroup();
              break;
            default:
              goog.asserts.fail("Invalid wire encoding for field.");
          }
        }, jspb.BinaryReader.prototype.registerReadCallback = function (e, t) {
          null === this.readCallbacks_ && (this.readCallbacks_ = {}), goog.asserts.assert(!this.readCallbacks_[e]), this.readCallbacks_[e] = t;
        }, jspb.BinaryReader.prototype.runReadCallback = function (e) {
          return goog.asserts.assert(null !== this.readCallbacks_), e = this.readCallbacks_[e], goog.asserts.assert(e), e(this);
        }, jspb.BinaryReader.prototype.readAny = function (e) {
          this.nextWireType_ = jspb.BinaryConstants.FieldTypeToWireType(e);
          var t = jspb.BinaryConstants.FieldType;
          switch (e) {
            case t.DOUBLE:
              return this.readDouble();
            case t.FLOAT:
              return this.readFloat();
            case t.INT64:
              return this.readInt64();
            case t.UINT64:
              return this.readUint64();
            case t.INT32:
              return this.readInt32();
            case t.FIXED64:
              return this.readFixed64();
            case t.FIXED32:
              return this.readFixed32();
            case t.BOOL:
              return this.readBool();
            case t.STRING:
              return this.readString();
            case t.GROUP:
              goog.asserts.fail("Group field type not supported in readAny()");
            case t.MESSAGE:
              goog.asserts.fail("Message field type not supported in readAny()");
            case t.BYTES:
              return this.readBytes();
            case t.UINT32:
              return this.readUint32();
            case t.ENUM:
              return this.readEnum();
            case t.SFIXED32:
              return this.readSfixed32();
            case t.SFIXED64:
              return this.readSfixed64();
            case t.SINT32:
              return this.readSint32();
            case t.SINT64:
              return this.readSint64();
            case t.FHASH64:
              return this.readFixedHash64();
            case t.VHASH64:
              return this.readVarintHash64();
            default:
              goog.asserts.fail("Invalid field type in readAny()");
          }
          return 0;
        }, jspb.BinaryReader.prototype.readMessage = function (e, t) {
          goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
          var r = this.decoder_.getEnd(),
            n = this.decoder_.readUnsignedVarint32();
          n = this.decoder_.getCursor() + n, this.decoder_.setEnd(n), t(e, this), this.decoder_.setCursor(n), this.decoder_.setEnd(r);
        }, jspb.BinaryReader.prototype.readGroup = function (e, t, r) {
          goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.START_GROUP), goog.asserts.assert(this.nextField_ == e), r(t, this), this.error_ || this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP || (goog.asserts.fail("Group submessage did not end with an END_GROUP tag"), this.error_ = true);
        }, jspb.BinaryReader.prototype.getFieldDecoder = function () {
          goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
          var e = this.decoder_.readUnsignedVarint32(),
            t = this.decoder_.getCursor(),
            r = t + e;
          return e = jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(), t, e), this.decoder_.setCursor(r), e;
        }, jspb.BinaryReader.prototype.readInt32 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32();
        }, jspb.BinaryReader.prototype.readInt32String = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32String();
        }, jspb.BinaryReader.prototype.readInt64 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
        }, jspb.BinaryReader.prototype.readInt64String = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64String();
        }, jspb.BinaryReader.prototype.readUint32 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32();
        }, jspb.BinaryReader.prototype.readUint32String = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32String();
        }, jspb.BinaryReader.prototype.readUint64 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64();
        }, jspb.BinaryReader.prototype.readUint64String = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64String();
        }, jspb.BinaryReader.prototype.readSint32 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint32();
        }, jspb.BinaryReader.prototype.readSint64 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64();
        }, jspb.BinaryReader.prototype.readSint64String = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64String();
        }, jspb.BinaryReader.prototype.readFixed32 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readUint32();
        }, jspb.BinaryReader.prototype.readFixed64 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64();
        }, jspb.BinaryReader.prototype.readFixed64String = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64String();
        }, jspb.BinaryReader.prototype.readSfixed32 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32();
        }, jspb.BinaryReader.prototype.readSfixed32String = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32().toString();
        }, jspb.BinaryReader.prototype.readSfixed64 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64();
        }, jspb.BinaryReader.prototype.readSfixed64String = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64String();
        }, jspb.BinaryReader.prototype.readFloat = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readFloat();
        }, jspb.BinaryReader.prototype.readDouble = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readDouble();
        }, jspb.BinaryReader.prototype.readBool = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), !!this.decoder_.readUnsignedVarint32();
        }, jspb.BinaryReader.prototype.readEnum = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
        }, jspb.BinaryReader.prototype.readString = function () {
          goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
          var e = this.decoder_.readUnsignedVarint32();
          return this.decoder_.readString(e);
        }, jspb.BinaryReader.prototype.readBytes = function () {
          goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
          var e = this.decoder_.readUnsignedVarint32();
          return this.decoder_.readBytes(e);
        }, jspb.BinaryReader.prototype.readVarintHash64 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readVarintHash64();
        }, jspb.BinaryReader.prototype.readSintHash64 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarintHash64();
        }, jspb.BinaryReader.prototype.readSplitVarint64 = function (e) {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(e);
        }, jspb.BinaryReader.prototype.readSplitZigzagVarint64 = function (e) {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(function (t, r) {
            return jspb.utils.fromZigzag64(t, r, e);
          });
        }, jspb.BinaryReader.prototype.readFixedHash64 = function () {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readFixedHash64();
        }, jspb.BinaryReader.prototype.readSplitFixed64 = function (e) {
          return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readSplitFixed64(e);
        }, jspb.BinaryReader.prototype.readPackedField_ = function (e) {
          goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
          var t = this.decoder_.readUnsignedVarint32();
          t = this.decoder_.getCursor() + t;
          for (var r = []; this.decoder_.getCursor() < t;) r.push(e.call(this.decoder_));
          return r;
        }, jspb.BinaryReader.prototype.readPackedInt32 = function () {
          return this.readPackedField_(this.decoder_.readSignedVarint32);
        }, jspb.BinaryReader.prototype.readPackedInt32String = function () {
          return this.readPackedField_(this.decoder_.readSignedVarint32String);
        }, jspb.BinaryReader.prototype.readPackedInt64 = function () {
          return this.readPackedField_(this.decoder_.readSignedVarint64);
        }, jspb.BinaryReader.prototype.readPackedInt64String = function () {
          return this.readPackedField_(this.decoder_.readSignedVarint64String);
        }, jspb.BinaryReader.prototype.readPackedUint32 = function () {
          return this.readPackedField_(this.decoder_.readUnsignedVarint32);
        }, jspb.BinaryReader.prototype.readPackedUint32String = function () {
          return this.readPackedField_(this.decoder_.readUnsignedVarint32String);
        }, jspb.BinaryReader.prototype.readPackedUint64 = function () {
          return this.readPackedField_(this.decoder_.readUnsignedVarint64);
        }, jspb.BinaryReader.prototype.readPackedUint64String = function () {
          return this.readPackedField_(this.decoder_.readUnsignedVarint64String);
        }, jspb.BinaryReader.prototype.readPackedSint32 = function () {
          return this.readPackedField_(this.decoder_.readZigzagVarint32);
        }, jspb.BinaryReader.prototype.readPackedSint64 = function () {
          return this.readPackedField_(this.decoder_.readZigzagVarint64);
        }, jspb.BinaryReader.prototype.readPackedSint64String = function () {
          return this.readPackedField_(this.decoder_.readZigzagVarint64String);
        }, jspb.BinaryReader.prototype.readPackedFixed32 = function () {
          return this.readPackedField_(this.decoder_.readUint32);
        }, jspb.BinaryReader.prototype.readPackedFixed64 = function () {
          return this.readPackedField_(this.decoder_.readUint64);
        }, jspb.BinaryReader.prototype.readPackedFixed64String = function () {
          return this.readPackedField_(this.decoder_.readUint64String);
        }, jspb.BinaryReader.prototype.readPackedSfixed32 = function () {
          return this.readPackedField_(this.decoder_.readInt32);
        }, jspb.BinaryReader.prototype.readPackedSfixed64 = function () {
          return this.readPackedField_(this.decoder_.readInt64);
        }, jspb.BinaryReader.prototype.readPackedSfixed64String = function () {
          return this.readPackedField_(this.decoder_.readInt64String);
        }, jspb.BinaryReader.prototype.readPackedFloat = function () {
          return this.readPackedField_(this.decoder_.readFloat);
        }, jspb.BinaryReader.prototype.readPackedDouble = function () {
          return this.readPackedField_(this.decoder_.readDouble);
        }, jspb.BinaryReader.prototype.readPackedBool = function () {
          return this.readPackedField_(this.decoder_.readBool);
        }, jspb.BinaryReader.prototype.readPackedEnum = function () {
          return this.readPackedField_(this.decoder_.readEnum);
        }, jspb.BinaryReader.prototype.readPackedVarintHash64 = function () {
          return this.readPackedField_(this.decoder_.readVarintHash64);
        }, jspb.BinaryReader.prototype.readPackedFixedHash64 = function () {
          return this.readPackedField_(this.decoder_.readFixedHash64);
        }, jspb.Map = function (e, t) {
          this.arr_ = e, this.valueCtor_ = t, this.map_ = {}, this.arrClean = true, 0 < this.arr_.length && this.loadFromArray_();
        }, jspb.Map.prototype.loadFromArray_ = function () {
          for (var e = 0; e < this.arr_.length; e++) {
            var t = this.arr_[e],
              r = t[0];
            this.map_[r.toString()] = new jspb.Map.Entry_(r, t[1]);
          }
          this.arrClean = true;
        }, jspb.Map.prototype.toArray = function () {
          if (this.arrClean) {
            if (this.valueCtor_) {
              var e,
                t = this.map_;
              for (e in t) if (Object.prototype.hasOwnProperty.call(t, e)) {
                var r = t[e].valueWrapper;
                r && r.toArray();
              }
            }
          } else {
            for (this.arr_.length = 0, (t = this.stringKeys_()).sort(), e = 0; e < t.length; e++) {
              var n = this.map_[t[e]];
              (r = n.valueWrapper) && r.toArray(), this.arr_.push([n.key, n.value]);
            }
            this.arrClean = true;
          }
          return this.arr_;
        }, jspb.Map.prototype.toObject = function (e, t) {
          for (var r = this.toArray(), n = [], o = 0; o < r.length; o++) {
            var i = this.map_[r[o][0].toString()];
            this.wrapEntry_(i);
            var s = i.valueWrapper;
            s ? (goog.asserts.assert(t), n.push([i.key, t(e, s)])) : n.push([i.key, i.value]);
          }
          return n;
        }, jspb.Map.fromObject = function (e, t, r) {
          t = new jspb.Map([], t);
          for (var n = 0; n < e.length; n++) {
            var o = e[n][0],
              i = r(e[n][1]);
            t.set(o, i);
          }
          return t;
        }, jspb.Map.ArrayIteratorIterable_ = function (e) {
          this.idx_ = 0, this.arr_ = e;
        }, jspb.Map.ArrayIteratorIterable_.prototype.next = function () {
          return this.idx_ < this.arr_.length ? {
            done: false,
            value: this.arr_[this.idx_++]
          } : {
            done: true,
            value: void 0
          };
        }, "undefined" != typeof Symbol && (jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator] = function () {
          return this;
        }), jspb.Map.prototype.getLength = function () {
          return this.stringKeys_().length;
        }, jspb.Map.prototype.clear = function () {
          this.map_ = {}, this.arrClean = false;
        }, jspb.Map.prototype.del = function (e) {
          e = e.toString();
          var t = this.map_.hasOwnProperty(e);
          return delete this.map_[e], this.arrClean = false, t;
        }, jspb.Map.prototype.getEntryList = function () {
          var e = [],
            t = this.stringKeys_();
          t.sort();
          for (var r = 0; r < t.length; r++) {
            var n = this.map_[t[r]];
            e.push([n.key, n.value]);
          }
          return e;
        }, jspb.Map.prototype.entries = function () {
          var e = [],
            t = this.stringKeys_();
          t.sort();
          for (var r = 0; r < t.length; r++) {
            var n = this.map_[t[r]];
            e.push([n.key, this.wrapEntry_(n)]);
          }
          return new jspb.Map.ArrayIteratorIterable_(e);
        }, jspb.Map.prototype.keys = function () {
          var e = [],
            t = this.stringKeys_();
          t.sort();
          for (var r = 0; r < t.length; r++) e.push(this.map_[t[r]].key);
          return new jspb.Map.ArrayIteratorIterable_(e);
        }, jspb.Map.prototype.values = function () {
          var e = [],
            t = this.stringKeys_();
          t.sort();
          for (var r = 0; r < t.length; r++) e.push(this.wrapEntry_(this.map_[t[r]]));
          return new jspb.Map.ArrayIteratorIterable_(e);
        }, jspb.Map.prototype.forEach = function (e, t) {
          var r = this.stringKeys_();
          r.sort();
          for (var n = 0; n < r.length; n++) {
            var o = this.map_[r[n]];
            e.call(t, this.wrapEntry_(o), o.key, this);
          }
        }, jspb.Map.prototype.set = function (e, t) {
          var r = new jspb.Map.Entry_(e);
          return this.valueCtor_ ? (r.valueWrapper = t, r.value = t.toArray()) : r.value = t, this.map_[e.toString()] = r, this.arrClean = false, this;
        }, jspb.Map.prototype.wrapEntry_ = function (e) {
          return this.valueCtor_ ? (e.valueWrapper || (e.valueWrapper = new this.valueCtor_(e.value)), e.valueWrapper) : e.value;
        }, jspb.Map.prototype.get = function (e) {
          if (e = this.map_[e.toString()]) return this.wrapEntry_(e);
        }, jspb.Map.prototype.has = function (e) {
          return e.toString() in this.map_;
        }, jspb.Map.prototype.serializeBinary = function (e, t, r, n, o) {
          var i = this.stringKeys_();
          i.sort();
          for (var s = 0; s < i.length; s++) {
            var a2 = this.map_[i[s]];
            t.beginSubMessage(e), r.call(t, 1, a2.key), this.valueCtor_ ? n.call(t, 2, this.wrapEntry_(a2), o) : n.call(t, 2, a2.value), t.endSubMessage();
          }
        }, jspb.Map.deserializeBinary = function (e, t, r, n, o, i, s) {
          for (; t.nextField() && !t.isEndGroup();) {
            var a2 = t.getFieldNumber();
            1 == a2 ? i = r.call(t) : 2 == a2 && (e.valueCtor_ ? (goog.asserts.assert(o), s || (s = new e.valueCtor_()), n.call(t, s, o)) : s = n.call(t));
          }
          goog.asserts.assert(null != i), goog.asserts.assert(null != s), e.set(i, s);
        }, jspb.Map.prototype.stringKeys_ = function () {
          var e,
            t = this.map_,
            r = [];
          for (e in t) Object.prototype.hasOwnProperty.call(t, e) && r.push(e);
          return r;
        }, jspb.Map.Entry_ = function (e, t) {
          this.key = e, this.value = t, this.valueWrapper = void 0;
        }, jspb.ExtensionFieldInfo = function (e, t, r, n, o) {
          this.fieldIndex = e, this.fieldName = t, this.ctor = r, this.toObjectFn = n, this.isRepeated = o;
        }, jspb.ExtensionFieldBinaryInfo = function (e, t, r, n, o, i) {
          this.fieldInfo = e, this.binaryReaderFn = t, this.binaryWriterFn = r, this.binaryMessageSerializeFn = n, this.binaryMessageDeserializeFn = o, this.isPacked = i;
        }, jspb.ExtensionFieldInfo.prototype.isMessageType = function () {
          return !!this.ctor;
        }, jspb.Message = function () {}, jspb.Message.GENERATE_TO_OBJECT = true, jspb.Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE, jspb.Message.GENERATE_TO_STRING = true, jspb.Message.ASSUME_LOCAL_ARRAYS = false, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS = true, jspb.Message.SUPPORTS_UINT8ARRAY_ = "function" == typeof Uint8Array, jspb.Message.prototype.getJsPbMessageId = function () {
          return this.messageId_;
        }, jspb.Message.getIndex_ = function (e, t) {
          return t + e.arrayIndexOffset_;
        }, jspb.Message.hiddenES6Property_ = function () {}, jspb.Message.getFieldNumber_ = function (e, t) {
          return t - e.arrayIndexOffset_;
        }, jspb.Message.initialize = function (e, t, r, n, o, i) {
          if (e.wrappers_ = null, t || (t = r ? [r] : []), e.messageId_ = r ? String(r) : void 0, e.arrayIndexOffset_ = 0 === r ? -1 : 0, e.array = t, jspb.Message.initPivotAndExtensionObject_(e, n), e.convertedPrimitiveFields_ = {}, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (e.repeatedFields = o), o) for (t = 0; t < o.length; t++) (r = o[t]) < e.pivot_ ? (r = jspb.Message.getIndex_(e, r), e.array[r] = e.array[r] || jspb.Message.EMPTY_LIST_SENTINEL_) : (jspb.Message.maybeInitEmptyExtensionObject_(e), e.extensionObject_[r] = e.extensionObject_[r] || jspb.Message.EMPTY_LIST_SENTINEL_);
          if (i && i.length) for (t = 0; t < i.length; t++) jspb.Message.computeOneofCase(e, i[t]);
        }, jspb.Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [], jspb.Message.isArray_ = function (e) {
          return jspb.Message.ASSUME_LOCAL_ARRAYS ? e instanceof Array : Array.isArray(e);
        }, jspb.Message.isExtensionObject_ = function (e) {
          return !(null === e || "object" != typeof e || jspb.Message.isArray_(e) || jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array);
        }, jspb.Message.initPivotAndExtensionObject_ = function (e, t) {
          var r = e.array.length,
            n = -1;
          if (r && (n = r - 1, r = e.array[n], jspb.Message.isExtensionObject_(r))) return e.pivot_ = jspb.Message.getFieldNumber_(e, n), void (e.extensionObject_ = r);
          -1 < t ? (e.pivot_ = Math.max(t, jspb.Message.getFieldNumber_(e, n + 1)), e.extensionObject_ = null) : e.pivot_ = Number.MAX_VALUE;
        }, jspb.Message.maybeInitEmptyExtensionObject_ = function (e) {
          var t = jspb.Message.getIndex_(e, e.pivot_);
          e.array[t] || (e.extensionObject_ = e.array[t] = {});
        }, jspb.Message.toObjectList = function (e, t, r) {
          for (var n = [], o = 0; o < e.length; o++) n[o] = t.call(e[o], r, e[o]);
          return n;
        }, jspb.Message.toObjectExtension = function (e, t, r, n, o) {
          for (var i in r) {
            var s = r[i],
              a2 = n.call(e, s);
            if (null != a2) {
              for (var l in s.fieldName) if (s.fieldName.hasOwnProperty(l)) break;
              t[l] = s.toObjectFn ? s.isRepeated ? jspb.Message.toObjectList(a2, s.toObjectFn, o) : s.toObjectFn(o, a2) : a2;
            }
          }
        }, jspb.Message.serializeBinaryExtensions = function (e, t, r, n) {
          for (var o in r) {
            var i = r[o],
              s = i.fieldInfo;
            if (!i.binaryWriterFn) throw Error("Message extension present that was generated without binary serialization support");
            var a2 = n.call(e, s);
            if (null != a2) if (s.isMessageType()) {
              if (!i.binaryMessageSerializeFn) throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
              i.binaryWriterFn.call(t, s.fieldIndex, a2, i.binaryMessageSerializeFn);
            } else i.binaryWriterFn.call(t, s.fieldIndex, a2);
          }
        }, jspb.Message.readBinaryExtension = function (e, t, r, n, o) {
          var i = r[t.getFieldNumber()];
          if (i) {
            if (r = i.fieldInfo, !i.binaryReaderFn) throw Error("Deserializing extension whose generated code does not support binary format");
            if (r.isMessageType()) {
              var s = new r.ctor();
              i.binaryReaderFn.call(t, s, i.binaryMessageDeserializeFn);
            } else s = i.binaryReaderFn.call(t);
            r.isRepeated && !i.isPacked ? (t = n.call(e, r)) ? t.push(s) : o.call(e, r, [s]) : o.call(e, r, s);
          } else t.skipField();
        }, jspb.Message.getField = function (e, t) {
          if (t < e.pivot_) {
            t = jspb.Message.getIndex_(e, t);
            var r = e.array[t];
            return r === jspb.Message.EMPTY_LIST_SENTINEL_ ? e.array[t] = [] : r;
          }
          if (e.extensionObject_) return (r = e.extensionObject_[t]) === jspb.Message.EMPTY_LIST_SENTINEL_ ? e.extensionObject_[t] = [] : r;
        }, jspb.Message.getRepeatedField = function (e, t) {
          return jspb.Message.getField(e, t);
        }, jspb.Message.getOptionalFloatingPointField = function (e, t) {
          return null == (e = jspb.Message.getField(e, t)) ? e : +e;
        }, jspb.Message.getBooleanField = function (e, t) {
          return null == (e = jspb.Message.getField(e, t)) ? e : !!e;
        }, jspb.Message.getRepeatedFloatingPointField = function (e, t) {
          var r = jspb.Message.getRepeatedField(e, t);
          if (e.convertedPrimitiveFields_ || (e.convertedPrimitiveFields_ = {}), !e.convertedPrimitiveFields_[t]) {
            for (var n = 0; n < r.length; n++) r[n] = +r[n];
            e.convertedPrimitiveFields_[t] = true;
          }
          return r;
        }, jspb.Message.getRepeatedBooleanField = function (e, t) {
          var r = jspb.Message.getRepeatedField(e, t);
          if (e.convertedPrimitiveFields_ || (e.convertedPrimitiveFields_ = {}), !e.convertedPrimitiveFields_[t]) {
            for (var n = 0; n < r.length; n++) r[n] = !!r[n];
            e.convertedPrimitiveFields_[t] = true;
          }
          return r;
        }, jspb.Message.bytesAsB64 = function (e) {
          return null == e || "string" == typeof e ? e : jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array ? goog.crypt.base64.encodeByteArray(e) : (goog.asserts.fail("Cannot coerce to b64 string: " + goog.typeOf(e)), null);
        }, jspb.Message.bytesAsU8 = function (e) {
          return null == e || e instanceof Uint8Array ? e : "string" == typeof e ? goog.crypt.base64.decodeStringToUint8Array(e) : (goog.asserts.fail("Cannot coerce to Uint8Array: " + goog.typeOf(e)), null);
        }, jspb.Message.bytesListAsB64 = function (e) {
          return jspb.Message.assertConsistentTypes_(e), e.length && "string" != typeof e[0] ? goog.array.map(e, jspb.Message.bytesAsB64) : e;
        }, jspb.Message.bytesListAsU8 = function (e) {
          return jspb.Message.assertConsistentTypes_(e), !e.length || e[0] instanceof Uint8Array ? e : goog.array.map(e, jspb.Message.bytesAsU8);
        }, jspb.Message.assertConsistentTypes_ = function (e) {
          if (goog.DEBUG && e && 1 < e.length) {
            var t = goog.typeOf(e[0]);
            goog.array.forEach(e, function (e2) {
              goog.typeOf(e2) != t && goog.asserts.fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(e2) + " expected " + t);
            });
          }
        }, jspb.Message.getFieldWithDefault = function (e, t, r) {
          return null == (e = jspb.Message.getField(e, t)) ? r : e;
        }, jspb.Message.getBooleanFieldWithDefault = function (e, t, r) {
          return null == (e = jspb.Message.getBooleanField(e, t)) ? r : e;
        }, jspb.Message.getFloatingPointFieldWithDefault = function (e, t, r) {
          return null == (e = jspb.Message.getOptionalFloatingPointField(e, t)) ? r : e;
        }, jspb.Message.getFieldProto3 = jspb.Message.getFieldWithDefault, jspb.Message.getMapField = function (e, t, r, n) {
          if (e.wrappers_ || (e.wrappers_ = {}), t in e.wrappers_) return e.wrappers_[t];
          var o = jspb.Message.getField(e, t);
          if (!o) {
            if (r) return;
            o = [], jspb.Message.setField(e, t, o);
          }
          return e.wrappers_[t] = new jspb.Map(o, n);
        }, jspb.Message.setField = function (e, t, r) {
          return goog.asserts.assertInstanceof(e, jspb.Message), t < e.pivot_ ? e.array[jspb.Message.getIndex_(e, t)] = r : (jspb.Message.maybeInitEmptyExtensionObject_(e), e.extensionObject_[t] = r), e;
        }, jspb.Message.setProto3IntField = function (e, t, r) {
          return jspb.Message.setFieldIgnoringDefault_(e, t, r, 0);
        }, jspb.Message.setProto3FloatField = function (e, t, r) {
          return jspb.Message.setFieldIgnoringDefault_(e, t, r, 0);
        }, jspb.Message.setProto3BooleanField = function (e, t, r) {
          return jspb.Message.setFieldIgnoringDefault_(e, t, r, false);
        }, jspb.Message.setProto3StringField = function (e, t, r) {
          return jspb.Message.setFieldIgnoringDefault_(e, t, r, "");
        }, jspb.Message.setProto3BytesField = function (e, t, r) {
          return jspb.Message.setFieldIgnoringDefault_(e, t, r, "");
        }, jspb.Message.setProto3EnumField = function (e, t, r) {
          return jspb.Message.setFieldIgnoringDefault_(e, t, r, 0);
        }, jspb.Message.setProto3StringIntField = function (e, t, r) {
          return jspb.Message.setFieldIgnoringDefault_(e, t, r, "0");
        }, jspb.Message.setFieldIgnoringDefault_ = function (e, t, r, n) {
          return goog.asserts.assertInstanceof(e, jspb.Message), r !== n ? jspb.Message.setField(e, t, r) : t < e.pivot_ ? e.array[jspb.Message.getIndex_(e, t)] = null : (jspb.Message.maybeInitEmptyExtensionObject_(e), delete e.extensionObject_[t]), e;
        }, jspb.Message.addToRepeatedField = function (e, t, r, n) {
          return goog.asserts.assertInstanceof(e, jspb.Message), t = jspb.Message.getRepeatedField(e, t), null != n ? t.splice(n, 0, r) : t.push(r), e;
        }, jspb.Message.setOneofField = function (e, t, r, n) {
          return goog.asserts.assertInstanceof(e, jspb.Message), (r = jspb.Message.computeOneofCase(e, r)) && r !== t && void 0 !== n && (e.wrappers_ && r in e.wrappers_ && (e.wrappers_[r] = void 0), jspb.Message.setField(e, r, void 0)), jspb.Message.setField(e, t, n);
        }, jspb.Message.computeOneofCase = function (e, t) {
          for (var r, n, o = 0; o < t.length; o++) {
            var i = t[o],
              s = jspb.Message.getField(e, i);
            null != s && (r = i, n = s, jspb.Message.setField(e, i, void 0));
          }
          return r ? (jspb.Message.setField(e, r, n), r) : 0;
        }, jspb.Message.getWrapperField = function (e, t, r, n) {
          if (e.wrappers_ || (e.wrappers_ = {}), !e.wrappers_[r]) {
            var o = jspb.Message.getField(e, r);
            (n || o) && (e.wrappers_[r] = new t(o));
          }
          return e.wrappers_[r];
        }, jspb.Message.getRepeatedWrapperField = function (e, t, r) {
          return jspb.Message.wrapRepeatedField_(e, t, r), (t = e.wrappers_[r]) == jspb.Message.EMPTY_LIST_SENTINEL_ && (t = e.wrappers_[r] = []), t;
        }, jspb.Message.wrapRepeatedField_ = function (e, t, r) {
          if (e.wrappers_ || (e.wrappers_ = {}), !e.wrappers_[r]) {
            for (var n = jspb.Message.getRepeatedField(e, r), o = [], i = 0; i < n.length; i++) o[i] = new t(n[i]);
            e.wrappers_[r] = o;
          }
        }, jspb.Message.setWrapperField = function (e, t, r) {
          goog.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {});
          var n = r ? r.toArray() : r;
          return e.wrappers_[t] = r, jspb.Message.setField(e, t, n);
        }, jspb.Message.setOneofWrapperField = function (e, t, r, n) {
          goog.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {});
          var o = n ? n.toArray() : n;
          return e.wrappers_[t] = n, jspb.Message.setOneofField(e, t, r, o);
        }, jspb.Message.setRepeatedWrapperField = function (e, t, r) {
          goog.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {}), r = r || [];
          for (var n = [], o = 0; o < r.length; o++) n[o] = r[o].toArray();
          return e.wrappers_[t] = r, jspb.Message.setField(e, t, n);
        }, jspb.Message.addToRepeatedWrapperField = function (e, t, r, n, o) {
          jspb.Message.wrapRepeatedField_(e, n, t);
          var i = e.wrappers_[t];
          return i || (i = e.wrappers_[t] = []), r = r || new n(), e = jspb.Message.getRepeatedField(e, t), null != o ? (i.splice(o, 0, r), e.splice(o, 0, r.toArray())) : (i.push(r), e.push(r.toArray())), r;
        }, jspb.Message.toMap = function (e, t, r, n) {
          for (var o = {}, i = 0; i < e.length; i++) o[t.call(e[i])] = r ? r.call(e[i], n, e[i]) : e[i];
          return o;
        }, jspb.Message.prototype.syncMapFields_ = function () {
          if (this.wrappers_) for (var e in this.wrappers_) {
            var t = this.wrappers_[e];
            if (Array.isArray(t)) for (var r = 0; r < t.length; r++) t[r] && t[r].toArray();else t && t.toArray();
          }
        }, jspb.Message.prototype.toArray = function () {
          return this.syncMapFields_(), this.array;
        }, jspb.Message.GENERATE_TO_STRING && (jspb.Message.prototype.toString = function () {
          return this.syncMapFields_(), this.array.toString();
        }), jspb.Message.prototype.getExtension = function (e) {
          if (this.extensionObject_) {
            this.wrappers_ || (this.wrappers_ = {});
            var t = e.fieldIndex;
            if (e.isRepeated) {
              if (e.isMessageType()) return this.wrappers_[t] || (this.wrappers_[t] = goog.array.map(this.extensionObject_[t] || [], function (t2) {
                return new e.ctor(t2);
              })), this.wrappers_[t];
            } else if (e.isMessageType()) return !this.wrappers_[t] && this.extensionObject_[t] && (this.wrappers_[t] = new e.ctor(this.extensionObject_[t])), this.wrappers_[t];
            return this.extensionObject_[t];
          }
        }, jspb.Message.prototype.setExtension = function (e, t) {
          this.wrappers_ || (this.wrappers_ = {}), jspb.Message.maybeInitEmptyExtensionObject_(this);
          var r = e.fieldIndex;
          return e.isRepeated ? (t = t || [], e.isMessageType() ? (this.wrappers_[r] = t, this.extensionObject_[r] = goog.array.map(t, function (e2) {
            return e2.toArray();
          })) : this.extensionObject_[r] = t) : e.isMessageType() ? (this.wrappers_[r] = t, this.extensionObject_[r] = t ? t.toArray() : t) : this.extensionObject_[r] = t, this;
        }, jspb.Message.difference = function (e, t) {
          if (!(e instanceof t.constructor)) throw Error("Messages have different types.");
          var r = e.toArray();
          t = t.toArray();
          var n = [],
            o = 0,
            i = r.length > t.length ? r.length : t.length;
          for (e.getJsPbMessageId() && (n[0] = e.getJsPbMessageId(), o = 1); o < i; o++) jspb.Message.compareFields(r[o], t[o]) || (n[o] = t[o]);
          return new e.constructor(n);
        }, jspb.Message.equals = function (e, t) {
          return e == t || !(!e || !t) && e instanceof t.constructor && jspb.Message.compareFields(e.toArray(), t.toArray());
        }, jspb.Message.compareExtensions = function (e, t) {
          e = e || {}, t = t || {};
          var r,
            n = {};
          for (r in e) n[r] = 0;
          for (r in t) n[r] = 0;
          for (r in n) if (!jspb.Message.compareFields(e[r], t[r])) return false;
          return true;
        }, jspb.Message.compareFields = function (e, t) {
          if (e == t) return true;
          if (!goog.isObject(e) || !goog.isObject(t)) return !!("number" == typeof e && isNaN(e) || "number" == typeof t && isNaN(t)) && String(e) == String(t);
          if (e.constructor != t.constructor) return false;
          if (jspb.Message.SUPPORTS_UINT8ARRAY_ && e.constructor === Uint8Array) {
            if (e.length != t.length) return false;
            for (var r = 0; r < e.length; r++) if (e[r] != t[r]) return false;
            return true;
          }
          if (e.constructor === Array) {
            var n = void 0,
              o = void 0,
              i = Math.max(e.length, t.length);
            for (r = 0; r < i; r++) {
              var s = e[r],
                a2 = t[r];
              if (s && s.constructor == Object && (goog.asserts.assert(void 0 === n), goog.asserts.assert(r === e.length - 1), n = s, s = void 0), a2 && a2.constructor == Object && (goog.asserts.assert(void 0 === o), goog.asserts.assert(r === t.length - 1), o = a2, a2 = void 0), !jspb.Message.compareFields(s, a2)) return false;
            }
            return !n && !o || (n = n || {}, o = o || {}, jspb.Message.compareExtensions(n, o));
          }
          if (e.constructor === Object) return jspb.Message.compareExtensions(e, t);
          throw Error("Invalid type in JSPB array");
        }, jspb.Message.prototype.cloneMessage = function () {
          return jspb.Message.cloneMessage(this);
        }, jspb.Message.prototype.clone = function () {
          return jspb.Message.cloneMessage(this);
        }, jspb.Message.clone = function (e) {
          return jspb.Message.cloneMessage(e);
        }, jspb.Message.cloneMessage = function (e) {
          return new e.constructor(jspb.Message.clone_(e.toArray()));
        }, jspb.Message.copyInto = function (e, t) {
          goog.asserts.assertInstanceof(e, jspb.Message), goog.asserts.assertInstanceof(t, jspb.Message), goog.asserts.assert(e.constructor == t.constructor, "Copy source and target message should have the same type."), e = jspb.Message.clone(e);
          for (var r = t.toArray(), n = e.toArray(), o = r.length = 0; o < n.length; o++) r[o] = n[o];
          t.wrappers_ = e.wrappers_, t.extensionObject_ = e.extensionObject_;
        }, jspb.Message.clone_ = function (e) {
          if (Array.isArray(e)) {
            for (var t = Array(e.length), r = 0; r < e.length; r++) {
              var n = e[r];
              null != n && (t[r] = "object" == typeof n ? jspb.Message.clone_(goog.asserts.assert(n)) : n);
            }
            return t;
          }
          if (jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array) return new Uint8Array(e);
          for (r in t = {}, e) null != (n = e[r]) && (t[r] = "object" == typeof n ? jspb.Message.clone_(goog.asserts.assert(n)) : n);
          return t;
        }, jspb.Message.registerMessageType = function (e, t) {
          t.messageId = e;
        }, jspb.Message.messageSetExtensions = {}, jspb.Message.messageSetExtensionsBinary = {}, jspb.arith = {}, jspb.arith.UInt64 = function (e, t) {
          this.lo = e, this.hi = t;
        }, jspb.arith.UInt64.prototype.cmp = function (e) {
          return this.hi < e.hi || this.hi == e.hi && this.lo < e.lo ? -1 : this.hi == e.hi && this.lo == e.lo ? 0 : 1;
        }, jspb.arith.UInt64.prototype.rightShift = function () {
          return new jspb.arith.UInt64((this.lo >>> 1 | (1 & this.hi) << 31) >>> 0, this.hi >>> 1 >>> 0);
        }, jspb.arith.UInt64.prototype.leftShift = function () {
          return new jspb.arith.UInt64(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
        }, jspb.arith.UInt64.prototype.msb = function () {
          return !!(2147483648 & this.hi);
        }, jspb.arith.UInt64.prototype.lsb = function () {
          return !!(1 & this.lo);
        }, jspb.arith.UInt64.prototype.zero = function () {
          return 0 == this.lo && 0 == this.hi;
        }, jspb.arith.UInt64.prototype.add = function (e) {
          return new jspb.arith.UInt64((this.lo + e.lo & 4294967295) >>> 0 >>> 0, ((this.hi + e.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + e.lo ? 1 : 0) >>> 0);
        }, jspb.arith.UInt64.prototype.sub = function (e) {
          return new jspb.arith.UInt64((this.lo - e.lo & 4294967295) >>> 0 >>> 0, ((this.hi - e.hi & 4294967295) >>> 0) - (0 > this.lo - e.lo ? 1 : 0) >>> 0);
        }, jspb.arith.UInt64.mul32x32 = function (e, t) {
          var r = 65535 & e,
            n = 65535 & t,
            o = t >>> 16;
          for (t = r * n + 65536 * (r * o & 65535) + 65536 * ((e >>>= 16) * n & 65535), r = e * o + (r * o >>> 16) + (e * n >>> 16); 4294967296 <= t;) t -= 4294967296, r += 1;
          return new jspb.arith.UInt64(t >>> 0, r >>> 0);
        }, jspb.arith.UInt64.prototype.mul = function (e) {
          var t = jspb.arith.UInt64.mul32x32(this.lo, e);
          return (e = jspb.arith.UInt64.mul32x32(this.hi, e)).hi = e.lo, e.lo = 0, t.add(e);
        }, jspb.arith.UInt64.prototype.div = function (e) {
          if (0 == e) return [];
          var t = new jspb.arith.UInt64(0, 0),
            r = new jspb.arith.UInt64(this.lo, this.hi);
          e = new jspb.arith.UInt64(e, 0);
          for (var n = new jspb.arith.UInt64(1, 0); !e.msb();) e = e.leftShift(), n = n.leftShift();
          for (; !n.zero();) 0 >= e.cmp(r) && (t = t.add(n), r = r.sub(e)), e = e.rightShift(), n = n.rightShift();
          return [t, r];
        }, jspb.arith.UInt64.prototype.toString = function () {
          for (var e = "", t = this; !t.zero();) {
            var r = (t = t.div(10))[0];
            e = t[1].lo + e, t = r;
          }
          return "" == e && (e = "0"), e;
        }, jspb.arith.UInt64.fromString = function (e) {
          for (var t = new jspb.arith.UInt64(0, 0), r = new jspb.arith.UInt64(0, 0), n = 0; n < e.length; n++) {
            if ("0" > e[n] || "9" < e[n]) return null;
            var o = parseInt(e[n], 10);
            r.lo = o, t = t.mul(10).add(r);
          }
          return t;
        }, jspb.arith.UInt64.prototype.clone = function () {
          return new jspb.arith.UInt64(this.lo, this.hi);
        }, jspb.arith.Int64 = function (e, t) {
          this.lo = e, this.hi = t;
        }, jspb.arith.Int64.prototype.add = function (e) {
          return new jspb.arith.Int64((this.lo + e.lo & 4294967295) >>> 0 >>> 0, ((this.hi + e.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + e.lo ? 1 : 0) >>> 0);
        }, jspb.arith.Int64.prototype.sub = function (e) {
          return new jspb.arith.Int64((this.lo - e.lo & 4294967295) >>> 0 >>> 0, ((this.hi - e.hi & 4294967295) >>> 0) - (0 > this.lo - e.lo ? 1 : 0) >>> 0);
        }, jspb.arith.Int64.prototype.clone = function () {
          return new jspb.arith.Int64(this.lo, this.hi);
        }, jspb.arith.Int64.prototype.toString = function () {
          var e = 0 != (2147483648 & this.hi),
            t = new jspb.arith.UInt64(this.lo, this.hi);
          return e && (t = new jspb.arith.UInt64(0, 0).sub(t)), (e ? "-" : "") + t.toString();
        }, jspb.arith.Int64.fromString = function (e) {
          var t = 0 < e.length && "-" == e[0];
          return t && (e = e.substring(1)), null === (e = jspb.arith.UInt64.fromString(e)) ? null : (t && (e = new jspb.arith.UInt64(0, 0).sub(e)), new jspb.arith.Int64(e.lo, e.hi));
        }, jspb.BinaryEncoder = function () {
          this.buffer_ = [];
        }, jspb.BinaryEncoder.prototype.length = function () {
          return this.buffer_.length;
        }, jspb.BinaryEncoder.prototype.end = function () {
          var e = this.buffer_;
          return this.buffer_ = [], e;
        }, jspb.BinaryEncoder.prototype.writeSplitVarint64 = function (e, t) {
          for (goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(t == Math.floor(t)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32); 0 < t || 127 < e;) this.buffer_.push(127 & e | 128), e = (e >>> 7 | t << 25) >>> 0, t >>>= 7;
          this.buffer_.push(e);
        }, jspb.BinaryEncoder.prototype.writeSplitFixed64 = function (e, t) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(t == Math.floor(t)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeUint32(e), this.writeUint32(t);
        }, jspb.BinaryEncoder.prototype.writeUnsignedVarint32 = function (e) {
          for (goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32); 127 < e;) this.buffer_.push(127 & e | 128), e >>>= 7;
          this.buffer_.push(e);
        }, jspb.BinaryEncoder.prototype.writeSignedVarint32 = function (e) {
          if (goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), 0 <= e) this.writeUnsignedVarint32(e);else {
            for (var t = 0; 9 > t; t++) this.buffer_.push(127 & e | 128), e >>= 7;
            this.buffer_.push(1);
          }
        }, jspb.BinaryEncoder.prototype.writeUnsignedVarint64 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitInt64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
        }, jspb.BinaryEncoder.prototype.writeSignedVarint64 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
        }, jspb.BinaryEncoder.prototype.writeZigzagVarint32 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.writeUnsignedVarint32((e << 1 ^ e >> 31) >>> 0);
        }, jspb.BinaryEncoder.prototype.writeZigzagVarint64 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitZigzag64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
        }, jspb.BinaryEncoder.prototype.writeZigzagVarint64String = function (e) {
          this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(e));
        }, jspb.BinaryEncoder.prototype.writeZigzagVarintHash64 = function (e) {
          var t = this;
          jspb.utils.splitHash64(e), jspb.utils.toZigzag64(jspb.utils.split64Low, jspb.utils.split64High, function (e2, r) {
            t.writeSplitVarint64(e2 >>> 0, r >>> 0);
          });
        }, jspb.BinaryEncoder.prototype.writeUint8 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && 256 > e), this.buffer_.push(e >>> 0 & 255);
        }, jspb.BinaryEncoder.prototype.writeUint16 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && 65536 > e), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255);
        }, jspb.BinaryEncoder.prototype.writeUint32 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255), this.buffer_.push(e >>> 16 & 255), this.buffer_.push(e >>> 24 & 255);
        }, jspb.BinaryEncoder.prototype.writeUint64 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitUint64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
        }, jspb.BinaryEncoder.prototype.writeInt8 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(-128 <= e && 128 > e), this.buffer_.push(e >>> 0 & 255);
        }, jspb.BinaryEncoder.prototype.writeInt16 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(-32768 <= e && 32768 > e), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255);
        }, jspb.BinaryEncoder.prototype.writeInt32 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255), this.buffer_.push(e >>> 16 & 255), this.buffer_.push(e >>> 24 & 255);
        }, jspb.BinaryEncoder.prototype.writeInt64 = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(e), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
        }, jspb.BinaryEncoder.prototype.writeInt64String = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(+e >= -jspb.BinaryConstants.TWO_TO_63 && +e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(e)), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
        }, jspb.BinaryEncoder.prototype.writeFloat = function (e) {
          goog.asserts.assert(1 / 0 === e || -1 / 0 === e || isNaN(e) || e >= -jspb.BinaryConstants.FLOAT32_MAX && e <= jspb.BinaryConstants.FLOAT32_MAX), jspb.utils.splitFloat32(e), this.writeUint32(jspb.utils.split64Low);
        }, jspb.BinaryEncoder.prototype.writeDouble = function (e) {
          goog.asserts.assert(1 / 0 === e || -1 / 0 === e || isNaN(e) || e >= -jspb.BinaryConstants.FLOAT64_MAX && e <= jspb.BinaryConstants.FLOAT64_MAX), jspb.utils.splitFloat64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
        }, jspb.BinaryEncoder.prototype.writeBool = function (e) {
          goog.asserts.assert("boolean" == typeof e || "number" == typeof e), this.buffer_.push(e ? 1 : 0);
        }, jspb.BinaryEncoder.prototype.writeEnum = function (e) {
          goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32(e);
        }, jspb.BinaryEncoder.prototype.writeBytes = function (e) {
          this.buffer_.push.apply(this.buffer_, e);
        }, jspb.BinaryEncoder.prototype.writeVarintHash64 = function (e) {
          jspb.utils.splitHash64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
        }, jspb.BinaryEncoder.prototype.writeFixedHash64 = function (e) {
          jspb.utils.splitHash64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
        }, jspb.BinaryEncoder.prototype.writeString = function (e) {
          for (var t = this.buffer_.length, r = 0; r < e.length; r++) {
            var n = e.charCodeAt(r);
            if (128 > n) this.buffer_.push(n);else if (2048 > n) this.buffer_.push(n >> 6 | 192), this.buffer_.push(63 & n | 128);else if (65536 > n) if (55296 <= n && 56319 >= n && r + 1 < e.length) {
              var o = e.charCodeAt(r + 1);
              56320 <= o && 57343 >= o && (n = 1024 * (n - 55296) + o - 56320 + 65536, this.buffer_.push(n >> 18 | 240), this.buffer_.push(n >> 12 & 63 | 128), this.buffer_.push(n >> 6 & 63 | 128), this.buffer_.push(63 & n | 128), r++);
            } else this.buffer_.push(n >> 12 | 224), this.buffer_.push(n >> 6 & 63 | 128), this.buffer_.push(63 & n | 128);
          }
          return this.buffer_.length - t;
        }, jspb.BinaryWriter = function () {
          this.blocks_ = [], this.totalLength_ = 0, this.encoder_ = new jspb.BinaryEncoder(), this.bookmarks_ = [];
        }, jspb.BinaryWriter.prototype.appendUint8Array_ = function (e) {
          var t = this.encoder_.end();
          this.blocks_.push(t), this.blocks_.push(e), this.totalLength_ += t.length + e.length;
        }, jspb.BinaryWriter.prototype.beginDelimited_ = function (e) {
          return this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), e = this.encoder_.end(), this.blocks_.push(e), this.totalLength_ += e.length, e.push(this.totalLength_), e;
        }, jspb.BinaryWriter.prototype.endDelimited_ = function (e) {
          var t = e.pop();
          for (t = this.totalLength_ + this.encoder_.length() - t, goog.asserts.assert(0 <= t); 127 < t;) e.push(127 & t | 128), t >>>= 7, this.totalLength_++;
          e.push(t), this.totalLength_++;
        }, jspb.BinaryWriter.prototype.writeSerializedMessage = function (e, t, r) {
          this.appendUint8Array_(e.subarray(t, r));
        }, jspb.BinaryWriter.prototype.maybeWriteSerializedMessage = function (e, t, r) {
          null != e && null != t && null != r && this.writeSerializedMessage(e, t, r);
        }, jspb.BinaryWriter.prototype.reset = function () {
          this.blocks_ = [], this.encoder_.end(), this.totalLength_ = 0, this.bookmarks_ = [];
        }, jspb.BinaryWriter.prototype.getResultBuffer = function () {
          goog.asserts.assert(0 == this.bookmarks_.length);
          for (var e = new Uint8Array(this.totalLength_ + this.encoder_.length()), t = this.blocks_, r = t.length, n = 0, o = 0; o < r; o++) {
            var i = t[o];
            e.set(i, n), n += i.length;
          }
          return t = this.encoder_.end(), e.set(t, n), n += t.length, goog.asserts.assert(n == e.length), this.blocks_ = [e], e;
        }, jspb.BinaryWriter.prototype.getResultBase64String = function (e) {
          return goog.crypt.base64.encodeByteArray(this.getResultBuffer(), e);
        }, jspb.BinaryWriter.prototype.beginSubMessage = function (e) {
          this.bookmarks_.push(this.beginDelimited_(e));
        }, jspb.BinaryWriter.prototype.endSubMessage = function () {
          goog.asserts.assert(0 <= this.bookmarks_.length), this.endDelimited_(this.bookmarks_.pop());
        }, jspb.BinaryWriter.prototype.writeFieldHeader_ = function (e, t) {
          goog.asserts.assert(1 <= e && e == Math.floor(e)), this.encoder_.writeUnsignedVarint32(8 * e + t);
        }, jspb.BinaryWriter.prototype.writeAny = function (e, t, r) {
          var n = jspb.BinaryConstants.FieldType;
          switch (e) {
            case n.DOUBLE:
              this.writeDouble(t, r);
              break;
            case n.FLOAT:
              this.writeFloat(t, r);
              break;
            case n.INT64:
              this.writeInt64(t, r);
              break;
            case n.UINT64:
              this.writeUint64(t, r);
              break;
            case n.INT32:
              this.writeInt32(t, r);
              break;
            case n.FIXED64:
              this.writeFixed64(t, r);
              break;
            case n.FIXED32:
              this.writeFixed32(t, r);
              break;
            case n.BOOL:
              this.writeBool(t, r);
              break;
            case n.STRING:
              this.writeString(t, r);
              break;
            case n.GROUP:
              goog.asserts.fail("Group field type not supported in writeAny()");
              break;
            case n.MESSAGE:
              goog.asserts.fail("Message field type not supported in writeAny()");
              break;
            case n.BYTES:
              this.writeBytes(t, r);
              break;
            case n.UINT32:
              this.writeUint32(t, r);
              break;
            case n.ENUM:
              this.writeEnum(t, r);
              break;
            case n.SFIXED32:
              this.writeSfixed32(t, r);
              break;
            case n.SFIXED64:
              this.writeSfixed64(t, r);
              break;
            case n.SINT32:
              this.writeSint32(t, r);
              break;
            case n.SINT64:
              this.writeSint64(t, r);
              break;
            case n.FHASH64:
              this.writeFixedHash64(t, r);
              break;
            case n.VHASH64:
              this.writeVarintHash64(t, r);
              break;
            default:
              goog.asserts.fail("Invalid field type in writeAny()");
          }
        }, jspb.BinaryWriter.prototype.writeUnsignedVarint32_ = function (e, t) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint32(t));
        }, jspb.BinaryWriter.prototype.writeSignedVarint32_ = function (e, t) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(t));
        }, jspb.BinaryWriter.prototype.writeUnsignedVarint64_ = function (e, t) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint64(t));
        }, jspb.BinaryWriter.prototype.writeSignedVarint64_ = function (e, t) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint64(t));
        }, jspb.BinaryWriter.prototype.writeZigzagVarint32_ = function (e, t) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint32(t));
        }, jspb.BinaryWriter.prototype.writeZigzagVarint64_ = function (e, t) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64(t));
        }, jspb.BinaryWriter.prototype.writeZigzagVarint64String_ = function (e, t) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64String(t));
        }, jspb.BinaryWriter.prototype.writeZigzagVarintHash64_ = function (e, t) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarintHash64(t));
        }, jspb.BinaryWriter.prototype.writeInt32 = function (e, t) {
          null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(e, t));
        }, jspb.BinaryWriter.prototype.writeInt32String = function (e, t) {
          null != t && (t = parseInt(t, 10), goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(e, t));
        }, jspb.BinaryWriter.prototype.writeInt64 = function (e, t) {
          null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_63 && t < jspb.BinaryConstants.TWO_TO_63), this.writeSignedVarint64_(e, t));
        }, jspb.BinaryWriter.prototype.writeInt64String = function (e, t) {
          null != t && (t = jspb.arith.Int64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t.lo, t.hi));
        }, jspb.BinaryWriter.prototype.writeUint32 = function (e, t) {
          null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(e, t));
        }, jspb.BinaryWriter.prototype.writeUint32String = function (e, t) {
          null != t && (t = parseInt(t, 10), goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(e, t));
        }, jspb.BinaryWriter.prototype.writeUint64 = function (e, t) {
          null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_64), this.writeUnsignedVarint64_(e, t));
        }, jspb.BinaryWriter.prototype.writeUint64String = function (e, t) {
          null != t && (t = jspb.arith.UInt64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t.lo, t.hi));
        }, jspb.BinaryWriter.prototype.writeSint32 = function (e, t) {
          null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeZigzagVarint32_(e, t));
        }, jspb.BinaryWriter.prototype.writeSint64 = function (e, t) {
          null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_63 && t < jspb.BinaryConstants.TWO_TO_63), this.writeZigzagVarint64_(e, t));
        }, jspb.BinaryWriter.prototype.writeSintHash64 = function (e, t) {
          null != t && this.writeZigzagVarintHash64_(e, t);
        }, jspb.BinaryWriter.prototype.writeSint64String = function (e, t) {
          null != t && this.writeZigzagVarint64String_(e, t);
        }, jspb.BinaryWriter.prototype.writeFixed32 = function (e, t) {
          null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeUint32(t));
        }, jspb.BinaryWriter.prototype.writeFixed64 = function (e, t) {
          null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_64), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeUint64(t));
        }, jspb.BinaryWriter.prototype.writeFixed64String = function (e, t) {
          null != t && (t = jspb.arith.UInt64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t.lo, t.hi));
        }, jspb.BinaryWriter.prototype.writeSfixed32 = function (e, t) {
          null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeInt32(t));
        }, jspb.BinaryWriter.prototype.writeSfixed64 = function (e, t) {
          null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_63 && t < jspb.BinaryConstants.TWO_TO_63), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeInt64(t));
        }, jspb.BinaryWriter.prototype.writeSfixed64String = function (e, t) {
          null != t && (t = jspb.arith.Int64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t.lo, t.hi));
        }, jspb.BinaryWriter.prototype.writeFloat = function (e, t) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeFloat(t));
        }, jspb.BinaryWriter.prototype.writeDouble = function (e, t) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeDouble(t));
        }, jspb.BinaryWriter.prototype.writeBool = function (e, t) {
          null != t && (goog.asserts.assert("boolean" == typeof t || "number" == typeof t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeBool(t));
        }, jspb.BinaryWriter.prototype.writeEnum = function (e, t) {
          null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(t));
        }, jspb.BinaryWriter.prototype.writeString = function (e, t) {
          null != t && (e = this.beginDelimited_(e), this.encoder_.writeString(t), this.endDelimited_(e));
        }, jspb.BinaryWriter.prototype.writeBytes = function (e, t) {
          null != t && (t = jspb.utils.byteSourceToUint8Array(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(t.length), this.appendUint8Array_(t));
        }, jspb.BinaryWriter.prototype.writeMessage = function (e, t, r) {
          null != t && (e = this.beginDelimited_(e), r(t, this), this.endDelimited_(e));
        }, jspb.BinaryWriter.prototype.writeMessageSet = function (e, t, r) {
          null != t && (this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.START_GROUP), this.writeFieldHeader_(2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(e), e = this.beginDelimited_(3), r(t, this), this.endDelimited_(e), this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.END_GROUP));
        }, jspb.BinaryWriter.prototype.writeGroup = function (e, t, r) {
          null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.START_GROUP), r(t, this), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.END_GROUP));
        }, jspb.BinaryWriter.prototype.writeFixedHash64 = function (e, t) {
          null != t && (goog.asserts.assert(8 == t.length), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeFixedHash64(t));
        }, jspb.BinaryWriter.prototype.writeVarintHash64 = function (e, t) {
          null != t && (goog.asserts.assert(8 == t.length), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeVarintHash64(t));
        }, jspb.BinaryWriter.prototype.writeSplitFixed64 = function (e, t, r) {
          this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t, r);
        }, jspb.BinaryWriter.prototype.writeSplitVarint64 = function (e, t, r) {
          this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t, r);
        }, jspb.BinaryWriter.prototype.writeSplitZigzagVarint64 = function (e, t, r) {
          this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT);
          var n = this.encoder_;
          jspb.utils.toZigzag64(t, r, function (e2, t2) {
            n.writeSplitVarint64(e2 >>> 0, t2 >>> 0);
          });
        }, jspb.BinaryWriter.prototype.writeRepeatedInt32 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeSignedVarint32_(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedInt32String = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeInt32String(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedInt64 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeSignedVarint64_(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64 = function (e, t, r, n) {
          if (null != t) for (var o = 0; o < t.length; o++) this.writeSplitFixed64(e, r(t[o]), n(t[o]));
        }, jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64 = function (e, t, r, n) {
          if (null != t) for (var o = 0; o < t.length; o++) this.writeSplitVarint64(e, r(t[o]), n(t[o]));
        }, jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64 = function (e, t, r, n) {
          if (null != t) for (var o = 0; o < t.length; o++) this.writeSplitZigzagVarint64(e, r(t[o]), n(t[o]));
        }, jspb.BinaryWriter.prototype.writeRepeatedInt64String = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeInt64String(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedUint32 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeUnsignedVarint32_(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedUint32String = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeUint32String(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedUint64 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeUnsignedVarint64_(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedUint64String = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeUint64String(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedSint32 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeZigzagVarint32_(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedSint64 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeZigzagVarint64_(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedSint64String = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeZigzagVarint64String_(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedSintHash64 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeZigzagVarintHash64_(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedFixed32 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeFixed32(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedFixed64 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeFixed64(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedFixed64String = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeFixed64String(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedSfixed32 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeSfixed32(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedSfixed64 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeSfixed64(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedSfixed64String = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeSfixed64String(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedFloat = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeFloat(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedDouble = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeDouble(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedBool = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeBool(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedEnum = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeEnum(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedString = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeString(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedBytes = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeBytes(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedMessage = function (e, t, r) {
          if (null != t) for (var n = 0; n < t.length; n++) {
            var o = this.beginDelimited_(e);
            r(t[n], this), this.endDelimited_(o);
          }
        }, jspb.BinaryWriter.prototype.writeRepeatedGroup = function (e, t, r) {
          if (null != t) for (var n = 0; n < t.length; n++) this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.START_GROUP), r(t[n], this), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.END_GROUP);
        }, jspb.BinaryWriter.prototype.writeRepeatedFixedHash64 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeFixedHash64(e, t[r]);
        }, jspb.BinaryWriter.prototype.writeRepeatedVarintHash64 = function (e, t) {
          if (null != t) for (var r = 0; r < t.length; r++) this.writeVarintHash64(e, t[r]);
        }, jspb.BinaryWriter.prototype.writePackedInt32 = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeSignedVarint32(t[r]);
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedInt32String = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeSignedVarint32(parseInt(t[r], 10));
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedInt64 = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeSignedVarint64(t[r]);
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedSplitFixed64 = function (e, t, r, n) {
          if (null != t) {
            e = this.beginDelimited_(e);
            for (var o = 0; o < t.length; o++) this.encoder_.writeSplitFixed64(r(t[o]), n(t[o]));
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedSplitVarint64 = function (e, t, r, n) {
          if (null != t) {
            e = this.beginDelimited_(e);
            for (var o = 0; o < t.length; o++) this.encoder_.writeSplitVarint64(r(t[o]), n(t[o]));
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64 = function (e, t, r, n) {
          if (null != t) {
            e = this.beginDelimited_(e);
            for (var o = this.encoder_, i = 0; i < t.length; i++) jspb.utils.toZigzag64(r(t[i]), n(t[i]), function (e2, t2) {
              o.writeSplitVarint64(e2 >>> 0, t2 >>> 0);
            });
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedInt64String = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) {
              var n = jspb.arith.Int64.fromString(t[r]);
              this.encoder_.writeSplitVarint64(n.lo, n.hi);
            }
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedUint32 = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeUnsignedVarint32(t[r]);
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedUint32String = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeUnsignedVarint32(parseInt(t[r], 10));
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedUint64 = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeUnsignedVarint64(t[r]);
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedUint64String = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) {
              var n = jspb.arith.UInt64.fromString(t[r]);
              this.encoder_.writeSplitVarint64(n.lo, n.hi);
            }
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedSint32 = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeZigzagVarint32(t[r]);
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedSint64 = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeZigzagVarint64(t[r]);
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedSint64String = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(t[r]));
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedSintHash64 = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeZigzagVarintHash64(t[r]);
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedFixed32 = function (e, t) {
          if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t.length), e = 0; e < t.length; e++) this.encoder_.writeUint32(t[e]);
        }, jspb.BinaryWriter.prototype.writePackedFixed64 = function (e, t) {
          if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeUint64(t[e]);
        }, jspb.BinaryWriter.prototype.writePackedFixed64String = function (e, t) {
          if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) {
            var r = jspb.arith.UInt64.fromString(t[e]);
            this.encoder_.writeSplitFixed64(r.lo, r.hi);
          }
        }, jspb.BinaryWriter.prototype.writePackedSfixed32 = function (e, t) {
          if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t.length), e = 0; e < t.length; e++) this.encoder_.writeInt32(t[e]);
        }, jspb.BinaryWriter.prototype.writePackedSfixed64 = function (e, t) {
          if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeInt64(t[e]);
        }, jspb.BinaryWriter.prototype.writePackedSfixed64String = function (e, t) {
          if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeInt64String(t[e]);
        }, jspb.BinaryWriter.prototype.writePackedFloat = function (e, t) {
          if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t.length), e = 0; e < t.length; e++) this.encoder_.writeFloat(t[e]);
        }, jspb.BinaryWriter.prototype.writePackedDouble = function (e, t) {
          if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeDouble(t[e]);
        }, jspb.BinaryWriter.prototype.writePackedBool = function (e, t) {
          if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(t.length), e = 0; e < t.length; e++) this.encoder_.writeBool(t[e]);
        }, jspb.BinaryWriter.prototype.writePackedEnum = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeEnum(t[r]);
            this.endDelimited_(e);
          }
        }, jspb.BinaryWriter.prototype.writePackedFixedHash64 = function (e, t) {
          if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeFixedHash64(t[e]);
        }, jspb.BinaryWriter.prototype.writePackedVarintHash64 = function (e, t) {
          if (null != t && t.length) {
            e = this.beginDelimited_(e);
            for (var r = 0; r < t.length; r++) this.encoder_.writeVarintHash64(t[r]);
            this.endDelimited_(e);
          }
        }, jspb.Export = {}, exports.Map = jspb.Map, exports.Message = jspb.Message, exports.BinaryReader = jspb.BinaryReader, exports.BinaryWriter = jspb.BinaryWriter, exports.ExtensionFieldInfo = jspb.ExtensionFieldInfo, exports.ExtensionFieldBinaryInfo = jspb.ExtensionFieldBinaryInfo, exports.exportSymbol = goog.exportSymbol, exports.inherits = goog.inherits, exports.object = {
          extend: goog.object.extend
        }, exports.typeOf = goog.typeOf;
      }).call(this, __webpack_require__(6), __webpack_require__(5).Buffer);
    }, function (e, t, r) {
      var _ref3 = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0,
        n = _ref3.AbortController,
        o = _ref3.AbortSignal;
      e.exports = n, e.exports.AbortSignal = o, e.exports.default = n;
    }, function (e, t) {
      var r = function (e2) {
        function t2() {
          this.fetch = false, this.DOMException = e2.DOMException;
        }
        return t2.prototype = e2, new t2();
      }("undefined" != typeof self ? self : this);
      !function (e2) {
        !function (t2) {
          var r2 = ("URLSearchParams" in e2),
            n = "Symbol" in e2 && "iterator" in Symbol,
            o = "FileReader" in e2 && "Blob" in e2 && function () {
              try {
                return new Blob(), true;
              } catch (e3) {
                return false;
              }
            }(),
            i = ("FormData" in e2),
            s = ("ArrayBuffer" in e2);
          if (s) var a2 = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
            l = ArrayBuffer.isView || function (e3) {
              return e3 && a2.indexOf(Object.prototype.toString.call(e3)) > -1;
            };
          function u(e3) {
            if ("string" != typeof e3 && (e3 = String(e3)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e3)) throw new TypeError("Invalid character in header field name");
            return e3.toLowerCase();
          }
          function g(e3) {
            return "string" != typeof e3 && (e3 = String(e3)), e3;
          }
          function c(e3) {
            var t3 = {
              next: function next() {
                var t4 = e3.shift();
                return {
                  done: void 0 === t4,
                  value: t4
                };
              }
            };
            return n && (t3[Symbol.iterator] = function () {
              return t3;
            }), t3;
          }
          function f(e3) {
            this.map = {}, e3 instanceof f ? e3.forEach(function (e4, t3) {
              this.append(t3, e4);
            }, this) : Array.isArray(e3) ? e3.forEach(function (e4) {
              this.append(e4[0], e4[1]);
            }, this) : e3 && Object.getOwnPropertyNames(e3).forEach(function (t3) {
              this.append(t3, e3[t3]);
            }, this);
          }
          function p(e3) {
            if (e3.bodyUsed) return Promise.reject(new TypeError("Already read"));
            e3.bodyUsed = true;
          }
          function h(e3) {
            return new Promise(function (t3, r3) {
              e3.onload = function () {
                t3(e3.result);
              }, e3.onerror = function () {
                r3(e3.error);
              };
            });
          }
          function d(e3) {
            var t3 = new FileReader(),
              r3 = h(t3);
            return t3.readAsArrayBuffer(e3), r3;
          }
          function y(e3) {
            if (e3.slice) return e3.slice(0);
            var t3 = new Uint8Array(e3.byteLength);
            return t3.set(new Uint8Array(e3)), t3.buffer;
          }
          function m() {
            return this.bodyUsed = false, this._initBody = function (e3) {
              var t3;
              this._bodyInit = e3, e3 ? "string" == typeof e3 ? this._bodyText = e3 : o && Blob.prototype.isPrototypeOf(e3) ? this._bodyBlob = e3 : i && FormData.prototype.isPrototypeOf(e3) ? this._bodyFormData = e3 : r2 && URLSearchParams.prototype.isPrototypeOf(e3) ? this._bodyText = e3.toString() : s && o && (t3 = e3) && DataView.prototype.isPrototypeOf(t3) ? (this._bodyArrayBuffer = y(e3.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : s && (ArrayBuffer.prototype.isPrototypeOf(e3) || l(e3)) ? this._bodyArrayBuffer = y(e3) : this._bodyText = e3 = Object.prototype.toString.call(e3) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e3 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r2 && URLSearchParams.prototype.isPrototypeOf(e3) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
            }, o && (this.blob = function () {
              var e3 = p(this);
              if (e3) return e3;
              if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
              if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              if (this._bodyFormData) throw new Error("could not read FormData body as blob");
              return Promise.resolve(new Blob([this._bodyText]));
            }, this.arrayBuffer = function () {
              return this._bodyArrayBuffer ? p(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(d);
            }), this.text = function () {
              var e3,
                t3,
                r3,
                n2 = p(this);
              if (n2) return n2;
              if (this._bodyBlob) return e3 = this._bodyBlob, t3 = new FileReader(), r3 = h(t3), t3.readAsText(e3), r3;
              if (this._bodyArrayBuffer) return Promise.resolve(function (e4) {
                for (var t4 = new Uint8Array(e4), r4 = new Array(t4.length), n3 = 0; n3 < t4.length; n3++) r4[n3] = String.fromCharCode(t4[n3]);
                return r4.join("");
              }(this._bodyArrayBuffer));
              if (this._bodyFormData) throw new Error("could not read FormData body as text");
              return Promise.resolve(this._bodyText);
            }, i && (this.formData = function () {
              return this.text().then(_);
            }), this.json = function () {
              return this.text().then(JSON.parse);
            }, this;
          }
          f.prototype.append = function (e3, t3) {
            e3 = u(e3), t3 = g(t3);
            var r3 = this.map[e3];
            this.map[e3] = r3 ? r3 + ", " + t3 : t3;
          }, f.prototype.delete = function (e3) {
            delete this.map[u(e3)];
          }, f.prototype.get = function (e3) {
            return e3 = u(e3), this.has(e3) ? this.map[e3] : null;
          }, f.prototype.has = function (e3) {
            return this.map.hasOwnProperty(u(e3));
          }, f.prototype.set = function (e3, t3) {
            this.map[u(e3)] = g(t3);
          }, f.prototype.forEach = function (e3, t3) {
            for (var r3 in this.map) this.map.hasOwnProperty(r3) && e3.call(t3, this.map[r3], r3, this);
          }, f.prototype.keys = function () {
            var e3 = [];
            return this.forEach(function (t3, r3) {
              e3.push(r3);
            }), c(e3);
          }, f.prototype.values = function () {
            var e3 = [];
            return this.forEach(function (t3) {
              e3.push(t3);
            }), c(e3);
          }, f.prototype.entries = function () {
            var e3 = [];
            return this.forEach(function (t3, r3) {
              e3.push([r3, t3]);
            }), c(e3);
          }, n && (f.prototype[Symbol.iterator] = f.prototype.entries);
          var b = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
          function v(e3, t3) {
            var r3,
              n2,
              o2 = (t3 = t3 || {}).body;
            if (e3 instanceof v) {
              if (e3.bodyUsed) throw new TypeError("Already read");
              this.url = e3.url, this.credentials = e3.credentials, t3.headers || (this.headers = new f(e3.headers)), this.method = e3.method, this.mode = e3.mode, this.signal = e3.signal, o2 || null == e3._bodyInit || (o2 = e3._bodyInit, e3.bodyUsed = true);
            } else this.url = String(e3);
            if (this.credentials = t3.credentials || this.credentials || "same-origin", !t3.headers && this.headers || (this.headers = new f(t3.headers)), this.method = (r3 = t3.method || this.method || "GET", n2 = r3.toUpperCase(), b.indexOf(n2) > -1 ? n2 : r3), this.mode = t3.mode || this.mode || null, this.signal = t3.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o2) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(o2);
          }
          function _(e3) {
            var t3 = new FormData();
            return e3.trim().split("&").forEach(function (e4) {
              if (e4) {
                var r3 = e4.split("="),
                  n2 = r3.shift().replace(/\+/g, " "),
                  o2 = r3.join("=").replace(/\+/g, " ");
                t3.append(decodeURIComponent(n2), decodeURIComponent(o2));
              }
            }), t3;
          }
          function S(e3, t3) {
            t3 || (t3 = {}), this.type = "default", this.status = void 0 === t3.status ? 200 : t3.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t3 ? t3.statusText : "OK", this.headers = new f(t3.headers), this.url = t3.url || "", this._initBody(e3);
          }
          v.prototype.clone = function () {
            return new v(this, {
              body: this._bodyInit
            });
          }, m.call(v.prototype), m.call(S.prototype), S.prototype.clone = function () {
            return new S(this._bodyInit, {
              status: this.status,
              statusText: this.statusText,
              headers: new f(this.headers),
              url: this.url
            });
          }, S.error = function () {
            var e3 = new S(null, {
              status: 0,
              statusText: ""
            });
            return e3.type = "error", e3;
          };
          var w = [301, 302, 303, 307, 308];
          S.redirect = function (e3, t3) {
            if (-1 === w.indexOf(t3)) throw new RangeError("Invalid status code");
            return new S(null, {
              status: t3,
              headers: {
                location: e3
              }
            });
          }, t2.DOMException = e2.DOMException;
          try {
            new t2.DOMException();
          } catch (e3) {
            t2.DOMException = function (e4, t3) {
              this.message = e4, this.name = t3;
              var r3 = Error(e4);
              this.stack = r3.stack;
            }, t2.DOMException.prototype = Object.create(Error.prototype), t2.DOMException.prototype.constructor = t2.DOMException;
          }
          function E(e3, r3) {
            return new Promise(function (n2, i2) {
              var s2 = new v(e3, r3);
              if (s2.signal && s2.signal.aborted) return i2(new t2.DOMException("Aborted", "AbortError"));
              var a3 = new XMLHttpRequest();
              function l2() {
                a3.abort();
              }
              a3.onload = function () {
                var e4,
                  t3,
                  r4 = {
                    status: a3.status,
                    statusText: a3.statusText,
                    headers: (e4 = a3.getAllResponseHeaders() || "", t3 = new f(), e4.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e5) {
                      var r5 = e5.split(":"),
                        n3 = r5.shift().trim();
                      if (n3) {
                        var o3 = r5.join(":").trim();
                        t3.append(n3, o3);
                      }
                    }), t3)
                  };
                r4.url = "responseURL" in a3 ? a3.responseURL : r4.headers.get("X-Request-URL");
                var o2 = "response" in a3 ? a3.response : a3.responseText;
                n2(new S(o2, r4));
              }, a3.onerror = function () {
                i2(new TypeError("Network request failed"));
              }, a3.ontimeout = function () {
                i2(new TypeError("Network request failed"));
              }, a3.onabort = function () {
                i2(new t2.DOMException("Aborted", "AbortError"));
              }, a3.open(s2.method, s2.url, true), "include" === s2.credentials ? a3.withCredentials = true : "omit" === s2.credentials && (a3.withCredentials = false), "responseType" in a3 && o && (a3.responseType = "blob"), s2.headers.forEach(function (e4, t3) {
                a3.setRequestHeader(t3, e4);
              }), s2.signal && (s2.signal.addEventListener("abort", l2), a3.onreadystatechange = function () {
                4 === a3.readyState && s2.signal.removeEventListener("abort", l2);
              }), a3.send(void 0 === s2._bodyInit ? null : s2._bodyInit);
            });
          }
          E.polyfill = true, e2.fetch || (e2.fetch = E, e2.Headers = f, e2.Request = v, e2.Response = S), t2.Headers = f, t2.Request = v, t2.Response = S, t2.fetch = E;
        }({});
      }(r), delete r.fetch.polyfill, (t = r.fetch).default = r.fetch, t.fetch = r.fetch, t.Headers = r.Headers, t.Request = r.Request, t.Response = r.Response, e.exports = t;
    }, function (e, t, r) {
      (function (t2) {
        var n = r(211),
          o = r(52),
          i = function i(e2, t3, s) {
            return {
              from: i,
              EnvVarError: r(52),
              get: function get(r2) {
                if (!r2) return e2;
                if (arguments.length > 1) throw new o("It looks like you passed more than one argument to env.get(). Since env-var@6.0.0 this is no longer supported. To set a default value use env.get(TARGET).default(DEFAULT)");
                return n(e2, r2, t3 || {}, s || function () {});
              },
              accessors: r(94),
              logger: r(225)(console.log, e2.NODE_ENV)
            };
          };
        e.exports = i(t2.env);
      }).call(this, r(2));
    }, function (e, t, r) {
      var n = r(13),
        o = r(73),
        i = r(3).LEVEL,
        s = e.exports = function () {
          var e2 = this,
            t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          o.call(this, {
            objectMode: true,
            highWaterMark: t2.highWaterMark
          }), this.format = t2.format, this.level = t2.level, this.handleExceptions = t2.handleExceptions, this.silent = t2.silent, t2.log && (this.log = t2.log), t2.logv && (this.logv = t2.logv), t2.close && (this.close = t2.close), this.once("pipe", function (t3) {
            e2.levels = t3.levels, e2.parent = t3;
          }), this.once("unpipe", function (t3) {
            t3 === e2.parent && (e2.parent = null, e2.close && e2.close());
          });
        };
      n.inherits(s, o), s.prototype._write = function (e2, t2, r2) {
        if (this.silent || true === e2.exception && !this.handleExceptions) return r2(null);
        var n2 = this.level || this.parent && this.parent.level;
        if (!n2 || this.levels[n2] >= this.levels[e2[i]]) {
          if (e2 && !this.format) return this.log(e2, r2);
          var o2 = void 0,
            s2 = void 0;
          try {
            s2 = this.format.transform(Object.assign({}, e2), this.format.options);
          } catch (e3) {
            o2 = e3;
          }
          if (o2 || !s2) {
            if (r2(), o2) throw o2;
            return;
          }
          return this.log(s2, r2);
        }
        return r2(null);
      }, s.prototype._writev = function (e2, t2) {
        if (this.logv) {
          var r2 = e2.filter(this._accept, this);
          return r2.length ? this.logv(r2, t2) : t2(null);
        }
        for (var n2 = 0; n2 < e2.length; n2++) if (this._accept(e2[n2])) if (!e2[n2].chunk || this.format) {
          var o2 = void 0,
            i2 = void 0;
          try {
            i2 = this.format.transform(Object.assign({}, e2[n2].chunk), this.format.options);
          } catch (e3) {
            o2 = e3;
          }
          if (o2 || !i2) {
            if (e2[n2].callback(), o2) throw t2(null), o2;
          } else this.log(i2, e2[n2].callback);
        } else this.log(e2[n2].chunk, e2[n2].callback);
        return t2(null);
      }, s.prototype._accept = function (e2) {
        var t2 = e2.chunk;
        if (this.silent) return false;
        var r2 = this.level || this.parent && this.parent.level;
        return !(true !== t2.exception && r2 && !(this.levels[r2] >= this.levels[t2[i]]) || !this.handleExceptions && true === t2.exception);
      }, s.prototype._nop = function () {};
    }, function (e, t, r) {
      (function (t2) {
        var r2 = "object" == typeof performance && performance && "function" == typeof performance.now ? performance : Date,
          n = "function" == typeof AbortController ? AbortController : /*#__PURE__*/function () {
            function _class() {
              _classCallCheck(this, _class);
              this.signal = new s();
            }
            _createClass(_class, [{
              key: "abort",
              value: function abort() {
                this.signal.dispatchEvent("abort");
              }
            }]);
            return _class;
          }(),
          o = "function" == typeof AbortSignal,
          i = "function" == typeof n.AbortSignal,
          s = o ? AbortSignal : i ? n.AbortController : /*#__PURE__*/function () {
            function _class2() {
              _classCallCheck(this, _class2);
              this.aborted = false, this._listeners = [];
            }
            _createClass(_class2, [{
              key: "dispatchEvent",
              value: function dispatchEvent(e2) {
                if ("abort" === e2) {
                  this.aborted = true;
                  var _t3 = {
                    type: e2,
                    target: this
                  };
                  this.onabort(_t3), this._listeners.forEach(function (e3) {
                    return e3(_t3);
                  }, this);
                }
              }
            }, {
              key: "onabort",
              value: function onabort() {}
            }, {
              key: "addEventListener",
              value: function addEventListener(e2, t3) {
                "abort" === e2 && this._listeners.push(t3);
              }
            }, {
              key: "removeEventListener",
              value: function removeEventListener(e2, t3) {
                "abort" === e2 && (this._listeners = this._listeners.filter(function (e3) {
                  return e3 !== t3;
                }));
              }
            }]);
            return _class2;
          }(),
          a2 = /* @__PURE__ */new Set(),
          l = function l(e2, t3) {
            var r3 = "LRU_CACHE_OPTION_".concat(e2);
            c(r3) && f(r3, "".concat(e2, " option"), "options.".concat(t3), m);
          },
          u = function u(e2, t3) {
            var r3 = "LRU_CACHE_METHOD_".concat(e2);
            if (c(r3)) {
              var n2 = m.prototype,
                _Object$getOwnPropert = Object.getOwnPropertyDescriptor(n2, e2),
                o2 = _Object$getOwnPropert.get;
              f(r3, "".concat(e2, " method"), "cache.".concat(t3, "()"), o2);
            }
          },
          g = function g() {
            var _console;
            "object" == typeof t2 && t2 && "function" == typeof t2.emitWarning ? t2.emitWarning.apply(t2, arguments) : (_console = console).error.apply(_console, arguments);
          },
          c = function c(e2) {
            return !a2.has(e2);
          },
          f = function f(e2, t3, r3, n2) {
            a2.add(e2), g("The ".concat(t3, " is deprecated. Please use ").concat(r3, " instead."), "DeprecationWarning", e2, n2);
          },
          p = function p(e2) {
            return e2 && e2 === Math.floor(e2) && e2 > 0 && isFinite(e2);
          },
          h = function h(e2) {
            return p(e2) ? e2 <= Math.pow(2, 8) ? Uint8Array : e2 <= Math.pow(2, 16) ? Uint16Array : e2 <= Math.pow(2, 32) ? Uint32Array : e2 <= Number.MAX_SAFE_INTEGER ? d : null : null;
          };
        var d = /*#__PURE__*/function (_Array) {
          _inherits(d, _Array);
          function d(e2) {
            var _this8;
            _classCallCheck(this, d);
            _this8 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, e2)), _this8.fill(0);
            return _this8;
          }
          return d;
        }(_wrapNativeSuper(Array));
        var y = /*#__PURE__*/function () {
          function y(e2) {
            _classCallCheck(this, y);
            if (0 === e2) return [];
            var t3 = h(e2);
            this.heap = new t3(e2), this.length = 0;
          }
          _createClass(y, [{
            key: "push",
            value: function push(e2) {
              this.heap[this.length++] = e2;
            }
          }, {
            key: "pop",
            value: function pop() {
              return this.heap[--this.length];
            }
          }]);
          return y;
        }();
        var m = /*#__PURE__*/function () {
          function m() {
            var e2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, m);
            var _e2$max = e2.max,
              t3 = _e2$max === void 0 ? 0 : _e2$max,
              r3 = e2.ttl,
              _e2$ttlResolution = e2.ttlResolution,
              n2 = _e2$ttlResolution === void 0 ? 1 : _e2$ttlResolution,
              o2 = e2.ttlAutopurge,
              i2 = e2.updateAgeOnGet,
              s2 = e2.updateAgeOnHas,
              u2 = e2.allowStale,
              f2 = e2.dispose,
              d2 = e2.disposeAfter,
              b = e2.noDisposeOnSet,
              v = e2.noUpdateTTL,
              _e2$maxSize = e2.maxSize,
              _ = _e2$maxSize === void 0 ? 0 : _e2$maxSize,
              _e2$maxEntrySize = e2.maxEntrySize,
              S = _e2$maxEntrySize === void 0 ? 0 : _e2$maxEntrySize,
              w = e2.sizeCalculation,
              E = e2.fetchMethod,
              T = e2.fetchContext,
              R = e2.noDeleteOnFetchRejection,
              A = e2.noDeleteOnStaleGet,
              _ref4 = e2 instanceof m ? {} : e2,
              O = _ref4.length,
              C = _ref4.maxAge,
              I = _ref4.stale;
            if (0 !== t3 && !p(t3)) throw new TypeError("max option must be a nonnegative integer");
            var j = t3 ? h(t3) : Array;
            if (!j) throw new Error("invalid max value: " + t3);
            if (this.max = t3, this.maxSize = _, this.maxEntrySize = S || this.maxSize, this.sizeCalculation = w || O, this.sizeCalculation) {
              if (!this.maxSize && !this.maxEntrySize) throw new TypeError("cannot set sizeCalculation without setting maxSize or maxEntrySize");
              if ("function" != typeof this.sizeCalculation) throw new TypeError("sizeCalculation set to non-function");
            }
            if (this.fetchMethod = E || null, this.fetchMethod && "function" != typeof this.fetchMethod) throw new TypeError("fetchMethod must be a function if specified");
            if (this.fetchContext = T, !this.fetchMethod && void 0 !== T) throw new TypeError("cannot set fetchContext without fetchMethod");
            if (this.keyMap = /* @__PURE__ */new Map(), this.keyList = new Array(t3).fill(null), this.valList = new Array(t3).fill(null), this.next = new j(t3), this.prev = new j(t3), this.head = 0, this.tail = 0, this.free = new y(t3), this.initialFill = 1, this.size = 0, "function" == typeof f2 && (this.dispose = f2), "function" == typeof d2 ? (this.disposeAfter = d2, this.disposed = []) : (this.disposeAfter = null, this.disposed = null), this.noDisposeOnSet = !!b, this.noUpdateTTL = !!v, this.noDeleteOnFetchRejection = !!R, 0 !== this.maxEntrySize) {
              if (0 !== this.maxSize && !p(this.maxSize)) throw new TypeError("maxSize must be a positive integer if specified");
              if (!p(this.maxEntrySize)) throw new TypeError("maxEntrySize must be a positive integer if specified");
              this.initializeSizeTracking();
            }
            if (this.allowStale = !!u2 || !!I, this.noDeleteOnStaleGet = !!A, this.updateAgeOnGet = !!i2, this.updateAgeOnHas = !!s2, this.ttlResolution = p(n2) || 0 === n2 ? n2 : 1, this.ttlAutopurge = !!o2, this.ttl = r3 || C || 0, this.ttl) {
              if (!p(this.ttl)) throw new TypeError("ttl must be a positive integer if specified");
              this.initializeTTLTracking();
            }
            if (0 === this.max && 0 === this.ttl && 0 === this.maxSize) throw new TypeError("At least one of max, maxSize, or ttl is required");
            if (!this.ttlAutopurge && !this.max && !this.maxSize) {
              var e3 = "LRU_CACHE_UNBOUNDED";
              if (c(e3)) {
                a2.add(e3), g("TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.", "UnboundedCacheWarning", e3, m);
              }
            }
            I && l("stale", "allowStale"), C && l("maxAge", "ttl"), O && l("length", "sizeCalculation");
          }
          _createClass(m, [{
            key: "getRemainingTTL",
            value: function getRemainingTTL(e2) {
              return this.has(e2, {
                updateAgeOnHas: false
              }) ? 1 / 0 : 0;
            }
          }, {
            key: "initializeTTLTracking",
            value: function initializeTTLTracking() {
              var _this9 = this;
              this.ttls = new d(this.max), this.starts = new d(this.max), this.setItemTTL = function (e3, t4) {
                var n2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : r2.now();
                if (_this9.starts[e3] = 0 !== t4 ? n2 : 0, _this9.ttls[e3] = t4, 0 !== t4 && _this9.ttlAutopurge) {
                  var r3 = setTimeout(function () {
                    _this9.isStale(e3) && _this9.delete(_this9.keyList[e3]);
                  }, t4 + 1);
                  r3.unref && r3.unref();
                }
              }, this.updateItemAge = function (e3) {
                _this9.starts[e3] = 0 !== _this9.ttls[e3] ? r2.now() : 0;
              };
              var e2 = 0;
              var t3 = function t3() {
                var t4 = r2.now();
                if (_this9.ttlResolution > 0) {
                  e2 = t4;
                  var r3 = setTimeout(function () {
                    return e2 = 0;
                  }, _this9.ttlResolution);
                  r3.unref && r3.unref();
                }
                return t4;
              };
              this.getRemainingTTL = function (r3) {
                var n2 = _this9.keyMap.get(r3);
                return void 0 === n2 ? 0 : 0 === _this9.ttls[n2] || 0 === _this9.starts[n2] ? 1 / 0 : _this9.starts[n2] + _this9.ttls[n2] - (e2 || t3());
              }, this.isStale = function (r3) {
                return 0 !== _this9.ttls[r3] && 0 !== _this9.starts[r3] && (e2 || t3()) - _this9.starts[r3] > _this9.ttls[r3];
              };
            }
          }, {
            key: "updateItemAge",
            value: function updateItemAge(e2) {}
          }, {
            key: "setItemTTL",
            value: function setItemTTL(e2, t3, r3) {}
          }, {
            key: "isStale",
            value: function isStale(e2) {
              return false;
            }
          }, {
            key: "initializeSizeTracking",
            value: function initializeSizeTracking() {
              var _this10 = this;
              this.calculatedSize = 0, this.sizes = new d(this.max), this.removeItemSize = function (e2) {
                _this10.calculatedSize -= _this10.sizes[e2], _this10.sizes[e2] = 0;
              }, this.requireSize = function (e2, t3, r3, n2) {
                if (!p(r3)) {
                  if (!n2) throw new TypeError("invalid size value (must be positive integer)");
                  if ("function" != typeof n2) throw new TypeError("sizeCalculation must be a function");
                  if (r3 = n2(t3, e2), !p(r3)) throw new TypeError("sizeCalculation return invalid (expect positive integer)");
                }
                return r3;
              }, this.addItemSize = function (e2, t3) {
                _this10.sizes[e2] = t3;
                var r3 = _this10.maxSize - _this10.sizes[e2];
                for (; _this10.calculatedSize > r3;) _this10.evict(true);
                _this10.calculatedSize += _this10.sizes[e2];
              };
            }
          }, {
            key: "removeItemSize",
            value: function removeItemSize(e2) {}
          }, {
            key: "addItemSize",
            value: function addItemSize(e2, t3) {}
          }, {
            key: "requireSize",
            value: function requireSize(e2, t3, r3, n2) {
              if (r3 || n2) throw new TypeError("cannot set size without setting maxSize or maxEntrySize on cache");
            }
          }, {
            key: "indexes",
            value: function indexes() {
              var _this11 = this;
              var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref5$allowStale = _ref5.allowStale,
                e2 = _ref5$allowStale === void 0 ? this.allowStale : _ref5$allowStale;
              return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                var _t4;
                return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      if (!_this11.size) {
                        _context8.next = 13;
                        break;
                      }
                      _t4 = _this11.tail;
                    case 2:
                      _context8.t0 = _this11.isValidIndex(_t4);
                      if (!_context8.t0) {
                        _context8.next = 9;
                        break;
                      }
                      _context8.t1 = !e2 && _this11.isStale(_t4);
                      if (_context8.t1) {
                        _context8.next = 8;
                        break;
                      }
                      _context8.next = 8;
                      return _t4;
                    case 8:
                      _context8.t0 = _t4 !== _this11.head;
                    case 9:
                      if (!_context8.t0) {
                        _context8.next = 13;
                        break;
                      }
                      _t4 = _this11.prev[_t4];
                    case 11:
                      _context8.next = 2;
                      break;
                    case 13:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              })();
            }
          }, {
            key: "rindexes",
            value: function rindexes() {
              var _this12 = this;
              var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref6$allowStale = _ref6.allowStale,
                e2 = _ref6$allowStale === void 0 ? this.allowStale : _ref6$allowStale;
              return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                var _t5;
                return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      if (!_this12.size) {
                        _context9.next = 13;
                        break;
                      }
                      _t5 = _this12.head;
                    case 2:
                      _context9.t0 = _this12.isValidIndex(_t5);
                      if (!_context9.t0) {
                        _context9.next = 9;
                        break;
                      }
                      _context9.t1 = !e2 && _this12.isStale(_t5);
                      if (_context9.t1) {
                        _context9.next = 8;
                        break;
                      }
                      _context9.next = 8;
                      return _t5;
                    case 8:
                      _context9.t0 = _t5 !== _this12.tail;
                    case 9:
                      if (!_context9.t0) {
                        _context9.next = 13;
                        break;
                      }
                      _t5 = _this12.next[_t5];
                    case 11:
                      _context9.next = 2;
                      break;
                    case 13:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              })();
            }
          }, {
            key: "isValidIndex",
            value: function isValidIndex(e2) {
              return this.keyMap.get(this.keyList[e2]) === e2;
            }
          }, {
            key: "entries",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function entries() {
              var _iterator, _step, e2;
              return _regeneratorRuntime().wrap(function entries$(_context10) {
                while (1) switch (_context10.prev = _context10.next) {
                  case 0:
                    _iterator = _createForOfIteratorHelper(this.indexes());
                    _context10.prev = 1;
                    _iterator.s();
                  case 3:
                    if ((_step = _iterator.n()).done) {
                      _context10.next = 9;
                      break;
                    }
                    e2 = _step.value;
                    _context10.next = 7;
                    return [this.keyList[e2], this.valList[e2]];
                  case 7:
                    _context10.next = 3;
                    break;
                  case 9:
                    _context10.next = 14;
                    break;
                  case 11:
                    _context10.prev = 11;
                    _context10.t0 = _context10["catch"](1);
                    _iterator.e(_context10.t0);
                  case 14:
                    _context10.prev = 14;
                    _iterator.f();
                    return _context10.finish(14);
                  case 17:
                  case "end":
                    return _context10.stop();
                }
              }, entries, this, [[1, 11, 14, 17]]);
            })
          }, {
            key: "rentries",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function rentries() {
              var _iterator2, _step2, e2;
              return _regeneratorRuntime().wrap(function rentries$(_context11) {
                while (1) switch (_context11.prev = _context11.next) {
                  case 0:
                    _iterator2 = _createForOfIteratorHelper(this.rindexes());
                    _context11.prev = 1;
                    _iterator2.s();
                  case 3:
                    if ((_step2 = _iterator2.n()).done) {
                      _context11.next = 9;
                      break;
                    }
                    e2 = _step2.value;
                    _context11.next = 7;
                    return [this.keyList[e2], this.valList[e2]];
                  case 7:
                    _context11.next = 3;
                    break;
                  case 9:
                    _context11.next = 14;
                    break;
                  case 11:
                    _context11.prev = 11;
                    _context11.t0 = _context11["catch"](1);
                    _iterator2.e(_context11.t0);
                  case 14:
                    _context11.prev = 14;
                    _iterator2.f();
                    return _context11.finish(14);
                  case 17:
                  case "end":
                    return _context11.stop();
                }
              }, rentries, this, [[1, 11, 14, 17]]);
            })
          }, {
            key: "keys",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function keys() {
              var _iterator3, _step3, e2;
              return _regeneratorRuntime().wrap(function keys$(_context12) {
                while (1) switch (_context12.prev = _context12.next) {
                  case 0:
                    _iterator3 = _createForOfIteratorHelper(this.indexes());
                    _context12.prev = 1;
                    _iterator3.s();
                  case 3:
                    if ((_step3 = _iterator3.n()).done) {
                      _context12.next = 9;
                      break;
                    }
                    e2 = _step3.value;
                    _context12.next = 7;
                    return this.keyList[e2];
                  case 7:
                    _context12.next = 3;
                    break;
                  case 9:
                    _context12.next = 14;
                    break;
                  case 11:
                    _context12.prev = 11;
                    _context12.t0 = _context12["catch"](1);
                    _iterator3.e(_context12.t0);
                  case 14:
                    _context12.prev = 14;
                    _iterator3.f();
                    return _context12.finish(14);
                  case 17:
                  case "end":
                    return _context12.stop();
                }
              }, keys, this, [[1, 11, 14, 17]]);
            })
          }, {
            key: "rkeys",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function rkeys() {
              var _iterator4, _step4, e2;
              return _regeneratorRuntime().wrap(function rkeys$(_context13) {
                while (1) switch (_context13.prev = _context13.next) {
                  case 0:
                    _iterator4 = _createForOfIteratorHelper(this.rindexes());
                    _context13.prev = 1;
                    _iterator4.s();
                  case 3:
                    if ((_step4 = _iterator4.n()).done) {
                      _context13.next = 9;
                      break;
                    }
                    e2 = _step4.value;
                    _context13.next = 7;
                    return this.keyList[e2];
                  case 7:
                    _context13.next = 3;
                    break;
                  case 9:
                    _context13.next = 14;
                    break;
                  case 11:
                    _context13.prev = 11;
                    _context13.t0 = _context13["catch"](1);
                    _iterator4.e(_context13.t0);
                  case 14:
                    _context13.prev = 14;
                    _iterator4.f();
                    return _context13.finish(14);
                  case 17:
                  case "end":
                    return _context13.stop();
                }
              }, rkeys, this, [[1, 11, 14, 17]]);
            })
          }, {
            key: "values",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function values() {
              var _iterator5, _step5, e2;
              return _regeneratorRuntime().wrap(function values$(_context14) {
                while (1) switch (_context14.prev = _context14.next) {
                  case 0:
                    _iterator5 = _createForOfIteratorHelper(this.indexes());
                    _context14.prev = 1;
                    _iterator5.s();
                  case 3:
                    if ((_step5 = _iterator5.n()).done) {
                      _context14.next = 9;
                      break;
                    }
                    e2 = _step5.value;
                    _context14.next = 7;
                    return this.valList[e2];
                  case 7:
                    _context14.next = 3;
                    break;
                  case 9:
                    _context14.next = 14;
                    break;
                  case 11:
                    _context14.prev = 11;
                    _context14.t0 = _context14["catch"](1);
                    _iterator5.e(_context14.t0);
                  case 14:
                    _context14.prev = 14;
                    _iterator5.f();
                    return _context14.finish(14);
                  case 17:
                  case "end":
                    return _context14.stop();
                }
              }, values, this, [[1, 11, 14, 17]]);
            })
          }, {
            key: "rvalues",
            value: /*#__PURE__*/_regeneratorRuntime().mark(function rvalues() {
              var _iterator6, _step6, e2;
              return _regeneratorRuntime().wrap(function rvalues$(_context15) {
                while (1) switch (_context15.prev = _context15.next) {
                  case 0:
                    _iterator6 = _createForOfIteratorHelper(this.rindexes());
                    _context15.prev = 1;
                    _iterator6.s();
                  case 3:
                    if ((_step6 = _iterator6.n()).done) {
                      _context15.next = 9;
                      break;
                    }
                    e2 = _step6.value;
                    _context15.next = 7;
                    return this.valList[e2];
                  case 7:
                    _context15.next = 3;
                    break;
                  case 9:
                    _context15.next = 14;
                    break;
                  case 11:
                    _context15.prev = 11;
                    _context15.t0 = _context15["catch"](1);
                    _iterator6.e(_context15.t0);
                  case 14:
                    _context15.prev = 14;
                    _iterator6.f();
                    return _context15.finish(14);
                  case 17:
                  case "end":
                    return _context15.stop();
                }
              }, rvalues, this, [[1, 11, 14, 17]]);
            })
          }, {
            key: Symbol.iterator,
            value: function value() {
              return this.entries();
            }
          }, {
            key: "find",
            value: function find(e2) {
              var t3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var _iterator7 = _createForOfIteratorHelper(this.indexes()),
                _step7;
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var r3 = _step7.value;
                  if (e2(this.valList[r3], this.keyList[r3], this)) return this.get(this.keyList[r3], t3);
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
            }
          }, {
            key: "forEach",
            value: function forEach(e2) {
              var t3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
              var _iterator8 = _createForOfIteratorHelper(this.indexes()),
                _step8;
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var r3 = _step8.value;
                  e2.call(t3, this.valList[r3], this.keyList[r3], this);
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
            }
          }, {
            key: "rforEach",
            value: function rforEach(e2) {
              var t3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
              var _iterator9 = _createForOfIteratorHelper(this.rindexes()),
                _step9;
              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var r3 = _step9.value;
                  e2.call(t3, this.valList[r3], this.keyList[r3], this);
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
            }
          }, {
            key: "purgeStale",
            value: function purgeStale() {
              var e2 = false;
              var _iterator10 = _createForOfIteratorHelper(this.rindexes({
                  allowStale: true
                })),
                _step10;
              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var _t6 = _step10.value;
                  this.isStale(_t6) && (this.delete(this.keyList[_t6]), e2 = true);
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }
              return e2;
            }
          }, {
            key: "dump",
            value: function dump() {
              var e2 = [];
              var _iterator11 = _createForOfIteratorHelper(this.indexes({
                  allowStale: true
                })),
                _step11;
              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  var _t7 = _step11.value;
                  var n2 = this.keyList[_t7],
                    o2 = this.valList[_t7],
                    i2 = {
                      value: this.isBackgroundFetch(o2) ? o2.__staleWhileFetching : o2
                    };
                  if (this.ttls) {
                    i2.ttl = this.ttls[_t7];
                    var e3 = r2.now() - this.starts[_t7];
                    i2.start = Math.floor(Date.now() - e3);
                  }
                  this.sizes && (i2.size = this.sizes[_t7]), e2.unshift([n2, i2]);
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
              return e2;
            }
          }, {
            key: "load",
            value: function load(e2) {
              this.clear();
              var _iterator12 = _createForOfIteratorHelper(e2),
                _step12;
              try {
                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                  var _step12$value = _slicedToArray(_step12.value, 2),
                    _t8 = _step12$value[0],
                    n2 = _step12$value[1];
                  if (n2.start) {
                    var e3 = Date.now() - n2.start;
                    n2.start = r2.now() - e3;
                  }
                  this.set(_t8, n2.value, n2);
                }
              } catch (err) {
                _iterator12.e(err);
              } finally {
                _iterator12.f();
              }
            }
          }, {
            key: "dispose",
            value: function dispose(e2, t3, r3) {}
          }, {
            key: "set",
            value: function set(e2, t3) {
              var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref7$ttl = _ref7.ttl,
                r3 = _ref7$ttl === void 0 ? this.ttl : _ref7$ttl,
                n2 = _ref7.start,
                _ref7$noDisposeOnSet = _ref7.noDisposeOnSet,
                o2 = _ref7$noDisposeOnSet === void 0 ? this.noDisposeOnSet : _ref7$noDisposeOnSet,
                _ref7$size = _ref7.size,
                i2 = _ref7$size === void 0 ? 0 : _ref7$size,
                _ref7$sizeCalculation = _ref7.sizeCalculation,
                s2 = _ref7$sizeCalculation === void 0 ? this.sizeCalculation : _ref7$sizeCalculation,
                _ref7$noUpdateTTL = _ref7.noUpdateTTL,
                a3 = _ref7$noUpdateTTL === void 0 ? this.noUpdateTTL : _ref7$noUpdateTTL;
              if (i2 = this.requireSize(e2, t3, i2, s2), this.maxEntrySize && i2 > this.maxEntrySize) return this;
              var l2 = 0 === this.size ? void 0 : this.keyMap.get(e2);
              if (void 0 === l2) l2 = this.newIndex(), this.keyList[l2] = e2, this.valList[l2] = t3, this.keyMap.set(e2, l2), this.next[this.tail] = l2, this.prev[l2] = this.tail, this.tail = l2, this.size++, this.addItemSize(l2, i2), a3 = false;else {
                var r4 = this.valList[l2];
                t3 !== r4 && (this.isBackgroundFetch(r4) ? r4.__abortController.abort() : o2 || (this.dispose(r4, e2, "set"), this.disposeAfter && this.disposed.push([r4, e2, "set"])), this.removeItemSize(l2), this.valList[l2] = t3, this.addItemSize(l2, i2)), this.moveToTail(l2);
              }
              if (0 === r3 || 0 !== this.ttl || this.ttls || this.initializeTTLTracking(), a3 || this.setItemTTL(l2, r3, n2), this.disposeAfter) for (; this.disposed.length;) this.disposeAfter.apply(this, _toConsumableArray(this.disposed.shift()));
              return this;
            }
          }, {
            key: "newIndex",
            value: function newIndex() {
              return 0 === this.size ? this.tail : this.size === this.max && 0 !== this.max ? this.evict(false) : 0 !== this.free.length ? this.free.pop() : this.initialFill++;
            }
          }, {
            key: "pop",
            value: function pop() {
              if (this.size) {
                var e2 = this.valList[this.head];
                return this.evict(true), e2;
              }
            }
          }, {
            key: "evict",
            value: function evict(e2) {
              var t3 = this.head,
                r3 = this.keyList[t3],
                n2 = this.valList[t3];
              return this.isBackgroundFetch(n2) ? n2.__abortController.abort() : (this.dispose(n2, r3, "evict"), this.disposeAfter && this.disposed.push([n2, r3, "evict"])), this.removeItemSize(t3), e2 && (this.keyList[t3] = null, this.valList[t3] = null, this.free.push(t3)), this.head = this.next[t3], this.keyMap.delete(r3), this.size--, t3;
            }
          }, {
            key: "has",
            value: function has(e2) {
              var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref8$updateAgeOnHas = _ref8.updateAgeOnHas,
                t3 = _ref8$updateAgeOnHas === void 0 ? this.updateAgeOnHas : _ref8$updateAgeOnHas;
              var r3 = this.keyMap.get(e2);
              return void 0 !== r3 && !this.isStale(r3) && (t3 && this.updateItemAge(r3), true);
            }
          }, {
            key: "peek",
            value: function peek(e2) {
              var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref9$allowStale = _ref9.allowStale,
                t3 = _ref9$allowStale === void 0 ? this.allowStale : _ref9$allowStale;
              var r3 = this.keyMap.get(e2);
              if (void 0 !== r3 && (t3 || !this.isStale(r3))) {
                var e3 = this.valList[r3];
                return this.isBackgroundFetch(e3) ? e3.__staleWhileFetching : e3;
              }
            }
          }, {
            key: "backgroundFetch",
            value: function backgroundFetch(e2, t3, r3, o2) {
              var _this13 = this;
              var i2 = void 0 === t3 ? void 0 : this.valList[t3];
              if (this.isBackgroundFetch(i2)) return i2;
              var s2 = new n(),
                a3 = {
                  signal: s2.signal,
                  options: r3,
                  context: o2
                },
                l2 = new Promise(function (t4) {
                  return t4(_this13.fetchMethod(e2, i2, a3));
                }).then(function (t4) {
                  return s2.signal.aborted || _this13.set(e2, t4, a3.options), t4;
                }, function (n2) {
                  if (_this13.valList[t3] === l2) {
                    !r3.noDeleteOnFetchRejection || void 0 === l2.__staleWhileFetching ? _this13.delete(e2) : _this13.valList[t3] = l2.__staleWhileFetching;
                  }
                  if (l2.__returned === l2) throw n2;
                });
              return l2.__abortController = s2, l2.__staleWhileFetching = i2, l2.__returned = null, void 0 === t3 ? (this.set(e2, l2, a3.options), t3 = this.keyMap.get(e2)) : this.valList[t3] = l2, l2;
            }
          }, {
            key: "isBackgroundFetch",
            value: function isBackgroundFetch(e2) {
              return e2 && "object" == typeof e2 && "function" == typeof e2.then && Object.prototype.hasOwnProperty.call(e2, "__staleWhileFetching") && Object.prototype.hasOwnProperty.call(e2, "__returned") && (e2.__returned === e2 || null === e2.__returned);
            }
          }, {
            key: "fetch",
            value: function () {
              var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e2) {
                var _ref10,
                  _ref10$allowStale,
                  t3,
                  _ref10$updateAgeOnGet,
                  r3,
                  _ref10$noDeleteOnStal,
                  n2,
                  _ref10$ttl,
                  o2,
                  _ref10$noDisposeOnSet,
                  i2,
                  _ref10$size,
                  s2,
                  _ref10$sizeCalculatio,
                  a3,
                  _ref10$noUpdateTTL,
                  l2,
                  _ref10$noDeleteOnFetc,
                  u2,
                  _ref10$fetchContext,
                  g2,
                  _ref10$forceRefresh,
                  c2,
                  f2,
                  p2,
                  t4,
                  n3,
                  o3,
                  _args16 = arguments;
                return _regeneratorRuntime().wrap(function _callee10$(_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      _ref10 = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : {}, _ref10$allowStale = _ref10.allowStale, t3 = _ref10$allowStale === void 0 ? this.allowStale : _ref10$allowStale, _ref10$updateAgeOnGet = _ref10.updateAgeOnGet, r3 = _ref10$updateAgeOnGet === void 0 ? this.updateAgeOnGet : _ref10$updateAgeOnGet, _ref10$noDeleteOnStal = _ref10.noDeleteOnStaleGet, n2 = _ref10$noDeleteOnStal === void 0 ? this.noDeleteOnStaleGet : _ref10$noDeleteOnStal, _ref10$ttl = _ref10.ttl, o2 = _ref10$ttl === void 0 ? this.ttl : _ref10$ttl, _ref10$noDisposeOnSet = _ref10.noDisposeOnSet, i2 = _ref10$noDisposeOnSet === void 0 ? this.noDisposeOnSet : _ref10$noDisposeOnSet, _ref10$size = _ref10.size, s2 = _ref10$size === void 0 ? 0 : _ref10$size, _ref10$sizeCalculatio = _ref10.sizeCalculation, a3 = _ref10$sizeCalculatio === void 0 ? this.sizeCalculation : _ref10$sizeCalculatio, _ref10$noUpdateTTL = _ref10.noUpdateTTL, l2 = _ref10$noUpdateTTL === void 0 ? this.noUpdateTTL : _ref10$noUpdateTTL, _ref10$noDeleteOnFetc = _ref10.noDeleteOnFetchRejection, u2 = _ref10$noDeleteOnFetc === void 0 ? this.noDeleteOnFetchRejection : _ref10$noDeleteOnFetc, _ref10$fetchContext = _ref10.fetchContext, g2 = _ref10$fetchContext === void 0 ? this.fetchContext : _ref10$fetchContext, _ref10$forceRefresh = _ref10.forceRefresh, c2 = _ref10$forceRefresh === void 0 ? false : _ref10$forceRefresh;
                      if (this.fetchMethod) {
                        _context16.next = 3;
                        break;
                      }
                      return _context16.abrupt("return", this.get(e2, {
                        allowStale: t3,
                        updateAgeOnGet: r3,
                        noDeleteOnStaleGet: n2
                      }));
                    case 3:
                      f2 = {
                        allowStale: t3,
                        updateAgeOnGet: r3,
                        noDeleteOnStaleGet: n2,
                        ttl: o2,
                        noDisposeOnSet: i2,
                        size: s2,
                        sizeCalculation: a3,
                        noUpdateTTL: l2,
                        noDeleteOnFetchRejection: u2
                      };
                      p2 = this.keyMap.get(e2);
                      if (!(void 0 === p2)) {
                        _context16.next = 8;
                        break;
                      }
                      t4 = this.backgroundFetch(e2, p2, f2, g2);
                      return _context16.abrupt("return", t4.__returned = t4);
                    case 8:
                      n3 = this.valList[p2];
                      if (!this.isBackgroundFetch(n3)) {
                        _context16.next = 11;
                        break;
                      }
                      return _context16.abrupt("return", t3 && void 0 !== n3.__staleWhileFetching ? n3.__staleWhileFetching : n3.__returned = n3);
                    case 11:
                      if (!(!c2 && !this.isStale(p2))) {
                        _context16.next = 13;
                        break;
                      }
                      return _context16.abrupt("return", (this.moveToTail(p2), r3 && this.updateItemAge(p2), n3));
                    case 13:
                      o3 = this.backgroundFetch(e2, p2, f2, g2);
                      return _context16.abrupt("return", t3 && void 0 !== o3.__staleWhileFetching ? o3.__staleWhileFetching : o3.__returned = o3);
                    case 15:
                    case "end":
                      return _context16.stop();
                  }
                }, _callee10, this);
              }));
              function fetch(_x) {
                return _fetch.apply(this, arguments);
              }
              return fetch;
            }()
          }, {
            key: "get",
            value: function get(e2) {
              var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref11$allowStale = _ref11.allowStale,
                t3 = _ref11$allowStale === void 0 ? this.allowStale : _ref11$allowStale,
                _ref11$updateAgeOnGet = _ref11.updateAgeOnGet,
                r3 = _ref11$updateAgeOnGet === void 0 ? this.updateAgeOnGet : _ref11$updateAgeOnGet,
                _ref11$noDeleteOnStal = _ref11.noDeleteOnStaleGet,
                n2 = _ref11$noDeleteOnStal === void 0 ? this.noDeleteOnStaleGet : _ref11$noDeleteOnStal;
              var o2 = this.keyMap.get(e2);
              if (void 0 !== o2) {
                var i2 = this.valList[o2],
                  s2 = this.isBackgroundFetch(i2);
                if (this.isStale(o2)) return s2 ? t3 ? i2.__staleWhileFetching : void 0 : (n2 || this.delete(e2), t3 ? i2 : void 0);
                if (s2) return;
                return this.moveToTail(o2), r3 && this.updateItemAge(o2), i2;
              }
            }
          }, {
            key: "connect",
            value: function connect(e2, t3) {
              this.prev[t3] = e2, this.next[e2] = t3;
            }
          }, {
            key: "moveToTail",
            value: function moveToTail(e2) {
              e2 !== this.tail && (e2 === this.head ? this.head = this.next[e2] : this.connect(this.prev[e2], this.next[e2]), this.connect(this.tail, e2), this.tail = e2);
            }
          }, {
            key: "delete",
            value: function _delete(e2) {
              var t3 = false;
              if (0 !== this.size) {
                var r3 = this.keyMap.get(e2);
                if (void 0 !== r3) if (t3 = true, 1 === this.size) this.clear();else {
                  this.removeItemSize(r3);
                  var t4 = this.valList[r3];
                  this.isBackgroundFetch(t4) ? t4.__abortController.abort() : (this.dispose(t4, e2, "delete"), this.disposeAfter && this.disposed.push([t4, e2, "delete"])), this.keyMap.delete(e2), this.keyList[r3] = null, this.valList[r3] = null, r3 === this.tail ? this.tail = this.prev[r3] : r3 === this.head ? this.head = this.next[r3] : (this.next[this.prev[r3]] = this.next[r3], this.prev[this.next[r3]] = this.prev[r3]), this.size--, this.free.push(r3);
                }
              }
              if (this.disposed) for (; this.disposed.length;) this.disposeAfter.apply(this, _toConsumableArray(this.disposed.shift()));
              return t3;
            }
          }, {
            key: "clear",
            value: function clear() {
              var _iterator13 = _createForOfIteratorHelper(this.rindexes({
                  allowStale: true
                })),
                _step13;
              try {
                for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                  var e2 = _step13.value;
                  var _t9 = this.valList[e2];
                  if (this.isBackgroundFetch(_t9)) _t9.__abortController.abort();else {
                    var r3 = this.keyList[e2];
                    this.dispose(_t9, r3, "delete"), this.disposeAfter && this.disposed.push([_t9, r3, "delete"]);
                  }
                }
              } catch (err) {
                _iterator13.e(err);
              } finally {
                _iterator13.f();
              }
              if (this.keyMap.clear(), this.valList.fill(null), this.keyList.fill(null), this.ttls && (this.ttls.fill(0), this.starts.fill(0)), this.sizes && this.sizes.fill(0), this.head = 0, this.tail = 0, this.initialFill = 1, this.free.length = 0, this.calculatedSize = 0, this.size = 0, this.disposed) for (; this.disposed.length;) this.disposeAfter.apply(this, _toConsumableArray(this.disposed.shift()));
            }
          }, {
            key: "prune",
            get: function get() {
              return u("prune", "purgeStale"), this.purgeStale;
            }
          }, {
            key: "del",
            get: function get() {
              return u("del", "delete"), this.delete;
            }
          }, {
            key: "reset",
            get: function get() {
              return u("reset", "clear"), this.clear;
            }
          }, {
            key: "length",
            get: function get() {
              return function (e2, t3) {
                var r3 = "LRU_CACHE_PROPERTY_".concat(e2);
                if (c(r3)) {
                  var n2 = m.prototype,
                    _Object$getOwnPropert2 = Object.getOwnPropertyDescriptor(n2, e2),
                    o2 = _Object$getOwnPropert2.get;
                  f(r3, "".concat(e2, " property"), "cache.".concat(t3), o2);
                }
              }("length", "size"), this.size;
            }
          }], [{
            key: "AbortController",
            get: function get() {
              return n;
            }
          }, {
            key: "AbortSignal",
            get: function get() {
              return s;
            }
          }]);
          return m;
        }();
        e.exports = m;
      }).call(this, r(2));
    }, function (e, t, r) {
      var n = r(41).Colorizer;
      e.exports = function (e2) {
        return n.addColors(e2.colors || e2), e2;
      };
    }, function (e, t, r) {
      var n = {};
      e.exports = n, n.themes = {};
      var o = r(13),
        i = n.styles = r(109),
        s = Object.defineProperties,
        a2 = new RegExp(/[\r\n]+/g);
      n.supportsColor = r(110).supportsColor, void 0 === n.enabled && (n.enabled = false !== n.supportsColor()), n.enable = function () {
        n.enabled = true;
      }, n.disable = function () {
        n.enabled = false;
      }, n.stripColors = n.strip = function (e2) {
        return ("" + e2).replace(/\x1B\[\d+m/g, "");
      };
      n.stylize = function (e2, t2) {
        return n.enabled ? i[t2].open + e2 + i[t2].close : e2 + "";
      };
      var l = /[|\\{}()[\]^$+*?.]/g;
      function u(e2) {
        var t2 = function e3() {
          return p.apply(e3, arguments);
        };
        return t2._styles = e2, t2.__proto__ = f, t2;
      }
      var g,
        c = (g = {}, i.grey = i.gray, Object.keys(i).forEach(function (e2) {
          i[e2].closeRe = new RegExp(function (e3) {
            if ("string" != typeof e3) throw new TypeError("Expected a string");
            return e3.replace(l, "\\$&");
          }(i[e2].close), "g"), g[e2] = {
            get: function get() {
              return u(this._styles.concat(e2));
            }
          };
        }), g),
        f = s(function () {}, c);
      function p() {
        var e2 = Array.prototype.slice.call(arguments),
          t2 = e2.map(function (e3) {
            return void 0 !== e3 && e3.constructor === String ? e3 : o.inspect(e3);
          }).join(" ");
        if (!n.enabled || !t2) return t2;
        for (var r2 = -1 != t2.indexOf("\n"), s2 = this._styles, l2 = s2.length; l2--;) {
          var u2 = i[s2[l2]];
          t2 = u2.open + t2.replace(u2.closeRe, u2.open) + u2.close, r2 && (t2 = t2.replace(a2, function (e3) {
            return u2.close + e3 + u2.open;
          }));
        }
        return t2;
      }
      n.setTheme = function (e2) {
        if ("string" != typeof e2) for (var t2 in e2) !function (t3) {
          n[t3] = function (r2) {
            if ("object" == typeof e2[t3]) {
              var o2 = r2;
              for (var i2 in e2[t3]) o2 = n[e2[t3][i2]](o2);
              return o2;
            }
            return n[e2[t3]](r2);
          };
        }(t2);else console.log("colors.setTheme now only accepts an object, not a string.  If you are trying to set a theme from a file, it is now your (the caller's) responsibility to require the file.  The old syntax looked like colors.setTheme(__dirname + '/../themes/generic-logging.js'); The new syntax looks like colors.setTheme(require(__dirname + '/../themes/generic-logging.js'));");
      };
      var h = function h(e2, t2) {
        var r2 = t2.split("");
        return (r2 = r2.map(e2)).join("");
      };
      for (var d in n.trap = r(112), n.zalgo = r(113), n.maps = {}, n.maps.america = r(114)(n), n.maps.zebra = r(115)(n), n.maps.rainbow = r(116)(n), n.maps.random = r(117)(n), n.maps) !function (e2) {
        n[e2] = function (t2) {
          return h(n.maps[e2], t2);
        };
      }(d);
      s(n, function () {
        var e2 = {};
        return Object.keys(c).forEach(function (t2) {
          e2[t2] = {
            get: function get() {
              return u([t2]);
            }
          };
        }), e2;
      }());
    }, function (e, t) {
      e.exports = function (e2) {
        return e2 && "object" == typeof e2 && "function" == typeof e2.copy && "function" == typeof e2.fill && "function" == typeof e2.readUInt8;
      };
    }, function (e, t) {
      "function" == typeof Object.create ? e.exports = function (e2, t2) {
        e2.super_ = t2, e2.prototype = Object.create(t2.prototype, {
          constructor: {
            value: e2,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
      } : e.exports = function (e2, t2) {
        e2.super_ = t2;
        var r = function r() {};
        r.prototype = t2.prototype, e2.prototype = new r(), e2.prototype.constructor = e2;
      };
    }, function (e, t) {
      var r = {};
      e.exports = r;
      var n = {
        reset: [0, 0],
        bold: [1, 22],
        dim: [2, 22],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        hidden: [8, 28],
        strikethrough: [9, 29],
        black: [30, 39],
        red: [31, 39],
        green: [32, 39],
        yellow: [33, 39],
        blue: [34, 39],
        magenta: [35, 39],
        cyan: [36, 39],
        white: [37, 39],
        gray: [90, 39],
        grey: [90, 39],
        bgBlack: [40, 49],
        bgRed: [41, 49],
        bgGreen: [42, 49],
        bgYellow: [43, 49],
        bgBlue: [44, 49],
        bgMagenta: [45, 49],
        bgCyan: [46, 49],
        bgWhite: [47, 49],
        blackBG: [40, 49],
        redBG: [41, 49],
        greenBG: [42, 49],
        yellowBG: [43, 49],
        blueBG: [44, 49],
        magentaBG: [45, 49],
        cyanBG: [46, 49],
        whiteBG: [47, 49]
      };
      Object.keys(n).forEach(function (e2) {
        var t2 = n[e2],
          o = r[e2] = [];
        o.open = "\x1B[" + t2[0] + "m", o.close = "\x1B[" + t2[1] + "m";
      });
    }, function (e, t, r) {
      (function (t2) {
        var n = r(18),
          o = r(111),
          i = t2.env,
          s = void 0;
        function a2(e2) {
          return function (e3) {
            return 0 !== e3 && {
              level: e3,
              hasBasic: true,
              has256: e3 >= 2,
              has16m: e3 >= 3
            };
          }(function (e3) {
            if (false === s) return 0;
            if (o("color=16m") || o("color=full") || o("color=truecolor")) return 3;
            if (o("color=256")) return 2;
            if (e3 && !e3.isTTY && true !== s) return 0;
            var r2 = s ? 1 : 0;
            if ("win32" === t2.platform) {
              var a3 = n.release().split(".");
              return Number(t2.versions.node.split(".")[0]) >= 8 && Number(a3[0]) >= 10 && Number(a3[2]) >= 10586 ? Number(a3[2]) >= 14931 ? 3 : 2 : 1;
            }
            if ("CI" in i) return ["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI"].some(function (e4) {
              return e4 in i;
            }) || "codeship" === i.CI_NAME ? 1 : r2;
            if ("TEAMCITY_VERSION" in i) return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(i.TEAMCITY_VERSION) ? 1 : 0;
            if ("TERM_PROGRAM" in i) {
              parseInt("445".split(".")[0], 10);
              return 2;
            }
            return /-256(color)?$/i.test("xterm-256color") ? 2 : /^screen|^xterm|^vt100|^rxvt|color|ansi|cygwin|linux/i.test("xterm-256color") || "COLORTERM" in i ? 1 : r2;
          }(e2));
        }
        o("no-color") || o("no-colors") || o("color=false") ? s = false : (o("color") || o("colors") || o("color=true") || o("color=always")) && (s = true), "FORCE_COLOR" in i && (s = 0 === i.FORCE_COLOR.length || 0 !== parseInt(i.FORCE_COLOR, 10)), e.exports = {
          supportsColor: a2,
          stdout: a2(t2.stdout),
          stderr: a2(t2.stderr)
        };
      }).call(this, r(2));
    }, function (e, t, r) {
      (function (t2) {
        e.exports = function (e2, r2) {
          var n = (r2 = r2 || t2.argv).indexOf("--"),
            o = /^-{1,2}/.test(e2) ? "" : "--",
            i = r2.indexOf(o + e2);
          return -1 !== i && (-1 === n || i < n);
        };
      }).call(this, r(2));
    }, function (e, t) {
      e.exports = function (e2, t2) {
        var r = "";
        e2 = (e2 = e2 || "Run the trap, drop the bass").split("");
        var n = {
          a: ["@", "\u0104", "\u023A", "\u0245", "\u0394", "\u039B", "\u0414"],
          b: ["\xDF", "\u0181", "\u0243", "\u026E", "\u03B2", "\u0E3F"],
          c: ["\xA9", "\u023B", "\u03FE"],
          d: ["\xD0", "\u018A", "\u0500", "\u0501", "\u0502", "\u0503"],
          e: ["\xCB", "\u0115", "\u018E", "\u0258", "\u03A3", "\u03BE", "\u04BC", "\u0A6C"],
          f: ["\u04FA"],
          g: ["\u0262"],
          h: ["\u0126", "\u0195", "\u04A2", "\u04BA", "\u04C7", "\u050A"],
          i: ["\u0F0F"],
          j: ["\u0134"],
          k: ["\u0138", "\u04A0", "\u04C3", "\u051E"],
          l: ["\u0139"],
          m: ["\u028D", "\u04CD", "\u04CE", "\u0520", "\u0521", "\u0D69"],
          n: ["\xD1", "\u014B", "\u019D", "\u0376", "\u03A0", "\u048A"],
          o: ["\xD8", "\xF5", "\xF8", "\u01FE", "\u0298", "\u047A", "\u05DD", "\u06DD", "\u0E4F"],
          p: ["\u01F7", "\u048E"],
          q: ["\u09CD"],
          r: ["\xAE", "\u01A6", "\u0210", "\u024C", "\u0280", "\u042F"],
          s: ["\xA7", "\u03DE", "\u03DF", "\u03E8"],
          t: ["\u0141", "\u0166", "\u0373"],
          u: ["\u01B1", "\u054D"],
          v: ["\u05D8"],
          w: ["\u0428", "\u0460", "\u047C", "\u0D70"],
          x: ["\u04B2", "\u04FE", "\u04FC", "\u04FD"],
          y: ["\xA5", "\u04B0", "\u04CB"],
          z: ["\u01B5", "\u0240"]
        };
        return e2.forEach(function (e3) {
          e3 = e3.toLowerCase();
          var t3 = n[e3] || [" "],
            o = Math.floor(Math.random() * t3.length);
          r += void 0 !== n[e3] ? n[e3][o] : e3;
        }), r;
      };
    }, function (e, t) {
      e.exports = function (e2, t2) {
        e2 = e2 || "   he is here   ";
        var r = {
            up: ["\u030D", "\u030E", "\u0304", "\u0305", "\u033F", "\u0311", "\u0306", "\u0310", "\u0352", "\u0357", "\u0351", "\u0307", "\u0308", "\u030A", "\u0342", "\u0313", "\u0308", "\u034A", "\u034B", "\u034C", "\u0303", "\u0302", "\u030C", "\u0350", "\u0300", "\u0301", "\u030B", "\u030F", "\u0312", "\u0313", "\u0314", "\u033D", "\u0309", "\u0363", "\u0364", "\u0365", "\u0366", "\u0367", "\u0368", "\u0369", "\u036A", "\u036B", "\u036C", "\u036D", "\u036E", "\u036F", "\u033E", "\u035B", "\u0346", "\u031A"],
            down: ["\u0316", "\u0317", "\u0318", "\u0319", "\u031C", "\u031D", "\u031E", "\u031F", "\u0320", "\u0324", "\u0325", "\u0326", "\u0329", "\u032A", "\u032B", "\u032C", "\u032D", "\u032E", "\u032F", "\u0330", "\u0331", "\u0332", "\u0333", "\u0339", "\u033A", "\u033B", "\u033C", "\u0345", "\u0347", "\u0348", "\u0349", "\u034D", "\u034E", "\u0353", "\u0354", "\u0355", "\u0356", "\u0359", "\u035A", "\u0323"],
            mid: ["\u0315", "\u031B", "\u0300", "\u0301", "\u0358", "\u0321", "\u0322", "\u0327", "\u0328", "\u0334", "\u0335", "\u0336", "\u035C", "\u035D", "\u035E", "\u035F", "\u0360", "\u0362", "\u0338", "\u0337", "\u0361", " \u0489"]
          },
          n = [].concat(r.up, r.down, r.mid);
        function o(e3) {
          return Math.floor(Math.random() * e3);
        }
        function i(e3) {
          var t3 = false;
          return n.filter(function (r2) {
            t3 = r2 === e3;
          }), t3;
        }
        return function (e3, t3) {
          var n2,
            s,
            a2 = "";
          for (s in (t3 = t3 || {}).up = void 0 === t3.up || t3.up, t3.mid = void 0 === t3.mid || t3.mid, t3.down = void 0 === t3.down || t3.down, t3.size = void 0 !== t3.size ? t3.size : "maxi", e3 = e3.split("")) if (!i(s)) {
            switch (a2 += e3[s], n2 = {
              up: 0,
              down: 0,
              mid: 0
            }, t3.size) {
              case "mini":
                n2.up = o(8), n2.mid = o(2), n2.down = o(8);
                break;
              case "maxi":
                n2.up = o(16) + 3, n2.mid = o(4) + 1, n2.down = o(64) + 3;
                break;
              default:
                n2.up = o(8) + 1, n2.mid = o(6) / 2, n2.down = o(8) + 1;
            }
            var l = ["up", "mid", "down"];
            for (var u in l) for (var g = l[u], c = 0; c <= n2[g]; c++) t3[g] && (a2 += r[g][o(r[g].length)]);
          }
          return a2;
        }(e2, t2);
      };
    }, function (e, t) {
      e.exports = function (e2) {
        return function (t2, r, n) {
          if (" " === t2) return t2;
          switch (r % 3) {
            case 0:
              return e2.red(t2);
            case 1:
              return e2.white(t2);
            case 2:
              return e2.blue(t2);
          }
        };
      };
    }, function (e, t) {
      e.exports = function (e2) {
        return function (t2, r, n) {
          return r % 2 == 0 ? t2 : e2.inverse(t2);
        };
      };
    }, function (e, t) {
      e.exports = function (e2) {
        var t2 = ["red", "yellow", "green", "blue", "magenta"];
        return function (r, n, o) {
          return " " === r ? r : e2[t2[n++ % t2.length]](r);
        };
      };
    }, function (e, t) {
      e.exports = function (e2) {
        var t2 = ["underline", "inverse", "grey", "yellow", "red", "green", "blue", "white", "cyan", "magenta"];
        return function (r, n, o) {
          return " " === r ? r : e2[t2[Math.round(Math.random() * (t2.length - 2))]](r);
        };
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "cli", {
        value: r(119)
      }), Object.defineProperty(t, "npm", {
        value: r(120)
      }), Object.defineProperty(t, "syslog", {
        value: r(121)
      });
    }, function (e, t, r) {
      t.levels = {
        error: 0,
        warn: 1,
        help: 2,
        data: 3,
        info: 4,
        debug: 5,
        prompt: 6,
        verbose: 7,
        input: 8,
        silly: 9
      }, t.colors = {
        error: "red",
        warn: "yellow",
        help: "cyan",
        data: "grey",
        info: "green",
        debug: "blue",
        prompt: "grey",
        verbose: "cyan",
        input: "grey",
        silly: "magenta"
      };
    }, function (e, t, r) {
      t.levels = {
        error: 0,
        warn: 1,
        info: 2,
        http: 3,
        verbose: 4,
        debug: 5,
        silly: 6
      }, t.colors = {
        error: "red",
        warn: "yellow",
        info: "green",
        http: "green",
        verbose: "cyan",
        debug: "blue",
        silly: "magenta"
      };
    }, function (e, t, r) {
      t.levels = {
        emerg: 0,
        alert: 1,
        crit: 2,
        error: 3,
        warning: 4,
        notice: 5,
        info: 6,
        debug: 7
      }, t.colors = {
        emerg: "red",
        alert: "yellow",
        crit: "red",
        error: "red",
        warning: "red",
        notice: "yellow",
        info: "green",
        debug: "blue"
      };
    }, function (e, t, r) {
      var n = r(12);
      e.exports = n(function (e2) {
        return e2.message = "	".concat(e2.message), e2;
      });
    }, function (e, t, r) {
      function n(e2, t2) {
        if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
      }
      function o(e2, t2) {
        for (var r2 = 0; r2 < t2.length; r2++) {
          var n2 = t2[r2];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
        }
      }
      var i = r(41).Colorizer,
        s = r(60).Padder,
        a2 = r(3),
        l = a2.configs,
        u = a2.MESSAGE,
        g = function () {
          function e2() {
            var t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            n(this, e2), t3.levels || (t3.levels = l.npm.levels), this.colorizer = new i(t3), this.padder = new s(t3), this.options = t3;
          }
          var t2, r2;
          return t2 = e2, (r2 = [{
            key: "transform",
            value: function value(e3, t3) {
              return this.colorizer.transform(this.padder.transform(e3, t3), t3), e3[u] = "".concat(e3.level, ":").concat(e3.message), e3;
            }
          }]) && o(t2.prototype, r2), e2;
        }();
      e.exports = function (e2) {
        return new g(e2);
      }, e.exports.Format = g;
    }, function (e, t, r) {
      var n = r(12);
      function o(e2) {
        if (e2.every(i)) return function (t2) {
          for (var r2 = t2, n2 = 0; n2 < e2.length; n2++) if (!(r2 = e2[n2].transform(r2, e2[n2].options))) return false;
          return r2;
        };
      }
      function i(e2) {
        if ("function" != typeof e2.transform) throw new Error(["No transform function found on format. Did you create a format instance?", "const myFormat = format(formatFn);", "const instance = myFormat();"].join("\n"));
        return true;
      }
      e.exports = function () {
        for (var e2 = arguments.length, t2 = new Array(e2), r2 = 0; r2 < e2; r2++) t2[r2] = arguments[r2];
        var i2 = n(o(t2)),
          s = i2();
        return s.Format = i2.Format, s;
      }, e.exports.cascade = o;
    }, function (e, t, r) {
      (function (t2) {
        var n = r(12),
          o = r(3).MESSAGE,
          i = r(35);
        function s(e2, r2) {
          return r2 instanceof t2 ? r2.toString("base64") : "bigint" == typeof r2 ? r2.toString() : r2;
        }
        e.exports = n(function (e2) {
          var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return e2[o] = (t3.stable ? i.stableStringify : i)(e2, t3.replacer || s, t3.space), e2;
        });
      }).call(this, r(5).Buffer);
    }, function (e, t, r) {
      t.byteLength = function (e2) {
        var t2 = u(e2),
          r2 = t2[0],
          n2 = t2[1];
        return 3 * (r2 + n2) / 4 - n2;
      }, t.toByteArray = function (e2) {
        for (var t2, r2 = u(e2), n2 = r2[0], s2 = r2[1], a3 = new i(function (e3, t3, r3) {
            return 3 * (t3 + r3) / 4 - r3;
          }(0, n2, s2)), l2 = 0, g2 = s2 > 0 ? n2 - 4 : n2, c = 0; c < g2; c += 4) t2 = o[e2.charCodeAt(c)] << 18 | o[e2.charCodeAt(c + 1)] << 12 | o[e2.charCodeAt(c + 2)] << 6 | o[e2.charCodeAt(c + 3)], a3[l2++] = t2 >> 16 & 255, a3[l2++] = t2 >> 8 & 255, a3[l2++] = 255 & t2;
        2 === s2 && (t2 = o[e2.charCodeAt(c)] << 2 | o[e2.charCodeAt(c + 1)] >> 4, a3[l2++] = 255 & t2);
        1 === s2 && (t2 = o[e2.charCodeAt(c)] << 10 | o[e2.charCodeAt(c + 1)] << 4 | o[e2.charCodeAt(c + 2)] >> 2, a3[l2++] = t2 >> 8 & 255, a3[l2++] = 255 & t2);
        return a3;
      }, t.fromByteArray = function (e2) {
        for (var t2, r2 = e2.length, o2 = r2 % 3, i2 = [], s2 = 0, a3 = r2 - o2; s2 < a3; s2 += 16383) i2.push(g(e2, s2, s2 + 16383 > a3 ? a3 : s2 + 16383));
        1 === o2 ? (t2 = e2[r2 - 1], i2.push(n[t2 >> 2] + n[t2 << 4 & 63] + "==")) : 2 === o2 && (t2 = (e2[r2 - 2] << 8) + e2[r2 - 1], i2.push(n[t2 >> 10] + n[t2 >> 4 & 63] + n[t2 << 2 & 63] + "="));
        return i2.join("");
      };
      for (var n = [], o = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a2 = 0, l = s.length; a2 < l; ++a2) n[a2] = s[a2], o[s.charCodeAt(a2)] = a2;
      function u(e2) {
        var t2 = e2.length;
        if (t2 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var r2 = e2.indexOf("=");
        return -1 === r2 && (r2 = t2), [r2, r2 === t2 ? 0 : 4 - r2 % 4];
      }
      function g(e2, t2, r2) {
        for (var o2, i2, s2 = [], a3 = t2; a3 < r2; a3 += 3) o2 = (e2[a3] << 16 & 16711680) + (e2[a3 + 1] << 8 & 65280) + (255 & e2[a3 + 2]), s2.push(n[(i2 = o2) >> 18 & 63] + n[i2 >> 12 & 63] + n[i2 >> 6 & 63] + n[63 & i2]);
        return s2.join("");
      }
      o["-".charCodeAt(0)] = 62, o["_".charCodeAt(0)] = 63;
    }, function (e, t) {
      t.read = function (e2, t2, r, n, o) {
        var i,
          s,
          a2 = 8 * o - n - 1,
          l = (1 << a2) - 1,
          u = l >> 1,
          g = -7,
          c = r ? o - 1 : 0,
          f = r ? -1 : 1,
          p = e2[t2 + c];
        for (c += f, i = p & (1 << -g) - 1, p >>= -g, g += a2; g > 0; i = 256 * i + e2[t2 + c], c += f, g -= 8);
        for (s = i & (1 << -g) - 1, i >>= -g, g += n; g > 0; s = 256 * s + e2[t2 + c], c += f, g -= 8);
        if (0 === i) i = 1 - u;else {
          if (i === l) return s ? NaN : 1 / 0 * (p ? -1 : 1);
          s += Math.pow(2, n), i -= u;
        }
        return (p ? -1 : 1) * s * Math.pow(2, i - n);
      }, t.write = function (e2, t2, r, n, o, i) {
        var s,
          a2,
          l,
          u = 8 * i - o - 1,
          g = (1 << u) - 1,
          c = g >> 1,
          f = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          p = n ? 0 : i - 1,
          h = n ? 1 : -1,
          d = t2 < 0 || 0 === t2 && 1 / t2 < 0 ? 1 : 0;
        for (t2 = Math.abs(t2), isNaN(t2) || t2 === 1 / 0 ? (a2 = isNaN(t2) ? 1 : 0, s = g) : (s = Math.floor(Math.log(t2) / Math.LN2), t2 * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), (t2 += s + c >= 1 ? f / l : f * Math.pow(2, 1 - c)) * l >= 2 && (s++, l /= 2), s + c >= g ? (a2 = 0, s = g) : s + c >= 1 ? (a2 = (t2 * l - 1) * Math.pow(2, o), s += c) : (a2 = t2 * Math.pow(2, c - 1) * Math.pow(2, o), s = 0)); o >= 8; e2[r + p] = 255 & a2, p += h, a2 /= 256, o -= 8);
        for (s = s << o | a2, u += o; u > 0; e2[r + p] = 255 & s, p += h, s /= 256, u -= 8);
        e2[r + p - h] |= 128 * d;
      };
    }, function (e, t, r) {
      var n = r(12);
      e.exports = n(function (e2, t2) {
        return t2.message ? (e2.message = "[".concat(t2.label, "] ").concat(e2.message), e2) : (e2.label = t2.label, e2);
      });
    }, function (e, t, r) {
      var n = r(12),
        o = r(3).MESSAGE,
        i = r(35);
      e.exports = n(function (e2) {
        var t2 = {};
        return e2.message && (t2["@message"] = e2.message, delete e2.message), e2.timestamp && (t2["@timestamp"] = e2.timestamp, delete e2.timestamp), t2["@fields"] = e2, e2[o] = i(t2), e2;
      });
    }, function (e, t, r) {
      var n = r(12);
      function o(e2, t2, r2) {
        var n2,
          o2,
          i2,
          s = t2.reduce(function (t3, r3) {
            return t3[r3] = e2[r3], delete e2[r3], t3;
          }, {}),
          a2 = Object.keys(e2).reduce(function (t3, r3) {
            return t3[r3] = e2[r3], delete e2[r3], t3;
          }, {});
        return Object.assign(e2, s, (i2 = a2, (o2 = r2) in (n2 = {}) ? Object.defineProperty(n2, o2, {
          value: i2,
          enumerable: true,
          configurable: true,
          writable: true
        }) : n2[o2] = i2, n2)), e2;
      }
      function i(e2, t2, r2) {
        return e2[r2] = t2.reduce(function (t3, r3) {
          return t3[r3] = e2[r3], delete e2[r3], t3;
        }, {}), e2;
      }
      e.exports = n(function (e2) {
        var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r2 = "metadata";
        t2.key && (r2 = t2.key);
        var n2 = [];
        return t2.fillExcept || t2.fillWith || (n2.push("level"), n2.push("message")), t2.fillExcept && (n2 = t2.fillExcept), n2.length > 0 ? o(e2, n2, r2) : t2.fillWith ? i(e2, t2.fillWith, r2) : e2;
      });
    }, function (e, t, r) {
      var n = r(13).inspect,
        o = r(12),
        i = r(3),
        s = i.LEVEL,
        a2 = i.MESSAGE,
        l = i.SPLAT;
      e.exports = o(function (e2) {
        var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r2 = Object.assign({}, e2);
        return delete r2[s], delete r2[a2], delete r2[l], e2[a2] = n(r2, false, t2.depth || null, t2.colorize), e2;
      });
    }, function (e, t, r) {
      function n(e2, t2) {
        for (var r2 = 0; r2 < t2.length; r2++) {
          var n2 = t2[r2];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
        }
      }
      var o = r(3).MESSAGE,
        i = function () {
          function e2(t3) {
            !function (e3, t4) {
              if (!(e3 instanceof t4)) throw new TypeError("Cannot call a class as a function");
            }(this, e2), this.template = t3;
          }
          var t2, r2;
          return t2 = e2, (r2 = [{
            key: "transform",
            value: function value(e3) {
              return e3[o] = this.template(e3), e3;
            }
          }]) && n(t2.prototype, r2), e2;
        }();
      e.exports = function (e2) {
        return new i(e2);
      }, e.exports.Printf = e.exports.Format = i;
    }, function (e, t, r) {
      var n = r(12),
        o = r(3).MESSAGE,
        i = r(35);
      e.exports = n(function (e2) {
        var t2 = i(Object.assign({}, e2, {
            level: void 0,
            message: void 0,
            splat: void 0
          })),
          r2 = e2.padding && e2.padding[e2.level] || "";
        return e2[o] = "{}" !== t2 ? "".concat(e2.level, ":").concat(r2, " ").concat(e2.message, " ").concat(t2) : "".concat(e2.level, ":").concat(r2, " ").concat(e2.message), e2;
      });
    }, function (e, t, r) {
      function n(e2) {
        return function (e3) {
          if (Array.isArray(e3)) return o(e3);
        }(e2) || function (e3) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(e3)) return Array.from(e3);
        }(e2) || function (e3, t2) {
          if (!e3) return;
          if ("string" == typeof e3) return o(e3, t2);
          var r2 = Object.prototype.toString.call(e3).slice(8, -1);
          "Object" === r2 && e3.constructor && (r2 = e3.constructor.name);
          if ("Map" === r2 || "Set" === r2) return Array.from(e3);
          if ("Arguments" === r2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r2)) return o(e3, t2);
        }(e2) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function o(e2, t2) {
        (null == t2 || t2 > e2.length) && (t2 = e2.length);
        for (var r2 = 0, n2 = new Array(t2); r2 < t2; r2++) n2[r2] = e2[r2];
        return n2;
      }
      function i(e2, t2) {
        for (var r2 = 0; r2 < t2.length; r2++) {
          var n2 = t2[r2];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
        }
      }
      var s = r(13),
        a2 = r(3).SPLAT,
        l = /%[scdjifoO%]/g,
        u = /%%/g,
        g = function () {
          function e2(t3) {
            !function (e3, t4) {
              if (!(e3 instanceof t4)) throw new TypeError("Cannot call a class as a function");
            }(this, e2), this.options = t3;
          }
          var t2, r2;
          return t2 = e2, (r2 = [{
            key: "_splat",
            value: function value(e3, t3) {
              var r3 = e3.message,
                o2 = e3[a2] || e3.splat || [],
                i2 = r3.match(u),
                l2 = i2 && i2.length || 0,
                g2 = t3.length - l2 - o2.length,
                c = g2 < 0 ? o2.splice(g2, -1 * g2) : [],
                f = c.length;
              if (f) for (var p = 0; p < f; p++) Object.assign(e3, c[p]);
              return e3.message = s.format.apply(s, [r3].concat(n(o2))), e3;
            }
          }, {
            key: "transform",
            value: function value(e3) {
              var t3 = e3.message,
                r3 = e3[a2] || e3.splat;
              if (!r3 || !r3.length) return e3;
              var n2 = t3 && t3.match && t3.match(l);
              if (!n2 && (r3 || r3.length)) {
                var o2 = r3.length > 1 ? r3.splice(0) : r3,
                  i2 = o2.length;
                if (i2) for (var s2 = 0; s2 < i2; s2++) Object.assign(e3, o2[s2]);
                return e3;
              }
              return n2 ? this._splat(e3, n2) : e3;
            }
          }]) && i(t2.prototype, r2), e2;
        }();
      e.exports = function (e2) {
        return new g(e2);
      };
    }, function (e, t, r) {
      var n = r(136),
        o = r(12);
      e.exports = o(function (e2) {
        var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return t2.format && (e2.timestamp = "function" == typeof t2.format ? t2.format() : n.format(new Date(), t2.format)), e2.timestamp || (e2.timestamp = new Date().toISOString()), t2.alias && (e2[t2.alias] = e2.timestamp), e2;
      });
    }, function (e, t, r) {
      r.r(t), r.d(t, "assign", function () {
        return l;
      }), r.d(t, "format", function () {
        return A;
      }), r.d(t, "parse", function () {
        return O;
      }), r.d(t, "defaultI18n", function () {
        return f;
      }), r.d(t, "setGlobalDateI18n", function () {
        return h;
      }), r.d(t, "setGlobalDateMasks", function () {
        return R;
      });
      var n = /d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|Z|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g,
        o = "[^\\s]+",
        i = /\[([^]*?)\]/gm;
      function s(e2, t2) {
        for (var r2 = [], n2 = 0, o2 = e2.length; n2 < o2; n2++) r2.push(e2[n2].substr(0, t2));
        return r2;
      }
      var a2 = function a2(e2) {
        return function (t2, r2) {
          var n2 = r2[e2].map(function (e3) {
            return e3.toLowerCase();
          }).indexOf(t2.toLowerCase());
          return n2 > -1 ? n2 : null;
        };
      };
      function l(e2) {
        for (var t2 = [], r2 = 1; r2 < arguments.length; r2++) t2[r2 - 1] = arguments[r2];
        for (var n2 = 0, o2 = t2; n2 < o2.length; n2++) {
          var i2 = o2[n2];
          for (var s2 in i2) e2[s2] = i2[s2];
        }
        return e2;
      }
      var u = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        g = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        c = s(g, 3),
        f = {
          dayNamesShort: s(u, 3),
          dayNames: u,
          monthNamesShort: c,
          monthNames: g,
          amPm: ["am", "pm"],
          DoFn: function DoFn(e2) {
            return e2 + ["th", "st", "nd", "rd"][e2 % 10 > 3 ? 0 : (e2 - e2 % 10 != 10 ? 1 : 0) * e2 % 10];
          }
        },
        p = l({}, f),
        h = function h(e2) {
          return p = l(p, e2);
        },
        d = function d(e2) {
          return e2.replace(/[|\\{()[^$+*?.-]/g, "\\$&");
        },
        y = function y(e2, t2) {
          for (void 0 === t2 && (t2 = 2), e2 = String(e2); e2.length < t2;) e2 = "0" + e2;
          return e2;
        },
        m = {
          D: function D(e2) {
            return String(e2.getDate());
          },
          DD: function DD(e2) {
            return y(e2.getDate());
          },
          Do: function Do(e2, t2) {
            return t2.DoFn(e2.getDate());
          },
          d: function d(e2) {
            return String(e2.getDay());
          },
          dd: function dd(e2) {
            return y(e2.getDay());
          },
          ddd: function ddd(e2, t2) {
            return t2.dayNamesShort[e2.getDay()];
          },
          dddd: function dddd(e2, t2) {
            return t2.dayNames[e2.getDay()];
          },
          M: function M(e2) {
            return String(e2.getMonth() + 1);
          },
          MM: function MM(e2) {
            return y(e2.getMonth() + 1);
          },
          MMM: function MMM(e2, t2) {
            return t2.monthNamesShort[e2.getMonth()];
          },
          MMMM: function MMMM(e2, t2) {
            return t2.monthNames[e2.getMonth()];
          },
          YY: function YY(e2) {
            return y(String(e2.getFullYear()), 4).substr(2);
          },
          YYYY: function YYYY(e2) {
            return y(e2.getFullYear(), 4);
          },
          h: function h(e2) {
            return String(e2.getHours() % 12 || 12);
          },
          hh: function hh(e2) {
            return y(e2.getHours() % 12 || 12);
          },
          H: function H(e2) {
            return String(e2.getHours());
          },
          HH: function HH(e2) {
            return y(e2.getHours());
          },
          m: function m(e2) {
            return String(e2.getMinutes());
          },
          mm: function mm(e2) {
            return y(e2.getMinutes());
          },
          s: function s(e2) {
            return String(e2.getSeconds());
          },
          ss: function ss(e2) {
            return y(e2.getSeconds());
          },
          S: function S(e2) {
            return String(Math.round(e2.getMilliseconds() / 100));
          },
          SS: function SS(e2) {
            return y(Math.round(e2.getMilliseconds() / 10), 2);
          },
          SSS: function SSS(e2) {
            return y(e2.getMilliseconds(), 3);
          },
          a: function a(e2, t2) {
            return e2.getHours() < 12 ? t2.amPm[0] : t2.amPm[1];
          },
          A: function A(e2, t2) {
            return e2.getHours() < 12 ? t2.amPm[0].toUpperCase() : t2.amPm[1].toUpperCase();
          },
          ZZ: function ZZ(e2) {
            var t2 = e2.getTimezoneOffset();
            return (t2 > 0 ? "-" : "+") + y(100 * Math.floor(Math.abs(t2) / 60) + Math.abs(t2) % 60, 4);
          },
          Z: function Z(e2) {
            var t2 = e2.getTimezoneOffset();
            return (t2 > 0 ? "-" : "+") + y(Math.floor(Math.abs(t2) / 60), 2) + ":" + y(Math.abs(t2) % 60, 2);
          }
        },
        b = function b(e2) {
          return +e2 - 1;
        },
        v = [null, "[1-9]\\d?"],
        _ = [null, o],
        S = ["isPm", o, function (e2, t2) {
          var r2 = e2.toLowerCase();
          return r2 === t2.amPm[0] ? 0 : r2 === t2.amPm[1] ? 1 : null;
        }],
        w = ["timezoneOffset", "[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z?", function (e2) {
          var t2 = (e2 + "").match(/([+-]|\d\d)/gi);
          if (t2) {
            var r2 = 60 * +t2[1] + parseInt(t2[2], 10);
            return "+" === t2[0] ? r2 : -r2;
          }
          return 0;
        }],
        E = {
          D: ["day", "[1-9]\\d?"],
          DD: ["day", "\\d\\d"],
          Do: ["day", "[1-9]\\d?" + o, function (e2) {
            return parseInt(e2, 10);
          }],
          M: ["month", "[1-9]\\d?", b],
          MM: ["month", "\\d\\d", b],
          YY: ["year", "\\d\\d", function (e2) {
            var t2 = +("" + new Date().getFullYear()).substr(0, 2);
            return +("" + (+e2 > 68 ? t2 - 1 : t2) + e2);
          }],
          h: ["hour", "[1-9]\\d?", void 0, "isPm"],
          hh: ["hour", "\\d\\d", void 0, "isPm"],
          H: ["hour", "[1-9]\\d?"],
          HH: ["hour", "\\d\\d"],
          m: ["minute", "[1-9]\\d?"],
          mm: ["minute", "\\d\\d"],
          s: ["second", "[1-9]\\d?"],
          ss: ["second", "\\d\\d"],
          YYYY: ["year", "\\d{4}"],
          S: ["millisecond", "\\d", function (e2) {
            return 100 * +e2;
          }],
          SS: ["millisecond", "\\d\\d", function (e2) {
            return 10 * +e2;
          }],
          SSS: ["millisecond", "\\d{3}"],
          d: v,
          dd: v,
          ddd: _,
          dddd: _,
          MMM: ["month", o, a2("monthNamesShort")],
          MMMM: ["month", o, a2("monthNames")],
          a: S,
          A: S,
          ZZ: w,
          Z: w
        },
        T = {
          default: "ddd MMM DD YYYY HH:mm:ss",
          shortDate: "M/D/YY",
          mediumDate: "MMM D, YYYY",
          longDate: "MMMM D, YYYY",
          fullDate: "dddd, MMMM D, YYYY",
          isoDate: "YYYY-MM-DD",
          isoDateTime: "YYYY-MM-DDTHH:mm:ssZ",
          shortTime: "HH:mm",
          mediumTime: "HH:mm:ss",
          longTime: "HH:mm:ss.SSS"
        },
        R = function R(e2) {
          return l(T, e2);
        },
        A = function A(e2, t2, r2) {
          if (void 0 === t2 && (t2 = T.default), void 0 === r2 && (r2 = {}), "number" == typeof e2 && (e2 = new Date(e2)), "[object Date]" !== Object.prototype.toString.call(e2) || isNaN(e2.getTime())) throw new Error("Invalid Date pass to format");
          var o2 = [];
          t2 = (t2 = T[t2] || t2).replace(i, function (e3, t3) {
            return o2.push(t3), "@@@";
          });
          var s2 = l(l({}, p), r2);
          return (t2 = t2.replace(n, function (t3) {
            return m[t3](e2, s2);
          })).replace(/@@@/g, function () {
            return o2.shift();
          });
        };
      function O(e2, t2, r2) {
        if (void 0 === r2 && (r2 = {}), "string" != typeof t2) throw new Error("Invalid format in fecha parse");
        if (t2 = T[t2] || t2, e2.length > 1e3) return null;
        var o2 = {
            year: new Date().getFullYear(),
            month: 0,
            day: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            isPm: null,
            timezoneOffset: null
          },
          s2 = [],
          a3 = [],
          u2 = t2.replace(i, function (e3, t3) {
            return a3.push(d(t3)), "@@@";
          }),
          g2 = {},
          c2 = {};
        u2 = d(u2).replace(n, function (e3) {
          var t3 = E[e3],
            r3 = t3[0],
            n2 = t3[1],
            o3 = t3[3];
          if (g2[r3]) throw new Error("Invalid format. " + r3 + " specified twice in format");
          return g2[r3] = true, o3 && (c2[o3] = true), s2.push(t3), "(" + n2 + ")";
        }), Object.keys(c2).forEach(function (e3) {
          if (!g2[e3]) throw new Error("Invalid format. " + e3 + " is required in specified format");
        }), u2 = u2.replace(/@@@/g, function () {
          return a3.shift();
        });
        var f2 = e2.match(new RegExp(u2, "i"));
        if (!f2) return null;
        for (var h2 = l(l({}, p), r2), y2 = 1; y2 < f2.length; y2++) {
          var m2 = s2[y2 - 1],
            b2 = m2[0],
            v2 = m2[2],
            _2 = v2 ? v2(f2[y2], h2) : +f2[y2];
          if (null == _2) return null;
          o2[b2] = _2;
        }
        1 === o2.isPm && null != o2.hour && 12 != +o2.hour ? o2.hour = +o2.hour + 12 : 0 === o2.isPm && 12 == +o2.hour && (o2.hour = 0);
        for (var S2 = new Date(o2.year, o2.month, o2.day, o2.hour, o2.minute, o2.second, o2.millisecond), w2 = [["month", "getMonth"], ["day", "getDate"], ["hour", "getHours"], ["minute", "getMinutes"], ["second", "getSeconds"]], R2 = (y2 = 0, w2.length); y2 < R2; y2++) if (g2[w2[y2][0]] && o2[w2[y2][0]] !== S2[w2[y2][1]]()) return null;
        return null == o2.timezoneOffset ? S2 : new Date(Date.UTC(o2.year, o2.month, o2.day, o2.hour, o2.minute - o2.timezoneOffset, o2.second, o2.millisecond));
      }
      var C = {
        format: A,
        parse: O,
        defaultI18n: f,
        setGlobalDateI18n: h,
        setGlobalDateMasks: R
      };
      t.default = C;
    }, function (e, t, r) {
      var n = r(59),
        o = r(12),
        i = r(3).MESSAGE;
      e.exports = o(function (e2, t2) {
        return false !== t2.level && (e2.level = n.strip(e2.level)), false !== t2.message && (e2.message = n.strip(e2.message)), false !== t2.raw && e2[i] && (e2[i] = n.strip(e2[i])), e2;
      });
    }, function (e) {
      e.exports = JSON.parse('{"name":"winston","description":"A logger for just about everything.","version":"3.3.3","author":"Charlie Robbins <charlie.robbins@gmail.com>","maintainers":["Jarrett Cruger <jcrugzz@gmail.com>","Chris Alderson <chrisalderson@protonmail.com>","David Hyde <dabh@stanford.edu>"],"repository":{"type":"git","url":"https://github.com/winstonjs/winston.git"},"keywords":["winston","logger","logging","logs","sysadmin","bunyan","pino","loglevel","tools","json","stream"],"dependencies":{"async":"^3.1.0","@dabh/diagnostics":"^2.0.2","is-stream":"^2.0.0","logform":"^2.2.0","one-time":"^1.0.0","readable-stream":"^3.4.0","stack-trace":"0.0.x","triple-beam":"^1.3.0","winston-transport":"^4.4.0"},"devDependencies":{"@babel/cli":"^7.10.3","@babel/core":"^7.10.3","@babel/preset-env":"^7.10.3","@types/node":"^14.0.13","abstract-winston-transport":"^0.5.1","assume":"^2.2.0","colors":"^1.4.0","cross-spawn-async":"^2.2.5","eslint-config-populist":"^4.2.0","hock":"^1.4.1","mocha":"^8.0.1","nyc":"^15.1.0","rimraf":"^3.0.2","split2":"^3.1.1","std-mocks":"^1.0.1","through2":"^3.0.1","winston-compat":"^0.1.5"},"main":"./lib/winston","browser":"./dist/winston","types":"./index.d.ts","scripts":{"lint":"populist lib/*.js lib/winston/*.js lib/winston/**/*.js","pretest":"npm run lint","test":"nyc --reporter=text --reporter lcov npm run test:mocha","test:mocha":"mocha test/*.test.js test/**/*.test.js --exit","build":"./node_modules/.bin/rimraf dist && babel lib -d dist","prepublishOnly":"npm run build"},"engines":{"node":">= 6.4.0"},"license":"MIT"}');
    }, function (e, t, r) {
      Object.defineProperty(t, "Console", {
        configurable: true,
        enumerable: true,
        get: function get() {
          return r(140);
        }
      }), Object.defineProperty(t, "File", {
        configurable: true,
        enumerable: true,
        get: function get() {
          return r(149);
        }
      }), Object.defineProperty(t, "Http", {
        configurable: true,
        enumerable: true,
        get: function get() {
          return r(189);
        }
      }), Object.defineProperty(t, "Stream", {
        configurable: true,
        enumerable: true,
        get: function get() {
          return r(201);
        }
      });
    }, function (e, t, r) {
      (function (t2) {
        function n(e2) {
          return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e3) {
            return typeof e3;
          } : function (e3) {
            return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
          })(e2);
        }
        function o(e2, t3) {
          if (!(e2 instanceof t3)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e2, t3) {
          for (var r2 = 0; r2 < t3.length; r2++) {
            var n2 = t3[r2];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
          }
        }
        function s(e2, t3) {
          return (s = Object.setPrototypeOf || function (e3, t4) {
            return e3.__proto__ = t4, e3;
          })(e2, t3);
        }
        function a2(e2) {
          var t3 = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if ("function" == typeof Proxy) return true;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), true;
            } catch (e3) {
              return false;
            }
          }();
          return function () {
            var r2,
              n2 = u(e2);
            if (t3) {
              var o2 = u(this).constructor;
              r2 = Reflect.construct(n2, arguments, o2);
            } else r2 = n2.apply(this, arguments);
            return l(this, r2);
          };
        }
        function l(e2, t3) {
          return !t3 || "object" !== n(t3) && "function" != typeof t3 ? function (e3) {
            if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e3;
          }(e2) : t3;
        }
        function u(e2) {
          return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e3) {
            return e3.__proto__ || Object.getPrototypeOf(e3);
          })(e2);
        }
        var g = r(18),
          c = r(3),
          f = c.LEVEL,
          p = c.MESSAGE,
          h = r(20);
        e.exports = function (e2) {
          !function (e3, t3) {
            if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
            e3.prototype = Object.create(t3 && t3.prototype, {
              constructor: {
                value: e3,
                writable: true,
                configurable: true
              }
            }), t3 && s(e3, t3);
          }(c2, e2);
          var r2,
            n2,
            u2 = a2(c2);
          function c2() {
            var e3,
              t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return o(this, c2), (e3 = u2.call(this, t3)).name = t3.name || "console", e3.stderrLevels = e3._stringArrayToSet(t3.stderrLevels), e3.consoleWarnLevels = e3._stringArrayToSet(t3.consoleWarnLevels), e3.eol = t3.eol || g.EOL, e3.setMaxListeners(30), e3;
          }
          return r2 = c2, (n2 = [{
            key: "log",
            value: function value(e3, r3) {
              var n3 = this;
              return t2(function () {
                return n3.emit("logged", e3);
              }), this.stderrLevels[e3[f]] ? (console._stderr ? console._stderr.write("".concat(e3[p]).concat(this.eol)) : console.error(e3[p]), void (r3 && r3())) : this.consoleWarnLevels[e3[f]] ? (console._stderr ? console._stderr.write("".concat(e3[p]).concat(this.eol)) : console.warn(e3[p]), void (r3 && r3())) : (console._stdout ? console._stdout.write("".concat(e3[p]).concat(this.eol)) : console.log(e3[p]), void (r3 && r3()));
            }
          }, {
            key: "_stringArrayToSet",
            value: function value(e3, t3) {
              if (!e3) return {};
              if (t3 = t3 || "Cannot make set from type other than Array of string elements", !Array.isArray(e3)) throw new Error(t3);
              return e3.reduce(function (e4, r3) {
                if ("string" != typeof r3) throw new Error(t3);
                return e4[r3] = true, e4;
              }, {});
            }
          }]) && i(r2.prototype, n2), c2;
        }(h);
      }).call(this, r(15).setImmediate);
    }, function (e, t, r) {
      (function (e2, t2) {
        !function (e3, r2) {
          if (!e3.setImmediate) {
            var n,
              o,
              i,
              s,
              a2,
              l = 1,
              u = {},
              g = false,
              c = e3.document,
              f = Object.getPrototypeOf && Object.getPrototypeOf(e3);
            f = f && f.setTimeout ? f : e3, "[object process]" === {}.toString.call(e3.process) ? n = function n(e4) {
              t2.nextTick(function () {
                h(e4);
              });
            } : !function () {
              if (e3.postMessage && !e3.importScripts) {
                var t3 = true,
                  r3 = e3.onmessage;
                return e3.onmessage = function () {
                  t3 = false;
                }, e3.postMessage("", "*"), e3.onmessage = r3, t3;
              }
            }() ? e3.MessageChannel ? ((i = new MessageChannel()).port1.onmessage = function (e4) {
              h(e4.data);
            }, n = function n(e4) {
              i.port2.postMessage(e4);
            }) : c && "onreadystatechange" in c.createElement("script") ? (o = c.documentElement, n = function n(e4) {
              var t3 = c.createElement("script");
              t3.onreadystatechange = function () {
                h(e4), t3.onreadystatechange = null, o.removeChild(t3), t3 = null;
              }, o.appendChild(t3);
            }) : n = function n(e4) {
              setTimeout(h, 0, e4);
            } : (s = "setImmediate$" + Math.random() + "$", a2 = function a2(t3) {
              t3.source === e3 && "string" == typeof t3.data && 0 === t3.data.indexOf(s) && h(+t3.data.slice(s.length));
            }, e3.addEventListener ? e3.addEventListener("message", a2, false) : e3.attachEvent("onmessage", a2), n = function n(t3) {
              e3.postMessage(s + t3, "*");
            }), f.setImmediate = function (e4) {
              "function" != typeof e4 && (e4 = new Function("" + e4));
              for (var t3 = new Array(arguments.length - 1), r3 = 0; r3 < t3.length; r3++) t3[r3] = arguments[r3 + 1];
              var o2 = {
                callback: e4,
                args: t3
              };
              return u[l] = o2, n(l), l++;
            }, f.clearImmediate = p;
          }
          function p(e4) {
            delete u[e4];
          }
          function h(e4) {
            if (g) setTimeout(h, 0, e4);else {
              var t3 = u[e4];
              if (t3) {
                g = true;
                try {
                  !function (e5) {
                    var t4 = e5.callback,
                      r3 = e5.args;
                    switch (r3.length) {
                      case 0:
                        t4();
                        break;
                      case 1:
                        t4(r3[0]);
                        break;
                      case 2:
                        t4(r3[0], r3[1]);
                        break;
                      case 3:
                        t4(r3[0], r3[1], r3[2]);
                        break;
                      default:
                        t4.apply(void 0, r3);
                    }
                  }(t3);
                } finally {
                  p(e4), g = false;
                }
              }
            }
          }
        }("undefined" == typeof self ? void 0 === e2 ? this : e2 : self);
      }).call(this, r(6), r(2));
    }, function (e, t, r) {
      e.exports = r(62);
    }, function (e, t, r) {
      (function (t2, n) {
        var o = r(16);
        e.exports = v;
        var i,
          s = r(42);
        v.ReadableState = b;
        r(21).EventEmitter;
        var a2 = function a2(e2, t3) {
            return e2.listeners(t3).length;
          },
          l = r(63),
          u = r(44).Buffer,
          g = t2.Uint8Array || function () {};
        var c = Object.create(r(17));
        c.inherits = r(7);
        var f = r(144),
          p = void 0;
        p = f && f.debuglog ? f.debuglog("stream") : function () {};
        var h,
          d = r(145),
          y = r(64);
        c.inherits(v, l);
        var m = ["error", "close", "destroy", "pause", "resume"];
        function b(e2, t3) {
          e2 = e2 || {};
          var n2 = t3 instanceof (i = i || r(36));
          this.objectMode = !!e2.objectMode, n2 && (this.objectMode = this.objectMode || !!e2.readableObjectMode);
          var o2 = e2.highWaterMark,
            s2 = e2.readableHighWaterMark,
            a3 = this.objectMode ? 16 : 16384;
          this.highWaterMark = o2 || 0 === o2 ? o2 : n2 && (s2 || 0 === s2) ? s2 : a3, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new d(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = false, this.endEmitted = false, this.reading = false, this.sync = true, this.needReadable = false, this.emittedReadable = false, this.readableListening = false, this.resumeScheduled = false, this.destroyed = false, this.defaultEncoding = e2.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = false, this.decoder = null, this.encoding = null, e2.encoding && (h || (h = r(22).StringDecoder), this.decoder = new h(e2.encoding), this.encoding = e2.encoding);
        }
        function v(e2) {
          if (i = i || r(36), !(this instanceof v)) return new v(e2);
          this._readableState = new b(e2, this), this.readable = true, e2 && ("function" == typeof e2.read && (this._read = e2.read), "function" == typeof e2.destroy && (this._destroy = e2.destroy)), l.call(this);
        }
        function _(e2, t3, r2, n2, o2) {
          var i2,
            s2 = e2._readableState;
          null === t3 ? (s2.reading = false, function (e3, t4) {
            if (t4.ended) return;
            if (t4.decoder) {
              var r3 = t4.decoder.end();
              r3 && r3.length && (t4.buffer.push(r3), t4.length += t4.objectMode ? 1 : r3.length);
            }
            t4.ended = true, E(e3);
          }(e2, s2)) : (o2 || (i2 = function (e3, t4) {
            var r3;
            n3 = t4, u.isBuffer(n3) || n3 instanceof g || "string" == typeof t4 || void 0 === t4 || e3.objectMode || (r3 = new TypeError("Invalid non-string/buffer chunk"));
            var n3;
            return r3;
          }(s2, t3)), i2 ? e2.emit("error", i2) : s2.objectMode || t3 && t3.length > 0 ? ("string" == typeof t3 || s2.objectMode || Object.getPrototypeOf(t3) === u.prototype || (t3 = function (e3) {
            return u.from(e3);
          }(t3)), n2 ? s2.endEmitted ? e2.emit("error", new Error("stream.unshift() after end event")) : S(e2, s2, t3, true) : s2.ended ? e2.emit("error", new Error("stream.push() after EOF")) : (s2.reading = false, s2.decoder && !r2 ? (t3 = s2.decoder.write(t3), s2.objectMode || 0 !== t3.length ? S(e2, s2, t3, false) : R(e2, s2)) : S(e2, s2, t3, false))) : n2 || (s2.reading = false));
          return function (e3) {
            return !e3.ended && (e3.needReadable || e3.length < e3.highWaterMark || 0 === e3.length);
          }(s2);
        }
        function S(e2, t3, r2, n2) {
          t3.flowing && 0 === t3.length && !t3.sync ? (e2.emit("data", r2), e2.read(0)) : (t3.length += t3.objectMode ? 1 : r2.length, n2 ? t3.buffer.unshift(r2) : t3.buffer.push(r2), t3.needReadable && E(e2)), R(e2, t3);
        }
        Object.defineProperty(v.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._readableState && this._readableState.destroyed;
          },
          set: function set(e2) {
            this._readableState && (this._readableState.destroyed = e2);
          }
        }), v.prototype.destroy = y.destroy, v.prototype._undestroy = y.undestroy, v.prototype._destroy = function (e2, t3) {
          this.push(null), t3(e2);
        }, v.prototype.push = function (e2, t3) {
          var r2,
            n2 = this._readableState;
          return n2.objectMode ? r2 = true : "string" == typeof e2 && ((t3 = t3 || n2.defaultEncoding) !== n2.encoding && (e2 = u.from(e2, t3), t3 = ""), r2 = true), _(this, e2, t3, false, r2);
        }, v.prototype.unshift = function (e2) {
          return _(this, e2, null, true, false);
        }, v.prototype.isPaused = function () {
          return false === this._readableState.flowing;
        }, v.prototype.setEncoding = function (e2) {
          return h || (h = r(22).StringDecoder), this._readableState.decoder = new h(e2), this._readableState.encoding = e2, this;
        };
        function w(e2, t3) {
          return e2 <= 0 || 0 === t3.length && t3.ended ? 0 : t3.objectMode ? 1 : e2 != e2 ? t3.flowing && t3.length ? t3.buffer.head.data.length : t3.length : (e2 > t3.highWaterMark && (t3.highWaterMark = function (e3) {
            return e3 >= 8388608 ? e3 = 8388608 : (e3--, e3 |= e3 >>> 1, e3 |= e3 >>> 2, e3 |= e3 >>> 4, e3 |= e3 >>> 8, e3 |= e3 >>> 16, e3++), e3;
          }(e2)), e2 <= t3.length ? e2 : t3.ended ? t3.length : (t3.needReadable = true, 0));
        }
        function E(e2) {
          var t3 = e2._readableState;
          t3.needReadable = false, t3.emittedReadable || (p("emitReadable", t3.flowing), t3.emittedReadable = true, t3.sync ? o.nextTick(T, e2) : T(e2));
        }
        function T(e2) {
          p("emit readable"), e2.emit("readable"), I(e2);
        }
        function R(e2, t3) {
          t3.readingMore || (t3.readingMore = true, o.nextTick(A, e2, t3));
        }
        function A(e2, t3) {
          for (var r2 = t3.length; !t3.reading && !t3.flowing && !t3.ended && t3.length < t3.highWaterMark && (p("maybeReadMore read 0"), e2.read(0), r2 !== t3.length);) r2 = t3.length;
          t3.readingMore = false;
        }
        function O(e2) {
          p("readable nexttick read 0"), e2.read(0);
        }
        function C(e2, t3) {
          t3.reading || (p("resume read 0"), e2.read(0)), t3.resumeScheduled = false, t3.awaitDrain = 0, e2.emit("resume"), I(e2), t3.flowing && !t3.reading && e2.read(0);
        }
        function I(e2) {
          var t3 = e2._readableState;
          for (p("flow", t3.flowing); t3.flowing && null !== e2.read(););
        }
        function j(e2, t3) {
          return 0 === t3.length ? null : (t3.objectMode ? r2 = t3.buffer.shift() : !e2 || e2 >= t3.length ? (r2 = t3.decoder ? t3.buffer.join("") : 1 === t3.buffer.length ? t3.buffer.head.data : t3.buffer.concat(t3.length), t3.buffer.clear()) : r2 = function (e3, t4, r3) {
            var n2;
            e3 < t4.head.data.length ? (n2 = t4.head.data.slice(0, e3), t4.head.data = t4.head.data.slice(e3)) : n2 = e3 === t4.head.data.length ? t4.shift() : r3 ? function (e4, t5) {
              var r4 = t5.head,
                n3 = 1,
                o2 = r4.data;
              e4 -= o2.length;
              for (; r4 = r4.next;) {
                var i2 = r4.data,
                  s2 = e4 > i2.length ? i2.length : e4;
                if (s2 === i2.length ? o2 += i2 : o2 += i2.slice(0, e4), 0 === (e4 -= s2)) {
                  s2 === i2.length ? (++n3, r4.next ? t5.head = r4.next : t5.head = t5.tail = null) : (t5.head = r4, r4.data = i2.slice(s2));
                  break;
                }
                ++n3;
              }
              return t5.length -= n3, o2;
            }(e3, t4) : function (e4, t5) {
              var r4 = u.allocUnsafe(e4),
                n3 = t5.head,
                o2 = 1;
              n3.data.copy(r4), e4 -= n3.data.length;
              for (; n3 = n3.next;) {
                var i2 = n3.data,
                  s2 = e4 > i2.length ? i2.length : e4;
                if (i2.copy(r4, r4.length - e4, 0, s2), 0 === (e4 -= s2)) {
                  s2 === i2.length ? (++o2, n3.next ? t5.head = n3.next : t5.head = t5.tail = null) : (t5.head = n3, n3.data = i2.slice(s2));
                  break;
                }
                ++o2;
              }
              return t5.length -= o2, r4;
            }(e3, t4);
            return n2;
          }(e2, t3.buffer, t3.decoder), r2);
          var r2;
        }
        function M(e2) {
          var t3 = e2._readableState;
          if (t3.length > 0) throw new Error('"endReadable()" called on non-empty stream');
          t3.endEmitted || (t3.ended = true, o.nextTick(P, t3, e2));
        }
        function P(e2, t3) {
          e2.endEmitted || 0 !== e2.length || (e2.endEmitted = true, t3.readable = false, t3.emit("end"));
        }
        function N(e2, t3) {
          for (var r2 = 0, n2 = e2.length; r2 < n2; r2++) if (e2[r2] === t3) return r2;
          return -1;
        }
        v.prototype.read = function (e2) {
          p("read", e2), e2 = parseInt(e2, 10);
          var t3 = this._readableState,
            r2 = e2;
          if (0 !== e2 && (t3.emittedReadable = false), 0 === e2 && t3.needReadable && (t3.length >= t3.highWaterMark || t3.ended)) return p("read: emitReadable", t3.length, t3.ended), 0 === t3.length && t3.ended ? M(this) : E(this), null;
          if (0 === (e2 = w(e2, t3)) && t3.ended) return 0 === t3.length && M(this), null;
          var n2,
            o2 = t3.needReadable;
          return p("need readable", o2), (0 === t3.length || t3.length - e2 < t3.highWaterMark) && p("length less than watermark", o2 = true), t3.ended || t3.reading ? p("reading or ended", o2 = false) : o2 && (p("do read"), t3.reading = true, t3.sync = true, 0 === t3.length && (t3.needReadable = true), this._read(t3.highWaterMark), t3.sync = false, t3.reading || (e2 = w(r2, t3))), null === (n2 = e2 > 0 ? j(e2, t3) : null) ? (t3.needReadable = true, e2 = 0) : t3.length -= e2, 0 === t3.length && (t3.ended || (t3.needReadable = true), r2 !== e2 && t3.ended && M(this)), null !== n2 && this.emit("data", n2), n2;
        }, v.prototype._read = function (e2) {
          this.emit("error", new Error("_read() is not implemented"));
        }, v.prototype.pipe = function (e2, t3) {
          var r2 = this,
            i2 = this._readableState;
          switch (i2.pipesCount) {
            case 0:
              i2.pipes = e2;
              break;
            case 1:
              i2.pipes = [i2.pipes, e2];
              break;
            default:
              i2.pipes.push(e2);
          }
          i2.pipesCount += 1, p("pipe count=%d opts=%j", i2.pipesCount, t3);
          var l2 = (!t3 || false !== t3.end) && e2 !== n.stdout && e2 !== n.stderr ? g2 : v2;
          function u2(t4, n2) {
            p("onunpipe"), t4 === r2 && n2 && false === n2.hasUnpiped && (n2.hasUnpiped = true, p("cleanup"), e2.removeListener("close", m2), e2.removeListener("finish", b2), e2.removeListener("drain", c2), e2.removeListener("error", y2), e2.removeListener("unpipe", u2), r2.removeListener("end", g2), r2.removeListener("end", v2), r2.removeListener("data", d2), f2 = true, !i2.awaitDrain || e2._writableState && !e2._writableState.needDrain || c2());
          }
          function g2() {
            p("onend"), e2.end();
          }
          i2.endEmitted ? o.nextTick(l2) : r2.once("end", l2), e2.on("unpipe", u2);
          var c2 = function (e3) {
            return function () {
              var t4 = e3._readableState;
              p("pipeOnDrain", t4.awaitDrain), t4.awaitDrain && t4.awaitDrain--, 0 === t4.awaitDrain && a2(e3, "data") && (t4.flowing = true, I(e3));
            };
          }(r2);
          e2.on("drain", c2);
          var f2 = false;
          var h2 = false;
          function d2(t4) {
            p("ondata"), h2 = false, false !== e2.write(t4) || h2 || ((1 === i2.pipesCount && i2.pipes === e2 || i2.pipesCount > 1 && -1 !== N(i2.pipes, e2)) && !f2 && (p("false write response, pause", r2._readableState.awaitDrain), r2._readableState.awaitDrain++, h2 = true), r2.pause());
          }
          function y2(t4) {
            p("onerror", t4), v2(), e2.removeListener("error", y2), 0 === a2(e2, "error") && e2.emit("error", t4);
          }
          function m2() {
            e2.removeListener("finish", b2), v2();
          }
          function b2() {
            p("onfinish"), e2.removeListener("close", m2), v2();
          }
          function v2() {
            p("unpipe"), r2.unpipe(e2);
          }
          return r2.on("data", d2), function (e3, t4, r3) {
            if ("function" == typeof e3.prependListener) return e3.prependListener(t4, r3);
            e3._events && e3._events[t4] ? s(e3._events[t4]) ? e3._events[t4].unshift(r3) : e3._events[t4] = [r3, e3._events[t4]] : e3.on(t4, r3);
          }(e2, "error", y2), e2.once("close", m2), e2.once("finish", b2), e2.emit("pipe", r2), i2.flowing || (p("pipe resume"), r2.resume()), e2;
        }, v.prototype.unpipe = function (e2) {
          var t3 = this._readableState,
            r2 = {
              hasUnpiped: false
            };
          if (0 === t3.pipesCount) return this;
          if (1 === t3.pipesCount) return e2 && e2 !== t3.pipes || (e2 || (e2 = t3.pipes), t3.pipes = null, t3.pipesCount = 0, t3.flowing = false, e2 && e2.emit("unpipe", this, r2)), this;
          if (!e2) {
            var n2 = t3.pipes,
              o2 = t3.pipesCount;
            t3.pipes = null, t3.pipesCount = 0, t3.flowing = false;
            for (var i2 = 0; i2 < o2; i2++) n2[i2].emit("unpipe", this, r2);
            return this;
          }
          var s2 = N(t3.pipes, e2);
          return -1 === s2 || (t3.pipes.splice(s2, 1), t3.pipesCount -= 1, 1 === t3.pipesCount && (t3.pipes = t3.pipes[0]), e2.emit("unpipe", this, r2)), this;
        }, v.prototype.on = function (e2, t3) {
          var r2 = l.prototype.on.call(this, e2, t3);
          if ("data" === e2) false !== this._readableState.flowing && this.resume();else if ("readable" === e2) {
            var n2 = this._readableState;
            n2.endEmitted || n2.readableListening || (n2.readableListening = n2.needReadable = true, n2.emittedReadable = false, n2.reading ? n2.length && E(this) : o.nextTick(O, this));
          }
          return r2;
        }, v.prototype.addListener = v.prototype.on, v.prototype.resume = function () {
          var e2 = this._readableState;
          return e2.flowing || (p("resume"), e2.flowing = true, function (e3, t3) {
            t3.resumeScheduled || (t3.resumeScheduled = true, o.nextTick(C, e3, t3));
          }(this, e2)), this;
        }, v.prototype.pause = function () {
          return p("call pause flowing=%j", this._readableState.flowing), false !== this._readableState.flowing && (p("pause"), this._readableState.flowing = false, this.emit("pause")), this;
        }, v.prototype.wrap = function (e2) {
          var t3 = this,
            r2 = this._readableState,
            n2 = false;
          for (var o2 in e2.on("end", function () {
            if (p("wrapped end"), r2.decoder && !r2.ended) {
              var e3 = r2.decoder.end();
              e3 && e3.length && t3.push(e3);
            }
            t3.push(null);
          }), e2.on("data", function (o3) {
            (p("wrapped data"), r2.decoder && (o3 = r2.decoder.write(o3)), r2.objectMode && null == o3) || (r2.objectMode || o3 && o3.length) && (t3.push(o3) || (n2 = true, e2.pause()));
          }), e2) void 0 === this[o2] && "function" == typeof e2[o2] && (this[o2] = function (t4) {
            return function () {
              return e2[t4].apply(e2, arguments);
            };
          }(o2));
          for (var i2 = 0; i2 < m.length; i2++) e2.on(m[i2], this.emit.bind(this, m[i2]));
          return this._read = function (t4) {
            p("wrapped _read", t4), n2 && (n2 = false, e2.resume());
          }, this;
        }, Object.defineProperty(v.prototype, "readableHighWaterMark", {
          enumerable: false,
          get: function get() {
            return this._readableState.highWaterMark;
          }
        }), v._fromList = j;
      }).call(this, r(6), r(2));
    }, function (e, t) {}, function (e, t, r) {
      var n = r(44).Buffer,
        o = r(146);
      e.exports = function () {
        function e2() {
          !function (e3, t2) {
            if (!(e3 instanceof t2)) throw new TypeError("Cannot call a class as a function");
          }(this, e2), this.head = null, this.tail = null, this.length = 0;
        }
        return e2.prototype.push = function (e3) {
          var t2 = {
            data: e3,
            next: null
          };
          this.length > 0 ? this.tail.next = t2 : this.head = t2, this.tail = t2, ++this.length;
        }, e2.prototype.unshift = function (e3) {
          var t2 = {
            data: e3,
            next: this.head
          };
          0 === this.length && (this.tail = t2), this.head = t2, ++this.length;
        }, e2.prototype.shift = function () {
          if (0 !== this.length) {
            var e3 = this.head.data;
            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e3;
          }
        }, e2.prototype.clear = function () {
          this.head = this.tail = null, this.length = 0;
        }, e2.prototype.join = function (e3) {
          if (0 === this.length) return "";
          for (var t2 = this.head, r2 = "" + t2.data; t2 = t2.next;) r2 += e3 + t2.data;
          return r2;
        }, e2.prototype.concat = function (e3) {
          if (0 === this.length) return n.alloc(0);
          if (1 === this.length) return this.head.data;
          for (var t2, r2, o2, i = n.allocUnsafe(e3 >>> 0), s = this.head, a2 = 0; s;) t2 = s.data, r2 = i, o2 = a2, t2.copy(r2, o2), a2 += s.data.length, s = s.next;
          return i;
        }, e2;
      }(), o && o.inspect && o.inspect.custom && (e.exports.prototype[o.inspect.custom] = function () {
        var e2 = o.inspect({
          length: this.length
        });
        return this.constructor.name + " " + e2;
      });
    }, function (e, t) {}, function (e, t, r) {
      var n = r(5),
        o = n.Buffer;
      function i(e2, t2) {
        for (var r2 in e2) t2[r2] = e2[r2];
      }
      function s(e2, t2, r2) {
        return o(e2, t2, r2);
      }
      o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? e.exports = n : (i(n, t), t.Buffer = s), i(o, s), s.from = function (e2, t2, r2) {
        if ("number" == typeof e2) throw new TypeError("Argument must not be a number");
        return o(e2, t2, r2);
      }, s.alloc = function (e2, t2, r2) {
        if ("number" != typeof e2) throw new TypeError("Argument must be a number");
        var n2 = o(e2);
        return void 0 !== t2 ? "string" == typeof r2 ? n2.fill(t2, r2) : n2.fill(t2) : n2.fill(0), n2;
      }, s.allocUnsafe = function (e2) {
        if ("number" != typeof e2) throw new TypeError("Argument must be a number");
        return o(e2);
      }, s.allocUnsafeSlow = function (e2) {
        if ("number" != typeof e2) throw new TypeError("Argument must be a number");
        return n.SlowBuffer(e2);
      };
    }, function (e, t, r) {
      var n = r(13),
        o = r(3).LEVEL,
        i = r(20),
        s = e.exports = function () {
          var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          if (i.call(this, e2), !e2.transport || "function" != typeof e2.transport.log) throw new Error("Invalid transport, must be an object with a log method.");
          function t2(e3) {
            this.emit("error", e3, this.transport);
          }
          this.transport = e2.transport, this.level = this.level || e2.transport.level, this.handleExceptions = this.handleExceptions || e2.transport.handleExceptions, this._deprecated(), this.transport.__winstonError || (this.transport.__winstonError = t2.bind(this), this.transport.on("error", this.transport.__winstonError));
        };
      n.inherits(s, i), s.prototype._write = function (e2, t2, r2) {
        if (this.silent || true === e2.exception && !this.handleExceptions) return r2(null);
        (!this.level || this.levels[this.level] >= this.levels[e2[o]]) && this.transport.log(e2[o], e2.message, e2, this._nop), r2(null);
      }, s.prototype._writev = function (e2, t2) {
        for (var r2 = 0; r2 < e2.length; r2++) this._accept(e2[r2]) && (this.transport.log(e2[r2].chunk[o], e2[r2].chunk.message, e2[r2].chunk, this._nop), e2[r2].callback());
        return t2(null);
      }, s.prototype._deprecated = function () {
        console.error([this.transport.name + " is a legacy winston transport. Consider upgrading: ", "- Upgrade docs: https://github.com/winstonjs/winston/blob/master/UPGRADE-3.0.md"].join("\n"));
      }, s.prototype.close = function () {
        this.transport.close && this.transport.close(), this.transport.__winstonError && (this.transport.removeListener("error", this.transport.__winstonError), this.transport.__winstonError = null);
      };
    }, function (e, t, r) {
      (function (t2, n) {
        function o(e2) {
          return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e3) {
            return typeof e3;
          } : function (e3) {
            return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
          })(e2);
        }
        function i(e2, t3) {
          if (!(e2 instanceof t3)) throw new TypeError("Cannot call a class as a function");
        }
        function s(e2, t3) {
          for (var r2 = 0; r2 < t3.length; r2++) {
            var n2 = t3[r2];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
          }
        }
        function a2(e2, t3) {
          return (a2 = Object.setPrototypeOf || function (e3, t4) {
            return e3.__proto__ = t4, e3;
          })(e2, t3);
        }
        function l(e2) {
          var t3 = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if ("function" == typeof Proxy) return true;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), true;
            } catch (e3) {
              return false;
            }
          }();
          return function () {
            var r2,
              n2 = c(e2);
            if (t3) {
              var o2 = c(this).constructor;
              r2 = Reflect.construct(n2, arguments, o2);
            } else r2 = n2.apply(this, arguments);
            return u(this, r2);
          };
        }
        function u(e2, t3) {
          return !t3 || "object" !== o(t3) && "function" != typeof t3 ? g(e2) : t3;
        }
        function g(e2) {
          if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e2;
        }
        function c(e2) {
          return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (e3) {
            return e3.__proto__ || Object.getPrototypeOf(e3);
          })(e2);
        }
        var f = r(65),
          p = r(56),
          h = r(150),
          d = r(160),
          y = r(3).MESSAGE,
          m = r(32),
          b = m.Stream,
          v = m.PassThrough,
          _ = r(20),
          S = r(38)("winston:file"),
          w = r(18),
          E = r(188);
        e.exports = function (e2) {
          !function (e3, t3) {
            if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
            e3.prototype = Object.create(t3 && t3.prototype, {
              constructor: {
                value: e3,
                writable: true,
                configurable: true
              }
            }), t3 && a2(e3, t3);
          }(_2, e2);
          var r2,
            u2,
            m2 = l(_2);
          function _2() {
            var e3,
              t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            function r3(e4) {
              for (var r4 = arguments.length, n2 = new Array(r4 > 1 ? r4 - 1 : 0), o2 = 1; o2 < r4; o2++) n2[o2 - 1] = arguments[o2];
              n2.slice(1).forEach(function (r5) {
                if (t3[r5]) throw new Error("Cannot set ".concat(r5, " and ").concat(e4, " together"));
              });
            }
            if (i(this, _2), (e3 = m2.call(this, t3)).name = t3.name || "file", e3._stream = new v(), e3._stream.setMaxListeners(30), e3._onError = e3._onError.bind(g(e3)), t3.filename || t3.dirname) r3("filename or dirname", "stream"), e3._basename = e3.filename = t3.filename ? p.basename(t3.filename) : "winston.log", e3.dirname = t3.dirname || p.dirname(t3.filename), e3.options = t3.options || {
              flags: "a"
            };else {
              if (!t3.stream) throw new Error("Cannot log to file without filename or stream.");
              console.warn("options.stream will be removed in winston@4. Use winston.transports.Stream"), r3("stream", "filename", "maxsize"), e3._dest = e3._stream.pipe(e3._setupStream(t3.stream)), e3.dirname = p.dirname(e3._dest.path);
            }
            return e3.maxsize = t3.maxsize || null, e3.rotationFormat = t3.rotationFormat || false, e3.zippedArchive = t3.zippedArchive || false, e3.maxFiles = t3.maxFiles || null, e3.eol = t3.eol || w.EOL, e3.tailable = t3.tailable || false, e3._size = 0, e3._pendingSize = 0, e3._created = 0, e3._drain = false, e3._opening = false, e3._ending = false, e3.dirname && e3._createLogDirIfNotExist(e3.dirname), e3.open(), e3;
          }
          return r2 = _2, (u2 = [{
            key: "finishIfEnding",
            value: function value() {
              var e3 = this;
              this._ending && (this._opening ? this.once("open", function () {
                e3._stream.once("finish", function () {
                  return e3.emit("finish");
                }), t2(function () {
                  return e3._stream.end();
                });
              }) : (this._stream.once("finish", function () {
                return e3.emit("finish");
              }), t2(function () {
                return e3._stream.end();
              })));
            }
          }, {
            key: "log",
            value: function value(e3) {
              var t3 = this,
                r3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {};
              if (this.silent) return r3(), true;
              if (this._drain) this._stream.once("drain", function () {
                t3._drain = false, t3.log(e3, r3);
              });else {
                if (!this._rotate) {
                  var o2 = "".concat(e3[y]).concat(this.eol),
                    i2 = n.byteLength(o2);
                  this._pendingSize += i2, this._opening && !this.rotatedWhileOpening && this._needsNewFile(this._size + this._pendingSize) && (this.rotatedWhileOpening = true);
                  var s2 = this._stream.write(o2, a3.bind(this));
                  return s2 ? r3() : (this._drain = true, this._stream.once("drain", function () {
                    t3._drain = false, r3();
                  })), S("written", s2, this._drain), this.finishIfEnding(), s2;
                }
                this._stream.once("rotate", function () {
                  t3._rotate = false, t3.log(e3, r3);
                });
              }
              function a3() {
                var t4 = this;
                this._size += i2, this._pendingSize -= i2, S("logged %s %s", this._size, o2), this.emit("logged", e3), this._opening || this._needsNewFile() && (this._rotate = true, this._endStream(function () {
                  return t4._rotateFile();
                }));
              }
            }
          }, {
            key: "query",
            value: function value(e3, t3) {
              "function" == typeof e3 && (t3 = e3, e3 = {}), e3 = function (e4) {
                return (e4 = e4 || {}).rows = e4.rows || e4.limit || 10, e4.start = e4.start || 0, e4.until = e4.until || new Date(), "object" !== o(e4.until) && (e4.until = new Date(e4.until)), e4.from = e4.from || e4.until - 864e5, "object" !== o(e4.from) && (e4.from = new Date(e4.from)), e4.order = e4.order || "desc", e4;
              }(e3);
              var r3 = p.join(this.dirname, this.filename),
                n2 = "",
                i2 = [],
                s2 = 0,
                a3 = f.createReadStream(r3, {
                  encoding: "utf8"
                });
              function l2(t4, r4) {
                try {
                  var n3 = JSON.parse(t4);
                  (function (t5) {
                    if (t5 && "object" === o(t5)) {
                      var r5 = new Date(t5.timestamp);
                      if (!(e3.from && r5 < e3.from || e3.until && r5 > e3.until || e3.level && e3.level !== t5.level)) return true;
                    }
                  })(n3) && function (t5) {
                    e3.rows && i2.length >= e3.rows && "desc" !== e3.order ? a3.readable && a3.destroy() : (e3.fields && (t5 = e3.fields.reduce(function (e4, r5) {
                      return e4[r5] = t5[r5], e4;
                    }, {})), "desc" === e3.order && i2.length >= e3.rows && i2.shift(), i2.push(t5));
                  }(n3);
                } catch (e4) {
                  r4 || a3.emit("error", e4);
                }
              }
              a3.on("error", function (e4) {
                if (a3.readable && a3.destroy(), t3) return "ENOENT" !== e4.code ? t3(e4) : t3(null, i2);
              }), a3.on("data", function (t4) {
                for (var r4 = (t4 = (n2 + t4).split(/\n+/)).length - 1, o2 = 0; o2 < r4; o2++) (!e3.start || s2 >= e3.start) && l2(t4[o2]), s2++;
                n2 = t4[r4];
              }), a3.on("close", function () {
                n2 && l2(n2, true), "desc" === e3.order && (i2 = i2.reverse()), t3 && t3(null, i2);
              });
            }
          }, {
            key: "stream",
            value: function value() {
              var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t3 = p.join(this.dirname, this.filename),
                r3 = new b(),
                n2 = {
                  file: t3,
                  start: e3.start
                };
              return r3.destroy = E(n2, function (e4, t4) {
                if (e4) return r3.emit("error", e4);
                try {
                  r3.emit("data", t4), t4 = JSON.parse(t4), r3.emit("log", t4);
                } catch (e5) {
                  r3.emit("error", e5);
                }
              }), r3;
            }
          }, {
            key: "open",
            value: function value() {
              var e3 = this;
              this.filename && (this._opening || (this._opening = true, this.stat(function (t3, r3) {
                if (t3) return e3.emit("error", t3);
                S("stat done: %s { size: %s }", e3.filename, r3), e3._size = r3, e3._dest = e3._createStream(e3._stream), e3._opening = false, e3.once("open", function () {
                  e3._stream.eventNames().includes("rotate") ? e3._stream.emit("rotate") : e3._rotate = false;
                });
              })));
            }
          }, {
            key: "stat",
            value: function value(e3) {
              var t3 = this,
                r3 = this._getFile(),
                n2 = p.join(this.dirname, r3);
              f.stat(n2, function (o2, i2) {
                return o2 && "ENOENT" === o2.code ? (S("ENOENT\xA0ok", n2), t3.filename = r3, e3(null, 0)) : o2 ? (S("err ".concat(o2.code, " ").concat(n2)), e3(o2)) : !i2 || t3._needsNewFile(i2.size) ? t3._incFile(function () {
                  return t3.stat(e3);
                }) : (t3.filename = r3, void e3(null, i2.size));
              });
            }
          }, {
            key: "close",
            value: function value(e3) {
              var t3 = this;
              this._stream && this._stream.end(function () {
                e3 && e3(), t3.emit("flush"), t3.emit("closed");
              });
            }
          }, {
            key: "_needsNewFile",
            value: function value(e3) {
              return e3 = e3 || this._size, this.maxsize && e3 >= this.maxsize;
            }
          }, {
            key: "_onError",
            value: function value(e3) {
              this.emit("error", e3);
            }
          }, {
            key: "_setupStream",
            value: function value(e3) {
              return e3.on("error", this._onError), e3;
            }
          }, {
            key: "_cleanupStream",
            value: function value(e3) {
              return e3.removeListener("error", this._onError), e3;
            }
          }, {
            key: "_rotateFile",
            value: function value() {
              var e3 = this;
              this._incFile(function () {
                return e3.open();
              });
            }
          }, {
            key: "_endStream",
            value: function value() {
              var e3 = this,
                t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function () {};
              this._dest ? (this._stream.unpipe(this._dest), this._dest.end(function () {
                e3._cleanupStream(e3._dest), t3();
              })) : t3();
            }
          }, {
            key: "_createStream",
            value: function value(e3) {
              var t3 = this,
                r3 = p.join(this.dirname, this.filename);
              S("create stream start", r3, this.options);
              var n2 = f.createWriteStream(r3, this.options).on("error", function (e4) {
                return S(e4);
              }).on("close", function () {
                return S("close", n2.path, n2.bytesWritten);
              }).on("open", function () {
                S("file open ok", r3), t3.emit("open", r3), e3.pipe(n2), t3.rotatedWhileOpening && (t3._stream = new v(), t3._stream.setMaxListeners(30), t3._rotateFile(), t3.rotatedWhileOpening = false, t3._cleanupStream(n2), e3.end());
              });
              if (S("create stream ok", r3), this.zippedArchive) {
                var o2 = d.createGzip();
                return o2.pipe(n2), o2;
              }
              return n2;
            }
          }, {
            key: "_incFile",
            value: function value(e3) {
              S("_incFile", this.filename);
              var t3 = p.extname(this._basename),
                r3 = p.basename(this._basename, t3);
              this.tailable ? this._checkMaxFilesTailable(t3, r3, e3) : (this._created += 1, this._checkMaxFilesIncrementing(t3, r3, e3));
            }
          }, {
            key: "_getFile",
            value: function value() {
              var e3 = p.extname(this._basename),
                t3 = p.basename(this._basename, e3),
                r3 = this.rotationFormat ? this.rotationFormat() : this._created,
                n2 = !this.tailable && this._created ? "".concat(t3).concat(r3).concat(e3) : "".concat(t3).concat(e3);
              return this.zippedArchive && !this.tailable ? "".concat(n2, ".gz") : n2;
            }
          }, {
            key: "_checkMaxFilesIncrementing",
            value: function value(e3, r3, n2) {
              if (!this.maxFiles || this._created < this.maxFiles) return t2(n2);
              var o2 = this._created - this.maxFiles,
                i2 = 0 !== o2 ? o2 : "",
                s2 = this.zippedArchive ? ".gz" : "",
                a3 = "".concat(r3).concat(i2).concat(e3).concat(s2),
                l2 = p.join(this.dirname, a3);
              f.unlink(l2, n2);
            }
          }, {
            key: "_checkMaxFilesTailable",
            value: function value(e3, t3, r3) {
              var n2 = this,
                o2 = [];
              if (this.maxFiles) {
                for (var i2 = this.zippedArchive ? ".gz" : "", s2 = this.maxFiles - 1; s2 > 1; s2--) o2.push(function (r4, n3) {
                  var o3 = this,
                    s3 = "".concat(t3).concat(r4 - 1).concat(e3).concat(i2),
                    a3 = p.join(this.dirname, s3);
                  f.exists(a3, function (l2) {
                    if (!l2) return n3(null);
                    s3 = "".concat(t3).concat(r4).concat(e3).concat(i2), f.rename(a3, p.join(o3.dirname, s3), n3);
                  });
                }.bind(this, s2));
                h(o2, function () {
                  f.rename(p.join(n2.dirname, "".concat(t3).concat(e3)), p.join(n2.dirname, "".concat(t3, "1").concat(e3).concat(i2)), r3);
                });
              }
            }
          }, {
            key: "_createLogDirIfNotExist",
            value: function value(e3) {
              f.existsSync(e3) || f.mkdirSync(e3, {
                recursive: true
              });
            }
          }]) && s(r2.prototype, u2), _2;
        }(_);
      }).call(this, r(15).setImmediate, r(5).Buffer);
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2, t2) {
        return (0, n.default)(o.default, e2, t2);
      };
      var n = i(r(151)),
        o = i(r(155));
      function i(e2) {
        return e2 && e2.__esModule ? e2 : {
          default: e2
        };
      }
      e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      });
      var n = s(r(45)),
        o = s(r(25)),
        i = s(r(30));
      function s(e2) {
        return e2 && e2.__esModule ? e2 : {
          default: e2
        };
      }
      t.default = (0, i.default)(function (e2, t2, r2) {
        var i2 = (0, n.default)(t2) ? [] : {};
        e2(t2, function (e3, t3, r3) {
          (0, o.default)(e3)(function (e4) {
            var _n, _n2;
            for (var _len6 = arguments.length, n2 = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
              n2[_key6 - 1] = arguments[_key6];
            }
            n2.length < 2 && (_n = n2, _n2 = _slicedToArray(_n, 1), n2 = _n2[0], _n), i2[t3] = n2, r3(e4);
          });
        }, function (e3) {
          return r2(e3, i2);
        });
      }, 3), e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2) {
        if ((0, i.isAsync)(e2)) return function () {
          for (var _len7 = arguments.length, t2 = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            t2[_key7] = arguments[_key7];
          }
          var r2 = t2.pop();
          return a2(e2.apply(this, t2), r2);
        };
        return (0, n.default)(function (t2, r2) {
          var n2;
          try {
            n2 = e2.apply(this, t2);
          } catch (e3) {
            return r2(e3);
          }
          if (n2 && "function" == typeof n2.then) return a2(n2, r2);
          r2(null, n2);
        });
      };
      var n = s(r(153)),
        o = s(r(154)),
        i = r(25);
      function s(e2) {
        return e2 && e2.__esModule ? e2 : {
          default: e2
        };
      }
      function a2(e2, t2) {
        return e2.then(function (e3) {
          l(t2, null, e3);
        }, function (e3) {
          l(t2, e3 && e3.message ? e3 : new Error(e3));
        });
      }
      function l(e2, t2, r2) {
        try {
          e2(t2, r2);
        } catch (e3) {
          (0, o.default)(function (e4) {
            throw e4;
          }, e3);
        }
      }
      e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2) {
        return function () {
          for (var _len8 = arguments.length, t2 = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            t2[_key8] = arguments[_key8];
          }
          var r2 = t2.pop();
          return e2.call(this, t2, r2);
        };
      }, e.exports = t.default;
    }, function (e, t, r) {
      (function (e2, r2) {
        Object.defineProperty(t, "__esModule", {
          value: true
        }), t.fallback = s, t.wrap = a2;
        var n,
          o = t.hasSetImmediate = "function" == typeof e2 && e2,
          i = t.hasNextTick = "object" == typeof r2 && "function" == typeof r2.nextTick;
        function s(e3) {
          setTimeout(e3, 0);
        }
        function a2(e3) {
          return function (t2) {
            for (var _len9 = arguments.length, r3 = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
              r3[_key9 - 1] = arguments[_key9];
            }
            return e3(function () {
              return t2.apply(void 0, r3);
            });
          };
        }
        n = o ? e2 : i ? r2.nextTick : s, t.default = a2(n);
      }).call(this, r(15).setImmediate, r(2));
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      });
      var n = i(r(66)),
        o = i(r(30));
      function i(e2) {
        return e2 && e2.__esModule ? e2 : {
          default: e2
        };
      }
      t.default = (0, o.default)(function (e2, t2, r2) {
        return (0, n.default)(e2, 1, t2, r2);
      }, 3), e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      });
      var n = u(r(67)),
        o = u(r(157)),
        i = u(r(68)),
        s = r(25),
        a2 = u(r(159)),
        l = u(r(46));
      function u(e2) {
        return e2 && e2.__esModule ? e2 : {
          default: e2
        };
      }
      t.default = function (e2) {
        return function (t2, r2, u2) {
          if (u2 = (0, n.default)(u2), e2 <= 0) throw new RangeError("concurrency limit cannot be less than 1");
          if (!t2) return u2(null);
          if ((0, s.isAsyncGenerator)(t2)) return (0, a2.default)(t2, e2, r2, u2);
          if ((0, s.isAsyncIterable)(t2)) return (0, a2.default)(t2[Symbol.asyncIterator](), e2, r2, u2);
          var g = (0, o.default)(t2),
            c = false,
            f = false,
            p = 0,
            h = false;
          function d(e3, t3) {
            if (!f) if (p -= 1, e3) c = true, u2(e3);else if (false === e3) c = true, f = true;else {
              if (t3 === l.default || c && p <= 0) return c = true, u2(null);
              h || y();
            }
          }
          function y() {
            for (h = true; p < e2 && !c;) {
              var t3 = g();
              if (null === t3) return c = true, void (p <= 0 && u2(null));
              p += 1, r2(t3.value, t3.key, (0, i.default)(d));
            }
            h = false;
          }
          y();
        };
      }, e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2) {
        if ((0, n.default)(e2)) return function (e3) {
          var t3 = -1,
            r3 = e3.length;
          return function () {
            return ++t3 < r3 ? {
              value: e3[t3],
              key: t3
            } : null;
          };
        }(e2);
        var t2 = (0, o.default)(e2);
        return t2 ? function (e3) {
          var t3 = -1;
          return function () {
            var r3 = e3.next();
            return r3.done ? null : (t3++, {
              value: r3.value,
              key: t3
            });
          };
        }(t2) : (r2 = e2, i2 = r2 ? Object.keys(r2) : [], s = -1, a2 = i2.length, function () {
          var e3 = i2[++s];
          return s < a2 ? {
            value: r2[e3],
            key: e3
          } : null;
        });
        var r2, i2, s, a2;
      };
      var n = i(r(45)),
        o = i(r(158));
      function i(e2) {
        return e2 && e2.__esModule ? e2 : {
          default: e2
        };
      }
      e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2) {
        return e2[Symbol.iterator] && e2[Symbol.iterator]();
      }, e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2, t2, r2, n2) {
        var o2 = false,
          s = false,
          a2 = false,
          l = 0,
          u = 0;
        function g() {
          l >= t2 || a2 || o2 || (a2 = true, e2.next().then(function (_ref12) {
            var e3 = _ref12.value,
              t3 = _ref12.done;
            if (!s && !o2) {
              if (a2 = false, t3) return o2 = true, void (l <= 0 && n2(null));
              l++, r2(e3, u, c), u++, g();
            }
          }).catch(f));
        }
        function c(e3, t3) {
          if (l -= 1, !s) return e3 ? f(e3) : false === e3 ? (o2 = true, void (s = true)) : t3 === i.default || o2 && l <= 0 ? (o2 = true, n2(null)) : void g();
        }
        function f(e3) {
          s || (a2 = false, o2 = true, n2(e3));
        }
        g();
      };
      var n,
        o = r(46),
        i = (n = o) && n.__esModule ? n : {
          default: n
        };
      e.exports = t.default;
    }, function (e, t, r) {
      (function (e2) {
        var n = r(5).Buffer,
          o = r(161).Transform,
          i = r(169),
          s = r(13),
          a2 = r(74).ok,
          l = r(5).kMaxLength,
          u = "Cannot create final Buffer. It would be larger than 0x" + l.toString(16) + " bytes";
        i.Z_MIN_WINDOWBITS = 8, i.Z_MAX_WINDOWBITS = 15, i.Z_DEFAULT_WINDOWBITS = 15, i.Z_MIN_CHUNK = 64, i.Z_MAX_CHUNK = 1 / 0, i.Z_DEFAULT_CHUNK = 16384, i.Z_MIN_MEMLEVEL = 1, i.Z_MAX_MEMLEVEL = 9, i.Z_DEFAULT_MEMLEVEL = 8, i.Z_MIN_LEVEL = -1, i.Z_MAX_LEVEL = 9, i.Z_DEFAULT_LEVEL = i.Z_DEFAULT_COMPRESSION;
        for (var g = Object.keys(i), c = 0; c < g.length; c++) {
          var f = g[c];
          f.match(/^Z/) && Object.defineProperty(t, f, {
            enumerable: true,
            value: i[f],
            writable: false
          });
        }
        for (var p = {
            Z_OK: i.Z_OK,
            Z_STREAM_END: i.Z_STREAM_END,
            Z_NEED_DICT: i.Z_NEED_DICT,
            Z_ERRNO: i.Z_ERRNO,
            Z_STREAM_ERROR: i.Z_STREAM_ERROR,
            Z_DATA_ERROR: i.Z_DATA_ERROR,
            Z_MEM_ERROR: i.Z_MEM_ERROR,
            Z_BUF_ERROR: i.Z_BUF_ERROR,
            Z_VERSION_ERROR: i.Z_VERSION_ERROR
          }, h = Object.keys(p), d = 0; d < h.length; d++) {
          var y = h[d];
          p[p[y]] = y;
        }
        function m(e3, t2, r2) {
          var o2 = [],
            i2 = 0;
          function s2() {
            for (var t3; null !== (t3 = e3.read());) o2.push(t3), i2 += t3.length;
            e3.once("readable", s2);
          }
          function a3() {
            var t3,
              s3 = null;
            i2 >= l ? s3 = new RangeError(u) : t3 = n.concat(o2, i2), o2 = [], e3.close(), r2(s3, t3);
          }
          e3.on("error", function (t3) {
            e3.removeListener("end", a3), e3.removeListener("readable", s2), r2(t3);
          }), e3.on("end", a3), e3.end(t2), s2();
        }
        function b(e3, t2) {
          if ("string" == typeof t2 && (t2 = n.from(t2)), !n.isBuffer(t2)) throw new TypeError("Not a string or buffer");
          var r2 = e3._finishFlushFlag;
          return e3._processChunk(t2, r2);
        }
        function v(e3) {
          if (!(this instanceof v)) return new v(e3);
          O.call(this, e3, i.DEFLATE);
        }
        function _(e3) {
          if (!(this instanceof _)) return new _(e3);
          O.call(this, e3, i.INFLATE);
        }
        function S(e3) {
          if (!(this instanceof S)) return new S(e3);
          O.call(this, e3, i.GZIP);
        }
        function w(e3) {
          if (!(this instanceof w)) return new w(e3);
          O.call(this, e3, i.GUNZIP);
        }
        function E(e3) {
          if (!(this instanceof E)) return new E(e3);
          O.call(this, e3, i.DEFLATERAW);
        }
        function T(e3) {
          if (!(this instanceof T)) return new T(e3);
          O.call(this, e3, i.INFLATERAW);
        }
        function R(e3) {
          if (!(this instanceof R)) return new R(e3);
          O.call(this, e3, i.UNZIP);
        }
        function A(e3) {
          return e3 === i.Z_NO_FLUSH || e3 === i.Z_PARTIAL_FLUSH || e3 === i.Z_SYNC_FLUSH || e3 === i.Z_FULL_FLUSH || e3 === i.Z_FINISH || e3 === i.Z_BLOCK;
        }
        function O(e3, r2) {
          var s2 = this;
          if (this._opts = e3 = e3 || {}, this._chunkSize = e3.chunkSize || t.Z_DEFAULT_CHUNK, o.call(this, e3), e3.flush && !A(e3.flush)) throw new Error("Invalid flush flag: " + e3.flush);
          if (e3.finishFlush && !A(e3.finishFlush)) throw new Error("Invalid flush flag: " + e3.finishFlush);
          if (this._flushFlag = e3.flush || i.Z_NO_FLUSH, this._finishFlushFlag = void 0 !== e3.finishFlush ? e3.finishFlush : i.Z_FINISH, e3.chunkSize && (e3.chunkSize < t.Z_MIN_CHUNK || e3.chunkSize > t.Z_MAX_CHUNK)) throw new Error("Invalid chunk size: " + e3.chunkSize);
          if (e3.windowBits && (e3.windowBits < t.Z_MIN_WINDOWBITS || e3.windowBits > t.Z_MAX_WINDOWBITS)) throw new Error("Invalid windowBits: " + e3.windowBits);
          if (e3.level && (e3.level < t.Z_MIN_LEVEL || e3.level > t.Z_MAX_LEVEL)) throw new Error("Invalid compression level: " + e3.level);
          if (e3.memLevel && (e3.memLevel < t.Z_MIN_MEMLEVEL || e3.memLevel > t.Z_MAX_MEMLEVEL)) throw new Error("Invalid memLevel: " + e3.memLevel);
          if (e3.strategy && e3.strategy != t.Z_FILTERED && e3.strategy != t.Z_HUFFMAN_ONLY && e3.strategy != t.Z_RLE && e3.strategy != t.Z_FIXED && e3.strategy != t.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + e3.strategy);
          if (e3.dictionary && !n.isBuffer(e3.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
          this._handle = new i.Zlib(r2);
          var a3 = this;
          this._hadError = false, this._handle.onerror = function (e4, r3) {
            C(a3), a3._hadError = true;
            var n2 = new Error(e4);
            n2.errno = r3, n2.code = t.codes[r3], a3.emit("error", n2);
          };
          var l2 = t.Z_DEFAULT_COMPRESSION;
          "number" == typeof e3.level && (l2 = e3.level);
          var u2 = t.Z_DEFAULT_STRATEGY;
          "number" == typeof e3.strategy && (u2 = e3.strategy), this._handle.init(e3.windowBits || t.Z_DEFAULT_WINDOWBITS, l2, e3.memLevel || t.Z_DEFAULT_MEMLEVEL, u2, e3.dictionary), this._buffer = n.allocUnsafe(this._chunkSize), this._offset = 0, this._level = l2, this._strategy = u2, this.once("end", this.close), Object.defineProperty(this, "_closed", {
            get: function get() {
              return !s2._handle;
            },
            configurable: true,
            enumerable: true
          });
        }
        function C(t2, r2) {
          r2 && e2.nextTick(r2), t2._handle && (t2._handle.close(), t2._handle = null);
        }
        function I(e3) {
          e3.emit("close");
        }
        Object.defineProperty(t, "codes", {
          enumerable: true,
          value: Object.freeze(p),
          writable: false
        }), t.Deflate = v, t.Inflate = _, t.Gzip = S, t.Gunzip = w, t.DeflateRaw = E, t.InflateRaw = T, t.Unzip = R, t.createDeflate = function (e3) {
          return new v(e3);
        }, t.createInflate = function (e3) {
          return new _(e3);
        }, t.createDeflateRaw = function (e3) {
          return new E(e3);
        }, t.createInflateRaw = function (e3) {
          return new T(e3);
        }, t.createGzip = function (e3) {
          return new S(e3);
        }, t.createGunzip = function (e3) {
          return new w(e3);
        }, t.createUnzip = function (e3) {
          return new R(e3);
        }, t.deflate = function (e3, t2, r2) {
          return "function" == typeof t2 && (r2 = t2, t2 = {}), m(new v(t2), e3, r2);
        }, t.deflateSync = function (e3, t2) {
          return b(new v(t2), e3);
        }, t.gzip = function (e3, t2, r2) {
          return "function" == typeof t2 && (r2 = t2, t2 = {}), m(new S(t2), e3, r2);
        }, t.gzipSync = function (e3, t2) {
          return b(new S(t2), e3);
        }, t.deflateRaw = function (e3, t2, r2) {
          return "function" == typeof t2 && (r2 = t2, t2 = {}), m(new E(t2), e3, r2);
        }, t.deflateRawSync = function (e3, t2) {
          return b(new E(t2), e3);
        }, t.unzip = function (e3, t2, r2) {
          return "function" == typeof t2 && (r2 = t2, t2 = {}), m(new R(t2), e3, r2);
        }, t.unzipSync = function (e3, t2) {
          return b(new R(t2), e3);
        }, t.inflate = function (e3, t2, r2) {
          return "function" == typeof t2 && (r2 = t2, t2 = {}), m(new _(t2), e3, r2);
        }, t.inflateSync = function (e3, t2) {
          return b(new _(t2), e3);
        }, t.gunzip = function (e3, t2, r2) {
          return "function" == typeof t2 && (r2 = t2, t2 = {}), m(new w(t2), e3, r2);
        }, t.gunzipSync = function (e3, t2) {
          return b(new w(t2), e3);
        }, t.inflateRaw = function (e3, t2, r2) {
          return "function" == typeof t2 && (r2 = t2, t2 = {}), m(new T(t2), e3, r2);
        }, t.inflateRawSync = function (e3, t2) {
          return b(new T(t2), e3);
        }, s.inherits(O, o), O.prototype.params = function (r2, n2, o2) {
          if (r2 < t.Z_MIN_LEVEL || r2 > t.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + r2);
          if (n2 != t.Z_FILTERED && n2 != t.Z_HUFFMAN_ONLY && n2 != t.Z_RLE && n2 != t.Z_FIXED && n2 != t.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + n2);
          if (this._level !== r2 || this._strategy !== n2) {
            var s2 = this;
            this.flush(i.Z_SYNC_FLUSH, function () {
              a2(s2._handle, "zlib binding closed"), s2._handle.params(r2, n2), s2._hadError || (s2._level = r2, s2._strategy = n2, o2 && o2());
            });
          } else e2.nextTick(o2);
        }, O.prototype.reset = function () {
          return a2(this._handle, "zlib binding closed"), this._handle.reset();
        }, O.prototype._flush = function (e3) {
          this._transform(n.alloc(0), "", e3);
        }, O.prototype.flush = function (t2, r2) {
          var o2 = this,
            s2 = this._writableState;
          ("function" == typeof t2 || void 0 === t2 && !r2) && (r2 = t2, t2 = i.Z_FULL_FLUSH), s2.ended ? r2 && e2.nextTick(r2) : s2.ending ? r2 && this.once("end", r2) : s2.needDrain ? r2 && this.once("drain", function () {
            return o2.flush(t2, r2);
          }) : (this._flushFlag = t2, this.write(n.alloc(0), "", r2));
        }, O.prototype.close = function (t2) {
          C(this, t2), e2.nextTick(I, this);
        }, O.prototype._transform = function (e3, t2, r2) {
          var o2,
            s2 = this._writableState,
            a3 = (s2.ending || s2.ended) && (!e3 || s2.length === e3.length);
          return null === e3 || n.isBuffer(e3) ? this._handle ? (a3 ? o2 = this._finishFlushFlag : (o2 = this._flushFlag, e3.length >= s2.length && (this._flushFlag = this._opts.flush || i.Z_NO_FLUSH)), void this._processChunk(e3, o2, r2)) : r2(new Error("zlib binding closed")) : r2(new Error("invalid input"));
        }, O.prototype._processChunk = function (e3, t2, r2) {
          var o2 = e3 && e3.length,
            i2 = this._chunkSize - this._offset,
            s2 = 0,
            g2 = this,
            c2 = "function" == typeof r2;
          if (!c2) {
            var f2,
              p2 = [],
              h2 = 0;
            this.on("error", function (e4) {
              f2 = e4;
            }), a2(this._handle, "zlib binding closed");
            do {
              var d2 = this._handle.writeSync(t2, e3, s2, o2, this._buffer, this._offset, i2);
            } while (!this._hadError && b2(d2[0], d2[1]));
            if (this._hadError) throw f2;
            if (h2 >= l) throw C(this), new RangeError(u);
            var y2 = n.concat(p2, h2);
            return C(this), y2;
          }
          a2(this._handle, "zlib binding closed");
          var m2 = this._handle.write(t2, e3, s2, o2, this._buffer, this._offset, i2);
          function b2(l2, u2) {
            if (this && (this.buffer = null, this.callback = null), !g2._hadError) {
              var f3 = i2 - u2;
              if (a2(f3 >= 0, "have should not go down"), f3 > 0) {
                var d3 = g2._buffer.slice(g2._offset, g2._offset + f3);
                g2._offset += f3, c2 ? g2.push(d3) : (p2.push(d3), h2 += d3.length);
              }
              if ((0 === u2 || g2._offset >= g2._chunkSize) && (i2 = g2._chunkSize, g2._offset = 0, g2._buffer = n.allocUnsafe(g2._chunkSize)), 0 === u2) {
                if (s2 += o2 - l2, o2 = l2, !c2) return true;
                var y3 = g2._handle.write(t2, e3, s2, o2, g2._buffer, g2._offset, g2._chunkSize);
                return y3.callback = b2, void (y3.buffer = e3);
              }
              if (!c2) return false;
              r2();
            }
          }
          m2.buffer = e3, m2.callback = b2;
        }, s.inherits(v, O), s.inherits(_, O), s.inherits(S, O), s.inherits(w, O), s.inherits(E, O), s.inherits(T, O), s.inherits(R, O);
      }).call(this, r(2));
    }, function (e, t, r) {
      e.exports = o;
      var n = r(21).EventEmitter;
      function o() {
        n.call(this);
      }
      r(7)(o, n), o.Readable = r(31), o.Writable = r(73), o.Duplex = r(166), o.Transform = r(167), o.PassThrough = r(168), o.Stream = o, o.prototype.pipe = function (e2, t2) {
        var r2 = this;
        function o2(t3) {
          e2.writable && false === e2.write(t3) && r2.pause && r2.pause();
        }
        function i() {
          r2.readable && r2.resume && r2.resume();
        }
        r2.on("data", o2), e2.on("drain", i), e2._isStdio || t2 && false === t2.end || (r2.on("end", a2), r2.on("close", l));
        var s = false;
        function a2() {
          s || (s = true, e2.end());
        }
        function l() {
          s || (s = true, "function" == typeof e2.destroy && e2.destroy());
        }
        function u(e3) {
          if (g(), 0 === n.listenerCount(this, "error")) throw e3;
        }
        function g() {
          r2.removeListener("data", o2), e2.removeListener("drain", i), r2.removeListener("end", a2), r2.removeListener("close", l), r2.removeListener("error", u), e2.removeListener("error", u), r2.removeListener("end", g), r2.removeListener("close", g), e2.removeListener("close", g);
        }
        return r2.on("error", u), e2.on("error", u), r2.on("end", g), r2.on("close", g), e2.on("close", g), e2.emit("pipe", r2), e2;
      };
    }, function (e, t) {}, function (e, t, r) {
      var n = r(47).Buffer,
        o = r(164);
      e.exports = function () {
        function e2() {
          !function (e3, t2) {
            if (!(e3 instanceof t2)) throw new TypeError("Cannot call a class as a function");
          }(this, e2), this.head = null, this.tail = null, this.length = 0;
        }
        return e2.prototype.push = function (e3) {
          var t2 = {
            data: e3,
            next: null
          };
          this.length > 0 ? this.tail.next = t2 : this.head = t2, this.tail = t2, ++this.length;
        }, e2.prototype.unshift = function (e3) {
          var t2 = {
            data: e3,
            next: this.head
          };
          0 === this.length && (this.tail = t2), this.head = t2, ++this.length;
        }, e2.prototype.shift = function () {
          if (0 !== this.length) {
            var e3 = this.head.data;
            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e3;
          }
        }, e2.prototype.clear = function () {
          this.head = this.tail = null, this.length = 0;
        }, e2.prototype.join = function (e3) {
          if (0 === this.length) return "";
          for (var t2 = this.head, r2 = "" + t2.data; t2 = t2.next;) r2 += e3 + t2.data;
          return r2;
        }, e2.prototype.concat = function (e3) {
          if (0 === this.length) return n.alloc(0);
          if (1 === this.length) return this.head.data;
          for (var t2, r2, o2, i = n.allocUnsafe(e3 >>> 0), s = this.head, a2 = 0; s;) t2 = s.data, r2 = i, o2 = a2, t2.copy(r2, o2), a2 += s.data.length, s = s.next;
          return i;
        }, e2;
      }(), o && o.inspect && o.inspect.custom && (e.exports.prototype[o.inspect.custom] = function () {
        var e2 = o.inspect({
          length: this.length
        });
        return this.constructor.name + " " + e2;
      });
    }, function (e, t) {}, function (e, t, r) {
      e.exports = i;
      var n = r(72),
        o = r(17);
      function i(e2) {
        if (!(this instanceof i)) return new i(e2);
        n.call(this, e2);
      }
      o.inherits = r(7), o.inherits(i, n), i.prototype._transform = function (e2, t2, r2) {
        r2(null, e2);
      };
    }, function (e, t, r) {
      e.exports = r(23);
    }, function (e, t, r) {
      e.exports = r(31).Transform;
    }, function (e, t, r) {
      e.exports = r(31).PassThrough;
    }, function (e, t, r) {
      (function (e2, n) {
        var o = r(74),
          i = r(171),
          s = r(172),
          a2 = r(175),
          l = r(178);
        for (var u in l) t[u] = l[u];
        t.NONE = 0, t.DEFLATE = 1, t.INFLATE = 2, t.GZIP = 3, t.GUNZIP = 4, t.DEFLATERAW = 5, t.INFLATERAW = 6, t.UNZIP = 7;
        function g(e3) {
          if ("number" != typeof e3 || e3 < t.DEFLATE || e3 > t.UNZIP) throw new TypeError("Bad argument");
          this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = false, this.level = 0, this.memLevel = 0, this.mode = e3, this.strategy = 0, this.windowBits = 0, this.write_in_progress = false, this.pending_close = false, this.gzip_id_bytes_read = 0;
        }
        g.prototype.close = function () {
          this.write_in_progress ? this.pending_close = true : (this.pending_close = false, o(this.init_done, "close before init"), o(this.mode <= t.UNZIP), this.mode === t.DEFLATE || this.mode === t.GZIP || this.mode === t.DEFLATERAW ? s.deflateEnd(this.strm) : this.mode !== t.INFLATE && this.mode !== t.GUNZIP && this.mode !== t.INFLATERAW && this.mode !== t.UNZIP || a2.inflateEnd(this.strm), this.mode = t.NONE, this.dictionary = null);
        }, g.prototype.write = function (e3, t2, r2, n2, o2, i2, s2) {
          return this._write(true, e3, t2, r2, n2, o2, i2, s2);
        }, g.prototype.writeSync = function (e3, t2, r2, n2, o2, i2, s2) {
          return this._write(false, e3, t2, r2, n2, o2, i2, s2);
        }, g.prototype._write = function (r2, i2, s2, a3, l2, u2, g2, c) {
          if (o.equal(arguments.length, 8), o(this.init_done, "write before init"), o(this.mode !== t.NONE, "already finalized"), o.equal(false, this.write_in_progress, "write already in progress"), o.equal(false, this.pending_close, "close is pending"), this.write_in_progress = true, o.equal(false, void 0 === i2, "must provide flush value"), this.write_in_progress = true, i2 !== t.Z_NO_FLUSH && i2 !== t.Z_PARTIAL_FLUSH && i2 !== t.Z_SYNC_FLUSH && i2 !== t.Z_FULL_FLUSH && i2 !== t.Z_FINISH && i2 !== t.Z_BLOCK) throw new Error("Invalid flush value");
          if (null == s2 && (s2 = e2.alloc(0), l2 = 0, a3 = 0), this.strm.avail_in = l2, this.strm.input = s2, this.strm.next_in = a3, this.strm.avail_out = c, this.strm.output = u2, this.strm.next_out = g2, this.flush = i2, !r2) return this._process(), this._checkError() ? this._afterSync() : void 0;
          var f = this;
          return n.nextTick(function () {
            f._process(), f._after();
          }), this;
        }, g.prototype._afterSync = function () {
          var e3 = this.strm.avail_out,
            t2 = this.strm.avail_in;
          return this.write_in_progress = false, [t2, e3];
        }, g.prototype._process = function () {
          var e3 = null;
          switch (this.mode) {
            case t.DEFLATE:
            case t.GZIP:
            case t.DEFLATERAW:
              this.err = s.deflate(this.strm, this.flush);
              break;
            case t.UNZIP:
              switch (this.strm.avail_in > 0 && (e3 = this.strm.next_in), this.gzip_id_bytes_read) {
                case 0:
                  if (null === e3) break;
                  if (31 !== this.strm.input[e3]) {
                    this.mode = t.INFLATE;
                    break;
                  }
                  if (this.gzip_id_bytes_read = 1, e3++, 1 === this.strm.avail_in) break;
                case 1:
                  if (null === e3) break;
                  139 === this.strm.input[e3] ? (this.gzip_id_bytes_read = 2, this.mode = t.GUNZIP) : this.mode = t.INFLATE;
                  break;
                default:
                  throw new Error("invalid number of gzip magic number bytes read");
              }
            case t.INFLATE:
            case t.GUNZIP:
            case t.INFLATERAW:
              for (this.err = a2.inflate(this.strm, this.flush), this.err === t.Z_NEED_DICT && this.dictionary && (this.err = a2.inflateSetDictionary(this.strm, this.dictionary), this.err === t.Z_OK ? this.err = a2.inflate(this.strm, this.flush) : this.err === t.Z_DATA_ERROR && (this.err = t.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === t.GUNZIP && this.err === t.Z_STREAM_END && 0 !== this.strm.next_in[0];) this.reset(), this.err = a2.inflate(this.strm, this.flush);
              break;
            default:
              throw new Error("Unknown mode " + this.mode);
          }
        }, g.prototype._checkError = function () {
          switch (this.err) {
            case t.Z_OK:
            case t.Z_BUF_ERROR:
              if (0 !== this.strm.avail_out && this.flush === t.Z_FINISH) return this._error("unexpected end of file"), false;
              break;
            case t.Z_STREAM_END:
              break;
            case t.Z_NEED_DICT:
              return null == this.dictionary ? this._error("Missing dictionary") : this._error("Bad dictionary"), false;
            default:
              return this._error("Zlib error"), false;
          }
          return true;
        }, g.prototype._after = function () {
          if (this._checkError()) {
            var e3 = this.strm.avail_out,
              t2 = this.strm.avail_in;
            this.write_in_progress = false, this.callback(t2, e3), this.pending_close && this.close();
          }
        }, g.prototype._error = function (e3) {
          this.strm.msg && (e3 = this.strm.msg), this.onerror(e3, this.err), this.write_in_progress = false, this.pending_close && this.close();
        }, g.prototype.init = function (e3, r2, n2, i2, s2) {
          o(4 === arguments.length || 5 === arguments.length, "init(windowBits, level, memLevel, strategy, [dictionary])"), o(e3 >= 8 && e3 <= 15, "invalid windowBits"), o(r2 >= -1 && r2 <= 9, "invalid compression level"), o(n2 >= 1 && n2 <= 9, "invalid memlevel"), o(i2 === t.Z_FILTERED || i2 === t.Z_HUFFMAN_ONLY || i2 === t.Z_RLE || i2 === t.Z_FIXED || i2 === t.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(r2, e3, n2, i2, s2), this._setDictionary();
        }, g.prototype.params = function () {
          throw new Error("deflateParams Not supported");
        }, g.prototype.reset = function () {
          this._reset(), this._setDictionary();
        }, g.prototype._init = function (e3, r2, n2, o2, l2) {
          switch (this.level = e3, this.windowBits = r2, this.memLevel = n2, this.strategy = o2, this.flush = t.Z_NO_FLUSH, this.err = t.Z_OK, this.mode !== t.GZIP && this.mode !== t.GUNZIP || (this.windowBits += 16), this.mode === t.UNZIP && (this.windowBits += 32), this.mode !== t.DEFLATERAW && this.mode !== t.INFLATERAW || (this.windowBits = -1 * this.windowBits), this.strm = new i(), this.mode) {
            case t.DEFLATE:
            case t.GZIP:
            case t.DEFLATERAW:
              this.err = s.deflateInit2(this.strm, this.level, t.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
              break;
            case t.INFLATE:
            case t.GUNZIP:
            case t.INFLATERAW:
            case t.UNZIP:
              this.err = a2.inflateInit2(this.strm, this.windowBits);
              break;
            default:
              throw new Error("Unknown mode " + this.mode);
          }
          this.err !== t.Z_OK && this._error("Init error"), this.dictionary = l2, this.write_in_progress = false, this.init_done = true;
        }, g.prototype._setDictionary = function () {
          if (null != this.dictionary) {
            switch (this.err = t.Z_OK, this.mode) {
              case t.DEFLATE:
              case t.DEFLATERAW:
                this.err = s.deflateSetDictionary(this.strm, this.dictionary);
            }
            this.err !== t.Z_OK && this._error("Failed to set dictionary");
          }
        }, g.prototype._reset = function () {
          switch (this.err = t.Z_OK, this.mode) {
            case t.DEFLATE:
            case t.DEFLATERAW:
            case t.GZIP:
              this.err = s.deflateReset(this.strm);
              break;
            case t.INFLATE:
            case t.INFLATERAW:
            case t.GUNZIP:
              this.err = a2.inflateReset(this.strm);
          }
          this.err !== t.Z_OK && this._error("Failed to reset stream");
        }, t.Zlib = g;
      }).call(this, r(5).Buffer, r(2));
    }, function (e, t, r) {
      var n = Object.getOwnPropertySymbols,
        o = Object.prototype.hasOwnProperty,
        i = Object.prototype.propertyIsEnumerable;
      function s(e2) {
        if (null == e2) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e2);
      }
      e.exports = function () {
        try {
          if (!Object.assign) return false;
          var e2 = new String("abc");
          if (e2[5] = "de", "5" === Object.getOwnPropertyNames(e2)[0]) return false;
          for (var t2 = {}, r2 = 0; r2 < 10; r2++) t2["_" + String.fromCharCode(r2)] = r2;
          if ("0123456789" !== Object.getOwnPropertyNames(t2).map(function (e3) {
            return t2[e3];
          }).join("")) return false;
          var n2 = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (e3) {
            n2[e3] = e3;
          }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n2)).join("");
        } catch (e3) {
          return false;
        }
      }() ? Object.assign : function (e2, t2) {
        for (var r2, a2, l = s(e2), u = 1; u < arguments.length; u++) {
          for (var g in r2 = Object(arguments[u])) o.call(r2, g) && (l[g] = r2[g]);
          if (n) {
            a2 = n(r2);
            for (var c = 0; c < a2.length; c++) i.call(r2, a2[c]) && (l[a2[c]] = r2[a2[c]]);
          }
        }
        return l;
      };
    }, function (e, t, r) {
      e.exports = function () {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, function (e, t, r) {
      var n,
        o = r(37),
        i = r(173),
        s = r(75),
        a2 = r(76),
        l = r(174);
      function u(e2, t2) {
        return e2.msg = l[t2], t2;
      }
      function g(e2) {
        return (e2 << 1) - (e2 > 4 ? 9 : 0);
      }
      function c(e2) {
        for (var t2 = e2.length; --t2 >= 0;) e2[t2] = 0;
      }
      function f(e2) {
        var t2 = e2.state,
          r2 = t2.pending;
        r2 > e2.avail_out && (r2 = e2.avail_out), 0 !== r2 && (o.arraySet(e2.output, t2.pending_buf, t2.pending_out, r2, e2.next_out), e2.next_out += r2, t2.pending_out += r2, e2.total_out += r2, e2.avail_out -= r2, t2.pending -= r2, 0 === t2.pending && (t2.pending_out = 0));
      }
      function p(e2, t2) {
        i._tr_flush_block(e2, e2.block_start >= 0 ? e2.block_start : -1, e2.strstart - e2.block_start, t2), e2.block_start = e2.strstart, f(e2.strm);
      }
      function h(e2, t2) {
        e2.pending_buf[e2.pending++] = t2;
      }
      function d(e2, t2) {
        e2.pending_buf[e2.pending++] = t2 >>> 8 & 255, e2.pending_buf[e2.pending++] = 255 & t2;
      }
      function y(e2, t2) {
        var r2,
          n2,
          o2 = e2.max_chain_length,
          i2 = e2.strstart,
          s2 = e2.prev_length,
          a3 = e2.nice_match,
          l2 = e2.strstart > e2.w_size - 262 ? e2.strstart - (e2.w_size - 262) : 0,
          u2 = e2.window,
          g2 = e2.w_mask,
          c2 = e2.prev,
          f2 = e2.strstart + 258,
          p2 = u2[i2 + s2 - 1],
          h2 = u2[i2 + s2];
        e2.prev_length >= e2.good_match && (o2 >>= 2), a3 > e2.lookahead && (a3 = e2.lookahead);
        do {
          if (u2[(r2 = t2) + s2] === h2 && u2[r2 + s2 - 1] === p2 && u2[r2] === u2[i2] && u2[++r2] === u2[i2 + 1]) {
            i2 += 2, r2++;
            do {} while (u2[++i2] === u2[++r2] && u2[++i2] === u2[++r2] && u2[++i2] === u2[++r2] && u2[++i2] === u2[++r2] && u2[++i2] === u2[++r2] && u2[++i2] === u2[++r2] && u2[++i2] === u2[++r2] && u2[++i2] === u2[++r2] && i2 < f2);
            if (n2 = 258 - (f2 - i2), i2 = f2 - 258, n2 > s2) {
              if (e2.match_start = t2, s2 = n2, n2 >= a3) break;
              p2 = u2[i2 + s2 - 1], h2 = u2[i2 + s2];
            }
          }
        } while ((t2 = c2[t2 & g2]) > l2 && 0 != --o2);
        return s2 <= e2.lookahead ? s2 : e2.lookahead;
      }
      function m(e2) {
        var t2,
          r2,
          n2,
          i2,
          l2,
          u2,
          g2,
          c2,
          f2,
          p2,
          h2 = e2.w_size;
        do {
          if (i2 = e2.window_size - e2.lookahead - e2.strstart, e2.strstart >= h2 + (h2 - 262)) {
            o.arraySet(e2.window, e2.window, h2, h2, 0), e2.match_start -= h2, e2.strstart -= h2, e2.block_start -= h2, t2 = r2 = e2.hash_size;
            do {
              n2 = e2.head[--t2], e2.head[t2] = n2 >= h2 ? n2 - h2 : 0;
            } while (--r2);
            t2 = r2 = h2;
            do {
              n2 = e2.prev[--t2], e2.prev[t2] = n2 >= h2 ? n2 - h2 : 0;
            } while (--r2);
            i2 += h2;
          }
          if (0 === e2.strm.avail_in) break;
          if (u2 = e2.strm, g2 = e2.window, c2 = e2.strstart + e2.lookahead, f2 = i2, p2 = void 0, (p2 = u2.avail_in) > f2 && (p2 = f2), r2 = 0 === p2 ? 0 : (u2.avail_in -= p2, o.arraySet(g2, u2.input, u2.next_in, p2, c2), 1 === u2.state.wrap ? u2.adler = s(u2.adler, g2, p2, c2) : 2 === u2.state.wrap && (u2.adler = a2(u2.adler, g2, p2, c2)), u2.next_in += p2, u2.total_in += p2, p2), e2.lookahead += r2, e2.lookahead + e2.insert >= 3) for (l2 = e2.strstart - e2.insert, e2.ins_h = e2.window[l2], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[l2 + 1]) & e2.hash_mask; e2.insert && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[l2 + 3 - 1]) & e2.hash_mask, e2.prev[l2 & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = l2, l2++, e2.insert--, !(e2.lookahead + e2.insert < 3)););
        } while (e2.lookahead < 262 && 0 !== e2.strm.avail_in);
      }
      function b(e2, t2) {
        for (var r2, n2;;) {
          if (e2.lookahead < 262) {
            if (m(e2), e2.lookahead < 262 && 0 === t2) return 1;
            if (0 === e2.lookahead) break;
          }
          if (r2 = 0, e2.lookahead >= 3 && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + 3 - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 !== r2 && e2.strstart - r2 <= e2.w_size - 262 && (e2.match_length = y(e2, r2)), e2.match_length >= 3) {
            if (n2 = i._tr_tally(e2, e2.strstart - e2.match_start, e2.match_length - 3), e2.lookahead -= e2.match_length, e2.match_length <= e2.max_lazy_match && e2.lookahead >= 3) {
              e2.match_length--;
              do {
                e2.strstart++, e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + 3 - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart;
              } while (0 != --e2.match_length);
              e2.strstart++;
            } else e2.strstart += e2.match_length, e2.match_length = 0, e2.ins_h = e2.window[e2.strstart], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + 1]) & e2.hash_mask;
          } else n2 = i._tr_tally(e2, 0, e2.window[e2.strstart]), e2.lookahead--, e2.strstart++;
          if (n2 && (p(e2, false), 0 === e2.strm.avail_out)) return 1;
        }
        return e2.insert = e2.strstart < 2 ? e2.strstart : 2, 4 === t2 ? (p(e2, true), 0 === e2.strm.avail_out ? 3 : 4) : e2.last_lit && (p(e2, false), 0 === e2.strm.avail_out) ? 1 : 2;
      }
      function v(e2, t2) {
        for (var r2, n2, o2;;) {
          if (e2.lookahead < 262) {
            if (m(e2), e2.lookahead < 262 && 0 === t2) return 1;
            if (0 === e2.lookahead) break;
          }
          if (r2 = 0, e2.lookahead >= 3 && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + 3 - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), e2.prev_length = e2.match_length, e2.prev_match = e2.match_start, e2.match_length = 2, 0 !== r2 && e2.prev_length < e2.max_lazy_match && e2.strstart - r2 <= e2.w_size - 262 && (e2.match_length = y(e2, r2), e2.match_length <= 5 && (1 === e2.strategy || 3 === e2.match_length && e2.strstart - e2.match_start > 4096) && (e2.match_length = 2)), e2.prev_length >= 3 && e2.match_length <= e2.prev_length) {
            o2 = e2.strstart + e2.lookahead - 3, n2 = i._tr_tally(e2, e2.strstart - 1 - e2.prev_match, e2.prev_length - 3), e2.lookahead -= e2.prev_length - 1, e2.prev_length -= 2;
            do {
              ++e2.strstart <= o2 && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + 3 - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart);
            } while (0 != --e2.prev_length);
            if (e2.match_available = 0, e2.match_length = 2, e2.strstart++, n2 && (p(e2, false), 0 === e2.strm.avail_out)) return 1;
          } else if (e2.match_available) {
            if ((n2 = i._tr_tally(e2, 0, e2.window[e2.strstart - 1])) && p(e2, false), e2.strstart++, e2.lookahead--, 0 === e2.strm.avail_out) return 1;
          } else e2.match_available = 1, e2.strstart++, e2.lookahead--;
        }
        return e2.match_available && (n2 = i._tr_tally(e2, 0, e2.window[e2.strstart - 1]), e2.match_available = 0), e2.insert = e2.strstart < 2 ? e2.strstart : 2, 4 === t2 ? (p(e2, true), 0 === e2.strm.avail_out ? 3 : 4) : e2.last_lit && (p(e2, false), 0 === e2.strm.avail_out) ? 1 : 2;
      }
      function _(e2, t2, r2, n2, o2) {
        this.good_length = e2, this.max_lazy = t2, this.nice_length = r2, this.max_chain = n2, this.func = o2;
      }
      function S() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new o.Buf16(1146), this.dyn_dtree = new o.Buf16(122), this.bl_tree = new o.Buf16(78), c(this.dyn_ltree), c(this.dyn_dtree), c(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new o.Buf16(16), this.heap = new o.Buf16(573), c(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new o.Buf16(573), c(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function w(e2) {
        var t2;
        return e2 && e2.state ? (e2.total_in = e2.total_out = 0, e2.data_type = 2, (t2 = e2.state).pending = 0, t2.pending_out = 0, t2.wrap < 0 && (t2.wrap = -t2.wrap), t2.status = t2.wrap ? 42 : 113, e2.adler = 2 === t2.wrap ? 0 : 1, t2.last_flush = 0, i._tr_init(t2), 0) : u(e2, -2);
      }
      function E(e2) {
        var t2,
          r2 = w(e2);
        return 0 === r2 && ((t2 = e2.state).window_size = 2 * t2.w_size, c(t2.head), t2.max_lazy_match = n[t2.level].max_lazy, t2.good_match = n[t2.level].good_length, t2.nice_match = n[t2.level].nice_length, t2.max_chain_length = n[t2.level].max_chain, t2.strstart = 0, t2.block_start = 0, t2.lookahead = 0, t2.insert = 0, t2.match_length = t2.prev_length = 2, t2.match_available = 0, t2.ins_h = 0), r2;
      }
      function T(e2, t2, r2, n2, i2, s2) {
        if (!e2) return -2;
        var a3 = 1;
        if (-1 === t2 && (t2 = 6), n2 < 0 ? (a3 = 0, n2 = -n2) : n2 > 15 && (a3 = 2, n2 -= 16), i2 < 1 || i2 > 9 || 8 !== r2 || n2 < 8 || n2 > 15 || t2 < 0 || t2 > 9 || s2 < 0 || s2 > 4) return u(e2, -2);
        8 === n2 && (n2 = 9);
        var l2 = new S();
        return e2.state = l2, l2.strm = e2, l2.wrap = a3, l2.gzhead = null, l2.w_bits = n2, l2.w_size = 1 << l2.w_bits, l2.w_mask = l2.w_size - 1, l2.hash_bits = i2 + 7, l2.hash_size = 1 << l2.hash_bits, l2.hash_mask = l2.hash_size - 1, l2.hash_shift = ~~((l2.hash_bits + 3 - 1) / 3), l2.window = new o.Buf8(2 * l2.w_size), l2.head = new o.Buf16(l2.hash_size), l2.prev = new o.Buf16(l2.w_size), l2.lit_bufsize = 1 << i2 + 6, l2.pending_buf_size = 4 * l2.lit_bufsize, l2.pending_buf = new o.Buf8(l2.pending_buf_size), l2.d_buf = 1 * l2.lit_bufsize, l2.l_buf = 3 * l2.lit_bufsize, l2.level = t2, l2.strategy = s2, l2.method = r2, E(e2);
      }
      n = [new _(0, 0, 0, 0, function (e2, t2) {
        var r2 = 65535;
        for (r2 > e2.pending_buf_size - 5 && (r2 = e2.pending_buf_size - 5);;) {
          if (e2.lookahead <= 1) {
            if (m(e2), 0 === e2.lookahead && 0 === t2) return 1;
            if (0 === e2.lookahead) break;
          }
          e2.strstart += e2.lookahead, e2.lookahead = 0;
          var n2 = e2.block_start + r2;
          if ((0 === e2.strstart || e2.strstart >= n2) && (e2.lookahead = e2.strstart - n2, e2.strstart = n2, p(e2, false), 0 === e2.strm.avail_out)) return 1;
          if (e2.strstart - e2.block_start >= e2.w_size - 262 && (p(e2, false), 0 === e2.strm.avail_out)) return 1;
        }
        return e2.insert = 0, 4 === t2 ? (p(e2, true), 0 === e2.strm.avail_out ? 3 : 4) : (e2.strstart > e2.block_start && (p(e2, false), e2.strm.avail_out), 1);
      }), new _(4, 4, 8, 4, b), new _(4, 5, 16, 8, b), new _(4, 6, 32, 32, b), new _(4, 4, 16, 16, v), new _(8, 16, 32, 32, v), new _(8, 16, 128, 128, v), new _(8, 32, 128, 256, v), new _(32, 128, 258, 1024, v), new _(32, 258, 258, 4096, v)], t.deflateInit = function (e2, t2) {
        return T(e2, t2, 8, 15, 8, 0);
      }, t.deflateInit2 = T, t.deflateReset = E, t.deflateResetKeep = w, t.deflateSetHeader = function (e2, t2) {
        return e2 && e2.state ? 2 !== e2.state.wrap ? -2 : (e2.state.gzhead = t2, 0) : -2;
      }, t.deflate = function (e2, t2) {
        var r2, o2, s2, l2;
        if (!e2 || !e2.state || t2 > 5 || t2 < 0) return e2 ? u(e2, -2) : -2;
        if (o2 = e2.state, !e2.output || !e2.input && 0 !== e2.avail_in || 666 === o2.status && 4 !== t2) return u(e2, 0 === e2.avail_out ? -5 : -2);
        if (o2.strm = e2, r2 = o2.last_flush, o2.last_flush = t2, 42 === o2.status) if (2 === o2.wrap) e2.adler = 0, h(o2, 31), h(o2, 139), h(o2, 8), o2.gzhead ? (h(o2, (o2.gzhead.text ? 1 : 0) + (o2.gzhead.hcrc ? 2 : 0) + (o2.gzhead.extra ? 4 : 0) + (o2.gzhead.name ? 8 : 0) + (o2.gzhead.comment ? 16 : 0)), h(o2, 255 & o2.gzhead.time), h(o2, o2.gzhead.time >> 8 & 255), h(o2, o2.gzhead.time >> 16 & 255), h(o2, o2.gzhead.time >> 24 & 255), h(o2, 9 === o2.level ? 2 : o2.strategy >= 2 || o2.level < 2 ? 4 : 0), h(o2, 255 & o2.gzhead.os), o2.gzhead.extra && o2.gzhead.extra.length && (h(o2, 255 & o2.gzhead.extra.length), h(o2, o2.gzhead.extra.length >> 8 & 255)), o2.gzhead.hcrc && (e2.adler = a2(e2.adler, o2.pending_buf, o2.pending, 0)), o2.gzindex = 0, o2.status = 69) : (h(o2, 0), h(o2, 0), h(o2, 0), h(o2, 0), h(o2, 0), h(o2, 9 === o2.level ? 2 : o2.strategy >= 2 || o2.level < 2 ? 4 : 0), h(o2, 3), o2.status = 113);else {
          var y2 = 8 + (o2.w_bits - 8 << 4) << 8;
          y2 |= (o2.strategy >= 2 || o2.level < 2 ? 0 : o2.level < 6 ? 1 : 6 === o2.level ? 2 : 3) << 6, 0 !== o2.strstart && (y2 |= 32), y2 += 31 - y2 % 31, o2.status = 113, d(o2, y2), 0 !== o2.strstart && (d(o2, e2.adler >>> 16), d(o2, 65535 & e2.adler)), e2.adler = 1;
        }
        if (69 === o2.status) if (o2.gzhead.extra) {
          for (s2 = o2.pending; o2.gzindex < (65535 & o2.gzhead.extra.length) && (o2.pending !== o2.pending_buf_size || (o2.gzhead.hcrc && o2.pending > s2 && (e2.adler = a2(e2.adler, o2.pending_buf, o2.pending - s2, s2)), f(e2), s2 = o2.pending, o2.pending !== o2.pending_buf_size));) h(o2, 255 & o2.gzhead.extra[o2.gzindex]), o2.gzindex++;
          o2.gzhead.hcrc && o2.pending > s2 && (e2.adler = a2(e2.adler, o2.pending_buf, o2.pending - s2, s2)), o2.gzindex === o2.gzhead.extra.length && (o2.gzindex = 0, o2.status = 73);
        } else o2.status = 73;
        if (73 === o2.status) if (o2.gzhead.name) {
          s2 = o2.pending;
          do {
            if (o2.pending === o2.pending_buf_size && (o2.gzhead.hcrc && o2.pending > s2 && (e2.adler = a2(e2.adler, o2.pending_buf, o2.pending - s2, s2)), f(e2), s2 = o2.pending, o2.pending === o2.pending_buf_size)) {
              l2 = 1;
              break;
            }
            l2 = o2.gzindex < o2.gzhead.name.length ? 255 & o2.gzhead.name.charCodeAt(o2.gzindex++) : 0, h(o2, l2);
          } while (0 !== l2);
          o2.gzhead.hcrc && o2.pending > s2 && (e2.adler = a2(e2.adler, o2.pending_buf, o2.pending - s2, s2)), 0 === l2 && (o2.gzindex = 0, o2.status = 91);
        } else o2.status = 91;
        if (91 === o2.status) if (o2.gzhead.comment) {
          s2 = o2.pending;
          do {
            if (o2.pending === o2.pending_buf_size && (o2.gzhead.hcrc && o2.pending > s2 && (e2.adler = a2(e2.adler, o2.pending_buf, o2.pending - s2, s2)), f(e2), s2 = o2.pending, o2.pending === o2.pending_buf_size)) {
              l2 = 1;
              break;
            }
            l2 = o2.gzindex < o2.gzhead.comment.length ? 255 & o2.gzhead.comment.charCodeAt(o2.gzindex++) : 0, h(o2, l2);
          } while (0 !== l2);
          o2.gzhead.hcrc && o2.pending > s2 && (e2.adler = a2(e2.adler, o2.pending_buf, o2.pending - s2, s2)), 0 === l2 && (o2.status = 103);
        } else o2.status = 103;
        if (103 === o2.status && (o2.gzhead.hcrc ? (o2.pending + 2 > o2.pending_buf_size && f(e2), o2.pending + 2 <= o2.pending_buf_size && (h(o2, 255 & e2.adler), h(o2, e2.adler >> 8 & 255), e2.adler = 0, o2.status = 113)) : o2.status = 113), 0 !== o2.pending) {
          if (f(e2), 0 === e2.avail_out) return o2.last_flush = -1, 0;
        } else if (0 === e2.avail_in && g(t2) <= g(r2) && 4 !== t2) return u(e2, -5);
        if (666 === o2.status && 0 !== e2.avail_in) return u(e2, -5);
        if (0 !== e2.avail_in || 0 !== o2.lookahead || 0 !== t2 && 666 !== o2.status) {
          var b2 = 2 === o2.strategy ? function (e3, t3) {
            for (var r3;;) {
              if (0 === e3.lookahead && (m(e3), 0 === e3.lookahead)) {
                if (0 === t3) return 1;
                break;
              }
              if (e3.match_length = 0, r3 = i._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++, r3 && (p(e3, false), 0 === e3.strm.avail_out)) return 1;
            }
            return e3.insert = 0, 4 === t3 ? (p(e3, true), 0 === e3.strm.avail_out ? 3 : 4) : e3.last_lit && (p(e3, false), 0 === e3.strm.avail_out) ? 1 : 2;
          }(o2, t2) : 3 === o2.strategy ? function (e3, t3) {
            for (var r3, n2, o3, s3, a3 = e3.window;;) {
              if (e3.lookahead <= 258) {
                if (m(e3), e3.lookahead <= 258 && 0 === t3) return 1;
                if (0 === e3.lookahead) break;
              }
              if (e3.match_length = 0, e3.lookahead >= 3 && e3.strstart > 0 && (n2 = a3[o3 = e3.strstart - 1]) === a3[++o3] && n2 === a3[++o3] && n2 === a3[++o3]) {
                s3 = e3.strstart + 258;
                do {} while (n2 === a3[++o3] && n2 === a3[++o3] && n2 === a3[++o3] && n2 === a3[++o3] && n2 === a3[++o3] && n2 === a3[++o3] && n2 === a3[++o3] && n2 === a3[++o3] && o3 < s3);
                e3.match_length = 258 - (s3 - o3), e3.match_length > e3.lookahead && (e3.match_length = e3.lookahead);
              }
              if (e3.match_length >= 3 ? (r3 = i._tr_tally(e3, 1, e3.match_length - 3), e3.lookahead -= e3.match_length, e3.strstart += e3.match_length, e3.match_length = 0) : (r3 = i._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++), r3 && (p(e3, false), 0 === e3.strm.avail_out)) return 1;
            }
            return e3.insert = 0, 4 === t3 ? (p(e3, true), 0 === e3.strm.avail_out ? 3 : 4) : e3.last_lit && (p(e3, false), 0 === e3.strm.avail_out) ? 1 : 2;
          }(o2, t2) : n[o2.level].func(o2, t2);
          if (3 !== b2 && 4 !== b2 || (o2.status = 666), 1 === b2 || 3 === b2) return 0 === e2.avail_out && (o2.last_flush = -1), 0;
          if (2 === b2 && (1 === t2 ? i._tr_align(o2) : 5 !== t2 && (i._tr_stored_block(o2, 0, 0, false), 3 === t2 && (c(o2.head), 0 === o2.lookahead && (o2.strstart = 0, o2.block_start = 0, o2.insert = 0))), f(e2), 0 === e2.avail_out)) return o2.last_flush = -1, 0;
        }
        return 4 !== t2 ? 0 : o2.wrap <= 0 ? 1 : (2 === o2.wrap ? (h(o2, 255 & e2.adler), h(o2, e2.adler >> 8 & 255), h(o2, e2.adler >> 16 & 255), h(o2, e2.adler >> 24 & 255), h(o2, 255 & e2.total_in), h(o2, e2.total_in >> 8 & 255), h(o2, e2.total_in >> 16 & 255), h(o2, e2.total_in >> 24 & 255)) : (d(o2, e2.adler >>> 16), d(o2, 65535 & e2.adler)), f(e2), o2.wrap > 0 && (o2.wrap = -o2.wrap), 0 !== o2.pending ? 0 : 1);
      }, t.deflateEnd = function (e2) {
        var t2;
        return e2 && e2.state ? 42 !== (t2 = e2.state.status) && 69 !== t2 && 73 !== t2 && 91 !== t2 && 103 !== t2 && 113 !== t2 && 666 !== t2 ? u(e2, -2) : (e2.state = null, 113 === t2 ? u(e2, -3) : 0) : -2;
      }, t.deflateSetDictionary = function (e2, t2) {
        var r2,
          n2,
          i2,
          a3,
          l2,
          u2,
          g2,
          f2,
          p2 = t2.length;
        if (!e2 || !e2.state) return -2;
        if (2 === (a3 = (r2 = e2.state).wrap) || 1 === a3 && 42 !== r2.status || r2.lookahead) return -2;
        for (1 === a3 && (e2.adler = s(e2.adler, t2, p2, 0)), r2.wrap = 0, p2 >= r2.w_size && (0 === a3 && (c(r2.head), r2.strstart = 0, r2.block_start = 0, r2.insert = 0), f2 = new o.Buf8(r2.w_size), o.arraySet(f2, t2, p2 - r2.w_size, r2.w_size, 0), t2 = f2, p2 = r2.w_size), l2 = e2.avail_in, u2 = e2.next_in, g2 = e2.input, e2.avail_in = p2, e2.next_in = 0, e2.input = t2, m(r2); r2.lookahead >= 3;) {
          n2 = r2.strstart, i2 = r2.lookahead - 2;
          do {
            r2.ins_h = (r2.ins_h << r2.hash_shift ^ r2.window[n2 + 3 - 1]) & r2.hash_mask, r2.prev[n2 & r2.w_mask] = r2.head[r2.ins_h], r2.head[r2.ins_h] = n2, n2++;
          } while (--i2);
          r2.strstart = n2, r2.lookahead = 2, m(r2);
        }
        return r2.strstart += r2.lookahead, r2.block_start = r2.strstart, r2.insert = r2.lookahead, r2.lookahead = 0, r2.match_length = r2.prev_length = 2, r2.match_available = 0, e2.next_in = u2, e2.input = g2, e2.avail_in = l2, r2.wrap = a3, 0;
      }, t.deflateInfo = "pako deflate (from Nodeca project)";
    }, function (e, t, r) {
      var n = r(37);
      function o(e2) {
        for (var t2 = e2.length; --t2 >= 0;) e2[t2] = 0;
      }
      var i = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
        s = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
        a2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
        l = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
        u = new Array(576);
      o(u);
      var g = new Array(60);
      o(g);
      var c = new Array(512);
      o(c);
      var f = new Array(256);
      o(f);
      var p = new Array(29);
      o(p);
      var h,
        d,
        y,
        m = new Array(30);
      function b(e2, t2, r2, n2, o2) {
        this.static_tree = e2, this.extra_bits = t2, this.extra_base = r2, this.elems = n2, this.max_length = o2, this.has_stree = e2 && e2.length;
      }
      function v(e2, t2) {
        this.dyn_tree = e2, this.max_code = 0, this.stat_desc = t2;
      }
      function _(e2) {
        return e2 < 256 ? c[e2] : c[256 + (e2 >>> 7)];
      }
      function S(e2, t2) {
        e2.pending_buf[e2.pending++] = 255 & t2, e2.pending_buf[e2.pending++] = t2 >>> 8 & 255;
      }
      function w(e2, t2, r2) {
        e2.bi_valid > 16 - r2 ? (e2.bi_buf |= t2 << e2.bi_valid & 65535, S(e2, e2.bi_buf), e2.bi_buf = t2 >> 16 - e2.bi_valid, e2.bi_valid += r2 - 16) : (e2.bi_buf |= t2 << e2.bi_valid & 65535, e2.bi_valid += r2);
      }
      function E(e2, t2, r2) {
        w(e2, r2[2 * t2], r2[2 * t2 + 1]);
      }
      function T(e2, t2) {
        var r2 = 0;
        do {
          r2 |= 1 & e2, e2 >>>= 1, r2 <<= 1;
        } while (--t2 > 0);
        return r2 >>> 1;
      }
      function R(e2, t2, r2) {
        var n2,
          o2,
          i2 = new Array(16),
          s2 = 0;
        for (n2 = 1; n2 <= 15; n2++) i2[n2] = s2 = s2 + r2[n2 - 1] << 1;
        for (o2 = 0; o2 <= t2; o2++) {
          var a3 = e2[2 * o2 + 1];
          0 !== a3 && (e2[2 * o2] = T(i2[a3]++, a3));
        }
      }
      function A(e2) {
        var t2;
        for (t2 = 0; t2 < 286; t2++) e2.dyn_ltree[2 * t2] = 0;
        for (t2 = 0; t2 < 30; t2++) e2.dyn_dtree[2 * t2] = 0;
        for (t2 = 0; t2 < 19; t2++) e2.bl_tree[2 * t2] = 0;
        e2.dyn_ltree[512] = 1, e2.opt_len = e2.static_len = 0, e2.last_lit = e2.matches = 0;
      }
      function O(e2) {
        e2.bi_valid > 8 ? S(e2, e2.bi_buf) : e2.bi_valid > 0 && (e2.pending_buf[e2.pending++] = e2.bi_buf), e2.bi_buf = 0, e2.bi_valid = 0;
      }
      function C(e2, t2, r2, n2) {
        var o2 = 2 * t2,
          i2 = 2 * r2;
        return e2[o2] < e2[i2] || e2[o2] === e2[i2] && n2[t2] <= n2[r2];
      }
      function I(e2, t2, r2) {
        for (var n2 = e2.heap[r2], o2 = r2 << 1; o2 <= e2.heap_len && (o2 < e2.heap_len && C(t2, e2.heap[o2 + 1], e2.heap[o2], e2.depth) && o2++, !C(t2, n2, e2.heap[o2], e2.depth));) e2.heap[r2] = e2.heap[o2], r2 = o2, o2 <<= 1;
        e2.heap[r2] = n2;
      }
      function j(e2, t2, r2) {
        var n2,
          o2,
          a3,
          l2,
          u2 = 0;
        if (0 !== e2.last_lit) do {
          n2 = e2.pending_buf[e2.d_buf + 2 * u2] << 8 | e2.pending_buf[e2.d_buf + 2 * u2 + 1], o2 = e2.pending_buf[e2.l_buf + u2], u2++, 0 === n2 ? E(e2, o2, t2) : (E(e2, (a3 = f[o2]) + 256 + 1, t2), 0 !== (l2 = i[a3]) && w(e2, o2 -= p[a3], l2), E(e2, a3 = _(--n2), r2), 0 !== (l2 = s[a3]) && w(e2, n2 -= m[a3], l2));
        } while (u2 < e2.last_lit);
        E(e2, 256, t2);
      }
      function M(e2, t2) {
        var r2,
          n2,
          o2,
          i2 = t2.dyn_tree,
          s2 = t2.stat_desc.static_tree,
          a3 = t2.stat_desc.has_stree,
          l2 = t2.stat_desc.elems,
          u2 = -1;
        for (e2.heap_len = 0, e2.heap_max = 573, r2 = 0; r2 < l2; r2++) 0 !== i2[2 * r2] ? (e2.heap[++e2.heap_len] = u2 = r2, e2.depth[r2] = 0) : i2[2 * r2 + 1] = 0;
        for (; e2.heap_len < 2;) i2[2 * (o2 = e2.heap[++e2.heap_len] = u2 < 2 ? ++u2 : 0)] = 1, e2.depth[o2] = 0, e2.opt_len--, a3 && (e2.static_len -= s2[2 * o2 + 1]);
        for (t2.max_code = u2, r2 = e2.heap_len >> 1; r2 >= 1; r2--) I(e2, i2, r2);
        o2 = l2;
        do {
          r2 = e2.heap[1], e2.heap[1] = e2.heap[e2.heap_len--], I(e2, i2, 1), n2 = e2.heap[1], e2.heap[--e2.heap_max] = r2, e2.heap[--e2.heap_max] = n2, i2[2 * o2] = i2[2 * r2] + i2[2 * n2], e2.depth[o2] = (e2.depth[r2] >= e2.depth[n2] ? e2.depth[r2] : e2.depth[n2]) + 1, i2[2 * r2 + 1] = i2[2 * n2 + 1] = o2, e2.heap[1] = o2++, I(e2, i2, 1);
        } while (e2.heap_len >= 2);
        e2.heap[--e2.heap_max] = e2.heap[1], function (e3, t3) {
          var r3,
            n3,
            o3,
            i3,
            s3,
            a4,
            l3 = t3.dyn_tree,
            u3 = t3.max_code,
            g2 = t3.stat_desc.static_tree,
            c2 = t3.stat_desc.has_stree,
            f2 = t3.stat_desc.extra_bits,
            p2 = t3.stat_desc.extra_base,
            h2 = t3.stat_desc.max_length,
            d2 = 0;
          for (i3 = 0; i3 <= 15; i3++) e3.bl_count[i3] = 0;
          for (l3[2 * e3.heap[e3.heap_max] + 1] = 0, r3 = e3.heap_max + 1; r3 < 573; r3++) (i3 = l3[2 * l3[2 * (n3 = e3.heap[r3]) + 1] + 1] + 1) > h2 && (i3 = h2, d2++), l3[2 * n3 + 1] = i3, n3 > u3 || (e3.bl_count[i3]++, s3 = 0, n3 >= p2 && (s3 = f2[n3 - p2]), a4 = l3[2 * n3], e3.opt_len += a4 * (i3 + s3), c2 && (e3.static_len += a4 * (g2[2 * n3 + 1] + s3)));
          if (0 !== d2) {
            do {
              for (i3 = h2 - 1; 0 === e3.bl_count[i3];) i3--;
              e3.bl_count[i3]--, e3.bl_count[i3 + 1] += 2, e3.bl_count[h2]--, d2 -= 2;
            } while (d2 > 0);
            for (i3 = h2; 0 !== i3; i3--) for (n3 = e3.bl_count[i3]; 0 !== n3;) (o3 = e3.heap[--r3]) > u3 || (l3[2 * o3 + 1] !== i3 && (e3.opt_len += (i3 - l3[2 * o3 + 1]) * l3[2 * o3], l3[2 * o3 + 1] = i3), n3--);
          }
        }(e2, t2), R(i2, u2, e2.bl_count);
      }
      function P(e2, t2, r2) {
        var n2,
          o2,
          i2 = -1,
          s2 = t2[1],
          a3 = 0,
          l2 = 7,
          u2 = 4;
        for (0 === s2 && (l2 = 138, u2 = 3), t2[2 * (r2 + 1) + 1] = 65535, n2 = 0; n2 <= r2; n2++) o2 = s2, s2 = t2[2 * (n2 + 1) + 1], ++a3 < l2 && o2 === s2 || (a3 < u2 ? e2.bl_tree[2 * o2] += a3 : 0 !== o2 ? (o2 !== i2 && e2.bl_tree[2 * o2]++, e2.bl_tree[32]++) : a3 <= 10 ? e2.bl_tree[34]++ : e2.bl_tree[36]++, a3 = 0, i2 = o2, 0 === s2 ? (l2 = 138, u2 = 3) : o2 === s2 ? (l2 = 6, u2 = 3) : (l2 = 7, u2 = 4));
      }
      function N(e2, t2, r2) {
        var n2,
          o2,
          i2 = -1,
          s2 = t2[1],
          a3 = 0,
          l2 = 7,
          u2 = 4;
        for (0 === s2 && (l2 = 138, u2 = 3), n2 = 0; n2 <= r2; n2++) if (o2 = s2, s2 = t2[2 * (n2 + 1) + 1], !(++a3 < l2 && o2 === s2)) {
          if (a3 < u2) do {
            E(e2, o2, e2.bl_tree);
          } while (0 != --a3);else 0 !== o2 ? (o2 !== i2 && (E(e2, o2, e2.bl_tree), a3--), E(e2, 16, e2.bl_tree), w(e2, a3 - 3, 2)) : a3 <= 10 ? (E(e2, 17, e2.bl_tree), w(e2, a3 - 3, 3)) : (E(e2, 18, e2.bl_tree), w(e2, a3 - 11, 7));
          a3 = 0, i2 = o2, 0 === s2 ? (l2 = 138, u2 = 3) : o2 === s2 ? (l2 = 6, u2 = 3) : (l2 = 7, u2 = 4);
        }
      }
      o(m);
      var L = false;
      function D(e2, t2, r2, o2) {
        w(e2, 0 + (o2 ? 1 : 0), 3), function (e3, t3, r3, o3) {
          O(e3), o3 && (S(e3, r3), S(e3, ~r3)), n.arraySet(e3.pending_buf, e3.window, t3, r3, e3.pending), e3.pending += r3;
        }(e2, t2, r2, true);
      }
      t._tr_init = function (e2) {
        L || (!function () {
          var e3,
            t2,
            r2,
            n2,
            o2,
            l2 = new Array(16);
          for (r2 = 0, n2 = 0; n2 < 28; n2++) for (p[n2] = r2, e3 = 0; e3 < 1 << i[n2]; e3++) f[r2++] = n2;
          for (f[r2 - 1] = n2, o2 = 0, n2 = 0; n2 < 16; n2++) for (m[n2] = o2, e3 = 0; e3 < 1 << s[n2]; e3++) c[o2++] = n2;
          for (o2 >>= 7; n2 < 30; n2++) for (m[n2] = o2 << 7, e3 = 0; e3 < 1 << s[n2] - 7; e3++) c[256 + o2++] = n2;
          for (t2 = 0; t2 <= 15; t2++) l2[t2] = 0;
          for (e3 = 0; e3 <= 143;) u[2 * e3 + 1] = 8, e3++, l2[8]++;
          for (; e3 <= 255;) u[2 * e3 + 1] = 9, e3++, l2[9]++;
          for (; e3 <= 279;) u[2 * e3 + 1] = 7, e3++, l2[7]++;
          for (; e3 <= 287;) u[2 * e3 + 1] = 8, e3++, l2[8]++;
          for (R(u, 287, l2), e3 = 0; e3 < 30; e3++) g[2 * e3 + 1] = 5, g[2 * e3] = T(e3, 5);
          h = new b(u, i, 257, 286, 15), d = new b(g, s, 0, 30, 15), y = new b(new Array(0), a2, 0, 19, 7);
        }(), L = true), e2.l_desc = new v(e2.dyn_ltree, h), e2.d_desc = new v(e2.dyn_dtree, d), e2.bl_desc = new v(e2.bl_tree, y), e2.bi_buf = 0, e2.bi_valid = 0, A(e2);
      }, t._tr_stored_block = D, t._tr_flush_block = function (e2, t2, r2, n2) {
        var o2,
          i2,
          s2 = 0;
        e2.level > 0 ? (2 === e2.strm.data_type && (e2.strm.data_type = function (e3) {
          var t3,
            r3 = 4093624447;
          for (t3 = 0; t3 <= 31; t3++, r3 >>>= 1) if (1 & r3 && 0 !== e3.dyn_ltree[2 * t3]) return 0;
          if (0 !== e3.dyn_ltree[18] || 0 !== e3.dyn_ltree[20] || 0 !== e3.dyn_ltree[26]) return 1;
          for (t3 = 32; t3 < 256; t3++) if (0 !== e3.dyn_ltree[2 * t3]) return 1;
          return 0;
        }(e2)), M(e2, e2.l_desc), M(e2, e2.d_desc), s2 = function (e3) {
          var t3;
          for (P(e3, e3.dyn_ltree, e3.l_desc.max_code), P(e3, e3.dyn_dtree, e3.d_desc.max_code), M(e3, e3.bl_desc), t3 = 18; t3 >= 3 && 0 === e3.bl_tree[2 * l[t3] + 1]; t3--);
          return e3.opt_len += 3 * (t3 + 1) + 5 + 5 + 4, t3;
        }(e2), o2 = e2.opt_len + 3 + 7 >>> 3, (i2 = e2.static_len + 3 + 7 >>> 3) <= o2 && (o2 = i2)) : o2 = i2 = r2 + 5, r2 + 4 <= o2 && -1 !== t2 ? D(e2, t2, r2, n2) : 4 === e2.strategy || i2 === o2 ? (w(e2, 2 + (n2 ? 1 : 0), 3), j(e2, u, g)) : (w(e2, 4 + (n2 ? 1 : 0), 3), function (e3, t3, r3, n3) {
          var o3;
          for (w(e3, t3 - 257, 5), w(e3, r3 - 1, 5), w(e3, n3 - 4, 4), o3 = 0; o3 < n3; o3++) w(e3, e3.bl_tree[2 * l[o3] + 1], 3);
          N(e3, e3.dyn_ltree, t3 - 1), N(e3, e3.dyn_dtree, r3 - 1);
        }(e2, e2.l_desc.max_code + 1, e2.d_desc.max_code + 1, s2 + 1), j(e2, e2.dyn_ltree, e2.dyn_dtree)), A(e2), n2 && O(e2);
      }, t._tr_tally = function (e2, t2, r2) {
        return e2.pending_buf[e2.d_buf + 2 * e2.last_lit] = t2 >>> 8 & 255, e2.pending_buf[e2.d_buf + 2 * e2.last_lit + 1] = 255 & t2, e2.pending_buf[e2.l_buf + e2.last_lit] = 255 & r2, e2.last_lit++, 0 === t2 ? e2.dyn_ltree[2 * r2]++ : (e2.matches++, t2--, e2.dyn_ltree[2 * (f[r2] + 256 + 1)]++, e2.dyn_dtree[2 * _(t2)]++), e2.last_lit === e2.lit_bufsize - 1;
      }, t._tr_align = function (e2) {
        w(e2, 2, 3), E(e2, 256, u), function (e3) {
          16 === e3.bi_valid ? (S(e3, e3.bi_buf), e3.bi_buf = 0, e3.bi_valid = 0) : e3.bi_valid >= 8 && (e3.pending_buf[e3.pending++] = 255 & e3.bi_buf, e3.bi_buf >>= 8, e3.bi_valid -= 8);
        }(e2);
      };
    }, function (e, t, r) {
      e.exports = {
        2: "need dictionary",
        1: "stream end",
        0: "",
        "-1": "file error",
        "-2": "stream error",
        "-3": "data error",
        "-4": "insufficient memory",
        "-5": "buffer error",
        "-6": "incompatible version"
      };
    }, function (e, t, r) {
      var n = r(37),
        o = r(75),
        i = r(76),
        s = r(176),
        a2 = r(177);
      function l(e2) {
        return (e2 >>> 24 & 255) + (e2 >>> 8 & 65280) + ((65280 & e2) << 8) + ((255 & e2) << 24);
      }
      function u() {
        this.mode = 0, this.last = false, this.wrap = 0, this.havedict = false, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function g(e2) {
        var t2;
        return e2 && e2.state ? (t2 = e2.state, e2.total_in = e2.total_out = t2.total = 0, e2.msg = "", t2.wrap && (e2.adler = 1 & t2.wrap), t2.mode = 1, t2.last = 0, t2.havedict = 0, t2.dmax = 32768, t2.head = null, t2.hold = 0, t2.bits = 0, t2.lencode = t2.lendyn = new n.Buf32(852), t2.distcode = t2.distdyn = new n.Buf32(592), t2.sane = 1, t2.back = -1, 0) : -2;
      }
      function c(e2) {
        var t2;
        return e2 && e2.state ? ((t2 = e2.state).wsize = 0, t2.whave = 0, t2.wnext = 0, g(e2)) : -2;
      }
      function f(e2, t2) {
        var r2, n2;
        return e2 && e2.state ? (n2 = e2.state, t2 < 0 ? (r2 = 0, t2 = -t2) : (r2 = 1 + (t2 >> 4), t2 < 48 && (t2 &= 15)), t2 && (t2 < 8 || t2 > 15) ? -2 : (null !== n2.window && n2.wbits !== t2 && (n2.window = null), n2.wrap = r2, n2.wbits = t2, c(e2))) : -2;
      }
      function p(e2, t2) {
        var r2, n2;
        return e2 ? (n2 = new u(), e2.state = n2, n2.window = null, 0 !== (r2 = f(e2, t2)) && (e2.state = null), r2) : -2;
      }
      var h,
        d,
        y = true;
      function m(e2) {
        if (y) {
          var t2;
          for (h = new n.Buf32(512), d = new n.Buf32(32), t2 = 0; t2 < 144;) e2.lens[t2++] = 8;
          for (; t2 < 256;) e2.lens[t2++] = 9;
          for (; t2 < 280;) e2.lens[t2++] = 7;
          for (; t2 < 288;) e2.lens[t2++] = 8;
          for (a2(1, e2.lens, 0, 288, h, 0, e2.work, {
            bits: 9
          }), t2 = 0; t2 < 32;) e2.lens[t2++] = 5;
          a2(2, e2.lens, 0, 32, d, 0, e2.work, {
            bits: 5
          }), y = false;
        }
        e2.lencode = h, e2.lenbits = 9, e2.distcode = d, e2.distbits = 5;
      }
      function b(e2, t2, r2, o2) {
        var i2,
          s2 = e2.state;
        return null === s2.window && (s2.wsize = 1 << s2.wbits, s2.wnext = 0, s2.whave = 0, s2.window = new n.Buf8(s2.wsize)), o2 >= s2.wsize ? (n.arraySet(s2.window, t2, r2 - s2.wsize, s2.wsize, 0), s2.wnext = 0, s2.whave = s2.wsize) : ((i2 = s2.wsize - s2.wnext) > o2 && (i2 = o2), n.arraySet(s2.window, t2, r2 - o2, i2, s2.wnext), (o2 -= i2) ? (n.arraySet(s2.window, t2, r2 - o2, o2, 0), s2.wnext = o2, s2.whave = s2.wsize) : (s2.wnext += i2, s2.wnext === s2.wsize && (s2.wnext = 0), s2.whave < s2.wsize && (s2.whave += i2))), 0;
      }
      t.inflateReset = c, t.inflateReset2 = f, t.inflateResetKeep = g, t.inflateInit = function (e2) {
        return p(e2, 15);
      }, t.inflateInit2 = p, t.inflate = function (e2, t2) {
        var r2,
          u2,
          g2,
          c2,
          f2,
          p2,
          h2,
          d2,
          y2,
          v,
          _,
          S,
          w,
          E,
          T,
          R,
          A,
          O,
          C,
          I,
          j,
          M,
          P,
          N,
          L = 0,
          D = new n.Buf8(4),
          x = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!e2 || !e2.state || !e2.output || !e2.input && 0 !== e2.avail_in) return -2;
        12 === (r2 = e2.state).mode && (r2.mode = 13), f2 = e2.next_out, g2 = e2.output, h2 = e2.avail_out, c2 = e2.next_in, u2 = e2.input, p2 = e2.avail_in, d2 = r2.hold, y2 = r2.bits, v = p2, _ = h2, M = 0;
        e: for (;;) switch (r2.mode) {
          case 1:
            if (0 === r2.wrap) {
              r2.mode = 13;
              break;
            }
            for (; y2 < 16;) {
              if (0 === p2) break e;
              p2--, d2 += u2[c2++] << y2, y2 += 8;
            }
            if (2 & r2.wrap && 35615 === d2) {
              r2.check = 0, D[0] = 255 & d2, D[1] = d2 >>> 8 & 255, r2.check = i(r2.check, D, 2, 0), d2 = 0, y2 = 0, r2.mode = 2;
              break;
            }
            if (r2.flags = 0, r2.head && (r2.head.done = false), !(1 & r2.wrap) || (((255 & d2) << 8) + (d2 >> 8)) % 31) {
              e2.msg = "incorrect header check", r2.mode = 30;
              break;
            }
            if (8 != (15 & d2)) {
              e2.msg = "unknown compression method", r2.mode = 30;
              break;
            }
            if (y2 -= 4, j = 8 + (15 & (d2 >>>= 4)), 0 === r2.wbits) r2.wbits = j;else if (j > r2.wbits) {
              e2.msg = "invalid window size", r2.mode = 30;
              break;
            }
            r2.dmax = 1 << j, e2.adler = r2.check = 1, r2.mode = 512 & d2 ? 10 : 12, d2 = 0, y2 = 0;
            break;
          case 2:
            for (; y2 < 16;) {
              if (0 === p2) break e;
              p2--, d2 += u2[c2++] << y2, y2 += 8;
            }
            if (r2.flags = d2, 8 != (255 & r2.flags)) {
              e2.msg = "unknown compression method", r2.mode = 30;
              break;
            }
            if (57344 & r2.flags) {
              e2.msg = "unknown header flags set", r2.mode = 30;
              break;
            }
            r2.head && (r2.head.text = d2 >> 8 & 1), 512 & r2.flags && (D[0] = 255 & d2, D[1] = d2 >>> 8 & 255, r2.check = i(r2.check, D, 2, 0)), d2 = 0, y2 = 0, r2.mode = 3;
          case 3:
            for (; y2 < 32;) {
              if (0 === p2) break e;
              p2--, d2 += u2[c2++] << y2, y2 += 8;
            }
            r2.head && (r2.head.time = d2), 512 & r2.flags && (D[0] = 255 & d2, D[1] = d2 >>> 8 & 255, D[2] = d2 >>> 16 & 255, D[3] = d2 >>> 24 & 255, r2.check = i(r2.check, D, 4, 0)), d2 = 0, y2 = 0, r2.mode = 4;
          case 4:
            for (; y2 < 16;) {
              if (0 === p2) break e;
              p2--, d2 += u2[c2++] << y2, y2 += 8;
            }
            r2.head && (r2.head.xflags = 255 & d2, r2.head.os = d2 >> 8), 512 & r2.flags && (D[0] = 255 & d2, D[1] = d2 >>> 8 & 255, r2.check = i(r2.check, D, 2, 0)), d2 = 0, y2 = 0, r2.mode = 5;
          case 5:
            if (1024 & r2.flags) {
              for (; y2 < 16;) {
                if (0 === p2) break e;
                p2--, d2 += u2[c2++] << y2, y2 += 8;
              }
              r2.length = d2, r2.head && (r2.head.extra_len = d2), 512 & r2.flags && (D[0] = 255 & d2, D[1] = d2 >>> 8 & 255, r2.check = i(r2.check, D, 2, 0)), d2 = 0, y2 = 0;
            } else r2.head && (r2.head.extra = null);
            r2.mode = 6;
          case 6:
            if (1024 & r2.flags && ((S = r2.length) > p2 && (S = p2), S && (r2.head && (j = r2.head.extra_len - r2.length, r2.head.extra || (r2.head.extra = new Array(r2.head.extra_len)), n.arraySet(r2.head.extra, u2, c2, S, j)), 512 & r2.flags && (r2.check = i(r2.check, u2, S, c2)), p2 -= S, c2 += S, r2.length -= S), r2.length)) break e;
            r2.length = 0, r2.mode = 7;
          case 7:
            if (2048 & r2.flags) {
              if (0 === p2) break e;
              S = 0;
              do {
                j = u2[c2 + S++], r2.head && j && r2.length < 65536 && (r2.head.name += String.fromCharCode(j));
              } while (j && S < p2);
              if (512 & r2.flags && (r2.check = i(r2.check, u2, S, c2)), p2 -= S, c2 += S, j) break e;
            } else r2.head && (r2.head.name = null);
            r2.length = 0, r2.mode = 8;
          case 8:
            if (4096 & r2.flags) {
              if (0 === p2) break e;
              S = 0;
              do {
                j = u2[c2 + S++], r2.head && j && r2.length < 65536 && (r2.head.comment += String.fromCharCode(j));
              } while (j && S < p2);
              if (512 & r2.flags && (r2.check = i(r2.check, u2, S, c2)), p2 -= S, c2 += S, j) break e;
            } else r2.head && (r2.head.comment = null);
            r2.mode = 9;
          case 9:
            if (512 & r2.flags) {
              for (; y2 < 16;) {
                if (0 === p2) break e;
                p2--, d2 += u2[c2++] << y2, y2 += 8;
              }
              if (d2 !== (65535 & r2.check)) {
                e2.msg = "header crc mismatch", r2.mode = 30;
                break;
              }
              d2 = 0, y2 = 0;
            }
            r2.head && (r2.head.hcrc = r2.flags >> 9 & 1, r2.head.done = true), e2.adler = r2.check = 0, r2.mode = 12;
            break;
          case 10:
            for (; y2 < 32;) {
              if (0 === p2) break e;
              p2--, d2 += u2[c2++] << y2, y2 += 8;
            }
            e2.adler = r2.check = l(d2), d2 = 0, y2 = 0, r2.mode = 11;
          case 11:
            if (0 === r2.havedict) return e2.next_out = f2, e2.avail_out = h2, e2.next_in = c2, e2.avail_in = p2, r2.hold = d2, r2.bits = y2, 2;
            e2.adler = r2.check = 1, r2.mode = 12;
          case 12:
            if (5 === t2 || 6 === t2) break e;
          case 13:
            if (r2.last) {
              d2 >>>= 7 & y2, y2 -= 7 & y2, r2.mode = 27;
              break;
            }
            for (; y2 < 3;) {
              if (0 === p2) break e;
              p2--, d2 += u2[c2++] << y2, y2 += 8;
            }
            switch (r2.last = 1 & d2, y2 -= 1, 3 & (d2 >>>= 1)) {
              case 0:
                r2.mode = 14;
                break;
              case 1:
                if (m(r2), r2.mode = 20, 6 === t2) {
                  d2 >>>= 2, y2 -= 2;
                  break e;
                }
                break;
              case 2:
                r2.mode = 17;
                break;
              case 3:
                e2.msg = "invalid block type", r2.mode = 30;
            }
            d2 >>>= 2, y2 -= 2;
            break;
          case 14:
            for (d2 >>>= 7 & y2, y2 -= 7 & y2; y2 < 32;) {
              if (0 === p2) break e;
              p2--, d2 += u2[c2++] << y2, y2 += 8;
            }
            if ((65535 & d2) != (d2 >>> 16 ^ 65535)) {
              e2.msg = "invalid stored block lengths", r2.mode = 30;
              break;
            }
            if (r2.length = 65535 & d2, d2 = 0, y2 = 0, r2.mode = 15, 6 === t2) break e;
          case 15:
            r2.mode = 16;
          case 16:
            if (S = r2.length) {
              if (S > p2 && (S = p2), S > h2 && (S = h2), 0 === S) break e;
              n.arraySet(g2, u2, c2, S, f2), p2 -= S, c2 += S, h2 -= S, f2 += S, r2.length -= S;
              break;
            }
            r2.mode = 12;
            break;
          case 17:
            for (; y2 < 14;) {
              if (0 === p2) break e;
              p2--, d2 += u2[c2++] << y2, y2 += 8;
            }
            if (r2.nlen = 257 + (31 & d2), d2 >>>= 5, y2 -= 5, r2.ndist = 1 + (31 & d2), d2 >>>= 5, y2 -= 5, r2.ncode = 4 + (15 & d2), d2 >>>= 4, y2 -= 4, r2.nlen > 286 || r2.ndist > 30) {
              e2.msg = "too many length or distance symbols", r2.mode = 30;
              break;
            }
            r2.have = 0, r2.mode = 18;
          case 18:
            for (; r2.have < r2.ncode;) {
              for (; y2 < 3;) {
                if (0 === p2) break e;
                p2--, d2 += u2[c2++] << y2, y2 += 8;
              }
              r2.lens[x[r2.have++]] = 7 & d2, d2 >>>= 3, y2 -= 3;
            }
            for (; r2.have < 19;) r2.lens[x[r2.have++]] = 0;
            if (r2.lencode = r2.lendyn, r2.lenbits = 7, P = {
              bits: r2.lenbits
            }, M = a2(0, r2.lens, 0, 19, r2.lencode, 0, r2.work, P), r2.lenbits = P.bits, M) {
              e2.msg = "invalid code lengths set", r2.mode = 30;
              break;
            }
            r2.have = 0, r2.mode = 19;
          case 19:
            for (; r2.have < r2.nlen + r2.ndist;) {
              for (; R = (L = r2.lencode[d2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, A = 65535 & L, !((T = L >>> 24) <= y2);) {
                if (0 === p2) break e;
                p2--, d2 += u2[c2++] << y2, y2 += 8;
              }
              if (A < 16) d2 >>>= T, y2 -= T, r2.lens[r2.have++] = A;else {
                if (16 === A) {
                  for (N = T + 2; y2 < N;) {
                    if (0 === p2) break e;
                    p2--, d2 += u2[c2++] << y2, y2 += 8;
                  }
                  if (d2 >>>= T, y2 -= T, 0 === r2.have) {
                    e2.msg = "invalid bit length repeat", r2.mode = 30;
                    break;
                  }
                  j = r2.lens[r2.have - 1], S = 3 + (3 & d2), d2 >>>= 2, y2 -= 2;
                } else if (17 === A) {
                  for (N = T + 3; y2 < N;) {
                    if (0 === p2) break e;
                    p2--, d2 += u2[c2++] << y2, y2 += 8;
                  }
                  y2 -= T, j = 0, S = 3 + (7 & (d2 >>>= T)), d2 >>>= 3, y2 -= 3;
                } else {
                  for (N = T + 7; y2 < N;) {
                    if (0 === p2) break e;
                    p2--, d2 += u2[c2++] << y2, y2 += 8;
                  }
                  y2 -= T, j = 0, S = 11 + (127 & (d2 >>>= T)), d2 >>>= 7, y2 -= 7;
                }
                if (r2.have + S > r2.nlen + r2.ndist) {
                  e2.msg = "invalid bit length repeat", r2.mode = 30;
                  break;
                }
                for (; S--;) r2.lens[r2.have++] = j;
              }
            }
            if (30 === r2.mode) break;
            if (0 === r2.lens[256]) {
              e2.msg = "invalid code -- missing end-of-block", r2.mode = 30;
              break;
            }
            if (r2.lenbits = 9, P = {
              bits: r2.lenbits
            }, M = a2(1, r2.lens, 0, r2.nlen, r2.lencode, 0, r2.work, P), r2.lenbits = P.bits, M) {
              e2.msg = "invalid literal/lengths set", r2.mode = 30;
              break;
            }
            if (r2.distbits = 6, r2.distcode = r2.distdyn, P = {
              bits: r2.distbits
            }, M = a2(2, r2.lens, r2.nlen, r2.ndist, r2.distcode, 0, r2.work, P), r2.distbits = P.bits, M) {
              e2.msg = "invalid distances set", r2.mode = 30;
              break;
            }
            if (r2.mode = 20, 6 === t2) break e;
          case 20:
            r2.mode = 21;
          case 21:
            if (p2 >= 6 && h2 >= 258) {
              e2.next_out = f2, e2.avail_out = h2, e2.next_in = c2, e2.avail_in = p2, r2.hold = d2, r2.bits = y2, s(e2, _), f2 = e2.next_out, g2 = e2.output, h2 = e2.avail_out, c2 = e2.next_in, u2 = e2.input, p2 = e2.avail_in, d2 = r2.hold, y2 = r2.bits, 12 === r2.mode && (r2.back = -1);
              break;
            }
            for (r2.back = 0; R = (L = r2.lencode[d2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, A = 65535 & L, !((T = L >>> 24) <= y2);) {
              if (0 === p2) break e;
              p2--, d2 += u2[c2++] << y2, y2 += 8;
            }
            if (R && 0 == (240 & R)) {
              for (O = T, C = R, I = A; R = (L = r2.lencode[I + ((d2 & (1 << O + C) - 1) >> O)]) >>> 16 & 255, A = 65535 & L, !(O + (T = L >>> 24) <= y2);) {
                if (0 === p2) break e;
                p2--, d2 += u2[c2++] << y2, y2 += 8;
              }
              d2 >>>= O, y2 -= O, r2.back += O;
            }
            if (d2 >>>= T, y2 -= T, r2.back += T, r2.length = A, 0 === R) {
              r2.mode = 26;
              break;
            }
            if (32 & R) {
              r2.back = -1, r2.mode = 12;
              break;
            }
            if (64 & R) {
              e2.msg = "invalid literal/length code", r2.mode = 30;
              break;
            }
            r2.extra = 15 & R, r2.mode = 22;
          case 22:
            if (r2.extra) {
              for (N = r2.extra; y2 < N;) {
                if (0 === p2) break e;
                p2--, d2 += u2[c2++] << y2, y2 += 8;
              }
              r2.length += d2 & (1 << r2.extra) - 1, d2 >>>= r2.extra, y2 -= r2.extra, r2.back += r2.extra;
            }
            r2.was = r2.length, r2.mode = 23;
          case 23:
            for (; R = (L = r2.distcode[d2 & (1 << r2.distbits) - 1]) >>> 16 & 255, A = 65535 & L, !((T = L >>> 24) <= y2);) {
              if (0 === p2) break e;
              p2--, d2 += u2[c2++] << y2, y2 += 8;
            }
            if (0 == (240 & R)) {
              for (O = T, C = R, I = A; R = (L = r2.distcode[I + ((d2 & (1 << O + C) - 1) >> O)]) >>> 16 & 255, A = 65535 & L, !(O + (T = L >>> 24) <= y2);) {
                if (0 === p2) break e;
                p2--, d2 += u2[c2++] << y2, y2 += 8;
              }
              d2 >>>= O, y2 -= O, r2.back += O;
            }
            if (d2 >>>= T, y2 -= T, r2.back += T, 64 & R) {
              e2.msg = "invalid distance code", r2.mode = 30;
              break;
            }
            r2.offset = A, r2.extra = 15 & R, r2.mode = 24;
          case 24:
            if (r2.extra) {
              for (N = r2.extra; y2 < N;) {
                if (0 === p2) break e;
                p2--, d2 += u2[c2++] << y2, y2 += 8;
              }
              r2.offset += d2 & (1 << r2.extra) - 1, d2 >>>= r2.extra, y2 -= r2.extra, r2.back += r2.extra;
            }
            if (r2.offset > r2.dmax) {
              e2.msg = "invalid distance too far back", r2.mode = 30;
              break;
            }
            r2.mode = 25;
          case 25:
            if (0 === h2) break e;
            if (S = _ - h2, r2.offset > S) {
              if ((S = r2.offset - S) > r2.whave && r2.sane) {
                e2.msg = "invalid distance too far back", r2.mode = 30;
                break;
              }
              S > r2.wnext ? (S -= r2.wnext, w = r2.wsize - S) : w = r2.wnext - S, S > r2.length && (S = r2.length), E = r2.window;
            } else E = g2, w = f2 - r2.offset, S = r2.length;
            S > h2 && (S = h2), h2 -= S, r2.length -= S;
            do {
              g2[f2++] = E[w++];
            } while (--S);
            0 === r2.length && (r2.mode = 21);
            break;
          case 26:
            if (0 === h2) break e;
            g2[f2++] = r2.length, h2--, r2.mode = 21;
            break;
          case 27:
            if (r2.wrap) {
              for (; y2 < 32;) {
                if (0 === p2) break e;
                p2--, d2 |= u2[c2++] << y2, y2 += 8;
              }
              if (_ -= h2, e2.total_out += _, r2.total += _, _ && (e2.adler = r2.check = r2.flags ? i(r2.check, g2, _, f2 - _) : o(r2.check, g2, _, f2 - _)), _ = h2, (r2.flags ? d2 : l(d2)) !== r2.check) {
                e2.msg = "incorrect data check", r2.mode = 30;
                break;
              }
              d2 = 0, y2 = 0;
            }
            r2.mode = 28;
          case 28:
            if (r2.wrap && r2.flags) {
              for (; y2 < 32;) {
                if (0 === p2) break e;
                p2--, d2 += u2[c2++] << y2, y2 += 8;
              }
              if (d2 !== (4294967295 & r2.total)) {
                e2.msg = "incorrect length check", r2.mode = 30;
                break;
              }
              d2 = 0, y2 = 0;
            }
            r2.mode = 29;
          case 29:
            M = 1;
            break e;
          case 30:
            M = -3;
            break e;
          case 31:
            return -4;
          case 32:
          default:
            return -2;
        }
        return e2.next_out = f2, e2.avail_out = h2, e2.next_in = c2, e2.avail_in = p2, r2.hold = d2, r2.bits = y2, (r2.wsize || _ !== e2.avail_out && r2.mode < 30 && (r2.mode < 27 || 4 !== t2)) && b(e2, e2.output, e2.next_out, _ - e2.avail_out) ? (r2.mode = 31, -4) : (v -= e2.avail_in, _ -= e2.avail_out, e2.total_in += v, e2.total_out += _, r2.total += _, r2.wrap && _ && (e2.adler = r2.check = r2.flags ? i(r2.check, g2, _, e2.next_out - _) : o(r2.check, g2, _, e2.next_out - _)), e2.data_type = r2.bits + (r2.last ? 64 : 0) + (12 === r2.mode ? 128 : 0) + (20 === r2.mode || 15 === r2.mode ? 256 : 0), (0 === v && 0 === _ || 4 === t2) && 0 === M && (M = -5), M);
      }, t.inflateEnd = function (e2) {
        if (!e2 || !e2.state) return -2;
        var t2 = e2.state;
        return t2.window && (t2.window = null), e2.state = null, 0;
      }, t.inflateGetHeader = function (e2, t2) {
        var r2;
        return e2 && e2.state ? 0 == (2 & (r2 = e2.state).wrap) ? -2 : (r2.head = t2, t2.done = false, 0) : -2;
      }, t.inflateSetDictionary = function (e2, t2) {
        var r2,
          n2 = t2.length;
        return e2 && e2.state ? 0 !== (r2 = e2.state).wrap && 11 !== r2.mode ? -2 : 11 === r2.mode && o(1, t2, n2, 0) !== r2.check ? -3 : b(e2, t2, n2, n2) ? (r2.mode = 31, -4) : (r2.havedict = 1, 0) : -2;
      }, t.inflateInfo = "pako inflate (from Nodeca project)";
    }, function (e, t, r) {
      e.exports = function (e2, t2) {
        var r2, n, o, i, s, a2, l, u, g, c, f, p, h, d, y, m, b, v, _, S, w, E, T, R, A;
        r2 = e2.state, n = e2.next_in, R = e2.input, o = n + (e2.avail_in - 5), i = e2.next_out, A = e2.output, s = i - (t2 - e2.avail_out), a2 = i + (e2.avail_out - 257), l = r2.dmax, u = r2.wsize, g = r2.whave, c = r2.wnext, f = r2.window, p = r2.hold, h = r2.bits, d = r2.lencode, y = r2.distcode, m = (1 << r2.lenbits) - 1, b = (1 << r2.distbits) - 1;
        e: do {
          h < 15 && (p += R[n++] << h, h += 8, p += R[n++] << h, h += 8), v = d[p & m];
          t: for (;;) {
            if (p >>>= _ = v >>> 24, h -= _, 0 === (_ = v >>> 16 & 255)) A[i++] = 65535 & v;else {
              if (!(16 & _)) {
                if (0 == (64 & _)) {
                  v = d[(65535 & v) + (p & (1 << _) - 1)];
                  continue t;
                }
                if (32 & _) {
                  r2.mode = 12;
                  break e;
                }
                e2.msg = "invalid literal/length code", r2.mode = 30;
                break e;
              }
              S = 65535 & v, (_ &= 15) && (h < _ && (p += R[n++] << h, h += 8), S += p & (1 << _) - 1, p >>>= _, h -= _), h < 15 && (p += R[n++] << h, h += 8, p += R[n++] << h, h += 8), v = y[p & b];
              r: for (;;) {
                if (p >>>= _ = v >>> 24, h -= _, !(16 & (_ = v >>> 16 & 255))) {
                  if (0 == (64 & _)) {
                    v = y[(65535 & v) + (p & (1 << _) - 1)];
                    continue r;
                  }
                  e2.msg = "invalid distance code", r2.mode = 30;
                  break e;
                }
                if (w = 65535 & v, h < (_ &= 15) && (p += R[n++] << h, (h += 8) < _ && (p += R[n++] << h, h += 8)), (w += p & (1 << _) - 1) > l) {
                  e2.msg = "invalid distance too far back", r2.mode = 30;
                  break e;
                }
                if (p >>>= _, h -= _, w > (_ = i - s)) {
                  if ((_ = w - _) > g && r2.sane) {
                    e2.msg = "invalid distance too far back", r2.mode = 30;
                    break e;
                  }
                  if (E = 0, T = f, 0 === c) {
                    if (E += u - _, _ < S) {
                      S -= _;
                      do {
                        A[i++] = f[E++];
                      } while (--_);
                      E = i - w, T = A;
                    }
                  } else if (c < _) {
                    if (E += u + c - _, (_ -= c) < S) {
                      S -= _;
                      do {
                        A[i++] = f[E++];
                      } while (--_);
                      if (E = 0, c < S) {
                        S -= _ = c;
                        do {
                          A[i++] = f[E++];
                        } while (--_);
                        E = i - w, T = A;
                      }
                    }
                  } else if (E += c - _, _ < S) {
                    S -= _;
                    do {
                      A[i++] = f[E++];
                    } while (--_);
                    E = i - w, T = A;
                  }
                  for (; S > 2;) A[i++] = T[E++], A[i++] = T[E++], A[i++] = T[E++], S -= 3;
                  S && (A[i++] = T[E++], S > 1 && (A[i++] = T[E++]));
                } else {
                  E = i - w;
                  do {
                    A[i++] = A[E++], A[i++] = A[E++], A[i++] = A[E++], S -= 3;
                  } while (S > 2);
                  S && (A[i++] = A[E++], S > 1 && (A[i++] = A[E++]));
                }
                break;
              }
            }
            break;
          }
        } while (n < o && i < a2);
        n -= S = h >> 3, p &= (1 << (h -= S << 3)) - 1, e2.next_in = n, e2.next_out = i, e2.avail_in = n < o ? o - n + 5 : 5 - (n - o), e2.avail_out = i < a2 ? a2 - i + 257 : 257 - (i - a2), r2.hold = p, r2.bits = h;
      };
    }, function (e, t, r) {
      var n = r(37),
        o = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
        i = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
        s = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
        a2 = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      e.exports = function (e2, t2, r2, l, u, g, c, f) {
        var p,
          h,
          d,
          y,
          m,
          b,
          v,
          _,
          S,
          w = f.bits,
          E = 0,
          T = 0,
          R = 0,
          A = 0,
          O = 0,
          C = 0,
          I = 0,
          j = 0,
          M = 0,
          P = 0,
          N = null,
          L = 0,
          D = new n.Buf16(16),
          x = new n.Buf16(16),
          U = null,
          B = 0;
        for (E = 0; E <= 15; E++) D[E] = 0;
        for (T = 0; T < l; T++) D[t2[r2 + T]]++;
        for (O = w, A = 15; A >= 1 && 0 === D[A]; A--);
        if (O > A && (O = A), 0 === A) return u[g++] = 20971520, u[g++] = 20971520, f.bits = 1, 0;
        for (R = 1; R < A && 0 === D[R]; R++);
        for (O < R && (O = R), j = 1, E = 1; E <= 15; E++) if (j <<= 1, (j -= D[E]) < 0) return -1;
        if (j > 0 && (0 === e2 || 1 !== A)) return -1;
        for (x[1] = 0, E = 1; E < 15; E++) x[E + 1] = x[E] + D[E];
        for (T = 0; T < l; T++) 0 !== t2[r2 + T] && (c[x[t2[r2 + T]]++] = T);
        if (0 === e2 ? (N = U = c, b = 19) : 1 === e2 ? (N = o, L -= 257, U = i, B -= 257, b = 256) : (N = s, U = a2, b = -1), P = 0, T = 0, E = R, m = g, C = O, I = 0, d = -1, y = (M = 1 << O) - 1, 1 === e2 && M > 852 || 2 === e2 && M > 592) return 1;
        for (;;) {
          v = E - I, c[T] < b ? (_ = 0, S = c[T]) : c[T] > b ? (_ = U[B + c[T]], S = N[L + c[T]]) : (_ = 96, S = 0), p = 1 << E - I, R = h = 1 << C;
          do {
            u[m + (P >> I) + (h -= p)] = v << 24 | _ << 16 | S | 0;
          } while (0 !== h);
          for (p = 1 << E - 1; P & p;) p >>= 1;
          if (0 !== p ? (P &= p - 1, P += p) : P = 0, T++, 0 == --D[E]) {
            if (E === A) break;
            E = t2[r2 + c[T]];
          }
          if (E > O && (P & y) !== d) {
            for (0 === I && (I = O), m += R, j = 1 << (C = E - I); C + I < A && !((j -= D[C + I]) <= 0);) C++, j <<= 1;
            if (M += 1 << C, 1 === e2 && M > 852 || 2 === e2 && M > 592) return 1;
            u[d = P & y] = O << 24 | C << 16 | m - g | 0;
          }
        }
        return 0 !== P && (u[m + P] = E - I << 24 | 64 << 16 | 0), f.bits = O, 0;
      };
    }, function (e, t, r) {
      e.exports = {
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        Z_BUF_ERROR: -5,
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        Z_BINARY: 0,
        Z_TEXT: 1,
        Z_UNKNOWN: 2,
        Z_DEFLATED: 8
      };
    }, function (e, t) {}, function (e, t, r) {
      function n(e2, t2) {
        var r2 = Object.keys(e2);
        if (Object.getOwnPropertySymbols) {
          var n2 = Object.getOwnPropertySymbols(e2);
          t2 && (n2 = n2.filter(function (t3) {
            return Object.getOwnPropertyDescriptor(e2, t3).enumerable;
          })), r2.push.apply(r2, n2);
        }
        return r2;
      }
      function o(e2, t2, r2) {
        return t2 in e2 ? Object.defineProperty(e2, t2, {
          value: r2,
          enumerable: true,
          configurable: true,
          writable: true
        }) : e2[t2] = r2, e2;
      }
      function i(e2, t2) {
        for (var r2 = 0; r2 < t2.length; r2++) {
          var n2 = t2[r2];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
        }
      }
      var s = r(5).Buffer,
        a2 = r(181).inspect,
        l = a2 && a2.custom || "inspect";
      e.exports = function () {
        function e2() {
          !function (e3, t3) {
            if (!(e3 instanceof t3)) throw new TypeError("Cannot call a class as a function");
          }(this, e2), this.head = null, this.tail = null, this.length = 0;
        }
        var t2, r2;
        return t2 = e2, (r2 = [{
          key: "push",
          value: function value(e3) {
            var t3 = {
              data: e3,
              next: null
            };
            this.length > 0 ? this.tail.next = t3 : this.head = t3, this.tail = t3, ++this.length;
          }
        }, {
          key: "unshift",
          value: function value(e3) {
            var t3 = {
              data: e3,
              next: this.head
            };
            0 === this.length && (this.tail = t3), this.head = t3, ++this.length;
          }
        }, {
          key: "shift",
          value: function value() {
            if (0 !== this.length) {
              var e3 = this.head.data;
              return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e3;
            }
          }
        }, {
          key: "clear",
          value: function value() {
            this.head = this.tail = null, this.length = 0;
          }
        }, {
          key: "join",
          value: function value(e3) {
            if (0 === this.length) return "";
            for (var t3 = this.head, r3 = "" + t3.data; t3 = t3.next;) r3 += e3 + t3.data;
            return r3;
          }
        }, {
          key: "concat",
          value: function value(e3) {
            if (0 === this.length) return s.alloc(0);
            for (var t3, r3, n2, o2 = s.allocUnsafe(e3 >>> 0), i2 = this.head, a3 = 0; i2;) t3 = i2.data, r3 = o2, n2 = a3, s.prototype.copy.call(t3, r3, n2), a3 += i2.data.length, i2 = i2.next;
            return o2;
          }
        }, {
          key: "consume",
          value: function value(e3, t3) {
            var r3;
            return e3 < this.head.data.length ? (r3 = this.head.data.slice(0, e3), this.head.data = this.head.data.slice(e3)) : r3 = e3 === this.head.data.length ? this.shift() : t3 ? this._getString(e3) : this._getBuffer(e3), r3;
          }
        }, {
          key: "first",
          value: function value() {
            return this.head.data;
          }
        }, {
          key: "_getString",
          value: function value(e3) {
            var t3 = this.head,
              r3 = 1,
              n2 = t3.data;
            for (e3 -= n2.length; t3 = t3.next;) {
              var o2 = t3.data,
                i2 = e3 > o2.length ? o2.length : e3;
              if (i2 === o2.length ? n2 += o2 : n2 += o2.slice(0, e3), 0 == (e3 -= i2)) {
                i2 === o2.length ? (++r3, t3.next ? this.head = t3.next : this.head = this.tail = null) : (this.head = t3, t3.data = o2.slice(i2));
                break;
              }
              ++r3;
            }
            return this.length -= r3, n2;
          }
        }, {
          key: "_getBuffer",
          value: function value(e3) {
            var t3 = s.allocUnsafe(e3),
              r3 = this.head,
              n2 = 1;
            for (r3.data.copy(t3), e3 -= r3.data.length; r3 = r3.next;) {
              var o2 = r3.data,
                i2 = e3 > o2.length ? o2.length : e3;
              if (o2.copy(t3, t3.length - e3, 0, i2), 0 == (e3 -= i2)) {
                i2 === o2.length ? (++n2, r3.next ? this.head = r3.next : this.head = this.tail = null) : (this.head = r3, r3.data = o2.slice(i2));
                break;
              }
              ++n2;
            }
            return this.length -= n2, t3;
          }
        }, {
          key: l,
          value: function value(e3, t3) {
            return a2(this, function (e4) {
              for (var t4 = 1; t4 < arguments.length; t4++) {
                var r3 = null != arguments[t4] ? arguments[t4] : {};
                t4 % 2 ? n(Object(r3), true).forEach(function (t5) {
                  o(e4, t5, r3[t5]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(r3)) : n(Object(r3)).forEach(function (t5) {
                  Object.defineProperty(e4, t5, Object.getOwnPropertyDescriptor(r3, t5));
                });
              }
              return e4;
            }({}, t3, {
              depth: 0,
              customInspect: false
            }));
          }
        }]) && i(t2.prototype, r2), e2;
      }();
    }, function (e, t) {}, function (e, t, r) {
      (function (t2) {
        var n;
        function o(e2, t3, r2) {
          return t3 in e2 ? Object.defineProperty(e2, t3, {
            value: r2,
            enumerable: true,
            configurable: true,
            writable: true
          }) : e2[t3] = r2, e2;
        }
        var i = r(49),
          s = Symbol("lastResolve"),
          a2 = Symbol("lastReject"),
          l = Symbol("error"),
          u = Symbol("ended"),
          g = Symbol("lastPromise"),
          c = Symbol("handlePromise"),
          f = Symbol("stream");
        function p(e2, t3) {
          return {
            value: e2,
            done: t3
          };
        }
        function h(e2) {
          var t3 = e2[s];
          if (null !== t3) {
            var r2 = e2[f].read();
            null !== r2 && (e2[g] = null, e2[s] = null, e2[a2] = null, t3(p(r2, false)));
          }
        }
        function d(e2) {
          t2.nextTick(h, e2);
        }
        var y = Object.getPrototypeOf(function () {}),
          m = Object.setPrototypeOf((o(n = {
            get stream() {
              return this[f];
            },
            next: function next() {
              var e2 = this,
                r2 = this[l];
              if (null !== r2) return Promise.reject(r2);
              if (this[u]) return Promise.resolve(p(void 0, true));
              if (this[f].destroyed) return new Promise(function (r3, n3) {
                t2.nextTick(function () {
                  e2[l] ? n3(e2[l]) : r3(p(void 0, true));
                });
              });
              var n2,
                o2 = this[g];
              if (o2) n2 = new Promise(function (e3, t3) {
                return function (r3, n3) {
                  e3.then(function () {
                    t3[u] ? r3(p(void 0, true)) : t3[c](r3, n3);
                  }, n3);
                };
              }(o2, this));else {
                var i2 = this[f].read();
                if (null !== i2) return Promise.resolve(p(i2, false));
                n2 = new Promise(this[c]);
              }
              return this[g] = n2, n2;
            }
          }, Symbol.asyncIterator, function () {
            return this;
          }), o(n, "return", function () {
            var e2 = this;
            return new Promise(function (t3, r2) {
              e2[f].destroy(null, function (e3) {
                e3 ? r2(e3) : t3(p(void 0, true));
              });
            });
          }), n), y);
        e.exports = function (e2) {
          var t3,
            r2 = Object.create(m, (o(t3 = {}, f, {
              value: e2,
              writable: true
            }), o(t3, s, {
              value: null,
              writable: true
            }), o(t3, a2, {
              value: null,
              writable: true
            }), o(t3, l, {
              value: null,
              writable: true
            }), o(t3, u, {
              value: e2._readableState.endEmitted,
              writable: true
            }), o(t3, c, {
              value: function value(e3, t4) {
                var n2 = r2[f].read();
                n2 ? (r2[g] = null, r2[s] = null, r2[a2] = null, e3(p(n2, false))) : (r2[s] = e3, r2[a2] = t4);
              },
              writable: true
            }), t3));
          return r2[g] = null, i(e2, function (e3) {
            if (e3 && "ERR_STREAM_PREMATURE_CLOSE" !== e3.code) {
              var t4 = r2[a2];
              return null !== t4 && (r2[g] = null, r2[s] = null, r2[a2] = null, t4(e3)), void (r2[l] = e3);
            }
            var n2 = r2[s];
            null !== n2 && (r2[g] = null, r2[s] = null, r2[a2] = null, n2(p(void 0, true))), r2[u] = true;
          }), e2.on("readable", d.bind(null, r2)), r2;
        };
      }).call(this, r(2));
    }, function (e, t) {
      e.exports = function () {
        throw new Error("Readable.from is not available in the browser");
      };
    }, function (e, t, r) {
      e.exports = o;
      var n = r(82);
      function o(e2) {
        if (!(this instanceof o)) return new o(e2);
        n.call(this, e2);
      }
      r(7)(o, n), o.prototype._transform = function (e2, t2, r2) {
        r2(null, e2);
      };
    }, function (e, t, r) {
      var n;
      var o = r(26).codes,
        i = o.ERR_MISSING_ARGS,
        s = o.ERR_STREAM_DESTROYED;
      function a2(e2) {
        if (e2) throw e2;
      }
      function l(e2, t2, o2, i2) {
        i2 = function (e3) {
          var t3 = false;
          return function () {
            t3 || (t3 = true, e3.apply(void 0, arguments));
          };
        }(i2);
        var a3 = false;
        e2.on("close", function () {
          a3 = true;
        }), void 0 === n && (n = r(49)), n(e2, {
          readable: t2,
          writable: o2
        }, function (e3) {
          if (e3) return i2(e3);
          a3 = true, i2();
        });
        var l2 = false;
        return function (t3) {
          if (!a3 && !l2) return l2 = true, function (e3) {
            return e3.setHeader && "function" == typeof e3.abort;
          }(e2) ? e2.abort() : "function" == typeof e2.destroy ? e2.destroy() : void i2(t3 || new s("pipe"));
        };
      }
      function u(e2) {
        e2();
      }
      function g(e2, t2) {
        return e2.pipe(t2);
      }
      function c(e2) {
        return e2.length ? "function" != typeof e2[e2.length - 1] ? a2 : e2.pop() : a2;
      }
      e.exports = function () {
        for (var e2 = arguments.length, t2 = new Array(e2), r2 = 0; r2 < e2; r2++) t2[r2] = arguments[r2];
        var n2,
          o2 = c(t2);
        if (Array.isArray(t2[0]) && (t2 = t2[0]), t2.length < 2) throw new i("streams");
        var s2 = t2.map(function (e3, r3) {
          var i2 = r3 < t2.length - 1;
          return l(e3, i2, r3 > 0, function (e4) {
            n2 || (n2 = e4), e4 && s2.forEach(u), i2 || (s2.forEach(u), o2(n2));
          });
        });
        return t2.reduce(g);
      };
    }, function (e, t, r) {
      var n = r(187)(function e2(t2, r2) {
        return (r2 = r2 || {}).namespace = t2, r2.prod = true, r2.dev = false, r2.force || e2.force ? e2.yep(r2) : e2.nope(r2);
      });
      e.exports = n;
    }, function (e, t) {
      var r = [],
        n = [],
        o = function o() {};
      function i(e2) {
        return !~r.indexOf(e2) && (r.push(e2), true);
      }
      function s(e2) {
        o = e2;
      }
      function a2(e2) {
        for (var t2 = [], n2 = 0; n2 < r.length; n2++) if (r[n2].async) t2.push(r[n2]);else if (r[n2](e2)) return true;
        return !!t2.length && new Promise(function (r2) {
          Promise.all(t2.map(function (t3) {
            return t3(e2);
          })).then(function (e3) {
            r2(e3.some(Boolean));
          });
        });
      }
      function l(e2) {
        return !~n.indexOf(e2) && (n.push(e2), true);
      }
      function u() {
        o.apply(o, arguments);
      }
      function g(e2) {
        for (var t2 = 0; t2 < n.length; t2++) e2 = n[t2].apply(n[t2], arguments);
        return e2;
      }
      function c(e2, t2) {
        var r2 = Object.prototype.hasOwnProperty;
        for (var n2 in t2) r2.call(t2, n2) && (e2[n2] = t2[n2]);
        return e2;
      }
      function f(e2) {
        return e2.enabled = false, e2.modify = l, e2.set = s, e2.use = i, c(function () {
          return false;
        }, e2);
      }
      function p(e2) {
        return e2.enabled = true, e2.modify = l, e2.set = s, e2.use = i, c(function () {
          var t2 = Array.prototype.slice.call(arguments, 0);
          return u.call(u, e2, g(t2, e2)), true;
        }, e2);
      }
      e.exports = function (e2) {
        return e2.introduce = c, e2.enabled = a2, e2.process = g, e2.modify = l, e2.write = u, e2.nope = f, e2.yep = p, e2.set = s, e2.use = i, e2;
      };
    }, function (e, t, r) {
      (function (t2) {
        var n = r(65),
          o = r(22).StringDecoder,
          i = r(32).Stream;
        function s() {}
        e.exports = function (e2, r2) {
          var a2 = t2.alloc(65536),
            l = new o("utf8"),
            u = new i(),
            g = "",
            c = 0,
            f = 0;
          return -1 === e2.start && delete e2.start, u.readable = true, u.destroy = function () {
            u.destroyed = true, u.emit("end"), u.emit("close");
          }, n.open(e2.file, "a+", "0644", function (t3, o2) {
            if (t3) return r2 ? r2(t3) : u.emit("error", t3), void u.destroy();
            !function t4() {
              if (!u.destroyed) return n.read(o2, a2, 0, a2.length, c, function (n2, o3) {
                if (n2) return r2 ? r2(n2) : u.emit("error", n2), void u.destroy();
                if (!o3) return g && ((null == e2.start || f > e2.start) && (r2 ? r2(null, g) : u.emit("line", g)), f++, g = ""), setTimeout(t4, 1e3);
                var i2 = l.write(a2.slice(0, o3));
                r2 || u.emit("data", i2);
                for (var s2 = (i2 = (g + i2).split(/\n+/)).length - 1, p = 0; p < s2; p++) (null == e2.start || f > e2.start) && (r2 ? r2(null, i2[p]) : u.emit("line", i2[p])), f++;
                return g = i2[s2], c += o3, t4();
              });
              n.close(o2, s);
            }();
          }), r2 ? u.destroy : u;
        };
      }).call(this, r(5).Buffer);
    }, function (e, t, r) {
      (function (t2, n) {
        function o(e2) {
          return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e3) {
            return typeof e3;
          } : function (e3) {
            return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
          })(e2);
        }
        function i(e2, t3) {
          var r2 = Object.keys(e2);
          if (Object.getOwnPropertySymbols) {
            var n2 = Object.getOwnPropertySymbols(e2);
            t3 && (n2 = n2.filter(function (t4) {
              return Object.getOwnPropertyDescriptor(e2, t4).enumerable;
            })), r2.push.apply(r2, n2);
          }
          return r2;
        }
        function s(e2) {
          for (var t3 = 1; t3 < arguments.length; t3++) {
            var r2 = null != arguments[t3] ? arguments[t3] : {};
            t3 % 2 ? i(Object(r2), true).forEach(function (t4) {
              a2(e2, t4, r2[t4]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(r2)) : i(Object(r2)).forEach(function (t4) {
              Object.defineProperty(e2, t4, Object.getOwnPropertyDescriptor(r2, t4));
            });
          }
          return e2;
        }
        function a2(e2, t3, r2) {
          return t3 in e2 ? Object.defineProperty(e2, t3, {
            value: r2,
            enumerable: true,
            configurable: true,
            writable: true
          }) : e2[t3] = r2, e2;
        }
        function l(e2, t3) {
          if (!(e2 instanceof t3)) throw new TypeError("Cannot call a class as a function");
        }
        function u(e2, t3) {
          for (var r2 = 0; r2 < t3.length; r2++) {
            var n2 = t3[r2];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
          }
        }
        function g(e2, t3) {
          return (g = Object.setPrototypeOf || function (e3, t4) {
            return e3.__proto__ = t4, e3;
          })(e2, t3);
        }
        function c(e2) {
          var t3 = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if ("function" == typeof Proxy) return true;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), true;
            } catch (e3) {
              return false;
            }
          }();
          return function () {
            var r2,
              n2 = p(e2);
            if (t3) {
              var o2 = p(this).constructor;
              r2 = Reflect.construct(n2, arguments, o2);
            } else r2 = n2.apply(this, arguments);
            return f(this, r2);
          };
        }
        function f(e2, t3) {
          return !t3 || "object" !== o(t3) && "function" != typeof t3 ? function (e3) {
            if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e3;
          }(e2) : t3;
        }
        function p(e2) {
          return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e3) {
            return e3.__proto__ || Object.getPrototypeOf(e3);
          })(e2);
        }
        var h = r(83),
          d = r(200),
          y = r(32).Stream,
          m = r(20);
        e.exports = function (e2) {
          !function (e3, t3) {
            if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
            e3.prototype = Object.create(t3 && t3.prototype, {
              constructor: {
                value: e3,
                writable: true,
                configurable: true
              }
            }), t3 && g(e3, t3);
          }(f2, e2);
          var r2,
            o2,
            a3 = c(f2);
          function f2() {
            var e3,
              t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return l(this, f2), (e3 = a3.call(this, t3)).options = t3, e3.name = t3.name || "http", e3.ssl = !!t3.ssl, e3.host = t3.host || "localhost", e3.port = t3.port, e3.auth = t3.auth, e3.path = t3.path || "", e3.agent = t3.agent, e3.headers = t3.headers || {}, e3.headers["content-type"] = "application/json", e3.port || (e3.port = e3.ssl ? 443 : 80), e3;
          }
          return r2 = f2, (o2 = [{
            key: "log",
            value: function value(e3, r3) {
              var n2 = this;
              this._request(e3, function (t3, r4) {
                r4 && 200 !== r4.statusCode && (t3 = new Error("Invalid HTTP Status Code: ".concat(r4.statusCode))), t3 ? n2.emit("warn", t3) : n2.emit("logged", e3);
              }), r3 && t2(r3);
            }
          }, {
            key: "query",
            value: function value(e3, t3) {
              "function" == typeof e3 && (t3 = e3, e3 = {}), (e3 = {
                method: "query",
                params: this.normalizeQuery(e3)
              }).params.path && (e3.path = e3.params.path, delete e3.params.path), e3.params.auth && (e3.auth = e3.params.auth, delete e3.params.auth), this._request(e3, function (e4, r3, n2) {
                if (r3 && 200 !== r3.statusCode && (e4 = new Error("Invalid HTTP Status Code: ".concat(r3.statusCode))), e4) return t3(e4);
                if ("string" == typeof n2) try {
                  n2 = JSON.parse(n2);
                } catch (e5) {
                  return t3(e5);
                }
                t3(null, n2);
              });
            }
          }, {
            key: "stream",
            value: function value() {
              var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t3 = new y();
              (e3 = {
                method: "stream",
                params: e3
              }).params.path && (e3.path = e3.params.path, delete e3.params.path), e3.params.auth && (e3.auth = e3.params.auth, delete e3.params.auth);
              var r3 = "",
                n2 = this._request(e3);
              return t3.destroy = function () {
                return n2.destroy();
              }, n2.on("data", function (e4) {
                for (var n3 = (e4 = (r3 + e4).split(/\n+/)).length - 1, o3 = 0; o3 < n3; o3++) try {
                  t3.emit("log", JSON.parse(e4[o3]));
                } catch (e5) {
                  t3.emit("error", e5);
                }
                r3 = e4[n3];
              }), n2.on("error", function (e4) {
                return t3.emit("error", e4);
              }), t3;
            }
          }, {
            key: "_request",
            value: function value(e3, t3) {
              var r3 = (e3 = e3 || {}).auth || this.auth,
                o3 = e3.path || this.path || "";
              delete e3.auth, delete e3.path;
              var i2 = Object.assign({}, this.headers);
              r3 && r3.bearer && (i2.Authorization = "Bearer ".concat(r3.bearer));
              var a4 = (this.ssl ? d : h).request(s(s({}, this.options), {}, {
                method: "POST",
                host: this.host,
                port: this.port,
                path: "/".concat(o3.replace(/^\//, "")),
                headers: i2,
                auth: r3 && r3.username && r3.password ? "".concat(r3.username, ":").concat(r3.password) : "",
                agent: this.agent
              }));
              a4.on("error", t3), a4.on("response", function (e4) {
                return e4.on("end", function () {
                  return t3(null, e4);
                }).resume();
              }), a4.end(n.from(JSON.stringify(e3), "utf8"));
            }
          }]) && u(r2.prototype, o2), f2;
        }(m);
      }).call(this, r(15).setImmediate, r(5).Buffer);
    }, function (e, t, r) {
      (function (t2, n, o) {
        var i = r(84),
          s = r(7),
          a2 = r(85),
          l = r(31),
          u = r(191),
          g = a2.IncomingMessage,
          c = a2.readyStates;
        var f = e.exports = function (e2) {
          var r2,
            n2 = this;
          l.Writable.call(n2), n2._opts = e2, n2._body = [], n2._headers = {}, e2.auth && n2.setHeader("Authorization", "Basic " + new t2(e2.auth).toString("base64")), Object.keys(e2.headers).forEach(function (t3) {
            n2.setHeader(t3, e2.headers[t3]);
          });
          var o2 = true;
          if ("disable-fetch" === e2.mode || "requestTimeout" in e2 && !i.abortController) o2 = false, r2 = true;else if ("prefer-streaming" === e2.mode) r2 = false;else if ("allow-wrong-content-type" === e2.mode) r2 = !i.overrideMimeType;else {
            if (e2.mode && "default" !== e2.mode && "prefer-fast" !== e2.mode) throw new Error("Invalid value for opts.mode");
            r2 = true;
          }
          n2._mode = function (e3, t3) {
            return i.fetch && t3 ? "fetch" : i.mozchunkedarraybuffer ? "moz-chunked-arraybuffer" : i.msstream ? "ms-stream" : i.arraybuffer && e3 ? "arraybuffer" : i.vbArray && e3 ? "text:vbarray" : "text";
          }(r2, o2), n2._fetchTimer = null, n2.on("finish", function () {
            n2._onFinish();
          });
        };
        s(f, l.Writable), f.prototype.setHeader = function (e2, t3) {
          var r2 = e2.toLowerCase();
          -1 === p.indexOf(r2) && (this._headers[r2] = {
            name: e2,
            value: t3
          });
        }, f.prototype.getHeader = function (e2) {
          var t3 = this._headers[e2.toLowerCase()];
          return t3 ? t3.value : null;
        }, f.prototype.removeHeader = function (e2) {
          delete this._headers[e2.toLowerCase()];
        }, f.prototype._onFinish = function () {
          var e2 = this;
          if (!e2._destroyed) {
            var r2 = e2._opts,
              s2 = e2._headers,
              a3 = null;
            "GET" !== r2.method && "HEAD" !== r2.method && (a3 = i.arraybuffer ? u(t2.concat(e2._body)) : i.blobConstructor ? new n.Blob(e2._body.map(function (e3) {
              return u(e3);
            }), {
              type: (s2["content-type"] || {}).value || ""
            }) : t2.concat(e2._body).toString());
            var l2 = [];
            if (Object.keys(s2).forEach(function (e3) {
              var t3 = s2[e3].name,
                r3 = s2[e3].value;
              Array.isArray(r3) ? r3.forEach(function (e4) {
                l2.push([t3, e4]);
              }) : l2.push([t3, r3]);
            }), "fetch" === e2._mode) {
              var g2 = null;
              if (i.abortController) {
                var f2 = new AbortController();
                g2 = f2.signal, e2._fetchAbortController = f2, "requestTimeout" in r2 && 0 !== r2.requestTimeout && (e2._fetchTimer = n.setTimeout(function () {
                  e2.emit("requestTimeout"), e2._fetchAbortController && e2._fetchAbortController.abort();
                }, r2.requestTimeout));
              }
              n.fetch(e2._opts.url, {
                method: e2._opts.method,
                headers: l2,
                body: a3 || void 0,
                mode: "cors",
                credentials: r2.withCredentials ? "include" : "same-origin",
                signal: g2
              }).then(function (t3) {
                e2._fetchResponse = t3, e2._connect();
              }, function (t3) {
                n.clearTimeout(e2._fetchTimer), e2._destroyed || e2.emit("error", t3);
              });
            } else {
              var p2 = e2._xhr = new n.XMLHttpRequest();
              try {
                p2.open(e2._opts.method, e2._opts.url, true);
              } catch (t3) {
                return void o.nextTick(function () {
                  e2.emit("error", t3);
                });
              }
              "responseType" in p2 && (p2.responseType = e2._mode.split(":")[0]), "withCredentials" in p2 && (p2.withCredentials = !!r2.withCredentials), "text" === e2._mode && "overrideMimeType" in p2 && p2.overrideMimeType("text/plain; charset=x-user-defined"), "requestTimeout" in r2 && (p2.timeout = r2.requestTimeout, p2.ontimeout = function () {
                e2.emit("requestTimeout");
              }), l2.forEach(function (e3) {
                p2.setRequestHeader(e3[0], e3[1]);
              }), e2._response = null, p2.onreadystatechange = function () {
                switch (p2.readyState) {
                  case c.LOADING:
                  case c.DONE:
                    e2._onXHRProgress();
                }
              }, "moz-chunked-arraybuffer" === e2._mode && (p2.onprogress = function () {
                e2._onXHRProgress();
              }), p2.onerror = function () {
                e2._destroyed || e2.emit("error", new Error("XHR error"));
              };
              try {
                p2.send(a3);
              } catch (t3) {
                return void o.nextTick(function () {
                  e2.emit("error", t3);
                });
              }
            }
          }
        }, f.prototype._onXHRProgress = function () {
          (function (e2) {
            try {
              var t3 = e2.status;
              return null !== t3 && 0 !== t3;
            } catch (e3) {
              return false;
            }
          })(this._xhr) && !this._destroyed && (this._response || this._connect(), this._response._onXHRProgress());
        }, f.prototype._connect = function () {
          var e2 = this;
          e2._destroyed || (e2._response = new g(e2._xhr, e2._fetchResponse, e2._mode, e2._fetchTimer), e2._response.on("error", function (t3) {
            e2.emit("error", t3);
          }), e2.emit("response", e2._response));
        }, f.prototype._write = function (e2, t3, r2) {
          this._body.push(e2), r2();
        }, f.prototype.abort = f.prototype.destroy = function () {
          this._destroyed = true, n.clearTimeout(this._fetchTimer), this._response && (this._response._destroyed = true), this._xhr ? this._xhr.abort() : this._fetchAbortController && this._fetchAbortController.abort();
        }, f.prototype.end = function (e2, t3, r2) {
          "function" == typeof e2 && (r2 = e2, e2 = void 0), l.Writable.prototype.end.call(this, e2, t3, r2);
        }, f.prototype.flushHeaders = function () {}, f.prototype.setTimeout = function () {}, f.prototype.setNoDelay = function () {}, f.prototype.setSocketKeepAlive = function () {};
        var p = ["accept-charset", "accept-encoding", "access-control-request-headers", "access-control-request-method", "connection", "content-length", "cookie", "cookie2", "date", "dnt", "expect", "host", "keep-alive", "origin", "referer", "te", "trailer", "transfer-encoding", "upgrade", "via"];
      }).call(this, r(5).Buffer, r(6), r(2));
    }, function (e, t, r) {
      var n = r(5).Buffer;
      e.exports = function (e2) {
        if (e2 instanceof Uint8Array) {
          if (0 === e2.byteOffset && e2.byteLength === e2.buffer.byteLength) return e2.buffer;
          if ("function" == typeof e2.buffer.slice) return e2.buffer.slice(e2.byteOffset, e2.byteOffset + e2.byteLength);
        }
        if (n.isBuffer(e2)) {
          for (var t2 = new Uint8Array(e2.length), r2 = e2.length, o = 0; o < r2; o++) t2[o] = e2[o];
          return t2.buffer;
        }
        throw new Error("Argument must be a Buffer");
      };
    }, function (e, t) {
      e.exports = function () {
        for (var e2 = {}, t2 = 0; t2 < arguments.length; t2++) {
          var n = arguments[t2];
          for (var o in n) r.call(n, o) && (e2[o] = n[o]);
        }
        return e2;
      };
      var r = Object.prototype.hasOwnProperty;
    }, function (e, t) {
      e.exports = {
        100: "Continue",
        101: "Switching Protocols",
        102: "Processing",
        200: "OK",
        201: "Created",
        202: "Accepted",
        203: "Non-Authoritative Information",
        204: "No Content",
        205: "Reset Content",
        206: "Partial Content",
        207: "Multi-Status",
        208: "Already Reported",
        226: "IM Used",
        300: "Multiple Choices",
        301: "Moved Permanently",
        302: "Found",
        303: "See Other",
        304: "Not Modified",
        305: "Use Proxy",
        307: "Temporary Redirect",
        308: "Permanent Redirect",
        400: "Bad Request",
        401: "Unauthorized",
        402: "Payment Required",
        403: "Forbidden",
        404: "Not Found",
        405: "Method Not Allowed",
        406: "Not Acceptable",
        407: "Proxy Authentication Required",
        408: "Request Timeout",
        409: "Conflict",
        410: "Gone",
        411: "Length Required",
        412: "Precondition Failed",
        413: "Payload Too Large",
        414: "URI Too Long",
        415: "Unsupported Media Type",
        416: "Range Not Satisfiable",
        417: "Expectation Failed",
        418: "I'm a teapot",
        421: "Misdirected Request",
        422: "Unprocessable Entity",
        423: "Locked",
        424: "Failed Dependency",
        425: "Unordered Collection",
        426: "Upgrade Required",
        428: "Precondition Required",
        429: "Too Many Requests",
        431: "Request Header Fields Too Large",
        451: "Unavailable For Legal Reasons",
        500: "Internal Server Error",
        501: "Not Implemented",
        502: "Bad Gateway",
        503: "Service Unavailable",
        504: "Gateway Timeout",
        505: "HTTP Version Not Supported",
        506: "Variant Also Negotiates",
        507: "Insufficient Storage",
        508: "Loop Detected",
        509: "Bandwidth Limit Exceeded",
        510: "Not Extended",
        511: "Network Authentication Required"
      };
    }, function (e, t, r) {
      (function (e2, n) {
        var o;
        !function (i) {
          t && t.nodeType, e2 && e2.nodeType;
          var s = "object" == typeof n && n;
          s.global !== s && s.window !== s && s.self;
          var a2,
            l = 2147483647,
            u = /^xn--/,
            g = /[^\x20-\x7E]/,
            c = /[\x2E\u3002\uFF0E\uFF61]/g,
            f = {
              overflow: "Overflow: input needs wider integers to process",
              "not-basic": "Illegal input >= 0x80 (not a basic code point)",
              "invalid-input": "Invalid input"
            },
            p = Math.floor,
            h = String.fromCharCode;
          function d(e3) {
            throw new RangeError(f[e3]);
          }
          function y(e3, t2) {
            for (var r2 = e3.length, n2 = []; r2--;) n2[r2] = t2(e3[r2]);
            return n2;
          }
          function m(e3, t2) {
            var r2 = e3.split("@"),
              n2 = "";
            return r2.length > 1 && (n2 = r2[0] + "@", e3 = r2[1]), n2 + y((e3 = e3.replace(c, ".")).split("."), t2).join(".");
          }
          function b(e3) {
            for (var t2, r2, n2 = [], o2 = 0, i2 = e3.length; o2 < i2;) (t2 = e3.charCodeAt(o2++)) >= 55296 && t2 <= 56319 && o2 < i2 ? 56320 == (64512 & (r2 = e3.charCodeAt(o2++))) ? n2.push(((1023 & t2) << 10) + (1023 & r2) + 65536) : (n2.push(t2), o2--) : n2.push(t2);
            return n2;
          }
          function v(e3) {
            return y(e3, function (e4) {
              var t2 = "";
              return e4 > 65535 && (t2 += h((e4 -= 65536) >>> 10 & 1023 | 55296), e4 = 56320 | 1023 & e4), t2 += h(e4);
            }).join("");
          }
          function _(e3, t2) {
            return e3 + 22 + 75 * (e3 < 26) - ((0 != t2) << 5);
          }
          function S(e3, t2, r2) {
            var n2 = 0;
            for (e3 = r2 ? p(e3 / 700) : e3 >> 1, e3 += p(e3 / t2); e3 > 455; n2 += 36) e3 = p(e3 / 35);
            return p(n2 + 36 * e3 / (e3 + 38));
          }
          function w(e3) {
            var t2,
              r2,
              n2,
              o2,
              i2,
              s2,
              a3,
              u2,
              g2,
              c2,
              f2,
              h2 = [],
              y2 = e3.length,
              m2 = 0,
              b2 = 128,
              _2 = 72;
            for ((r2 = e3.lastIndexOf("-")) < 0 && (r2 = 0), n2 = 0; n2 < r2; ++n2) e3.charCodeAt(n2) >= 128 && d("not-basic"), h2.push(e3.charCodeAt(n2));
            for (o2 = r2 > 0 ? r2 + 1 : 0; o2 < y2;) {
              for (i2 = m2, s2 = 1, a3 = 36; o2 >= y2 && d("invalid-input"), ((u2 = (f2 = e3.charCodeAt(o2++)) - 48 < 10 ? f2 - 22 : f2 - 65 < 26 ? f2 - 65 : f2 - 97 < 26 ? f2 - 97 : 36) >= 36 || u2 > p((l - m2) / s2)) && d("overflow"), m2 += u2 * s2, !(u2 < (g2 = a3 <= _2 ? 1 : a3 >= _2 + 26 ? 26 : a3 - _2)); a3 += 36) s2 > p(l / (c2 = 36 - g2)) && d("overflow"), s2 *= c2;
              _2 = S(m2 - i2, t2 = h2.length + 1, 0 == i2), p(m2 / t2) > l - b2 && d("overflow"), b2 += p(m2 / t2), m2 %= t2, h2.splice(m2++, 0, b2);
            }
            return v(h2);
          }
          function E(e3) {
            var t2,
              r2,
              n2,
              o2,
              i2,
              s2,
              a3,
              u2,
              g2,
              c2,
              f2,
              y2,
              m2,
              v2,
              w2,
              E2 = [];
            for (y2 = (e3 = b(e3)).length, t2 = 128, r2 = 0, i2 = 72, s2 = 0; s2 < y2; ++s2) (f2 = e3[s2]) < 128 && E2.push(h(f2));
            for (n2 = o2 = E2.length, o2 && E2.push("-"); n2 < y2;) {
              for (a3 = l, s2 = 0; s2 < y2; ++s2) (f2 = e3[s2]) >= t2 && f2 < a3 && (a3 = f2);
              for (a3 - t2 > p((l - r2) / (m2 = n2 + 1)) && d("overflow"), r2 += (a3 - t2) * m2, t2 = a3, s2 = 0; s2 < y2; ++s2) if ((f2 = e3[s2]) < t2 && ++r2 > l && d("overflow"), f2 == t2) {
                for (u2 = r2, g2 = 36; !(u2 < (c2 = g2 <= i2 ? 1 : g2 >= i2 + 26 ? 26 : g2 - i2)); g2 += 36) w2 = u2 - c2, v2 = 36 - c2, E2.push(h(_(c2 + w2 % v2, 0))), u2 = p(w2 / v2);
                E2.push(h(_(u2, 0))), i2 = S(r2, m2, n2 == o2), r2 = 0, ++n2;
              }
              ++r2, ++t2;
            }
            return E2.join("");
          }
          a2 = {
            version: "1.4.1",
            ucs2: {
              decode: b,
              encode: v
            },
            decode: w,
            encode: E,
            toASCII: function toASCII(e3) {
              return m(e3, function (e4) {
                return g.test(e4) ? "xn--" + E(e4) : e4;
              });
            },
            toUnicode: function toUnicode(e3) {
              return m(e3, function (e4) {
                return u.test(e4) ? w(e4.slice(4).toLowerCase()) : e4;
              });
            }
          }, void 0 === (o = function () {
            return a2;
          }.call(t, r, t, e2)) || (e2.exports = o);
        }();
      }).call(this, r(195)(e), r(6));
    }, function (e, t) {
      e.exports = function (e2) {
        return e2.webpackPolyfill || (e2.deprecate = function () {}, e2.paths = [], e2.children || (e2.children = []), Object.defineProperty(e2, "loaded", {
          enumerable: true,
          get: function get() {
            return e2.l;
          }
        }), Object.defineProperty(e2, "id", {
          enumerable: true,
          get: function get() {
            return e2.i;
          }
        }), e2.webpackPolyfill = 1), e2;
      };
    }, function (e, t, r) {
      e.exports = {
        isString: function isString(e2) {
          return "string" == typeof e2;
        },
        isObject: function isObject(e2) {
          return "object" == typeof e2 && null !== e2;
        },
        isNull: function isNull(e2) {
          return null === e2;
        },
        isNullOrUndefined: function isNullOrUndefined(e2) {
          return null == e2;
        }
      };
    }, function (e, t, r) {
      t.decode = t.parse = r(198), t.encode = t.stringify = r(199);
    }, function (e, t, r) {
      function n(e2, t2) {
        return Object.prototype.hasOwnProperty.call(e2, t2);
      }
      e.exports = function (e2, t2, r2, i) {
        t2 = t2 || "&", r2 = r2 || "=";
        var s = {};
        if ("string" != typeof e2 || 0 === e2.length) return s;
        var a2 = /\+/g;
        e2 = e2.split(t2);
        var l = 1e3;
        i && "number" == typeof i.maxKeys && (l = i.maxKeys);
        var u = e2.length;
        l > 0 && u > l && (u = l);
        for (var g = 0; g < u; ++g) {
          var c,
            f,
            p,
            h,
            d = e2[g].replace(a2, "%20"),
            y = d.indexOf(r2);
          y >= 0 ? (c = d.substr(0, y), f = d.substr(y + 1)) : (c = d, f = ""), p = decodeURIComponent(c), h = decodeURIComponent(f), n(s, p) ? o(s[p]) ? s[p].push(h) : s[p] = [s[p], h] : s[p] = h;
        }
        return s;
      };
      var o = Array.isArray || function (e2) {
        return "[object Array]" === Object.prototype.toString.call(e2);
      };
    }, function (e, t, r) {
      var n = function n(e2) {
        switch (typeof e2) {
          case "string":
            return e2;
          case "boolean":
            return e2 ? "true" : "false";
          case "number":
            return isFinite(e2) ? e2 : "";
          default:
            return "";
        }
      };
      e.exports = function (e2, t2, r2, a2) {
        return t2 = t2 || "&", r2 = r2 || "=", null === e2 && (e2 = void 0), "object" == typeof e2 ? i(s(e2), function (s2) {
          var a3 = encodeURIComponent(n(s2)) + r2;
          return o(e2[s2]) ? i(e2[s2], function (e3) {
            return a3 + encodeURIComponent(n(e3));
          }).join(t2) : a3 + encodeURIComponent(n(e2[s2]));
        }).join(t2) : a2 ? encodeURIComponent(n(a2)) + r2 + encodeURIComponent(n(e2)) : "";
      };
      var o = Array.isArray || function (e2) {
        return "[object Array]" === Object.prototype.toString.call(e2);
      };
      function i(e2, t2) {
        if (e2.map) return e2.map(t2);
        for (var r2 = [], n2 = 0; n2 < e2.length; n2++) r2.push(t2(e2[n2], n2));
        return r2;
      }
      var s = Object.keys || function (e2) {
        var t2 = [];
        for (var r2 in e2) Object.prototype.hasOwnProperty.call(e2, r2) && t2.push(r2);
        return t2;
      };
    }, function (e, t, r) {
      var n = r(83),
        o = r(86),
        i = e.exports;
      for (var s in n) n.hasOwnProperty(s) && (i[s] = n[s]);
      function a2(e2) {
        if ("string" == typeof e2 && (e2 = o.parse(e2)), e2.protocol || (e2.protocol = "https:"), "https:" !== e2.protocol) throw new Error('Protocol "' + e2.protocol + '" not supported. Expected "https:"');
        return e2;
      }
      i.request = function (e2, t2) {
        return e2 = a2(e2), n.request.call(this, e2, t2);
      }, i.get = function (e2, t2) {
        return e2 = a2(e2), n.get.call(this, e2, t2);
      };
    }, function (e, t, r) {
      (function (t2) {
        function n(e2) {
          return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e3) {
            return typeof e3;
          } : function (e3) {
            return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
          })(e2);
        }
        function o(e2, t3) {
          if (!(e2 instanceof t3)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e2, t3) {
          for (var r2 = 0; r2 < t3.length; r2++) {
            var n2 = t3[r2];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
          }
        }
        function s(e2, t3) {
          return (s = Object.setPrototypeOf || function (e3, t4) {
            return e3.__proto__ = t4, e3;
          })(e2, t3);
        }
        function a2(e2) {
          var t3 = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if ("function" == typeof Proxy) return true;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), true;
            } catch (e3) {
              return false;
            }
          }();
          return function () {
            var r2,
              n2 = u(e2);
            if (t3) {
              var o2 = u(this).constructor;
              r2 = Reflect.construct(n2, arguments, o2);
            } else r2 = n2.apply(this, arguments);
            return l(this, r2);
          };
        }
        function l(e2, t3) {
          return !t3 || "object" !== n(t3) && "function" != typeof t3 ? function (e3) {
            if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e3;
          }(e2) : t3;
        }
        function u(e2) {
          return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e3) {
            return e3.__proto__ || Object.getPrototypeOf(e3);
          })(e2);
        }
        var g = r(87),
          c = r(3).MESSAGE,
          f = r(18),
          p = r(20);
        e.exports = function (e2) {
          !function (e3, t3) {
            if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
            e3.prototype = Object.create(t3 && t3.prototype, {
              constructor: {
                value: e3,
                writable: true,
                configurable: true
              }
            }), t3 && s(e3, t3);
          }(p2, e2);
          var r2,
            n2,
            u2 = a2(p2);
          function p2() {
            var e3,
              t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (o(this, p2), e3 = u2.call(this, t3), !t3.stream || !g(t3.stream)) throw new Error("options.stream is required.");
            return e3._stream = t3.stream, e3._stream.setMaxListeners(1 / 0), e3.isObjectMode = t3.stream._writableState.objectMode, e3.eol = t3.eol || f.EOL, e3;
          }
          return r2 = p2, (n2 = [{
            key: "log",
            value: function value(e3, r3) {
              var n3 = this;
              if (t2(function () {
                return n3.emit("logged", e3);
              }), this.isObjectMode) return this._stream.write(e3), void (r3 && r3());
              this._stream.write("".concat(e3[c]).concat(this.eol)), r3 && r3();
            }
          }]) && i(r2.prototype, n2), p2;
        }(p);
      }).call(this, r(15).setImmediate);
    }, function (e, t, r) {
      (function (t2) {
        function n(e2, t3, r2) {
          return t3 in e2 ? Object.defineProperty(e2, t3, {
            value: r2,
            enumerable: true,
            configurable: true,
            writable: true
          }) : e2[t3] = r2, e2;
        }
        function o(e2) {
          return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e3) {
            return typeof e3;
          } : function (e3) {
            return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
          })(e2);
        }
        function i(e2, t3) {
          for (var r2 = 0; r2 < t3.length; r2++) {
            var n2 = t3[r2];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
          }
        }
        function s(e2, t3) {
          return (s = Object.setPrototypeOf || function (e3, t4) {
            return e3.__proto__ = t4, e3;
          })(e2, t3);
        }
        function a2(e2) {
          var t3 = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if ("function" == typeof Proxy) return true;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), true;
            } catch (e3) {
              return false;
            }
          }();
          return function () {
            var r2,
              n2 = u(e2);
            if (t3) {
              var o2 = u(this).constructor;
              r2 = Reflect.construct(n2, arguments, o2);
            } else r2 = n2.apply(this, arguments);
            return l(this, r2);
          };
        }
        function l(e2, t3) {
          return !t3 || "object" !== o(t3) && "function" != typeof t3 ? function (e3) {
            if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e3;
          }(e2) : t3;
        }
        function u(e2) {
          return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e3) {
            return e3.__proto__ || Object.getPrototypeOf(e3);
          })(e2);
        }
        var g = r(32),
          c = g.Stream,
          f = g.Transform,
          p = r(51),
          h = r(3),
          d = h.LEVEL,
          y = h.SPLAT,
          m = r(87),
          b = r(89),
          v = r(93),
          _ = r(206),
          S = r(207),
          w = r(61).warn,
          E = r(50),
          T = /%[scdjifoO%]/g,
          R = function (e2) {
            !function (e3, t3) {
              if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
              e3.prototype = Object.create(t3 && t3.prototype, {
                constructor: {
                  value: e3,
                  writable: true,
                  configurable: true
                }
              }), t3 && s(e3, t3);
            }(h2, e2);
            var l2,
              u2,
              f2 = a2(h2);
            function h2(e3) {
              var t3;
              return function (e4, t4) {
                if (!(e4 instanceof t4)) throw new TypeError("Cannot call a class as a function");
              }(this, h2), (t3 = f2.call(this, {
                objectMode: true
              })).configure(e3), t3;
            }
            return l2 = h2, (u2 = [{
              key: "child",
              value: function value(e3) {
                var t3 = this;
                return Object.create(t3, {
                  write: {
                    value: function value(r2) {
                      var n2 = Object.assign({}, e3, r2);
                      r2 instanceof Error && (n2.stack = r2.stack, n2.message = r2.message), t3.write(n2);
                    }
                  }
                });
              }
            }, {
              key: "configure",
              value: function value() {
                var e3 = this,
                  t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  n2 = t3.silent,
                  o2 = t3.format,
                  i2 = t3.defaultMeta,
                  s2 = t3.levels,
                  a3 = t3.level,
                  l3 = void 0 === a3 ? "info" : a3,
                  u3 = t3.exitOnError,
                  g2 = void 0 === u3 || u3,
                  c2 = t3.transports,
                  f3 = t3.colors,
                  p2 = t3.emitErrs,
                  h3 = t3.formatters,
                  d2 = t3.padLevels,
                  y2 = t3.rewriters,
                  m2 = t3.stripColors,
                  _2 = t3.exceptionHandlers,
                  S2 = t3.rejectionHandlers;
                if (this.transports.length && this.clear(), this.silent = n2, this.format = o2 || this.format || r(208)(), this.defaultMeta = i2 || null, this.levels = s2 || this.levels || E.npm.levels, this.level = l3, this.exceptions = new b(this), this.rejections = new v(this), this.profilers = {}, this.exitOnError = g2, c2 && (c2 = Array.isArray(c2) ? c2 : [c2]).forEach(function (t4) {
                  return e3.add(t4);
                }), f3 || p2 || h3 || d2 || y2 || m2) throw new Error(["{ colors, emitErrs, formatters, padLevels, rewriters, stripColors } were removed in winston@3.0.0.", "Use a custom winston.format(function) instead.", "See: https://github.com/winstonjs/winston/tree/master/UPGRADE-3.0.md"].join("\n"));
                _2 && this.exceptions.handle(_2), S2 && this.rejections.handle(S2);
              }
            }, {
              key: "isLevelEnabled",
              value: function value(e3) {
                var t3 = this,
                  r2 = A(this.levels, e3);
                if (null === r2) return false;
                var n2 = A(this.levels, this.level);
                return null !== n2 && (this.transports && 0 !== this.transports.length ? -1 !== this.transports.findIndex(function (e4) {
                  var o2 = A(t3.levels, e4.level);
                  return null === o2 && (o2 = n2), o2 >= r2;
                }) : n2 >= r2);
              }
            }, {
              key: "log",
              value: function value(e3, t3) {
                for (var r2, i2, s2 = arguments.length, a3 = new Array(s2 > 2 ? s2 - 2 : 0), l3 = 2; l3 < s2; l3++) a3[l3 - 2] = arguments[l3];
                if (1 === arguments.length) return e3[d] = e3.level, this._addDefaultMeta(e3), this.write(e3), this;
                if (2 === arguments.length) return t3 && "object" === o(t3) ? (t3[d] = t3.level = e3, this._addDefaultMeta(t3), this.write(t3), this) : (this.write((n(i2 = {}, d, e3), n(i2, "level", e3), n(i2, "message", t3), i2)), this);
                var u3 = a3[0];
                if ("object" === o(u3) && null !== u3) {
                  var g2 = t3 && t3.match && t3.match(T);
                  if (!g2) {
                    var c2,
                      f3 = Object.assign({}, this.defaultMeta, u3, (n(c2 = {}, d, e3), n(c2, y, a3), n(c2, "level", e3), n(c2, "message", t3), c2));
                    return u3.message && (f3.message = "".concat(f3.message, " ").concat(u3.message)), u3.stack && (f3.stack = u3.stack), this.write(f3), this;
                  }
                }
                return this.write(Object.assign({}, this.defaultMeta, (n(r2 = {}, d, e3), n(r2, y, a3), n(r2, "level", e3), n(r2, "message", t3), r2))), this;
              }
            }, {
              key: "_transform",
              value: function value(e3, t3, r2) {
                if (this.silent) return r2();
                e3[d] || (e3[d] = e3.level), this.levels[e3[d]] || 0 === this.levels[e3[d]] || console.error("[winston] Unknown logger level: %s", e3[d]), this._readableState.pipes || console.error("[winston] Attempt to write logs with no transports %j", e3);
                try {
                  this.push(this.format.transform(e3, this.format.options));
                } catch (e4) {
                  throw e4;
                } finally {
                  r2();
                }
              }
            }, {
              key: "_final",
              value: function value(e3) {
                var r2 = this.transports.slice();
                p(r2, function (e4, r3) {
                  if (!e4 || e4.finished) return t2(r3);
                  e4.once("finish", r3), e4.end();
                }, e3);
              }
            }, {
              key: "add",
              value: function value(e3) {
                var t3 = !m(e3) || e3.log.length > 2 ? new _({
                  transport: e3
                }) : e3;
                if (!t3._writableState || !t3._writableState.objectMode) throw new Error("Transports must WritableStreams in objectMode. Set { objectMode: true }.");
                return this._onEvent("error", t3), this._onEvent("warn", t3), this.pipe(t3), e3.handleExceptions && this.exceptions.handle(), e3.handleRejections && this.rejections.handle(), this;
              }
            }, {
              key: "remove",
              value: function value(e3) {
                if (!e3) return this;
                var t3 = e3;
                return (!m(e3) || e3.log.length > 2) && (t3 = this.transports.filter(function (t4) {
                  return t4.transport === e3;
                })[0]), t3 && this.unpipe(t3), this;
              }
            }, {
              key: "clear",
              value: function value() {
                return this.unpipe(), this;
              }
            }, {
              key: "close",
              value: function value() {
                return this.clear(), this.emit("close"), this;
              }
            }, {
              key: "setLevels",
              value: function value() {
                w.deprecated("setLevels");
              }
            }, {
              key: "query",
              value: function value(e3, t3) {
                "function" == typeof e3 && (t3 = e3, e3 = {}), e3 = e3 || {};
                var r2 = {},
                  n2 = Object.assign({}, e3.query || {});
                p(this.transports.filter(function (e4) {
                  return !!e4.query;
                }), function (t4, o2) {
                  !function (t5, r3) {
                    e3.query && "function" == typeof t5.formatQuery && (e3.query = t5.formatQuery(n2)), t5.query(e3, function (n3, o3) {
                      if (n3) return r3(n3);
                      "function" == typeof t5.formatResults && (o3 = t5.formatResults(o3, e3.format)), r3(null, o3);
                    });
                  }(t4, function (e4, n3) {
                    o2 && ((n3 = e4 || n3) && (r2[t4.name] = n3), o2()), o2 = null;
                  });
                }, function () {
                  return t3(null, r2);
                });
              }
            }, {
              key: "stream",
              value: function value() {
                var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  t3 = new c(),
                  r2 = [];
                return t3._streams = r2, t3.destroy = function () {
                  for (var e4 = r2.length; e4--;) r2[e4].destroy();
                }, this.transports.filter(function (e4) {
                  return !!e4.stream;
                }).forEach(function (n2) {
                  var o2 = n2.stream(e3);
                  o2 && (r2.push(o2), o2.on("log", function (e4) {
                    e4.transport = e4.transport || [], e4.transport.push(n2.name), t3.emit("log", e4);
                  }), o2.on("error", function (e4) {
                    e4.transport = e4.transport || [], e4.transport.push(n2.name), t3.emit("error", e4);
                  }));
                }), t3;
              }
            }, {
              key: "startTimer",
              value: function value() {
                return new S(this);
              }
            }, {
              key: "profile",
              value: function value(e3) {
                var t3 = Date.now();
                if (this.profilers[e3]) {
                  var r2 = this.profilers[e3];
                  delete this.profilers[e3];
                  for (var n2 = arguments.length, i2 = new Array(n2 > 1 ? n2 - 1 : 0), s2 = 1; s2 < n2; s2++) i2[s2 - 1] = arguments[s2];
                  "function" == typeof i2[i2.length - 2] && (console.warn("Callback function no longer supported as of winston@3.0.0"), i2.pop());
                  var a3 = "object" === o(i2[i2.length - 1]) ? i2.pop() : {};
                  return a3.level = a3.level || "info", a3.durationMs = t3 - r2, a3.message = a3.message || e3, this.write(a3);
                }
                return this.profilers[e3] = t3, this;
              }
            }, {
              key: "handleExceptions",
              value: function value() {
                var e3;
                console.warn("Deprecated: .handleExceptions() will be removed in winston@4. Use .exceptions.handle()"), (e3 = this.exceptions).handle.apply(e3, arguments);
              }
            }, {
              key: "unhandleExceptions",
              value: function value() {
                var e3;
                console.warn("Deprecated: .unhandleExceptions() will be removed in winston@4. Use .exceptions.unhandle()"), (e3 = this.exceptions).unhandle.apply(e3, arguments);
              }
            }, {
              key: "cli",
              value: function value() {
                throw new Error(["Logger.cli() was removed in winston@3.0.0", "Use a custom winston.formats.cli() instead.", "See: https://github.com/winstonjs/winston/tree/master/UPGRADE-3.0.md"].join("\n"));
              }
            }, {
              key: "_onEvent",
              value: function value(e3, t3) {
                t3["__winston" + e3] || (t3["__winston" + e3] = function (r2) {
                  "error" !== e3 || this.transports.includes(t3) || this.add(t3), this.emit(e3, r2, t3);
                }.bind(this), t3.on(e3, t3["__winston" + e3]));
              }
            }, {
              key: "_addDefaultMeta",
              value: function value(e3) {
                this.defaultMeta && Object.assign(e3, this.defaultMeta);
              }
            }]) && i(l2.prototype, u2), h2;
          }(f);
        function A(e2, t3) {
          var r2 = e2[t3];
          return r2 || 0 === r2 ? r2 : null;
        }
        Object.defineProperty(R.prototype, "transports", {
          configurable: false,
          enumerable: true,
          get: function get() {
            var e2 = this._readableState.pipes;
            return Array.isArray(e2) ? e2 : [e2].filter(Boolean);
          }
        }), e.exports = R;
      }).call(this, r(15).setImmediate);
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      });
      var n = g(r(45)),
        o = g(r(46)),
        i = g(r(66)),
        s = g(r(67)),
        a2 = g(r(68)),
        l = g(r(25)),
        u = g(r(30));
      function g(e2) {
        return e2 && e2.__esModule ? e2 : {
          default: e2
        };
      }
      function c(e2, t2, r2) {
        r2 = (0, s.default)(r2);
        var n2 = 0,
          i2 = 0,
          l2 = e2.length,
          u2 = false;
        function g2(e3, t3) {
          false === e3 && (u2 = true), true !== u2 && (e3 ? r2(e3) : ++i2 !== l2 && t3 !== o.default || r2(null));
        }
        for (0 === l2 && r2(null); n2 < l2; n2++) t2(e2[n2], n2, (0, a2.default)(g2));
      }
      function f(e2, t2, r2) {
        return (0, i.default)(e2, 1 / 0, t2, r2);
      }
      t.default = (0, u.default)(function (e2, t2, r2) {
        return ((0, n.default)(e2) ? c : f)(e2, (0, l.default)(t2), r2);
      }, 3), e.exports = t.default;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: true
      }), t.default = function (e2) {
        return function (t2, r2, n) {
          return e2(t2, n);
        };
      }, e.exports = t.default;
    }, function (e, t, r) {
      var n = Object.prototype.toString;
      e.exports = function (e2) {
        if ("string" == typeof e2.displayName && e2.constructor.name) return e2.displayName;
        if ("string" == typeof e2.name && e2.name) return e2.name;
        if ("object" == typeof e2 && e2.constructor && "string" == typeof e2.constructor.name) return e2.constructor.name;
        var t2 = e2.toString(),
          r2 = n.call(e2).slice(8, -1);
        return (t2 = "Function" === r2 ? t2.substring(t2.indexOf("(") + 1, t2.indexOf(")")) : r2) || "anonymous";
      };
    }, function (e, t, r) {
      var n = r(13),
        _r = r(3),
        o = _r.LEVEL,
        i = r(20),
        s = e.exports = function () {
          var e2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (i.call(this, e2), !e2.transport || "function" != typeof e2.transport.log) throw new Error("Invalid transport, must be an object with a log method.");
          this.transport = e2.transport, this.level = this.level || e2.transport.level, this.handleExceptions = this.handleExceptions || e2.transport.handleExceptions, this._deprecated(), this.transport.__winstonError || (this.transport.__winstonError = function (e3) {
            this.emit("error", e3, this.transport);
          }.bind(this), this.transport.on("error", this.transport.__winstonError));
        };
      n.inherits(s, i), s.prototype._write = function (e2, t2, r2) {
        if (this.silent || true === e2.exception && !this.handleExceptions) return r2(null);
        (!this.level || this.levels[this.level] >= this.levels[e2[o]]) && this.transport.log(e2[o], e2.message, e2, this._nop), r2(null);
      }, s.prototype._writev = function (e2, t2) {
        for (var _t10 = 0; _t10 < e2.length; _t10++) this._accept(e2[_t10]) && (this.transport.log(e2[_t10].chunk[o], e2[_t10].chunk.message, e2[_t10].chunk, this._nop), e2[_t10].callback());
        return t2(null);
      }, s.prototype._deprecated = function () {
        console.error(["".concat(this.transport.name, " is a legacy winston transport. Consider upgrading: "), "- Upgrade docs: https://github.com/winstonjs/winston/blob/master/UPGRADE-3.0.md"].join("\n"));
      }, s.prototype.close = function () {
        this.transport.close && this.transport.close(), this.transport.__winstonError && (this.transport.removeListener("error", this.transport.__winstonError), this.transport.__winstonError = null);
      };
    }, function (e, t, r) {
      function n(e2) {
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e3) {
          return typeof e3;
        } : function (e3) {
          return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
        })(e2);
      }
      function o(e2, t2) {
        for (var r2 = 0; r2 < t2.length; r2++) {
          var n2 = t2[r2];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
        }
      }
      e.exports = function () {
        function e2(t3) {
          if (function (e3, t4) {
            if (!(e3 instanceof t4)) throw new TypeError("Cannot call a class as a function");
          }(this, e2), !t3) throw new Error("Logger is required for profiling.");
          this.logger = t3, this.start = Date.now();
        }
        var t2, r2;
        return t2 = e2, (r2 = [{
          key: "done",
          value: function value() {
            for (var e3 = arguments.length, t3 = new Array(e3), r3 = 0; r3 < e3; r3++) t3[r3] = arguments[r3];
            "function" == typeof t3[t3.length - 1] && (console.warn("Callback function no longer supported as of winston@3.0.0"), t3.pop());
            var o2 = "object" === n(t3[t3.length - 1]) ? t3.pop() : {};
            return o2.level = o2.level || "info", o2.durationMs = Date.now() - this.start, this.logger.write(o2);
          }
        }]) && o(t2.prototype, r2), e2;
      }();
    }, function (e, t, r) {
      (function (t2) {
        var n = r(209),
          _r2 = r(3),
          o = _r2.MESSAGE,
          i = r(35);
        function s(e2, r2) {
          return r2 instanceof t2 ? r2.toString("base64") : "bigint" == typeof r2 ? r2.toString() : r2;
        }
        e.exports = n(function (e2) {
          var t3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return e2[o] = (t3.stable ? i.stableStringify : i)(e2, t3.replacer || s, t3.space), e2;
        });
      }).call(this, r(5).Buffer);
    }, function (e, t, r) {
      var n = /*#__PURE__*/function (_Error5) {
        _inherits(n, _Error5);
        function n(e2) {
          var _this14;
          _classCallCheck(this, n);
          _this14 = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, "Format functions must be synchronous taking a two arguments: (info, opts)\nFound: ".concat(e2.toString().split("\n")[0], "\n"))), Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this14)), n);
          return _this14;
        }
        return n;
      }(_wrapNativeSuper(Error));
      e.exports = function (e2) {
        if (e2.length > 2) throw new n(e2);
        function t2() {
          var e3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          this.options = e3;
        }
        function r2(e3) {
          return new t2(e3);
        }
        return t2.prototype.transform = e2, r2.Format = t2, r2;
      };
    }, function (e, t, r) {
      function n(e2, t2) {
        if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
      }
      function o(e2, t2) {
        for (var r2 = 0; r2 < t2.length; r2++) {
          var n2 = t2[r2];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
        }
      }
      var i = r(88);
      e.exports = function () {
        function e2() {
          var t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          n(this, e2), this.loggers = /* @__PURE__ */new Map(), this.options = t3;
        }
        var t2, r2;
        return t2 = e2, (r2 = [{
          key: "add",
          value: function value(e3, t3) {
            var r3 = this;
            if (!this.loggers.has(e3)) {
              var n2 = (t3 = Object.assign({}, t3 || this.options)).transports || this.options.transports;
              t3.transports = n2 ? n2.slice() : [];
              var o2 = i(t3);
              o2.on("close", function () {
                return r3._delete(e3);
              }), this.loggers.set(e3, o2);
            }
            return this.loggers.get(e3);
          }
        }, {
          key: "get",
          value: function value(e3, t3) {
            return this.add(e3, t3);
          }
        }, {
          key: "has",
          value: function value(e3) {
            return !!this.loggers.has(e3);
          }
        }, {
          key: "close",
          value: function value(e3) {
            var t3 = this;
            if (e3) return this._removeLogger(e3);
            this.loggers.forEach(function (e4, r3) {
              return t3._removeLogger(r3);
            });
          }
        }, {
          key: "_removeLogger",
          value: function value(e3) {
            this.loggers.has(e3) && (this.loggers.get(e3).close(), this._delete(e3));
          }
        }, {
          key: "_delete",
          value: function value(e3) {
            this.loggers.delete(e3);
          }
        }]) && o(t2.prototype, r2), e2;
      }();
    }, function (e, t, r) {
      (function (t2) {
        var n = r(52),
          o = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
        e.exports = function (e2, i, s, a2) {
          var l,
            u,
            g = false,
            c = false;
          var f = r(94);
          function p(e3) {
            a2(i, e3);
          }
          function h(e3, t3) {
            var r2 = "\"".concat(i, "\" ").concat(t3);
            throw e3 && (r2 = "".concat(r2)), u && (r2 = "".concat(r2, ". An example of a valid value would be: ").concat(u)), new n(r2);
          }
          var d = {
            convertFromBase64: function convertFromBase64() {
              return p("marking for base64 conversion"), g = true, d;
            },
            default: function _default(e3) {
              if ("number" == typeof e3) l = e3.toString();else if (Array.isArray(e3) || "object" == typeof e3 && null !== e3) l = JSON.stringify(e3);else {
                if ("string" != typeof e3) throw new n("values passed to default() must be of Number, String, Array, or Object type");
                l = e3;
              }
              return p("setting default value to \"".concat(l, "\"")), d;
            },
            required: function required(e3) {
              return void 0 === e3 ? (p("marked as required"), c = true) : (p("setting required flag to ".concat(e3)), c = e3), d;
            },
            example: function example(e3) {
              return u = e3, d;
            }
          };
          return Object.entries(_objectSpread({}, f, s)).forEach(function (_ref13) {
            var _ref14 = _slicedToArray(_ref13, 2),
              r2 = _ref14[0],
              n2 = _ref14[1];
            d[r2] = function (r3) {
              return function () {
                var n3 = e2[i];
                if (p("will be read from the environment using \"".concat(r3.name, "\" accessor")), void 0 === n3) if (void 0 === l && c) p("was not found in the environment, but is required to be set"), h(void 0, "is a required variable, but it was not set");else {
                  if (void 0 === l) return void p("was not found in the environment, but is not required. returning undefined");
                  p("was not found in the environment, parsing default value \"".concat(l, "\" instead")), n3 = l;
                }
                c && (p("verifying variable value is not an empty string"), 0 === n3.trim().length && h(void 0, "is a required variable, but its value was empty")), g && (p("verifying variable is a valid base64 string"), n3.match(o) || h(n3, "should be a valid base64 string if using convertFromBase64"), p("converting from base64 to utf8 string"), n3 = t2.from(n3, "base64").toString());
                var s2 = [n3].concat(Array.prototype.slice.call(arguments));
                try {
                  p("passing value \"".concat(n3, "\" to \"").concat(r3.name, "\" accessor"));
                  var e3 = r3.apply(r3, s2);
                  return p("parsed successfully, returning ".concat(e3)), e3;
                } catch (e3) {
                  h(n3, e3.message);
                }
              };
            }(n2);
          }), d;
        };
      }).call(this, r(5).Buffer);
    }, function (e, t, r) {
      var n = r(33);
      e.exports = function (e2, t2) {
        return t2 = t2 || ",", e2.length ? n(e2).split(t2).filter(Boolean) : [];
      };
    }, function (e, t, r) {
      e.exports = function (e2) {
        var t2 = e2.toLowerCase();
        if ("false" !== t2 && "true" !== t2) throw new Error('should be either "true", "false", "TRUE", or "FALSE"');
        return "false" !== t2;
      };
    }, function (e, t, r) {
      e.exports = function (e2) {
        var t2 = e2.toLowerCase();
        if (-1 === ["false", "0", "true", "1"].indexOf(t2)) throw new Error('should be either "true", "false", "TRUE", "FALSE", 1, or 0');
        return !("0" === t2 || "false" === t2);
      };
    }, function (e, t, r) {
      var n = r(95);
      e.exports = function (e2) {
        var t2 = n(e2);
        if (t2 > 65535) throw new Error("cannot assign a port number greater than 65535");
        return t2;
      };
    }, function (e, t, r) {
      var n = r(33);
      e.exports = function (e2, t2) {
        var r2 = n(e2);
        if (t2.indexOf(r2) < 0) throw new Error("should be one of [".concat(t2.join(", "), "]"));
        return r2;
      };
    }, function (e, t, r) {
      var n = r(54);
      e.exports = function (e2) {
        var t2 = n(e2);
        if (t2 > 0) throw new Error("should be a negative float");
        return t2;
      };
    }, function (e, t, r) {
      var n = r(54);
      e.exports = function (e2) {
        var t2 = n(e2);
        if (t2 < 0) throw new Error("should be a positive float");
        return t2;
      };
    }, function (e, t, r) {
      var n = r(53);
      e.exports = function (e2) {
        var t2 = n(e2);
        if (t2 > 0) throw new Error("should be a negative integer");
        return t2;
      };
    }, function (e, t, r) {
      var n = r(55);
      e.exports = function (e2) {
        var t2 = n(e2);
        if (!Array.isArray(t2)) throw new Error("should be a parseable JSON Array");
        return t2;
      };
    }, function (e, t, r) {
      var n = r(55);
      e.exports = function (e2) {
        var t2 = n(e2);
        if (Array.isArray(t2)) throw new Error("should be a parseable JSON Object");
        return t2;
      };
    }, function (e, t, r) {
      e.exports = function (e2, t2) {
        try {
          RegExp(void 0, t2);
        } catch (e3) {
          throw new Error("invalid regexp flags");
        }
        try {
          return new RegExp(e2, t2);
        } catch (e3) {
          throw new Error("should be a valid regexp");
        }
      };
    }, function (e, t, r) {
      var n = r(96);
      e.exports = function (e2) {
        return n(e2).toString();
      };
    }, function (e, t, r) {
      var n = r(33),
        o = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\u0001-\u0008\u000b\u000c\u000e-\u001f\u0021\u0023-\u005b\u005d-\u007f]|\\[\u0001-\u0009\u000b\u000c\u000e-\u007f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\u0001-\u0008\u000b\u000c\u000e-\u001f\u0021-\u005a\u0053-\u007f]|\\[\u0001-\u0009\u000b\u000c\u000e-\u007f])+)\])$/;
      e.exports = function (e2) {
        var t2 = n(e2);
        if (!o.test(t2)) throw new Error("should be a valid email address");
        return t2;
      };
    }, function (e, t, r) {
      e.exports = function (e2, t2) {
        return function (r2, n) {
          t2 && t2.match(/prod|production/) || e2("env-var (".concat(r2, "): ").concat(n));
        };
      };
    }, function (e, t, r) {
      (function (t2) {
        (function () {
          var r2, n, o, i, s, a2;
          "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
            return performance.now();
          } : null != t2 && t2.hrtime ? (e.exports = function () {
            return (r2() - s) / 1e6;
          }, n = t2.hrtime, i = (r2 = function r2() {
            var e2;
            return 1e9 * (e2 = n())[0] + e2[1];
          })(), a2 = 1e9 * t2.uptime(), s = i - a2) : Date.now ? (e.exports = function () {
            return Date.now() - o;
          }, o = Date.now()) : (e.exports = function () {
            return new Date().getTime() - o;
          }, o = new Date().getTime());
        }).call(this);
      }).call(this, r(2));
    }, function (e, t, r) {
      (function (e2) {
        !function (e3) {
          function t2(e4) {
            if ("utf-8" !== (e4 = void 0 === e4 ? "utf-8" : e4)) throw new RangeError("Failed to construct 'TextEncoder': The encoding label provided ('" + e4 + "') is invalid.");
          }
          function r2(e4, t3) {
            if (t3 = void 0 === t3 ? {
              fatal: false
            } : t3, "utf-8" !== (e4 = void 0 === e4 ? "utf-8" : e4)) throw new RangeError("Failed to construct 'TextDecoder': The encoding label provided ('" + e4 + "') is invalid.");
            if (t3.fatal) throw Error("Failed to construct 'TextDecoder': the 'fatal' option is unsupported.");
          }
          if (e3.TextEncoder && e3.TextDecoder) return false;
          Object.defineProperty(t2.prototype, "encoding", {
            value: "utf-8"
          }), t2.prototype.encode = function (e4, t3) {
            if ((t3 = void 0 === t3 ? {
              stream: false
            } : t3).stream) throw Error("Failed to encode: the 'stream' option is unsupported.");
            t3 = 0;
            for (var r3 = e4.length, n = 0, o = Math.max(32, r3 + (r3 >> 1) + 7), i = new Uint8Array(o >> 3 << 3); t3 < r3;) {
              var s = e4.charCodeAt(t3++);
              if (55296 <= s && 56319 >= s) {
                if (t3 < r3) {
                  var a2 = e4.charCodeAt(t3);
                  56320 == (64512 & a2) && (++t3, s = ((1023 & s) << 10) + (1023 & a2) + 65536);
                }
                if (55296 <= s && 56319 >= s) continue;
              }
              if (n + 4 > i.length && (o += 8, o = (o *= 1 + t3 / e4.length * 2) >> 3 << 3, (a2 = new Uint8Array(o)).set(i), i = a2), 0 == (4294967168 & s)) i[n++] = s;else {
                if (0 == (4294965248 & s)) i[n++] = s >> 6 & 31 | 192;else if (0 == (4294901760 & s)) i[n++] = s >> 12 & 15 | 224, i[n++] = s >> 6 & 63 | 128;else {
                  if (0 != (4292870144 & s)) continue;
                  i[n++] = s >> 18 & 7 | 240, i[n++] = s >> 12 & 63 | 128, i[n++] = s >> 6 & 63 | 128;
                }
                i[n++] = 63 & s | 128;
              }
            }
            return i.slice(0, n);
          }, Object.defineProperty(r2.prototype, "encoding", {
            value: "utf-8"
          }), Object.defineProperty(r2.prototype, "fatal", {
            value: false
          }), Object.defineProperty(r2.prototype, "ignoreBOM", {
            value: false
          }), r2.prototype.decode = function (e4, t3) {
            if ((t3 = void 0 === t3 ? {
              stream: false
            } : t3).stream) throw Error("Failed to decode: the 'stream' option is unsupported.");
            t3 = 0;
            for (var r3 = (e4 = new Uint8Array(e4)).length, n = []; t3 < r3;) {
              var o = e4[t3++];
              if (0 === o) break;
              if (0 == (128 & o)) n.push(o);else if (192 == (224 & o)) {
                var i = 63 & e4[t3++];
                n.push((31 & o) << 6 | i);
              } else if (224 == (240 & o)) {
                i = 63 & e4[t3++];
                var s = 63 & e4[t3++];
                n.push((31 & o) << 12 | i << 6 | s);
              } else if (240 == (248 & o)) {
                65535 < (o = (7 & o) << 18 | (i = 63 & e4[t3++]) << 12 | (s = 63 & e4[t3++]) << 6 | 63 & e4[t3++]) && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | 1023 & o), n.push(o);
              }
            }
            return String.fromCharCode.apply(null, n);
          }, e3.TextEncoder = t2, e3.TextDecoder = r2;
        }("undefined" != typeof window ? window : void 0 !== e2 ? e2 : this);
      }).call(this, r(6));
    }, function (e, t, r) {
      r.r(t), r.d(t, "AuthClient", function () {
        return i;
      }), r.d(t, "RtcSignalingClient", function () {
        return a2;
      }), r.d(t, "Credentials", function () {
        return I;
      }), r.d(t, "IRtcStream", function () {}), r.d(t, "SignalingPromiseClient", function () {
        return j.SignalingPromiseClient;
      }), r.d(t, "IRtcClientConfigurationV1", function () {}), r.d(t, "IRtcClientConfiguration", function () {}), r.d(t, "IRtcConnectionStatsInfo", function () {}), r.d(t, "IRtcSendConfiguration", function () {}), r.d(t, "IRtcSessionMetricsMessageCounts", function () {}), r.d(t, "IRtcStreamMessage", function () {}), r.d(t, "IRtcStreamPayload", function () {}), r.d(t, "IStreamControl", function () {}), r.d(t, "RtcClient", function () {
        return ge;
      }), r.d(t, "RtcClientV1", function () {
        return ve;
      }), r.d(t, "createRtcStreamMessage", function () {
        return re;
      });
      var n = r(28),
        o = function o(e2, t2, r2, n2) {
          return new (r2 || (r2 = Promise))(function (o2, i2) {
            function s2(e3) {
              try {
                l2(n2.next(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function a3(e3) {
              try {
                l2(n2.throw(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function l2(e3) {
              var t3;
              e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
                e4(t3);
              })).then(s2, a3);
            }
            l2((n2 = n2.apply(e2, t2 || [])).next());
          });
        };
      var i = /*#__PURE__*/function (_n$a2) {
        _inherits(i, _n$a2);
        function i() {
          _classCallCheck(this, i);
          return _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments));
        }
        _createClass(i, [{
          key: "adminSignup",
          value: function adminSignup(e2, t2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
              return _regeneratorRuntime().wrap(function _callee11$(_context17) {
                while (1) switch (_context17.prev = _context17.next) {
                  case 0:
                    _context17.next = 2;
                    return this.fetch("auth/admin-signup", {
                      token: t2,
                      method: "POST",
                      body: JSON.stringify(e2)
                    });
                  case 2:
                    return _context17.abrupt("return", _context17.sent);
                  case 3:
                  case "end":
                    return _context17.stop();
                }
              }, _callee11, this);
            }));
          }
        }, {
          key: "login",
          value: function login(e2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
              return _regeneratorRuntime().wrap(function _callee12$(_context18) {
                while (1) switch (_context18.prev = _context18.next) {
                  case 0:
                    _context18.next = 2;
                    return this.fetch("auth/login", {
                      method: "POST",
                      body: JSON.stringify(e2),
                      allowUnsafeRetries: true
                    });
                  case 2:
                    return _context18.abrupt("return", _context18.sent);
                  case 3:
                  case "end":
                    return _context18.stop();
                }
              }, _callee12, this);
            }));
          }
        }, {
          key: "loginWithGoogleToken",
          value: function loginWithGoogleToken(e2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
              return _regeneratorRuntime().wrap(function _callee13$(_context19) {
                while (1) switch (_context19.prev = _context19.next) {
                  case 0:
                    _context19.next = 2;
                    return this.fetch("auth/login-google", {
                      method: "POST",
                      body: JSON.stringify(e2),
                      allowUnsafeRetries: true
                    });
                  case 2:
                    return _context19.abrupt("return", _context19.sent);
                  case 3:
                  case "end":
                    return _context19.stop();
                }
              }, _callee13, this);
            }));
          }
        }, {
          key: "refresh",
          value: function refresh(e2, t2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
              return _regeneratorRuntime().wrap(function _callee14$(_context20) {
                while (1) switch (_context20.prev = _context20.next) {
                  case 0:
                    _context20.next = 2;
                    return this.fetch("auth/refresh", {
                      method: "POST",
                      body: JSON.stringify({
                        refreshToken: e2,
                        tokenExpirationSeconds: t2
                      }),
                      allowUnsafeRetries: true
                    });
                  case 2:
                    return _context20.abrupt("return", _context20.sent);
                  case 3:
                  case "end":
                    return _context20.stop();
                }
              }, _callee14, this);
            }));
          }
        }, {
          key: "respondToNewPasswordRequiredChallenge",
          value: function respondToNewPasswordRequiredChallenge(e2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
              return _regeneratorRuntime().wrap(function _callee15$(_context21) {
                while (1) switch (_context21.prev = _context21.next) {
                  case 0:
                    _context21.next = 2;
                    return this.fetch("auth/respond-to-new-password-required-challenge", {
                      method: "POST",
                      body: JSON.stringify(e2)
                    });
                  case 2:
                    return _context21.abrupt("return", _context21.sent);
                  case 3:
                  case "end":
                    return _context21.stop();
                }
              }, _callee15, this);
            }));
          }
        }, {
          key: "forgotPassword",
          value: function forgotPassword(e2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
              return _regeneratorRuntime().wrap(function _callee16$(_context22) {
                while (1) switch (_context22.prev = _context22.next) {
                  case 0:
                    _context22.next = 2;
                    return this.fetch("auth/forgot-password", {
                      method: "POST",
                      body: JSON.stringify({
                        email: e2
                      })
                    });
                  case 2:
                    return _context22.abrupt("return", _context22.sent);
                  case 3:
                  case "end":
                    return _context22.stop();
                }
              }, _callee16, this);
            }));
          }
        }, {
          key: "confirmForgotPassword",
          value: function confirmForgotPassword(e2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
              return _regeneratorRuntime().wrap(function _callee17$(_context23) {
                while (1) switch (_context23.prev = _context23.next) {
                  case 0:
                    _context23.next = 2;
                    return this.fetch("auth/confirm-forgot-password", {
                      method: "POST",
                      body: JSON.stringify(e2)
                    });
                  case 2:
                    return _context23.abrupt("return", _context23.sent);
                  case 3:
                  case "end":
                    return _context23.stop();
                }
              }, _callee17, this);
            }));
          }
        }, {
          key: "resendInvitation",
          value: function resendInvitation(e2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
              return _regeneratorRuntime().wrap(function _callee18$(_context24) {
                while (1) switch (_context24.prev = _context24.next) {
                  case 0:
                    _context24.next = 2;
                    return this.fetch("auth/resend-invitation", {
                      method: "POST",
                      body: JSON.stringify({
                        email: e2
                      })
                    });
                  case 2:
                    return _context24.abrupt("return", _context24.sent);
                  case 3:
                  case "end":
                    return _context24.stop();
                }
              }, _callee18, this);
            }));
          }
        }, {
          key: "changePassword",
          value: function changePassword(_ref15) {
            var e2 = _ref15.token,
              t2 = _ref15.refreshToken,
              r2 = _ref15.currentPassword,
              n2 = _ref15.newPassword;
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
              return _regeneratorRuntime().wrap(function _callee19$(_context25) {
                while (1) switch (_context25.prev = _context25.next) {
                  case 0:
                    _context25.next = 2;
                    return this.fetch("auth/change-password", {
                      token: e2,
                      method: "POST",
                      body: JSON.stringify({
                        refreshToken: t2,
                        currentPassword: r2,
                        newPassword: n2
                      })
                    });
                  case 2:
                    return _context25.abrupt("return", _context25.sent);
                  case 3:
                  case "end":
                    return _context25.stop();
                }
              }, _callee19, this);
            }));
          }
        }, {
          key: "getDeviceCredentials",
          value: function getDeviceCredentials(e2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
              return _regeneratorRuntime().wrap(function _callee20$(_context26) {
                while (1) switch (_context26.prev = _context26.next) {
                  case 0:
                    _context26.next = 2;
                    return this.fetch("auth/device-credentials", {
                      token: e2,
                      method: "POST",
                      allowUnsafeRetries: true
                    });
                  case 2:
                    return _context26.abrupt("return", _context26.sent);
                  case 3:
                  case "end":
                    return _context26.stop();
                }
              }, _callee20, this);
            }));
          }
        }, {
          key: "impersonate",
          value: function impersonate(e2, t2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
              return _regeneratorRuntime().wrap(function _callee21$(_context27) {
                while (1) switch (_context27.prev = _context27.next) {
                  case 0:
                    _context27.next = 2;
                    return this.fetch("auth/impersonate", {
                      token: e2,
                      method: "POST",
                      allowUnsafeRetries: true,
                      body: JSON.stringify({
                        userId: t2
                      })
                    });
                  case 2:
                    return _context27.abrupt("return", _context27.sent);
                  case 3:
                  case "end":
                    return _context27.stop();
                }
              }, _callee21, this);
            }));
          }
        }, {
          key: "createServiceAccount",
          value: function createServiceAccount(e2, t2, r2, n2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
              return _regeneratorRuntime().wrap(function _callee22$(_context28) {
                while (1) switch (_context28.prev = _context28.next) {
                  case 0:
                    _context28.next = 2;
                    return this.fetch("auth/service-account", {
                      token: e2,
                      method: "POST",
                      allowUnsafeRetries: true,
                      body: JSON.stringify({
                        name: t2,
                        roleId: r2,
                        tags: n2
                      })
                    });
                  case 2:
                    return _context28.abrupt("return", _context28.sent);
                  case 3:
                  case "end":
                    return _context28.stop();
                }
              }, _callee22, this);
            }));
          }
        }, {
          key: "getFeatures",
          value: function getFeatures(e2) {
            return o(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
              return _regeneratorRuntime().wrap(function _callee23$(_context29) {
                while (1) switch (_context29.prev = _context29.next) {
                  case 0:
                    _context29.next = 2;
                    return this.fetch("auth/features", {
                      token: e2
                    });
                  case 2:
                    return _context29.abrupt("return", _context29.sent.features);
                  case 3:
                  case "end":
                    return _context29.stop();
                }
              }, _callee23, this);
            }));
          }
        }]);
        return i;
      }(n.a);
      var s = function s(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      var a2 = /*#__PURE__*/function (_n$a3) {
        _inherits(a2, _n$a3);
        function a2() {
          _classCallCheck(this, a2);
          return _possibleConstructorReturn(this, _getPrototypeOf(a2).apply(this, arguments));
        }
        _createClass(a2, [{
          key: "createPeer",
          value: function createPeer(e2, t2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
              return _regeneratorRuntime().wrap(function _callee24$(_context30) {
                while (1) switch (_context30.prev = _context30.next) {
                  case 0:
                    _context30.next = 2;
                    return this.fetch("peers", {
                      token: e2,
                      method: "POST",
                      body: JSON.stringify(t2)
                    });
                  case 2:
                    return _context30.abrupt("return", _context30.sent);
                  case 3:
                  case "end":
                    return _context30.stop();
                }
              }, _callee24, this);
            }));
          }
        }, {
          key: "getPeers",
          value: function getPeers(e2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
              return _regeneratorRuntime().wrap(function _callee25$(_context31) {
                while (1) switch (_context31.prev = _context31.next) {
                  case 0:
                    _context31.next = 2;
                    return this.fetch("peers", {
                      token: e2
                    });
                  case 2:
                    return _context31.abrupt("return", _context31.sent.items);
                  case 3:
                  case "end":
                    return _context31.stop();
                }
              }, _callee25, this);
            }));
          }
        }, {
          key: "refreshPeer",
          value: function refreshPeer(e2, t2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
              return _regeneratorRuntime().wrap(function _callee26$(_context32) {
                while (1) switch (_context32.prev = _context32.next) {
                  case 0:
                    _context32.next = 2;
                    return this.fetch("peers/".concat(t2, "/refresh"), {
                      token: e2,
                      method: "POST",
                      allowUnsafeRetries: true
                    });
                  case 2:
                  case "end":
                    return _context32.stop();
                }
              }, _callee26, this);
            }));
          }
        }, {
          key: "createSession",
          value: function createSession(e2, t2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
              return _regeneratorRuntime().wrap(function _callee27$(_context33) {
                while (1) switch (_context33.prev = _context33.next) {
                  case 0:
                    _context33.next = 2;
                    return this.fetch("sessions", {
                      token: e2,
                      method: "POST",
                      body: JSON.stringify(t2)
                    });
                  case 2:
                    return _context33.abrupt("return", _context33.sent);
                  case 3:
                  case "end":
                    return _context33.stop();
                }
              }, _callee27, this);
            }));
          }
        }, {
          key: "refreshSession",
          value: function refreshSession(e2, t2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
              return _regeneratorRuntime().wrap(function _callee28$(_context34) {
                while (1) switch (_context34.prev = _context34.next) {
                  case 0:
                    _context34.next = 2;
                    return this.fetch("sessions/".concat(t2, "/refresh"), {
                      token: e2,
                      method: "POST",
                      allowUnsafeRetries: true
                    });
                  case 2:
                  case "end":
                    return _context34.stop();
                }
              }, _callee28, this);
            }));
          }
        }, {
          key: "deleteSession",
          value: function deleteSession(e2, t2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
              return _regeneratorRuntime().wrap(function _callee29$(_context35) {
                while (1) switch (_context35.prev = _context35.next) {
                  case 0:
                    _context35.next = 2;
                    return this.fetch("sessions/".concat(t2), {
                      token: e2,
                      method: "DELETE",
                      allowUnsafeRetries: true
                    });
                  case 2:
                  case "end":
                    return _context35.stop();
                }
              }, _callee29, this);
            }));
          }
        }, {
          key: "getSessions",
          value: function getSessions(e2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
              return _regeneratorRuntime().wrap(function _callee30$(_context36) {
                while (1) switch (_context36.prev = _context36.next) {
                  case 0:
                    _context36.next = 2;
                    return this.fetch("sessions", {
                      token: e2
                    });
                  case 2:
                    return _context36.abrupt("return", _context36.sent.items);
                  case 3:
                  case "end":
                    return _context36.stop();
                }
              }, _callee30, this);
            }));
          }
        }, {
          key: "getIceServers",
          value: function getIceServers(e2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
              return _regeneratorRuntime().wrap(function _callee31$(_context37) {
                while (1) switch (_context37.prev = _context37.next) {
                  case 0:
                    _context37.next = 2;
                    return this.fetch("ice-servers", {
                      token: e2
                    });
                  case 2:
                    return _context37.abrupt("return", _context37.sent.items);
                  case 3:
                  case "end":
                    return _context37.stop();
                }
              }, _callee31, this);
            }));
          }
        }, {
          key: "addSignals",
          value: function addSignals(e2, t2, r2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
              return _regeneratorRuntime().wrap(function _callee32$(_context38) {
                while (1) switch (_context38.prev = _context38.next) {
                  case 0:
                    _context38.next = 2;
                    return this.fetch("sessions/".concat(t2, "/add-signals"), {
                      token: e2,
                      method: "POST",
                      body: JSON.stringify(r2)
                    });
                  case 2:
                  case "end":
                    return _context38.stop();
                }
              }, _callee32, this);
            }));
          }
        }, {
          key: "takeSignals",
          value: function takeSignals(e2, t2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
              return _regeneratorRuntime().wrap(function _callee33$(_context39) {
                while (1) switch (_context39.prev = _context39.next) {
                  case 0:
                    _context39.next = 2;
                    return this.fetch("sessions/".concat(t2, "/take-signals"), {
                      token: e2,
                      method: "POST"
                    });
                  case 2:
                    return _context39.abrupt("return", _context39.sent.items);
                  case 3:
                  case "end":
                    return _context39.stop();
                }
              }, _callee33, this);
            }));
          }
        }]);
        return a2;
      }(n.a);
      var l = r(1),
        u = r(8),
        g = r(14),
        c = r.n(g),
        f = r(104),
        p = r.n(f),
        h = r(0);
      var d = function d(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      var y = /*#__PURE__*/function () {
        function y(e2) {
          _classCallCheck(this, y);
          this.name = "LogReporter", this.type = "simple", this.message = e2;
        }
        _createClass(y, [{
          key: "send",
          value: function send(e2) {
            return d(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
              var t2, r2;
              return _regeneratorRuntime().wrap(function _callee34$(_context40) {
                while (1) switch (_context40.prev = _context40.next) {
                  case 0:
                    h.a.info(this.message, (t2 = e2.reduce(function (e3, t3) {
                      return Object.assign(Object.assign({}, e3), _defineProperty({}, t3.name, t3.stat));
                    }, {}), r2 = function r2(e3) {
                      var t3 = e3.sum,
                        r3 = e3.count,
                        n2 = t3 / r3;
                      return Object.assign(Object.assign({}, e3), {
                        average: n2
                      });
                    }, Object.keys(t2).reduce(function (e3, n2) {
                      return Object.assign(Object.assign({}, e3), _defineProperty({}, n2, r2(t2[n2])));
                    }, {})));
                  case 1:
                  case "end":
                    return _context40.stop();
                }
              }, _callee34, this);
            }));
          }
        }]);
        return y;
      }();
      var m = r(4),
        b = r(39);
      function v(e2) {
        return !!e2.match(/^[a-zA-Z0-9-_.,:?'"()@\/\\#$+ ]{1,255}$/);
      }
      var _ = function _(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      function S(_ref16) {
        var e2 = _ref16.func,
          t2 = _ref16.delay,
          r2 = _ref16.immediate;
        var n2 = false,
          o2 = setTimeout(function r3() {
            return _(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
              var s2, e3;
              return _regeneratorRuntime().wrap(function _callee35$(_context41) {
                while (1) switch (_context41.prev = _context41.next) {
                  case 0:
                    if (!n2) {
                      _context41.next = 2;
                      break;
                    }
                    return _context41.abrupt("return");
                  case 2:
                    s2 = new Date().getTime();
                    _context41.prev = 3;
                    i2 = e2();
                    _context41.next = 7;
                    return i2;
                  case 7:
                    _context41.prev = 7;
                    if (!n2) {
                      e3 = new Date().getTime();
                      o2 = setTimeout(r3, Math.max(t2 - (e3 - s2), 0));
                    }
                    return _context41.finish(7);
                  case 10:
                  case "end":
                    return _context41.stop();
                }
              }, _callee35, null, [[3,, 7, 10]]);
            }));
          }, r2 ? 0 : t2),
          i2 = Promise.resolve();
        return {
          stop: function stop() {
            return _(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
              return _regeneratorRuntime().wrap(function _callee36$(_context42) {
                while (1) switch (_context42.prev = _context42.next) {
                  case 0:
                    n2 = true;
                    clearTimeout(o2);
                    _context42.next = 4;
                    return i2;
                  case 4:
                  case "end":
                    return _context42.stop();
                }
              }, _callee36);
            }));
          }
        };
      }
      var w = function w(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      var E = r(226);
      var T = !!m.c,
        R = new ( /*#__PURE__*/function () {
          function _class3(e2) {
            var _this15 = this;
            _classCallCheck(this, _class3);
            this.samplePeriodSeconds = 60, this.buffer = {}, this.reporters = [], this.flushInterval = S({
              func: function func() {
                return _this15.flushStats();
              },
              delay: this.samplePeriodSeconds * l.a.second
            }), this.tags = this.filterTags((null == e2 ? void 0 : e2.tags) || {
              app: m.a,
              version: m.j,
              namespace: m.i,
              instanceId: b.a
            });
          }
          _createClass(_class3, [{
            key: "shutdown",
            value: function shutdown() {
              return w(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
                return _regeneratorRuntime().wrap(function _callee37$(_context43) {
                  while (1) switch (_context43.prev = _context43.next) {
                    case 0:
                      _context43.next = 2;
                      return this.flushInterval.stop();
                    case 2:
                      _context43.next = 4;
                      return this.flushStats();
                    case 4:
                      _context43.next = 6;
                      return Object(u.a)(2 * l.a.second);
                    case 6:
                    case "end":
                      return _context43.stop();
                  }
                }, _callee37, this);
              }));
            }
          }, {
            key: "aggregate",
            value: function aggregate(e2, t2, r2) {
              this.addToBuffer(this.buffer, this.encodeKey({
                metric: e2,
                tags: this.filterTags(r2 || {})
              }), "number" == typeof t2 ? {
                min: t2,
                max: t2,
                sum: t2,
                count: 1
              } : t2);
            }
          }, {
            key: "increment",
            value: function increment(e2, t2) {
              this.aggregate(e2, 1, t2);
            }
          }, {
            key: "timer",
            value: function timer(e2, t2, r2) {
              return w(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
                var n2, o2, i2;
                return _regeneratorRuntime().wrap(function _callee38$(_context44) {
                  while (1) switch (_context44.prev = _context44.next) {
                    case 0:
                      n2 = E();
                      _context44.next = 3;
                      return t2();
                    case 3:
                      o2 = _context44.sent;
                      i2 = E();
                      return _context44.abrupt("return", (this.aggregate(e2, i2 - n2, r2), o2));
                    case 6:
                    case "end":
                      return _context44.stop();
                  }
                }, _callee38, this);
              }));
            }
          }, {
            key: "registerStatsReporter",
            value: function registerStatsReporter(e2) {
              this.reporters.push(e2);
            }
          }, {
            key: "setTag",
            value: function setTag(e2, t2) {
              var r2 = this.filterTags(_defineProperty({}, e2, t2));
              this.tags = Object.assign(Object.assign({}, this.tags), r2);
            }
          }, {
            key: "addToBuffer",
            value: function addToBuffer(e2, t2, r2) {
              if (e2[t2]) {
                var _e2$t = e2[t2],
                  n2 = _e2$t.min,
                  o2 = _e2$t.max,
                  i2 = _e2$t.sum,
                  s2 = _e2$t.count;
                e2[t2] = {
                  min: Math.min(n2, r2.min),
                  max: Math.max(o2, r2.max),
                  sum: i2 + r2.sum,
                  count: s2 + r2.count
                };
              } else e2[t2] = r2;
            }
          }, {
            key: "write",
            value: function write(e2) {
              return w(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
                var _this16 = this;
                return _regeneratorRuntime().wrap(function _callee40$(_context46) {
                  while (1) switch (_context46.prev = _context46.next) {
                    case 0:
                      _context46.next = 2;
                      return Promise.all(this.reporters.map(function (t2) {
                        return w(_this16, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
                          var _this17 = this;
                          var r2, n2, _i, _Object$entries, _Object$entries$_i, _t11, r3, _this$decodeKey, e3, o2;
                          return _regeneratorRuntime().wrap(function _callee39$(_context45) {
                            while (1) switch (_context45.prev = _context45.next) {
                              case 0:
                                n2 = {};
                                _context45.t0 = t2.type;
                                _context45.next = _context45.t0 === "simple" ? 4 : _context45.t0 === "tagged" ? 7 : 9;
                                break;
                              case 4:
                                for (_i = 0, _Object$entries = Object.entries(e2); _i < _Object$entries.length; _i++) {
                                  _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), _t11 = _Object$entries$_i[0], r3 = _Object$entries$_i[1];
                                  _this$decodeKey = this.decodeKey(_t11), e3 = _this$decodeKey.metric;
                                  this.addToBuffer(n2, this.encodeKey({
                                    metric: e3
                                  }), r3);
                                }
                                r2 = n2;
                                return _context45.abrupt("break", 10);
                              case 7:
                                r2 = e2;
                                return _context45.abrupt("break", 10);
                              case 9:
                                !function (e3) {
                                  throw new Error("Unreachable type encountered (".concat(e3, ")"));
                                }(t2.type);
                              case 10:
                                o2 = Object.entries(r2);
                                if (!(o2.length > 0)) {
                                  _context45.next = 13;
                                  break;
                                }
                                return _context45.abrupt("return", t2.send(o2.map(function (_ref17) {
                                  var _ref18 = _slicedToArray(_ref17, 2),
                                    e3 = _ref18[0],
                                    t3 = _ref18[1];
                                  var _this17$decodeKey = _this17.decodeKey(e3),
                                    r3 = _this17$decodeKey.metric,
                                    n3 = _this17$decodeKey.tags;
                                  return {
                                    name: r3,
                                    tags: Object.assign(Object.assign({}, n3), _this17.tags),
                                    stat: t3
                                  };
                                }), this.samplePeriodSeconds).catch(function (e3) {
                                  h.a.debug("Failed to write stats to ".concat(t2.name), {
                                    error: e3
                                  });
                                }));
                              case 13:
                              case "end":
                                return _context45.stop();
                            }
                          }, _callee39, this);
                        }));
                      }));
                    case 2:
                    case "end":
                      return _context46.stop();
                  }
                }, _callee40, this);
              }));
            }
          }, {
            key: "flushStats",
            value: function flushStats() {
              return w(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
                return _regeneratorRuntime().wrap(function _callee41$(_context47) {
                  while (1) switch (_context47.prev = _context47.next) {
                    case 0:
                      _context47.next = 2;
                      return this.write(this.buffer);
                    case 2:
                      this.buffer = {};
                    case 3:
                    case "end":
                      return _context47.stop();
                  }
                }, _callee41, this);
              }));
            }
          }, {
            key: "encodeKey",
            value: function encodeKey(e2) {
              return c()(Object.assign(Object.assign({}, e2), Object.keys(e2.tags || {}).length > 0 ? {
                tags: e2.tags
              } : {}));
            }
          }, {
            key: "decodeKey",
            value: function decodeKey(e2) {
              return JSON.parse(e2);
            }
          }, {
            key: "filterTags",
            value: function filterTags(e2) {
              return Object.entries(e2 || {}).reduce(function (e3, _ref19) {
                var _ref20 = _slicedToArray(_ref19, 2),
                  t2 = _ref20[0],
                  r2 = _ref20[1];
                return v(t2) && v(r2) && (e3[t2] = r2), e3;
              }, {});
            }
          }]);
          return _class3;
        }())();
      T || ["local", "on-prem"].includes(m.i) || R.registerStatsReporter(new y("stats"));
      var A = function A(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      var O = /*#__PURE__*/function (_ref21) {
        _inherits(O, _ref21);
        function O(e2) {
          var _this18;
          _classCallCheck(this, O);
          if (_this18 = _possibleConstructorReturn(this, _getPrototypeOf(O).call(this, e2)), _this18.expireRejectedPromiseValues = void 0 === e2.expireRejectedPromiseValues || e2.expireRejectedPromiseValues, _this18.rejectedPromiseValueTtl = void 0 !== e2.rejectedPromiseValueTtl ? e2.rejectedPromiseValueTtl : l.a.second, _this18.rejectedPromiseValueTtl < 0) throw new Error("rejectedPromiseValueTtl must not be negative");
          return _possibleConstructorReturn(_this18);
        }
        _createClass(O, [{
          key: "set",
          value: function set(e2, t2, r2) {
            var _this19 = this;
            _get(_getPrototypeOf(O.prototype), "set", this).call(this, e2, t2, r2), this.expireRejectedPromiseValues && t2.catch(function () {
              return A(_this19, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
                return _regeneratorRuntime().wrap(function _callee42$(_context48) {
                  while (1) switch (_context48.prev = _context48.next) {
                    case 0:
                      _context48.next = 2;
                      return Object(u.a)(this.rejectedPromiseValueTtl);
                    case 2:
                      this.peek(e2) === t2 && this.delete(e2);
                    case 3:
                    case "end":
                      return _context48.stop();
                  }
                }, _callee42, this);
              }));
            });
          }
        }]);
        return O;
      }( /*#__PURE__*/function () {
        function _class4(e2) {
          var _this20 = this;
          _classCallCheck(this, _class4);
          this.options = e2, this.cache = new p.a(Object.assign(Object.assign(Object.assign({}, e2.dispose || e2.disposeAfter ? {
            ttlAutopurge: true
          } : {}), e2), {
            dispose: function dispose() {
              var _r3;
              var r2;
              for (var _len10 = arguments.length, t2 = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
                t2[_key10] = arguments[_key10];
              }
              "evict" === t2[2] && R.increment("lru-eviction", {
                name: e2.name
              }), null === (r2 = e2.dispose) || void 0 === r2 || (_r3 = r2).call.apply(_r3, [e2].concat(t2));
            },
            disposeAfter: function disposeAfter() {
              var _r4;
              var r2;
              for (var _len11 = arguments.length, t2 = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
                t2[_key11] = arguments[_key11];
              }
              _this20.updateStats(), null === (r2 = e2.disposeAfter) || void 0 === r2 || (_r4 = r2).call.apply(_r4, [e2].concat(t2));
            }
          })), this.stringify = e2.fastStringify ? JSON.stringify : c.a;
        }
        _createClass(_class4, [{
          key: "set",
          value: function set(e2, t2, r2) {
            var n2 = this.stringify(e2);
            if (!this.cache.set(n2, t2, {
              ttl: r2
            })) {
              var e3 = this.cache.sizeCalculation ? this.cache.sizeCalculation(t2, n2) : "unknown";
              throw Error("Value too large (".concat(e3, " > ").concat(this.cache.max, ")"));
            }
            this.updateStats();
          }
        }, {
          key: "get",
          value: function get(e2) {
            var t2 = this.options.name,
              r2 = this.stringify(e2),
              n2 = this.cache.getRemainingTTL(r2);
            return n2 <= 0 ? R.increment("cache-miss", {
              name: t2
            }) : n2 !== 1 / 0 && R.aggregate("cache-item-ttl", n2, {
              name: t2
            }), this.cache.get(r2);
          }
        }, {
          key: "delete",
          value: function _delete(e2) {
            this.cache.delete(this.stringify(e2));
          }
        }, {
          key: "peek",
          value: function peek(e2) {
            return this.cache.peek(this.stringify(e2));
          }
        }, {
          key: "size",
          value: function size() {
            return this.cache.size;
          }
        }, {
          key: "clear",
          value: function clear() {
            this.cache.clear();
          }
        }, {
          key: "forEach",
          value: function forEach(e2) {
            this.cache.forEach(e2);
          }
        }, {
          key: "purgeStale",
          value: function purgeStale() {
            return this.cache.purgeStale();
          }
        }, {
          key: "updateStats",
          value: function updateStats() {
            var e2 = this.options.name;
            R.aggregate("cache-item-count", this.cache.size, {
              name: e2
            }), void 0 !== this.cache.calculatedSize && R.aggregate("cache-length", this.cache.calculatedSize, {
              name: e2
            });
          }
        }]);
        return _class4;
      }());
      var C = function C(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      var I = /*#__PURE__*/function () {
        function I(e2, t2, r2) {
          _classCallCheck(this, I);
          this.authClient = e2, this.email = t2, this.password = r2, this.tokenTtlMs = 1 * l.a.hour, this.tokenCache = new O({
            name: "Credentials-tokenCache",
            max: 100,
            ttl: this.tokenTtlMs - 5 * l.a.minute,
            fastStringify: true
          });
        }
        _createClass(I, [{
          key: "getToken",
          value: function getToken() {
            return C(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
              var _this21 = this;
              var e2;
              return _regeneratorRuntime().wrap(function _callee44$(_context50) {
                while (1) switch (_context50.prev = _context50.next) {
                  case 0:
                    e2 = this.tokenCache.get(this.email);
                    return _context50.abrupt("return", (e2 || (e2 = function () {
                      return C(_this21, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
                        var _yield$this$authClien, e3;
                        return _regeneratorRuntime().wrap(function _callee43$(_context49) {
                          while (1) switch (_context49.prev = _context49.next) {
                            case 0:
                              _context49.next = 2;
                              return this.authClient.login({
                                email: this.email,
                                password: this.password,
                                tokenExpirationSeconds: this.tokenTtlMs / l.a.second
                              });
                            case 2:
                              _yield$this$authClien = _context49.sent;
                              e3 = _yield$this$authClien.authentication;
                              if (e3) {
                                _context49.next = 6;
                                break;
                              }
                              throw new Error("User account not verified.");
                            case 6:
                              return _context49.abrupt("return", e3.accessToken);
                            case 7:
                            case "end":
                              return _context49.stop();
                          }
                        }, _callee43, this);
                      }));
                    }(), this.tokenCache.set(this.email, e2)), e2));
                  case 2:
                  case "end":
                    return _context50.stop();
                }
              }, _callee44, this);
            }));
          }
        }]);
        return I;
      }();
      var j = r(97);
      var M = r(40),
        P = function P(e2, t2, r2, n2) {
          return new (r2 || (r2 = Promise))(function (o2, i2) {
            function s2(e3) {
              try {
                l2(n2.next(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function a3(e3) {
              try {
                l2(n2.throw(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function l2(e3) {
              var t3;
              e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
                e4(t3);
              })).then(s2, a3);
            }
            l2((n2 = n2.apply(e2, t2 || [])).next());
          });
        };
      var N = /*#__PURE__*/function (_M$a) {
        _inherits(N, _M$a);
        function N(e2) {
          _classCallCheck(this, N);
          return _possibleConstructorReturn(this, _getPrototypeOf(N).call(this, e2));
        }
        _createClass(N, [{
          key: "postLanRtcOffer",
          value: function postLanRtcOffer(e2) {
            return P(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
              return _regeneratorRuntime().wrap(function _callee45$(_context51) {
                while (1) switch (_context51.prev = _context51.next) {
                  case 0:
                    _context51.next = 2;
                    return this.fetch("v1/lan-rtc-offer", {
                      method: "POST",
                      body: JSON.stringify(e2)
                    });
                  case 2:
                    return _context51.abrupt("return", _context51.sent);
                  case 3:
                  case "end":
                    return _context51.stop();
                }
              }, _callee45, this);
            }));
          }
        }]);
        return N;
      }(M.a);
      var L = function L(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      function D(e2) {
        return L(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
          return _regeneratorRuntime().wrap(function _callee46$(_context52) {
            while (1) switch (_context52.prev = _context52.next) {
              case 0:
                _context52.next = 2;
                return Promise.all(e2.map(function (e3) {
                  return e3.catch(function (e4) {
                    return e4;
                  });
                }));
              case 2:
                return _context52.abrupt("return", _context52.sent.filter(function (e3) {
                  return e3 instanceof Error;
                }));
              case 3:
              case "end":
                return _context52.stop();
            }
          }, _callee46);
        }));
      }
      function x(e2) {
        if (void 0 !== e2) return e2;
        throw new Error("Value is undefined");
      }
      function U(e2, t2) {
        var r2 = e2.reduce(function (e3, t3) {
          return [].concat(_toConsumableArray(e3), _toConsumableArray(t3.urls));
        }, []).filter(function (e3) {
          return B(e3, t2);
        }).sort(function (e3) {
          return k(e3, "udp") ? -1 : 0;
        }).shift();
        if (r2) return Object.assign(Object.assign({}, x(e2.find(function (e3) {
          return e3.urls.includes(r2);
        }))), {
          urls: [r2]
        });
      }
      function B(e2, t2) {
        switch (t2) {
          case "stun":
            return /^stuns?:/.test(e2);
          case "turn":
            return /^turns?:/.test(e2);
        }
      }
      function k(e2, t2) {
        return e2.endsWith("transport=".concat(t2));
      }
      var F = r(9);
      var W = r(24),
        V = r(229);
      var H = r(29);
      var z = {
          ordered: false,
          maxPacketLifeTime: 300 * l.a.millisecond
        },
        G = {
          ordered: true
        },
        q = {
          ordered: true
        },
        Y = {
          ordered: false,
          maxRetransmits: 0
        },
        Z = {
          ordered: false,
          maxRetransmits: 0
        },
        $ = function $(e2) {
          return "received" in e2 && void 0 !== e2.received;
        },
        K = function K(e2) {
          return !("received" in e2) || void 0 === e2.received;
        },
        X = 2 * l.a.second;
      function J(e2) {
        var t2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r2 = Array.from(e2.values()),
          n2 = r2.filter($),
          o2 = n2.length > 0,
          i2 = Math.max.apply(Math, _toConsumableArray(n2.map(function (e3) {
            return e3.received;
          })));
        var s2;
        if (o2) {
          var e3 = r2.length,
            _t12 = n2.length,
            o3 = n2.map(function (e4) {
              return e4.received - e4.sent;
            }),
            _ref22 = function (e4) {
              var t4 = e4.length;
              if (0 === t4) return {
                mean: NaN,
                standardDeviation: -1,
                jitter: NaN
              };
              var r3 = e4.reduce(function (e5, t5) {
                  return e5 + t5;
                }, 0) / t4,
                n3 = Math.sqrt(e4.map(function (e5) {
                  return Math.pow(e5 - r3, 2);
                }).reduce(function (e5, t5) {
                  return e5 + t5;
                }) / t4);
              var o4 = 0;
              for (var r4 = 1; r4 < t4; ++r4) o4 += Math.abs(e4[r4] - e4[r4 - 1]);
              return {
                mean: r3,
                standardDeviation: n3,
                jitter: o4 / (t4 - 1)
              };
            }(o3),
            a4 = _ref22.standardDeviation,
            l3 = _ref22.mean,
            u2 = _ref22.jitter,
            g2 = r2.filter(function (e4) {
              return e4.sent < i2 - X;
            }),
            c2 = g2.filter(K),
            f2 = 0 === c2.length ? 0 : c2.length / g2.length;
          s2 = {
            pingsSent: e3,
            pongsReceived: _t12,
            average: l3,
            standardDeviation: a4,
            jitter: u2,
            max: Math.max.apply(Math, _toConsumableArray(o3)),
            min: Math.min.apply(Math, _toConsumableArray(o3)),
            loss: f2
          };
        } else s2 = null;
        var _t2$temporalNow = t2.temporalNow,
          a3 = _t2$temporalNow === void 0 ? Date.now() : _t2$temporalNow,
          l2 = (o2 ? i2 : a3) - 4 * X;
        return Array.from(e2.entries()).forEach(function (t3) {
          var _t13 = _slicedToArray(t3, 2),
            r3 = _t13[0],
            n3 = _t13[1];
          n3.sent < l2 && e2.delete(r3);
        }), s2;
      }
      function Q(_ref23) {
        var e2 = _ref23.entityId,
          t2 = _ref23.streamName,
          r2 = _ref23.streamType;
        return "".concat(e2, ".").concat(t2, ".").concat(r2);
      }
      var ee = function ee(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      var te = /*#__PURE__*/function () {
        function te(e2, t2) {
          _classCallCheck(this, te);
          this.sessionId = e2, this.connection = t2, this.counts = {
            localSent: /* @__PURE__ */new Map(),
            localReceived: /* @__PURE__ */new Map(),
            remoteSent: /* @__PURE__ */new Map(),
            remoteReceived: /* @__PURE__ */new Map()
          }, this.sessionId = e2, this.connection = t2;
        }
        _createClass(te, [{
          key: "updateRemoteMessagesCounts",
          value: function updateRemoteMessagesCounts(e2) {
            if (e2.payload.streamsInfo) {
              this.counts.remoteSent = /* @__PURE__ */new Map(), this.counts.remoteReceived = /* @__PURE__ */new Map();
              var _iterator14 = _createForOfIteratorHelper(e2.payload.streamsInfo.items),
                _step14;
              try {
                for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                  var t2 = _step14.value;
                  this.counts.remoteSent.set(t2.streamId, t2.sentCount), this.counts.remoteReceived.set(t2.streamId, t2.receivedCount);
                }
              } catch (err) {
                _iterator14.e(err);
              } finally {
                _iterator14.f();
              }
            }
          }
        }, {
          key: "getLocalStreamsInfo",
          value: function getLocalStreamsInfo(e2) {
            var _this$counts = this.counts,
              t2 = _this$counts.localSent,
              r2 = _this$counts.localReceived;
            return {
              items: _toConsumableArray( /* @__PURE__ */new Set([].concat(_toConsumableArray(t2.keys()), _toConsumableArray(r2.keys())))).map(function (e3) {
                var n2, o2;
                return {
                  streamId: e3,
                  sentCount: null !== (n2 = t2.get(e3)) && void 0 !== n2 ? n2 : 0,
                  receivedCount: null !== (o2 = r2.get(e3)) && void 0 !== o2 ? o2 : 0
                };
              }),
              timestamp: e2
            };
          }
        }, {
          key: "incrementLocalSent",
          value: function incrementLocalSent(e2) {
            var t2 = this.counts.localSent,
              r2 = Q(e2.header.stream);
            t2.set(r2, (t2.get(r2) || 0) + 1);
          }
        }, {
          key: "incrementLocalReceived",
          value: function incrementLocalReceived(e2) {
            var t2 = this.counts.localReceived,
              r2 = Q(e2.header.stream),
              n2 = t2.get(r2) || 0;
            if (0 === n2) {
              var _e2$header$stream = e2.header.stream,
                _t14 = _e2$header$stream.streamName,
                r3 = _e2$header$stream.streamType;
              h.a.debug("RTC client received first message for stream", {
                streamName: _t14,
                streamType: r3
              });
            }
            t2.set(r2, n2 + 1);
          }
        }, {
          key: "uploadMetrics",
          value: function uploadMetrics() {
            return ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
              var e2, t2, r2, _this$counts2, n2, o2, i2, s2, a3;
              return _regeneratorRuntime().wrap(function _callee47$(_context53) {
                while (1) switch (_context53.prev = _context53.next) {
                  case 0:
                    e2 = this.sessionId;
                    _context53.next = 3;
                    return this.connection.peerConnection.getStats();
                  case 3:
                    t2 = _context53.sent;
                    r2 = {};
                    t2.forEach(function (e3) {
                      return r2[e3.id] = e3;
                    }), h.a.debug("rtc-stats", Object.assign(Object.assign({}, r2), {
                      sessionId: e2
                    }));
                    _this$counts2 = this.counts, n2 = _this$counts2.localSent, o2 = _this$counts2.localReceived, i2 = _this$counts2.remoteSent, s2 = _this$counts2.remoteReceived, a3 = _toConsumableArray( /* @__PURE__ */new Set([].concat(_toConsumableArray(n2.keys()), _toConsumableArray(o2.keys())))).reduce(function (e3, t3) {
                      var _Object$assign3;
                      var r3 = n2.get(t3),
                        a4 = o2.get(t3),
                        l2 = i2.get(t3),
                        u2 = s2.get(t3);
                      return Object.assign(Object.assign({}, e3), (_Object$assign3 = {}, _defineProperty(_Object$assign3, "local-".concat(t3, "-sent"), r3), _defineProperty(_Object$assign3, "local-".concat(t3, "-received"), a4), _defineProperty(_Object$assign3, "remote-".concat(t3, "-sent"), l2), _defineProperty(_Object$assign3, "remote-".concat(t3, "-received"), u2), _Object$assign3));
                    }, {
                      sessionId: e2
                    });
                    h.a.debug("rtc-message-report", Object.assign({
                      deviceId: this.connection.getRemoteDeviceId()
                    }, a3));
                  case 8:
                  case "end":
                    return _context53.stop();
                }
              }, _callee47, this);
            }));
          }
        }]);
        return te;
      }();
      function re(e2, t2, r2) {
        return {
          header: {
            stream: e2,
            created: Date.now(),
            frameId: r2 || ""
          },
          payload: t2
        };
      }
      function ne(e2) {
        return /* @__PURE__ */new Set(["disconnected", "failed", "closed"]).has(e2.iceConnectionState);
      }
      function oe(e2) {
        switch (e2.header.stream.streamType) {
          case "twist":
            {
              var t2 = e2.payload.twist;
              if (!t2) throw Error("twist not in payload of RTC message with type twist");
              return {
                header: e2.header,
                payload: {
                  twist: {
                    linear: Object.assign({
                      x: 0,
                      y: 0,
                      z: 0
                    }, t2.linear),
                    angular: Object.assign({
                      x: 0,
                      y: 0,
                      z: 0
                    }, t2.angular)
                  }
                }
              };
            }
          case "pose":
            {
              var _t15 = e2.payload.pose;
              if (!_t15) throw Error("pose not in payload of RTC message with type pose");
              return {
                header: e2.header,
                payload: {
                  pose: {
                    translation: Object.assign({
                      x: 0,
                      y: 0,
                      z: 0
                    }, _t15.translation),
                    rotation: Object.assign({
                      x: 0,
                      y: 0,
                      z: 0,
                      w: 0
                    }, _t15.rotation)
                  }
                }
              };
            }
          case "pose-with-covariance":
            {
              var _t16 = e2.payload.poseWithCovariance;
              if (!_t16) throw Error("poseWithCovariance not in payload of RTC message with type pose-with-covariance");
              var r2 = new Array(36).fill(0);
              return _t16.covariance.forEach(function (e3, t3) {
                if (t3 >= 36) throw Error("covariance contains more than 36 elements");
                r2[t3] = e3;
              }), {
                header: e2.header,
                payload: {
                  poseWithCovariance: {
                    pose: {
                      translation: Object.assign({
                        x: 0,
                        y: 0,
                        z: 0
                      }, _t16.pose.translation),
                      rotation: Object.assign({
                        x: 0,
                        y: 0,
                        z: 0,
                        w: 0
                      }, _t16.pose.rotation)
                    },
                    covariance: r2
                  }
                }
              };
            }
          case "point":
            {
              var _t17 = e2.payload.point;
              if (!_t17) throw Error("point not in payload of RTC message with type point");
              return {
                header: e2.header,
                payload: {
                  point: Object.assign({
                    x: 0,
                    y: 0,
                    z: 0
                  }, _t17)
                }
              };
            }
          default:
            return e2;
        }
      }
      var ie = function ie(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      var se = /*#__PURE__*/function () {
        function se(e2, t2, r2) {
          var _this22 = this;
          _classCallCheck(this, se);
          this.peerConnection = e2, this.config = t2, this.dataChannelNotifier = r2, this.connectTimeoutMs = 20 * l.a.second, this.iceGatheringTimeoutMs = 15 * l.a.second, this.pingUpdateTimeoutMs = 1 * l.a.second, this.pingV2UpdateTimeoutMs = 250 * l.a.millisecond, this.pingV2MetricsGatherTimeoutMs = 1 * l.a.second, this.streamsInfoUpdateTimeoutMs = 2 * l.a.second, this.reassemblyTimeoutMs = 500 * l.a.millisecond, this.reassemblyTableCleanupMs = 1 * l.a.second, this.heartbeatTimeoutMs = 20 * l.a.millisecond, this.streamLatestTimestamp = /* @__PURE__ */new Map(), this.reassemblyTable = /* @__PURE__ */new Map(), this.reassemblyTableLastTimestamp = /* @__PURE__ */new Map(), this.closeCalled = false, this.gotOffer = false, this.hasIceCandidate = false, this.pingV2Map = /* @__PURE__ */new Map(), this.sendPingV2 = function () {
            var e3 = _this22.latestTryOnceStreamChannel;
            if (!e3) return;
            var t3 = new Date().getTime(),
              r3 = Object(V.a)();
            _this22.sendSystemMessage(e3, {
              type: "ping-v2",
              payload: {
                timestamp: t3,
                id: r3
              }
            }), _this22.pingV2Map.set(r3, {
              sent: t3
            });
          }, this.gatherPingV2Metrics = function () {
            var e3 = J(_this22.pingV2Map);
            e3 && (_this22.pingInfo = e3, R.aggregate("rtc-ping-average", e3.average), R.aggregate("rtc-ping-loss", e3.loss), R.aggregate("rtc-jitter", e3.jitter));
          };
          var n2 = t2.baseConfig.isOffer;
          n2 ? this.initializeChannels(e2) : e2.ondatachannel = function (e3) {
            switch (e3.channel.label) {
              case "stream.latest-ttl":
                _this22.latestTtlStreamChannel = e3.channel;
                break;
              case "stream.reliable":
                _this22.reliableStreamChannel = e3.channel;
                break;
              case "stream.latest-reliable":
                _this22.latestReliableStreamChannel = e3.channel;
                break;
              case "stream.latest-try-once":
                _this22.latestTryOnceStreamChannel = e3.channel;
                break;
              case "heartbeat":
                return void (_this22.heartbeatChannel = e3.channel);
              default:
                return void _this22.dataChannelNotifier(e3.channel);
            }
            _this22.setupChannel(e3.channel);
          }, this.pingUpdateTimeout = setInterval(function () {
            var e3 = _this22.reliableStreamChannel;
            e3 && _this22.sendSystemMessage(e3, {
              type: "ping"
            });
          }, this.pingUpdateTimeoutMs), this.pingV2UpdateTimeout = setInterval(this.sendPingV2, this.pingV2UpdateTimeoutMs), this.pingV2MetricsGatherTimeout = setInterval(this.gatherPingV2Metrics, this.pingV2MetricsGatherTimeoutMs), this.streamsInfoUpdateTimeout = setInterval(function () {
            var e3 = _this22.latestTtlStreamChannel;
            e3 && _this22.sendSystemMessage(e3, {
              type: "streams-info"
            });
          }, this.streamsInfoUpdateTimeoutMs), this.reassemblyTableCleanupTimeout = setInterval(function () {
            var e3 = new Date().getTime();
            _this22.reassemblyTableLastTimestamp.forEach(function (t3, r3, n3) {
              e3 > r3 + _this22.reassemblyTimeoutMs && _this22.reassemblyTable.delete(t3);
            });
          }, this.reassemblyTableCleanupMs), this.heartbeatTimeout = setInterval(function () {
            var e3 = _this22.heartbeatChannel;
            e3 && "open" === e3.readyState && e3.send(new Uint8Array([1]));
          }, this.heartbeatTimeoutMs);
        }
        _createClass(se, [{
          key: "handleSignal",
          value: function handleSignal(e2) {
            return ie(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
              var t2, r2, n2, o2, i2, s2, a3, o3, i3;
              return _regeneratorRuntime().wrap(function _callee48$(_context54) {
                while (1) switch (_context54.prev = _context54.next) {
                  case 0:
                    t2 = this.peerConnection, r2 = this.config.baseConfig.track, n2 = function () {
                      try {
                        return JSON.parse(e2.getPayload());
                      } catch (e3) {
                        return;
                      }
                    }();
                    if (n2) {
                      _context54.next = 3;
                      break;
                    }
                    return _context54.abrupt("return", void h.a.error("Received unparseable signal."));
                  case 3:
                    h.a.debug("Handling signal", {
                      description: n2
                    });
                    o2 = n2.sdp, i2 = n2.type;
                    if (!(!o2 || !i2)) {
                      _context54.next = 7;
                      break;
                    }
                    return _context54.abrupt("return", void h.a.warn("Received non-SDP signal"));
                  case 7:
                    s2 = t2.signalingState, a3 = t2.connectionState;
                    if (!("stable" !== s2 || "connected" !== a3)) {
                      _context54.next = 32;
                      break;
                    }
                    if (!t2.remoteDescription) {
                      _context54.next = 13;
                      break;
                    }
                    h.a.warn("Received SDP after remote description was set: ".concat(o2));
                    _context54.next = 30;
                    break;
                  case 13:
                    if (!("offer" === i2)) {
                      _context54.next = 25;
                      break;
                    }
                    if (!("stable" !== s2)) {
                      _context54.next = 16;
                      break;
                    }
                    return _context54.abrupt("return", void h.a.warn("Received offer SDP when signaling is ongoing."));
                  case 16:
                    _context54.next = 18;
                    return t2.setRemoteDescription(n2);
                  case 18:
                    _context54.next = 20;
                    return t2.createAnswer();
                  case 20:
                    o3 = _context54.sent;
                    _context54.next = 23;
                    return t2.setLocalDescription(o3);
                  case 23:
                    i3 = e2.clone();
                    return _context54.abrupt("return", (null == r2 || r2("Answer Received", i3), i3.setPayload(JSON.stringify(o3)), i3.setReceiverId(e2.getSenderId()), i3.setSenderId(e2.getReceiverId()), i3));
                  case 25:
                    if (!("answer" === i2)) {
                      _context54.next = 30;
                      break;
                    }
                    if (!("stable" === s2)) {
                      _context54.next = 28;
                      break;
                    }
                    return _context54.abrupt("return", void h.a.warn("Received answer SDP when signaling hasn't started."));
                  case 28:
                    _context54.next = 30;
                    return t2.setRemoteDescription(n2);
                  case 30:
                    _context54.next = 33;
                    break;
                  case 32:
                    h.a.warn("Received SDP when already connected: ".concat(o2));
                  case 33:
                  case "end":
                    return _context54.stop();
                }
              }, _callee48, this);
            }));
          }
        }, {
          key: "send",
          value: function send(e2, t2) {
            var r2 = this.getChannelFromLabel(t2.channelLabel);
            r2 ? this.sendOnChannel(r2, e2) : h.a.warn("Send called with unexpected channel label", {
              channelLabel: t2.channelLabel
            });
          }
        }, {
          key: "controlRemoteStream",
          value: function controlRemoteStream(e2) {
            this.sendSystemMessage(x(this.reliableStreamChannel), {
              type: "stream-control",
              streamControl: e2
            });
          }
        }, {
          key: "isActive",
          value: function isActive() {
            return /* @__PURE__ */new Set(["new", "checking", "connected", "completed"]).has(this.peerConnection.iceConnectionState) || this.isReady();
          }
        }, {
          key: "isReady",
          value: function isReady() {
            var e2 = this.reliableStreamChannel,
              t2 = this.latestTtlStreamChannel,
              r2 = this.latestTryOnceStreamChannel,
              n2 = this.latestReliableStreamChannel;
            return "open" === (null == e2 ? void 0 : e2.readyState) && "open" === (null == t2 ? void 0 : t2.readyState) && "open" === (null == r2 ? void 0 : r2.readyState) && "open" === (null == n2 ? void 0 : n2.readyState);
          }
        }, {
          key: "close",
          value: function close() {
            return ie(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
              var e2, t2, r2, n2, o2;
              return _regeneratorRuntime().wrap(function _callee49$(_context55) {
                while (1) switch (_context55.prev = _context55.next) {
                  case 0:
                    if (!this.closeCalled) {
                      _context55.next = 2;
                      break;
                    }
                    return _context55.abrupt("return");
                  case 2:
                    this.closeCalled = true;
                    _context55.t0 = this.sessionMetrics;
                    if (!_context55.t0) {
                      _context55.next = 7;
                      break;
                    }
                    _context55.next = 7;
                    return this.sessionMetrics.uploadMetrics();
                  case 7:
                    ae(this.pingUpdateTimeout);
                    ae(this.pingV2UpdateTimeout);
                    ae(this.pingV2MetricsGatherTimeout);
                    ae(this.reassemblyTableCleanupTimeout);
                    ae(this.streamsInfoUpdateTimeout);
                    ae(this.heartbeatTimeout);
                    e2 = this.peerConnection, t2 = this.reliableStreamChannel, r2 = this.latestTtlStreamChannel, n2 = this.latestTryOnceStreamChannel, o2 = this.latestReliableStreamChannel;
                    e2.close(), null == t2 || t2.close(), null == r2 || r2.close(), null == n2 || n2.close(), null == o2 || o2.close();
                  case 15:
                  case "end":
                    return _context55.stop();
                }
              }, _callee49, this);
            }));
          }
        }, {
          key: "getPing",
          value: function getPing() {
            return this.pingTimeMs;
          }
        }, {
          key: "getPingInfo",
          value: function getPingInfo() {
            return this.pingInfo;
          }
        }, {
          key: "getLastMessageTimestamp",
          value: function getLastMessageTimestamp() {
            return this.lastMessageTimestamp;
          }
        }, {
          key: "getSessionCreatedTimestamp",
          value: function getSessionCreatedTimestamp() {
            var e2;
            return null === (e2 = this.config.remoteConfig) || void 0 === e2 ? void 0 : e2.sessionCreatedTimestamp;
          }
        }, {
          key: "setSessionCreatedTimestamp",
          value: function setSessionCreatedTimestamp(e2) {
            this.config.remoteConfig && (this.config.remoteConfig.sessionCreatedTimestamp = e2);
          }
        }, {
          key: "getSessionId",
          value: function getSessionId() {
            var e2;
            return null === (e2 = this.config.remoteConfig) || void 0 === e2 ? void 0 : e2.sessionId;
          }
        }, {
          key: "setSessionId",
          value: function setSessionId(e2) {
            this.config.remoteConfig && (this.config.remoteConfig.sessionId = e2, this.sessionMetrics = new te(e2, this));
          }
        }, {
          key: "getRemotePeerId",
          value: function getRemotePeerId() {
            return this.config.baseConfig.remotePeerId;
          }
        }, {
          key: "getRemoteDeviceId",
          value: function getRemoteDeviceId() {
            var e2;
            return null === (e2 = this.config.baseConfig) || void 0 === e2 ? void 0 : e2.remoteDeviceId;
          }
        }, {
          key: "setRemoteDeviceId",
          value: function setRemoteDeviceId(e2) {
            this.config.baseConfig.remoteDeviceId = e2;
          }
        }, {
          key: "getSessionMetricsMessageCounts",
          value: function getSessionMetricsMessageCounts() {
            var e2;
            return null === (e2 = this.sessionMetrics) || void 0 === e2 ? void 0 : e2.counts;
          }
        }, {
          key: "getConnectionStatsInfo",
          value: function getConnectionStatsInfo() {
            return ie(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
              var e2, t2, r2, n2, o2, i2, s2;
              return _regeneratorRuntime().wrap(function _callee50$(_context56) {
                while (1) switch (_context56.prev = _context56.next) {
                  case 0:
                    e2 = this.peerConnection;
                    if (e2) {
                      _context56.next = 3;
                      break;
                    }
                    return _context56.abrupt("return");
                  case 3:
                    _context56.next = 5;
                    return e2.getStats(null);
                  case 5:
                    t2 = _context56.sent;
                    r2 = [];
                    t2.forEach(function (e3) {
                      r2.push(e3);
                    });
                    n2 = r2.find(function (e3) {
                      return "transport" === e3.type;
                    });
                    if (n2) {
                      _context56.next = 11;
                      break;
                    }
                    return _context56.abrupt("return");
                  case 11:
                    o2 = r2.find(function (e3) {
                      return ("candidate-pair" === e3.type || "candidatepair" === e3.type) && e3.id === n2.selectedCandidatePairId;
                    });
                    if (o2) {
                      _context56.next = 14;
                      break;
                    }
                    return _context56.abrupt("return");
                  case 14:
                    i2 = r2.find(function (e3) {
                      return e3.id === o2.localCandidateId;
                    }), s2 = r2.find(function (e3) {
                      return e3.id === o2.remoteCandidateId;
                    });
                    return _context56.abrupt("return", i2 && s2 && (i2.address = i2.address || i2.ip, s2.address = s2.address || s2.ip, void 0 !== i2.address && void 0 !== s2.address) ? {
                      transport: n2,
                      localCandidate: i2,
                      remoteCandidate: s2
                    } : void 0);
                  case 16:
                  case "end":
                    return _context56.stop();
                }
              }, _callee50, this);
            }));
          }
        }, {
          key: "initializeChannels",
          value: function initializeChannels(e2) {
            this.heartbeatChannel = e2.createDataChannel("heartbeat", Z), this.heartbeatChannel.binaryType = "arraybuffer", this.latestTtlStreamChannel = e2.createDataChannel("stream.latest-ttl", z), this.latestTtlStreamChannel.binaryType = "arraybuffer", this.reliableStreamChannel = e2.createDataChannel("stream.reliable", G), this.reliableStreamChannel.binaryType = "arraybuffer", this.latestReliableStreamChannel = e2.createDataChannel("stream.latest-reliable", q), this.latestReliableStreamChannel.binaryType = "arraybuffer", this.latestTryOnceStreamChannel = e2.createDataChannel("stream.latest-try-once", Y), this.latestTryOnceStreamChannel.binaryType = "arraybuffer", this.setupChannel(this.latestTtlStreamChannel), this.setupChannel(this.reliableStreamChannel), this.setupChannel(this.latestReliableStreamChannel), this.setupChannel(this.latestTryOnceStreamChannel);
          }
        }, {
          key: "getOffer",
          value: function getOffer() {
            var e2, t2, r2;
            return ie(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
              var _this23 = this;
              var n2, o2, i2, s2, a3, g2, e3, c2, _iterator15, _step15, _e3, f2, p2;
              return _regeneratorRuntime().wrap(function _callee52$(_context58) {
                while (1) switch (_context58.prev = _context58.next) {
                  case 0:
                    n2 = this.gotOffer, o2 = this.peerConnection, i2 = this.config;
                    if (!this.config.baseConfig.isLan) {
                      _context58.next = 3;
                      break;
                    }
                    throw new Error('"getOffer" method can only be called with internet connections. LAN connections should call the "getLanOffer" method.');
                  case 3:
                    s2 = null === (e2 = this.config.remoteConfig) || void 0 === e2 ? void 0 : e2.sessionId;
                    if (!n2) {
                      _context58.next = 6;
                      break;
                    }
                    return _context58.abrupt("return", void h.a.debug("Failed to generate offer because gotOffer was already called."));
                  case 6:
                    if (!(this.gotOffer = true, ne(this.peerConnection))) {
                      _context58.next = 8;
                      break;
                    }
                    return _context58.abrupt("return", void h.a.debug("Failed to generate offer because the peer connection was inactive."));
                  case 8:
                    a3 = i2.baseConfig.track;
                    o2.onicecandidate = function () {
                      _this23.hasIceCandidate = true;
                    };
                    o2.oniceconnectionstatechange = function () {
                      return ie(_this23, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
                        var e3, _t18, r3;
                        return _regeneratorRuntime().wrap(function _callee51$(_context57) {
                          while (1) switch (_context57.prev = _context57.next) {
                            case 0:
                              e3 = o2.iceConnectionState;
                              if (!("connected" === e3 || "completed" === e3)) {
                                _context57.next = 7;
                                break;
                              }
                              _context57.next = 4;
                              return this.getConnectionStatsInfo();
                            case 4:
                              _t18 = _context57.sent;
                              r3 = _t18 ? function (e4) {
                                var t4 = e4.localCandidate.candidateType,
                                  r4 = e4.remoteCandidate.candidateType;
                                return "host" === t4 && "host" === r4 ? "local" : "relay" === t4 || "relay" === r4 ? "TURN" : "STUN";
                              }(_t18) : void 0;
                              h.a.info("ICE connection state changed to ".concat(e3), {
                                sessionId: s2,
                                connectionStatsInfo: _t18,
                                iceMode: r3
                              }), null == a3 || a3("ICE connection state change", {
                                iceConnectionState: e3,
                                sessionId: s2,
                                connectionStatsInfo: _t18,
                                iceMode: r3
                              });
                            case 7:
                            case "end":
                              return _context57.stop();
                          }
                        }, _callee51, this);
                      }));
                    };
                    _context58.t0 = o2;
                    _context58.next = 14;
                    return o2.createOffer();
                  case 14:
                    _context58.t1 = _context58.sent;
                    _context58.next = 17;
                    return _context58.t0.setLocalDescription.call(_context58.t0, _context58.t1);
                  case 17:
                    g2 = new Date().getTime();
                  case 18:
                    e3 = new Date().getTime() - g2;
                    if (!(e3 > this.connectTimeoutMs)) {
                      _context58.next = 21;
                      break;
                    }
                    return _context58.abrupt("return", void h.a.debug("Failed to generate offer because ICE gathering timed out."));
                  case 21:
                    if (!(e3 > this.iceGatheringTimeoutMs && this.hasIceCandidate)) {
                      _context58.next = 24;
                      break;
                    }
                    h.a.debug("ICE gathering partially completed; proceeding", {
                      iceTransportPolicy: o2.getConfiguration().iceTransportPolicy,
                      waitTime: e3
                    }), null == a3 || a3("ICE gathering partially completed", {
                      sessionId: s2,
                      iceTransportPolicy: o2.getConfiguration().iceTransportPolicy,
                      waitTime: e3
                    });
                    return _context58.abrupt("break", 31);
                  case 24:
                    if (!("complete" === o2.iceGatheringState)) {
                      _context58.next = 27;
                      break;
                    }
                    h.a.debug("ICE gathering complete", {
                      iceTransportPolicy: o2.getConfiguration().iceTransportPolicy,
                      waitTime: e3
                    }), null == a3 || a3("ICE gathering completed", {
                      sessionId: s2,
                      iceTransportPolicy: o2.getConfiguration().iceTransportPolicy,
                      waitTime: e3
                    });
                    return _context58.abrupt("break", 31);
                  case 27:
                    _context58.next = 29;
                    return Object(u.a)(0.1 * l.a.second);
                  case 29:
                    _context58.next = 18;
                    break;
                  case 31:
                    c2 = null !== (t2 = this.peerConnection.getConfiguration().iceServers) && void 0 !== t2 ? t2 : [];
                    _iterator15 = _createForOfIteratorHelper(c2);
                    try {
                      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                        _e3 = _step15.value;
                        _e3.credentialType = void 0;
                      }
                    } catch (err) {
                      _iterator15.e(err);
                    } finally {
                      _iterator15.f();
                    }
                    f2 = JSON.stringify(c2), p2 = new F.Signal();
                    return _context58.abrupt("return", (p2.setPayload(JSON.stringify(o2.localDescription)), p2.setSenderId(this.config.baseConfig.localPeerId), p2.setReceiverId(this.config.baseConfig.remotePeerId), p2.setIceServers(f2), p2.setIceTransportPolicy(null !== (r2 = this.peerConnection.getConfiguration().iceTransportPolicy) && void 0 !== r2 ? r2 : "all"), void 0 !== this.config.baseConfig.sessionType ? p2.setSessionType(this.config.baseConfig.sessionType) : p2.setSessionType(F.SessionType.TELEOP), h.a.debug("Sending offer signal with description", {
                      description: p2.getPayload()
                    }), p2));
                  case 36:
                  case "end":
                    return _context58.stop();
                }
              }, _callee52, this);
            }));
          }
        }, {
          key: "getLanOffer",
          value: function getLanOffer() {
            return ie(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
              var e2, t2, r2, n2;
              return _regeneratorRuntime().wrap(function _callee53$(_context59) {
                while (1) switch (_context59.prev = _context59.next) {
                  case 0:
                    e2 = this.peerConnection, t2 = this.gotOffer;
                    if (this.config.baseConfig.isLan) {
                      _context59.next = 3;
                      break;
                    }
                    throw new Error('"getLanOffer" method can only be used with LAN connections. Internet connections should call the "getOffer" method.');
                  case 3:
                    if (!t2) {
                      _context59.next = 5;
                      break;
                    }
                    return _context59.abrupt("return", void h.a.debug("Failed to generate offer because gotOffer was already called."));
                  case 5:
                    if (!(this.gotOffer = true, ne(this.peerConnection))) {
                      _context59.next = 7;
                      break;
                    }
                    return _context59.abrupt("return", void h.a.debug("Failed to generate offer because the peer connection was inactive."));
                  case 7:
                    _context59.t0 = e2;
                    _context59.next = 10;
                    return e2.createOffer();
                  case 10:
                    _context59.t1 = _context59.sent;
                    _context59.next = 13;
                    return _context59.t0.setLocalDescription.call(_context59.t0, _context59.t1);
                  case 13:
                    r2 = new Date().getTime();
                  case 14:
                    if (!(new Date().getTime() - r2 > this.iceGatheringTimeoutMs)) {
                      _context59.next = 16;
                      break;
                    }
                    return _context59.abrupt("return", void h.a.debug("Failed to generate offer because ICE gathering timed out."));
                  case 16:
                    if (!("complete" === e2.iceGatheringState)) {
                      _context59.next = 18;
                      break;
                    }
                    return _context59.abrupt("break", 22);
                  case 18:
                    _context59.next = 20;
                    return Object(u.a)(0.1 * l.a.second);
                  case 20:
                    _context59.next = 14;
                    break;
                  case 22:
                    n2 = e2.localDescription;
                    if (!n2) {
                      _context59.next = 25;
                      break;
                    }
                    return _context59.abrupt("return", (h.a.debug("Sending LAN offer signal with description", {
                      description: n2
                    }), n2));
                  case 25:
                    h.a.error("Failed to generate LAN offer description");
                  case 26:
                  case "end":
                    return _context59.stop();
                }
              }, _callee53, this);
            }));
          }
        }, {
          key: "handleLanAnswer",
          value: function handleLanAnswer(e2) {
            return ie(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
              var t2;
              return _regeneratorRuntime().wrap(function _callee54$(_context60) {
                while (1) switch (_context60.prev = _context60.next) {
                  case 0:
                    t2 = this.peerConnection;
                    if (this.config.baseConfig.isLan) {
                      _context60.next = 3;
                      break;
                    }
                    throw new Error('"handleLanAnswer" method can only be used with LAN connections. Internet connections should call the "handleSignal" method.');
                  case 3:
                    _context60.next = 5;
                    return t2.setRemoteDescription(e2);
                  case 5:
                  case "end":
                    return _context60.stop();
                }
              }, _callee54, this);
            }));
          }
        }, {
          key: "getChannelFromLabel",
          value: function getChannelFromLabel(e2) {
            switch (e2) {
              case "stream.latest-ttl":
                return this.latestTtlStreamChannel;
              case "stream.reliable":
                return this.reliableStreamChannel;
              case "stream.latest-reliable":
                return this.latestReliableStreamChannel;
              case "stream.latest-try-once":
                return this.latestTryOnceStreamChannel;
            }
          }
        }, {
          key: "sendOnChannel",
          value: function sendOnChannel(e2, t2) {
            var r2;
            try {
              r2 = Object(H.encode)(JSON.stringify(t2));
            } catch (e3) {
              return void h.a.warn("Failed to encode RTC message", {
                error: e3
              });
            }
            try {
              e2.send(r2), this.sessionMetrics && this.sessionMetrics.incrementLocalSent(t2);
            } catch (t3) {
              h.a.warn("Failed to send message to channel", {
                error: t3,
                channel: e2.label
              });
            }
          }
        }, {
          key: "channelNotRecognized",
          value: function channelNotRecognized(e2) {
            return e2 !== this.latestTtlStreamChannel && e2 !== this.latestReliableStreamChannel && e2 !== this.latestTryOnceStreamChannel && e2 !== this.reliableStreamChannel;
          }
        }, {
          key: "setupChannel",
          value: function setupChannel(e2) {
            var _this24 = this;
            e2.onmessage = function (t2) {
              if (_this24.channelNotRecognized(e2)) return void h.a.warn("Received message on unrecognized data channel.");
              var r2;
              try {
                r2 = JSON.parse(Object(H.decode)(t2.data));
              } catch (t3) {
                return void h.a.warn("Received unparseable message on RTC stream data channel", {
                  error: t3,
                  channel: e2.label
                });
              }
              "message-chunk" === r2.communicationType ? _this24.receiveChannelMessageChunk(e2, r2) : _this24.receiveChannelMessage(e2, r2);
            }, e2.onerror = function (t2) {
              h.a.warn("Channel error: ".concat(t2.error), {
                error: t2.error,
                sessionId: _this24.getSessionId(),
                channelLabel: e2.label
              });
            }, e2.onopen = function () {
              h.a.debug("Channel opened", {
                sessionId: _this24.getSessionId(),
                channelLabel: e2.label
              });
            }, e2.onclose = function () {
              var t2 = {
                bufferedAmount: e2.bufferedAmount,
                sessionId: _this24.getSessionId(),
                channelLabel: e2.label
              };
              false === _this24.closeCalled ? h.a.debug("Unexpected channel closed", t2) : h.a.debug("Channel closed", t2);
            };
          }
        }, {
          key: "receiveChannelMessage",
          value: function receiveChannelMessage(e2, t2) {
            var r2 = this.config,
              n2 = this.config.baseConfig.remotePeerId;
            this.lastMessageTimestamp = new Date().getTime(), t2 = oe(t2), this.sessionMetrics && this.sessionMetrics.incrementLocalReceived(t2), this.handleSystemMessage(e2, t2) || (e2 === this.latestTryOnceStreamChannel || e2 === this.latestTtlStreamChannel || e2 === this.latestReliableStreamChannel) && !this.isLatestMessage(t2) || r2.baseConfig.receive(n2, t2);
          }
        }, {
          key: "receiveChannelMessageChunk",
          value: function receiveChannelMessageChunk(e2, t2) {
            var r2 = this.reassemblyTable.get(t2.id) || [];
            if (r2.push(t2), r2.length === t2.total) {
              var n2 = function (e3) {
                var t3 = e3.sort(function (e4, t4) {
                  return e4.seq < t4.seq ? -1 : 1;
                }).map(function (e4) {
                  return e4.part;
                }).reduce(function (e4, t4) {
                  return e4 + t4;
                });
                try {
                  return JSON.parse(t3);
                } catch (e4) {
                  return void h.a.warn("Could not reassemble RTC message chunks");
                }
              }(r2);
              return n2 && this.receiveChannelMessage(e2, n2), void this.reassemblyTable.delete(t2.id);
            }
            this.reassemblyTable.set(t2.id, r2), this.reassemblyTableLastTimestamp.set(t2.id, new Date().getTime());
          }
        }, {
          key: "handleSystemMessage",
          value: function handleSystemMessage(e2, t2) {
            var r2, n2;
            var o2 = this.config,
              i2 = o2.baseConfig,
              s2 = i2.remotePeerId;
            switch (t2.header.stream.streamType) {
              case "ping":
                return this.sendSystemMessage(e2, {
                  type: "pong",
                  timestamp: x(t2.payload.ping)
                }), true;
              case "pong":
                {
                  var e3 = new Date().getTime() - x(t2.payload.pong);
                  return this.pingTimeMs = e3, R.aggregate("rtc-ping-time", e3), true;
                }
              case "ping-v2":
                return this.sendPingV2(), true;
              case "pong-v2":
                {
                  var _e4 = x(t2.payload.pongV2),
                    r3 = this.pingV2Map.get(_e4.id);
                  return (null == r3 ? void 0 : r3.sent) !== _e4.timestamp ? (h.a.warn("Pong timestamp doesn't match stored value", {
                    currentEntry: r3,
                    pong: _e4
                  }), true) : (this.pingV2Map.set(_e4.id, {
                    sent: _e4.timestamp,
                    received: new Date().getTime()
                  }), true);
                }
              case "streams-info":
                {
                  var _e5 = this.sessionMetrics,
                    o3 = null === (r2 = t2.payload.streamsInfo) || void 0 === r2 ? void 0 : r2.timestamp;
                  return !!o3 && (null == _e5 || _e5.updateRemoteMessagesCounts(t2), null === (n2 = i2.onStreamsInfoUpdate) || void 0 === n2 || n2.call(i2, s2, o3), true);
                }
              case "stream-control":
                return true;
              default:
                return false;
            }
          }
        }, {
          key: "sendSystemMessage",
          value: function sendSystemMessage(e2, t2) {
            var r2;
            var _this$config$baseConf = this.config.baseConfig,
              n2 = _this$config$baseConf.localUserId,
              o2 = _this$config$baseConf.localPeerId;
            if ("open" !== e2.readyState) return;
            var i2 = {
              entityId: null != n2 ? n2 : o2,
              streamName: "$.".concat(t2.type),
              streamType: t2.type
            };
            var s2;
            switch (t2.type) {
              case "ping":
                s2 = {
                  ping: new Date().getTime()
                };
                break;
              case "pong":
                s2 = {
                  pong: t2.timestamp
                };
                break;
              case "ping-v2":
                s2 = {
                  pingV2: t2.payload
                };
                break;
              case "pong-v2":
                s2 = {
                  pongV2: t2.payload
                };
                break;
              case "stream-control":
                s2 = {
                  streamControl: t2.streamControl
                };
                break;
              case "streams-info":
                s2 = {
                  streamsInfo: null === (r2 = this.sessionMetrics) || void 0 === r2 ? void 0 : r2.getLocalStreamsInfo(new Date().getTime())
                };
            }
            this.sendOnChannel(e2, re(i2, s2));
          }
        }, {
          key: "isLatestMessage",
          value: function isLatestMessage(e2) {
            var t2 = Q(e2.header.stream),
              r2 = (this.streamLatestTimestamp.get(t2) || 0) <= e2.header.created;
            return r2 && this.streamLatestTimestamp.set(t2, e2.header.created), r2;
          }
        }]);
        return se;
      }();
      function ae(e2) {
        e2 && clearInterval(e2);
      }
      function le(e2) {
        var t2, r2;
        return {
          userId: null === (t2 = e2.getUserId()) || void 0 === t2 ? void 0 : t2.getValue(),
          deviceId: null === (r2 = e2.getDeviceId()) || void 0 === r2 ? void 0 : r2.getValue(),
          organizationId: e2.getOrganizationId(),
          id: e2.getPeerId(),
          capabilities: [],
          capabilitySet: {}
        };
      }
      var ue = function ue(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      var ge = /*#__PURE__*/function () {
        function ge(e2) {
          var _this25 = this;
          _classCallCheck(this, ge);
          this.config = e2, this.grpcCallDeadline = 5 * l.a.second, this.refreshIntervalDelayMs = 2 * l.a.second, this.iceServersTtl = 30 * l.a.minute, this.connections = [], this.localConnections = [], this.isConnectionInitiator = /* @__PURE__ */new Map(), this.isOutgoingConnection = /* @__PURE__ */new Map(), this.peerDataChannelListeners = [];
          var t2 = this.refreshIntervalDelayMs;
          this.refreshInterval = S({
            func: function func() {
              return ue(_this25, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
                return _regeneratorRuntime().wrap(function _callee55$(_context61) {
                  while (1) switch (_context61.prev = _context61.next) {
                    case 0:
                      _context61.prev = 0;
                      _context61.next = 3;
                      return this.update();
                    case 3:
                      _context61.next = 8;
                      break;
                    case 5:
                      _context61.prev = 5;
                      _context61.t0 = _context61["catch"](0);
                      h.a.warn("RTC refresh failed", {
                        error: _context61.t0
                      });
                    case 8:
                    case "end":
                      return _context61.stop();
                  }
                }, _callee55, this, [[0, 5]]);
              }));
            },
            delay: t2,
            immediate: true
          });
        }
        _createClass(ge, [{
          key: "send",
          value: function send(e2, t2, r2) {
            var n2 = this.getActiveConnection(e2);
            n2 ? n2.isReady() ? n2.send(t2, r2) : h.a.warn("Send called with unready connection.") : h.a.warn("Send called with no connection.");
          }
        }, {
          key: "controlRemoteStream",
          value: function controlRemoteStream(e2, t2) {
            var r2 = this.getActiveConnection(e2);
            r2 ? r2.isReady() ? r2.controlRemoteStream(t2) : h.a.warn("controlRemoteStream called with unready connection.") : h.a.warn("controlRemoteStream called with no connection.");
          }
        }, {
          key: "getLocalPeer",
          value: function getLocalPeer() {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
              return _regeneratorRuntime().wrap(function _callee56$(_context62) {
                while (1) switch (_context62.prev = _context62.next) {
                  case 0:
                    if (this.localPeer) {
                      _context62.next = 5;
                      break;
                    }
                    _context62.next = 3;
                    return Object(u.a)(0.1 * l.a.second);
                  case 3:
                    _context62.next = 0;
                    break;
                  case 5:
                    return _context62.abrupt("return", le(this.localPeer));
                  case 6:
                  case "end":
                    return _context62.stop();
                }
              }, _callee56, this);
            }));
          }
        }, {
          key: "connect",
          value: function connect(e2, t2) {
            var r2, n2, o2;
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
              var _this26 = this;
              var _this$config, i2, s2, a3, l2, u2, g2, c2, f2, p2, d2, y2, m2;
              return _regeneratorRuntime().wrap(function _callee58$(_context64) {
                while (1) switch (_context64.prev = _context64.next) {
                  case 0:
                    if (!(true === this.config.lanOnlyMode)) {
                      _context64.next = 2;
                      break;
                    }
                    throw new Error("connect method called in local only mode.");
                  case 2:
                    _this$config = this.config, i2 = _this$config.track, s2 = _this$config.signalingClient, a3 = this.localPeer, l2 = this.receiveSignalStream, u2 = this.iceServers;
                    if (!(!a3 || !l2 || !u2)) {
                      _context64.next = 5;
                      break;
                    }
                    return _context64.abrupt("return", void h.a.warn("Connect called prior to local peer, receiveSignalStream, and ICE servers ready"));
                  case 5:
                    if (!this.getActiveConnection(e2)) {
                      _context64.next = 7;
                      break;
                    }
                    return _context64.abrupt("return", void h.a.warn("Connect called for peer with existing connection."));
                  case 7:
                    if (!this.isOutgoingConnection.get(e2)) {
                      _context64.next = 9;
                      break;
                    }
                    return _context64.abrupt("return", void h.a.warn("Connect called for peer with an existing outgoing connection offer."));
                  case 9:
                    this.isOutgoingConnection.set(e2, true);
                    g2 = function (e3, t3, r3) {
                      var _ref24 = t3 || {},
                        n3 = _ref24.rtcIceTransportPolicies,
                        o3 = _ref24.rtcIceServerProtocol,
                        i3 = _ref24.useAllServers,
                        s3 = e3.map(function (e4) {
                          return Object.assign(Object.assign({}, e4), {
                            urls: e4.urls.filter(function (e5) {
                              var t4 = (void 0 === n3 || n3.some(function (t5) {
                                return B(e5, t5);
                              })) && (void 0 === o3 || k(e5, o3));
                              return t4 || h.a.debug("Ignoring ICE server: ".concat(e5), {
                                organizationId: r3
                              }), t4;
                            })
                          });
                        }).filter(function (_ref25) {
                          var e4 = _ref25.urls;
                          return e4.filter(function (e5) {
                            return e5;
                          }).length > 0;
                        });
                      return i3 ? s3 : [U(s3, "stun"), U(s3, "turn")].filter(function (e4) {
                        return void 0 !== e4;
                      }).map(function (e4) {
                        return x(e4);
                      });
                    }(u2, t2);
                    h.a.debug("Received ICE servers:", u2), h.a.debug("Using ICE servers:", g2);
                    _context64.t0 = se;
                    _context64.next = 15;
                    return this.createRTCPeerConnection(g2);
                  case 15:
                    _context64.t1 = _context64.sent;
                    _context64.t2 = {
                      baseConfig: {
                        isOffer: true,
                        isLan: false,
                        receive: function receive(e3, t3) {
                          return _this26.config.receive(e3, t3);
                        },
                        onStreamsInfoUpdate: this.config.onStreamsInfoUpdate ? function (e3, t3) {
                          var r3, n3;
                          return null === (n3 = (r3 = _this26.config).onStreamsInfoUpdate) || void 0 === n3 ? void 0 : n3.call(r3, e3, t3);
                        } : void 0,
                        track: this.config.lanOnlyMode ? void 0 : this.config.track,
                        localUserId: null === (r2 = a3.getUserId()) || void 0 === r2 ? void 0 : r2.getValue(),
                        localPeerId: a3.getPeerId(),
                        remotePeerId: e2,
                        sessionType: this.config.sessionType
                      },
                      remoteConfig: {}
                    };
                    _context64.t3 = function (t3) {
                      return _this26.onCustomDataChannel(e2, t3);
                    };
                    c2 = new _context64.t0(_context64.t1, _context64.t2, _context64.t3);
                    _context64.next = 21;
                    return c2.getOffer();
                  case 21:
                    f2 = _context64.sent;
                    if (f2) {
                      _context64.next = 24;
                      break;
                    }
                    return _context64.abrupt("return", (h.a.error("Failed to generate offer."), void this.isOutgoingConnection.delete(e2)));
                  case 24:
                    h.a.debug("Sending offer."), null == i2 || i2("Sending offer", f2);
                    p2 = new F.SendSignalRequest();
                    p2.setSignal(f2);
                    _context64.next = 29;
                    return function () {
                      return ue(_this26, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
                        return _regeneratorRuntime().wrap(function _callee57$(_context63) {
                          while (1) switch (_context63.prev = _context63.next) {
                            case 0:
                              _context63.prev = 0;
                              _context63.t0 = s2;
                              _context63.t1 = p2;
                              _context63.next = 5;
                              return this.getMetadata({});
                            case 5:
                              _context63.t2 = _context63.sent;
                              _context63.next = 8;
                              return _context63.t0.sendSignal.call(_context63.t0, _context63.t1, _context63.t2);
                            case 8:
                              return _context63.abrupt("return", _context63.sent);
                            case 11:
                              _context63.prev = 11;
                              _context63.t3 = _context63["catch"](0);
                              h.a.warn("Error when sending signal", {
                                error: _context63.t3
                              });
                            case 14:
                            case "end":
                              return _context63.stop();
                          }
                        }, _callee57, this, [[0, 11]]);
                      }));
                    }();
                  case 29:
                    d2 = _context64.sent;
                    if (this.isOutgoingConnection.get(e2)) {
                      _context64.next = 32;
                      break;
                    }
                    return _context64.abrupt("return", void h.a.debug("No offer set after receiving offer signal response."));
                  case 32:
                    h.a.debug("Offer sent.");
                    y2 = null === (n2 = null == d2 ? void 0 : d2.getSessionId()) || void 0 === n2 ? void 0 : n2.getValue(), m2 = null === (o2 = null == d2 ? void 0 : d2.getSessionCreatedTimestamp()) || void 0 === o2 ? void 0 : o2.getValue();
                    return _context64.abrupt("return", y2 && m2 ? (c2.setSessionId(y2), c2.setSessionCreatedTimestamp(m2), this.isOutgoingConnection.delete(e2), this.connections.push(c2), this.isConnectionInitiator.set(c2, true), this.setupHandlers(c2), y2) : (h.a.warn("No session ID or no session created timestamp on send signal response."), void this.isOutgoingConnection.delete(e2)));
                  case 35:
                  case "end":
                    return _context64.stop();
                }
              }, _callee58, this);
            }));
          }
        }, {
          key: "connectLan",
          value: function connectLan(e2) {
            var t2, r2;
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
              var _this27 = this;
              var n2, o2, i2, s2, a3;
              return _regeneratorRuntime().wrap(function _callee59$(_context65) {
                while (1) switch (_context65.prev = _context65.next) {
                  case 0:
                    n2 = new N(e2);
                    _context65.t0 = se;
                    _context65.next = 4;
                    return this.createRTCPeerConnection([]);
                  case 4:
                    _context65.t1 = _context65.sent;
                    _context65.t2 = {
                      baseConfig: {
                        isOffer: true,
                        isLan: true,
                        receive: function receive(e3, t3) {
                          return _this27.config.receive(e3, t3);
                        },
                        onStreamsInfoUpdate: this.config.onStreamsInfoUpdate ? function (e3, t3) {
                          var r3, n3;
                          return null === (n3 = (r3 = _this27.config).onStreamsInfoUpdate) || void 0 === n3 ? void 0 : n3.call(r3, e3, t3);
                        } : void 0,
                        track: this.config.lanOnlyMode ? void 0 : this.config.track,
                        localUserId: null === (r2 = null === (t2 = this.localPeer) || void 0 === t2 ? void 0 : t2.getUserId()) || void 0 === r2 ? void 0 : r2.getValue(),
                        localPeerId: "lan_client",
                        remotePeerId: e2
                      }
                    };
                    _context65.t3 = function (t3) {
                      return _this27.onCustomDataChannel(e2, t3);
                    };
                    o2 = new _context65.t0(_context65.t1, _context65.t2, _context65.t3);
                    _context65.next = 10;
                    return o2.getLanOffer();
                  case 10:
                    i2 = _context65.sent;
                    if (i2) {
                      _context65.next = 13;
                      break;
                    }
                    return _context65.abrupt("return", (h.a.warn("Could not generate LAN offer"), false));
                  case 13:
                    _context65.next = 15;
                    return n2.postLanRtcOffer({
                      offer: JSON.stringify(i2)
                    });
                  case 15:
                    s2 = _context65.sent;
                    a3 = new RTCSessionDescription(JSON.parse(s2.answer));
                    _context65.next = 19;
                    return o2.handleLanAnswer(a3);
                  case 19:
                    this.localConnections.push(o2);
                    this.isConnectionInitiator.set(o2, true);
                    return _context65.abrupt("return", Object(V.a)());
                  case 22:
                  case "end":
                    return _context65.stop();
                }
              }, _callee59, this);
            }));
          }
        }, {
          key: "getConnections",
          value: function getConnections() {
            return [].concat(_toConsumableArray(this.connections), _toConsumableArray(this.localConnections));
          }
        }, {
          key: "createCustomDataChannel",
          value: function createCustomDataChannel(e2, t2, r2, n2, o2) {
            var _this28 = this;
            var i2 = this.getActiveConnection(e2);
            if (i2 && this.isConnectionInitiator.has(i2)) {
              var s3 = i2.peerConnection.createDataChannel("custom." + t2, r2);
              return n2 && (s3.binaryType = "arraybuffer"), o2(e2, s3), function () {};
            }
            var s2 = function s2(r3, n3) {
              e2 === r3 && n3.label === "custom." + t2 && o2(e2, n3);
            };
            return this.peerDataChannelListeners.push(s2), function () {
              _this28.peerDataChannelListeners = _this28.peerDataChannelListeners.filter(function (e3) {
                return e3 !== s2;
              });
            };
          }
        }, {
          key: "onCustomDataChannel",
          value: function onCustomDataChannel(e2, t2) {
            this.peerDataChannelListeners.forEach(function (r2) {
              return r2(e2, t2);
            });
          }
        }, {
          key: "getConnectionStatus",
          value: function getConnectionStatus(e2) {
            if (this.isOutgoingConnection.get(e2)) return "connecting";
            var t2 = this.getActiveConnection(e2);
            return t2 ? t2.isReady() ? "connected" : "connecting" : "disconnected";
          }
        }, {
          key: "getConnectionStatsInfo",
          value: function getConnectionStatsInfo(e2) {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
              var t2;
              return _regeneratorRuntime().wrap(function _callee60$(_context66) {
                while (1) switch (_context66.prev = _context66.next) {
                  case 0:
                    t2 = this.getActiveConnection(e2);
                    if (!t2) {
                      _context66.next = 5;
                      break;
                    }
                    _context66.next = 4;
                    return t2.getConnectionStatsInfo();
                  case 4:
                    return _context66.abrupt("return", _context66.sent);
                  case 5:
                  case "end":
                    return _context66.stop();
                }
              }, _callee60, this);
            }));
          }
        }, {
          key: "disconnect",
          value: function disconnect(e2) {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
              var t2;
              return _regeneratorRuntime().wrap(function _callee61$(_context67) {
                while (1) switch (_context67.prev = _context67.next) {
                  case 0:
                    t2 = this.getActiveConnection(e2);
                    _context67.t0 = t2;
                    if (!_context67.t0) {
                      _context67.next = 5;
                      break;
                    }
                    _context67.next = 5;
                    return t2.close();
                  case 5:
                  case "end":
                    return _context67.stop();
                }
              }, _callee61, this);
            }));
          }
        }, {
          key: "getPeers",
          value: function getPeers() {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
              var _this29 = this;
              var e2, t2, r2, n2;
              return _regeneratorRuntime().wrap(function _callee63$(_context69) {
                while (1) switch (_context69.prev = _context69.next) {
                  case 0:
                    if (!this.config.lanOnlyMode) {
                      _context69.next = 2;
                      break;
                    }
                    throw new Error("getPeers method cannot be used in local-only mode.");
                  case 2:
                    e2 = this.config.signalingClient;
                    _context69.next = 5;
                    return function () {
                      return ue(_this29, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee62() {
                        return _regeneratorRuntime().wrap(function _callee62$(_context68) {
                          while (1) switch (_context68.prev = _context68.next) {
                            case 0:
                              _context68.prev = 0;
                              _context68.t0 = e2;
                              _context68.t1 = new F.GetPeersRequest();
                              _context68.next = 5;
                              return this.getMetadata({});
                            case 5:
                              _context68.t2 = _context68.sent;
                              _context68.next = 8;
                              return _context68.t0.getPeers.call(_context68.t0, _context68.t1, _context68.t2);
                            case 8:
                              return _context68.abrupt("return", _context68.sent);
                            case 11:
                              _context68.prev = 11;
                              _context68.t3 = _context68["catch"](0);
                              h.a.warn("Error when getting peers", {
                                error: _context68.t3
                              });
                            case 14:
                            case "end":
                              return _context68.stop();
                          }
                        }, _callee62, this, [[0, 11]]);
                      }));
                    }();
                  case 5:
                    t2 = _context69.sent;
                    if (t2) {
                      _context69.next = 8;
                      break;
                    }
                    return _context69.abrupt("return", []);
                  case 8:
                    r2 = t2.getPeersList();
                    if (r2) {
                      _context69.next = 11;
                      break;
                    }
                    return _context69.abrupt("return", []);
                  case 11:
                    n2 = function n2(e3) {
                      var t3, r3;
                      return null !== (r3 = null === (t3 = e3.getPeerCreatedTimestamp()) || void 0 === t3 ? void 0 : t3.getValue()) && void 0 !== r3 ? r3 : 0;
                    };
                    return _context69.abrupt("return", r2.sort(function (e3, t3) {
                      return n2(t3) - n2(e3);
                    }).map(function (e3) {
                      return le(e3);
                    }));
                  case 13:
                  case "end":
                    return _context69.stop();
                }
              }, _callee63, this);
            }));
          }
        }, {
          key: "getSessions",
          value: function getSessions() {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
              var _this30 = this;
              var e2, t2, r2, n2, _iterator16, _step16, e3;
              return _regeneratorRuntime().wrap(function _callee65$(_context71) {
                while (1) switch (_context71.prev = _context71.next) {
                  case 0:
                    if (!this.config.lanOnlyMode) {
                      _context71.next = 2;
                      break;
                    }
                    throw new Error("getPeers method cannot be used in local-only mode.");
                  case 2:
                    e2 = this.config.signalingClient;
                    _context71.next = 5;
                    return function () {
                      return ue(_this30, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
                        return _regeneratorRuntime().wrap(function _callee64$(_context70) {
                          while (1) switch (_context70.prev = _context70.next) {
                            case 0:
                              _context70.prev = 0;
                              _context70.t0 = e2;
                              _context70.t1 = new F.GetPeersRequest();
                              _context70.next = 5;
                              return this.getMetadata({});
                            case 5:
                              _context70.t2 = _context70.sent;
                              _context70.next = 8;
                              return _context70.t0.getPeers.call(_context70.t0, _context70.t1, _context70.t2);
                            case 8:
                              return _context70.abrupt("return", _context70.sent);
                            case 11:
                              _context70.prev = 11;
                              _context70.t3 = _context70["catch"](0);
                              h.a.warn("Error when getting peers", {
                                error: _context70.t3
                              });
                            case 14:
                            case "end":
                              return _context70.stop();
                          }
                        }, _callee64, this, [[0, 11]]);
                      }));
                    }();
                  case 5:
                    t2 = _context71.sent;
                    if (t2) {
                      _context71.next = 8;
                      break;
                    }
                    return _context71.abrupt("return", {});
                  case 8:
                    r2 = t2.getPeersList(), n2 = {};
                    _iterator16 = _createForOfIteratorHelper(r2);
                    try {
                      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                        e3 = _step16.value;
                        n2[e3.getPeerId()] = e3.getSessionIdsList();
                      }
                    } catch (err) {
                      _iterator16.e(err);
                    } finally {
                      _iterator16.f();
                    }
                    return _context71.abrupt("return", n2);
                  case 12:
                  case "end":
                    return _context71.stop();
                }
              }, _callee65, this);
            }));
          }
        }, {
          key: "getPing",
          value: function getPing(e2) {
            var t2 = this.getActiveConnection(e2);
            if (t2) return t2.getPing();
            h.a.warn("Attempted to get ping time from inactive peer.");
          }
        }, {
          key: "getPingInfo",
          value: function getPingInfo(e2) {
            var t2 = this.getActiveConnection(e2);
            if (t2) return t2.getPingInfo();
            h.a.warn("Attempted to get ping time from inactive peer.");
          }
        }, {
          key: "getLastMessageTimestamp",
          value: function getLastMessageTimestamp(e2) {
            var t2 = this.getActiveConnection(e2);
            if (t2) return t2.getLastMessageTimestamp();
            h.a.warn("Attempted to get last message time from inactive peer.");
          }
        }, {
          key: "getSessionMetricsMessageCounts",
          value: function getSessionMetricsMessageCounts(e2) {
            var t2 = this.getActiveConnection(e2);
            if (t2) return t2.getSessionMetricsMessageCounts();
            h.a.warn("Attempted to get session metrics counts from inactive peer.");
          }
        }, {
          key: "isReady",
          value: function isReady() {
            if (this.config.lanOnlyMode) return true;
            var e2 = this.localPeer,
              t2 = this.receiveSignalStream,
              r2 = this.iceServers;
            return !!(e2 && t2 && r2);
          }
        }, {
          key: "shutdown",
          value: function shutdown() {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
              var _this31 = this;
              var e2, t2, r2;
              return _regeneratorRuntime().wrap(function _callee67$(_context73) {
                while (1) switch (_context73.prev = _context73.next) {
                  case 0:
                    h.a.info("Shutdown called on RTC client");
                    _context73.next = 3;
                    return this.refreshInterval.stop();
                  case 3:
                    this.receiveSignalStream && this.receiveSignalStream.cancel();
                    e2 = this.connections;
                    this.connections = [];
                    _context73.next = 8;
                    return this.closeConnections(e2);
                  case 8:
                    t2 = this.localPeer;
                    if (t2) {
                      _context73.next = 11;
                      break;
                    }
                    return _context73.abrupt("return");
                  case 11:
                    if (!this.config.lanOnlyMode) {
                      _context73.next = 13;
                      break;
                    }
                    return _context73.abrupt("return");
                  case 13:
                    r2 = this.config.signalingClient;
                    _context73.next = 16;
                    return function () {
                      return ue(_this31, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee66() {
                        var e3;
                        return _regeneratorRuntime().wrap(function _callee66$(_context72) {
                          while (1) switch (_context72.prev = _context72.next) {
                            case 0:
                              _context72.prev = 0;
                              e3 = new F.DeletePeerRequest();
                              e3.setPeerId(t2.getPeerId());
                              _context72.t0 = r2;
                              _context72.t1 = e3;
                              _context72.next = 7;
                              return this.getMetadata({});
                            case 7:
                              _context72.t2 = _context72.sent;
                              _context72.next = 10;
                              return _context72.t0.deletePeer.call(_context72.t0, _context72.t1, _context72.t2);
                            case 10:
                              _context72.next = 15;
                              break;
                            case 12:
                              _context72.prev = 12;
                              _context72.t3 = _context72["catch"](0);
                              return _context72.abrupt("return", void h.a.warn("Error deleting local peer", {
                                error: _context72.t3
                              }));
                            case 15:
                            case "end":
                              return _context72.stop();
                          }
                        }, _callee66, this, [[0, 12]]);
                      }));
                    }();
                  case 16:
                  case "end":
                    return _context73.stop();
                }
              }, _callee67, this);
            }));
          }
        }, {
          key: "createPeer",
          value: function createPeer() {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee69() {
              var _this32 = this;
              var e2, t2, r2;
              return _regeneratorRuntime().wrap(function _callee69$(_context75) {
                while (1) switch (_context75.prev = _context75.next) {
                  case 0:
                    if (!this.config.lanOnlyMode) {
                      _context75.next = 2;
                      break;
                    }
                    throw new Error("createPeer method cannot be used in local-only mode.");
                  case 2:
                    e2 = this.config.signalingClient;
                    _context75.next = 5;
                    return function () {
                      return ue(_this32, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee68() {
                        return _regeneratorRuntime().wrap(function _callee68$(_context74) {
                          while (1) switch (_context74.prev = _context74.next) {
                            case 0:
                              _context74.prev = 0;
                              _context74.t0 = e2;
                              _context74.t1 = new F.CreatePeerRequest();
                              _context74.next = 5;
                              return this.getMetadata({});
                            case 5:
                              _context74.t2 = _context74.sent;
                              _context74.next = 8;
                              return _context74.t0.createPeer.call(_context74.t0, _context74.t1, _context74.t2);
                            case 8:
                              return _context74.abrupt("return", _context74.sent);
                            case 11:
                              _context74.prev = 11;
                              _context74.t3 = _context74["catch"](0);
                              throw new Error("Was not able to create peer: ".concat(JSON.stringify(_context74.t3)));
                            case 14:
                            case "end":
                              return _context74.stop();
                          }
                        }, _callee68, this, [[0, 11]]);
                      }));
                    }();
                  case 5:
                    t2 = _context75.sent;
                    r2 = null == t2 ? void 0 : t2.getPeer();
                    if (r2) {
                      _context75.next = 9;
                      break;
                    }
                    throw new Error("Response did not provide peer.");
                  case 9:
                    return _context75.abrupt("return", this.localPeer = r2);
                  case 10:
                  case "end":
                    return _context75.stop();
                }
              }, _callee69, this);
            }));
          }
        }, {
          key: "createReceiveSignalStream",
          value: function createReceiveSignalStream() {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee72() {
              var _this33 = this;
              var e2, t2, r2, n2, o2, i2;
              return _regeneratorRuntime().wrap(function _callee72$(_context78) {
                while (1) switch (_context78.prev = _context78.next) {
                  case 0:
                    if (!this.config.lanOnlyMode) {
                      _context78.next = 2;
                      break;
                    }
                    throw new Error("createReceiveSignalStream method cannot be used in local-only mode.");
                  case 2:
                    e2 = this.config.signalingClient, t2 = this.localPeer, r2 = this.iceServers;
                    if (!(!t2 || !r2)) {
                      _context78.next = 5;
                      break;
                    }
                    return _context78.abrupt("return");
                  case 5:
                    n2 = this.receiveSignalStream;
                    n2 && n2.cancel();
                    o2 = new F.ReceiveSignalStreamRequest();
                    o2.setPeerId(t2.getPeerId());
                    _context78.next = 11;
                    return function () {
                      return ue(_this33, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee70() {
                        return _regeneratorRuntime().wrap(function _callee70$(_context76) {
                          while (1) switch (_context76.prev = _context76.next) {
                            case 0:
                              _context76.prev = 0;
                              _context76.t0 = e2;
                              _context76.t1 = o2;
                              _context76.next = 5;
                              return this.getMetadata({
                                hasDeadline: false
                              });
                            case 5:
                              _context76.t2 = _context76.sent;
                              return _context76.abrupt("return", _context76.t0.receiveSignalStream.call(_context76.t0, _context76.t1, _context76.t2));
                            case 9:
                              _context76.prev = 9;
                              _context76.t3 = _context76["catch"](0);
                              throw new Error("Unable to create receive signal stream: ".concat(JSON.stringify(_context76.t3)));
                            case 12:
                            case "end":
                              return _context76.stop();
                          }
                        }, _callee70, this, [[0, 9]]);
                      }));
                    }();
                  case 11:
                    i2 = _context78.sent;
                    if (i2) {
                      _context78.next = 14;
                      break;
                    }
                    throw new Error("Response did not provide stream.");
                  case 14:
                    return _context78.abrupt("return", (i2.on("data", function (e3) {
                      return ue(_this33, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee71() {
                        var _this34 = this;
                        var n3, o3, i3, s2, a3, l2, u2, g2, c2, f2, e4, _e6;
                        return _regeneratorRuntime().wrap(function _callee71$(_context77) {
                          while (1) switch (_context77.prev = _context77.next) {
                            case 0:
                              a3 = e3.getSignal(), l2 = null === (n3 = null == a3 ? void 0 : a3.getSessionId()) || void 0 === n3 ? void 0 : n3.getValue(), u2 = null == a3 ? void 0 : a3.getSenderId(), g2 = null == a3 ? void 0 : a3.getReceiverId(), c2 = null === (o3 = null == a3 ? void 0 : a3.getSessionCreatedTimestamp()) || void 0 === o3 ? void 0 : o3.getValue();
                              if (a3 && l2 && u2 && g2 && c2) {
                                _context77.next = 3;
                                break;
                              }
                              return _context77.abrupt("return", void h.a.warn("Received signal with missing information."));
                            case 3:
                              f2 = this.getActiveConnection(u2);
                              if (!f2) {
                                _context77.next = 25;
                                break;
                              }
                              if (!(f2.getSessionId() !== l2)) {
                                _context77.next = 20;
                                break;
                              }
                              if (!(h.a.debug("Received signal: different session for a peer we're already connected to."), (f2.getSessionCreatedTimestamp() || 0) > c2)) {
                                _context77.next = 8;
                                break;
                              }
                              return _context77.abrupt("return");
                            case 8:
                              _context77.t0 = se;
                              _context77.next = 11;
                              return this.createRTCPeerConnection(r2);
                            case 11:
                              _context77.t1 = _context77.sent;
                              _context77.t2 = {
                                baseConfig: {
                                  isOffer: false,
                                  isLan: false,
                                  receive: function receive(e5, t3) {
                                    return _this34.config.receive(e5, t3);
                                  },
                                  onStreamsInfoUpdate: this.config.onStreamsInfoUpdate ? function (e5, t3) {
                                    var r3, n4;
                                    return null === (n4 = (r3 = _this34.config).onStreamsInfoUpdate) || void 0 === n4 ? void 0 : n4.call(r3, e5, t3);
                                  } : void 0,
                                  track: this.config.lanOnlyMode ? void 0 : this.config.track,
                                  localPeerId: t2.getPeerId(),
                                  localUserId: null === (s2 = t2.getUserId()) || void 0 === s2 ? void 0 : s2.getValue(),
                                  remotePeerId: u2
                                },
                                remoteConfig: {
                                  sessionId: l2,
                                  sessionCreatedTimestamp: c2
                                }
                              };
                              _context77.t3 = function (e5) {
                                return _this34.onCustomDataChannel(u2, e5);
                              };
                              e4 = new _context77.t0(_context77.t1, _context77.t2, _context77.t3);
                              _context77.next = 17;
                              return e4.handleSignal(a3);
                            case 17:
                              this.connections.push(e4);
                              _context77.next = 23;
                              break;
                            case 20:
                              h.a.debug("Received signal: for an existing connection.");
                              _context77.next = 23;
                              return f2.handleSignal(a3);
                            case 23:
                              _context77.next = 36;
                              break;
                            case 25:
                              h.a.debug("Received signal: new connection.");
                              _context77.t4 = se;
                              _context77.next = 29;
                              return this.createRTCPeerConnection(r2);
                            case 29:
                              _context77.t5 = _context77.sent;
                              _context77.t6 = {
                                baseConfig: {
                                  isOffer: false,
                                  isLan: false,
                                  receive: function receive(e5, t3) {
                                    return _this34.config.receive(e5, t3);
                                  },
                                  onStreamsInfoUpdate: this.config.onStreamsInfoUpdate ? function (e5, t3) {
                                    var r3, n4;
                                    return null === (n4 = (r3 = _this34.config).onStreamsInfoUpdate) || void 0 === n4 ? void 0 : n4.call(r3, e5, t3);
                                  } : void 0,
                                  track: this.config.lanOnlyMode ? void 0 : this.config.track,
                                  localPeerId: t2.getPeerId(),
                                  localUserId: null === (i3 = t2.getUserId()) || void 0 === i3 ? void 0 : i3.getValue(),
                                  remotePeerId: u2
                                },
                                remoteConfig: {
                                  sessionId: l2,
                                  sessionCreatedTimestamp: c2
                                }
                              };
                              _context77.t7 = function (e5) {
                                return _this34.onCustomDataChannel(u2, e5);
                              };
                              _e6 = new _context77.t4(_context77.t5, _context77.t6, _context77.t7);
                              _context77.next = 35;
                              return _e6.handleSignal(a3);
                            case 35:
                              this.connections.push(_e6);
                            case 36:
                            case "end":
                              return _context77.stop();
                          }
                        }, _callee71, this);
                      }));
                    }), i2.on("end", function () {
                      i2.cancel(), _this33.receiveSignalStream = void 0;
                    }), i2.on("error", function (e3) {
                      switch (e3.code) {
                        case W.StatusCode.CANCELLED:
                        case W.StatusCode.UNAVAILABLE:
                        case W.StatusCode.UNKNOWN:
                          h.a.debug("Receive signal stream error", {
                            error: e3
                          });
                          break;
                        case W.StatusCode.UNAUTHENTICATED:
                          h.a.warn("Receive signal stream error", {
                            error: e3
                          });
                          break;
                        default:
                          h.a.error("Receive signal stream error", {
                            error: e3
                          });
                      }
                      i2.cancel(), _this33.receiveSignalStream = void 0;
                    }), this.receiveSignalStream = i2));
                  case 15:
                  case "end":
                    return _context78.stop();
                }
              }, _callee72, this);
            }));
          }
        }, {
          key: "createRTCPeerConnection",
          value: function createRTCPeerConnection(e2) {
            var t2;
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee73() {
              var r2;
              return _regeneratorRuntime().wrap(function _callee73$(_context79) {
                while (1) switch (_context79.prev = _context79.next) {
                  case 0:
                    r2 = null !== (t2 = this.config.alternateRTCPeerConnection) && void 0 !== t2 ? t2 : window.RTCPeerConnection;
                    if (r2) {
                      _context79.next = 5;
                      break;
                    }
                    if (!("Chrome" !== function () {
                      var _navigator = navigator,
                        e3 = _navigator.userAgent;
                      return e3.includes("Firefox/") ? "Firefox" : e3.includes("Edg/") ? "Edge" : e3.includes("Chrome/") ? "Chrome" : e3.includes("Safari/") ? "Safari" : e3.includes("MSIE/") || e3.includes("Trident/") ? "IE" : "Other";
                    }())) {
                      _context79.next = 4;
                      break;
                    }
                    throw new Error("WebRTC is not enabled. Please try again with the latest version of Google Chrome.");
                  case 4:
                    throw new Error("WebRTC is not enabled. Please ensure WebRTC is not disabled by ad blocking software.");
                  case 5:
                    return _context79.abrupt("return", new r2({
                      iceServers: e2
                    }));
                  case 6:
                  case "end":
                    return _context79.stop();
                }
              }, _callee73, this);
            }));
          }
        }, {
          key: "closeConnections",
          value: function closeConnections(e2) {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee75() {
              var _this35 = this;
              var t2, _iterator17, _step17, e3;
              return _regeneratorRuntime().wrap(function _callee75$(_context81) {
                while (1) switch (_context81.prev = _context81.next) {
                  case 0:
                    _context81.next = 2;
                    return D(e2.map(function (e3) {
                      return ue(_this35, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee74() {
                        return _regeneratorRuntime().wrap(function _callee74$(_context80) {
                          while (1) switch (_context80.prev = _context80.next) {
                            case 0:
                              _context80.next = 2;
                              return e3.close();
                            case 2:
                            case "end":
                              return _context80.stop();
                          }
                        }, _callee74);
                      }));
                    }));
                  case 2:
                    t2 = _context81.sent;
                    _iterator17 = _createForOfIteratorHelper(t2);
                    try {
                      for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                        e3 = _step17.value;
                        h.a.warn("Request to close session failed", {
                          error: e3
                        });
                      }
                    } catch (err) {
                      _iterator17.e(err);
                    } finally {
                      _iterator17.f();
                    }
                  case 5:
                  case "end":
                    return _context81.stop();
                }
              }, _callee75);
            }));
          }
        }, {
          key: "getActiveConnection",
          value: function getActiveConnection(e2) {
            return this.getConnections().find(function (t2) {
              return t2.getRemotePeerId() === e2 && t2.isActive();
            });
          }
        }, {
          key: "update",
          value: function update() {
            var e2;
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee76() {
              var t2, r2, n2, o2, i2, _iterator18, _step18, _loop;
              return _regeneratorRuntime().wrap(function _callee76$(_context83) {
                while (1) switch (_context83.prev = _context83.next) {
                  case 0:
                    if (!(this.localConnections = this.localConnections.filter(function (e3) {
                      return e3.isActive();
                    }), this.config.lanOnlyMode)) {
                      _context83.next = 2;
                      break;
                    }
                    return _context83.abrupt("return");
                  case 2:
                    t2 = this.config.signalingClient;
                    if (!(!this.localPeer || !this.receiveSignalStream || !this.iceServers)) {
                      _context83.next = 18;
                      break;
                    }
                    _context83.t0 = this.localPeer;
                    if (_context83.t0) {
                      _context83.next = 8;
                      break;
                    }
                    _context83.next = 8;
                    return this.createPeer();
                  case 8:
                    _context83.t1 = this.iceServers;
                    if (_context83.t1) {
                      _context83.next = 12;
                      break;
                    }
                    _context83.next = 12;
                    return this.updateIceServers();
                  case 12:
                    _context83.t2 = this.receiveSignalStream;
                    if (_context83.t2) {
                      _context83.next = 17;
                      break;
                    }
                    _context83.next = 16;
                    return this.createReceiveSignalStream();
                  case 16:
                    _context83.t2 = _context83.sent;
                  case 17:
                    return _context83.abrupt("return", void _context83.t2);
                  case 18:
                    _context83.next = 20;
                    return this.closeConnections(this.connections.filter(function (e3) {
                      return !e3.isActive();
                    }));
                  case 20:
                    this.connections = this.connections.filter(function (e3) {
                      return e3.isActive();
                    });
                    r2 = this.localPeer, n2 = this.connections.filter(function (e3) {
                      return e3.getSessionId;
                    }).map(function (e3) {
                      return x(e3.getSessionId());
                    });
                    r2.setSessionIdsList(n2);
                    o2 = new F.RefreshPeerRequest();
                    o2.setPeer(r2);
                    _context83.prev = 25;
                    _context83.t3 = t2;
                    _context83.t4 = o2;
                    _context83.next = 30;
                    return this.getMetadata({});
                  case 30:
                    _context83.t5 = _context83.sent;
                    _context83.next = 33;
                    return _context83.t3.refreshPeer.call(_context83.t3, _context83.t4, _context83.t5);
                  case 33:
                    _context83.next = 44;
                    break;
                  case 35:
                    _context83.prev = 35;
                    _context83.t6 = _context83["catch"](25);
                    if (!(_context83.t6.code === W.StatusCode.NOT_FOUND)) {
                      _context83.next = 43;
                      break;
                    }
                    h.a.warn("Peer expired, creating new peer", {
                      peerId: r2.getPeerId()
                    });
                    _context83.next = 41;
                    return this.reset();
                  case 41:
                    _context83.next = 44;
                    break;
                  case 43:
                    h.a.warn("Error calling RefreshPeer", {
                      error: _context83.t6
                    });
                  case 44:
                    _context83.next = 46;
                    return this.getPeers();
                  case 46:
                    i2 = _context83.sent;
                    _iterator18 = _createForOfIteratorHelper(this.connections);
                    _context83.prev = 48;
                    _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                      var t3;
                      return _regeneratorRuntime().wrap(function _loop$(_context82) {
                        while (1) switch (_context82.prev = _context82.next) {
                          case 0:
                            t3 = _step18.value;
                            t3.setRemoteDeviceId(null === (e2 = i2.find(function (e3) {
                              return e3.id === t3.getRemotePeerId();
                            })) || void 0 === e2 ? void 0 : e2.deviceId);
                          case 2:
                          case "end":
                            return _context82.stop();
                        }
                      }, _loop);
                    });
                    _iterator18.s();
                  case 51:
                    if ((_step18 = _iterator18.n()).done) {
                      _context83.next = 55;
                      break;
                    }
                    return _context83.delegateYield(_loop(), "t7", 53);
                  case 53:
                    _context83.next = 51;
                    break;
                  case 55:
                    _context83.next = 60;
                    break;
                  case 57:
                    _context83.prev = 57;
                    _context83.t8 = _context83["catch"](48);
                    _iterator18.e(_context83.t8);
                  case 60:
                    _context83.prev = 60;
                    _iterator18.f();
                    return _context83.finish(60);
                  case 63:
                  case "end":
                    return _context83.stop();
                }
              }, _callee76, this, [[25, 35], [48, 57, 60, 63]]);
            }));
          }
        }, {
          key: "reset",
          value: function reset() {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee77() {
              return _regeneratorRuntime().wrap(function _callee77$(_context84) {
                while (1) switch (_context84.prev = _context84.next) {
                  case 0:
                    _context84.next = 2;
                    return this.closeConnections(this.connections);
                  case 2:
                    this.connections = [];
                    this.isOutgoingConnection = /* @__PURE__ */new Map();
                    _context84.next = 6;
                    return this.createPeer();
                  case 6:
                    _context84.next = 8;
                    return this.createReceiveSignalStream();
                  case 8:
                  case "end":
                    return _context84.stop();
                }
              }, _callee77, this);
            }));
          }
        }, {
          key: "updateIceServers",
          value: function updateIceServers() {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee78() {
              var e2, t2, r2, e3;
              return _regeneratorRuntime().wrap(function _callee78$(_context85) {
                while (1) switch (_context85.prev = _context85.next) {
                  case 0:
                    if (!this.config.lanOnlyMode) {
                      _context85.next = 2;
                      break;
                    }
                    return _context85.abrupt("return");
                  case 2:
                    e2 = this.iceServersLastUpdate, t2 = this.iceServersTtl, r2 = new Date().getTime();
                    if (!(!e2 || r2 - e2 > t2)) {
                      _context85.next = 19;
                      break;
                    }
                    _context85.prev = 4;
                    _context85.t0 = this.config.signalingClient;
                    _context85.t1 = new F.GetIceServersRequest();
                    _context85.next = 9;
                    return this.getMetadata({});
                  case 9:
                    _context85.t2 = _context85.sent;
                    _context85.next = 12;
                    return _context85.t0.getIceServers.call(_context85.t0, _context85.t1, _context85.t2);
                  case 12:
                    e3 = _context85.sent.getIceServers();
                    this.iceServers = JSON.parse(e3), this.iceServersLastUpdate = r2;
                    _context85.next = 19;
                    break;
                  case 16:
                    _context85.prev = 16;
                    _context85.t3 = _context85["catch"](4);
                    h.a.warn("Error in updateIceServers", {
                      error: _context85.t3
                    });
                  case 19:
                  case "end":
                    return _context85.stop();
                }
              }, _callee78, this, [[4, 16]]);
            }));
          }
        }, {
          key: "setupHandlers",
          value: function setupHandlers(e2) {
            var _this36 = this;
            var t2 = e2.peerConnection,
              r2 = e2.getSessionCreatedTimestamp();
            t2.onconnectionstatechange = function () {
              return ue(_this36, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee79() {
                var e3;
                return _regeneratorRuntime().wrap(function _callee79$(_context86) {
                  while (1) switch (_context86.prev = _context86.next) {
                    case 0:
                      e3 = t2.connectionState;
                      if (!r2) {
                        _context86.next = 8;
                        break;
                      }
                      _context86.t0 = e3;
                      _context86.next = _context86.t0 === "connected" ? 5 : _context86.t0 === "failed" ? 7 : 8;
                      break;
                    case 5:
                      R.aggregate("rtc-connect-time", new Date().getTime() - r2);
                      return _context86.abrupt("break", 8);
                    case 7:
                      R.increment("rtc-connect-failed");
                    case 8:
                    case "end":
                      return _context86.stop();
                  }
                }, _callee79);
              }));
            };
          }
        }, {
          key: "getMetadata",
          value: function getMetadata(e2) {
            return ue(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
              var t2, r2, n2, o2;
              return _regeneratorRuntime().wrap(function _callee80$(_context87) {
                while (1) switch (_context87.prev = _context87.next) {
                  case 0:
                    if (!this.config.lanOnlyMode) {
                      _context87.next = 2;
                      break;
                    }
                    throw new Error("getMetadata method cannot be called in local-only mode");
                  case 2:
                    t2 = this.config.getToken, r2 = this.grpcCallDeadline, n2 = e2.hasDeadline, o2 = false === n2 ? void 0 : new Date().getTime() + r2;
                    _context87.next = 5;
                    return t2();
                  case 5:
                    _context87.t0 = _context87.sent;
                    _context87.t1 = o2;
                    return _context87.abrupt("return", {
                      authorization: _context87.t0,
                      deadline: _context87.t1
                    });
                  case 8:
                  case "end":
                    return _context87.stop();
                }
              }, _callee80, this);
            }));
          }
        }]);
        return ge;
      }();
      var ce = r(10),
        fe = r(11),
        pe = function pe(e2, t2, r2, n2) {
          return new (r2 || (r2 = Promise))(function (o2, i2) {
            function s2(e3) {
              try {
                l2(n2.next(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function a3(e3) {
              try {
                l2(n2.throw(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function l2(e3) {
              var t3;
              e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
                e4(t3);
              })).then(s2, a3);
            }
            l2((n2 = n2.apply(e2, t2 || [])).next());
          });
        };
      var he = /*#__PURE__*/function () {
        function he(e2, t2) {
          _classCallCheck(this, he);
          this.sessionId = e2, this.connection = t2, this.sentMessagesCounts = /* @__PURE__ */new Map(), this.receivedMessagesCounts = /* @__PURE__ */new Map(), this.sessionId = e2, this.connection = t2;
        }
        _createClass(he, [{
          key: "incrementMessageSent",
          value: function incrementMessageSent(e2) {
            var t2 = Q(e2.header.stream);
            this.sentMessagesCounts.set(t2, (this.sentMessagesCounts.get(t2) || 0) + 1);
          }
        }, {
          key: "incrementMessageReceived",
          value: function incrementMessageReceived(e2) {
            var t2 = Q(e2.header.stream);
            this.receivedMessagesCounts.set(t2, (this.receivedMessagesCounts.get(t2) || 0) + 1);
          }
        }, {
          key: "uploadMetrics",
          value: function uploadMetrics() {
            return pe(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee81() {
              var _this37 = this;
              var e2, t2, r2, n2;
              return _regeneratorRuntime().wrap(function _callee81$(_context88) {
                while (1) switch (_context88.prev = _context88.next) {
                  case 0:
                    e2 = this.sessionId;
                    _context88.next = 3;
                    return this.connection.peerConnection.getStats();
                  case 3:
                    t2 = _context88.sent;
                    r2 = {};
                    t2.forEach(function (e3) {
                      return r2[e3.id] = e3;
                    }), h.a.debug("rtc-stats", Object.assign(Object.assign({}, r2), {
                      sessionId: e2
                    }));
                    n2 = _toConsumableArray(new Set(Array.from(this.sentMessagesCounts.keys()).concat(Array.from(this.receivedMessagesCounts.keys())))).reduce(function (e3, t3) {
                      var _Object$assign4;
                      var r3 = _this37.sentMessagesCounts.get(t3),
                        n3 = _this37.receivedMessagesCounts.get(t3);
                      return Object.assign(Object.assign({}, e3), (_Object$assign4 = {}, _defineProperty(_Object$assign4, "".concat(t3, "-sent"), r3), _defineProperty(_Object$assign4, "".concat(t3, "-received"), n3), _Object$assign4));
                    }, {
                      sessionId: e2
                    });
                    h.a.debug("rtc-message-report", n2);
                  case 8:
                  case "end":
                    return _context88.stop();
                }
              }, _callee81, this);
            }));
          }
        }]);
        return he;
      }();
      function de(e2, t2) {
        return Q(e2) === Q(t2);
      }
      var ye = function ye(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      var me = /*#__PURE__*/function () {
        function me(e2, t2) {
          var _this38 = this;
          _classCallCheck(this, me);
          this.peerConnection = e2, this.config = t2, this.connectTimeoutMs = 10 * l.a.second, this.gatherIceTimeoutMs = 5 * l.a.second, this.pingUpdateTimeoutMs = 2 * l.a.second, this.streamLatestTimestamp = /* @__PURE__ */new Map(), this.closeCalled = false, this.connectCalled = false, this.sentOffer = false, this.receivedIceCandidate = false;
          var r2 = t2.isOffer;
          r2 ? this.initializeChannels(e2) : e2.ondatachannel = function (e3) {
            switch (e3.channel.label) {
              case "stream.latest-ttl":
                _this38.latestTtlStreamChannel = e3.channel;
                break;
              case "stream.reliable":
                _this38.reliableStreamChannel = e3.channel;
                break;
              case "stream.latest-reliable":
                _this38.latestReliableStreamChannel = e3.channel;
                break;
              case "stream.latest-try-once":
                _this38.latestTryOnceStreamChannel = e3.channel;
            }
            _this38.setupChannel(e3.channel);
          }, this.sessionMetrics = new he(this.getSessionId(), this);
        }
        _createClass(me, [{
          key: "connect",
          value: function connect() {
            return ye(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee86() {
              var _this39 = this;
              var e2, _this$config2, t2, r2, _t19;
              return _regeneratorRuntime().wrap(function _callee86$(_context93) {
                while (1) switch (_context93.prev = _context93.next) {
                  case 0:
                    if (!this.connectCalled) {
                      _context93.next = 2;
                      break;
                    }
                    return _context93.abrupt("return");
                  case 2:
                    this.connectCalled = true, this.pingUpdateTimeout = setInterval(function () {
                      var e3 = _this39.reliableStreamChannel;
                      e3 && _this39.sendSystemMessage(e3, {
                        type: "ping"
                      });
                    }, this.pingUpdateTimeoutMs), this.connectTimeout = setTimeout(function () {
                      return ye(_this39, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee82() {
                        return _regeneratorRuntime().wrap(function _callee82$(_context89) {
                          while (1) switch (_context89.prev = _context89.next) {
                            case 0:
                              _context89.t0 = this.isReady();
                              if (_context89.t0) {
                                _context89.next = 5;
                                break;
                              }
                              h.a.warn("RTC connect timed out, closing connection");
                              _context89.next = 5;
                              return this.close();
                            case 5:
                            case "end":
                              return _context89.stop();
                          }
                        }, _callee82, this);
                      }));
                    }, this.connectTimeoutMs);
                    e2 = this.peerConnection, _this$config2 = this.config, t2 = _this$config2.isOffer, r2 = _this$config2.sessionId;
                    if (!t2) {
                      _context93.next = 10;
                      break;
                    }
                    _context93.next = 7;
                    return e2.createOffer();
                  case 7:
                    _t19 = _context93.sent;
                    _context93.next = 10;
                    return e2.setLocalDescription(_t19);
                  case 10:
                    t2 && (this.gatherIceTimeout = setTimeout(function () {
                      return ye(_this39, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee83() {
                        return _regeneratorRuntime().wrap(function _callee83$(_context90) {
                          while (1) switch (_context90.prev = _context90.next) {
                            case 0:
                              _context90.t0 = this.sentOffer;
                              if (_context90.t0) {
                                _context90.next = 11;
                                break;
                              }
                              h.a.warn("ICE gathering timed out");
                              if (!this.receivedIceCandidate) {
                                _context90.next = 9;
                                break;
                              }
                              h.a.warn("Attempting to connect with partial ICE candidate pool");
                              _context90.next = 7;
                              return this.sendOffer();
                            case 7:
                              _context90.next = 11;
                              break;
                            case 9:
                              _context90.next = 11;
                              return this.close();
                            case 11:
                            case "end":
                              return _context90.stop();
                          }
                        }, _callee83, this);
                      }));
                    }, this.gatherIceTimeoutMs), e2.onicecandidate = function (e3) {
                      return ye(_this39, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee84() {
                        return _regeneratorRuntime().wrap(function _callee84$(_context91) {
                          while (1) switch (_context91.prev = _context91.next) {
                            case 0:
                              if (!e3.candidate) {
                                _context91.next = 4;
                                break;
                              }
                              this.receivedIceCandidate = true;
                              _context91.next = 6;
                              break;
                            case 4:
                              _context91.next = 6;
                              return this.sendOffer();
                            case 6:
                            case "end":
                              return _context91.stop();
                          }
                        }, _callee84, this);
                      }));
                    }, e2.onicegatheringstatechange = function () {
                      return ye(_this39, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee85() {
                        return _regeneratorRuntime().wrap(function _callee85$(_context92) {
                          while (1) switch (_context92.prev = _context92.next) {
                            case 0:
                              _context92.t0 = "complete" === e2.iceGatheringState;
                              if (!_context92.t0) {
                                _context92.next = 4;
                                break;
                              }
                              _context92.next = 4;
                              return this.sendOffer();
                            case 4:
                            case "end":
                              return _context92.stop();
                          }
                        }, _callee85, this);
                      }));
                    }, e2.onnegotiationneeded = function () {
                      h.a.debug("Negotiation needed", {
                        sessionId: r2
                      });
                    });
                  case 11:
                  case "end":
                    return _context93.stop();
                }
              }, _callee86, this);
            }));
          }
        }, {
          key: "handleSignal",
          value: function handleSignal(e2) {
            return ye(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee87() {
              var t2, _this$config3, r2, n2, _JSON$parse, o2, e3;
              return _regeneratorRuntime().wrap(function _callee87$(_context94) {
                while (1) switch (_context94.prev = _context94.next) {
                  case 0:
                    t2 = this.peerConnection, _this$config3 = this.config, r2 = _this$config3.sessionId, n2 = _this$config3.sendSignal, _JSON$parse = JSON.parse(e2.payload), o2 = _JSON$parse.description;
                    if (!(h.a.debug("Handling signal", {
                      sessionId: r2,
                      description: JSON.stringify(o2)
                    }), o2)) {
                      _context94.next = 28;
                      break;
                    }
                    if (!("stable" !== t2.signalingState || "connected" !== t2.connectionState)) {
                      _context94.next = 25;
                      break;
                    }
                    if (!t2.remoteDescription) {
                      _context94.next = 7;
                      break;
                    }
                    h.a.warn("Received SDP signal during negotiation when remote description is already set: ".concat(JSON.stringify(e2)));
                    _context94.next = 23;
                    break;
                  case 7:
                    if (!("offer" === o2.type)) {
                      _context94.next = 19;
                      break;
                    }
                    _context94.next = 10;
                    return t2.setRemoteDescription(o2);
                  case 10:
                    _context94.next = 12;
                    return t2.createAnswer();
                  case 12:
                    e3 = _context94.sent;
                    _context94.next = 15;
                    return t2.setLocalDescription(e3);
                  case 15:
                    _context94.next = 17;
                    return n2({
                      payload: JSON.stringify({
                        description: e3
                      })
                    });
                  case 17:
                    _context94.next = 23;
                    break;
                  case 19:
                    _context94.t0 = "answer" === o2.type;
                    if (!_context94.t0) {
                      _context94.next = 23;
                      break;
                    }
                    _context94.next = 23;
                    return t2.setRemoteDescription(o2);
                  case 23:
                    _context94.next = 26;
                    break;
                  case 25:
                    h.a.warn("Received SDP signal when signaling is stable and connected: ".concat(JSON.stringify(e2)));
                  case 26:
                    _context94.next = 29;
                    break;
                  case 28:
                    h.a.warn("Received non-SDP signal: ".concat(JSON.stringify(e2)));
                  case 29:
                  case "end":
                    return _context94.stop();
                }
              }, _callee87, this);
            }));
          }
        }, {
          key: "send",
          value: function send(e2, t2) {
            var r2 = this.getChannelFromLabel(t2.channelLabel);
            r2 ? this.sendOnChannel(r2, e2) : h.a.warn("Send called with unexpected channel label", {
              channelLabel: t2.channelLabel
            });
          }
        }, {
          key: "controlRemoteStream",
          value: function controlRemoteStream(e2) {
            this.sendSystemMessage(x(this.reliableStreamChannel), {
              type: "stream-control",
              streamControl: e2
            });
          }
        }, {
          key: "isActive",
          value: function isActive() {
            return /* @__PURE__ */new Set(["new", "connecting", "connected"]).has(this.peerConnection.connectionState);
          }
        }, {
          key: "isReady",
          value: function isReady() {
            var e2 = this.peerConnection,
              t2 = this.latestTtlStreamChannel,
              r2 = this.reliableStreamChannel,
              n2 = this.latestTryOnceStreamChannel;
            return !!(r2 && t2 && n2) && "connected" === e2.connectionState && "open" === r2.readyState && "open" === t2.readyState && "open" === n2.readyState;
          }
        }, {
          key: "isClosed",
          value: function isClosed() {
            var e2 = this.peerConnection,
              t2 = this.reliableStreamChannel,
              r2 = this.latestTryOnceStreamChannel,
              n2 = this.latestTtlStreamChannel;
            return !("closed" !== e2.connectionState || void 0 !== t2 && "closed" !== t2.readyState || void 0 !== r2 && "closed" !== r2.readyState || void 0 !== n2 && "closed" !== n2.readyState);
          }
        }, {
          key: "needsClosing",
          value: function needsClosing() {
            var e2 = this.peerConnection,
              t2 = this.latestTtlStreamChannel,
              r2 = this.reliableStreamChannel,
              n2 = this.latestTryOnceStreamChannel;
            if (this.isClosed()) return false;
            var o2 = /* @__PURE__ */new Set(["closing", "closed"]),
              i2 = function i2(e3) {
                return e3 && o2.has(e3.readyState);
              };
            return ne(e2) || i2(t2) || i2(r2) || i2(n2);
          }
        }, {
          key: "close",
          value: function close() {
            return ye(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee88() {
              return _regeneratorRuntime().wrap(function _callee88$(_context95) {
                while (1) switch (_context95.prev = _context95.next) {
                  case 0:
                    _context95.t0 = this.closeCalled;
                    if (_context95.t0) {
                      _context95.next = 9;
                      break;
                    }
                    this.closeCalled = true;
                    _context95.next = 5;
                    return this.sessionMetrics.uploadMetrics();
                  case 5:
                    this.pingUpdateTimeout && clearInterval(this.pingUpdateTimeout);
                    this.connectTimeout && clearTimeout(this.connectTimeout);
                    this.gatherIceTimeout && clearTimeout(this.gatherIceTimeout);
                    this.peerConnection.close();
                  case 9:
                  case "end":
                    return _context95.stop();
                }
              }, _callee88, this);
            }));
          }
        }, {
          key: "getPing",
          value: function getPing() {
            return this.pingTimeMs;
          }
        }, {
          key: "getLastMessageTimestamp",
          value: function getLastMessageTimestamp() {
            return this.lastMessageTimestamp;
          }
        }, {
          key: "getSessionId",
          value: function getSessionId() {
            return this.config.sessionId;
          }
        }, {
          key: "getRemotePeer",
          value: function getRemotePeer() {
            return this.config.remotePeer;
          }
        }, {
          key: "initializeChannels",
          value: function initializeChannels(e2) {
            this.latestTtlStreamChannel = e2.createDataChannel("stream.latest-ttl", z), this.reliableStreamChannel = e2.createDataChannel("stream.reliable", G), this.latestReliableStreamChannel = e2.createDataChannel("stream.latest-reliable", q), this.latestTryOnceStreamChannel = e2.createDataChannel("stream.latest-try-once", Y), this.setupChannel(this.latestTtlStreamChannel), this.setupChannel(this.reliableStreamChannel), this.setupChannel(this.latestReliableStreamChannel), this.setupChannel(this.latestTryOnceStreamChannel);
          }
        }, {
          key: "sendOffer",
          value: function sendOffer() {
            return ye(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee89() {
              var e2, t2, r2, n2;
              return _regeneratorRuntime().wrap(function _callee89$(_context96) {
                while (1) switch (_context96.prev = _context96.next) {
                  case 0:
                    if (!this.sentOffer) {
                      _context96.next = 2;
                      break;
                    }
                    return _context96.abrupt("return");
                  case 2:
                    if (!(this.sentOffer = true, ne(this.peerConnection))) {
                      _context96.next = 4;
                      break;
                    }
                    return _context96.abrupt("return");
                  case 4:
                    e2 = this.peerConnection;
                    t2 = this.config.sendSignal;
                    _context96.next = 8;
                    return e2.createOffer();
                  case 8:
                    r2 = _context96.sent;
                    _context96.next = 11;
                    return e2.setLocalDescription(r2);
                  case 11:
                    n2 = {
                      payload: JSON.stringify({
                        description: r2
                      })
                    };
                    _context96.next = 14;
                    return t2(n2);
                  case 14:
                  case "end":
                    return _context96.stop();
                }
              }, _callee89, this);
            }));
          }
        }, {
          key: "getChannelFromLabel",
          value: function getChannelFromLabel(e2) {
            switch (e2) {
              case "stream.latest-ttl":
                return this.latestTtlStreamChannel;
              case "stream.reliable":
                return this.reliableStreamChannel;
              case "stream.latest-reliable":
                return this.latestReliableStreamChannel;
              case "stream.latest-try-once":
                return this.latestTryOnceStreamChannel;
            }
          }
        }, {
          key: "sendOnChannel",
          value: function sendOnChannel(e2, t2) {
            var r2;
            try {
              r2 = Object(H.encode)(JSON.stringify(t2));
            } catch (e3) {
              return void h.a.warn("Failed to encode RTC message", {
                error: e3
              });
            }
            try {
              e2.send(r2), this.sessionMetrics.incrementMessageSent(t2);
            } catch (t3) {
              h.a.warn("Failed to send message to channel", {
                error: t3,
                channel: e2.label
              });
            }
          }
        }, {
          key: "channelNotRecognized",
          value: function channelNotRecognized(e2) {
            return e2 !== this.latestTtlStreamChannel && e2 !== this.latestReliableStreamChannel && e2 !== this.latestTryOnceStreamChannel && e2 !== this.reliableStreamChannel;
          }
        }, {
          key: "setupChannel",
          value: function setupChannel(e2) {
            var _this40 = this;
            e2.onmessage = function (t2) {
              if (_this40.channelNotRecognized(e2)) return void h.a.warn("Received message on unrecognized data channel.");
              var r2;
              try {
                r2 = JSON.parse(Object(H.decode)(t2.data));
              } catch (t3) {
                return void h.a.warn("Received unparseable RTC message", {
                  error: t3,
                  channel: e2.label
                });
              }
              if (_this40.lastMessageTimestamp = new Date().getTime(), r2 = oe(r2), _this40.sessionMetrics.incrementMessageReceived(r2), _this40.handleSystemMessage(e2, r2)) return;
              if (!_this40.hasCapabilities(r2)) return void h.a.warn("Received RTC message that was not within the capability scope of the connection.");
              (e2 === _this40.latestTryOnceStreamChannel || e2 === _this40.latestTtlStreamChannel || e2 === _this40.latestReliableStreamChannel) && !_this40.isLatestMessage(r2) || _this40.config.receive(_this40.config.remotePeer.id, r2);
            }, e2.onerror = function (t2) {
              h.a.warn("Channel error: ".concat(t2.error), {
                error: t2.error,
                sessionId: _this40.getSessionId(),
                channelLabel: e2.label
              });
            }, e2.onopen = function () {
              h.a.debug("Channel opened", {
                sessionId: _this40.getSessionId(),
                channelLabel: e2.label
              });
            }, e2.onclose = function () {
              var t2 = {
                bufferedAmount: e2.bufferedAmount,
                sessionId: _this40.getSessionId(),
                channelLabel: e2.label
              };
              false === _this40.closeCalled ? h.a.debug("Unexpected channel closed", t2) : h.a.debug("Channel closed", t2);
            };
          }
        }, {
          key: "handleSystemMessage",
          value: function handleSystemMessage(e2, t2) {
            switch (t2.header.stream.streamType) {
              case "ping":
                return this.sendSystemMessage(e2, {
                  type: "pong",
                  timestamp: x(t2.payload.ping)
                }), true;
              case "pong":
                {
                  var e3 = new Date().getTime() - x(t2.payload.pong);
                  return this.pingTimeMs = e3, R.aggregate("rtc-ping-time", e3), true;
                }
              case "stream-control":
                return true;
              default:
                return false;
            }
          }
        }, {
          key: "sendSystemMessage",
          value: function sendSystemMessage(e2, t2) {
            if ("open" !== e2.readyState) return;
            var r2 = {
              entityId: x(this.config.localPeer.deviceId || this.config.localPeer.userId),
              streamName: "$.".concat(t2.type),
              streamType: t2.type
            };
            var n2;
            switch (t2.type) {
              case "ping":
                n2 = {
                  ping: new Date().getTime()
                };
                break;
              case "pong":
                n2 = {
                  pong: t2.timestamp
                };
                break;
              case "stream-control":
                n2 = {
                  streamControl: t2.streamControl
                };
            }
            this.sendOnChannel(e2, re(r2, n2));
          }
        }, {
          key: "hasCapabilities",
          value: function hasCapabilities(e2) {
            var t2, r2;
            var _this$config4 = this.config,
              n2 = _this$config4.localPeer,
              o2 = _this$config4.remotePeer,
              i2 = null === (t2 = n2.capabilitySet.streaming) || void 0 === t2 ? void 0 : t2.streams,
              s2 = i2 && i2.some(function (t3) {
                return t3.receive && de(t3.stream, e2.header.stream);
              }),
              a3 = null === (r2 = o2.capabilitySet.streaming) || void 0 === r2 ? void 0 : r2.streams,
              l2 = a3 && a3.some(function (t3) {
                return t3.send && de(t3.stream, e2.header.stream);
              });
            return s2 || l2;
          }
        }, {
          key: "isLatestMessage",
          value: function isLatestMessage(e2) {
            var t2 = Q(e2.header.stream),
              r2 = (this.streamLatestTimestamp.get(t2) || 0) <= e2.header.created;
            return r2 && this.streamLatestTimestamp.set(t2, e2.header.created), r2;
          }
        }]);
        return me;
      }();
      var be = function be(e2, t2, r2, n2) {
        return new (r2 || (r2 = Promise))(function (o2, i2) {
          function s2(e3) {
            try {
              l2(n2.next(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function a3(e3) {
            try {
              l2(n2.throw(e3));
            } catch (e4) {
              i2(e4);
            }
          }
          function l2(e3) {
            var t3;
            e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
              e4(t3);
            })).then(s2, a3);
          }
          l2((n2 = n2.apply(e2, t2 || [])).next());
        });
      };
      var ve = /*#__PURE__*/function () {
        function ve(e2) {
          var _this41 = this;
          _classCallCheck(this, ve);
          this.config = e2, this.connections = [], this.connectingSessions = /* @__PURE__ */new Map(), this.updateInterval = S({
            func: function func() {
              return be(_this41, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee90() {
                return _regeneratorRuntime().wrap(function _callee90$(_context97) {
                  while (1) switch (_context97.prev = _context97.next) {
                    case 0:
                      _context97.prev = 0;
                      _context97.next = 3;
                      return this.update();
                    case 3:
                      _context97.next = 8;
                      break;
                    case 5:
                      _context97.prev = 5;
                      _context97.t0 = _context97["catch"](0);
                      h.a.warn("RTC update failed", {
                        error: _context97.t0
                      });
                    case 8:
                    case "end":
                      return _context97.stop();
                  }
                }, _callee90, this, [[0, 5]]);
              }));
            },
            delay: 250 * l.a.millisecond,
            immediate: true
          }), this.localPeer = this.createPeer();
        }
        _createClass(ve, [{
          key: "send",
          value: function send(e2, t2, r2) {
            var n2 = this.getActiveConnection(e2);
            n2 ? n2.isReady() ? n2.send(t2, r2) : h.a.warn("Attempted to send with an active connection to that peer which was not yet ready.") : h.a.warn("Attempted to send with no active connection to that peer.");
          }
        }, {
          key: "controlRemoteStream",
          value: function controlRemoteStream(e2, t2) {
            var r2 = this.getActiveConnection(e2);
            r2 ? r2.isReady() ? r2.controlRemoteStream(t2) : h.a.warn("Attempted to control remote stream with an active connection to that peer which was not yet ready.") : h.a.warn("Attempted to control remote stream with no active connection to that peer.");
          }
        }, {
          key: "connect",
          value: function connect(e2) {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee91() {
              var t2, r2;
              return _regeneratorRuntime().wrap(function _callee91$(_context98) {
                while (1) switch (_context98.prev = _context98.next) {
                  case 0:
                    _context98.next = 2;
                    return this.getLocalPeer();
                  case 2:
                    t2 = _context98.sent;
                    if (!this.getActiveConnection(e2)) {
                      _context98.next = 5;
                      break;
                    }
                    return _context98.abrupt("return", void h.a.warn("Attempted to connect to peer with an already active connection."));
                  case 5:
                    _context98.prev = 5;
                    _context98.t0 = this.config.signalingClient;
                    _context98.next = 9;
                    return this.config.getToken();
                  case 9:
                    _context98.t1 = _context98.sent;
                    _context98.t2 = {
                      offerPeerId: t2.id,
                      answerPeerId: e2
                    };
                    _context98.next = 13;
                    return _context98.t0.createSession.call(_context98.t0, _context98.t1, _context98.t2);
                  case 13:
                    r2 = _context98.sent;
                    _context98.next = 19;
                    break;
                  case 16:
                    _context98.prev = 16;
                    _context98.t3 = _context98["catch"](5);
                    Object(ce.a)(_context98.t3, fe.a, function (e4) {
                      return 404 === e4.statusCode;
                    }), h.a.warn("Attempted to connect to peer that does not exist.");
                  case 19:
                    if (!r2) {
                      _context98.next = 33;
                      break;
                    }
                    this.connectingSessions.set(r2.id, new Date().getTime());
                    _context98.next = 23;
                    return this.connectToSession(r2);
                  case 23:
                    _context98.next = 25;
                    return Object(u.a)(0.1);
                  case 25:
                    _context98.t4 = this.getConnectionStatus(e2);
                    _context98.next = _context98.t4 === "connecting" ? 28 : _context98.t4 === "connected" ? 29 : _context98.t4 === "disconnected" ? 30 : 31;
                    break;
                  case 28:
                    return _context98.abrupt("continue", 31);
                  case 29:
                    return _context98.abrupt("return", r2.id);
                  case 30:
                    return _context98.abrupt("return");
                  case 31:
                    _context98.next = 23;
                    break;
                  case 33:
                  case "end":
                    return _context98.stop();
                }
              }, _callee91, this, [[5, 16]]);
            }));
          }
        }, {
          key: "getConnectionStatus",
          value: function getConnectionStatus(e2) {
            var t2 = this.getActiveConnection(e2);
            return t2 ? t2.isReady() ? "connected" : "connecting" : "disconnected";
          }
        }, {
          key: "getIceMode",
          value: function getIceMode(e2) {
            var t2 = this.getActiveConnection(e2);
            if (t2) return t2.iceMode;
          }
        }, {
          key: "disconnect",
          value: function disconnect(e2) {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee92() {
              var t2;
              return _regeneratorRuntime().wrap(function _callee92$(_context99) {
                while (1) switch (_context99.prev = _context99.next) {
                  case 0:
                    t2 = this.getActiveConnection(e2);
                    _context99.t0 = t2;
                    if (!_context99.t0) {
                      _context99.next = 5;
                      break;
                    }
                    _context99.next = 5;
                    return this.closeConnection(t2);
                  case 5:
                  case "end":
                    return _context99.stop();
                }
              }, _callee92, this);
            }));
          }
        }, {
          key: "getLocalPeer",
          value: function getLocalPeer() {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee93() {
              return _regeneratorRuntime().wrap(function _callee93$(_context100) {
                while (1) switch (_context100.prev = _context100.next) {
                  case 0:
                    _context100.next = 2;
                    return this.localPeer;
                  case 2:
                    return _context100.abrupt("return", _context100.sent);
                  case 3:
                  case "end":
                    return _context100.stop();
                }
              }, _callee93, this);
            }));
          }
        }, {
          key: "getPeers",
          value: function getPeers() {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee94() {
              return _regeneratorRuntime().wrap(function _callee94$(_context101) {
                while (1) switch (_context101.prev = _context101.next) {
                  case 0:
                    _context101.t0 = this.config.signalingClient;
                    _context101.next = 3;
                    return this.config.getToken();
                  case 3:
                    _context101.t1 = _context101.sent;
                    _context101.next = 6;
                    return _context101.t0.getPeers.call(_context101.t0, _context101.t1);
                  case 6:
                    return _context101.abrupt("return", _context101.sent);
                  case 7:
                  case "end":
                    return _context101.stop();
                }
              }, _callee94, this);
            }));
          }
        }, {
          key: "getPing",
          value: function getPing(e2) {
            var t2 = this.getActiveConnection(e2);
            if (t2) return t2.getPing();
            h.a.warn("Attempted to get ping time from inactive peer.");
          }
        }, {
          key: "getLastMessageTimestamp",
          value: function getLastMessageTimestamp(e2) {
            var t2 = this.getActiveConnection(e2);
            if (t2) return t2.getLastMessageTimestamp();
            h.a.warn("Attempted to get ping time from inactive peer.");
          }
        }, {
          key: "shutdown",
          value: function shutdown() {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee95() {
              var e2;
              return _regeneratorRuntime().wrap(function _callee95$(_context102) {
                while (1) switch (_context102.prev = _context102.next) {
                  case 0:
                    _context102.next = 2;
                    return this.updateInterval.stop();
                  case 2:
                    e2 = this.connections;
                    this.connections = [];
                    _context102.next = 6;
                    return this.closeConnections(e2);
                  case 6:
                  case "end":
                    return _context102.stop();
                }
              }, _callee95, this);
            }));
          }
        }, {
          key: "closeConnection",
          value: function closeConnection(e2) {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee96() {
              return _regeneratorRuntime().wrap(function _callee96$(_context103) {
                while (1) switch (_context103.prev = _context103.next) {
                  case 0:
                    this.connectingSessions.delete(e2.getSessionId());
                    _context103.next = 3;
                    return e2.close();
                  case 3:
                    _context103.prev = 3;
                    _context103.t0 = this.config.signalingClient;
                    _context103.next = 7;
                    return this.config.getToken();
                  case 7:
                    _context103.t1 = _context103.sent;
                    _context103.t2 = e2.getSessionId();
                    _context103.next = 11;
                    return _context103.t0.deleteSession.call(_context103.t0, _context103.t1, _context103.t2);
                  case 11:
                    _context103.next = 16;
                    break;
                  case 13:
                    _context103.prev = 13;
                    _context103.t3 = _context103["catch"](3);
                    Object(ce.a)(_context103.t3, fe.a, function (e4) {
                      return 404 === e4.statusCode;
                    });
                  case 16:
                  case "end":
                    return _context103.stop();
                }
              }, _callee96, this, [[3, 13]]);
            }));
          }
        }, {
          key: "getSessions",
          value: function getSessions() {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee97() {
              var e2;
              return _regeneratorRuntime().wrap(function _callee97$(_context104) {
                while (1) switch (_context104.prev = _context104.next) {
                  case 0:
                    _context104.next = 2;
                    return this.getLocalPeer();
                  case 2:
                    e2 = _context104.sent;
                    _context104.t0 = this.config.signalingClient;
                    _context104.next = 6;
                    return this.config.getToken();
                  case 6:
                    _context104.t1 = _context104.sent;
                    _context104.next = 9;
                    return _context104.t0.getSessions.call(_context104.t0, _context104.t1);
                  case 9:
                    return _context104.abrupt("return", _context104.sent.filter(function (t2) {
                      return t2.offer.peer.id === e2.id || t2.answer.peer.id === e2.id;
                    }));
                  case 10:
                  case "end":
                    return _context104.stop();
                }
              }, _callee97, this);
            }));
          }
        }, {
          key: "createPeer",
          value: function createPeer() {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee98() {
              return _regeneratorRuntime().wrap(function _callee98$(_context105) {
                while (1) switch (_context105.prev = _context105.next) {
                  case 0:
                    _context105.t0 = this.config.signalingClient;
                    _context105.next = 3;
                    return this.config.getToken();
                  case 3:
                    _context105.t1 = _context105.sent;
                    _context105.t2 = {
                      capabilitySet: this.config.capabilitySet || {}
                    };
                    _context105.next = 7;
                    return _context105.t0.createPeer.call(_context105.t0, _context105.t1, _context105.t2);
                  case 7:
                    return _context105.abrupt("return", _context105.sent);
                  case 8:
                  case "end":
                    return _context105.stop();
                }
              }, _callee98, this);
            }));
          }
        }, {
          key: "createRTCPeerConnection",
          value: function createRTCPeerConnection() {
            var e2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee99() {
              return _regeneratorRuntime().wrap(function _callee99$(_context106) {
                while (1) switch (_context106.prev = _context106.next) {
                  case 0:
                    _context106.t0 = this.config.alternateRTCPeerConnection || RTCPeerConnection;
                    _context106.t1 = Object;
                    _context106.t2 = this.config.signalingClient;
                    _context106.next = 5;
                    return this.config.getToken();
                  case 5:
                    _context106.t3 = _context106.sent;
                    _context106.next = 8;
                    return _context106.t2.getIceServers.call(_context106.t2, _context106.t3);
                  case 8:
                    _context106.t4 = _context106.sent;
                    _context106.t5 = {
                      iceServers: _context106.t4
                    };
                    _context106.t6 = e2;
                    _context106.t7 = _context106.t1.assign.call(_context106.t1, _context106.t5, _context106.t6);
                    return _context106.abrupt("return", new _context106.t0(_context106.t7));
                  case 13:
                  case "end":
                    return _context106.stop();
                }
              }, _callee99, this);
            }));
          }
        }, {
          key: "closeConnections",
          value: function closeConnections(e2) {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee101() {
              var _this42 = this;
              var t2, _iterator19, _step19, e3;
              return _regeneratorRuntime().wrap(function _callee101$(_context108) {
                while (1) switch (_context108.prev = _context108.next) {
                  case 0:
                    _context108.next = 2;
                    return D(e2.map(function (e3) {
                      return be(_this42, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee100() {
                        return _regeneratorRuntime().wrap(function _callee100$(_context107) {
                          while (1) switch (_context107.prev = _context107.next) {
                            case 0:
                              _context107.next = 2;
                              return this.closeConnection(e3);
                            case 2:
                            case "end":
                              return _context107.stop();
                          }
                        }, _callee100, this);
                      }));
                    }));
                  case 2:
                    t2 = _context108.sent;
                    _iterator19 = _createForOfIteratorHelper(t2);
                    try {
                      for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                        e3 = _step19.value;
                        h.a.warn("Request to close session failed", {
                          error: e3
                        });
                      }
                    } catch (err) {
                      _iterator19.e(err);
                    } finally {
                      _iterator19.f();
                    }
                  case 5:
                  case "end":
                    return _context108.stop();
                }
              }, _callee101);
            }));
          }
        }, {
          key: "reset",
          value: function reset() {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee102() {
              return _regeneratorRuntime().wrap(function _callee102$(_context109) {
                while (1) switch (_context109.prev = _context109.next) {
                  case 0:
                    _context109.next = 2;
                    return this.closeConnections(this.connections);
                  case 2:
                    this.connections = [];
                    this.connectingSessions = /* @__PURE__ */new Map();
                    this.localPeer = this.createPeer();
                    _context109.next = 7;
                    return this.localPeer;
                  case 7:
                  case "end":
                    return _context109.stop();
                }
              }, _callee102, this);
            }));
          }
        }, {
          key: "getActiveConnection",
          value: function getActiveConnection(e2) {
            return this.connections.find(function (t2) {
              return t2.getRemotePeer().id === e2 && t2.isActive();
            });
          }
        }, {
          key: "update",
          value: function update() {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee103() {
              var e2;
              return _regeneratorRuntime().wrap(function _callee103$(_context110) {
                while (1) switch (_context110.prev = _context110.next) {
                  case 0:
                    _context110.next = 2;
                    return this.getLocalPeer();
                  case 2:
                    e2 = _context110.sent;
                    _context110.prev = 3;
                    _context110.t0 = this.config.signalingClient;
                    _context110.next = 7;
                    return this.config.getToken();
                  case 7:
                    _context110.t1 = _context110.sent;
                    _context110.t2 = e2.id;
                    _context110.next = 11;
                    return _context110.t0.refreshPeer.call(_context110.t0, _context110.t1, _context110.t2);
                  case 11:
                    _context110.next = 19;
                    break;
                  case 13:
                    _context110.prev = 13;
                    _context110.t3 = _context110["catch"](3);
                    Object(ce.a)(_context110.t3, fe.a, function (e3) {
                      return 404 === e3.statusCode;
                    });
                    h.a.warn("Peer expired, creating new peer", {
                      peerId: e2.id
                    });
                    _context110.next = 19;
                    return this.reset();
                  case 19:
                    _context110.t4 = this;
                    _context110.next = 22;
                    return this.getSessions();
                  case 22:
                    _context110.t5 = _context110.sent;
                    _context110.next = 25;
                    return _context110.t4.handleSessions.call(_context110.t4, _context110.t5);
                  case 25:
                  case "end":
                    return _context110.stop();
                }
              }, _callee103, this, [[3, 13]]);
            }));
          }
        }, {
          key: "handleSessions",
          value: function handleSessions(e2) {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee105() {
              var _this43 = this;
              var t2;
              return _regeneratorRuntime().wrap(function _callee105$(_context112) {
                while (1) switch (_context112.prev = _context112.next) {
                  case 0:
                    _context112.next = 2;
                    return this.syncConnectionsAndSessions(e2);
                  case 2:
                    t2 = e2.map(function (e3) {
                      return {
                        session: e3,
                        connection: _this43.connections.find(function (t3) {
                          return t3.getSessionId() === e3.id;
                        })
                      };
                    });
                    _context112.next = 5;
                    return Promise.all(t2.map(function (_ref26) {
                      var e3 = _ref26.session,
                        t3 = _ref26.connection;
                      return be(_this43, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee104() {
                        return _regeneratorRuntime().wrap(function _callee104$(_context111) {
                          while (1) switch (_context111.prev = _context111.next) {
                            case 0:
                              _context111.next = 2;
                              return this.maintainConnection(e3, t3);
                            case 2:
                              return _context111.abrupt("return", _context111.sent);
                            case 3:
                            case "end":
                              return _context111.stop();
                          }
                        }, _callee104, this);
                      }));
                    }));
                  case 5:
                  case "end":
                    return _context112.stop();
                }
              }, _callee105, this);
            }));
          }
        }, {
          key: "syncConnectionsAndSessions",
          value: function syncConnectionsAndSessions(e2) {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee107() {
              var _this44 = this;
              var t2, r2, n2;
              return _regeneratorRuntime().wrap(function _callee107$(_context114) {
                while (1) switch (_context114.prev = _context114.next) {
                  case 0:
                    t2 = new Set(e2.map(function (e3) {
                      return e3.id;
                    })), r2 = function r2(e3) {
                      return t2.has(e3.getSessionId()) || _this44.connectingSessions.has(e3.getSessionId());
                    };
                    this.connections = this.connections.filter(function (e3) {
                      return r2(e3);
                    });
                    n2 = this.connections.filter(function (e3) {
                      return !r2(e3) || e3.needsClosing();
                    });
                    _context114.next = 5;
                    return Promise.all(n2.map(function (e3) {
                      return be(_this44, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee106() {
                        return _regeneratorRuntime().wrap(function _callee106$(_context113) {
                          while (1) switch (_context113.prev = _context113.next) {
                            case 0:
                              _context113.next = 2;
                              return this.closeConnection(e3);
                            case 2:
                            case "end":
                              return _context113.stop();
                          }
                        }, _callee106, this);
                      }));
                    }));
                  case 5:
                  case "end":
                    return _context114.stop();
                }
              }, _callee107, this);
            }));
          }
        }, {
          key: "maintainConnection",
          value: function maintainConnection(e2, t2) {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee108() {
              var r2, n2;
              return _regeneratorRuntime().wrap(function _callee108$(_context115) {
                while (1) switch (_context115.prev = _context115.next) {
                  case 0:
                    _context115.next = 2;
                    return this.getLocalPeer();
                  case 2:
                    r2 = _context115.sent;
                    n2 = e2.offer.peer.id === r2.id;
                    if (!t2) {
                      _context115.next = 34;
                      break;
                    }
                    if (!t2.isReady()) {
                      _context115.next = 21;
                      break;
                    }
                    _context115.prev = 6;
                    _context115.t0 = this.config.signalingClient;
                    _context115.next = 10;
                    return this.config.getToken();
                  case 10:
                    _context115.t1 = _context115.sent;
                    _context115.t2 = e2.id;
                    _context115.next = 14;
                    return _context115.t0.refreshSession.call(_context115.t0, _context115.t1, _context115.t2);
                  case 14:
                    _context115.next = 19;
                    break;
                  case 16:
                    _context115.prev = 16;
                    _context115.t3 = _context115["catch"](6);
                    Object(ce.a)(_context115.t3, fe.a, function (e3) {
                      return 404 === e3.statusCode;
                    }), h.a.debug("Refresh session not found", {
                      sessionId: e2.id
                    });
                  case 19:
                    _context115.next = 32;
                    break;
                  case 21:
                    if (!t2.isActive()) {
                      _context115.next = 32;
                      break;
                    }
                    _context115.prev = 22;
                    _context115.next = 25;
                    return this.consumeSignals(t2);
                  case 25:
                    _context115.next = 32;
                    break;
                  case 27:
                    _context115.prev = 27;
                    _context115.t4 = _context115["catch"](22);
                    h.a.warn("Failed to ingest signals, closing connection", {
                      error: _context115.t4
                    });
                    _context115.next = 32;
                    return this.closeConnection(t2);
                  case 32:
                    _context115.next = 38;
                    break;
                  case 34:
                    if (!n2) {
                      _context115.next = 36;
                      break;
                    }
                    return _context115.abrupt("return");
                  case 36:
                    _context115.next = 38;
                    return this.connectToSession(e2);
                  case 38:
                  case "end":
                    return _context115.stop();
                }
              }, _callee108, this, [[6, 16], [22, 27]]);
            }));
          }
        }, {
          key: "connectToSession",
          value: function connectToSession(e2) {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee109() {
              var _this45 = this;
              var t2, r2, n2, o2;
              return _regeneratorRuntime().wrap(function _callee109$(_context116) {
                while (1) switch (_context116.prev = _context116.next) {
                  case 0:
                    _context116.next = 2;
                    return this.getLocalPeer();
                  case 2:
                    t2 = _context116.sent;
                    r2 = e2.offer.peer.id === t2.id;
                    _context116.next = 6;
                    return this.createRTCPeerConnection();
                  case 6:
                    n2 = _context116.sent;
                    o2 = new me(n2, {
                      localPeer: r2 ? e2.offer.peer : e2.answer.peer,
                      remotePeer: r2 ? e2.answer.peer : e2.offer.peer,
                      sessionId: e2.id,
                      isOffer: r2,
                      sendSignal: function sendSignal(t3) {
                        return _this45.sendSignal(e2.id, t3);
                      },
                      receive: function receive(e3, t3) {
                        return _this45.config.receive(e3, t3);
                      }
                    });
                    if (!this.connections.find(function (t3) {
                      return t3.getSessionId() === e2.id;
                    })) {
                      _context116.next = 13;
                      break;
                    }
                    h.a.warn("connectToSession called on a session that already has a connection.", {
                      sessionId: e2.id
                    });
                    _context116.next = 12;
                    return o2.close();
                  case 12:
                    return _context116.abrupt("return", void _context116.sent);
                  case 13:
                    this.setupHandlers(o2), this.connections.push(o2);
                    _context116.prev = 14;
                    _context116.next = 17;
                    return o2.connect();
                  case 17:
                    _context116.next = 24;
                    break;
                  case 19:
                    _context116.prev = 19;
                    _context116.t0 = _context116["catch"](14);
                    h.a.warn("Failed to handle negotiation, closing connection", {
                      error: _context116.t0
                    });
                    _context116.next = 24;
                    return this.closeConnection(o2);
                  case 24:
                  case "end":
                    return _context116.stop();
                }
              }, _callee109, this, [[14, 19]]);
            }));
          }
        }, {
          key: "setupHandlers",
          value: function setupHandlers(e2) {
            var _this46 = this;
            var t2 = e2.peerConnection,
              r2 = e2.getSessionId();
            t2.onconnectionstatechange = function () {
              return be(_this46, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee110() {
                var n2, o2, e3;
                return _regeneratorRuntime().wrap(function _callee110$(_context117) {
                  while (1) switch (_context117.prev = _context117.next) {
                    case 0:
                      n2 = this.connectingSessions.get(r2);
                      if (!(void 0 === n2)) {
                        _context117.next = 3;
                        break;
                      }
                      return _context117.abrupt("return");
                    case 3:
                      o2 = t2.connectionState;
                      _context117.t0 = (ne(t2) && this.connectingSessions.delete(r2), o2);
                      _context117.next = _context117.t0 === "connected" ? 7 : _context117.t0 === "failed" ? 11 : 14;
                      break;
                    case 7:
                      this.connectingSessions.delete(r2);
                      e3 = new Date().getTime() - n2;
                      R.aggregate("rtc-connect-time", e3);
                      return _context117.abrupt("break", 14);
                    case 11:
                      R.increment("rtc-connect-failed");
                      _context117.next = 14;
                      return this.closeConnection(e2);
                    case 14:
                    case "end":
                      return _context117.stop();
                  }
                }, _callee110, this);
              }));
            };
          }
        }, {
          key: "consumeSignals",
          value: function consumeSignals(e2) {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee111() {
              var t2, _iterator20, _step20, r2;
              return _regeneratorRuntime().wrap(function _callee111$(_context118) {
                while (1) switch (_context118.prev = _context118.next) {
                  case 0:
                    t2 = [];
                    _context118.prev = 1;
                    _context118.t0 = this.config.signalingClient;
                    _context118.next = 5;
                    return this.config.getToken();
                  case 5:
                    _context118.t1 = _context118.sent;
                    _context118.t2 = e2.getSessionId();
                    _context118.next = 9;
                    return _context118.t0.takeSignals.call(_context118.t0, _context118.t1, _context118.t2);
                  case 9:
                    t2 = _context118.sent;
                    _context118.next = 15;
                    break;
                  case 12:
                    _context118.prev = 12;
                    _context118.t3 = _context118["catch"](1);
                    Object(ce.a)(_context118.t3, fe.a, function (e4) {
                      return 404 === e4.statusCode;
                    });
                  case 15:
                    _iterator20 = _createForOfIteratorHelper(t2);
                    _context118.prev = 16;
                    _iterator20.s();
                  case 18:
                    if ((_step20 = _iterator20.n()).done) {
                      _context118.next = 24;
                      break;
                    }
                    r2 = _step20.value;
                    _context118.next = 22;
                    return e2.handleSignal(r2);
                  case 22:
                    _context118.next = 18;
                    break;
                  case 24:
                    _context118.next = 29;
                    break;
                  case 26:
                    _context118.prev = 26;
                    _context118.t4 = _context118["catch"](16);
                    _iterator20.e(_context118.t4);
                  case 29:
                    _context118.prev = 29;
                    _iterator20.f();
                    return _context118.finish(29);
                  case 32:
                  case "end":
                    return _context118.stop();
                }
              }, _callee111, this, [[1, 12], [16, 26, 29, 32]]);
            }));
          }
        }, {
          key: "sendSignal",
          value: function sendSignal(e2, t2) {
            return be(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee112() {
              return _regeneratorRuntime().wrap(function _callee112$(_context119) {
                while (1) switch (_context119.prev = _context119.next) {
                  case 0:
                    _context119.prev = 0;
                    _context119.t0 = this.config.signalingClient;
                    _context119.next = 4;
                    return this.config.getToken();
                  case 4:
                    _context119.t1 = _context119.sent;
                    _context119.t2 = e2;
                    _context119.t3 = {
                      signals: [t2]
                    };
                    _context119.next = 9;
                    return _context119.t0.addSignals.call(_context119.t0, _context119.t1, _context119.t2, _context119.t3);
                  case 9:
                    _context119.next = 14;
                    break;
                  case 11:
                    _context119.prev = 11;
                    _context119.t4 = _context119["catch"](0);
                    Object(ce.a)(_context119.t4, fe.a, function (e4) {
                      return 404 === e4.statusCode;
                    });
                  case 14:
                  case "end":
                    return _context119.stop();
                }
              }, _callee112, this, [[0, 11]]);
            }));
          }
        }]);
        return ve;
      }();
    }, function (e, t, r) {
      var n = {
        randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
      };
      var o;
      var i = new Uint8Array(16);
      function s() {
        if (!o && (o = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !o)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        return o(i);
      }
      var a2 = [];
      for (var e2 = 0; e2 < 256; ++e2) a2.push((e2 + 256).toString(16).slice(1));
      function l(e2) {
        var t2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return (a2[e2[t2 + 0]] + a2[e2[t2 + 1]] + a2[e2[t2 + 2]] + a2[e2[t2 + 3]] + "-" + a2[e2[t2 + 4]] + a2[e2[t2 + 5]] + "-" + a2[e2[t2 + 6]] + a2[e2[t2 + 7]] + "-" + a2[e2[t2 + 8]] + a2[e2[t2 + 9]] + "-" + a2[e2[t2 + 10]] + a2[e2[t2 + 11]] + a2[e2[t2 + 12]] + a2[e2[t2 + 13]] + a2[e2[t2 + 14]] + a2[e2[t2 + 15]]).toLowerCase();
      }
      t.a = function (e2, t2, r2) {
        if (n.randomUUID && !t2 && !e2) return n.randomUUID();
        var o2 = (e2 = e2 || {}).random || (e2.rng || s)();
        if (o2[6] = 15 & o2[6] | 64, o2[8] = 63 & o2[8] | 128, t2) {
          r2 = r2 || 0;
          for (var e3 = 0; e3 < 16; ++e3) t2[r2 + e3] = o2[e3];
          return t2;
        }
        return l(o2);
      };
    },, function (e, t, r) {
      r.r(t), r.d(t, "LogClient", function () {
        return a2;
      });
      var n = r(28),
        o = r(10),
        i = r(11),
        s = function s(e2, t2, r2, n2) {
          return new (r2 || (r2 = Promise))(function (o2, i2) {
            function s2(e3) {
              try {
                l(n2.next(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function a3(e3) {
              try {
                l(n2.throw(e3));
              } catch (e4) {
                i2(e4);
              }
            }
            function l(e3) {
              var t3;
              e3.done ? o2(e3.value) : (t3 = e3.value, t3 instanceof r2 ? t3 : new r2(function (e4) {
                e4(t3);
              })).then(s2, a3);
            }
            l((n2 = n2.apply(e2, t2 || [])).next());
          });
        };
      var a2 = /*#__PURE__*/function (_n$a4) {
        _inherits(a2, _n$a4);
        function a2() {
          _classCallCheck(this, a2);
          return _possibleConstructorReturn(this, _getPrototypeOf(a2).apply(this, arguments));
        }
        _createClass(a2, [{
          key: "log",
          value: function log(e2) {
            return s(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee113() {
              var t2;
              return _regeneratorRuntime().wrap(function _callee113$(_context120) {
                while (1) switch (_context120.prev = _context120.next) {
                  case 0:
                    t2 = a2.token;
                    _context120.prev = 1;
                    _context120.next = 4;
                    return this.fetch("logs", {
                      token: t2,
                      method: "POST",
                      body: JSON.stringify({
                        logs: e2
                      }),
                      allowUnsafeRetries: true
                    });
                  case 4:
                    _context120.next = 12;
                    break;
                  case 6:
                    _context120.prev = 6;
                    _context120.t0 = _context120["catch"](1);
                    Object(o.a)(_context120.t0, i.a, function (e3) {
                      return 401 === e3.statusCode && void 0 !== t2;
                    });
                    a2.token === t2 && delete a2.token;
                    _context120.next = 12;
                    return this.log(e2);
                  case 12:
                  case "end":
                    return _context120.stop();
                }
              }, _callee113, this, [[1, 6]]);
            }));
          }
        }]);
        return a2;
      }(n.a);
    }]);
  });
})(dist);
function defined(value, errorMessage) {
  if (value !== void 0) {
    return value;
  }
  throw new Error(errorMessage || "Value is undefined");
}
var FORMANT_API_URL = "https://api.formant.io";
if (typeof window !== "undefined") {
  FORMANT_API_URL = window.FORMANT_API_URL || FORMANT_API_URL;
}
var urlParams$2 = new URLSearchParams("");
if (typeof window !== "undefined") {
  urlParams$2 = new URLSearchParams(window.location.search);
}
var envDev = urlParams$2.get("formant_dev");
if (envDev) {
  FORMANT_API_URL = "https://api-dev.formant.io";
}
var envStage = urlParams$2.get("formant_stage");
if (envStage) {
  FORMANT_API_URL = "https://api-stage.formant.io";
}
var envLocal = urlParams$2.get("formant_local");
if (envLocal) {
  FORMANT_API_URL = "https://api.formant.local";
}
var millisecond = 1;
var second = 1e3;
var minute = 60 * second;
var hour = 60 * minute;
var day = 24 * hour;
var week = 7 * day;
var month = 30 * day;
var year = 365 * day;
var duration = {
  millisecond: millisecond,
  second: second,
  minute: minute,
  hour: hour,
  day: day,
  week: week,
  month: month,
  year: year
};
function filterDataByType(datas, type) {
  return datas.filter(function (_) {
    return type.includes(_.type);
  });
}
function filterDataByTime(datas, start, end) {
  var startTime = start.getTime();
  var endTime = end.getTime();
  return datas.map(function (data) {
    return _objectSpread({}, data, {
      points: data.points.filter(function (_ref27) {
        var _ref28 = _slicedToArray(_ref27, 1),
          timestamp = _ref28[0];
        return timestamp >= startTime && timestamp < endTime;
      })
    });
  }).filter(function (_ref29) {
    var points = _ref29.points;
    return points.length > 0;
  });
}
function fork(_) {
  return void 0;
}
var StoreCache = /*#__PURE__*/function () {
  function StoreCache() {
    var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      capacity = _ref30.capacity,
      timeout2 = _ref30.timeout;
    _classCallCheck(this, StoreCache);
    __publicField(this, "entries", /* @__PURE__ */new Map());
    __publicField(this, "metadata", /* @__PURE__ */new Map());
    __publicField(this, "capacity");
    __publicField(this, "timeout");
    this.capacity = capacity || 1e4;
    this.timeout = timeout2 || duration.minute;
  }
  _createClass(StoreCache, [{
    key: "get",
    value: function get(key, generator) {
      var cacheKey = this.keyToCacheKey(key);
      var entry = this.entries.get(cacheKey);
      var metadata = this.metadata.get(cacheKey);
      if ((entry === void 0 || metadata && (metadata == null ? void 0 : metadata.expiration.getTime()) < Date.now()) && !(metadata == null ? void 0 : metadata.generating) && generator) {
        this.generate(key, generator());
      }
      if (entry === void 0 && metadata && metadata.lastValue !== void 0) {
        return metadata.lastValue;
      }
      return entry;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var cacheKey = this.keyToCacheKey(key);
      this.metadata.set(cacheKey, {
        generating: false,
        expiration: new Date(Date.now() + this.timeout),
        lastValue: value
      });
      this.entries.set(cacheKey, value);
      if (this.metadata.size > this.capacity) {
        this.deleteOldestEntry();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.entries.clear();
      _toConsumableArray(this.metadata.values()).forEach(function (value) {
        return value.generating = false;
      });
    }
  }, {
    key: "clearKey",
    value: function clearKey(key) {
      this.metadata.delete(key);
      this.entries.delete(key);
    }
  }, {
    key: "keyToCacheKey",
    value: function keyToCacheKey(key) {
      return JSON.stringify(key);
    }
  }, {
    key: "deleteOldestEntry",
    value: function deleteOldestEntry() {
      if (this.metadata.size < 1) {
        return;
      }
      var _reduce = _toConsumableArray(this.metadata.entries()).reduce(function (_ref31, _ref32) {
          var _ref33 = _slicedToArray(_ref31, 2),
            oldestKey = _ref33[0],
            oldestEntry = _ref33[1];
          var _ref34 = _slicedToArray(_ref32, 2),
            thisKey = _ref34[0],
            entry = _ref34[1];
          return entry.expiration.getTime() < oldestEntry.expiration.getTime() ? [thisKey, entry] : [oldestKey, oldestEntry];
        }),
        _reduce2 = _slicedToArray(_reduce, 1),
        key = _reduce2[0];
      this.clearKey(key);
    }
  }, {
    key: "generate",
    value: function generate(key, promise) {
      var _this47 = this;
      var cacheKey = this.keyToCacheKey(key);
      var existingMetadata = this.metadata.get(cacheKey) || {};
      this.metadata.set(cacheKey, _objectSpread({}, existingMetadata, {
        generating: true,
        expiration: new Date(Date.now() + this.timeout)
      }));
      setTimeout(function () {
        fork(promise.then(function (value) {
          var metadata = _this47.metadata.get(cacheKey);
          var canceled = !(metadata == null ? void 0 : metadata.generating);
          if (!canceled) {
            _this47.set(key, value);
          }
        }));
      }, 0);
    }
  }]);
  return StoreCache;
}();
var QueryStore = /*#__PURE__*/function () {
  function QueryStore() {
    _classCallCheck(this, QueryStore);
    __publicField(this, "queryStoreCache", new StoreCache({
      capacity: 1e4,
      timeout: 20 * duration.second
    }));
    __publicField(this, "liveQueryStoreCache", new StoreCache({
      capacity: 1e4,
      timeout: 200 * duration.millisecond
    }));
  }
  _createClass(QueryStore, [{
    key: "moduleQuery",
    value: function moduleQuery(filter, name, type, start, end) {
      var latestOnly = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var q = _objectSpread({}, filter, {
        names: _toConsumableArray(name),
        types: _toConsumableArray(type)
      });
      var data = this.query(q, start, end, latestOnly);
      if (data === void 0 || data === "too much data") {
        return data;
      }
      return filterDataByType(data, type);
    }
  }, {
    key: "query",
    value: function query(filter, start, end) {
      var latestOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var q = _objectSpread({}, filter, {
        start: startOfMinute(start).toISOString(),
        end: latestOnly ? end.toISOString() : addMinutes(roundToNearestMinutes(end), 1).toISOString(),
        latestOnly: latestOnly
      });
      var isLive = end > addSeconds(new Date(), -20);
      var data;
      if (isLive) {
        data = this.liveQueryCache(q);
      } else {
        data = this.queryCache(q);
      }
      if (!data || data === "too much data") {
        return data;
      }
      if (latestOnly) {
        return data;
      }
      return filterDataByTime(data, start, end);
    }
  }, {
    key: "queryCache",
    value: function queryCache(query) {
      return this.queryStoreCache.get(query, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee114() {
        return _regeneratorRuntime().wrap(function _callee114$(_context121) {
          while (1) switch (_context121.prev = _context121.next) {
            case 0:
              _context121.prev = 0;
              _context121.next = 3;
              return Fleet.queryTelemetry(query);
            case 3:
              return _context121.abrupt("return", _context121.sent);
            case 6:
              _context121.prev = 6;
              _context121.t0 = _context121["catch"](0);
              throw _context121.t0;
            case 9:
            case "end":
              return _context121.stop();
          }
        }, _callee114, null, [[0, 6]]);
      })));
    }
  }, {
    key: "liveQueryCache",
    value: function liveQueryCache(query) {
      return this.liveQueryStoreCache.get(query, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee115() {
        return _regeneratorRuntime().wrap(function _callee115$(_context122) {
          while (1) switch (_context122.prev = _context122.next) {
            case 0:
              _context122.prev = 0;
              _context122.next = 3;
              return Fleet.queryTelemetry(query);
            case 3:
              return _context122.abrupt("return", _context122.sent);
            case 6:
              _context122.prev = 6;
              _context122.t0 = _context122["catch"](0);
              throw _context122.t0;
            case 9:
            case "end":
              return _context122.stop();
          }
        }, _callee115, null, [[0, 6]]);
      })));
    }
  }]);
  return QueryStore;
}();
var queryStore = new QueryStore();
var App = /*#__PURE__*/function () {
  function App() {
    _classCallCheck(this, App);
  }
  _createClass(App, null, [{
    key: "sendAppMessage",
    value: function sendAppMessage(message) {
      window.parent.postMessage(message, "*");
    }
  }, {
    key: "getCurrentModuleContext",
    value: function getCurrentModuleContext() {
      var urlParams2 = new URLSearchParams("");
      if (typeof window !== "undefined") {
        urlParams2 = new URLSearchParams(window.location.search);
      }
      var moduleName2 = urlParams2.get("module");
      return moduleName2;
    }
  }, {
    key: "getCurrentModuleConfiguration",
    value: function () {
      var _getCurrentModuleConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee116() {
        var urlParams2, configurationId, response, moduleConfiguration;
        return _regeneratorRuntime().wrap(function _callee116$(_context123) {
          while (1) switch (_context123.prev = _context123.next) {
            case 0:
              urlParams2 = new URLSearchParams("");
              if (typeof window !== "undefined") {
                urlParams2 = new URLSearchParams(window.location.search);
              }
              configurationId = urlParams2.get("configuration");
              if (!(configurationId === null || configurationId.trim() === "")) {
                _context123.next = 5;
                break;
              }
              return _context123.abrupt("return", void 0);
            case 5:
              _context123.next = 7;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/module-configurations/") + configurationId, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 7:
              response = _context123.sent;
              _context123.next = 10;
              return response.json();
            case 10:
              moduleConfiguration = _context123.sent;
              return _context123.abrupt("return", moduleConfiguration.configuration);
            case 12:
            case "end":
              return _context123.stop();
          }
        }, _callee116);
      }));
      function getCurrentModuleConfiguration() {
        return _getCurrentModuleConfiguration.apply(this, arguments);
      }
      return getCurrentModuleConfiguration;
    }()
  }, {
    key: "isModule",
    value: function isModule() {
      return this.getCurrentModuleContext() !== null;
    }
  }, {
    key: "goToTime",
    value: function goToTime(date) {
      this.sendAppMessage({
        type: "go_to_time",
        time: date.getTime()
      });
    }
  }, {
    key: "goToDevice",
    value: function goToDevice(deviceId) {
      this.sendAppMessage({
        type: "go_to_device",
        deviceId: deviceId
      });
    }
  }, {
    key: "showMessage",
    value: function showMessage(message) {
      this.sendAppMessage({
        type: "show_message",
        message: message
      });
    }
  }, {
    key: "requestModuleData",
    value: function requestModuleData() {
      var moduleName2 = this.getCurrentModuleContext();
      if (!moduleName2) {
        throw new Error("No module context");
      }
      this.sendAppMessage({
        type: "request_module_data",
        module: moduleName2
      });
    }
  }, {
    key: "setModuleDateTimeRange",
    value: function setModuleDateTimeRange(beforeInMilliseconds, afterInMilliseconds) {
      var moduleName2 = this.getCurrentModuleContext();
      if (!moduleName2) {
        throw new Error("No module context");
      }
      this.sendAppMessage({
        type: "set_module_data_time_range",
        module: moduleName2,
        before: beforeInMilliseconds,
        after: afterInMilliseconds || 0
      });
    }
  }, {
    key: "refreshAuthToken",
    value: function refreshAuthToken() {
      var moduleName2 = this.getCurrentModuleContext();
      if (!moduleName2) {
        throw new Error("No module context");
      }
      this.sendAppMessage({
        type: "refresh_auth_token",
        module: moduleName2
      });
    }
  }, {
    key: "sendChannelData",
    value: function sendChannelData(channel, data) {
      var moduleName2 = this.getCurrentModuleContext();
      if (!moduleName2) {
        throw new Error("No module context");
      }
      this.sendAppMessage({
        type: "send_channel_data",
        source: moduleName2,
        channel: channel,
        data: data
      });
    }
  }, {
    key: "setupModuleMenus",
    value: function setupModuleMenus(menus) {
      var moduleName2 = this.getCurrentModuleContext();
      if (!moduleName2) {
        throw new Error("No module context");
      }
      this.sendAppMessage({
        type: "setup_module_menus",
        module: moduleName2,
        menus: menus
      });
    }
  }, {
    key: "addMenuListener",
    value: function addMenuListener(handler) {
      window.addEventListener("message", function (event) {
        var msg = event.data;
        if (msg.type === "module_menu_item_clicked") {
          handler(msg.menu);
        }
      });
    }
  }, {
    key: "addAccessTokenRefreshListener",
    value: function addAccessTokenRefreshListener(handler) {
      window.addEventListener("message", function (event) {
        var msg = event.data;
        if (msg.type === "auth_token") {
          handler(msg.token);
        }
      });
    }
  }, {
    key: "addModuleDataListener",
    value: function addModuleDataListener(handler) {
      var moduleName2 = this.getCurrentModuleContext();
      if (moduleName2) {
        this.sendAppMessage({
          type: "request_module_data",
          module: moduleName2
        });
      }
      window.addEventListener("message", function (event) {
        var msg = event.data;
        if (msg.type === "module_data") {
          handler({
            streams: msg.streams,
            time: msg.time,
            queryRange: msg.queryRange
          });
        }
      });
    }
  }, {
    key: "addStreamListener",
    value: function addStreamListener(streamNames, streamTypes, handler) {
      var listener = function listener(event) {
        var msg = event.data;
        if (msg.type === "module_data") {
          var _msg$queryRange = msg.queryRange,
            start = _msg$queryRange.start,
            end = _msg$queryRange.end;
          handler(queryStore.moduleQuery({}, streamNames, streamTypes, new Date(start), new Date(end), false));
        }
      };
      window.addEventListener("message", listener);
      return function () {
        return window.removeEventListener("message", listener);
      };
    }
  }, {
    key: "addModuleConfigurationListener",
    value: function addModuleConfigurationListener(handler) {
      window.addEventListener("message", function (event) {
        var msg = event.data;
        if (msg.type === "module_configuration") {
          handler(msg);
        }
      });
    }
  }, {
    key: "addChannelDataListener",
    value: function addChannelDataListener(channel, handler) {
      window.addEventListener("message", function (event) {
        var msg = event.data;
        if (msg.type === "channel_data" && msg.channel === channel) {
          handler({
            source: msg.source,
            data: msg.data
          });
        }
      });
    }
  }, {
    key: "requestOverviewDevices",
    value: function requestOverviewDevices(handler) {
      this.sendAppMessage({
        type: "request_devices"
      });
      window.addEventListener("message", function (event) {
        var msg = event.data;
        handler(msg);
      });
    }
  }, {
    key: "prompt",
    value: function () {
      var _prompt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee117(schema, options) {
        var _this48 = this;
        return _regeneratorRuntime().wrap(function _callee117$(_context124) {
          while (1) switch (_context124.prev = _context124.next) {
            case 0:
              return _context124.abrupt("return", new Promise(function (resolve) {
                var promptId = Math.random().toString();
                _this48.sendAppMessage({
                  type: "prompt",
                  promptId: promptId,
                  schema: schema,
                  okText: options == null ? void 0 : options.okText,
                  cancelText: options == null ? void 0 : options.cancelText
                });
                var handler = function handler(event) {
                  var msg = event.data;
                  if (msg.type === "prompt_response" && msg.promptId === promptId) {
                    resolve(msg.data);
                  }
                  window.removeEventListener("message", handler);
                };
                window.addEventListener("message", handler);
              }));
            case 1:
            case "end":
              return _context124.stop();
          }
        }, _callee117);
      }));
      function prompt(_x2, _x3) {
        return _prompt.apply(this, arguments);
      }
      return prompt;
    }()
  }]);
  return App;
}();
var _Authentication = /*#__PURE__*/function () {
  function _Authentication() {
    _classCallCheck(this, _Authentication);
  }
  _createClass(_Authentication, null, [{
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee118(email, password) {
        var result, auth;
        return _regeneratorRuntime().wrap(function _callee118$(_context125) {
          while (1) switch (_context125.prev = _context125.next) {
            case 0:
              _context125.prev = 0;
              _context125.next = 3;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/auth/login"), {
                method: "POST",
                body: JSON.stringify({
                  email: email,
                  password: password
                }),
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 3:
              result = _context125.sent;
              _context125.next = 6;
              return result.json();
            case 6:
              auth = _context125.sent;
              if (!(result.status !== 200)) {
                _context125.next = 9;
                break;
              }
              throw new Error(auth.message);
            case 9:
              _context125.next = 11;
              return _Authentication.loginWithToken(auth.authentication.accessToken, auth.authentication.refreshToken);
            case 11:
              return _context125.abrupt("return", auth.authentication);
            case 14:
              _context125.prev = 14;
              _context125.t0 = _context125["catch"](0);
              _Authentication.waitingForAuth.forEach(function (_) {
                return _(false);
              });
              _Authentication.waitingForAuth = [];
              return _context125.abrupt("return", Promise.reject(_context125.t0));
            case 19:
            case "end":
              return _context125.stop();
          }
        }, _callee118, null, [[0, 14]]);
      }));
      function login(_x4, _x5) {
        return _login.apply(this, arguments);
      }
      return login;
    }()
  }, {
    key: "loginWithToken",
    value: function () {
      var _loginWithToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee120(token, refreshToken) {
        var tokenData, userId, result, data;
        return _regeneratorRuntime().wrap(function _callee120$(_context127) {
          while (1) switch (_context127.prev = _context127.next) {
            case 0:
              tokenData = JSON.parse(atob(token.split(".")[1]));
              _context127.prev = 1;
              _Authentication.isShareToken = tokenData["formant:claims"] && tokenData["formant:claims"].type == "share";
              if (tokenData["formant:claims"]) {
                _Authentication.currentOrganization = tokenData["formant:claims"].organizationId;
              }
              if (tokenData["custom:organization_id"]) {
                _Authentication.currentOrganization = tokenData["custom:organization_id"];
              }
              if (!_Authentication.isShareToken) {
                userId = tokenData.sub;
              }
              if (tokenData["formant:claims"] && tokenData["formant:claims"].userId) {
                userId = tokenData["formant:claims"].userId;
              }
              if (!userId) {
                _context127.next = 17;
                break;
              }
              _context127.next = 10;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/users/").concat(userId), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token
                }
              });
            case 10:
              result = _context127.sent;
              _context127.next = 13;
              return result.json();
            case 13:
              data = _context127.sent;
              if (!(result.status !== 200)) {
                _context127.next = 16;
                break;
              }
              throw new Error(data.message);
            case 16:
              _Authentication.currentUser = data;
            case 17:
              _Authentication.token = token;
              _Authentication.waitingForAuth.forEach(function (_) {
                return _(true);
              });
              _context127.next = 25;
              break;
            case 21:
              _context127.prev = 21;
              _context127.t0 = _context127["catch"](1);
              console.error(_context127.t0);
              _Authentication.waitingForAuth.forEach(function (_) {
                return _(false);
              });
            case 25:
              _Authentication.waitingForAuth = [];
              if (refreshToken) {
                _Authentication.refreshToken = refreshToken;
                setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee119() {
                  var _result, refreshData;
                  return _regeneratorRuntime().wrap(function _callee119$(_context126) {
                    while (1) switch (_context126.prev = _context126.next) {
                      case 0:
                        if (!_Authentication.refreshToken) {
                          _context126.next = 8;
                          break;
                        }
                        _context126.next = 3;
                        return fetch("".concat(FORMANT_API_URL, "/v1/admin/auth/refresh"), {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json"
                          },
                          body: JSON.stringify({
                            refreshToken: _Authentication.refreshToken
                          })
                        });
                      case 3:
                        _result = _context126.sent;
                        _context126.next = 6;
                        return _result.json();
                      case 6:
                        refreshData = _context126.sent;
                        _Authentication.token = refreshData.authentication.accessToken;
                      case 8:
                      case "end":
                        return _context126.stop();
                    }
                  }, _callee119);
                })), 1e3 * 60 * 60);
              }
            case 27:
            case "end":
              return _context127.stop();
          }
        }, _callee120, null, [[1, 21]]);
      }));
      function loginWithToken(_x6, _x7) {
        return _loginWithToken.apply(this, arguments);
      }
      return loginWithToken;
    }()
  }, {
    key: "isAuthenticated",
    value: function isAuthenticated() {
      return _Authentication.token !== void 0;
    }
  }, {
    key: "getCurrentUser",
    value: function getCurrentUser() {
      return _Authentication.currentUser;
    }
  }, {
    key: "waitTilAuthenticated",
    value: function () {
      var _waitTilAuthenticated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee121() {
        return _regeneratorRuntime().wrap(function _callee121$(_context128) {
          while (1) switch (_context128.prev = _context128.next) {
            case 0:
              if (!(_Authentication.token !== void 0)) {
                _context128.next = 4;
                break;
              }
              return _context128.abrupt("return", true);
            case 4:
              return _context128.abrupt("return", new Promise(function (resolve) {
                _Authentication.waitingForAuth.push(function (result) {
                  resolve(result);
                });
              }));
            case 5:
            case "end":
              return _context128.stop();
          }
        }, _callee121);
      }));
      function waitTilAuthenticated() {
        return _waitTilAuthenticated.apply(this, arguments);
      }
      return waitTilAuthenticated;
    }()
  }, {
    key: "listenForRefresh",
    value: function () {
      var _listenForRefresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee123() {
        var _this49 = this;
        return _regeneratorRuntime().wrap(function _callee123$(_context130) {
          while (1) switch (_context130.prev = _context130.next) {
            case 0:
              App.addAccessTokenRefreshListener(function (token) {
                _this49.loginWithToken(token);
              });
              setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee122() {
                return _regeneratorRuntime().wrap(function _callee122$(_context129) {
                  while (1) switch (_context129.prev = _context129.next) {
                    case 0:
                      App.refreshAuthToken();
                    case 1:
                    case "end":
                      return _context129.stop();
                  }
                }, _callee122);
              })), 1e3 * 60 * 60);
            case 2:
            case "end":
              return _context130.stop();
          }
        }, _callee123);
      }));
      function listenForRefresh() {
        return _listenForRefresh.apply(this, arguments);
      }
      return listenForRefresh;
    }()
  }]);
  return _Authentication;
}();
var Authentication = _Authentication;
__publicField(Authentication, "token");
__publicField(Authentication, "refreshToken");
__publicField(Authentication, "currentUser");
__publicField(Authentication, "currentOrganization");
__publicField(Authentication, "isShareToken", false);
__publicField(Authentication, "defaultDeviceId");
__publicField(Authentication, "waitingForAuth", []);
function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
var DataChannel = /*#__PURE__*/function () {
  function DataChannel(dataChannel) {
    var _this50 = this;
    _classCallCheck(this, DataChannel);
    __publicField(this, "ready", false);
    __publicField(this, "listeners", []);
    __publicField(this, "openListeners", []);
    __publicField(this, "closeListeners", []);
    __publicField(this, "errorListeners", []);
    __publicField(this, "binaryListeners", []);
    __publicField(this, "error");
    __publicField(this, "decoder", new TextDecoder());
    this.dataChannel = dataChannel;
    this.dataChannel.binaryType = "arraybuffer";
    this.dataChannel.onopen = function () {
      _this50.ready = true;
      _this50.openListeners.forEach(function (listener) {
        return listener();
      });
    };
    this.dataChannel.onclose = function () {
      _this50.ready = false;
      _this50.closeListeners.forEach(function (listener) {
        return listener();
      });
    };
    this.dataChannel.onerror = function (e) {
      console.error(e);
      _this50.error = "An error occurred in DataChannel";
      _this50.errorListeners.forEach(function (listener) {
        return listener(e);
      });
    };
    this.dataChannel.onmessage = function (m) {
      _this50.listeners.forEach(function (_) {
        var d = new Uint8Array(m.data);
        var s = _this50.decoder.decode(d);
        _(s);
      });
      _this50.binaryListeners.forEach(function (_) {
        _(new Uint8Array(m.data));
      });
    };
  }
  _createClass(DataChannel, [{
    key: "addOpenListener",
    value: function addOpenListener(listener) {
      this.openListeners.push(listener);
    }
  }, {
    key: "removeOpenListener",
    value: function removeOpenListener(listener) {
      this.openListeners = this.openListeners.filter(function (_) {
        return _ !== listener;
      });
    }
  }, {
    key: "addCloseListener",
    value: function addCloseListener(listener) {
      this.closeListeners.push(listener);
    }
  }, {
    key: "removeCloseListener",
    value: function removeCloseListener(listener) {
      this.closeListeners = this.closeListeners.filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "addErrorListener",
    value: function addErrorListener(listener) {
      this.errorListeners.push(listener);
    }
  }, {
    key: "removeErrorListener",
    value: function removeErrorListener(listener) {
      this.errorListeners = this.errorListeners.filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "waitTilReady",
    value: function () {
      var _waitTilReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee124() {
        var _this51 = this;
        var p;
        return _regeneratorRuntime().wrap(function _callee124$(_context131) {
          while (1) switch (_context131.prev = _context131.next) {
            case 0:
              if (!this.ready) {
                _context131.next = 2;
                break;
              }
              return _context131.abrupt("return", true);
            case 2:
              p = new Promise(function (resolve, reject) {
                var a2 = window.setInterval(function () {
                  if (_this51.ready) {
                    window.clearInterval(a2);
                    resolve(true);
                  }
                  if (_this51.error) {
                    reject(_this51.error);
                  }
                }, 10);
              });
              return _context131.abrupt("return", p);
            case 4:
            case "end":
              return _context131.stop();
          }
        }, _callee124, this);
      }));
      function waitTilReady() {
        return _waitTilReady.apply(this, arguments);
      }
      return waitTilReady;
    }()
  }, {
    key: "send",
    value: function send(data) {
      if (!this.ready) {
        throw new Error("Connection has been closed");
      }
      this.dataChannel.send(data);
    }
  }, {
    key: "sendBinary",
    value: function sendBinary(data) {
      if (!this.ready) {
        throw new Error("Connection has been closed");
      }
      this.dataChannel.send(data);
    }
  }, {
    key: "addListener",
    value: function addListener(listener) {
      this.listeners.push(listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(listener) {
      var i = this.listeners.indexOf(listener);
      if (i === -1) {
        throw new Error("Could not find data channel listener to remove");
      }
      if (this.error) {
        throw new Error(this.error);
      }
      this.listeners.splice(i, 1);
    }
  }, {
    key: "addBinaryListener",
    value: function addBinaryListener(listener) {
      this.binaryListeners.push(listener);
    }
  }, {
    key: "removeBinaryListener",
    value: function removeBinaryListener(listener) {
      var i = this.binaryListeners.indexOf(listener);
      if (i === -1) {
        throw new Error("Could not find data channel listener to remove");
      }
      if (this.error) {
        throw new Error(this.error);
      }
      this.binaryListeners.splice(i, 1);
    }
  }]);
  return DataChannel;
}();
var CaptureStream = /*#__PURE__*/function () {
  function CaptureStream(captureSession) {
    _classCallCheck(this, CaptureStream);
    __publicField(this, "token");
    this.captureSession = captureSession;
  }
  _createClass(CaptureStream, [{
    key: "ingestJSON",
    value: function () {
      var _ingestJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee125(value) {
        var result, authInfo;
        return _regeneratorRuntime().wrap(function _callee125$(_context132) {
          while (1) switch (_context132.prev = _context132.next) {
            case 0:
              if (this.token) {
                _context132.next = 8;
                break;
              }
              _context132.next = 3;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/capture-sessions/").concat(this.captureSession.code, "/authenticate"), {
                method: "POST"
              });
            case 3:
              result = _context132.sent;
              _context132.next = 6;
              return result.json();
            case 6:
              authInfo = _context132.sent;
              this.token = authInfo.token;
            case 8:
              _context132.next = 10;
              return fetch("".concat(FORMANT_API_URL, "/v1/ingest"), {
                method: "POST",
                body: JSON.stringify({
                  deviceId: this.captureSession.deviceId,
                  name: this.captureSession.streamName,
                  type: "json",
                  points: [[Date.now(), JSON.stringify(value)]]
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + this.token
                }
              });
            case 10:
            case "end":
              return _context132.stop();
          }
        }, _callee125, this);
      }));
      function ingestJSON(_x8) {
        return _ingestJSON.apply(this, arguments);
      }
      return ingestJSON;
    }()
  }]);
  return CaptureStream;
}();
var Manipulator = /*#__PURE__*/function () {
  function Manipulator(device, config) {
    var _this52 = this;
    _classCallCheck(this, Manipulator);
    __publicField(this, "currentListeners", []);
    __publicField(this, "onRealtimeMessage", function (_peerId, message) {
      if (message.payload.jointState) {
        _this52.currentListeners.forEach(function (listener) {
          if (message.payload.jointState) listener(message.payload.jointState);
        });
      }
    });
    this.device = device;
    this.config = config;
  }
  _createClass(Manipulator, [{
    key: "synchronize",
    value: function () {
      var _synchronize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee126() {
        return _regeneratorRuntime().wrap(function _callee126$(_context133) {
          while (1) switch (_context133.prev = _context133.next) {
            case 0:
              this.device.addRealtimeListener(this.onRealtimeMessage);
              this.device.startListeningToRealtimeDataStream(this.config.currentJointStateStream);
            case 2:
            case "end":
              return _context133.stop();
          }
        }, _callee126, this);
      }));
      function synchronize() {
        return _synchronize.apply(this, arguments);
      }
      return synchronize;
    }()
  }, {
    key: "desynchronize",
    value: function () {
      var _desynchronize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee127() {
        return _regeneratorRuntime().wrap(function _callee127$(_context134) {
          while (1) switch (_context134.prev = _context134.next) {
            case 0:
              this.device.removeRealtimeListener(this.onRealtimeMessage);
              this.device.stopListeningToRealtimeDataStream(this.config.currentJointStateStream);
            case 2:
            case "end":
              return _context134.stop();
          }
        }, _callee127, this);
      }));
      function desynchronize() {
        return _desynchronize.apply(this, arguments);
      }
      return desynchronize;
    }()
  }, {
    key: "addCurrentJointStateListener",
    value: function () {
      var _addCurrentJointStateListener = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee128(listener) {
        return _regeneratorRuntime().wrap(function _callee128$(_context135) {
          while (1) switch (_context135.prev = _context135.next) {
            case 0:
              this.currentListeners.push(listener);
            case 1:
            case "end":
              return _context135.stop();
          }
        }, _callee128, this);
      }));
      function addCurrentJointStateListener(_x9) {
        return _addCurrentJointStateListener.apply(this, arguments);
      }
      return addCurrentJointStateListener;
    }()
  }]);
  return Manipulator;
}();
var RequestDataChannel = /*#__PURE__*/function () {
  function RequestDataChannel(device, channel_name, timeout2) {
    _classCallCheck(this, RequestDataChannel);
    __publicField(this, "channel");
    __publicField(this, "requestIdToResponseMap", /* @__PURE__ */new Map());
    this.device = device;
    this.channel_name = channel_name;
    this.timeout = timeout2;
  }
  _createClass(RequestDataChannel, [{
    key: "addOpenListener",
    value: function addOpenListener(listener) {
      defined(this.channel, "channel not initalized").addOpenListener(listener);
    }
  }, {
    key: "removeOpenListener",
    value: function removeOpenListener(listener) {
      defined(this.channel, "channel not initalized").removeOpenListener(listener);
    }
  }, {
    key: "addCloseListener",
    value: function addCloseListener(listener) {
      defined(this.channel, "channel not initalized").addCloseListener(listener);
    }
  }, {
    key: "removeCloseListener",
    value: function removeCloseListener(listener) {
      defined(this.channel, "channel not initalized").removeCloseListener(listener);
    }
  }, {
    key: "addErrorListener",
    value: function addErrorListener(listener) {
      defined(this.channel, "channel not initalized").addErrorListener(listener);
    }
  }, {
    key: "removeErrorListener",
    value: function removeErrorListener(listener) {
      defined(this.channel, "channel not initalized").removeErrorListener(listener);
    }
  }]);
  return RequestDataChannel;
}();
var BinaryRequestDataChannel = /*#__PURE__*/function (_RequestDataChannel) {
  _inherits(BinaryRequestDataChannel, _RequestDataChannel);
  function BinaryRequestDataChannel() {
    var _this53;
    _classCallCheck(this, BinaryRequestDataChannel);
    _this53 = _possibleConstructorReturn(this, _getPrototypeOf(BinaryRequestDataChannel).apply(this, arguments));
    __publicField(_assertThisInitialized(_assertThisInitialized(_this53)), "RESPONSE_SUCCESS_BYTE", 0);
    __publicField(_assertThisInitialized(_assertThisInitialized(_this53)), "decoder", new TextDecoder());
    return _this53;
  }
  _createClass(BinaryRequestDataChannel, [{
    key: "generateBinaryId",
    value: function generateBinaryId() {
      var id = new Uint8Array(16);
      for (var i = 0; i < id.length; i++) {
        id[i] = Math.floor(Math.random() * 256);
      }
      return id;
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee129() {
        var _this54 = this;
        return _regeneratorRuntime().wrap(function _callee129$(_context136) {
          while (1) switch (_context136.prev = _context136.next) {
            case 0:
              _context136.next = 2;
              return this.device.createCustomDataChannel(this.channel_name);
            case 2:
              this.channel = _context136.sent;
              this.channel.addBinaryListener(function (message) {
                var binaryId = message.slice(0, 16);
                var id = binaryId.toString();
                if (id.length === 0) {
                  throw new Error("Invalid response");
                }
                var response = message.slice(16);
                if (response.length === 0) {
                  throw new Error("Invalid response");
                }
                if (_this54.requestIdToResponseMap.has(id)) {
                  _this54.requestIdToResponseMap.set(id, response);
                }
              });
            case 4:
            case "end":
              return _context136.stop();
          }
        }, _callee129, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee130(data) {
        var channel, requestIdToResponseMap, timeout2, binaryId, id, start, response, success, payload;
        return _regeneratorRuntime().wrap(function _callee130$(_context137) {
          while (1) switch (_context137.prev = _context137.next) {
            case 0:
              if (this.channel) {
                _context137.next = 3;
                break;
              }
              _context137.next = 3;
              return this.initialize();
            case 3:
              if (this.channel) {
                _context137.next = 5;
                break;
              }
              throw new Error("Failed to create channel");
            case 5:
              channel = this.channel, requestIdToResponseMap = this.requestIdToResponseMap, timeout2 = this.timeout;
              _context137.next = 8;
              return channel.waitTilReady();
            case 8:
              binaryId = this.generateBinaryId();
              id = binaryId.toString();
              requestIdToResponseMap.set(id, true);
              channel.sendBinary(new Uint8Array([].concat(_toConsumableArray(binaryId), _toConsumableArray(data))));
              start = new Date().getTime();
            case 13:
              if (!(new Date().getTime() < start + timeout2)) {
                _context137.next = 30;
                break;
              }
              _context137.next = 16;
              return delay(50);
            case 16:
              if (!requestIdToResponseMap.has(id)) {
                _context137.next = 28;
                break;
              }
              response = requestIdToResponseMap.get(id);
              if (!(response !== true)) {
                _context137.next = 28;
                break;
              }
              requestIdToResponseMap.delete(id);
              success = response[0] === this.RESPONSE_SUCCESS_BYTE;
              payload = response.slice(1);
              if (!success) {
                _context137.next = 26;
                break;
              }
              return _context137.abrupt("return", payload);
            case 26:
              console.error({
                name: "AdapterError",
                message: this.decoder.decode(payload)
              });
              throw new Error("Binary request datachannel adapter error");
            case 28:
              _context137.next = 13;
              break;
            case 30:
              requestIdToResponseMap.delete(id);
              console.error({
                name: "TimeoutError",
                message: "Request timed out after ".concat(timeout2 / 1e3, " seconds")
              });
              throw new Error("Binary request data channel request timed out");
            case 33:
            case "end":
              return _context137.stop();
          }
        }, _callee130, this);
      }));
      function request(_x10) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }]);
  return BinaryRequestDataChannel;
}(RequestDataChannel);
var TextRequestDataChannel = /*#__PURE__*/function (_RequestDataChannel2) {
  _inherits(TextRequestDataChannel, _RequestDataChannel2);
  function TextRequestDataChannel() {
    _classCallCheck(this, TextRequestDataChannel);
    return _possibleConstructorReturn(this, _getPrototypeOf(TextRequestDataChannel).apply(this, arguments));
  }
  _createClass(TextRequestDataChannel, [{
    key: "generateTextId",
    value: function generateTextId() {
      return Math.random().toString(36).substring(2) + "-" + Math.random().toString(36).substring(2);
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee131() {
        var _this55 = this;
        return _regeneratorRuntime().wrap(function _callee131$(_context138) {
          while (1) switch (_context138.prev = _context138.next) {
            case 0:
              _context138.next = 2;
              return this.device.createCustomDataChannel(this.channel_name);
            case 2:
              this.channel = _context138.sent;
              this.channel.addListener(function (message) {
                var response = JSON.parse(message);
                var id = response.id,
                  data = response.data,
                  error = response.error;
                if (!id) {
                  throw new Error("Invalid response");
                }
                if (!data && !error) {
                  throw new Error("Invalid response");
                }
                if (_this55.requestIdToResponseMap.has(id)) {
                  _this55.requestIdToResponseMap.set(id, response);
                }
              });
            case 4:
            case "end":
              return _context138.stop();
          }
        }, _callee131, this);
      }));
      function initialize() {
        return _initialize2.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "request",
    value: function () {
      var _request2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee132(data) {
        var channel, requestIdToResponseMap, timeout2, id, start, response, data2, error;
        return _regeneratorRuntime().wrap(function _callee132$(_context139) {
          while (1) switch (_context139.prev = _context139.next) {
            case 0:
              if (this.channel) {
                _context139.next = 3;
                break;
              }
              _context139.next = 3;
              return this.initialize();
            case 3:
              if (this.channel) {
                _context139.next = 5;
                break;
              }
              throw new Error("Failed to create channel");
            case 5:
              channel = this.channel, requestIdToResponseMap = this.requestIdToResponseMap, timeout2 = this.timeout;
              _context139.next = 8;
              return channel.waitTilReady();
            case 8:
              id = this.generateTextId();
              requestIdToResponseMap.set(id, true);
              channel.send(JSON.stringify({
                id: id,
                data: data
              }));
              start = new Date().getTime();
            case 12:
              if (!(new Date().getTime() < start + timeout2)) {
                _context139.next = 27;
                break;
              }
              _context139.next = 15;
              return delay(50);
            case 15:
              if (!requestIdToResponseMap.has(id)) {
                _context139.next = 25;
                break;
              }
              response = requestIdToResponseMap.get(id);
              if (!(response !== true)) {
                _context139.next = 25;
                break;
              }
              requestIdToResponseMap.delete(id);
              data2 = response.data, error = response.error;
              if (!data2) {
                _context139.next = 22;
                break;
              }
              return _context139.abrupt("return", data2);
            case 22:
              if (!error) {
                _context139.next = 25;
                break;
              }
              console.error({
                name: "AdapterError",
                message: error
              });
              throw new Error("Text request datachannel adapter error");
            case 25:
              _context139.next = 12;
              break;
            case 27:
              requestIdToResponseMap.delete(id);
              console.error({
                name: "TimeoutError",
                message: "Request timed out after ".concat(timeout2 / 1e3, " seconds")
              });
              throw new Error("Text request datachannel request timed out");
            case 30:
            case "end":
              return _context139.stop();
          }
        }, _callee132, this);
      }));
      function request(_x11) {
        return _request2.apply(this, arguments);
      }
      return request;
    }()
  }]);
  return TextRequestDataChannel;
}(RequestDataChannel);
var urlParams$1 = new URLSearchParams(window.location.search);
var rtcClientVersion = urlParams$1.get("rtc_client");
var SessionType = {
  Teleop: 1,
  Observe: 3
};
var Device = /*#__PURE__*/function () {
  function Device(id, name, organizationId) {
    var _this56 = this;
    _classCallCheck(this, Device);
    __publicField(this, "rtcClient");
    __publicField(this, "remoteDevicePeerId");
    __publicField(this, "realtimeListeners", []);
    __publicField(this, "handleMessage", function (peerId, message) {
      _this56.realtimeListeners.forEach(function (_) {
        return _(peerId, message);
      });
    });
    this.id = id;
    this.name = name;
    this.organizationId = organizationId;
  }
  _createClass(Device, [{
    key: "getLatestTelemetry",
    value: function () {
      var _getLatestTelemetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee133() {
        var data, telemetry;
        return _regeneratorRuntime().wrap(function _callee133$(_context140) {
          while (1) switch (_context140.prev = _context140.next) {
            case 0:
              _context140.next = 2;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/stream-current-value"), {
                method: "POST",
                body: JSON.stringify({
                  deviceIds: [this.id]
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 2:
              data = _context140.sent;
              _context140.next = 5;
              return data.json();
            case 5:
              telemetry = _context140.sent;
              return _context140.abrupt("return", telemetry.items);
            case 7:
            case "end":
              return _context140.stop();
          }
        }, _callee133, this);
      }));
      function getLatestTelemetry() {
        return _getLatestTelemetry.apply(this, arguments);
      }
      return getLatestTelemetry;
    }()
  }, {
    key: "getConfiguration",
    value: function () {
      var _getConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee134() {
        var result, device, version, config;
        return _regeneratorRuntime().wrap(function _callee134$(_context141) {
          while (1) switch (_context141.prev = _context141.next) {
            case 0:
              _context141.next = 2;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/devices/").concat(this.id), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 2:
              result = _context141.sent;
              _context141.next = 5;
              return result.json();
            case 5:
              device = _context141.sent;
              if (device.state.reportedConfiguration) {
                _context141.next = 8;
                break;
              }
              throw new Error("Device has no configuration, has it ever been turned on?");
            case 8:
              version = device.state.reportedConfiguration.version;
              _context141.next = 11;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/devices/").concat(this.id, "/configurations/").concat(version), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 11:
              result = _context141.sent;
              _context141.next = 14;
              return result.json();
            case 14:
              config = _context141.sent;
              return _context141.abrupt("return", config.document);
            case 16:
            case "end":
              return _context141.stop();
          }
        }, _callee134, this);
      }));
      function getConfiguration() {
        return _getConfiguration.apply(this, arguments);
      }
      return getConfiguration;
    }()
  }, {
    key: "getFileUrl",
    value: function () {
      var _getFileUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee135(fileId) {
        var result, files;
        return _regeneratorRuntime().wrap(function _callee135$(_context142) {
          while (1) switch (_context142.prev = _context142.next) {
            case 0:
              _context142.next = 2;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/files/query"), {
                method: "POST",
                body: JSON.stringify({
                  fileIds: [fileId]
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 2:
              result = _context142.sent;
              _context142.next = 5;
              return result.json();
            case 5:
              files = _context142.sent;
              return _context142.abrupt("return", files.fileUrls);
            case 7:
            case "end":
              return _context142.stop();
          }
        }, _callee135);
      }));
      function getFileUrl(_x12) {
        return _getFileUrl.apply(this, arguments);
      }
      return getFileUrl;
    }()
  }, {
    key: "getRealtimeStatus",
    value: function getRealtimeStatus() {
      if (this.rtcClient && this.remoteDevicePeerId) {
        return this.rtcClient.getConnectionStatus(this.remoteDevicePeerId);
      } else {
        throw new Error("Realtime connection hasn't been started for ".concat(this.id));
      }
    }
  }, {
    key: "getRealtimePing",
    value: function getRealtimePing() {
      if (this.rtcClient && this.remoteDevicePeerId) {
        return this.rtcClient.getPing(this.remoteDevicePeerId);
      } else {
        throw new Error("Realtime connection hasn't been started for ".concat(this.id));
      }
    }
  }, {
    key: "startRealtimeConnection",
    value: function () {
      var _startRealtimeConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee138(sessionType) {
        var _this57 = this;
        var rtcClient, peers, devicePeer;
        return _regeneratorRuntime().wrap(function _callee138$(_context145) {
          while (1) switch (_context145.prev = _context145.next) {
            case 0:
              if (this.rtcClient) {
                _context145.next = 25;
                break;
              }
              if (rtcClientVersion === "1") {
                rtcClient = new dist.exports.RtcClientV1({
                  signalingClient: new dist.exports.RtcSignalingClient(FORMANT_API_URL + "/v1/signaling"),
                  getToken: function () {
                    var _getToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee136() {
                      return _regeneratorRuntime().wrap(function _callee136$(_context143) {
                        while (1) switch (_context143.prev = _context143.next) {
                          case 0:
                            return _context143.abrupt("return", defined(Authentication.token, "Realtime when user isn't authorized"));
                          case 1:
                          case "end":
                            return _context143.stop();
                        }
                      }, _callee136);
                    }));
                    function getToken() {
                      return _getToken.apply(this, arguments);
                    }
                    return getToken;
                  }(),
                  receive: this.handleMessage
                });
              } else {
                rtcClient = new dist.exports.RtcClient({
                  signalingClient: new dist.exports.SignalingPromiseClient(FORMANT_API_URL, null, null),
                  getToken: function () {
                    var _getToken2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee137() {
                      return _regeneratorRuntime().wrap(function _callee137$(_context144) {
                        while (1) switch (_context144.prev = _context144.next) {
                          case 0:
                            return _context144.abrupt("return", defined(Authentication.token, "Realtime when user isn't authorized"));
                          case 1:
                          case "end":
                            return _context144.stop();
                        }
                      }, _callee137);
                    }));
                    function getToken() {
                      return _getToken2.apply(this, arguments);
                    }
                    return getToken;
                  }(),
                  receive: this.handleMessage,
                  sessionType: sessionType
                });
              }
              if (!rtcClient.isReady) {
                _context145.next = 8;
                break;
              }
            case 3:
              if (rtcClient.isReady()) {
                _context145.next = 8;
                break;
              }
              _context145.next = 6;
              return delay(100);
            case 6:
              _context145.next = 3;
              break;
            case 8:
              _context145.next = 10;
              return rtcClient.getPeers();
            case 10:
              peers = _context145.sent;
              devicePeer = peers.find(function (_) {
                return _.deviceId === _this57.id;
              });
              if (devicePeer) {
                _context145.next = 14;
                break;
              }
              throw new Error("Cannot find peer, is the robot offline?");
            case 14:
              this.remoteDevicePeerId = devicePeer.id;
              _context145.next = 17;
              return rtcClient.connect(this.remoteDevicePeerId);
            case 17:
              if (!(rtcClient.getConnectionStatus(this.remoteDevicePeerId) !== "connected")) {
                _context145.next = 22;
                break;
              }
              _context145.next = 20;
              return delay(100);
            case 20:
              _context145.next = 17;
              break;
            case 22:
              this.rtcClient = rtcClient;
              _context145.next = 26;
              break;
            case 25:
              throw new Error("Already created realtime connection to device ".concat(this.id));
            case 26:
            case "end":
              return _context145.stop();
          }
        }, _callee138, this);
      }));
      function startRealtimeConnection(_x13) {
        return _startRealtimeConnection.apply(this, arguments);
      }
      return startRealtimeConnection;
    }()
  }, {
    key: "sendRealtimeMessage",
    value: function () {
      var _sendRealtimeMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee139(message) {
        var config,
          client,
          devicePeer,
          _args146 = arguments;
        return _regeneratorRuntime().wrap(function _callee139$(_context146) {
          while (1) switch (_context146.prev = _context146.next) {
            case 0:
              config = _args146.length > 1 && _args146[1] !== undefined ? _args146[1] : {
                channelLabel: "stream.reliable"
              };
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context146.next = 4;
              return this.getRemotePeer();
            case 4:
              devicePeer = _context146.sent;
              client.send(defined(devicePeer).id, message, config);
            case 6:
            case "end":
              return _context146.stop();
          }
        }, _callee139, this);
      }));
      function sendRealtimeMessage(_x14) {
        return _sendRealtimeMessage.apply(this, arguments);
      }
      return sendRealtimeMessage;
    }()
  }, {
    key: "addRealtimeListener",
    value: function addRealtimeListener(listener) {
      this.realtimeListeners.push(listener);
    }
  }, {
    key: "removeRealtimeListener",
    value: function removeRealtimeListener(listener) {
      var i = this.realtimeListeners.indexOf(listener);
      if (i === -1) {
        throw new Error("Could not find realtime listener to remove");
      }
      this.realtimeListeners.splice(i, 1);
    }
  }, {
    key: "getRealtimeAudioStreams",
    value: function () {
      var _getRealtimeAudioStreams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee140() {
        var _a, _b, _c, _d, _e, _f, document2, streams, _iterator21, _step21, _, _iterator22, _step22, _3, _iterator23, _step23, _4;
        return _regeneratorRuntime().wrap(function _callee140$(_context147) {
          while (1) switch (_context147.prev = _context147.next) {
            case 0:
              _context147.next = 2;
              return this.getConfiguration();
            case 2:
              document2 = _context147.sent;
              streams = [];
              _iterator21 = _createForOfIteratorHelper((_b = (_a = document2.teleop) == null ? void 0 : _a.hardwareStreams) != null ? _b : []);
              try {
                for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                  _ = _step21.value;
                  if (_.rtcStreamType === "audio-chunk") {
                    streams.push({
                      name: _.name
                    });
                  }
                }
              } catch (err) {
                _iterator21.e(err);
              } finally {
                _iterator21.f();
              }
              _iterator22 = _createForOfIteratorHelper((_d = (_c = document2.teleop) == null ? void 0 : _c.rosStreams) != null ? _d : []);
              try {
                for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                  _3 = _step22.value;
                  if (_3.topicType == "audio_common_msgs/AudioData") {
                    streams.push({
                      name: _3.topicName
                    });
                  }
                }
              } catch (err) {
                _iterator22.e(err);
              } finally {
                _iterator22.f();
              }
              _iterator23 = _createForOfIteratorHelper((_f = (_e = document2.teleop) == null ? void 0 : _e.customStreams) != null ? _f : []);
              try {
                for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                  _4 = _step23.value;
                  if (_4.rtcStreamType === "audio-chunk") {
                    streams.push({
                      name: _4.name
                    });
                  }
                }
              } catch (err) {
                _iterator23.e(err);
              } finally {
                _iterator23.f();
              }
              return _context147.abrupt("return", streams);
            case 11:
            case "end":
              return _context147.stop();
          }
        }, _callee140, this);
      }));
      function getRealtimeAudioStreams() {
        return _getRealtimeAudioStreams.apply(this, arguments);
      }
      return getRealtimeAudioStreams;
    }()
  }, {
    key: "getRealtimeVideoStreams",
    value: function () {
      var _getRealtimeVideoStreams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee141() {
        var _a, _b, _c, _d, _e, _f, document2, streams, _iterator24, _step24, _, _iterator25, _step25, _5, _iterator26, _step26, _6;
        return _regeneratorRuntime().wrap(function _callee141$(_context148) {
          while (1) switch (_context148.prev = _context148.next) {
            case 0:
              _context148.next = 2;
              return this.getConfiguration();
            case 2:
              document2 = _context148.sent;
              streams = [];
              _iterator24 = _createForOfIteratorHelper((_b = (_a = document2.teleop) == null ? void 0 : _a.hardwareStreams) != null ? _b : []);
              try {
                for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                  _ = _step24.value;
                  if (_.rtcStreamType === "h264-video-frame") {
                    streams.push({
                      name: _.name
                    });
                  }
                }
              } catch (err) {
                _iterator24.e(err);
              } finally {
                _iterator24.f();
              }
              _iterator25 = _createForOfIteratorHelper((_d = (_c = document2.teleop) == null ? void 0 : _c.rosStreams) != null ? _d : []);
              try {
                for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
                  _5 = _step25.value;
                  if (_5.topicType == "formant/H264VideoFrame") {
                    streams.push({
                      name: _5.topicName
                    });
                  }
                }
              } catch (err) {
                _iterator25.e(err);
              } finally {
                _iterator25.f();
              }
              _iterator26 = _createForOfIteratorHelper((_f = (_e = document2.teleop) == null ? void 0 : _e.customStreams) != null ? _f : []);
              try {
                for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                  _6 = _step26.value;
                  if (_6.rtcStreamType === "h264-video-frame") {
                    streams.push({
                      name: _6.name
                    });
                  }
                }
              } catch (err) {
                _iterator26.e(err);
              } finally {
                _iterator26.f();
              }
              return _context148.abrupt("return", streams);
            case 11:
            case "end":
              return _context148.stop();
          }
        }, _callee141, this);
      }));
      function getRealtimeVideoStreams() {
        return _getRealtimeVideoStreams.apply(this, arguments);
      }
      return getRealtimeVideoStreams;
    }()
  }, {
    key: "getRealtimeManipulators",
    value: function () {
      var _getRealtimeManipulators = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee142() {
        var _a, document2, manipulators, _iterator27, _step27, _;
        return _regeneratorRuntime().wrap(function _callee142$(_context149) {
          while (1) switch (_context149.prev = _context149.next) {
            case 0:
              _context149.next = 2;
              return this.getConfiguration();
            case 2:
              document2 = _context149.sent;
              manipulators = [];
              _iterator27 = _createForOfIteratorHelper((_a = document2.teleop.rosStreams) != null ? _a : []);
              try {
                for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                  _ = _step27.value;
                  if (_.topicType == "sensor_msgs/JointState") {
                    manipulators.push(new Manipulator(this, {
                      currentJointStateStream: {
                        name: _.topicName
                      },
                      plannedJointStateStream: _.plannedTopic ? {
                        name: _.plannedTopic
                      } : void 0,
                      planValidStream: _.planValidTopic ? {
                        name: _.planValidTopic
                      } : void 0,
                      endEffectorStream: _.endEffectorTopic ? {
                        name: _.endEffectorTopic
                      } : void 0,
                      endEffectorLinkName: _.endEffectorLinkName,
                      baseReferenceFrame: _.baseReferenceFrame,
                      localFrame: _.localFrame
                    }));
                  }
                }
              } catch (err) {
                _iterator27.e(err);
              } finally {
                _iterator27.f();
              }
              return _context149.abrupt("return", manipulators);
            case 7:
            case "end":
              return _context149.stop();
          }
        }, _callee142, this);
      }));
      function getRealtimeManipulators() {
        return _getRealtimeManipulators.apply(this, arguments);
      }
      return getRealtimeManipulators;
    }()
  }, {
    key: "startListeningToRealtimeVideo",
    value: function () {
      var _startListeningToRealtimeVideo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee143(stream) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee143$(_context150) {
          while (1) switch (_context150.prev = _context150.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context150.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context150.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: stream.name,
                enable: true,
                pipeline: "rtc"
              });
            case 5:
            case "end":
              return _context150.stop();
          }
        }, _callee143, this);
      }));
      function startListeningToRealtimeVideo(_x15) {
        return _startListeningToRealtimeVideo.apply(this, arguments);
      }
      return startListeningToRealtimeVideo;
    }()
  }, {
    key: "stopListeningToRealtimeVideo",
    value: function () {
      var _stopListeningToRealtimeVideo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee144(stream) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee144$(_context151) {
          while (1) switch (_context151.prev = _context151.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context151.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context151.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: stream.name,
                enable: false,
                pipeline: "rtc"
              });
            case 5:
            case "end":
              return _context151.stop();
          }
        }, _callee144, this);
      }));
      function stopListeningToRealtimeVideo(_x16) {
        return _stopListeningToRealtimeVideo.apply(this, arguments);
      }
      return stopListeningToRealtimeVideo;
    }()
  }, {
    key: "startListeningToRealtimeDataStream",
    value: function () {
      var _startListeningToRealtimeDataStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee145(stream) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee145$(_context152) {
          while (1) switch (_context152.prev = _context152.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context152.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context152.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: stream.name,
                enable: true,
                pipeline: "rtc"
              });
            case 5:
            case "end":
              return _context152.stop();
          }
        }, _callee145, this);
      }));
      function startListeningToRealtimeDataStream(_x17) {
        return _startListeningToRealtimeDataStream.apply(this, arguments);
      }
      return startListeningToRealtimeDataStream;
    }()
  }, {
    key: "stopListeningToRealtimeDataStream",
    value: function () {
      var _stopListeningToRealtimeDataStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee146(stream) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee146$(_context153) {
          while (1) switch (_context153.prev = _context153.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context153.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context153.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: stream.name,
                enable: false,
                pipeline: "rtc"
              });
            case 5:
            case "end":
              return _context153.stop();
          }
        }, _callee146, this);
      }));
      function stopListeningToRealtimeDataStream(_x18) {
        return _stopListeningToRealtimeDataStream.apply(this, arguments);
      }
      return stopListeningToRealtimeDataStream;
    }()
  }, {
    key: "enableRealtimeTelemetryPriorityIngestion",
    value: function () {
      var _enableRealtimeTelemetryPriorityIngestion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee147(streamName) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee147$(_context154) {
          while (1) switch (_context154.prev = _context154.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context154.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context154.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: streamName,
                enablePriorityUpload: true,
                pipeline: "telemetry"
              });
            case 5:
            case "end":
              return _context154.stop();
          }
        }, _callee147, this);
      }));
      function enableRealtimeTelemetryPriorityIngestion(_x19) {
        return _enableRealtimeTelemetryPriorityIngestion.apply(this, arguments);
      }
      return enableRealtimeTelemetryPriorityIngestion;
    }()
  }, {
    key: "changeStreamAudioType",
    value: function () {
      var _changeStreamAudioType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee148(streamName, newFormat) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee148$(_context155) {
          while (1) switch (_context155.prev = _context155.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context155.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context155.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: streamName,
                setAudioFormat: newFormat
              });
            case 5:
            case "end":
              return _context155.stop();
          }
        }, _callee148, this);
      }));
      function changeStreamAudioType(_x20, _x21) {
        return _changeStreamAudioType.apply(this, arguments);
      }
      return changeStreamAudioType;
    }()
  }, {
    key: "disableRealtimeTelemetryPriorityIngestion",
    value: function () {
      var _disableRealtimeTelemetryPriorityIngestion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee149(streamName) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee149$(_context156) {
          while (1) switch (_context156.prev = _context156.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context156.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context156.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: streamName,
                enablePriorityUpload: false,
                pipeline: "telemetry"
              });
            case 5:
            case "end":
              return _context156.stop();
          }
        }, _callee149, this);
      }));
      function disableRealtimeTelemetryPriorityIngestion(_x22) {
        return _disableRealtimeTelemetryPriorityIngestion.apply(this, arguments);
      }
      return disableRealtimeTelemetryPriorityIngestion;
    }()
  }, {
    key: "getRemotePeer",
    value: function () {
      var _getRemotePeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee150() {
        var _this58 = this;
        var peers, devicePeer;
        return _regeneratorRuntime().wrap(function _callee150$(_context157) {
          while (1) switch (_context157.prev = _context157.next) {
            case 0:
              _context157.next = 2;
              return defined(this.rtcClient, "Realtime connection has not been started").getPeers();
            case 2:
              peers = _context157.sent;
              devicePeer = peers.find(function (_) {
                return _.deviceId === _this58.id;
              });
              return _context157.abrupt("return", defined(devicePeer, "Could not find remote peer for device " + this.id));
            case 5:
            case "end":
              return _context157.stop();
          }
        }, _callee150, this);
      }));
      function getRemotePeer() {
        return _getRemotePeer.apply(this, arguments);
      }
      return getRemotePeer;
    }()
  }, {
    key: "stopRealtimeConnection",
    value: function () {
      var _stopRealtimeConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee151() {
        return _regeneratorRuntime().wrap(function _callee151$(_context158) {
          while (1) switch (_context158.prev = _context158.next) {
            case 0:
              if (!this.rtcClient) {
                _context158.next = 5;
                break;
              }
              _context158.next = 3;
              return this.rtcClient.disconnect(this.id);
            case 3:
              _context158.next = 6;
              break;
            case 5:
              throw new Error("Realtime connection hasn't been started for ".concat(this.id));
            case 6:
            case "end":
              return _context158.stop();
          }
        }, _callee151, this);
      }));
      function stopRealtimeConnection() {
        return _stopRealtimeConnection.apply(this, arguments);
      }
      return stopRealtimeConnection;
    }()
  }, {
    key: "isInRealtimeSession",
    value: function () {
      var _isInRealtimeSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee152() {
        var _this59 = this;
        var peers, sessions, peer;
        return _regeneratorRuntime().wrap(function _callee152$(_context159) {
          while (1) switch (_context159.prev = _context159.next) {
            case 0:
              _context159.next = 2;
              return Fleet.getPeers();
            case 2:
              peers = _context159.sent;
              _context159.next = 5;
              return Fleet.getRealtimeSessions();
            case 5:
              sessions = _context159.sent;
              peer = peers.find(function (_) {
                return _.deviceId === _this59.id;
              });
              if (!peer) {
                _context159.next = 9;
                break;
              }
              return _context159.abrupt("return", sessions[peer.id].length > 0);
            case 9:
              return _context159.abrupt("return", false);
            case 10:
            case "end":
              return _context159.stop();
          }
        }, _callee152);
      }));
      function isInRealtimeSession() {
        return _isInRealtimeSession.apply(this, arguments);
      }
      return isInRealtimeSession;
    }()
  }, {
    key: "getAvailableCommands",
    value: function () {
      var _getAvailableCommands = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee153() {
        var result, commands;
        return _regeneratorRuntime().wrap(function _callee153$(_context160) {
          while (1) switch (_context160.prev = _context160.next) {
            case 0:
              _context160.next = 2;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/command-templates/"), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 2:
              result = _context160.sent;
              _context160.next = 5;
              return result.json();
            case 5:
              commands = _context160.sent;
              return _context160.abrupt("return", commands.items.map(function (i) {
                return {
                  name: i.name,
                  id: i.id,
                  command: i.command,
                  description: i.description,
                  parameterEnabled: i.parameterEnabled,
                  parameterValue: i.parameterValue,
                  parameterMeta: i.parameterMeta,
                  enabled: i.enabled
                };
              }));
            case 7:
            case "end":
              return _context160.stop();
          }
        }, _callee153);
      }));
      function getAvailableCommands() {
        return _getAvailableCommands.apply(this, arguments);
      }
      return getAvailableCommands;
    }()
  }, {
    key: "sendCommand",
    value: function () {
      var _sendCommand = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee154(name, data, time, metadata) {
        var _a, commands, command, d, parameter;
        return _regeneratorRuntime().wrap(function _callee154$(_context161) {
          while (1) switch (_context161.prev = _context161.next) {
            case 0:
              _context161.next = 2;
              return this.getAvailableCommands();
            case 2:
              commands = _context161.sent;
              command = commands.find(function (_) {
                return _.name === name;
              });
              if (command) {
                _context161.next = 6;
                break;
              }
              throw new Error("Could not find command with name \"".concat(name, "\""));
            case 6:
              d = "";
              if (data === void 0) {
                if (command.parameterEnabled && command.parameterValue) {
                  d = command.parameterValue;
                }
              } else {
                d = data;
              }
              parameter = {
                value: d,
                scrubberTime: (time || new Date()).toISOString(),
                meta: _objectSpread({}, command.parameterMeta, metadata)
              };
              _context161.next = 11;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/commands"), {
                method: "POST",
                body: JSON.stringify({
                  commandTemplateId: command.id,
                  organizationId: this.organizationId,
                  deviceId: this.id,
                  command: command.command,
                  parameter: parameter,
                  userId: (_a = Authentication.currentUser) == null ? void 0 : _a.id
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 11:
            case "end":
              return _context161.stop();
          }
        }, _callee154, this);
      }));
      function sendCommand(_x23, _x24, _x25, _x26) {
        return _sendCommand.apply(this, arguments);
      }
      return sendCommand;
    }()
  }, {
    key: "createCustomDataChannel",
    value: function () {
      var _createCustomDataChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee155(channelName, rtcConfig) {
        var client, devicePeer, p;
        return _regeneratorRuntime().wrap(function _callee155$(_context162) {
          while (1) switch (_context162.prev = _context162.next) {
            case 0:
              if (!(rtcClientVersion === "1")) {
                _context162.next = 2;
                break;
              }
              throw new Error("createCustomDataChannel is not supported in rtcClientVersion 1");
            case 2:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context162.next = 5;
              return this.getRemotePeer();
            case 5:
              devicePeer = _context162.sent;
              _context162.next = 8;
              return new Promise(function (resolve) {
                client.createCustomDataChannel(defined(devicePeer).id, channelName, _objectSpread({
                  ordered: true
                }, rtcConfig), false, function (_peerId, channel) {
                  var dataChannel = new DataChannel(channel);
                  resolve(dataChannel);
                });
              });
            case 8:
              p = _context162.sent;
              _context162.next = 11;
              return p.waitTilReady();
            case 11:
              return _context162.abrupt("return", p);
            case 12:
            case "end":
              return _context162.stop();
          }
        }, _callee155, this);
      }));
      function createCustomDataChannel(_x27, _x28) {
        return _createCustomDataChannel.apply(this, arguments);
      }
      return createCustomDataChannel;
    }()
  }, {
    key: "createCustomRequestDataChannel",
    value: function createCustomRequestDataChannel(channelName) {
      var timeout2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3e3;
      return new TextRequestDataChannel(this, channelName, timeout2);
    }
  }, {
    key: "createCustomBinaryRequestDataChannel",
    value: function createCustomBinaryRequestDataChannel(channelName) {
      var timeout2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3e3;
      return new BinaryRequestDataChannel(this, channelName, timeout2);
    }
  }, {
    key: "createCaptureStream",
    value: function () {
      var _createCaptureStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee156(streamName) {
        var result, captureSession;
        return _regeneratorRuntime().wrap(function _callee156$(_context163) {
          while (1) switch (_context163.prev = _context163.next) {
            case 0:
              _context163.next = 2;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/capture-sessions"), {
                method: "POST",
                body: JSON.stringify({
                  deviceId: this.id,
                  streamName: streamName,
                  tags: {}
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 2:
              result = _context163.sent;
              _context163.next = 5;
              return result.json();
            case 5:
              captureSession = _context163.sent;
              return _context163.abrupt("return", new CaptureStream(captureSession));
            case 7:
            case "end":
              return _context163.stop();
          }
        }, _callee156, this);
      }));
      function createCaptureStream(_x29) {
        return _createCaptureStream.apply(this, arguments);
      }
      return createCaptureStream;
    }()
  }, {
    key: "getTelemetry",
    value: function () {
      var _getTelemetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee157(streamNameOrStreamNames, start, end, tags) {
        return _regeneratorRuntime().wrap(function _callee157$(_context164) {
          while (1) switch (_context164.prev = _context164.next) {
            case 0:
              _context164.next = 2;
              return Fleet.getTelemetry(this.id, streamNameOrStreamNames, start, end, tags);
            case 2:
              return _context164.abrupt("return", _context164.sent);
            case 3:
            case "end":
              return _context164.stop();
          }
        }, _callee157, this);
      }));
      function getTelemetry(_x30, _x31, _x32, _x33) {
        return _getTelemetry.apply(this, arguments);
      }
      return getTelemetry;
    }()
  }, {
    key: "getTelemetryStreams",
    value: function () {
      var _getTelemetryStreams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee158() {
        var _a, _b, config, result, disabledList, onDemandList, data, streamNames;
        return _regeneratorRuntime().wrap(function _callee158$(_context165) {
          while (1) switch (_context165.prev = _context165.next) {
            case 0:
              _context165.next = 2;
              return this.getConfiguration();
            case 2:
              config = _context165.sent;
              _context165.next = 5;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/metadata/stream-names"), {
                method: "POST",
                body: JSON.stringify({
                  deviceIds: [this.id]
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 5:
              result = _context165.sent;
              disabledList = [];
              onDemandList = [];
              (_b = (_a = config.telemetry) == null ? void 0 : _a.streams) == null ? void 0 : _b.forEach(function (_) {
                if (_.disabled !== true) {
                  disabledList.push(_.name);
                }
                if (_.onDemand === true) {
                  onDemandList.push(_.name);
                }
              });
              console.log(onDemandList);
              _context165.next = 12;
              return result.json();
            case 12:
              data = _context165.sent;
              streamNames = data.items.filter(function (_) {
                return !disabledList.includes(_);
              }).map(function (_) {
                return {
                  name: _,
                  onDemand: onDemandList.includes(_)
                };
              });
              return _context165.abrupt("return", streamNames);
            case 15:
            case "end":
              return _context165.stop();
          }
        }, _callee158, this);
      }));
      function getTelemetryStreams() {
        return _getTelemetryStreams.apply(this, arguments);
      }
      return getTelemetryStreams;
    }()
  }, {
    key: "createInterventionRequest",
    value: function () {
      var _createInterventionRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee159(message, interventionType, interventionRequest, tags) {
        var intervention, interventionJson;
        return _regeneratorRuntime().wrap(function _callee159$(_context166) {
          while (1) switch (_context166.prev = _context166.next) {
            case 0:
              _context166.next = 2;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/intervention-requests"), {
                method: "POST",
                body: JSON.stringify({
                  message: message,
                  interventionType: interventionType,
                  time: new Date().toISOString(),
                  deviceId: this.id,
                  tags: tags,
                  data: interventionRequest
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 2:
              intervention = _context166.sent;
              _context166.next = 5;
              return intervention.json();
            case 5:
              interventionJson = _context166.sent;
              return _context166.abrupt("return", interventionJson);
            case 7:
            case "end":
              return _context166.stop();
          }
        }, _callee159, this);
      }));
      function createInterventionRequest(_x34, _x35, _x36, _x37) {
        return _createInterventionRequest.apply(this, arguments);
      }
      return createInterventionRequest;
    }()
  }, {
    key: "addInterventionResponse",
    value: function () {
      var _addInterventionResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee160(interventionId, interventionType, data) {
        var response, interventionResponse;
        return _regeneratorRuntime().wrap(function _callee160$(_context167) {
          while (1) switch (_context167.prev = _context167.next) {
            case 0:
              _context167.next = 2;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/intervention-responses"), {
                method: "POST",
                body: JSON.stringify({
                  interventionId: interventionId,
                  interventionType: interventionType,
                  data: data
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 2:
              response = _context167.sent;
              _context167.next = 5;
              return response.json();
            case 5:
              interventionResponse = _context167.sent;
              return _context167.abrupt("return", interventionResponse);
            case 7:
            case "end":
              return _context167.stop();
          }
        }, _callee160);
      }));
      function addInterventionResponse(_x38, _x39, _x40) {
        return _addInterventionResponse.apply(this, arguments);
      }
      return addInterventionResponse;
    }()
  }, {
    key: "getAnnotationCount",
    value: function () {
      var _getAnnotationCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee161(query, tagKey) {
        return _regeneratorRuntime().wrap(function _callee161$(_context168) {
          while (1) switch (_context168.prev = _context168.next) {
            case 0:
              _context168.next = 2;
              return Fleet.getAnnotationCount(_objectSpread({}, query, {
                deviceIds: [this.id]
              }), tagKey);
            case 2:
              return _context168.abrupt("return", _context168.sent);
            case 3:
            case "end":
              return _context168.stop();
          }
        }, _callee161, this);
      }));
      function getAnnotationCount(_x41, _x42) {
        return _getAnnotationCount.apply(this, arguments);
      }
      return getAnnotationCount;
    }()
  }, {
    key: "getAnnotationCountByIntervals",
    value: function () {
      var _getAnnotationCountByIntervals = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee162(query, tagKey, aggregate) {
        return _regeneratorRuntime().wrap(function _callee162$(_context169) {
          while (1) switch (_context169.prev = _context169.next) {
            case 0:
              _context169.next = 2;
              return Fleet.getAnnotationCountByIntervals(_objectSpread({}, query, {
                deviceIds: [this.id]
              }), tagKey, aggregate);
            case 2:
              return _context169.abrupt("return", _context169.sent);
            case 3:
            case "end":
              return _context169.stop();
          }
        }, _callee162, this);
      }));
      function getAnnotationCountByIntervals(_x43, _x44, _x45) {
        return _getAnnotationCountByIntervals.apply(this, arguments);
      }
      return getAnnotationCountByIntervals;
    }()
  }, {
    key: "eventsCounter",
    value: function () {
      var _eventsCounter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee163(eventTypes2, timeFrame, range, time, query) {
        return _regeneratorRuntime().wrap(function _callee163$(_context170) {
          while (1) switch (_context170.prev = _context170.next) {
            case 0:
              _context170.next = 2;
              return Fleet.eventsCounter(eventTypes2, timeFrame, range, time, _objectSpread({}, query, {
                deviceIds: [this.id]
              }));
            case 2:
              return _context170.abrupt("return", _context170.sent);
            case 3:
            case "end":
              return _context170.stop();
          }
        }, _callee163, this);
      }));
      function eventsCounter(_x46, _x47, _x48, _x49, _x50) {
        return _eventsCounter.apply(this, arguments);
      }
      return eventsCounter;
    }()
  }, {
    key: "createShareLink",
    value: function () {
      var _createShareLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee164(params) {
        var response;
        return _regeneratorRuntime().wrap(function _callee164$(_context171) {
          while (1) switch (_context171.prev = _context171.next) {
            case 0:
              if (Authentication.token) {
                _context171.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context171.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/shares"), {
                method: "POST",
                body: JSON.stringify(_objectSpread({}, params, {
                  deviceIds: [this.id]
                })),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context171.sent;
              _context171.next = 7;
              return response.json();
            case 7:
              return _context171.abrupt("return", _context171.sent);
            case 8:
            case "end":
              return _context171.stop();
          }
        }, _callee164, this);
      }));
      function createShareLink(_x51) {
        return _createShareLink.apply(this, arguments);
      }
      return createShareLink;
    }()
  }]);
  return Device;
}();
var PeerDevice = /*#__PURE__*/function () {
  function PeerDevice(peerUrl) {
    var _this60 = this;
    _classCallCheck(this, PeerDevice);
    __publicField(this, "rtcClient");
    __publicField(this, "remoteDevicePeerId");
    __publicField(this, "realtimeListeners", []);
    __publicField(this, "id");
    __publicField(this, "handleMessage", function (peerId, message) {
      _this60.realtimeListeners.forEach(function (_) {
        return _(peerId, message);
      });
    });
    this.peerUrl = peerUrl;
  }
  _createClass(PeerDevice, [{
    key: "getLatestTelemetry",
    value: function () {
      var _getLatestTelemetry2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee165() {
        var _this61 = this;
        var data, telemetry, entries;
        return _regeneratorRuntime().wrap(function _callee165$(_context172) {
          while (1) switch (_context172.prev = _context172.next) {
            case 0:
              _context172.next = 2;
              return fetch("".concat(this.peerUrl, "/telemetry"));
            case 2:
              data = _context172.sent;
              _context172.next = 5;
              return data.json();
            case 5:
              telemetry = _context172.sent;
              entries = Object.entries(telemetry);
              return _context172.abrupt("return", entries.map(function (_ref39) {
                var _ref40 = _slicedToArray(_ref39, 2),
                  stream = _ref40[0],
                  latestValue = _ref40[1];
                var v = {
                  deviceId: _this61.id,
                  streamName: stream,
                  streamType: "json",
                  currentValue: latestValue,
                  currentValueTime: latestValue.timestamp,
                  tags: {}
                };
                return v;
              }));
            case 8:
            case "end":
              return _context172.stop();
          }
        }, _callee165, this);
      }));
      function getLatestTelemetry() {
        return _getLatestTelemetry2.apply(this, arguments);
      }
      return getLatestTelemetry;
    }()
  }, {
    key: "getDeviceId",
    value: function () {
      var _getDeviceId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee166() {
        var result, cfg;
        return _regeneratorRuntime().wrap(function _callee166$(_context173) {
          while (1) switch (_context173.prev = _context173.next) {
            case 0:
              _context173.next = 2;
              return fetch("".concat(this.peerUrl, "/configuration"));
            case 2:
              result = _context173.sent;
              _context173.next = 5;
              return result.json();
            case 5:
              cfg = _context173.sent;
              return _context173.abrupt("return", cfg.agent_config.id);
            case 7:
            case "end":
              return _context173.stop();
          }
        }, _callee166, this);
      }));
      function getDeviceId() {
        return _getDeviceId.apply(this, arguments);
      }
      return getDeviceId;
    }()
  }, {
    key: "getConfiguration",
    value: function () {
      var _getConfiguration2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee167() {
        var result, cfg;
        return _regeneratorRuntime().wrap(function _callee167$(_context174) {
          while (1) switch (_context174.prev = _context174.next) {
            case 0:
              _context174.next = 2;
              return fetch("".concat(this.peerUrl, "/configuration"));
            case 2:
              result = _context174.sent;
              _context174.next = 5;
              return result.json();
            case 5:
              cfg = _context174.sent;
              return _context174.abrupt("return", cfg.agent_config.document);
            case 7:
            case "end":
              return _context174.stop();
          }
        }, _callee167, this);
      }));
      function getConfiguration() {
        return _getConfiguration2.apply(this, arguments);
      }
      return getConfiguration;
    }()
  }, {
    key: "getRealtimeStatus",
    value: function getRealtimeStatus() {
      if (this.rtcClient && this.remoteDevicePeerId) {
        return this.rtcClient.getConnectionStatus(this.remoteDevicePeerId);
      } else {
        throw new Error("Realtime connection hasn't been started");
      }
    }
  }, {
    key: "getRealtimePing",
    value: function getRealtimePing() {
      if (this.rtcClient && this.remoteDevicePeerId) {
        return this.rtcClient.getPing(this.remoteDevicePeerId);
      } else {
        throw new Error("Realtime connection hasn't been started");
      }
    }
  }, {
    key: "startRealtimeConnection",
    value: function () {
      var _startRealtimeConnection2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee168(sessionType) {
        var rtcClient;
        return _regeneratorRuntime().wrap(function _callee168$(_context175) {
          while (1) switch (_context175.prev = _context175.next) {
            case 0:
              if (this.rtcClient) {
                _context175.next = 12;
                break;
              }
              rtcClient = new dist.exports.RtcClient({
                lanOnlyMode: true,
                receive: this.handleMessage,
                sessionType: sessionType
              });
              _context175.next = 4;
              return rtcClient.connectLan(this.peerUrl);
            case 4:
              if (!(rtcClient.getConnectionStatus(this.peerUrl) !== "connected")) {
                _context175.next = 9;
                break;
              }
              _context175.next = 7;
              return delay(100);
            case 7:
              _context175.next = 4;
              break;
            case 9:
              this.rtcClient = rtcClient;
              _context175.next = 13;
              break;
            case 12:
              throw new Error("Already created realtime connection to device ".concat(this.id));
            case 13:
            case "end":
              return _context175.stop();
          }
        }, _callee168, this);
      }));
      function startRealtimeConnection(_x52) {
        return _startRealtimeConnection2.apply(this, arguments);
      }
      return startRealtimeConnection;
    }()
  }, {
    key: "addRealtimeListener",
    value: function addRealtimeListener(listener) {
      this.realtimeListeners.push(listener);
    }
  }, {
    key: "removeRealtimeListener",
    value: function removeRealtimeListener(listener) {
      var i = this.realtimeListeners.indexOf(listener);
      if (i === -1) {
        throw new Error("Could not find realtime listener to remove");
      }
      this.realtimeListeners.splice(i, 1);
    }
  }, {
    key: "getRealtimeVideoStreams",
    value: function () {
      var _getRealtimeVideoStreams2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee169() {
        var _a, _b, _c, document2, streams, _iterator28, _step28, _, _iterator29, _step29, _7, _iterator30, _step30, _8;
        return _regeneratorRuntime().wrap(function _callee169$(_context176) {
          while (1) switch (_context176.prev = _context176.next) {
            case 0:
              _context176.next = 2;
              return this.getConfiguration();
            case 2:
              document2 = _context176.sent;
              streams = [];
              _iterator28 = _createForOfIteratorHelper((_a = document2.teleop.hardwareStreams) != null ? _a : []);
              try {
                for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                  _ = _step28.value;
                  if (_.rtcStreamType === "h264-video-frame") {
                    streams.push({
                      name: _.name
                    });
                  }
                }
              } catch (err) {
                _iterator28.e(err);
              } finally {
                _iterator28.f();
              }
              _iterator29 = _createForOfIteratorHelper((_b = document2.teleop.rosStreams) != null ? _b : []);
              try {
                for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                  _7 = _step29.value;
                  if (_7.topicType == "formant/H264VideoFrame") {
                    streams.push({
                      name: _7.topicName
                    });
                  }
                }
              } catch (err) {
                _iterator29.e(err);
              } finally {
                _iterator29.f();
              }
              _iterator30 = _createForOfIteratorHelper((_c = document2.teleop.customStreams) != null ? _c : []);
              try {
                for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
                  _8 = _step30.value;
                  if (_8.rtcStreamType === "h264-video-frame") {
                    streams.push({
                      name: _8.name
                    });
                  }
                }
              } catch (err) {
                _iterator30.e(err);
              } finally {
                _iterator30.f();
              }
              return _context176.abrupt("return", streams);
            case 11:
            case "end":
              return _context176.stop();
          }
        }, _callee169, this);
      }));
      function getRealtimeVideoStreams() {
        return _getRealtimeVideoStreams2.apply(this, arguments);
      }
      return getRealtimeVideoStreams;
    }()
  }, {
    key: "getRealtimeManipulators",
    value: function () {
      var _getRealtimeManipulators2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee170() {
        var _a, document2, manipulators, _iterator31, _step31, _;
        return _regeneratorRuntime().wrap(function _callee170$(_context177) {
          while (1) switch (_context177.prev = _context177.next) {
            case 0:
              _context177.next = 2;
              return this.getConfiguration();
            case 2:
              document2 = _context177.sent;
              manipulators = [];
              _iterator31 = _createForOfIteratorHelper((_a = document2.teleop.rosStreams) != null ? _a : []);
              try {
                for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
                  _ = _step31.value;
                  if (_.topicType == "sensor_msgs/JointState") {
                    manipulators.push(new Manipulator(this, {
                      currentJointStateStream: {
                        name: _.topicName
                      },
                      plannedJointStateStream: _.plannedTopic ? {
                        name: _.plannedTopic
                      } : void 0,
                      planValidStream: _.planValidTopic ? {
                        name: _.planValidTopic
                      } : void 0,
                      endEffectorStream: _.endEffectorTopic ? {
                        name: _.endEffectorTopic
                      } : void 0,
                      endEffectorLinkName: _.endEffectorLinkName,
                      baseReferenceFrame: _.baseReferenceFrame,
                      localFrame: _.localFrame
                    }));
                  }
                }
              } catch (err) {
                _iterator31.e(err);
              } finally {
                _iterator31.f();
              }
              return _context177.abrupt("return", manipulators);
            case 7:
            case "end":
              return _context177.stop();
          }
        }, _callee170, this);
      }));
      function getRealtimeManipulators() {
        return _getRealtimeManipulators2.apply(this, arguments);
      }
      return getRealtimeManipulators;
    }()
  }, {
    key: "startListeningToRealtimeVideo",
    value: function () {
      var _startListeningToRealtimeVideo2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee171(stream) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee171$(_context178) {
          while (1) switch (_context178.prev = _context178.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context178.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context178.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: stream.name,
                enable: true,
                pipeline: "rtc"
              });
            case 5:
            case "end":
              return _context178.stop();
          }
        }, _callee171, this);
      }));
      function startListeningToRealtimeVideo(_x53) {
        return _startListeningToRealtimeVideo2.apply(this, arguments);
      }
      return startListeningToRealtimeVideo;
    }()
  }, {
    key: "stopListeningToRealtimeVideo",
    value: function () {
      var _stopListeningToRealtimeVideo2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee172(stream) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee172$(_context179) {
          while (1) switch (_context179.prev = _context179.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context179.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context179.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: stream.name,
                enable: false,
                pipeline: "rtc"
              });
            case 5:
            case "end":
              return _context179.stop();
          }
        }, _callee172, this);
      }));
      function stopListeningToRealtimeVideo(_x54) {
        return _stopListeningToRealtimeVideo2.apply(this, arguments);
      }
      return stopListeningToRealtimeVideo;
    }()
  }, {
    key: "startListeningToRealtimeDataStream",
    value: function () {
      var _startListeningToRealtimeDataStream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee173(stream) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee173$(_context180) {
          while (1) switch (_context180.prev = _context180.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context180.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context180.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: stream.name,
                enable: true,
                pipeline: "rtc"
              });
            case 5:
            case "end":
              return _context180.stop();
          }
        }, _callee173, this);
      }));
      function startListeningToRealtimeDataStream(_x55) {
        return _startListeningToRealtimeDataStream2.apply(this, arguments);
      }
      return startListeningToRealtimeDataStream;
    }()
  }, {
    key: "stopListeningToRealtimeDataStream",
    value: function () {
      var _stopListeningToRealtimeDataStream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee174(stream) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee174$(_context181) {
          while (1) switch (_context181.prev = _context181.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context181.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context181.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: stream.name,
                enable: false,
                pipeline: "rtc"
              });
            case 5:
            case "end":
              return _context181.stop();
          }
        }, _callee174, this);
      }));
      function stopListeningToRealtimeDataStream(_x56) {
        return _stopListeningToRealtimeDataStream2.apply(this, arguments);
      }
      return stopListeningToRealtimeDataStream;
    }()
  }, {
    key: "enableRealtimeTelemetryPriorityIngestion",
    value: function () {
      var _enableRealtimeTelemetryPriorityIngestion2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee175(streamName) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee175$(_context182) {
          while (1) switch (_context182.prev = _context182.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context182.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context182.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: streamName,
                enablePriorityUpload: true,
                pipeline: "telemetry"
              });
            case 5:
            case "end":
              return _context182.stop();
          }
        }, _callee175, this);
      }));
      function enableRealtimeTelemetryPriorityIngestion(_x57) {
        return _enableRealtimeTelemetryPriorityIngestion2.apply(this, arguments);
      }
      return enableRealtimeTelemetryPriorityIngestion;
    }()
  }, {
    key: "disableRealtimeTelemetryPriorityIngestion",
    value: function () {
      var _disableRealtimeTelemetryPriorityIngestion2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee176(streamName) {
        var client, devicePeer;
        return _regeneratorRuntime().wrap(function _callee176$(_context183) {
          while (1) switch (_context183.prev = _context183.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context183.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context183.sent;
              client.controlRemoteStream(defined(devicePeer).id, {
                streamName: streamName,
                enablePriorityUpload: false,
                pipeline: "telemetry"
              });
            case 5:
            case "end":
              return _context183.stop();
          }
        }, _callee176, this);
      }));
      function disableRealtimeTelemetryPriorityIngestion(_x58) {
        return _disableRealtimeTelemetryPriorityIngestion2.apply(this, arguments);
      }
      return disableRealtimeTelemetryPriorityIngestion;
    }()
  }, {
    key: "getRemotePeer",
    value: function () {
      var _getRemotePeer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee177() {
        return _regeneratorRuntime().wrap(function _callee177$(_context184) {
          while (1) switch (_context184.prev = _context184.next) {
            case 0:
              return _context184.abrupt("return", {
                id: this.peerUrl,
                organizationId: "",
                deviceId: this.id,
                capabilities: [],
                capabilitySet: {}
              });
            case 1:
            case "end":
              return _context184.stop();
          }
        }, _callee177, this);
      }));
      function getRemotePeer() {
        return _getRemotePeer2.apply(this, arguments);
      }
      return getRemotePeer;
    }()
  }, {
    key: "stopRealtimeConnection",
    value: function () {
      var _stopRealtimeConnection2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee178() {
        return _regeneratorRuntime().wrap(function _callee178$(_context185) {
          while (1) switch (_context185.prev = _context185.next) {
            case 0:
              if (!this.rtcClient) {
                _context185.next = 5;
                break;
              }
              _context185.next = 3;
              return this.rtcClient.disconnect(this.id);
            case 3:
              _context185.next = 6;
              break;
            case 5:
              throw new Error("Realtime connection hasn't been started for ".concat(this.id));
            case 6:
            case "end":
              return _context185.stop();
          }
        }, _callee178, this);
      }));
      function stopRealtimeConnection() {
        return _stopRealtimeConnection2.apply(this, arguments);
      }
      return stopRealtimeConnection;
    }()
  }, {
    key: "createCustomDataChannel",
    value: function () {
      var _createCustomDataChannel2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee179(channelName, rtcConfig) {
        var client, devicePeer, p;
        return _regeneratorRuntime().wrap(function _callee179$(_context186) {
          while (1) switch (_context186.prev = _context186.next) {
            case 0:
              client = defined(this.rtcClient, "Realtime connection has not been started");
              _context186.next = 3;
              return this.getRemotePeer();
            case 3:
              devicePeer = _context186.sent;
              _context186.next = 6;
              return new Promise(function (resolve) {
                client.createCustomDataChannel(defined(devicePeer).id, channelName, _objectSpread({
                  ordered: true
                }, rtcConfig), false, function (_peerId, channel) {
                  var dataChannel = new DataChannel(channel);
                  resolve(dataChannel);
                });
              });
            case 6:
              p = _context186.sent;
              _context186.next = 9;
              return p.waitTilReady();
            case 9:
              return _context186.abrupt("return", p);
            case 10:
            case "end":
              return _context186.stop();
          }
        }, _callee179, this);
      }));
      function createCustomDataChannel(_x59, _x60) {
        return _createCustomDataChannel2.apply(this, arguments);
      }
      return createCustomDataChannel;
    }()
  }, {
    key: "createCustomRequestDataChannel",
    value: function createCustomRequestDataChannel(channelName) {
      var timeout2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3e3;
      return new TextRequestDataChannel(this, channelName, timeout2);
    }
  }, {
    key: "createCustomBinaryRequestDataChannel",
    value: function createCustomBinaryRequestDataChannel(channelName) {
      var timeout2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3e3;
      return new BinaryRequestDataChannel(this, channelName, timeout2);
    }
  }]);
  return PeerDevice;
}();
var _Fleet = /*#__PURE__*/function () {
  function _Fleet() {
    _classCallCheck(this, _Fleet);
  }
  _createClass(_Fleet, null, [{
    key: "setDefaultDevice",
    value: function () {
      var _setDefaultDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee180(deviceId) {
        return _regeneratorRuntime().wrap(function _callee180$(_context187) {
          while (1) switch (_context187.prev = _context187.next) {
            case 0:
              _Fleet.defaultDeviceId = deviceId;
            case 1:
            case "end":
              return _context187.stop();
          }
        }, _callee180);
      }));
      function setDefaultDevice(_x61) {
        return _setDefaultDevice.apply(this, arguments);
      }
      return setDefaultDevice;
    }()
  }, {
    key: "getCurrentDevice",
    value: function () {
      var _getCurrentDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee181() {
        var data, devices, device, name, context;
        return _regeneratorRuntime().wrap(function _callee181$(_context188) {
          while (1) switch (_context188.prev = _context188.next) {
            case 0:
              if (Authentication.token) {
                _context188.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              if (_Fleet.defaultDeviceId) {
                _context188.next = 4;
                break;
              }
              throw new Error("No known default device");
            case 4:
              _context188.next = 6;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/device-details/query"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 6:
              data = _context188.sent;
              _context188.next = 9;
              return data.json();
            case 9:
              devices = _context188.sent;
              device = devices.items.find(function (_) {
                return _.id === _Fleet.defaultDeviceId;
              });
              name = device.name;
              context = new Device(_Fleet.defaultDeviceId, name, defined(Authentication.currentOrganization));
              _Fleet.knownContext.push(new WeakRef(context));
              return _context188.abrupt("return", context);
            case 15:
            case "end":
              return _context188.stop();
          }
        }, _callee181);
      }));
      function getCurrentDevice() {
        return _getCurrentDevice.apply(this, arguments);
      }
      return getCurrentDevice;
    }()
  }, {
    key: "getPeerDevice",
    value: function () {
      var _getPeerDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee182(url) {
        var peer;
        return _regeneratorRuntime().wrap(function _callee182$(_context189) {
          while (1) switch (_context189.prev = _context189.next) {
            case 0:
              peer = new PeerDevice(url);
              _context189.next = 3;
              return peer.getDeviceId();
            case 3:
              peer.id = _context189.sent;
              return _context189.abrupt("return", peer);
            case 5:
            case "end":
              return _context189.stop();
          }
        }, _callee182);
      }));
      function getPeerDevice(_x62) {
        return _getPeerDevice.apply(this, arguments);
      }
      return getPeerDevice;
    }()
  }, {
    key: "getDevice",
    value: function () {
      var _getDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee183(deviceId) {
        var data, device, name, context;
        return _regeneratorRuntime().wrap(function _callee183$(_context190) {
          while (1) switch (_context190.prev = _context190.next) {
            case 0:
              if (Authentication.token) {
                _context190.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context190.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/devices/").concat(deviceId), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              data = _context190.sent;
              _context190.next = 7;
              return data.json();
            case 7:
              device = _context190.sent;
              name = device.name;
              context = new Device(deviceId, name, device.organizationId);
              _Fleet.knownContext.push(new WeakRef(context));
              return _context190.abrupt("return", context);
            case 12:
            case "end":
              return _context190.stop();
          }
        }, _callee183);
      }));
      function getDevice(_x63) {
        return _getDevice.apply(this, arguments);
      }
      return getDevice;
    }()
  }, {
    key: "getDevices",
    value: function () {
      var _getDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee184() {
        var data, devices;
        return _regeneratorRuntime().wrap(function _callee184$(_context191) {
          while (1) switch (_context191.prev = _context191.next) {
            case 0:
              if (Authentication.token) {
                _context191.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context191.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/device-details/query"), {
                method: "POST",
                body: JSON.stringify({
                  enabled: true,
                  type: "default"
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              data = _context191.sent;
              _context191.next = 7;
              return data.json();
            case 7:
              devices = _context191.sent;
              devices.items;
              return _context191.abrupt("return", devices.items.map(function (_) {
                return new Device(_.id, _.name, _.organizationId);
              }));
            case 10:
            case "end":
              return _context191.stop();
          }
        }, _callee184);
      }));
      function getDevices() {
        return _getDevices.apply(this, arguments);
      }
      return getDevices;
    }()
  }, {
    key: "queryDevices",
    value: function () {
      var _queryDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee185(query) {
        var data, devices;
        return _regeneratorRuntime().wrap(function _callee185$(_context192) {
          while (1) switch (_context192.prev = _context192.next) {
            case 0:
              if (Authentication.token) {
                _context192.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context192.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/devices/query"), {
                method: "POST",
                body: JSON.stringify(query),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              data = _context192.sent;
              _context192.next = 7;
              return data.json();
            case 7:
              devices = _context192.sent;
              return _context192.abrupt("return", devices.items.map(function (_) {
                return new Device(_.id, _.name, _.organizationId);
              }));
            case 9:
            case "end":
              return _context192.stop();
          }
        }, _callee185);
      }));
      function queryDevices(_x64) {
        return _queryDevices.apply(this, arguments);
      }
      return queryDevices;
    }()
  }, {
    key: "getOnlineDevices",
    value: function () {
      var _getOnlineDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee186() {
        var data, devices, onlineIds, allDevices;
        return _regeneratorRuntime().wrap(function _callee186$(_context193) {
          while (1) switch (_context193.prev = _context193.next) {
            case 0:
              if (Authentication.token) {
                _context193.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context193.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/online-devices"), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              data = _context193.sent;
              _context193.next = 7;
              return data.json();
            case 7:
              devices = _context193.sent;
              onlineIds = devices.items;
              _context193.next = 11;
              return _Fleet.getDevices();
            case 11:
              allDevices = _context193.sent;
              return _context193.abrupt("return", allDevices.filter(function (_) {
                return onlineIds.includes(_.id);
              }));
            case 13:
            case "end":
              return _context193.stop();
          }
        }, _callee186);
      }));
      function getOnlineDevices() {
        return _getOnlineDevices.apply(this, arguments);
      }
      return getOnlineDevices;
    }()
  }, {
    key: "getPeers",
    value: function () {
      var _getPeers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee188() {
        var rtcClient;
        return _regeneratorRuntime().wrap(function _callee188$(_context195) {
          while (1) switch (_context195.prev = _context195.next) {
            case 0:
              if (Authentication.token) {
                _context195.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              rtcClient = new dist.exports.RtcClient({
                signalingClient: new dist.exports.SignalingPromiseClient(FORMANT_API_URL, null, null),
                getToken: function () {
                  var _getToken3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee187() {
                    return _regeneratorRuntime().wrap(function _callee187$(_context194) {
                      while (1) switch (_context194.prev = _context194.next) {
                        case 0:
                          return _context194.abrupt("return", defined(Authentication.token, "Realtime when user isn't authorized"));
                        case 1:
                        case "end":
                          return _context194.stop();
                      }
                    }, _callee187);
                  }));
                  function getToken() {
                    return _getToken3.apply(this, arguments);
                  }
                  return getToken;
                }(),
                receive: function receive() {}
              });
              _context195.next = 5;
              return rtcClient.getPeers();
            case 5:
              return _context195.abrupt("return", _context195.sent);
            case 6:
            case "end":
              return _context195.stop();
          }
        }, _callee188);
      }));
      function getPeers() {
        return _getPeers.apply(this, arguments);
      }
      return getPeers;
    }()
  }, {
    key: "getRealtimeSessions",
    value: function () {
      var _getRealtimeSessions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee190() {
        var rtcClient;
        return _regeneratorRuntime().wrap(function _callee190$(_context197) {
          while (1) switch (_context197.prev = _context197.next) {
            case 0:
              if (Authentication.token) {
                _context197.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              rtcClient = new dist.exports.RtcClient({
                signalingClient: new dist.exports.SignalingPromiseClient(FORMANT_API_URL, null, null),
                getToken: function () {
                  var _getToken4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee189() {
                    return _regeneratorRuntime().wrap(function _callee189$(_context196) {
                      while (1) switch (_context196.prev = _context196.next) {
                        case 0:
                          return _context196.abrupt("return", defined(Authentication.token, "Realtime when user isn't authorized"));
                        case 1:
                        case "end":
                          return _context196.stop();
                      }
                    }, _callee189);
                  }));
                  function getToken() {
                    return _getToken4.apply(this, arguments);
                  }
                  return getToken;
                }(),
                receive: function receive() {}
              });
              _context197.next = 5;
              return rtcClient.getSessions();
            case 5:
              return _context197.abrupt("return", _context197.sent);
            case 6:
            case "end":
              return _context197.stop();
          }
        }, _callee190);
      }));
      function getRealtimeSessions() {
        return _getRealtimeSessions.apply(this, arguments);
      }
      return getRealtimeSessions;
    }()
  }, {
    key: "getRealtimeDevices",
    value: function () {
      var _getRealtimeDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee191() {
        var data, devices, onlineIds, allDevices;
        return _regeneratorRuntime().wrap(function _callee191$(_context198) {
          while (1) switch (_context198.prev = _context198.next) {
            case 0:
              if (Authentication.token) {
                _context198.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context198.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/signaling/peers"), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              data = _context198.sent;
              _context198.next = 7;
              return data.json();
            case 7:
              devices = _context198.sent;
              onlineIds = devices.items.map(function (_) {
                return _.deviceId;
              });
              _context198.next = 11;
              return _Fleet.getDevices();
            case 11:
              allDevices = _context198.sent;
              return _context198.abrupt("return", allDevices.filter(function (_) {
                return onlineIds.includes(_.id);
              }));
            case 13:
            case "end":
              return _context198.stop();
          }
        }, _callee191);
      }));
      function getRealtimeDevices() {
        return _getRealtimeDevices.apply(this, arguments);
      }
      return getRealtimeDevices;
    }()
  }, {
    key: "getLatestTelemetry",
    value: function () {
      var _getLatestTelemetry3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee192(deviceIdOrDeviceIds) {
        var deviceIds, data, telemetry;
        return _regeneratorRuntime().wrap(function _callee192$(_context199) {
          while (1) switch (_context199.prev = _context199.next) {
            case 0:
              deviceIds = deviceIdOrDeviceIds;
              if (deviceIdOrDeviceIds && !Array.isArray(deviceIdOrDeviceIds)) {
                deviceIdOrDeviceIds = [deviceIdOrDeviceIds];
              }
              _context199.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/stream-current-value"), {
                method: "POST",
                body: JSON.stringify({
                  deviceIds: deviceIds
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              data = _context199.sent;
              _context199.next = 7;
              return data.json();
            case 7:
              telemetry = _context199.sent;
              return _context199.abrupt("return", telemetry.items);
            case 9:
            case "end":
              return _context199.stop();
          }
        }, _callee192);
      }));
      function getLatestTelemetry(_x65) {
        return _getLatestTelemetry3.apply(this, arguments);
      }
      return getLatestTelemetry;
    }()
  }, {
    key: "getTelemetry",
    value: function () {
      var _getTelemetry2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee193(deviceIdOrDeviceIds, streamNameOrStreamNames, start, end, tags) {
        var deviceIds, streamNames, data, telemetry;
        return _regeneratorRuntime().wrap(function _callee193$(_context200) {
          while (1) switch (_context200.prev = _context200.next) {
            case 0:
              deviceIds = deviceIdOrDeviceIds;
              if (!Array.isArray(deviceIdOrDeviceIds)) {
                deviceIds = [deviceIdOrDeviceIds];
              }
              streamNames = streamNameOrStreamNames;
              if (!Array.isArray(streamNameOrStreamNames)) {
                streamNames = [streamNameOrStreamNames];
              }
              _context200.next = 6;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/queries"), {
                method: "POST",
                body: JSON.stringify({
                  deviceIds: deviceIds,
                  end: end.toISOString(),
                  names: streamNames,
                  start: start.toISOString(),
                  tags: tags
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 6:
              data = _context200.sent;
              _context200.next = 9;
              return data.json();
            case 9:
              telemetry = _context200.sent;
              return _context200.abrupt("return", telemetry.items);
            case 11:
            case "end":
              return _context200.stop();
          }
        }, _callee193);
      }));
      function getTelemetry(_x66, _x67, _x68, _x69, _x70) {
        return _getTelemetry2.apply(this, arguments);
      }
      return getTelemetry;
    }()
  }, {
    key: "getFileUrl",
    value: function () {
      var _getFileUrl2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee194(uuid) {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee194$(_context201) {
          while (1) switch (_context201.prev = _context201.next) {
            case 0:
              _context201.next = 2;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/files/query"), {
                method: "POST",
                body: JSON.stringify({
                  fileIds: [uuid]
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 2:
              data = _context201.sent;
              _context201.next = 5;
              return data.json();
            case 5:
              result = _context201.sent;
              if (!(result.fileUrls.length === 0)) {
                _context201.next = 8;
                break;
              }
              throw new Error("File not found");
            case 8:
              return _context201.abrupt("return", result.fileUrls[0]);
            case 9:
            case "end":
              return _context201.stop();
          }
        }, _callee194);
      }));
      function getFileUrl(_x71) {
        return _getFileUrl2.apply(this, arguments);
      }
      return getFileUrl;
    }()
  }, {
    key: "queryTelemetry",
    value: function () {
      var _queryTelemetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee195(query) {
        var data;
        return _regeneratorRuntime().wrap(function _callee195$(_context202) {
          while (1) switch (_context202.prev = _context202.next) {
            case 0:
              if (Authentication.token) {
                _context202.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context202.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/queries"), {
                method: "POST",
                body: JSON.stringify(query),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              data = _context202.sent;
              _context202.next = 7;
              return data.json();
            case 7:
              return _context202.abrupt("return", _context202.sent.items);
            case 8:
            case "end":
              return _context202.stop();
          }
        }, _callee195);
      }));
      function queryTelemetry(_x72) {
        return _queryTelemetry.apply(this, arguments);
      }
      return queryTelemetry;
    }()
  }, {
    key: "aggregateTelemetry",
    value: function () {
      var _aggregateTelemetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee196(query) {
        var data;
        return _regeneratorRuntime().wrap(function _callee196$(_context203) {
          while (1) switch (_context203.prev = _context203.next) {
            case 0:
              if (Authentication.token) {
                _context203.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context203.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/queries"), {
                method: "POST",
                body: JSON.stringify(query),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              data = _context203.sent;
              _context203.next = 7;
              return data.json();
            case 7:
              return _context203.abrupt("return", _context203.sent.aggregates);
            case 8:
            case "end":
              return _context203.stop();
          }
        }, _callee196);
      }));
      function aggregateTelemetry(_x73) {
        return _aggregateTelemetry.apply(this, arguments);
      }
      return aggregateTelemetry;
    }()
  }, {
    key: "queryEvents",
    value: function () {
      var _queryEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee197(query) {
        var data;
        return _regeneratorRuntime().wrap(function _callee197$(_context204) {
          while (1) switch (_context204.prev = _context204.next) {
            case 0:
              if (Authentication.token) {
                _context204.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context204.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/events/query"), {
                method: "POST",
                body: JSON.stringify(query),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              data = _context204.sent;
              _context204.next = 7;
              return data.json();
            case 7:
              return _context204.abrupt("return", _context204.sent.items);
            case 8:
            case "end":
              return _context204.stop();
          }
        }, _callee197);
      }));
      function queryEvents(_x74) {
        return _queryEvents.apply(this, arguments);
      }
      return queryEvents;
    }()
  }, {
    key: "getEvent",
    value: function () {
      var _getEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee198(uuid) {
        var data;
        return _regeneratorRuntime().wrap(function _callee198$(_context205) {
          while (1) switch (_context205.prev = _context205.next) {
            case 0:
              if (Authentication.token) {
                _context205.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context205.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/events/query/id=").concat(uuid), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              data = _context205.sent;
              _context205.next = 7;
              return data.json();
            case 7:
              return _context205.abrupt("return", _context205.sent.items);
            case 8:
            case "end":
              return _context205.stop();
          }
        }, _callee198);
      }));
      function getEvent(_x75) {
        return _getEvent.apply(this, arguments);
      }
      return getEvent;
    }()
  }, {
    key: "getInterventions",
    value: function () {
      var _getInterventions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee199() {
        var interventions;
        return _regeneratorRuntime().wrap(function _callee199$(_context206) {
          while (1) switch (_context206.prev = _context206.next) {
            case 0:
              if (Authentication.token) {
                _context206.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context206.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/intervention-requests"), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              interventions = _context206.sent;
              _context206.next = 7;
              return interventions.json();
            case 7:
              return _context206.abrupt("return", _context206.sent.items);
            case 8:
            case "end":
              return _context206.stop();
          }
        }, _callee199);
      }));
      function getInterventions() {
        return _getInterventions.apply(this, arguments);
      }
      return getInterventions;
    }()
  }, {
    key: "getCurrentGroup",
    value: function () {
      var _getCurrentGroup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee200() {
        var urlParams2, groupId, response, _yield$response$json, tagKey, tagValue, devices;
        return _regeneratorRuntime().wrap(function _callee200$(_context207) {
          while (1) switch (_context207.prev = _context207.next) {
            case 0:
              if (Authentication.token) {
                _context207.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              urlParams2 = new URLSearchParams("");
              if (typeof window !== "undefined") {
                urlParams2 = new URLSearchParams(window.location.search);
              }
              groupId = urlParams2.get("group");
              if (!(groupId === null || groupId.trim() === "")) {
                _context207.next = 7;
                break;
              }
              return _context207.abrupt("return", void 0);
            case 7:
              _context207.next = 9;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/groups/") + groupId, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 9:
              response = _context207.sent;
              _context207.next = 12;
              return response.json();
            case 12:
              _yield$response$json = _context207.sent;
              tagKey = _yield$response$json.tagKey;
              tagValue = _yield$response$json.tagValue;
              _context207.next = 17;
              return this.queryDevices({
                tags: _defineProperty({}, tagKey, [tagValue]),
                enabled: true,
                type: "default"
              });
            case 17:
              devices = _context207.sent;
              return _context207.abrupt("return", devices);
            case 19:
            case "end":
              return _context207.stop();
          }
        }, _callee200, this);
      }));
      function getCurrentGroup() {
        return _getCurrentGroup.apply(this, arguments);
      }
      return getCurrentGroup;
    }()
  }, {
    key: "getAnnotationCount",
    value: function () {
      var _getAnnotationCount2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee201(query, tagKey) {
        var annotations, validAnnotations, annotationCounter;
        return _regeneratorRuntime().wrap(function _callee201$(_context208) {
          while (1) switch (_context208.prev = _context208.next) {
            case 0:
              _context208.next = 2;
              return this.queryEvents(_objectSpread({}, query, {
                eventTypes: ["annotation"]
              }));
            case 2:
              annotations = _context208.sent;
              validAnnotations = annotations.filter(function (_) {
                return !!_.tags && Object.keys(_.tags).includes(tagKey);
              });
              annotationCounter = validAnnotations.reduce(function (prev, current) {
                var value = current.tags[tagKey];
                if (value in prev) {
                  prev[value] += 1;
                  return prev;
                }
                prev[value] = 1;
                return prev;
              }, {});
              return _context208.abrupt("return", annotationCounter);
            case 6:
            case "end":
              return _context208.stop();
          }
        }, _callee201, this);
      }));
      function getAnnotationCount(_x76, _x77) {
        return _getAnnotationCount2.apply(this, arguments);
      }
      return getAnnotationCount;
    }()
  }, {
    key: "getAnnotationCountByIntervals",
    value: function () {
      var _getAnnotationCountByIntervals2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee202(query, tagKey, aggregate) {
        var _this62 = this;
        var end, start, dateFunctions, intervals, annotationsQuery, responses;
        return _regeneratorRuntime().wrap(function _callee202$(_context209) {
          while (1) switch (_context209.prev = _context209.next) {
            case 0:
              end = query.end, start = query.start;
              dateFunctions = aggregateByDateFunctions[aggregate];
              intervals = dateFunctions.interval({
                start: new Date(start),
                end: new Date(end)
              });
              annotationsQuery = intervals.map(function (_, idx) {
                var startDate = new Date(_).toISOString();
                var endDate = idx === intervals.length - 1 ? new Date(Date.now()).toISOString() : new Date(intervals[idx + 1]);
                return _this62.getAnnotationCount(_objectSpread({}, query, {
                  start: startDate,
                  end: endDate
                }), tagKey);
              });
              _context209.next = 6;
              return Promise.all(annotationsQuery);
            case 6:
              responses = _context209.sent;
              return _context209.abrupt("return", intervals.map(function (_, idx) {
                return {
                  date: new Date(_).toISOString(),
                  annotations: responses[idx]
                };
              }));
            case 8:
            case "end":
              return _context209.stop();
          }
        }, _callee202);
      }));
      function getAnnotationCountByIntervals(_x78, _x79, _x80) {
        return _getAnnotationCountByIntervals2.apply(this, arguments);
      }
      return getAnnotationCountByIntervals;
    }()
  }, {
    key: "getStreams",
    value: function () {
      var _getStreams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee203() {
        var response, streams;
        return _regeneratorRuntime().wrap(function _callee203$(_context210) {
          while (1) switch (_context210.prev = _context210.next) {
            case 0:
              if (Authentication.token) {
                _context210.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context210.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/streams"), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context210.sent;
              _context210.next = 7;
              return response.json();
            case 7:
              streams = _context210.sent;
              return _context210.abrupt("return", streams.items.filter(function (_) {
                return _.enabled;
              }));
            case 9:
            case "end":
              return _context210.stop();
          }
        }, _callee203);
      }));
      function getStreams() {
        return _getStreams.apply(this, arguments);
      }
      return getStreams;
    }()
  }, {
    key: "patchStream",
    value: function () {
      var _patchStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee204(stream) {
        var response;
        return _regeneratorRuntime().wrap(function _callee204$(_context211) {
          while (1) switch (_context211.prev = _context211.next) {
            case 0:
              if (Authentication.token) {
                _context211.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context211.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/streams/").concat(stream.id), {
                method: "PATCH",
                body: JSON.stringify(stream),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context211.sent;
              _context211.next = 7;
              return response.json();
            case 7:
              return _context211.abrupt("return", _context211.sent);
            case 8:
            case "end":
              return _context211.stop();
          }
        }, _callee204);
      }));
      function patchStream(_x81) {
        return _patchStream.apply(this, arguments);
      }
      return patchStream;
    }()
  }, {
    key: "getViews",
    value: function () {
      var _getViews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee205() {
        var response, views;
        return _regeneratorRuntime().wrap(function _callee205$(_context212) {
          while (1) switch (_context212.prev = _context212.next) {
            case 0:
              if (Authentication.token) {
                _context212.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context212.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/views"), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context212.sent;
              _context212.next = 7;
              return response.json();
            case 7:
              views = _context212.sent;
              return _context212.abrupt("return", views.items);
            case 9:
            case "end":
              return _context212.stop();
          }
        }, _callee205);
      }));
      function getViews() {
        return _getViews.apply(this, arguments);
      }
      return getViews;
    }()
  }, {
    key: "patchView",
    value: function () {
      var _patchView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee206(view) {
        var response;
        return _regeneratorRuntime().wrap(function _callee206$(_context213) {
          while (1) switch (_context213.prev = _context213.next) {
            case 0:
              if (Authentication.token) {
                _context213.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context213.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/views/").concat(view.id), {
                method: "PATCH",
                body: JSON.stringify(view),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context213.sent;
              _context213.next = 7;
              return response.json();
            case 7:
              return _context213.abrupt("return", _context213.sent);
            case 8:
            case "end":
              return _context213.stop();
          }
        }, _callee206);
      }));
      function patchView(_x82) {
        return _patchView.apply(this, arguments);
      }
      return patchView;
    }()
  }, {
    key: "eventsCounter",
    value: function () {
      var _eventsCounter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee208(eventTypes2, timeFrame, range, time, query) {
        var dateFunctions;
        return _regeneratorRuntime().wrap(function _callee208$(_context215) {
          while (1) switch (_context215.prev = _context215.next) {
            case 0:
              dateFunctions = aggregateByDateFunctions[timeFrame];
              _context215.next = 3;
              return Promise.all(Array(range).fill(0).map( /*#__PURE__*/function () {
                var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee207(_, dateOffset) {
                  var activePointInTimeLine, startDate, endDate, date, events;
                  return _regeneratorRuntime().wrap(function _callee207$(_context214) {
                    while (1) switch (_context214.prev = _context214.next) {
                      case 0:
                        activePointInTimeLine = new Date(time);
                        startDate = dateFunctions.sub(dateFunctions.start(activePointInTimeLine), range - dateOffset - 1);
                        endDate = dateFunctions.sub(dateFunctions.end(activePointInTimeLine), range - dateOffset - 1);
                        date = formatTimeFrameText(startDate.toLocaleDateString(), endDate.toLocaleDateString());
                        _context214.next = 6;
                        return _Fleet.queryEvents(_objectSpread({}, query, {
                          eventTypes: eventTypes2,
                          start: new Date(startDate).toISOString(),
                          end: new Date(endDate).toISOString()
                        }));
                      case 6:
                        events = _context214.sent;
                        return _context214.abrupt("return", {
                          date: date,
                          events: events
                        });
                      case 8:
                      case "end":
                        return _context214.stop();
                    }
                  }, _callee207);
                }));
                return function (_x88, _x89) {
                  return _ref41.apply(this, arguments);
                };
              }()));
            case 3:
              return _context215.abrupt("return", _context215.sent);
            case 4:
            case "end":
              return _context215.stop();
          }
        }, _callee208);
      }));
      function eventsCounter(_x83, _x84, _x85, _x86, _x87) {
        return _eventsCounter2.apply(this, arguments);
      }
      return eventsCounter;
    }()
  }, {
    key: "getAnalyticsModules",
    value: function () {
      var _getAnalyticsModules = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee209() {
        var response;
        return _regeneratorRuntime().wrap(function _callee209$(_context216) {
          while (1) switch (_context216.prev = _context216.next) {
            case 0:
              if (Authentication.token) {
                _context216.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context216.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/admin/analytics-modules"), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context216.sent;
              _context216.next = 7;
              return response.json();
            case 7:
              return _context216.abrupt("return", _context216.sent.items);
            case 8:
            case "end":
              return _context216.stop();
          }
        }, _callee209);
      }));
      function getAnalyticsModules() {
        return _getAnalyticsModules.apply(this, arguments);
      }
      return getAnalyticsModules;
    }()
  }, {
    key: "getAnalyticStreams",
    value: function () {
      var _getAnalyticStreams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee210() {
        var response;
        return _regeneratorRuntime().wrap(function _callee210$(_context217) {
          while (1) switch (_context217.prev = _context217.next) {
            case 0:
              if (Authentication.token) {
                _context217.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context217.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/analytics/streams"), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context217.sent;
              _context217.next = 7;
              return response.json();
            case 7:
              return _context217.abrupt("return", _context217.sent.items);
            case 8:
            case "end":
              return _context217.stop();
          }
        }, _callee210);
      }));
      function getAnalyticStreams() {
        return _getAnalyticStreams.apply(this, arguments);
      }
      return getAnalyticStreams;
    }()
  }, {
    key: "getTaskReportTables",
    value: function () {
      var _getTaskReportTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee211() {
        var response;
        return _regeneratorRuntime().wrap(function _callee211$(_context218) {
          while (1) switch (_context218.prev = _context218.next) {
            case 0:
              if (Authentication.token) {
                _context218.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context218.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/analytics/task-reports"), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context218.sent;
              _context218.next = 7;
              return response.json();
            case 7:
              return _context218.abrupt("return", _context218.sent.items);
            case 8:
            case "end":
              return _context218.stop();
          }
        }, _callee211);
      }));
      function getTaskReportTables() {
        return _getTaskReportTables.apply(this, arguments);
      }
      return getTaskReportTables;
    }()
  }, {
    key: "queryAnalytics",
    value: function () {
      var _queryAnalytics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee212(query) {
        var response;
        return _regeneratorRuntime().wrap(function _callee212$(_context219) {
          while (1) switch (_context219.prev = _context219.next) {
            case 0:
              if (Authentication.token) {
                _context219.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context219.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/analytics"), {
                method: "POST",
                body: JSON.stringify(query),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context219.sent;
              _context219.next = 7;
              return response.json();
            case 7:
              return _context219.abrupt("return", _context219.sent);
            case 8:
            case "end":
              return _context219.stop();
          }
        }, _callee212);
      }));
      function queryAnalytics(_x90) {
        return _queryAnalytics.apply(this, arguments);
      }
      return queryAnalytics;
    }()
  }, {
    key: "getAnalyticsRows",
    value: function () {
      var _getAnalyticsRows = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee213(query) {
        var response;
        return _regeneratorRuntime().wrap(function _callee213$(_context220) {
          while (1) switch (_context220.prev = _context220.next) {
            case 0:
              if (Authentication.token) {
                _context220.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context220.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/analytics/rows"), {
                method: "POST",
                body: JSON.stringify(query),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context220.sent;
              _context220.next = 7;
              return response.json();
            case 7:
              return _context220.abrupt("return", _context220.sent);
            case 8:
            case "end":
              return _context220.stop();
          }
        }, _callee213);
      }));
      function getAnalyticsRows(_x91) {
        return _getAnalyticsRows.apply(this, arguments);
      }
      return getAnalyticsRows;
    }()
  }, {
    key: "getTaskReportRows",
    value: function () {
      var _getTaskReportRows = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee214(query) {
        var response;
        return _regeneratorRuntime().wrap(function _callee214$(_context221) {
          while (1) switch (_context221.prev = _context221.next) {
            case 0:
              if (Authentication.token) {
                _context221.next = 2;
                break;
              }
              throw new Error("Not authenticated");
            case 2:
              _context221.next = 4;
              return fetch("".concat(FORMANT_API_URL, "/v1/queries/analytics/task-report-rows"), {
                method: "POST",
                body: JSON.stringify(query),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 4:
              response = _context221.sent;
              _context221.next = 7;
              return response.json();
            case 7:
              return _context221.abrupt("return", _context221.sent);
            case 8:
            case "end":
              return _context221.stop();
          }
        }, _callee214);
      }));
      function getTaskReportRows(_x92) {
        return _getTaskReportRows.apply(this, arguments);
      }
      return getTaskReportRows;
    }()
  }]);
  return _Fleet;
}();
var Fleet = _Fleet;
__publicField(Fleet, "defaultDeviceId");
__publicField(Fleet, "knownContext", []);
var KeyValue = /*#__PURE__*/function () {
  function KeyValue() {
    _classCallCheck(this, KeyValue);
  }
  _createClass(KeyValue, null, [{
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee215(key, value) {
        var result, keyValue;
        return _regeneratorRuntime().wrap(function _callee215$(_context222) {
          while (1) switch (_context222.prev = _context222.next) {
            case 0:
              _context222.prev = 0;
              _context222.next = 3;
              return fetch(FORMANT_API_URL + "/v1/admin/key-value", {
                method: "POST",
                body: JSON.stringify({
                  organizationId: defined(Authentication.currentUser).organizationId,
                  key: key,
                  value: value
                }),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 3:
              result = _context222.sent;
              _context222.next = 6;
              return result.json();
            case 6:
              keyValue = _context222.sent;
              if (!(result.status !== 200)) {
                _context222.next = 9;
                break;
              }
              throw new Error(keyValue.message);
            case 9:
              _context222.next = 14;
              break;
            case 11:
              _context222.prev = 11;
              _context222.t0 = _context222["catch"](0);
              throw _context222.t0;
            case 14:
            case "end":
              return _context222.stop();
          }
        }, _callee215, null, [[0, 11]]);
      }));
      function set(_x93, _x94) {
        return _set.apply(this, arguments);
      }
      return set;
    }()
  }, {
    key: "get",
    value: function () {
      var _get2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee216(key) {
        var result, keyValue;
        return _regeneratorRuntime().wrap(function _callee216$(_context223) {
          while (1) switch (_context223.prev = _context223.next) {
            case 0:
              _context223.prev = 0;
              _context223.next = 3;
              return fetch(FORMANT_API_URL + "/v1/admin/key-value/".concat(key), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 3:
              result = _context223.sent;
              _context223.next = 6;
              return result.json();
            case 6:
              keyValue = _context223.sent;
              if (!(result.status !== 200)) {
                _context223.next = 9;
                break;
              }
              throw new Error(keyValue.message);
            case 9:
              return _context223.abrupt("return", keyValue.value);
            case 12:
              _context223.prev = 12;
              _context223.t0 = _context223["catch"](0);
              throw _context223.t0;
            case 15:
            case "end":
              return _context223.stop();
          }
        }, _callee216, null, [[0, 12]]);
      }));
      function get(_x95) {
        return _get2.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "list",
    value: function () {
      var _list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee217() {
        var result, keyValueList;
        return _regeneratorRuntime().wrap(function _callee217$(_context224) {
          while (1) switch (_context224.prev = _context224.next) {
            case 0:
              _context224.prev = 0;
              _context224.next = 3;
              return fetch(FORMANT_API_URL + "/v1/admin/key-value", {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 3:
              result = _context224.sent;
              _context224.next = 6;
              return result.json();
            case 6:
              keyValueList = _context224.sent;
              if (!(result.status !== 200)) {
                _context224.next = 9;
                break;
              }
              throw new Error(keyValueList.message);
            case 9:
              return _context224.abrupt("return", keyValueList.items);
            case 12:
              _context224.prev = 12;
              _context224.t0 = _context224["catch"](0);
              throw _context224.t0;
            case 15:
            case "end":
              return _context224.stop();
          }
        }, _callee217, null, [[0, 12]]);
      }));
      function list() {
        return _list.apply(this, arguments);
      }
      return list;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee218(key) {
        var result;
        return _regeneratorRuntime().wrap(function _callee218$(_context225) {
          while (1) switch (_context225.prev = _context225.next) {
            case 0:
              _context225.prev = 0;
              _context225.next = 3;
              return fetch(FORMANT_API_URL + "/v1/admin/key-value/".concat(key), {
                method: "DELETE",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + Authentication.token
                }
              });
            case 3:
              result = _context225.sent;
              if (result.ok) {
                _context225.next = 6;
                break;
              }
              throw new Error("Unable to handle request");
            case 6:
              return _context225.abrupt("return");
            case 9:
              _context225.prev = 9;
              _context225.t0 = _context225["catch"](0);
              throw _context225.t0;
            case 12:
            case "end":
              return _context225.stop();
          }
        }, _callee218, null, [[0, 9]]);
      }));
      function _delete(_x96) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
  }]);
  return KeyValue;
}();
var vailableAggregationIntervals = ["day", "week", "month", "year", "hour", "minute", "quarter"];
var aggregateFunctions = ["interval", "start", "end", "sub", "get"];
function getVariance(a2) {
  if (a2.count < 2) {
    return 0;
  }
  return a2.sumOfSquares / (a2.count - 1);
}
function getStandardDeviation(a2) {
  return Math.sqrt(getVariance(a2));
}
function getMax(a2) {
  return a2.max;
}
function getMin(a2) {
  return a2.min;
}
function getAverage(a2) {
  return a2.count === 0 ? -1 : a2.sum / a2.count;
}
function getSum(a2) {
  return a2.sum;
}
function getCount(a2) {
  return a2.count;
}
var aggregateFunctionMap = {
  min: getMin,
  max: getMax,
  "standard deviation": getStandardDeviation,
  average: getAverage,
  sum: getSum,
  count: getCount
};
var aggregateByDateFunctions = {
  day: {
    interval: dateFns.eachDayOfInterval,
    start: dateFns.startOfDay,
    end: dateFns.endOfDay,
    sub: dateFns.subDays,
    get: dateFns.getDay
  },
  week: {
    interval: dateFns.eachWeekOfInterval,
    start: dateFns.startOfWeek,
    end: dateFns.endOfWeek,
    sub: dateFns.subWeeks,
    get: dateFns.getWeek
  },
  month: {
    interval: dateFns.eachMonthOfInterval,
    start: dateFns.startOfMonth,
    end: dateFns.endOfMonth,
    sub: dateFns.subMonths,
    get: dateFns.getMonth
  },
  year: {
    interval: dateFns.eachYearOfInterval,
    start: dateFns.startOfYear,
    end: dateFns.endOfYear,
    sub: dateFns.subYears,
    get: dateFns.getYear
  },
  hour: {
    interval: dateFns.eachHourOfInterval,
    start: dateFns.startOfHour,
    end: dateFns.endOfHour,
    sub: dateFns.subHours,
    get: dateFns.getHours
  },
  minute: {
    interval: dateFns.eachMinuteOfInterval,
    start: dateFns.startOfMinute,
    end: dateFns.endOfMinute,
    sub: dateFns.subMinutes,
    get: dateFns.getMinutes
  },
  quarter: {
    interval: dateFns.eachQuarterOfInterval,
    start: dateFns.startOfQuarter,
    end: dateFns.endOfQuarter,
    sub: dateFns.subQuarters,
    get: dateFns.getQuarter
  }
};
var formatTimeFrameText = function formatTimeFrameText(start, end) {
  return start.split("/")[0] + "/" + start.split("/")[1] + "\u2013" + end.split("/")[0] + "/" + end.split("/")[1];
};
function getZeroINumericSet() {
  return {
    min: Number.MAX_SAFE_INTEGER,
    max: 0,
    sum: 0,
    count: 0,
    sumOfSquares: 0
  };
}
function reduceNumericStreamAggregates(stream) {
  return stream.aggregates.reduce(function (acc, entry) {
    var aggregate = entry[1];
    return combineNumericAggregates(aggregate, acc);
  }, getZeroINumericSet());
}
function reduceNumericSetStreamAggregates(stream, numericSetKey) {
  var _a;
  return (_a = stream.aggregates.reduce(function (acc, entry) {
    var aggregate = entry[1];
    return combineNumericSetAggregates(aggregate, acc);
  }, {})[numericSetKey]) == null ? void 0 : _a.value;
}
function combineNumericAggregates(e1, e2) {
  return {
    min: Math.min(e1.min, e2.min),
    max: Math.max(e1.max, e2.max),
    sum: e1.sum + e2.sum,
    count: e1.count + e2.count,
    sumOfSquares: e1.sumOfSquares + e2.sumOfSquares
  };
}
function combineNumericSetAggregates(e1, e2) {
  return Object.keys(e1).reduce(function (acc, key) {
    var _a, _b;
    return _objectSpread({}, acc, _defineProperty({}, key, {
      value: combineNumericAggregates(e1[key].value, (_b = (_a = e2[key]) == null ? void 0 : _a.value) != null ? _b : getZeroINumericSet()),
      unit: e1[key].unit
    }));
  }, {});
}
var timeout = function timeout(s) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, s * 1e3);
  });
};
function stringToArrayBuffer(input) {
  return Uint8Array.from(atob(input), function (_) {
    return _.charCodeAt(0);
  });
}
function browser() {
  var _navigator2 = navigator,
    userAgent = _navigator2.userAgent;
  if (userAgent.includes("Firefox/")) {
    return "Firefox";
  } else if (userAgent.includes("Edg/")) {
    return "Edge";
  } else if (userAgent.includes("Chrome/")) {
    return "Chrome";
  } else if (userAgent.includes("Safari/")) {
    return "Safari";
  } else if (userAgent.includes("MSIE/") || userAgent.includes("Trident/")) {
    return "IE";
  } else {
    return "Other";
  }
}
var rtcAudioChunkStreamType = "audio-chunk";
var AudioPlayer = /*#__PURE__*/function () {
  function AudioPlayer(device, stream) {
    var _this63 = this;
    _classCallCheck(this, AudioPlayer);
    __publicField(this, "muted", false);
    __publicField(this, "hasReceivedData", false);
    __publicField(this, "audioContext");
    __publicField(this, "chunks", []);
    __publicField(this, "isPlaying", false);
    __publicField(this, "startTime", 0);
    __publicField(this, "lastChunkOffset", 0);
    __publicField(this, "bufferSize", 3);
    __publicField(this, "receive", /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee219(msg) {
        var _a, data, audioContext, muted, arrayBuffer;
        return _regeneratorRuntime().wrap(function _callee219$(_context226) {
          while (1) switch (_context226.prev = _context226.next) {
            case 0:
              data = (_a = msg.payload.audioChunk) == null ? void 0 : _a.chunk_data;
              if (data) {
                _context226.next = 3;
                break;
              }
              return _context226.abrupt("return");
            case 3:
              if (!_this63.hasReceivedData) {
                _this63.hasReceivedData = true;
              }
              audioContext = _this63.audioContext, muted = _this63.muted;
              if (!(!audioContext || msg.header.stream.streamType !== rtcAudioChunkStreamType || muted !== false)) {
                _context226.next = 7;
                break;
              }
              return _context226.abrupt("return");
            case 7:
              arrayBuffer = stringToArrayBuffer(data);
              _context226.prev = 8;
              _context226.next = 11;
              return audioContext.decodeAudioData(arrayBuffer.buffer, _this63.scheduleChunk);
            case 11:
              _context226.next = 17;
              break;
            case 13:
              _context226.prev = 13;
              _context226.t0 = _context226["catch"](8);
              console.warn("Error decoding audio buffer, changing audioWireFormat on agent", {
                error: _context226.t0
              });
              _this63.changeAudioWireFormat("wav");
            case 17:
            case "end":
              return _context226.stop();
          }
        }, _callee219, null, [[8, 13]]);
      }));
      return function (_x97) {
        return _ref42.apply(this, arguments);
      };
    }());
    __publicField(this, "scheduleChunk", function (buffer) {
      var audioContext = _this63.audioContext;
      if (!audioContext) {
        return;
      }
      if (_this63.chunks.length > _this63.bufferSize || _this63.isPlaying === false) {
        _this63.chunks.forEach(function (c) {
          c.stop();
        });
        _this63.isPlaying = false;
        _this63.chunks = [];
      }
      var chunk = _this63.createChunk(buffer);
      if (!chunk) {
        return;
      }
      if (!chunk.buffer) {
        return;
      }
      if (_this63.isPlaying === false) {
        _this63.startTime = audioContext.currentTime;
        _this63.lastChunkOffset = 0;
        _this63.isPlaying = true;
      }
      chunk.start(_this63.startTime + _this63.lastChunkOffset, 0, buffer.duration);
      _this63.lastChunkOffset += chunk.buffer.duration;
      _this63.chunks.push(chunk);
    });
    this.device = device;
    this.stream = stream;
    this.device.startListeningToRealtimeDataStream(stream);
    this.device.addRealtimeListener(function (_peerId, msg) {
      _this63.receive(msg);
    });
    if (browser() === "Safari" || browser() === "IE") {
      this.changeAudioWireFormat("wav");
    } else {
      this.changeAudioWireFormat("opus");
    }
    var AudioContext = window.AudioContext || window.webkitAudioContext;
    this.audioContext = new AudioContext();
  }
  _createClass(AudioPlayer, [{
    key: "play",
    value: function () {
      var _play = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee220() {
        var _a, _b;
        return _regeneratorRuntime().wrap(function _callee220$(_context227) {
          while (1) switch (_context227.prev = _context227.next) {
            case 0:
              if (!(((_a = this.audioContext) == null ? void 0 : _a.state) === "suspended")) {
                _context227.next = 3;
                break;
              }
              _context227.next = 3;
              return (_b = this.audioContext) == null ? void 0 : _b.resume();
            case 3:
              this.muted = false;
            case 4:
            case "end":
              return _context227.stop();
          }
        }, _callee220, this);
      }));
      function play() {
        return _play.apply(this, arguments);
      }
      return play;
    }()
  }, {
    key: "pause",
    value: function () {
      var _pause = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee221() {
        return _regeneratorRuntime().wrap(function _callee221$(_context228) {
          while (1) switch (_context228.prev = _context228.next) {
            case 0:
              _context228.next = 2;
              return this.audioContext.suspend();
            case 2:
              this.muted = true;
            case 3:
            case "end":
              return _context228.stop();
          }
        }, _callee221, this);
      }));
      function pause() {
        return _pause.apply(this, arguments);
      }
      return pause;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      this.device.stopListeningToRealtimeDataStream(this.stream);
    }
  }, {
    key: "createChunk",
    value: function createChunk(buffer) {
      var _this64 = this;
      var audioContext = this.audioContext;
      if (!audioContext) {
        return;
      }
      var source = audioContext.createBufferSource();
      source.buffer = buffer;
      source.connect(audioContext.destination);
      source.loop = false;
      source.onended = function (_) {
        _this64.chunks.splice(_this64.chunks.indexOf(source), 1);
        if (_this64.chunks.length === 0) {
          _this64.isPlaying = false;
        }
      };
      return source;
    }
  }, {
    key: "changeAudioWireFormat",
    value: function changeAudioWireFormat(newFormat) {
      var _this65 = this;
      var stream = this.stream;
      fork(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee222() {
        return _regeneratorRuntime().wrap(function _callee222$(_context229) {
          while (1) switch (_context229.prev = _context229.next) {
            case 0:
              _context229.next = 2;
              return _this65.device.changeStreamAudioType(stream.name, newFormat);
            case 2:
            case "end":
              return _context229.stop();
          }
        }, _callee222);
      }))());
    }
  }]);
  return AudioPlayer;
}();
var accessLevels = ["viewer", "operator", "administrator"];
var viewer = "viewer";
var operator = "operator";
var administrator = "administrator";
var aggregateLevels = ["year", "month", "week", "day", "hour", "minute"];
var annotationTypes = ["tag", "sheet", "user"];
var eventTypes = ["triggered-event", "intervention-request", "teleop-session-record", "port-forwarding-session-record", "command-request", "command-response", "command-delivery", "custom", "comment", "system", "annotation"];
var healthStatuses = ["unknown", "operational", "offline", "error"];
var interventionTypes = ["selection", "labeling", "teleop"];
var severities = ["info", "warning", "error", "critical"];
var videoMimeTypes = ["video/mp4"];
var urlParams = new URLSearchParams("");
if (typeof window !== "undefined") {
  urlParams = new URLSearchParams(window.location.search);
}
var urlDevice = urlParams.get("device");
if (urlDevice) {
  Fleet.setDefaultDevice(urlDevice);
}
var urlAuth = urlParams.get("auth");
if (urlAuth) {
  Authentication.loginWithToken(urlAuth);
}
var moduleName = urlParams.get("module");
if (moduleName) {
  Authentication.listenForRefresh();
}
var IRtcSendConfiguration = dist.exports.IRtcSendConfiguration;
var IRtcStreamMessage = dist.exports.IRtcStreamMessage;
var IRtcStreamPayload = dist.exports.IRtcStreamPayload;
export { App, AudioPlayer, Authentication, BinaryRequestDataChannel, CaptureStream, DataChannel, Device, Fleet, IRtcSendConfiguration, IRtcStreamMessage, IRtcStreamPayload, KeyValue, Manipulator, PeerDevice, SessionType, TextRequestDataChannel, accessLevels, administrator, aggregateByDateFunctions, aggregateFunctionMap, aggregateFunctions, aggregateLevels, annotationTypes, combineNumericAggregates, combineNumericSetAggregates, eventTypes, formatTimeFrameText, getAverage, getCount, getMax, getMin, getStandardDeviation, getSum, getVariance, getZeroINumericSet, healthStatuses, interventionTypes, operator, reduceNumericSetStreamAggregates, reduceNumericStreamAggregates, severities, timeout, vailableAggregationIntervals, videoMimeTypes, viewer };